[
  {
    "frequency": 54113,
    "simplified": "坚定不移",
    "traditional": "堅定不移"
  },
  {
    "frequency": 52510,
    "simplified": "随时随地",
    "traditional": "隨時隨地"
  },
  {
    "frequency": 36156,
    "simplified": "全力以赴",
    "traditional": "全力以赴"
  },
  {
    "frequency": 34727,
    "simplified": "丰富多彩",
    "traditional": "豐富多彩"
  },
  {
    "frequency": 32967,
    "simplified": "余波未平",
    "traditional": "餘波未平"
  },
  {
    "frequency": 31974,
    "simplified": "脱颖而出",
    "traditional": "脫穎而出"
  },
  {
    "frequency": 31565,
    "simplified": "实事求是",
    "traditional": "實事求是"
  },
  {
    "frequency": 30338,
    "simplified": "一如既往",
    "traditional": "一如既往"
  },
  {
    "frequency": 29469,
    "simplified": "众所周知",
    "traditional": "眾所周知"
  },
  {
    "frequency": 29188,
    "simplified": "一年一度",
    "traditional": "一年一度"
  },
  {
    "frequency": 27805,
    "simplified": "因地制宜",
    "traditional": "因地制宜"
  },
  {
    "frequency": 27561,
    "simplified": "千方百计",
    "traditional": "千方百計"
  },
  {
    "frequency": 25804,
    "simplified": "息息相关",
    "traditional": "息息相關"
  },
  {
    "frequency": 25301,
    "simplified": "层出不穷",
    "traditional": "層出不窮"
  },
  {
    "frequency": 24076,
    "simplified": "引人注目",
    "traditional": "引人注目"
  },
  {
    "frequency": 22965,
    "simplified": "当务之急",
    "traditional": "當務之急"
  },
  {
    "frequency": 22885,
    "simplified": "滥用职权",
    "traditional": "濫用職權"
  },
  {
    "frequency": 22071,
    "simplified": "深入人心",
    "traditional": "深入人心"
  },
  {
    "frequency": 21847,
    "simplified": "解放思想",
    "traditional": "解放思想"
  },
  {
    "frequency": 21157,
    "simplified": "见义勇为",
    "traditional": "見義勇為"
  },
  {
    "frequency": 20827,
    "simplified": "敲诈勒索",
    "traditional": "敲詐勒索"
  },
  {
    "frequency": 20236,
    "simplified": "名不虚传",
    "traditional": "名不虛傳"
  },
  {
    "frequency": 20180,
    "simplified": "来之不易",
    "traditional": "來之不易"
  },
  {
    "frequency": 20015,
    "simplified": "名副其实",
    "traditional": "名副其實"
  },
  {
    "frequency": 19848,
    "simplified": "下落不明",
    "traditional": "下落不明"
  },
  {
    "frequency": 19818,
    "simplified": "坚持不懈",
    "traditional": "堅持不懈"
  },
  {
    "frequency": 19395,
    "simplified": "源源不断",
    "traditional": "源源不斷"
  },
  {
    "frequency": 19137,
    "simplified": "络绎不绝",
    "traditional": "絡繹不絕"
  },
  {
    "frequency": 19010,
    "simplified": "弄虚作假",
    "traditional": "弄虛作假"
  },
  {
    "frequency": 18980,
    "simplified": "不可思议",
    "traditional": "不可思議"
  },
  {
    "frequency": 18949,
    "simplified": "不正之风",
    "traditional": "不正之風"
  },
  {
    "frequency": 18841,
    "simplified": "小心翼翼",
    "traditional": "小心翼翼"
  },
  {
    "frequency": 18732,
    "simplified": "长治久安",
    "traditional": "長治久安"
  },
  {
    "frequency": 18585,
    "simplified": "如火如荼",
    "traditional": "如火如荼"
  },
  {
    "frequency": 18574,
    "simplified": "不折不扣",
    "traditional": "不折不扣"
  },
  {
    "frequency": 18005,
    "simplified": "后顾之忧",
    "traditional": "後顧之憂"
  },
  {
    "frequency": 17612,
    "simplified": "纸醉金迷",
    "traditional": "紙醉金迷"
  },
  {
    "frequency": 17518,
    "simplified": "力所能及",
    "traditional": "力所能及"
  },
  {
    "frequency": 17422,
    "simplified": "供不应求",
    "traditional": "供不應求"
  },
  {
    "frequency": 17310,
    "simplified": "一目了然",
    "traditional": "一目瞭然"
  },
  {
    "frequency": 17273,
    "simplified": "显而易见",
    "traditional": "顯而易見"
  },
  {
    "frequency": 16953,
    "simplified": "持之以恒",
    "traditional": "持之以恆"
  },
  {
    "frequency": 16698,
    "simplified": "成千上万",
    "traditional": "成千上萬"
  },
  {
    "frequency": 16354,
    "simplified": "大街小巷",
    "traditional": "大街小巷"
  },
  {
    "frequency": 16264,
    "simplified": "可想而知",
    "traditional": "可想而知"
  },
  {
    "frequency": 16133,
    "simplified": "安居乐业",
    "traditional": "安居樂業"
  },
  {
    "frequency": 15972,
    "simplified": "齐心协力",
    "traditional": "齊心協力"
  },
  {
    "frequency": 15675,
    "simplified": "得天独厚",
    "traditional": "得天獨厚"
  },
  {
    "frequency": 15636,
    "simplified": "一见钟情",
    "traditional": "一見鍾情"
  },
  {
    "frequency": 15564,
    "simplified": "艰苦奋斗",
    "traditional": "艱苦奮鬥"
  },
  {
    "frequency": 15503,
    "simplified": "全心全意",
    "traditional": "全心全意"
  },
  {
    "frequency": 15496,
    "simplified": "独一无二",
    "traditional": "獨一無二"
  },
  {
    "frequency": 15230,
    "simplified": "不约而同",
    "traditional": "不約而同"
  },
  {
    "frequency": 15200,
    "simplified": "紧锣密鼓",
    "traditional": "緊鑼密鼓"
  },
  {
    "frequency": 15109,
    "simplified": "五花八门",
    "traditional": "五花八門"
  },
  {
    "frequency": 15089,
    "simplified": "一应俱全",
    "traditional": "一應俱全"
  },
  {
    "frequency": 14881,
    "simplified": "应运而生",
    "traditional": "應運而生"
  },
  {
    "frequency": 14801,
    "simplified": "与众不同",
    "traditional": "與眾不同"
  },
  {
    "frequency": 14766,
    "simplified": "触目惊心",
    "traditional": "觸目驚心"
  },
  {
    "frequency": 14553,
    "simplified": "屡见不鲜",
    "traditional": "屢見不鮮"
  },
  {
    "frequency": 14457,
    "simplified": "无独有偶",
    "traditional": "無獨有偶"
  },
  {
    "frequency": 14353,
    "simplified": "行之有效",
    "traditional": "行之有效"
  },
  {
    "frequency": 14263,
    "simplified": "不知不觉",
    "traditional": "不知不覺"
  },
  {
    "frequency": 14236,
    "simplified": "大势所趋",
    "traditional": "大勢所趨"
  },
  {
    "frequency": 14142,
    "simplified": "千家万户",
    "traditional": "千家萬戶"
  },
  {
    "frequency": 13820,
    "simplified": "心有余悸",
    "traditional": "心有餘悸"
  },
  {
    "frequency": 13727,
    "simplified": "不得而知",
    "traditional": "不得而知"
  },
  {
    "frequency": 13620,
    "simplified": "前所未有",
    "traditional": "前所未有"
  },
  {
    "frequency": 13603,
    "simplified": "迫不及待",
    "traditional": "迫不及待"
  },
  {
    "frequency": 13570,
    "simplified": "雪上加霜",
    "traditional": "雪上加霜"
  },
  {
    "frequency": 13502,
    "simplified": "迫在眉睫",
    "traditional": "迫在眉睫"
  },
  {
    "frequency": 13494,
    "simplified": "此起彼伏",
    "traditional": "此起彼伏"
  },
  {
    "frequency": 13433,
    "simplified": "脚踏实地",
    "traditional": "腳踏實地"
  },
  {
    "frequency": 13303,
    "simplified": "意想不到",
    "traditional": "意想不到"
  },
  {
    "frequency": 13132,
    "simplified": "错综复杂",
    "traditional": "錯綜複雜"
  },
  {
    "frequency": 13090,
    "simplified": "无可厚非",
    "traditional": "無可厚非"
  },
  {
    "frequency": 13043,
    "simplified": "源远流长",
    "traditional": "源遠流長"
  },
  {
    "frequency": 13004,
    "simplified": "举一反三",
    "traditional": "舉一反三"
  },
  {
    "frequency": 12875,
    "simplified": "循序渐进",
    "traditional": "循序漸進"
  },
  {
    "frequency": 12844,
    "simplified": "不遗余力",
    "traditional": "不遺餘力"
  },
  {
    "frequency": 12652,
    "simplified": "不言而喻",
    "traditional": "不言而喻"
  },
  {
    "frequency": 12516,
    "simplified": "讨价还价",
    "traditional": "討價還價"
  },
  {
    "frequency": 12511,
    "simplified": "深恶痛绝",
    "traditional": "深惡痛絕"
  },
  {
    "frequency": 12414,
    "simplified": "三位一体",
    "traditional": "三位一體"
  },
  {
    "frequency": 12326,
    "simplified": "截然不同",
    "traditional": "截然不同"
  },
  {
    "frequency": 12263,
    "simplified": "记忆犹新",
    "traditional": "記憶猶新"
  },
  {
    "frequency": 12230,
    "simplified": "喜闻乐见",
    "traditional": "喜聞樂見"
  },
  {
    "frequency": 12098,
    "simplified": "家喻户晓",
    "traditional": "家喻戶曉"
  },
  {
    "frequency": 12066,
    "simplified": "日新月异",
    "traditional": "日新月異"
  },
  {
    "frequency": 12053,
    "simplified": "取而代之",
    "traditional": "取而代之"
  },
  {
    "frequency": 11999,
    "simplified": "莫名其妙",
    "traditional": "莫名其妙"
  },
  {
    "frequency": 11993,
    "simplified": "名列前茅",
    "traditional": "名列前茅"
  },
  {
    "frequency": 11980,
    "simplified": "排忧解难",
    "traditional": "排憂解難"
  },
  {
    "frequency": 11976,
    "simplified": "各式各样",
    "traditional": "各式各樣"
  },
  {
    "frequency": 11949,
    "simplified": "玩忽职守",
    "traditional": "翫忽職守"
  },
  {
    "frequency": 11946,
    "simplified": "任重道远",
    "traditional": "任重道遠"
  },
  {
    "frequency": 11859,
    "simplified": "奋发有为",
    "traditional": "奮發有為"
  },
  {
    "frequency": 11820,
    "simplified": "举足轻重",
    "traditional": "舉足輕重"
  },
  {
    "frequency": 11743,
    "simplified": "比比皆是",
    "traditional": "比比皆是"
  },
  {
    "frequency": 11730,
    "simplified": "卓有成效",
    "traditional": "卓有成效"
  },
  {
    "frequency": 11714,
    "simplified": "落地生根",
    "traditional": "落地生根"
  },
  {
    "frequency": 11637,
    "simplified": "势在必行",
    "traditional": "勢在必行"
  },
  {
    "frequency": 11636,
    "simplified": "史无前例",
    "traditional": "史無前例"
  },
  {
    "frequency": 11591,
    "simplified": "理所当然",
    "traditional": "理所當然"
  },
  {
    "frequency": 11453,
    "simplified": "耳熟能详",
    "traditional": "耳熟能詳"
  },
  {
    "frequency": 11434,
    "simplified": "由来已久",
    "traditional": "由來已久"
  },
  {
    "frequency": 11401,
    "simplified": "一模一样",
    "traditional": "一模一樣"
  },
  {
    "frequency": 11378,
    "simplified": "厉行节约",
    "traditional": "厲行節約"
  },
  {
    "frequency": 11335,
    "simplified": "恶性循环",
    "traditional": "惡性循環"
  },
  {
    "frequency": 11292,
    "simplified": "铤而走险",
    "traditional": "鋌而走險"
  },
  {
    "frequency": 11230,
    "simplified": "举世瞩目",
    "traditional": "舉世矚目"
  },
  {
    "frequency": 11218,
    "simplified": "再接再厉",
    "traditional": "再接再厲"
  },
  {
    "frequency": 11172,
    "simplified": "足不出户",
    "traditional": "足不出戶"
  },
  {
    "frequency": 11138,
    "simplified": "翻天覆地",
    "traditional": "翻天覆地"
  },
  {
    "frequency": 11077,
    "simplified": "非同寻常",
    "traditional": "非同尋常"
  },
  {
    "frequency": 11057,
    "simplified": "挨家挨户",
    "traditional": "挨家挨戶"
  },
  {
    "frequency": 11020,
    "simplified": "不翼而飞",
    "traditional": "不翼而飛"
  },
  {
    "frequency": 10983,
    "simplified": "参差不齐",
    "traditional": "參差不齊"
  },
  {
    "frequency": 10972,
    "simplified": "水涨船高",
    "traditional": "水漲船高"
  },
  {
    "frequency": 10931,
    "simplified": "沸沸扬扬",
    "traditional": "沸沸揚揚"
  },
  {
    "frequency": 10913,
    "simplified": "先发制人",
    "traditional": "先發制人"
  },
  {
    "frequency": 10893,
    "simplified": "轩然大波",
    "traditional": "軒然大波"
  },
  {
    "frequency": 10861,
    "simplified": "土生土长",
    "traditional": "土生土長"
  },
  {
    "frequency": 10861,
    "simplified": "出人意料",
    "traditional": "出人意料"
  },
  {
    "frequency": 10847,
    "simplified": "统筹兼顾",
    "traditional": "統籌兼顧"
  },
  {
    "frequency": 10825,
    "simplified": "明察暗访",
    "traditional": "明察暗訪"
  },
  {
    "frequency": 10797,
    "simplified": "刻不容缓",
    "traditional": "刻不容緩"
  },
  {
    "frequency": 10758,
    "simplified": "融为一体",
    "traditional": "融為一體"
  },
  {
    "frequency": 10740,
    "simplified": "焕然一新",
    "traditional": "煥然一新"
  },
  {
    "frequency": 10717,
    "simplified": "以身作则",
    "traditional": "以身作則"
  },
  {
    "frequency": 10707,
    "simplified": "潜移默化",
    "traditional": "潛移默化"
  },
  {
    "frequency": 10663,
    "simplified": "风口浪尖",
    "traditional": "風口浪尖"
  },
  {
    "frequency": 10326,
    "simplified": "有条不紊",
    "traditional": "有條不紊"
  },
  {
    "frequency": 10289,
    "simplified": "归根结底",
    "traditional": "歸根結底"
  },
  {
    "frequency": 10276,
    "simplified": "发扬光大",
    "traditional": "發揚光大"
  },
  {
    "frequency": 10236,
    "simplified": "旗帜鲜明",
    "traditional": "旗幟鮮明"
  },
  {
    "frequency": 10222,
    "simplified": "万无一失",
    "traditional": "萬無一失"
  },
  {
    "frequency": 10214,
    "simplified": "可见一斑",
    "traditional": "可見一斑"
  },
  {
    "frequency": 10136,
    "simplified": "一视同仁",
    "traditional": "一視同仁"
  },
  {
    "frequency": 10077,
    "simplified": "相辅相成",
    "traditional": "相輔相成"
  },
  {
    "frequency": 9971,
    "simplified": "淋漓尽致",
    "traditional": "淋漓盡致"
  },
  {
    "frequency": 9971,
    "simplified": "耳目一新",
    "traditional": "耳目一新"
  },
  {
    "frequency": 9877,
    "simplified": "不了了之",
    "traditional": "不了了之"
  },
  {
    "frequency": 9846,
    "simplified": "热火朝天",
    "traditional": "熱火朝天"
  },
  {
    "frequency": 9788,
    "simplified": "有目共睹",
    "traditional": "有目共睹"
  },
  {
    "frequency": 9768,
    "simplified": "久而久之",
    "traditional": "久而久之"
  },
  {
    "frequency": 9757,
    "simplified": "视而不见",
    "traditional": "視而不見"
  },
  {
    "frequency": 9753,
    "simplified": "自强不息",
    "traditional": "自強不息"
  },
  {
    "frequency": 9641,
    "simplified": "以权谋私",
    "traditional": "以權謀私"
  },
  {
    "frequency": 9625,
    "simplified": "继往开来",
    "traditional": "繼往開來"
  },
  {
    "frequency": 9602,
    "simplified": "赞不绝口",
    "traditional": "讚不絕口"
  },
  {
    "frequency": 9525,
    "simplified": "义不容辞",
    "traditional": "義不容辭"
  },
  {
    "frequency": 9508,
    "simplified": "未雨绸缪",
    "traditional": "未雨綢繆"
  },
  {
    "frequency": 9506,
    "simplified": "一举一动",
    "traditional": "一舉一動"
  },
  {
    "frequency": 9496,
    "simplified": "绳之以法",
    "traditional": "繩之以法"
  },
  {
    "frequency": 9435,
    "simplified": "尽如人意",
    "traditional": "盡如人意"
  },
  {
    "frequency": 9411,
    "simplified": "有所作为",
    "traditional": "有所作為"
  },
  {
    "frequency": 9363,
    "simplified": "对症下药",
    "traditional": "對症下藥"
  },
  {
    "frequency": 9352,
    "simplified": "出谋划策",
    "traditional": "出謀劃策"
  },
  {
    "frequency": 9346,
    "simplified": "四面八方",
    "traditional": "四面八方"
  },
  {
    "frequency": 9337,
    "simplified": "首当其冲",
    "traditional": "首當其衝"
  },
  {
    "frequency": 9283,
    "simplified": "马不停蹄",
    "traditional": "馬不停蹄"
  },
  {
    "frequency": 9266,
    "simplified": "不以为然",
    "traditional": "不以為然"
  },
  {
    "frequency": 9255,
    "simplified": "必由之路",
    "traditional": "必由之路"
  },
  {
    "frequency": 9240,
    "simplified": "所作所为",
    "traditional": "所作所為"
  },
  {
    "frequency": 9223,
    "simplified": "一蹴而就",
    "traditional": "一蹴而就"
  },
  {
    "frequency": 9218,
    "simplified": "人满为患",
    "traditional": "人滿為患"
  },
  {
    "frequency": 9193,
    "simplified": "身体力行",
    "traditional": "身體力行"
  },
  {
    "frequency": 9158,
    "simplified": "精益求精",
    "traditional": "精益求精"
  },
  {
    "frequency": 9121,
    "simplified": "不可忽视",
    "traditional": "不可忽視"
  },
  {
    "frequency": 9086,
    "simplified": "大吃一惊",
    "traditional": "大吃一驚"
  },
  {
    "frequency": 9085,
    "simplified": "竭尽全力",
    "traditional": "竭盡全力"
  },
  {
    "frequency": 9051,
    "simplified": "拭目以待",
    "traditional": "拭目以待"
  },
  {
    "frequency": 9045,
    "simplified": "无家可归",
    "traditional": "無家可歸"
  },
  {
    "frequency": 8991,
    "simplified": "哭笑不得",
    "traditional": "哭笑不得"
  },
  {
    "frequency": 8980,
    "simplified": "铺张浪费",
    "traditional": "鋪張浪費"
  },
  {
    "frequency": 8956,
    "simplified": "不知所措",
    "traditional": "不知所措"
  },
  {
    "frequency": 8908,
    "simplified": "座无虚席",
    "traditional": "座無虛席"
  },
  {
    "frequency": 8891,
    "simplified": "可乘之机",
    "traditional": "可乘之機"
  },
  {
    "frequency": 8857,
    "simplified": "琳琅满目",
    "traditional": "琳琅滿目"
  },
  {
    "frequency": 8835,
    "simplified": "卷土重来",
    "traditional": "捲土重來"
  },
  {
    "frequency": 8799,
    "simplified": "铺天盖地",
    "traditional": "鋪天蓋地"
  },
  {
    "frequency": 8788,
    "simplified": "理直气壮",
    "traditional": "理直氣壯"
  },
  {
    "frequency": 8775,
    "simplified": "面目全非",
    "traditional": "面目全非"
  },
  {
    "frequency": 8741,
    "simplified": "忧心忡忡",
    "traditional": "憂心忡忡"
  },
  {
    "frequency": 8700,
    "simplified": "在所难免",
    "traditional": "在所難免"
  },
  {
    "frequency": 8700,
    "simplified": "燃眉之急",
    "traditional": "燃眉之急"
  },
  {
    "frequency": 8683,
    "simplified": "图文并茂",
    "traditional": "圖文並茂"
  },
  {
    "frequency": 8680,
    "simplified": "不绝于耳",
    "traditional": "不絕於耳"
  },
  {
    "frequency": 8638,
    "simplified": "津津乐道",
    "traditional": "津津樂道"
  },
  {
    "frequency": 8626,
    "simplified": "数以万计",
    "traditional": "數以萬計"
  },
  {
    "frequency": 8578,
    "simplified": "立竿见影",
    "traditional": "立竿見影"
  },
  {
    "frequency": 8572,
    "simplified": "议论纷纷",
    "traditional": "議論紛紛"
  },
  {
    "frequency": 8529,
    "simplified": "与日俱增",
    "traditional": "與日俱增"
  },
  {
    "frequency": 8510,
    "simplified": "衣食住行",
    "traditional": "衣食住行"
  },
  {
    "frequency": 8470,
    "simplified": "精心设计",
    "traditional": "精心設計"
  },
  {
    "frequency": 8454,
    "simplified": "急功近利",
    "traditional": "急功近利"
  },
  {
    "frequency": 8450,
    "simplified": "鲜为人知",
    "traditional": "鮮為人知"
  },
  {
    "frequency": 8431,
    "simplified": "根深蒂固",
    "traditional": "根深蒂固"
  },
  {
    "frequency": 8431,
    "simplified": "博大精深",
    "traditional": "博大精深"
  },
  {
    "frequency": 8403,
    "simplified": "大有可为",
    "traditional": "大有可為"
  },
  {
    "frequency": 8398,
    "simplified": "轰轰烈烈",
    "traditional": "轟轟烈烈"
  },
  {
    "frequency": 8380,
    "simplified": "惊心动魄",
    "traditional": "驚心動魄"
  },
  {
    "frequency": 8378,
    "simplified": "不亦乐乎",
    "traditional": "不亦樂乎"
  },
  {
    "frequency": 8359,
    "simplified": "何去何从",
    "traditional": "何去何從"
  },
  {
    "frequency": 8357,
    "simplified": "独立自主",
    "traditional": "獨立自主"
  },
  {
    "frequency": 8348,
    "simplified": "率先垂范",
    "traditional": "率先垂範"
  },
  {
    "frequency": 8298,
    "simplified": "相得益彰",
    "traditional": "相得益彰"
  },
  {
    "frequency": 8293,
    "simplified": "取信于民",
    "traditional": "取信於民"
  },
  {
    "frequency": 8255,
    "simplified": "耐人寻味",
    "traditional": "耐人尋味"
  },
  {
    "frequency": 8221,
    "simplified": "别开生面",
    "traditional": "別開生面"
  },
  {
    "frequency": 8189,
    "simplified": "水泄不通",
    "traditional": "水洩不通"
  },
  {
    "frequency": 8181,
    "simplified": "接二连三",
    "traditional": "接二連三"
  },
  {
    "frequency": 8154,
    "simplified": "无能为力",
    "traditional": "無能為力"
  },
  {
    "frequency": 8139,
    "simplified": "难以为继",
    "traditional": "難以為繼"
  },
  {
    "frequency": 8108,
    "simplified": "陷入僵局",
    "traditional": "陷入僵局"
  },
  {
    "frequency": 8104,
    "simplified": "感同身受",
    "traditional": "感同身受"
  },
  {
    "frequency": 8074,
    "simplified": "不知去向",
    "traditional": "不知去向"
  },
  {
    "frequency": 8046,
    "simplified": "匪夷所思",
    "traditional": "匪夷所思"
  },
  {
    "frequency": 7996,
    "simplified": "背道而驰",
    "traditional": "背道而馳"
  },
  {
    "frequency": 7977,
    "simplified": "难以置信",
    "traditional": "難以置信"
  },
  {
    "frequency": 7974,
    "simplified": "拳打脚踢",
    "traditional": "拳打腳踢"
  },
  {
    "frequency": 7963,
    "simplified": "一帆风顺",
    "traditional": "一帆風順"
  },
  {
    "frequency": 7923,
    "simplified": "掉以轻心",
    "traditional": "掉以輕心"
  },
  {
    "frequency": 7910,
    "simplified": "畅所欲言",
    "traditional": "暢所欲言"
  },
  {
    "frequency": 7871,
    "simplified": "习以为常",
    "traditional": "習以為常"
  },
  {
    "frequency": 7870,
    "simplified": "漏洞百出",
    "traditional": "漏洞百出"
  },
  {
    "frequency": 7846,
    "simplified": "年久失修",
    "traditional": "年久失修"
  },
  {
    "frequency": 7834,
    "simplified": "出乎意料",
    "traditional": "出乎意料"
  },
  {
    "frequency": 7808,
    "simplified": "一脉相承",
    "traditional": "一脈相承"
  },
  {
    "frequency": 7803,
    "simplified": "毫不动摇",
    "traditional": "毫不動搖"
  },
  {
    "frequency": 7760,
    "simplified": "当之无愧",
    "traditional": "當之無愧"
  },
  {
    "frequency": 7757,
    "simplified": "肆无忌惮",
    "traditional": "肆無忌憚"
  },
  {
    "frequency": 7709,
    "simplified": "寥寥无几",
    "traditional": "寥寥無幾"
  },
  {
    "frequency": 7679,
    "simplified": "顺藤摸瓜",
    "traditional": "順藤摸瓜"
  },
  {
    "frequency": 7647,
    "simplified": "助人为乐",
    "traditional": "助人為樂"
  },
  {
    "frequency": 7632,
    "simplified": "欢聚一堂",
    "traditional": "歡聚一堂"
  },
  {
    "frequency": 7629,
    "simplified": "泪流满面",
    "traditional": "淚流滿面"
  },
  {
    "frequency": 7620,
    "simplified": "接踵而至",
    "traditional": "接踵而至"
  },
  {
    "frequency": 7616,
    "simplified": "直言不讳",
    "traditional": "直言不諱"
  },
  {
    "frequency": 7610,
    "simplified": "义无反顾",
    "traditional": "義無反顧"
  },
  {
    "frequency": 7593,
    "simplified": "力不从心",
    "traditional": "力不從心"
  },
  {
    "frequency": 7585,
    "simplified": "遍地开花",
    "traditional": "遍地開花"
  },
  {
    "frequency": 7578,
    "simplified": "慕名而来",
    "traditional": "慕名而來"
  },
  {
    "frequency": 7576,
    "simplified": "纷至沓来",
    "traditional": "紛至沓來"
  },
  {
    "frequency": 7571,
    "simplified": "兴致勃勃",
    "traditional": "興致勃勃"
  },
  {
    "frequency": 7568,
    "simplified": "家常便饭",
    "traditional": "家常便飯"
  },
  {
    "frequency": 7558,
    "simplified": "措手不及",
    "traditional": "措手不及"
  },
  {
    "frequency": 7540,
    "simplified": "心急如焚",
    "traditional": "心急如焚"
  },
  {
    "frequency": 7495,
    "simplified": "一席之地",
    "traditional": "一席之地"
  },
  {
    "frequency": 7485,
    "simplified": "栩栩如生",
    "traditional": "栩栩如生"
  },
  {
    "frequency": 7483,
    "simplified": "眼花缭乱",
    "traditional": "眼花繚亂"
  },
  {
    "frequency": 7479,
    "simplified": "雪中送炭",
    "traditional": "雪中送炭"
  },
  {
    "frequency": 7383,
    "simplified": "得不偿失",
    "traditional": "得不償失"
  },
  {
    "frequency": 7341,
    "simplified": "安然无恙",
    "traditional": "安然無恙"
  },
  {
    "frequency": 7338,
    "simplified": "深入浅出",
    "traditional": "深入淺出"
  },
  {
    "frequency": 7337,
    "simplified": "自始至终",
    "traditional": "自始至終"
  },
  {
    "frequency": 7337,
    "simplified": "捉襟见肘",
    "traditional": "捉襟見肘"
  },
  {
    "frequency": 7328,
    "simplified": "拒之门外",
    "traditional": "拒之門外"
  },
  {
    "frequency": 7322,
    "simplified": "望而却步",
    "traditional": "望而卻步"
  },
  {
    "frequency": 7300,
    "simplified": "默默无闻",
    "traditional": "默默無聞"
  },
  {
    "frequency": 7282,
    "simplified": "顺理成章",
    "traditional": "順理成章"
  },
  {
    "frequency": 7237,
    "simplified": "难能可贵",
    "traditional": "難能可貴"
  },
  {
    "frequency": 7236,
    "simplified": "来龙去脉",
    "traditional": "來龍去脈"
  },
  {
    "frequency": 7221,
    "simplified": "不谋而合",
    "traditional": "不謀而合"
  },
  {
    "frequency": 7218,
    "simplified": "清清楚楚",
    "traditional": "清清楚楚"
  },
  {
    "frequency": 7209,
    "simplified": "如出一辙",
    "traditional": "如出一轍"
  },
  {
    "frequency": 7205,
    "simplified": "提心吊胆",
    "traditional": "提心吊膽"
  },
  {
    "frequency": 7194,
    "simplified": "徇私舞弊",
    "traditional": "徇私舞弊"
  },
  {
    "frequency": 7151,
    "simplified": "一无所知",
    "traditional": "一無所知"
  },
  {
    "frequency": 7144,
    "simplified": "锲而不舍",
    "traditional": "鍥而不捨"
  },
  {
    "frequency": 7135,
    "simplified": "别有用心",
    "traditional": "別有用心"
  },
  {
    "frequency": 7114,
    "simplified": "大打出手",
    "traditional": "大打出手"
  },
  {
    "frequency": 7107,
    "simplified": "同舟共济",
    "traditional": "同舟共濟"
  },
  {
    "frequency": 7073,
    "simplified": "雨后春笋",
    "traditional": "雨後春筍"
  },
  {
    "frequency": 7041,
    "simplified": "兢兢业业",
    "traditional": "兢兢業業"
  },
  {
    "frequency": 7019,
    "simplified": "泣不成声",
    "traditional": "泣不成聲"
  },
  {
    "frequency": 6983,
    "simplified": "无人问津",
    "traditional": "無人問津"
  },
  {
    "frequency": 6982,
    "simplified": "应有尽有",
    "traditional": "應有盡有"
  },
  {
    "frequency": 6965,
    "simplified": "引以为戒",
    "traditional": "引以為戒"
  },
  {
    "frequency": 6964,
    "simplified": "异军突起",
    "traditional": "異軍突起"
  },
  {
    "frequency": 6960,
    "simplified": "通俗易懂",
    "traditional": "通俗易懂"
  },
  {
    "frequency": 6922,
    "simplified": "波澜壮阔",
    "traditional": "波瀾壯闊"
  },
  {
    "frequency": 6862,
    "simplified": "无可奈何",
    "traditional": "無可奈何"
  },
  {
    "frequency": 6858,
    "simplified": "归根到底",
    "traditional": "歸根到底"
  },
  {
    "frequency": 6815,
    "simplified": "品学兼优",
    "traditional": "品學兼優"
  },
  {
    "frequency": 6814,
    "simplified": "司空见惯",
    "traditional": "司空見慣"
  },
  {
    "frequency": 6796,
    "simplified": "推波助澜",
    "traditional": "推波助瀾"
  },
  {
    "frequency": 6790,
    "simplified": "微乎其微",
    "traditional": "微乎其微"
  },
  {
    "frequency": 6741,
    "simplified": "相提并论",
    "traditional": "相提並論"
  },
  {
    "frequency": 6734,
    "simplified": "束手无策",
    "traditional": "束手無策"
  },
  {
    "frequency": 6712,
    "simplified": "信以为真",
    "traditional": "信以為真"
  },
  {
    "frequency": 6643,
    "simplified": "死灰复燃",
    "traditional": "死灰復燃"
  },
  {
    "frequency": 6631,
    "simplified": "苦不堪言",
    "traditional": "苦不堪言"
  },
  {
    "frequency": 6626,
    "simplified": "防患于未然",
    "traditional": "防患於未然"
  },
  {
    "frequency": 6615,
    "simplified": "争分夺秒",
    "traditional": "爭分奪秒"
  },
  {
    "frequency": 6592,
    "simplified": "集思广益",
    "traditional": "集思廣益"
  },
  {
    "frequency": 6591,
    "simplified": "蛮不讲理",
    "traditional": "蠻不講理"
  },
  {
    "frequency": 6590,
    "simplified": "自力更生",
    "traditional": "自力更生"
  },
  {
    "frequency": 6587,
    "simplified": "有的放矢",
    "traditional": "有的放矢"
  },
  {
    "frequency": 6565,
    "simplified": "严阵以待",
    "traditional": "嚴陣以待"
  },
  {
    "frequency": 6537,
    "simplified": "建功立业",
    "traditional": "建功立業"
  },
  {
    "frequency": 6535,
    "simplified": "人山人海",
    "traditional": "人山人海"
  },
  {
    "frequency": 6531,
    "simplified": "溃不成军",
    "traditional": "潰不成軍"
  },
  {
    "frequency": 6514,
    "simplified": "国计民生",
    "traditional": "國計民生"
  },
  {
    "frequency": 6494,
    "simplified": "年事已高",
    "traditional": "年事已高"
  },
  {
    "frequency": 6492,
    "simplified": "绿水青山",
    "traditional": "綠水青山"
  },
  {
    "frequency": 6479,
    "simplified": "半壁江山",
    "traditional": "半壁江山"
  },
  {
    "frequency": 6450,
    "simplified": "求同存异",
    "traditional": "求同存異"
  },
  {
    "frequency": 6448,
    "simplified": "蛛丝马迹",
    "traditional": "蛛絲馬跡"
  },
  {
    "frequency": 6437,
    "simplified": "鱼龙混杂",
    "traditional": "魚龍混雜"
  },
  {
    "frequency": 6434,
    "simplified": "扑朔迷离",
    "traditional": "撲朔迷離"
  },
  {
    "frequency": 6433,
    "simplified": "熙熙攘攘",
    "traditional": "熙熙攘攘"
  },
  {
    "frequency": 6426,
    "simplified": "一技之长",
    "traditional": "一技之長"
  },
  {
    "frequency": 6408,
    "simplified": "大江南北",
    "traditional": "大江南北"
  },
  {
    "frequency": 6404,
    "simplified": "屈指可数",
    "traditional": "屈指可數"
  },
  {
    "frequency": 6397,
    "simplified": "交相辉映",
    "traditional": "交相輝映"
  },
  {
    "frequency": 6389,
    "simplified": "公之于众",
    "traditional": "公之於眾"
  },
  {
    "frequency": 6388,
    "simplified": "一拍即合",
    "traditional": "一拍即合"
  },
  {
    "frequency": 6388,
    "simplified": "絮絮叨叨",
    "traditional": "絮絮叨叨"
  },
  {
    "frequency": 6383,
    "simplified": "一丝不苟",
    "traditional": "一絲不苟"
  },
  {
    "frequency": 6382,
    "simplified": "相依为命",
    "traditional": "相依為命"
  },
  {
    "frequency": 6370,
    "simplified": "微不足道",
    "traditional": "微不足道"
  },
  {
    "frequency": 6349,
    "simplified": "大有作为",
    "traditional": "大有作為"
  },
  {
    "frequency": 6348,
    "simplified": "良莠不齐",
    "traditional": "良莠不齊"
  },
  {
    "frequency": 6343,
    "simplified": "令人瞩目",
    "traditional": "令人矚目"
  },
  {
    "frequency": 6334,
    "simplified": "迎刃而解",
    "traditional": "迎刃而解"
  },
  {
    "frequency": 6329,
    "simplified": "从天而降",
    "traditional": "從天而降"
  },
  {
    "frequency": 6313,
    "simplified": "不合时宜",
    "traditional": "不合時宜"
  },
  {
    "frequency": 6305,
    "simplified": "现身说法",
    "traditional": "現身說法"
  },
  {
    "frequency": 6275,
    "simplified": "受益匪浅",
    "traditional": "受益匪淺"
  },
  {
    "frequency": 6275,
    "simplified": "新陈代谢",
    "traditional": "新陳代謝"
  },
  {
    "frequency": 6263,
    "simplified": "声势浩大",
    "traditional": "聲勢浩大"
  },
  {
    "frequency": 6250,
    "simplified": "高高在上",
    "traditional": "高高在上"
  },
  {
    "frequency": 6241,
    "simplified": "合情合理",
    "traditional": "合情合理"
  },
  {
    "frequency": 6240,
    "simplified": "量力而行",
    "traditional": "量力而行"
  },
  {
    "frequency": 6225,
    "simplified": "不切实际",
    "traditional": "不切實際"
  },
  {
    "frequency": 6205,
    "simplified": "针锋相对",
    "traditional": "針鋒相對"
  },
  {
    "frequency": 6201,
    "simplified": "责无旁贷",
    "traditional": "責無旁貸"
  },
  {
    "frequency": 6196,
    "simplified": "高瞻远瞩",
    "traditional": "高瞻遠矚"
  },
  {
    "frequency": 6187,
    "simplified": "千千万万",
    "traditional": "千千萬萬"
  },
  {
    "frequency": 6186,
    "simplified": "明目张胆",
    "traditional": "明目張膽"
  },
  {
    "frequency": 6171,
    "simplified": "连锁反应",
    "traditional": "連鎖反應"
  },
  {
    "frequency": 6145,
    "simplified": "适得其反",
    "traditional": "適得其反"
  },
  {
    "frequency": 6140,
    "simplified": "摇身一变",
    "traditional": "搖身一變"
  },
  {
    "frequency": 6108,
    "simplified": "跃跃欲试",
    "traditional": "躍躍欲試"
  },
  {
    "frequency": 6100,
    "simplified": "聚精会神",
    "traditional": "聚精會神"
  },
  {
    "frequency": 6092,
    "simplified": "承前启后",
    "traditional": "承前啟後"
  },
  {
    "frequency": 6092,
    "simplified": "杯水车薪",
    "traditional": "杯水車薪"
  },
  {
    "frequency": 6088,
    "simplified": "一网打尽",
    "traditional": "一網打盡"
  },
  {
    "frequency": 6073,
    "simplified": "开花结果",
    "traditional": "開花結果"
  },
  {
    "frequency": 6053,
    "simplified": "慷慨解囊",
    "traditional": "慷慨解囊"
  },
  {
    "frequency": 6050,
    "simplified": "素不相识",
    "traditional": "素不相識"
  },
  {
    "frequency": 6048,
    "simplified": "重建家园",
    "traditional": "重建家園"
  },
  {
    "frequency": 6047,
    "simplified": "长此以往",
    "traditional": "長此以往"
  },
  {
    "frequency": 6047,
    "simplified": "无可争辩",
    "traditional": "無可爭辯"
  },
  {
    "frequency": 6005,
    "simplified": "格格不入",
    "traditional": "格格不入"
  },
  {
    "frequency": 5999,
    "simplified": "蔚然成风",
    "traditional": "蔚然成風"
  },
  {
    "frequency": 5988,
    "simplified": "生机勃勃",
    "traditional": "生機勃勃"
  },
  {
    "frequency": 5983,
    "simplified": "吃苦耐劳",
    "traditional": "吃苦耐勞"
  },
  {
    "frequency": 5980,
    "simplified": "昏迷不醒",
    "traditional": "昏迷不醒"
  },
  {
    "frequency": 5977,
    "simplified": "金字招牌",
    "traditional": "金字招牌"
  },
  {
    "frequency": 5975,
    "simplified": "大相径庭",
    "traditional": "大相逕庭"
  },
  {
    "frequency": 5950,
    "simplified": "堂而皇之",
    "traditional": "堂而皇之"
  },
  {
    "frequency": 5942,
    "simplified": "如数家珍",
    "traditional": "如數家珍"
  },
  {
    "frequency": 5939,
    "simplified": "更新换代",
    "traditional": "更新換代"
  },
  {
    "frequency": 5903,
    "simplified": "争先恐后",
    "traditional": "爭先恐後"
  },
  {
    "frequency": 5893,
    "simplified": "浓墨重彩",
    "traditional": "濃墨重彩"
  },
  {
    "frequency": 5880,
    "simplified": "大刀阔斧",
    "traditional": "大刀闊斧"
  },
  {
    "frequency": 5868,
    "simplified": "惊慌失措",
    "traditional": "驚慌失措"
  },
  {
    "frequency": 5857,
    "simplified": "所剩无几",
    "traditional": "所剩無幾"
  },
  {
    "frequency": 5850,
    "simplified": "高官厚禄",
    "traditional": "高官厚祿"
  },
  {
    "frequency": 5847,
    "simplified": "一心一意",
    "traditional": "一心一意"
  },
  {
    "frequency": 5815,
    "simplified": "井然有序",
    "traditional": "井然有序"
  },
  {
    "frequency": 5805,
    "simplified": "一波三折",
    "traditional": "一波三折"
  },
  {
    "frequency": 5804,
    "simplified": "形迹可疑",
    "traditional": "形跡可疑"
  },
  {
    "frequency": 5749,
    "simplified": "炙手可热",
    "traditional": "炙手可熱"
  },
  {
    "frequency": 5740,
    "simplified": "身临其境",
    "traditional": "身臨其境"
  },
  {
    "frequency": 5735,
    "simplified": "二话不说",
    "traditional": "二話不說"
  },
  {
    "frequency": 5693,
    "simplified": "流连忘返",
    "traditional": "流連忘返"
  },
  {
    "frequency": 5692,
    "simplified": "热泪盈眶",
    "traditional": "熱淚盈眶"
  },
  {
    "frequency": 5687,
    "simplified": "销声匿迹",
    "traditional": "銷聲匿跡"
  },
  {
    "frequency": 5679,
    "simplified": "打击报复",
    "traditional": "打擊報復"
  },
  {
    "frequency": 5669,
    "simplified": "尽心尽力",
    "traditional": "盡心盡力"
  },
  {
    "frequency": 5663,
    "simplified": "一以贯之",
    "traditional": "一以貫之"
  },
  {
    "frequency": 5657,
    "simplified": "恍然大悟",
    "traditional": "恍然大悟"
  },
  {
    "frequency": 5655,
    "simplified": "置之不理",
    "traditional": "置之不理"
  },
  {
    "frequency": 5631,
    "simplified": "轻而易举",
    "traditional": "輕而易舉"
  },
  {
    "frequency": 5626,
    "simplified": "人来人往",
    "traditional": "人來人往"
  },
  {
    "frequency": 5619,
    "simplified": "青山绿水",
    "traditional": "青山綠水"
  },
  {
    "frequency": 5613,
    "simplified": "齐头并进",
    "traditional": "齊頭並進"
  },
  {
    "frequency": 5585,
    "simplified": "一筹莫展",
    "traditional": "一籌莫展"
  },
  {
    "frequency": 5578,
    "simplified": "百花齐放",
    "traditional": "百花齊放"
  },
  {
    "frequency": 5570,
    "simplified": "各执一词",
    "traditional": "各執一詞"
  },
  {
    "frequency": 5565,
    "simplified": "志同道合",
    "traditional": "志同道合"
  },
  {
    "frequency": 5550,
    "simplified": "绞尽脑汁",
    "traditional": "絞盡腦汁"
  },
  {
    "frequency": 5537,
    "simplified": "首屈一指",
    "traditional": "首屈一指"
  },
  {
    "frequency": 5530,
    "simplified": "水到渠成",
    "traditional": "水到渠成"
  },
  {
    "frequency": 5526,
    "simplified": "物美价廉",
    "traditional": "物美價廉"
  },
  {
    "frequency": 5514,
    "simplified": "众说纷纭",
    "traditional": "眾說紛紜"
  },
  {
    "frequency": 5506,
    "simplified": "各自为政",
    "traditional": "各自為政"
  },
  {
    "frequency": 5502,
    "simplified": "语重心长",
    "traditional": "語重心長"
  },
  {
    "frequency": 5488,
    "simplified": "德才兼备",
    "traditional": "德才兼備"
  },
  {
    "frequency": 5477,
    "simplified": "乐此不疲",
    "traditional": "樂此不疲"
  },
  {
    "frequency": 5471,
    "simplified": "方兴未艾",
    "traditional": "方興未艾"
  },
  {
    "frequency": 5445,
    "simplified": "五颜六色",
    "traditional": "五顏六色"
  },
  {
    "frequency": 5438,
    "simplified": "无动于衷",
    "traditional": "無動於衷"
  },
  {
    "frequency": 5428,
    "simplified": "锦上添花",
    "traditional": "錦上添花"
  },
  {
    "frequency": 5426,
    "simplified": "荒淫无度",
    "traditional": "荒淫無度"
  },
  {
    "frequency": 5426,
    "simplified": "推陈出新",
    "traditional": "推陳出新"
  },
  {
    "frequency": 5425,
    "simplified": "畅通无阻",
    "traditional": "暢通無阻"
  },
  {
    "frequency": 5419,
    "simplified": "独树一帜",
    "traditional": "獨樹一幟"
  },
  {
    "frequency": 5418,
    "simplified": "省吃俭用",
    "traditional": "省吃儉用"
  },
  {
    "frequency": 5412,
    "simplified": "无济于事",
    "traditional": "無濟於事"
  },
  {
    "frequency": 5405,
    "simplified": "情不自禁",
    "traditional": "情不自禁"
  },
  {
    "frequency": 5391,
    "simplified": "不足为奇",
    "traditional": "不足為奇"
  },
  {
    "frequency": 5380,
    "simplified": "忍无可忍",
    "traditional": "忍無可忍"
  },
  {
    "frequency": 5372,
    "simplified": "埋头苦干",
    "traditional": "埋頭苦幹"
  },
  {
    "frequency": 5371,
    "simplified": "郁郁葱葱",
    "traditional": "鬱鬱蔥蔥"
  },
  {
    "frequency": 5360,
    "simplified": "事半功倍",
    "traditional": "事半功倍"
  },
  {
    "frequency": 5349,
    "simplified": "不省人事",
    "traditional": "不省人事"
  },
  {
    "frequency": 5345,
    "simplified": "分门别类",
    "traditional": "分門別類"
  },
  {
    "frequency": 5333,
    "simplified": "别出心裁",
    "traditional": "別出心裁"
  },
  {
    "frequency": 5328,
    "simplified": "明明白白",
    "traditional": "明明白白"
  },
  {
    "frequency": 5318,
    "simplified": "热情洋溢",
    "traditional": "熱情洋溢"
  },
  {
    "frequency": 5315,
    "simplified": "大张旗鼓",
    "traditional": "大張旗鼓"
  },
  {
    "frequency": 5312,
    "simplified": "防不胜防",
    "traditional": "防不勝防"
  },
  {
    "frequency": 5301,
    "simplified": "惊魂未定",
    "traditional": "驚魂未定"
  },
  {
    "frequency": 5301,
    "simplified": "蒙混过关",
    "traditional": "矇混過關"
  },
  {
    "frequency": 5297,
    "simplified": "错落有致",
    "traditional": "錯落有致"
  },
  {
    "frequency": 5277,
    "simplified": "一点一滴",
    "traditional": "一點一滴"
  },
  {
    "frequency": 5266,
    "simplified": "入不敷出",
    "traditional": "入不敷出"
  },
  {
    "frequency": 5257,
    "simplified": "我行我素",
    "traditional": "我行我素"
  },
  {
    "frequency": 5252,
    "simplified": "深思熟虑",
    "traditional": "深思熟慮"
  },
  {
    "frequency": 5247,
    "simplified": "趋之若鹜",
    "traditional": "趨之若鶩"
  },
  {
    "frequency": 5234,
    "simplified": "无微不至",
    "traditional": "無微不至"
  },
  {
    "frequency": 5231,
    "simplified": "溢于言表",
    "traditional": "溢於言表"
  },
  {
    "frequency": 5196,
    "simplified": "车水马龙",
    "traditional": "車水馬龍"
  },
  {
    "frequency": 5189,
    "simplified": "同心同德",
    "traditional": "同心同德"
  },
  {
    "frequency": 5185,
    "simplified": "无所适从",
    "traditional": "無所適從"
  },
  {
    "frequency": 5164,
    "simplified": "变本加厉",
    "traditional": "變本加厲"
  },
  {
    "frequency": 5158,
    "simplified": "壮士断腕",
    "traditional": "壯士斷腕"
  },
  {
    "frequency": 5152,
    "simplified": "雄心勃勃",
    "traditional": "雄心勃勃"
  },
  {
    "frequency": 5152,
    "simplified": "崭露头角",
    "traditional": "嶄露頭角"
  },
  {
    "frequency": 5145,
    "simplified": "以点带面",
    "traditional": "以點帶面"
  },
  {
    "frequency": 5143,
    "simplified": "学以致用",
    "traditional": "學以致用"
  },
  {
    "frequency": 5132,
    "simplified": "心中有数",
    "traditional": "心中有數"
  },
  {
    "frequency": 5124,
    "simplified": "五湖四海",
    "traditional": "五湖四海"
  },
  {
    "frequency": 5117,
    "simplified": "审时度势",
    "traditional": "審時度勢"
  },
  {
    "frequency": 5114,
    "simplified": "不择手段",
    "traditional": "不擇手段"
  },
  {
    "frequency": 5082,
    "simplified": "大起大落",
    "traditional": "大起大落"
  },
  {
    "frequency": 5081,
    "simplified": "不厌其烦",
    "traditional": "不厭其煩"
  },
  {
    "frequency": 5076,
    "simplified": "一针见血",
    "traditional": "一針見血"
  },
  {
    "frequency": 5075,
    "simplified": "四通八达",
    "traditional": "四通八達"
  },
  {
    "frequency": 5061,
    "simplified": "不可开交",
    "traditional": "不可開交"
  },
  {
    "frequency": 5052,
    "simplified": "春暖花开",
    "traditional": "春暖花開"
  },
  {
    "frequency": 5051,
    "simplified": "天经地义",
    "traditional": "天經地義"
  },
  {
    "frequency": 5037,
    "simplified": "悬而未决",
    "traditional": "懸而未決"
  },
  {
    "frequency": 5036,
    "simplified": "一言不发",
    "traditional": "一言不發"
  },
  {
    "frequency": 5036,
    "simplified": "蜂拥而至",
    "traditional": "蜂擁而至"
  },
  {
    "frequency": 5023,
    "simplified": "扬长而去",
    "traditional": "揚長而去"
  },
  {
    "frequency": 5018,
    "simplified": "水落石出",
    "traditional": "水落石出"
  },
  {
    "frequency": 5006,
    "simplified": "大开眼界",
    "traditional": "大開眼界"
  },
  {
    "frequency": 5002,
    "simplified": "载歌载舞",
    "traditional": "載歌載舞"
  },
  {
    "frequency": 4990,
    "simplified": "子虚乌有",
    "traditional": "子虛烏有"
  },
  {
    "frequency": 4987,
    "simplified": "了如指掌",
    "traditional": "瞭如指掌"
  },
  {
    "frequency": 4974,
    "simplified": "历历在目",
    "traditional": "歷歷在目"
  },
  {
    "frequency": 4966,
    "simplified": "徇私枉法",
    "traditional": "徇私枉法"
  },
  {
    "frequency": 4958,
    "simplified": "风云变幻",
    "traditional": "風雲變幻"
  },
  {
    "frequency": 4946,
    "simplified": "公正廉洁",
    "traditional": "公正廉潔"
  },
  {
    "frequency": 4945,
    "simplified": "茁壮成长",
    "traditional": "茁壯成長"
  },
  {
    "frequency": 4944,
    "simplified": "千丝万缕",
    "traditional": "千絲萬縷"
  },
  {
    "frequency": 4943,
    "simplified": "一步一个脚印",
    "traditional": "一步一個腳印"
  },
  {
    "frequency": 4939,
    "simplified": "奋不顾身",
    "traditional": "奮不顧身"
  },
  {
    "frequency": 4927,
    "simplified": "轻描淡写",
    "traditional": "輕描淡寫"
  },
  {
    "frequency": 4914,
    "simplified": "不解之缘",
    "traditional": "不解之緣"
  },
  {
    "frequency": 4914,
    "simplified": "有意无意",
    "traditional": "有意無意"
  },
  {
    "frequency": 4904,
    "simplified": "顾名思义",
    "traditional": "顧名思義"
  },
  {
    "frequency": 4898,
    "simplified": "有声有色",
    "traditional": "有聲有色"
  },
  {
    "frequency": 4895,
    "simplified": "流离失所",
    "traditional": "流離失所"
  },
  {
    "frequency": 4865,
    "simplified": "诸如此类",
    "traditional": "諸如此類"
  },
  {
    "frequency": 4858,
    "simplified": "一清二楚",
    "traditional": "一清二楚"
  },
  {
    "frequency": 4857,
    "simplified": "众志成城",
    "traditional": "眾志成城"
  },
  {
    "frequency": 4851,
    "simplified": "救死扶伤",
    "traditional": "救死扶傷"
  },
  {
    "frequency": 4846,
    "simplified": "梦寐以求",
    "traditional": "夢寐以求"
  },
  {
    "frequency": 4846,
    "simplified": "逍遥法外",
    "traditional": "逍遙法外"
  },
  {
    "frequency": 4845,
    "simplified": "按捺不住",
    "traditional": "按捺不住"
  },
  {
    "frequency": 4834,
    "simplified": "信誓旦旦",
    "traditional": "信誓旦旦"
  },
  {
    "frequency": 4829,
    "simplified": "不计其数",
    "traditional": "不計其數"
  },
  {
    "frequency": 4828,
    "simplified": "缺一不可",
    "traditional": "缺一不可"
  },
  {
    "frequency": 4823,
    "simplified": "脱胎换骨",
    "traditional": "脫胎換骨"
  },
  {
    "frequency": 4814,
    "simplified": "真心实意",
    "traditional": "真心實意"
  },
  {
    "frequency": 4808,
    "simplified": "对簿公堂",
    "traditional": "對簿公堂"
  },
  {
    "frequency": 4790,
    "simplified": "不辱使命",
    "traditional": "不辱使命"
  },
  {
    "frequency": 4789,
    "simplified": "狂风暴雨",
    "traditional": "狂風暴雨"
  },
  {
    "frequency": 4788,
    "simplified": "日复一日",
    "traditional": "日復一日"
  },
  {
    "frequency": 4782,
    "simplified": "白发苍苍",
    "traditional": "白髮蒼蒼"
  },
  {
    "frequency": 4776,
    "simplified": "山清水秀",
    "traditional": "山清水秀"
  },
  {
    "frequency": 4774,
    "simplified": "随心所欲",
    "traditional": "隨心所欲"
  },
  {
    "frequency": 4770,
    "simplified": "浩浩荡荡",
    "traditional": "浩浩蕩蕩"
  },
  {
    "frequency": 4770,
    "simplified": "不堪设想",
    "traditional": "不堪設想"
  },
  {
    "frequency": 4764,
    "simplified": "叹为观止",
    "traditional": "歎為觀止"
  },
  {
    "frequency": 4756,
    "simplified": "不由自主",
    "traditional": "不由自主"
  },
  {
    "frequency": 4754,
    "simplified": "天下第一",
    "traditional": "天下第一"
  },
  {
    "frequency": 4749,
    "simplified": "如愿以偿",
    "traditional": "如願以償"
  },
  {
    "frequency": 4747,
    "simplified": "取长补短",
    "traditional": "取長補短"
  },
  {
    "frequency": 4719,
    "simplified": "所见所闻",
    "traditional": "所見所聞"
  },
  {
    "frequency": 4713,
    "simplified": "近在咫尺",
    "traditional": "近在咫尺"
  },
  {
    "frequency": 4709,
    "simplified": "一言一行",
    "traditional": "一言一行"
  },
  {
    "frequency": 4708,
    "simplified": "惨不忍睹",
    "traditional": "慘不忍睹"
  },
  {
    "frequency": 4704,
    "simplified": "一无所获",
    "traditional": "一無所獲"
  },
  {
    "frequency": 4703,
    "simplified": "既得利益",
    "traditional": "既得利益"
  },
  {
    "frequency": 4698,
    "simplified": "呼之欲出",
    "traditional": "呼之欲出"
  },
  {
    "frequency": 4697,
    "simplified": "一厢情愿",
    "traditional": "一廂情願"
  },
  {
    "frequency": 4697,
    "simplified": "黄金时代",
    "traditional": "黃金時代"
  },
  {
    "frequency": 4692,
    "simplified": "无与伦比",
    "traditional": "無與倫比"
  },
  {
    "frequency": 4692,
    "simplified": "无中生有",
    "traditional": "無中生有"
  },
  {
    "frequency": 4686,
    "simplified": "啃硬骨头",
    "traditional": "啃硬骨頭"
  },
  {
    "frequency": 4682,
    "simplified": "轰动一时",
    "traditional": "轟動一時"
  },
  {
    "frequency": 4673,
    "simplified": "街头巷尾",
    "traditional": "街頭巷尾"
  },
  {
    "frequency": 4662,
    "simplified": "掷地有声",
    "traditional": "擲地有聲"
  },
  {
    "frequency": 4660,
    "simplified": "戛然而止",
    "traditional": "戛然而止"
  },
  {
    "frequency": 4655,
    "simplified": "念念不忘",
    "traditional": "念念不忘"
  },
  {
    "frequency": 4639,
    "simplified": "偷工减料",
    "traditional": "偷工減料"
  },
  {
    "frequency": 4636,
    "simplified": "津津有味",
    "traditional": "津津有味"
  },
  {
    "frequency": 4634,
    "simplified": "改头换面",
    "traditional": "改頭換面"
  },
  {
    "frequency": 4624,
    "simplified": "据为己有",
    "traditional": "據為己有"
  },
  {
    "frequency": 4618,
    "simplified": "大同小异",
    "traditional": "大同小異"
  },
  {
    "frequency": 4613,
    "simplified": "刮目相看",
    "traditional": "刮目相看"
  },
  {
    "frequency": 4607,
    "simplified": "令人发指",
    "traditional": "令人髮指"
  },
  {
    "frequency": 4603,
    "simplified": "目瞪口呆",
    "traditional": "目瞪口呆"
  },
  {
    "frequency": 4591,
    "simplified": "三三两两",
    "traditional": "三三兩兩"
  },
  {
    "frequency": 4591,
    "simplified": "雷厉风行",
    "traditional": "雷厲風行"
  },
  {
    "frequency": 4586,
    "simplified": "风雨无阻",
    "traditional": "風雨無阻"
  },
  {
    "frequency": 4577,
    "simplified": "江郎才尽",
    "traditional": "江郎才盡"
  },
  {
    "frequency": 4561,
    "simplified": "美轮美奂",
    "traditional": "美輪美奐"
  },
  {
    "frequency": 4548,
    "simplified": "货真价实",
    "traditional": "貨真價實"
  },
  {
    "frequency": 4545,
    "simplified": "三令五申",
    "traditional": "三令五申"
  },
  {
    "frequency": 4538,
    "simplified": "和睦相处",
    "traditional": "和睦相處"
  },
  {
    "frequency": 4524,
    "simplified": "感慨万千",
    "traditional": "感慨萬千"
  },
  {
    "frequency": 4515,
    "simplified": "拾金不昧",
    "traditional": "拾金不昧"
  },
  {
    "frequency": 4514,
    "simplified": "因人而异",
    "traditional": "因人而異"
  },
  {
    "frequency": 4513,
    "simplified": "一纸空文",
    "traditional": "一紙空文"
  },
  {
    "frequency": 4511,
    "simplified": "双管齐下",
    "traditional": "雙管齊下"
  },
  {
    "frequency": 4502,
    "simplified": "脱口而出",
    "traditional": "脫口而出"
  },
  {
    "frequency": 4498,
    "simplified": "曾几何时",
    "traditional": "曾幾何時"
  },
  {
    "frequency": 4496,
    "simplified": "逃之夭夭",
    "traditional": "逃之夭夭"
  },
  {
    "frequency": 4495,
    "simplified": "不可估量",
    "traditional": "不可估量"
  },
  {
    "frequency": 4490,
    "simplified": "心甘情愿",
    "traditional": "心甘情願"
  },
  {
    "frequency": 4488,
    "simplified": "一朝一夕",
    "traditional": "一朝一夕"
  },
  {
    "frequency": 4486,
    "simplified": "倾家荡产",
    "traditional": "傾家蕩產"
  },
  {
    "frequency": 4485,
    "simplified": "有利可图",
    "traditional": "有利可圖"
  },
  {
    "frequency": 4478,
    "simplified": "更上一层楼",
    "traditional": "更上一層樓"
  },
  {
    "frequency": 4473,
    "simplified": "证据确凿",
    "traditional": "證據確鑿"
  },
  {
    "frequency": 4456,
    "simplified": "万众一心",
    "traditional": "萬眾一心"
  },
  {
    "frequency": 4454,
    "simplified": "古色古香",
    "traditional": "古色古香"
  },
  {
    "frequency": 4440,
    "simplified": "刻骨铭心",
    "traditional": "刻骨銘心"
  },
  {
    "frequency": 4435,
    "simplified": "东窗事发",
    "traditional": "東窗事發"
  },
  {
    "frequency": 4425,
    "simplified": "开门见山",
    "traditional": "開門見山"
  },
  {
    "frequency": 4423,
    "simplified": "蒸蒸日上",
    "traditional": "蒸蒸日上"
  },
  {
    "frequency": 4416,
    "simplified": "艰苦卓绝",
    "traditional": "艱苦卓絕"
  },
  {
    "frequency": 4410,
    "simplified": "承上启下",
    "traditional": "承上啟下"
  },
  {
    "frequency": 4406,
    "simplified": "振奋人心",
    "traditional": "振奮人心"
  },
  {
    "frequency": 4406,
    "simplified": "风起云涌",
    "traditional": "風起雲湧"
  },
  {
    "frequency": 4404,
    "simplified": "乱七八糟",
    "traditional": "亂七八糟"
  },
  {
    "frequency": 4403,
    "simplified": "浑身解数",
    "traditional": "渾身解數"
  },
  {
    "frequency": 4398,
    "simplified": "一意孤行",
    "traditional": "一意孤行"
  },
  {
    "frequency": 4393,
    "simplified": "大有人在",
    "traditional": "大有人在"
  },
  {
    "frequency": 4388,
    "simplified": "年复一年",
    "traditional": "年復一年"
  },
  {
    "frequency": 4382,
    "simplified": "水土不服",
    "traditional": "水土不服"
  },
  {
    "frequency": 4381,
    "simplified": "绝无仅有",
    "traditional": "絕無僅有"
  },
  {
    "frequency": 4374,
    "simplified": "奄奄一息",
    "traditional": "奄奄一息"
  },
  {
    "frequency": 4370,
    "simplified": "生生不息",
    "traditional": "生生不息"
  },
  {
    "frequency": 4357,
    "simplified": "从头到尾",
    "traditional": "從頭到尾"
  },
  {
    "frequency": 4355,
    "simplified": "迫不得已",
    "traditional": "迫不得已"
  },
  {
    "frequency": 4353,
    "simplified": "公平合理",
    "traditional": "公平合理"
  },
  {
    "frequency": 4353,
    "simplified": "独善其身",
    "traditional": "獨善其身"
  },
  {
    "frequency": 4347,
    "simplified": "恰到好处",
    "traditional": "恰到好處"
  },
  {
    "frequency": 4336,
    "simplified": "一触即发",
    "traditional": "一觸即發"
  },
  {
    "frequency": 4327,
    "simplified": "说三道四",
    "traditional": "說三道四"
  },
  {
    "frequency": 4325,
    "simplified": "不胜枚举",
    "traditional": "不勝枚舉"
  },
  {
    "frequency": 4325,
    "simplified": "各抒己见",
    "traditional": "各抒己見"
  },
  {
    "frequency": 4324,
    "simplified": "意味深长",
    "traditional": "意味深長"
  },
  {
    "frequency": 4323,
    "simplified": "聪明才智",
    "traditional": "聰明才智"
  },
  {
    "frequency": 4317,
    "simplified": "生死存亡",
    "traditional": "生死存亡"
  },
  {
    "frequency": 4304,
    "simplified": "蠢蠢欲动",
    "traditional": "蠢蠢欲動"
  },
  {
    "frequency": 4294,
    "simplified": "摇摇欲坠",
    "traditional": "搖搖欲墜"
  },
  {
    "frequency": 4290,
    "simplified": "世外桃源",
    "traditional": "世外桃源"
  },
  {
    "frequency": 4284,
    "simplified": "滔滔不绝",
    "traditional": "滔滔不絕"
  },
  {
    "frequency": 4277,
    "simplified": "欣欣向荣",
    "traditional": "欣欣向榮"
  },
  {
    "frequency": 4271,
    "simplified": "添砖加瓦",
    "traditional": "添磚加瓦"
  },
  {
    "frequency": 4270,
    "simplified": "相差无几",
    "traditional": "相差無幾"
  },
  {
    "frequency": 4267,
    "simplified": "来势汹汹",
    "traditional": "來勢洶洶"
  },
  {
    "frequency": 4264,
    "simplified": "有朝一日",
    "traditional": "有朝一日"
  },
  {
    "frequency": 4264,
    "simplified": "疑难杂症",
    "traditional": "疑難雜症"
  },
  {
    "frequency": 4262,
    "simplified": "指日可待",
    "traditional": "指日可待"
  },
  {
    "frequency": 4259,
    "simplified": "每况愈下",
    "traditional": "每況愈下"
  },
  {
    "frequency": 4250,
    "simplified": "精打细算",
    "traditional": "精打細算"
  },
  {
    "frequency": 4249,
    "simplified": "真知灼见",
    "traditional": "真知灼見"
  },
  {
    "frequency": 4244,
    "simplified": "遥遥无期",
    "traditional": "遙遙無期"
  },
  {
    "frequency": 4237,
    "simplified": "代代相传",
    "traditional": "代代相傳"
  },
  {
    "frequency": 4231,
    "simplified": "勇往直前",
    "traditional": "勇往直前"
  },
  {
    "frequency": 4225,
    "simplified": "好景不长",
    "traditional": "好景不長"
  },
  {
    "frequency": 4223,
    "simplified": "另辟蹊径",
    "traditional": "另闢蹊徑"
  },
  {
    "frequency": 4223,
    "simplified": "朝气蓬勃",
    "traditional": "朝氣蓬勃"
  },
  {
    "frequency": 4218,
    "simplified": "见怪不怪",
    "traditional": "見怪不怪"
  },
  {
    "frequency": 4218,
    "simplified": "一劳永逸",
    "traditional": "一勞永逸"
  },
  {
    "frequency": 4217,
    "simplified": "目不暇接",
    "traditional": "目不暇接"
  },
  {
    "frequency": 4215,
    "simplified": "热气腾腾",
    "traditional": "熱氣騰騰"
  },
  {
    "frequency": 4207,
    "simplified": "脍炙人口",
    "traditional": "膾炙人口"
  },
  {
    "frequency": 4185,
    "simplified": "牵一发而动全身",
    "traditional": "牽一髮而動全身"
  },
  {
    "frequency": 4172,
    "simplified": "无所事事",
    "traditional": "無所事事"
  },
  {
    "frequency": 4166,
    "simplified": "甚嚣尘上",
    "traditional": "甚囂塵上"
  },
  {
    "frequency": 4164,
    "simplified": "时不我待",
    "traditional": "時不我待"
  },
  {
    "frequency": 4161,
    "simplified": "打成一片",
    "traditional": "打成一片"
  },
  {
    "frequency": 4161,
    "simplified": "一成不变",
    "traditional": "一成不變"
  },
  {
    "frequency": 4156,
    "simplified": "怀恨在心",
    "traditional": "懷恨在心"
  },
  {
    "frequency": 4145,
    "simplified": "总而言之",
    "traditional": "總而言之"
  },
  {
    "frequency": 4136,
    "simplified": "支支吾吾",
    "traditional": "支支吾吾"
  },
  {
    "frequency": 4135,
    "simplified": "艰苦创业",
    "traditional": "艱苦創業"
  },
  {
    "frequency": 4132,
    "simplified": "不务正业",
    "traditional": "不務正業"
  },
  {
    "frequency": 4122,
    "simplified": "身无分文",
    "traditional": "身無分文"
  },
  {
    "frequency": 4121,
    "simplified": "别具一格",
    "traditional": "別具一格"
  },
  {
    "frequency": 4105,
    "simplified": "治病救人",
    "traditional": "治病救人"
  },
  {
    "frequency": 4089,
    "simplified": "岌岌可危",
    "traditional": "岌岌可危"
  },
  {
    "frequency": 4087,
    "simplified": "丰功伟绩",
    "traditional": "豐功偉績"
  },
  {
    "frequency": 4080,
    "simplified": "他山之石",
    "traditional": "他山之石"
  },
  {
    "frequency": 4069,
    "simplified": "避重就轻",
    "traditional": "避重就輕"
  },
  {
    "frequency": 4063,
    "simplified": "按部就班",
    "traditional": "按部就班"
  },
  {
    "frequency": 4058,
    "simplified": "急转直下",
    "traditional": "急轉直下"
  },
  {
    "frequency": 4054,
    "simplified": "一举两得",
    "traditional": "一舉兩得"
  },
  {
    "frequency": 4052,
    "simplified": "兴高采烈",
    "traditional": "興高采烈"
  },
  {
    "frequency": 4045,
    "simplified": "同心协力",
    "traditional": "同心協力"
  },
  {
    "frequency": 4035,
    "simplified": "侃侃而谈",
    "traditional": "侃侃而談"
  },
  {
    "frequency": 4018,
    "simplified": "恼羞成怒",
    "traditional": "惱羞成怒"
  },
  {
    "frequency": 4017,
    "simplified": "天壤之别",
    "traditional": "天壤之別"
  },
  {
    "frequency": 4016,
    "simplified": "咄咄逼人",
    "traditional": "咄咄逼人"
  },
  {
    "frequency": 4011,
    "simplified": "千篇一律",
    "traditional": "千篇一律"
  },
  {
    "frequency": 4007,
    "simplified": "寸步难行",
    "traditional": "寸步難行"
  },
  {
    "frequency": 4004,
    "simplified": "嘘寒问暖",
    "traditional": "噓寒問暖"
  },
  {
    "frequency": 3999,
    "simplified": "不失时机",
    "traditional": "不失時機"
  },
  {
    "frequency": 3997,
    "simplified": "直截了当",
    "traditional": "直截了當"
  },
  {
    "frequency": 3989,
    "simplified": "白手起家",
    "traditional": "白手起家"
  },
  {
    "frequency": 3979,
    "simplified": "人去楼空",
    "traditional": "人去樓空"
  },
  {
    "frequency": 3978,
    "simplified": "置若罔闻",
    "traditional": "置若罔聞"
  },
  {
    "frequency": 3969,
    "simplified": "瞠目结舌",
    "traditional": "瞠目結舌"
  },
  {
    "frequency": 3962,
    "simplified": "长途跋涉",
    "traditional": "長途跋涉"
  },
  {
    "frequency": 3956,
    "simplified": "有说有笑",
    "traditional": "有說有笑"
  },
  {
    "frequency": 3955,
    "simplified": "严于律己",
    "traditional": "嚴於律己"
  },
  {
    "frequency": 3953,
    "simplified": "群策群力",
    "traditional": "群策群力"
  },
  {
    "frequency": 3952,
    "simplified": "前车之鉴",
    "traditional": "前車之鑑"
  },
  {
    "frequency": 3951,
    "simplified": "一拥而上",
    "traditional": "一擁而上"
  },
  {
    "frequency": 3950,
    "simplified": "毋庸讳言",
    "traditional": "毋庸諱言"
  },
  {
    "frequency": 3949,
    "simplified": "违法乱纪",
    "traditional": "違法亂紀"
  },
  {
    "frequency": 3947,
    "simplified": "大政方针",
    "traditional": "大政方針"
  },
  {
    "frequency": 3943,
    "simplified": "痛定思痛",
    "traditional": "痛定思痛"
  },
  {
    "frequency": 3941,
    "simplified": "难上加难",
    "traditional": "難上加難"
  },
  {
    "frequency": 3939,
    "simplified": "并肩作战",
    "traditional": "並肩作戰"
  },
  {
    "frequency": 3928,
    "simplified": "始终如一",
    "traditional": "始終如一"
  },
  {
    "frequency": 3927,
    "simplified": "数不胜数",
    "traditional": "數不勝數"
  },
  {
    "frequency": 3927,
    "simplified": "啼笑皆非",
    "traditional": "啼笑皆非"
  },
  {
    "frequency": 3924,
    "simplified": "不闻不问",
    "traditional": "不聞不問"
  },
  {
    "frequency": 3910,
    "simplified": "不相上下",
    "traditional": "不相上下"
  },
  {
    "frequency": 3908,
    "simplified": "自给自足",
    "traditional": "自給自足"
  },
  {
    "frequency": 3908,
    "simplified": "有生之年",
    "traditional": "有生之年"
  },
  {
    "frequency": 3901,
    "simplified": "民以食为天",
    "traditional": "民以食為天"
  },
  {
    "frequency": 3900,
    "simplified": "打草惊蛇",
    "traditional": "打草驚蛇"
  },
  {
    "frequency": 3898,
    "simplified": "守望相助",
    "traditional": "守望相助"
  },
  {
    "frequency": 3891,
    "simplified": "鼓舞人心",
    "traditional": "鼓舞人心"
  },
  {
    "frequency": 3873,
    "simplified": "三五成群",
    "traditional": "三五成群"
  },
  {
    "frequency": 3871,
    "simplified": "铿锵有力",
    "traditional": "鏗鏘有力"
  },
  {
    "frequency": 3862,
    "simplified": "接踵而来",
    "traditional": "接踵而來"
  },
  {
    "frequency": 3859,
    "simplified": "勤工俭学",
    "traditional": "勤工儉學"
  },
  {
    "frequency": 3858,
    "simplified": "赏心悦目",
    "traditional": "賞心悅目"
  },
  {
    "frequency": 3850,
    "simplified": "夜以继日",
    "traditional": "夜以繼日"
  },
  {
    "frequency": 3846,
    "simplified": "起早贪黑",
    "traditional": "起早貪黑"
  },
  {
    "frequency": 3845,
    "simplified": "爱不释手",
    "traditional": "愛不釋手"
  },
  {
    "frequency": 3844,
    "simplified": "手足无措",
    "traditional": "手足無措"
  },
  {
    "frequency": 3842,
    "simplified": "一分为二",
    "traditional": "一分為二"
  },
  {
    "frequency": 3841,
    "simplified": "不可多得",
    "traditional": "不可多得"
  },
  {
    "frequency": 3841,
    "simplified": "喜出望外",
    "traditional": "喜出望外"
  },
  {
    "frequency": 3831,
    "simplified": "何乐而不为",
    "traditional": "何樂而不為"
  },
  {
    "frequency": 3822,
    "simplified": "口口相传",
    "traditional": "口口相傳"
  },
  {
    "frequency": 3816,
    "simplified": "只争朝夕",
    "traditional": "只爭朝夕"
  },
  {
    "frequency": 3793,
    "simplified": "气喘吁吁",
    "traditional": "氣喘吁吁"
  },
  {
    "frequency": 3787,
    "simplified": "猝不及防",
    "traditional": "猝不及防"
  },
  {
    "frequency": 3784,
    "simplified": "不甘示弱",
    "traditional": "不甘示弱"
  },
  {
    "frequency": 3783,
    "simplified": "亡羊补牢",
    "traditional": "亡羊補牢"
  },
  {
    "frequency": 3781,
    "simplified": "意气风发",
    "traditional": "意氣風發"
  },
  {
    "frequency": 3777,
    "simplified": "摩拳擦掌",
    "traditional": "摩拳擦掌"
  },
  {
    "frequency": 3776,
    "simplified": "喜怒哀乐",
    "traditional": "喜怒哀樂"
  },
  {
    "frequency": 3776,
    "simplified": "千差万别",
    "traditional": "千差萬別"
  },
  {
    "frequency": 3773,
    "simplified": "酸甜苦辣",
    "traditional": "酸甜苦辣"
  },
  {
    "frequency": 3772,
    "simplified": "惟妙惟肖",
    "traditional": "惟妙惟肖"
  },
  {
    "frequency": 3765,
    "simplified": "自相矛盾",
    "traditional": "自相矛盾"
  },
  {
    "frequency": 3760,
    "simplified": "中流砥柱",
    "traditional": "中流砥柱"
  },
  {
    "frequency": 3754,
    "simplified": "真相大白",
    "traditional": "真相大白"
  },
  {
    "frequency": 3751,
    "simplified": "早出晚归",
    "traditional": "早出晚歸"
  },
  {
    "frequency": 3745,
    "simplified": "繁荣昌盛",
    "traditional": "繁榮昌盛"
  },
  {
    "frequency": 3745,
    "simplified": "异口同声",
    "traditional": "異口同聲"
  },
  {
    "frequency": 3732,
    "simplified": "喜气洋洋",
    "traditional": "喜氣洋洋"
  },
  {
    "frequency": 3726,
    "simplified": "大是大非",
    "traditional": "大是大非"
  },
  {
    "frequency": 3724,
    "simplified": "自食其力",
    "traditional": "自食其力"
  },
  {
    "frequency": 3721,
    "simplified": "言传身教",
    "traditional": "言傳身教"
  },
  {
    "frequency": 3716,
    "simplified": "浴血奋战",
    "traditional": "浴血奮戰"
  },
  {
    "frequency": 3716,
    "simplified": "充满生机",
    "traditional": "充滿生機"
  },
  {
    "frequency": 3700,
    "simplified": "大惊小怪",
    "traditional": "大驚小怪"
  },
  {
    "frequency": 3695,
    "simplified": "转危为安",
    "traditional": "轉危為安"
  },
  {
    "frequency": 3691,
    "simplified": "见缝插针",
    "traditional": "見縫插針"
  },
  {
    "frequency": 3687,
    "simplified": "平易近人",
    "traditional": "平易近人"
  },
  {
    "frequency": 3679,
    "simplified": "古今中外",
    "traditional": "古今中外"
  },
  {
    "frequency": 3673,
    "simplified": "怨声载道",
    "traditional": "怨聲載道"
  },
  {
    "frequency": 3667,
    "simplified": "人声鼎沸",
    "traditional": "人聲鼎沸"
  },
  {
    "frequency": 3661,
    "simplified": "千里迢迢",
    "traditional": "千里迢迢"
  },
  {
    "frequency": 3655,
    "simplified": "融会贯通",
    "traditional": "融會貫通"
  },
  {
    "frequency": 3654,
    "simplified": "整装待发",
    "traditional": "整裝待發"
  },
  {
    "frequency": 3642,
    "simplified": "得心应手",
    "traditional": "得心應手"
  },
  {
    "frequency": 3639,
    "simplified": "守土有责",
    "traditional": "守土有責"
  },
  {
    "frequency": 3637,
    "simplified": "破口大骂",
    "traditional": "破口大罵"
  },
  {
    "frequency": 3632,
    "simplified": "不可磨灭",
    "traditional": "不可磨滅"
  },
  {
    "frequency": 3626,
    "simplified": "永无止境",
    "traditional": "永無止境"
  },
  {
    "frequency": 3624,
    "simplified": "令人咋舌",
    "traditional": "令人咋舌"
  },
  {
    "frequency": 3624,
    "simplified": "犹豫不决",
    "traditional": "猶豫不決"
  },
  {
    "frequency": 3617,
    "simplified": "一去不复返",
    "traditional": "一去不復返"
  },
  {
    "frequency": 3616,
    "simplified": "火眼金睛",
    "traditional": "火眼金睛"
  },
  {
    "frequency": 3614,
    "simplified": "袖手旁观",
    "traditional": "袖手旁觀"
  },
  {
    "frequency": 3611,
    "simplified": "苦口婆心",
    "traditional": "苦口婆心"
  },
  {
    "frequency": 3604,
    "simplified": "游刃有余",
    "traditional": "遊刃有餘"
  },
  {
    "frequency": 3581,
    "simplified": "始终不渝",
    "traditional": "始終不渝"
  },
  {
    "frequency": 3576,
    "simplified": "发家致富",
    "traditional": "發家致富"
  },
  {
    "frequency": 3562,
    "simplified": "耿耿于怀",
    "traditional": "耿耿於懷"
  },
  {
    "frequency": 3561,
    "simplified": "油然而生",
    "traditional": "油然而生"
  },
  {
    "frequency": 3557,
    "simplified": "害群之马",
    "traditional": "害群之馬"
  },
  {
    "frequency": 3556,
    "simplified": "伤痕累累",
    "traditional": "傷痕累累"
  },
  {
    "frequency": 3549,
    "simplified": "权宜之计",
    "traditional": "權宜之計"
  },
  {
    "frequency": 3546,
    "simplified": "背井离乡",
    "traditional": "背井離鄉"
  },
  {
    "frequency": 3544,
    "simplified": "支离破碎",
    "traditional": "支離破碎"
  },
  {
    "frequency": 3544,
    "simplified": "皆大欢喜",
    "traditional": "皆大歡喜"
  },
  {
    "frequency": 3537,
    "simplified": "大名鼎鼎",
    "traditional": "大名鼎鼎"
  },
  {
    "frequency": 3518,
    "simplified": "合二为一",
    "traditional": "合二為一"
  },
  {
    "frequency": 3516,
    "simplified": "风吹草动",
    "traditional": "風吹草動"
  },
  {
    "frequency": 3515,
    "simplified": "依依不舍",
    "traditional": "依依不捨"
  },
  {
    "frequency": 3513,
    "simplified": "秋高气爽",
    "traditional": "秋高氣爽"
  },
  {
    "frequency": 3512,
    "simplified": "挺身而出",
    "traditional": "挺身而出"
  },
  {
    "frequency": 3500,
    "simplified": "掩人耳目",
    "traditional": "掩人耳目"
  },
  {
    "frequency": 3496,
    "simplified": "姗姗来迟",
    "traditional": "姍姍來遲"
  },
  {
    "frequency": 3493,
    "simplified": "实至名归",
    "traditional": "實至名歸"
  },
  {
    "frequency": 3493,
    "simplified": "事与愿违",
    "traditional": "事與願違"
  },
  {
    "frequency": 3486,
    "simplified": "翩翩起舞",
    "traditional": "翩翩起舞"
  },
  {
    "frequency": 3483,
    "simplified": "名目繁多",
    "traditional": "名目繁多"
  },
  {
    "frequency": 3480,
    "simplified": "凤毛麟角",
    "traditional": "鳳毛麟角"
  },
  {
    "frequency": 3475,
    "simplified": "忍气吞声",
    "traditional": "忍氣吞聲"
  },
  {
    "frequency": 3468,
    "simplified": "耳濡目染",
    "traditional": "耳濡目染"
  },
  {
    "frequency": 3462,
    "simplified": "天伦之乐",
    "traditional": "天倫之樂"
  },
  {
    "frequency": 3462,
    "simplified": "一气呵成",
    "traditional": "一氣呵成"
  },
  {
    "frequency": 3457,
    "simplified": "千载难逢",
    "traditional": "千載難逢"
  },
  {
    "frequency": 3452,
    "simplified": "满目疮痍",
    "traditional": "滿目瘡痍"
  },
  {
    "frequency": 3450,
    "simplified": "堆积如山",
    "traditional": "堆積如山"
  },
  {
    "frequency": 3446,
    "simplified": "一无所有",
    "traditional": "一無所有"
  },
  {
    "frequency": 3446,
    "simplified": "追根溯源",
    "traditional": "追根溯源"
  },
  {
    "frequency": 3444,
    "simplified": "精神抖擞",
    "traditional": "精神抖擻"
  },
  {
    "frequency": 3440,
    "simplified": "人心惶惶",
    "traditional": "人心惶惶"
  },
  {
    "frequency": 3438,
    "simplified": "朝夕相处",
    "traditional": "朝夕相處"
  },
  {
    "frequency": 3437,
    "simplified": "当仁不让",
    "traditional": "當仁不讓"
  },
  {
    "frequency": 3421,
    "simplified": "不依不饶",
    "traditional": "不依不饒"
  },
  {
    "frequency": 3419,
    "simplified": "设身处地",
    "traditional": "設身處地"
  },
  {
    "frequency": 3417,
    "simplified": "名胜古迹",
    "traditional": "名勝古蹟"
  },
  {
    "frequency": 3417,
    "simplified": "血肉模糊",
    "traditional": "血肉模糊"
  },
  {
    "frequency": 3414,
    "simplified": "焦头烂额",
    "traditional": "焦頭爛額"
  },
  {
    "frequency": 3411,
    "simplified": "无缘无故",
    "traditional": "無緣無故"
  },
  {
    "frequency": 3408,
    "simplified": "日积月累",
    "traditional": "日積月累"
  },
  {
    "frequency": 3398,
    "simplified": "旷日持久",
    "traditional": "曠日持久"
  },
  {
    "frequency": 3393,
    "simplified": "不胫而走",
    "traditional": "不脛而走"
  },
  {
    "frequency": 3384,
    "simplified": "忍俊不禁",
    "traditional": "忍俊不禁"
  },
  {
    "frequency": 3379,
    "simplified": "成群结队",
    "traditional": "成群結隊"
  },
  {
    "frequency": 3376,
    "simplified": "接连不断",
    "traditional": "接連不斷"
  },
  {
    "frequency": 3373,
    "simplified": "无稽之谈",
    "traditional": "無稽之談"
  },
  {
    "frequency": 3370,
    "simplified": "债台高筑",
    "traditional": "債臺高築"
  },
  {
    "frequency": 3368,
    "simplified": "因材施教",
    "traditional": "因材施教"
  },
  {
    "frequency": 3366,
    "simplified": "居安思危",
    "traditional": "居安思危"
  },
  {
    "frequency": 3366,
    "simplified": "手忙脚乱",
    "traditional": "手忙腳亂"
  },
  {
    "frequency": 3361,
    "simplified": "轻重缓急",
    "traditional": "輕重緩急"
  },
  {
    "frequency": 3360,
    "simplified": "应接不暇",
    "traditional": "應接不暇"
  },
  {
    "frequency": 3355,
    "simplified": "矢志不渝",
    "traditional": "矢志不渝"
  },
  {
    "frequency": 3349,
    "simplified": "触手可及",
    "traditional": "觸手可及"
  },
  {
    "frequency": 3344,
    "simplified": "发人深省",
    "traditional": "發人深省"
  },
  {
    "frequency": 3343,
    "simplified": "破门而入",
    "traditional": "破門而入"
  },
  {
    "frequency": 3343,
    "simplified": "异曲同工",
    "traditional": "異曲同工"
  },
  {
    "frequency": 3340,
    "simplified": "自言自语",
    "traditional": "自言自語"
  },
  {
    "frequency": 3331,
    "simplified": "左邻右舍",
    "traditional": "左鄰右舍"
  },
  {
    "frequency": 3322,
    "simplified": "乐在其中",
    "traditional": "樂在其中"
  },
  {
    "frequency": 3311,
    "simplified": "以身试法",
    "traditional": "以身試法"
  },
  {
    "frequency": 3310,
    "simplified": "养家糊口",
    "traditional": "養家餬口"
  },
  {
    "frequency": 3309,
    "simplified": "众矢之的",
    "traditional": "眾矢之的"
  },
  {
    "frequency": 3300,
    "simplified": "心平气和",
    "traditional": "心平氣和"
  },
  {
    "frequency": 3288,
    "simplified": "若隐若现",
    "traditional": "若隱若現"
  },
  {
    "frequency": 3288,
    "simplified": "繁荣富强",
    "traditional": "繁榮富強"
  },
  {
    "frequency": 3285,
    "simplified": "哗众取宠",
    "traditional": "譁眾取寵"
  },
  {
    "frequency": 3281,
    "simplified": "纵横交错",
    "traditional": "縱橫交錯"
  },
  {
    "frequency": 3273,
    "simplified": "空穴来风",
    "traditional": "空穴來風"
  },
  {
    "frequency": 3270,
    "simplified": "叫苦不迭",
    "traditional": "叫苦不迭"
  },
  {
    "frequency": 3264,
    "simplified": "因势利导",
    "traditional": "因勢利導"
  },
  {
    "frequency": 3263,
    "simplified": "德高望重",
    "traditional": "德高望重"
  },
  {
    "frequency": 3256,
    "simplified": "舆论哗然",
    "traditional": "輿論譁然"
  },
  {
    "frequency": 3255,
    "simplified": "有恃无恐",
    "traditional": "有恃無恐"
  },
  {
    "frequency": 3251,
    "simplified": "人命关天",
    "traditional": "人命關天"
  },
  {
    "frequency": 3250,
    "simplified": "气势磅礴",
    "traditional": "氣勢磅礴"
  },
  {
    "frequency": 3245,
    "simplified": "昙花一现",
    "traditional": "曇花一現"
  },
  {
    "frequency": 3243,
    "simplified": "息事宁人",
    "traditional": "息事寧人"
  },
  {
    "frequency": 3242,
    "simplified": "日日夜夜",
    "traditional": "日日夜夜"
  },
  {
    "frequency": 3240,
    "simplified": "荡然无存",
    "traditional": "蕩然無存"
  },
  {
    "frequency": 3239,
    "simplified": "欢欣鼓舞",
    "traditional": "歡欣鼓舞"
  },
  {
    "frequency": 3231,
    "simplified": "惊天动地",
    "traditional": "驚天動地"
  },
  {
    "frequency": 3220,
    "simplified": "艰难险阻",
    "traditional": "艱難險阻"
  },
  {
    "frequency": 3218,
    "simplified": "险象环生",
    "traditional": "險象環生"
  },
  {
    "frequency": 3206,
    "simplified": "数一数二",
    "traditional": "數一數二"
  },
  {
    "frequency": 3204,
    "simplified": "切身体会",
    "traditional": "切身體會"
  },
  {
    "frequency": 3192,
    "simplified": "以假乱真",
    "traditional": "以假亂真"
  },
  {
    "frequency": 3191,
    "simplified": "风风雨雨",
    "traditional": "風風雨雨"
  },
  {
    "frequency": 3187,
    "simplified": "天寒地冻",
    "traditional": "天寒地凍"
  },
  {
    "frequency": 3187,
    "simplified": "辞旧迎新",
    "traditional": "辭舊迎新"
  },
  {
    "frequency": 3178,
    "simplified": "负债累累",
    "traditional": "負債累累"
  },
  {
    "frequency": 3173,
    "simplified": "任劳任怨",
    "traditional": "任勞任怨"
  },
  {
    "frequency": 3171,
    "simplified": "走投无路",
    "traditional": "走投無路"
  },
  {
    "frequency": 3170,
    "simplified": "令行禁止",
    "traditional": "令行禁止"
  },
  {
    "frequency": 3170,
    "simplified": "重蹈覆辙",
    "traditional": "重蹈覆轍"
  },
  {
    "frequency": 3168,
    "simplified": "无时无刻",
    "traditional": "無時無刻"
  },
  {
    "frequency": 3167,
    "simplified": "成家立业",
    "traditional": "成家立業"
  },
  {
    "frequency": 3167,
    "simplified": "炎黄子孙",
    "traditional": "炎黃子孫"
  },
  {
    "frequency": 3166,
    "simplified": "剑拔弩张",
    "traditional": "劍拔弩張"
  },
  {
    "frequency": 3161,
    "simplified": "将心比心",
    "traditional": "將心比心"
  },
  {
    "frequency": 3158,
    "simplified": "大手大脚",
    "traditional": "大手大腳"
  },
  {
    "frequency": 3157,
    "simplified": "一览无余",
    "traditional": "一覽無餘"
  },
  {
    "frequency": 3156,
    "simplified": "为所欲为",
    "traditional": "為所欲為"
  },
  {
    "frequency": 3155,
    "simplified": "名正言顺",
    "traditional": "名正言順"
  },
  {
    "frequency": 3153,
    "simplified": "纸上谈兵",
    "traditional": "紙上談兵"
  },
  {
    "frequency": 3143,
    "simplified": "川流不息",
    "traditional": "川流不息"
  },
  {
    "frequency": 3143,
    "simplified": "夜深人静",
    "traditional": "夜深人靜"
  },
  {
    "frequency": 3139,
    "simplified": "一天到晚",
    "traditional": "一天到晚"
  },
  {
    "frequency": 3139,
    "simplified": "美不胜收",
    "traditional": "美不勝收"
  },
  {
    "frequency": 3136,
    "simplified": "善始善终",
    "traditional": "善始善終"
  },
  {
    "frequency": 3136,
    "simplified": "枝繁叶茂",
    "traditional": "枝繁葉茂"
  },
  {
    "frequency": 3135,
    "simplified": "意料之外",
    "traditional": "意料之外"
  },
  {
    "frequency": 3131,
    "simplified": "斩钉截铁",
    "traditional": "斬釘截鐵"
  },
  {
    "frequency": 3125,
    "simplified": "风云人物",
    "traditional": "風雲人物"
  },
  {
    "frequency": 3123,
    "simplified": "壮烈牺牲",
    "traditional": "壯烈犧牲"
  },
  {
    "frequency": 3122,
    "simplified": "大有裨益",
    "traditional": "大有裨益"
  },
  {
    "frequency": 3120,
    "simplified": "铺平道路",
    "traditional": "鋪平道路"
  },
  {
    "frequency": 3119,
    "simplified": "防微杜渐",
    "traditional": "防微杜漸"
  },
  {
    "frequency": 3118,
    "simplified": "无影无踪",
    "traditional": "無影無蹤"
  },
  {
    "frequency": 3116,
    "simplified": "举手之劳",
    "traditional": "舉手之勞"
  },
  {
    "frequency": 3109,
    "simplified": "中西合璧",
    "traditional": "中西合璧"
  },
  {
    "frequency": 3101,
    "simplified": "走马上任",
    "traditional": "走馬上任"
  },
  {
    "frequency": 3098,
    "simplified": "拍手称快",
    "traditional": "拍手稱快"
  },
  {
    "frequency": 3095,
    "simplified": "一年到头",
    "traditional": "一年到頭"
  },
  {
    "frequency": 3093,
    "simplified": "小心谨慎",
    "traditional": "小心謹慎"
  },
  {
    "frequency": 3085,
    "simplified": "海纳百川",
    "traditional": "海納百川"
  },
  {
    "frequency": 3085,
    "simplified": "来历不明",
    "traditional": "來歷不明"
  },
  {
    "frequency": 3083,
    "simplified": "汗流浃背",
    "traditional": "汗流浹背"
  },
  {
    "frequency": 3078,
    "simplified": "七嘴八舌",
    "traditional": "七嘴八舌"
  },
  {
    "frequency": 3076,
    "simplified": "本末倒置",
    "traditional": "本末倒置"
  },
  {
    "frequency": 3073,
    "simplified": "嚎啕大哭",
    "traditional": "嚎啕大哭"
  },
  {
    "frequency": 3073,
    "simplified": "不顾一切",
    "traditional": "不顧一切"
  },
  {
    "frequency": 3071,
    "simplified": "混淆视听",
    "traditional": "混淆視聽"
  },
  {
    "frequency": 3068,
    "simplified": "热血沸腾",
    "traditional": "熱血沸騰"
  },
  {
    "frequency": 3067,
    "simplified": "左右为难",
    "traditional": "左右為難"
  },
  {
    "frequency": 3063,
    "simplified": "风平浪静",
    "traditional": "風平浪靜"
  },
  {
    "frequency": 3061,
    "simplified": "如履薄冰",
    "traditional": "如履薄冰"
  },
  {
    "frequency": 3056,
    "simplified": "先天不足",
    "traditional": "先天不足"
  },
  {
    "frequency": 3056,
    "simplified": "招摇撞骗",
    "traditional": "招搖撞騙"
  },
  {
    "frequency": 3048,
    "simplified": "解疑释惑",
    "traditional": "解疑釋惑"
  },
  {
    "frequency": 3044,
    "simplified": "不速之客",
    "traditional": "不速之客"
  },
  {
    "frequency": 3044,
    "simplified": "心服口服",
    "traditional": "心服口服"
  },
  {
    "frequency": 3043,
    "simplified": "东拼西凑",
    "traditional": "東拼西湊"
  },
  {
    "frequency": 3041,
    "simplified": "一落千丈",
    "traditional": "一落千丈"
  },
  {
    "frequency": 3041,
    "simplified": "原原本本",
    "traditional": "原原本本"
  },
  {
    "frequency": 3036,
    "simplified": "火上浇油",
    "traditional": "火上澆油"
  },
  {
    "frequency": 3036,
    "simplified": "就事论事",
    "traditional": "就事論事"
  },
  {
    "frequency": 3033,
    "simplified": "没完没了",
    "traditional": "沒完沒了"
  },
  {
    "frequency": 3032,
    "simplified": "报效祖国",
    "traditional": "報效祖國"
  },
  {
    "frequency": 3030,
    "simplified": "劳民伤财",
    "traditional": "勞民傷財"
  },
  {
    "frequency": 3028,
    "simplified": "危言耸听",
    "traditional": "危言聳聽"
  },
  {
    "frequency": 3026,
    "simplified": "天马行空",
    "traditional": "天馬行空"
  },
  {
    "frequency": 3026,
    "simplified": "煞费苦心",
    "traditional": "煞費苦心"
  },
  {
    "frequency": 3020,
    "simplified": "自欺欺人",
    "traditional": "自欺欺人"
  },
  {
    "frequency": 3007,
    "simplified": "讳莫如深",
    "traditional": "諱莫如深"
  },
  {
    "frequency": 3003,
    "simplified": "断章取义",
    "traditional": "斷章取義"
  },
  {
    "frequency": 3002,
    "simplified": "五彩缤纷",
    "traditional": "五彩繽紛"
  },
  {
    "frequency": 2995,
    "simplified": "进退两难",
    "traditional": "進退兩難"
  },
  {
    "frequency": 2994,
    "simplified": "改过自新",
    "traditional": "改過自新"
  },
  {
    "frequency": 2988,
    "simplified": "一口咬定",
    "traditional": "一口咬定"
  },
  {
    "frequency": 2978,
    "simplified": "急于求成",
    "traditional": "急於求成"
  },
  {
    "frequency": 2973,
    "simplified": "严惩不贷",
    "traditional": "嚴懲不貸"
  },
  {
    "frequency": 2973,
    "simplified": "疲惫不堪",
    "traditional": "疲憊不堪"
  },
  {
    "frequency": 2970,
    "simplified": "百折不挠",
    "traditional": "百折不撓"
  },
  {
    "frequency": 2969,
    "simplified": "一家老小",
    "traditional": "一家老小"
  },
  {
    "frequency": 2968,
    "simplified": "大显身手",
    "traditional": "大顯身手"
  },
  {
    "frequency": 2968,
    "simplified": "兴旺发达",
    "traditional": "興旺發達"
  },
  {
    "frequency": 2963,
    "simplified": "头破血流",
    "traditional": "頭破血流"
  },
  {
    "frequency": 2957,
    "simplified": "浑水摸鱼",
    "traditional": "渾水摸魚"
  },
  {
    "frequency": 2944,
    "simplified": "不容置疑",
    "traditional": "不容置疑"
  },
  {
    "frequency": 2943,
    "simplified": "孜孜不倦",
    "traditional": "孜孜不倦"
  },
  {
    "frequency": 2943,
    "simplified": "长久之计",
    "traditional": "長久之計"
  },
  {
    "frequency": 2942,
    "simplified": "闻名遐迩",
    "traditional": "聞名遐邇"
  },
  {
    "frequency": 2941,
    "simplified": "千辛万苦",
    "traditional": "千辛萬苦"
  },
  {
    "frequency": 2939,
    "simplified": "指手画脚",
    "traditional": "指手畫腳"
  },
  {
    "frequency": 2937,
    "simplified": "赫赫有名",
    "traditional": "赫赫有名"
  },
  {
    "frequency": 2934,
    "simplified": "灭顶之灾",
    "traditional": "滅頂之災"
  },
  {
    "frequency": 2931,
    "simplified": "如影随形",
    "traditional": "如影隨形"
  },
  {
    "frequency": 2927,
    "simplified": "风调雨顺",
    "traditional": "風調雨順"
  },
  {
    "frequency": 2926,
    "simplified": "无所作为",
    "traditional": "無所作為"
  },
  {
    "frequency": 2925,
    "simplified": "茶余饭后",
    "traditional": "茶餘飯後"
  },
  {
    "frequency": 2921,
    "simplified": "痛哭流涕",
    "traditional": "痛哭流涕"
  },
  {
    "frequency": 2915,
    "simplified": "高屋建瓴",
    "traditional": "高屋建瓴"
  },
  {
    "frequency": 2912,
    "simplified": "走马观花",
    "traditional": "走馬觀花"
  },
  {
    "frequency": 2909,
    "simplified": "步调一致",
    "traditional": "步調一致"
  },
  {
    "frequency": 2907,
    "simplified": "憨态可掬",
    "traditional": "憨態可掬"
  },
  {
    "frequency": 2905,
    "simplified": "蒙在鼓里",
    "traditional": "矇在鼓裡"
  },
  {
    "frequency": 2902,
    "simplified": "屡教不改",
    "traditional": "屢教不改"
  },
  {
    "frequency": 2901,
    "simplified": "歪风邪气",
    "traditional": "歪風邪氣"
  },
  {
    "frequency": 2899,
    "simplified": "失之交臂",
    "traditional": "失之交臂"
  },
  {
    "frequency": 2898,
    "simplified": "漫天要价",
    "traditional": "漫天要價"
  },
  {
    "frequency": 2894,
    "simplified": "平心而论",
    "traditional": "平心而論"
  },
  {
    "frequency": 2893,
    "simplified": "不在话下",
    "traditional": "不在話下"
  },
  {
    "frequency": 2890,
    "simplified": "还本付息",
    "traditional": "還本付息"
  },
  {
    "frequency": 2890,
    "simplified": "担惊受怕",
    "traditional": "擔驚受怕"
  },
  {
    "frequency": 2888,
    "simplified": "约定俗成",
    "traditional": "約定俗成"
  },
  {
    "frequency": 2883,
    "simplified": "廉洁奉公",
    "traditional": "廉潔奉公"
  },
  {
    "frequency": 2882,
    "simplified": "果不其然",
    "traditional": "果不其然"
  },
  {
    "frequency": 2870,
    "simplified": "立于不败之地",
    "traditional": "立於不敗之地"
  },
  {
    "frequency": 2867,
    "simplified": "晴天霹雳",
    "traditional": "晴天霹靂"
  },
  {
    "frequency": 2865,
    "simplified": "正本清源",
    "traditional": "正本清源"
  },
  {
    "frequency": 2857,
    "simplified": "不负众望",
    "traditional": "不負眾望"
  },
  {
    "frequency": 2857,
    "simplified": "瞬息万变",
    "traditional": "瞬息萬變"
  },
  {
    "frequency": 2855,
    "simplified": "不可逾越",
    "traditional": "不可逾越"
  },
  {
    "frequency": 2852,
    "simplified": "靠天吃饭",
    "traditional": "靠天吃飯"
  },
  {
    "frequency": 2846,
    "simplified": "语焉不详",
    "traditional": "語焉不詳"
  },
  {
    "frequency": 2844,
    "simplified": "悲痛欲绝",
    "traditional": "悲痛欲絕"
  },
  {
    "frequency": 2842,
    "simplified": "各显神通",
    "traditional": "各顯神通"
  },
  {
    "frequency": 2831,
    "simplified": "前赴后继",
    "traditional": "前赴後繼"
  },
  {
    "frequency": 2829,
    "simplified": "翻山越岭",
    "traditional": "翻山越嶺"
  },
  {
    "frequency": 2828,
    "simplified": "临危受命",
    "traditional": "臨危受命"
  },
  {
    "frequency": 2827,
    "simplified": "忐忑不安",
    "traditional": "忐忑不安"
  },
  {
    "frequency": 2826,
    "simplified": "不可同日而语",
    "traditional": "不可同日而語"
  },
  {
    "frequency": 2825,
    "simplified": "不拘一格",
    "traditional": "不拘一格"
  },
  {
    "frequency": 2822,
    "simplified": "有机可乘",
    "traditional": "有機可乘"
  },
  {
    "frequency": 2820,
    "simplified": "漫山遍野",
    "traditional": "漫山遍野"
  },
  {
    "frequency": 2819,
    "simplified": "赞叹不已",
    "traditional": "讚歎不已"
  },
  {
    "frequency": 2819,
    "simplified": "而立之年",
    "traditional": "而立之年"
  },
  {
    "frequency": 2816,
    "simplified": "不假思索",
    "traditional": "不假思索"
  },
  {
    "frequency": 2816,
    "simplified": "不屈不挠",
    "traditional": "不屈不撓"
  },
  {
    "frequency": 2811,
    "simplified": "潸然泪下",
    "traditional": "潸然淚下"
  },
  {
    "frequency": 2803,
    "simplified": "礼尚往来",
    "traditional": "禮尚往來"
  },
  {
    "frequency": 2803,
    "simplified": "条条框框",
    "traditional": "條條框框"
  },
  {
    "frequency": 2803,
    "simplified": "灵机一动",
    "traditional": "靈機一動"
  },
  {
    "frequency": 2802,
    "simplified": "引人入胜",
    "traditional": "引人入勝"
  },
  {
    "frequency": 2801,
    "simplified": "若无其事",
    "traditional": "若無其事"
  },
  {
    "frequency": 2798,
    "simplified": "熟视无睹",
    "traditional": "熟視無睹"
  },
  {
    "frequency": 2796,
    "simplified": "骇人听闻",
    "traditional": "駭人聽聞"
  },
  {
    "frequency": 2793,
    "simplified": "趋利避害",
    "traditional": "趨利避害"
  },
  {
    "frequency": 2793,
    "simplified": "供过于求",
    "traditional": "供過於求"
  },
  {
    "frequency": 2792,
    "simplified": "交口称赞",
    "traditional": "交口稱讚"
  },
  {
    "frequency": 2781,
    "simplified": "精力充沛",
    "traditional": "精力充沛"
  },
  {
    "frequency": 2778,
    "simplified": "冠冕堂皇",
    "traditional": "冠冕堂皇"
  },
  {
    "frequency": 2778,
    "simplified": "分道扬镳",
    "traditional": "分道揚鑣"
  },
  {
    "frequency": 2777,
    "simplified": "荷枪实弹",
    "traditional": "荷槍實彈"
  },
  {
    "frequency": 2777,
    "simplified": "老生常谈",
    "traditional": "老生常談"
  },
  {
    "frequency": 2774,
    "simplified": "彻头彻尾",
    "traditional": "徹頭徹尾"
  },
  {
    "frequency": 2770,
    "simplified": "活灵活现",
    "traditional": "活靈活現"
  },
  {
    "frequency": 2765,
    "simplified": "安身立命",
    "traditional": "安身立命"
  },
  {
    "frequency": 2763,
    "simplified": "风雨同舟",
    "traditional": "風雨同舟"
  },
  {
    "frequency": 2761,
    "simplified": "游手好闲",
    "traditional": "遊手好閒"
  },
  {
    "frequency": 2760,
    "simplified": "心灰意冷",
    "traditional": "心灰意冷"
  },
  {
    "frequency": 2759,
    "simplified": "耸人听闻",
    "traditional": "聳人聽聞"
  },
  {
    "frequency": 2757,
    "simplified": "网开一面",
    "traditional": "網開一面"
  },
  {
    "frequency": 2753,
    "simplified": "精兵强将",
    "traditional": "精兵強將"
  },
  {
    "frequency": 2753,
    "simplified": "电闪雷鸣",
    "traditional": "電閃雷鳴"
  },
  {
    "frequency": 2751,
    "simplified": "星罗棋布",
    "traditional": "星羅棋佈"
  },
  {
    "frequency": 2750,
    "simplified": "谈何容易",
    "traditional": "談何容易"
  },
  {
    "frequency": 2749,
    "simplified": "三缄其口",
    "traditional": "三緘其口"
  },
  {
    "frequency": 2742,
    "simplified": "众目睽睽",
    "traditional": "眾目睽睽"
  },
  {
    "frequency": 2739,
    "simplified": "混为一谈",
    "traditional": "混為一談"
  },
  {
    "frequency": 2737,
    "simplified": "不能自拔",
    "traditional": "不能自拔"
  },
  {
    "frequency": 2735,
    "simplified": "多才多艺",
    "traditional": "多才多藝"
  },
  {
    "frequency": 2734,
    "simplified": "不欢而散",
    "traditional": "不歡而散"
  },
  {
    "frequency": 2731,
    "simplified": "井井有条",
    "traditional": "井井有條"
  },
  {
    "frequency": 2729,
    "simplified": "鳞次栉比",
    "traditional": "鱗次櫛比"
  },
  {
    "frequency": 2725,
    "simplified": "自以为是",
    "traditional": "自以為是"
  },
  {
    "frequency": 2724,
    "simplified": "腾空而起",
    "traditional": "騰空而起"
  },
  {
    "frequency": 2724,
    "simplified": "不动声色",
    "traditional": "不動聲色"
  },
  {
    "frequency": 2719,
    "simplified": "稳扎稳打",
    "traditional": "穩紮穩打"
  },
  {
    "frequency": 2719,
    "simplified": "似曾相识",
    "traditional": "似曾相識"
  },
  {
    "frequency": 2718,
    "simplified": "空空如也",
    "traditional": "空空如也"
  },
  {
    "frequency": 2714,
    "simplified": "危在旦夕",
    "traditional": "危在旦夕"
  },
  {
    "frequency": 2708,
    "simplified": "开诚布公",
    "traditional": "開誠佈公"
  },
  {
    "frequency": 2699,
    "simplified": "可歌可泣",
    "traditional": "可歌可泣"
  },
  {
    "frequency": 2690,
    "simplified": "口诛笔伐",
    "traditional": "口誅筆伐"
  },
  {
    "frequency": 2688,
    "simplified": "釜底抽薪",
    "traditional": "釜底抽薪"
  },
  {
    "frequency": 2687,
    "simplified": "口口声声",
    "traditional": "口口聲聲"
  },
  {
    "frequency": 2683,
    "simplified": "举世闻名",
    "traditional": "舉世聞名"
  },
  {
    "frequency": 2682,
    "simplified": "光明正大",
    "traditional": "光明正大"
  },
  {
    "frequency": 2679,
    "simplified": "一门心思",
    "traditional": "一門心思"
  },
  {
    "frequency": 2675,
    "simplified": "不一而足",
    "traditional": "不一而足"
  },
  {
    "frequency": 2675,
    "simplified": "文山会海",
    "traditional": "文山會海"
  },
  {
    "frequency": 2674,
    "simplified": "德艺双馨",
    "traditional": "德藝雙馨"
  },
  {
    "frequency": 2672,
    "simplified": "顾全大局",
    "traditional": "顧全大局"
  },
  {
    "frequency": 2669,
    "simplified": "能上能下",
    "traditional": "能上能下"
  },
  {
    "frequency": 2666,
    "simplified": "胆战心惊",
    "traditional": "膽戰心驚"
  },
  {
    "frequency": 2663,
    "simplified": "坚韧不拔",
    "traditional": "堅韌不拔"
  },
  {
    "frequency": 2662,
    "simplified": "起死回生",
    "traditional": "起死回生"
  },
  {
    "frequency": 2661,
    "simplified": "全神贯注",
    "traditional": "全神貫注"
  },
  {
    "frequency": 2659,
    "simplified": "死里逃生",
    "traditional": "死裡逃生"
  },
  {
    "frequency": 2654,
    "simplified": "一马当先",
    "traditional": "一馬當先"
  },
  {
    "frequency": 2654,
    "simplified": "平安无事",
    "traditional": "平安無事"
  },
  {
    "frequency": 2653,
    "simplified": "厚积薄发",
    "traditional": "厚積薄發"
  },
  {
    "frequency": 2652,
    "simplified": "无理取闹",
    "traditional": "無理取鬧"
  },
  {
    "frequency": 2647,
    "simplified": "当机立断",
    "traditional": "當機立斷"
  },
  {
    "frequency": 2644,
    "simplified": "八方支援",
    "traditional": "八方支援"
  },
  {
    "frequency": 2644,
    "simplified": "深情厚谊",
    "traditional": "深情厚誼"
  },
  {
    "frequency": 2642,
    "simplified": "名存实亡",
    "traditional": "名存實亡"
  },
  {
    "frequency": 2642,
    "simplified": "如释重负",
    "traditional": "如釋重負"
  },
  {
    "frequency": 2641,
    "simplified": "雷打不动",
    "traditional": "雷打不動"
  },
  {
    "frequency": 2639,
    "simplified": "一望无际",
    "traditional": "一望無際"
  },
  {
    "frequency": 2631,
    "simplified": "与世隔绝",
    "traditional": "與世隔絕"
  },
  {
    "frequency": 2629,
    "simplified": "门可罗雀",
    "traditional": "門可羅雀"
  },
  {
    "frequency": 2629,
    "simplified": "大摇大摆",
    "traditional": "大搖大擺"
  },
  {
    "frequency": 2627,
    "simplified": "将信将疑",
    "traditional": "將信將疑"
  },
  {
    "frequency": 2625,
    "simplified": "饶有兴趣",
    "traditional": "饒有興趣"
  },
  {
    "frequency": 2624,
    "simplified": "勤勤恳恳",
    "traditional": "勤勤懇懇"
  },
  {
    "frequency": 2623,
    "simplified": "心旷神怡",
    "traditional": "心曠神怡"
  },
  {
    "frequency": 2615,
    "simplified": "柴米油盐",
    "traditional": "柴米油鹽"
  },
  {
    "frequency": 2614,
    "simplified": "心照不宣",
    "traditional": "心照不宣"
  },
  {
    "frequency": 2611,
    "simplified": "半途而废",
    "traditional": "半途而廢"
  },
  {
    "frequency": 2602,
    "simplified": "半信半疑",
    "traditional": "半信半疑"
  },
  {
    "frequency": 2601,
    "simplified": "无计可施",
    "traditional": "無計可施"
  },
  {
    "frequency": 2597,
    "simplified": "轻装上阵",
    "traditional": "輕裝上陣"
  },
  {
    "frequency": 2596,
    "simplified": "一塌糊涂",
    "traditional": "一塌糊塗"
  },
  {
    "frequency": 2595,
    "simplified": "震撼人心",
    "traditional": "震撼人心"
  },
  {
    "frequency": 2593,
    "simplified": "后来居上",
    "traditional": "後來居上"
  },
  {
    "frequency": 2590,
    "simplified": "并驾齐驱",
    "traditional": "並駕齊驅"
  },
  {
    "frequency": 2587,
    "simplified": "不时之需",
    "traditional": "不時之需"
  },
  {
    "frequency": 2585,
    "simplified": "自告奋勇",
    "traditional": "自告奮勇"
  },
  {
    "frequency": 2584,
    "simplified": "东山再起",
    "traditional": "東山再起"
  },
  {
    "frequency": 2584,
    "simplified": "锒铛入狱",
    "traditional": "鋃鐺入獄"
  },
  {
    "frequency": 2584,
    "simplified": "轻车简从",
    "traditional": "輕車簡從"
  },
  {
    "frequency": 2580,
    "simplified": "通力合作",
    "traditional": "通力合作"
  },
  {
    "frequency": 2575,
    "simplified": "石沉大海",
    "traditional": "石沉大海"
  },
  {
    "frequency": 2573,
    "simplified": "隐姓埋名",
    "traditional": "隱姓埋名"
  },
  {
    "frequency": 2571,
    "simplified": "愤愤不平",
    "traditional": "憤憤不平"
  },
  {
    "frequency": 2565,
    "simplified": "一鼓作气",
    "traditional": "一鼓作氣"
  },
  {
    "frequency": 2565,
    "simplified": "心安理得",
    "traditional": "心安理得"
  },
  {
    "frequency": 2565,
    "simplified": "千头万绪",
    "traditional": "千頭萬緒"
  },
  {
    "frequency": 2559,
    "simplified": "冰天雪地",
    "traditional": "冰天雪地"
  },
  {
    "frequency": 2556,
    "simplified": "奋发向上",
    "traditional": "奮發向上"
  },
  {
    "frequency": 2546,
    "simplified": "后起之秀",
    "traditional": "後起之秀"
  },
  {
    "frequency": 2546,
    "simplified": "谨言慎行",
    "traditional": "謹言慎行"
  },
  {
    "frequency": 2541,
    "simplified": "时过境迁",
    "traditional": "時過境遷"
  },
  {
    "frequency": 2539,
    "simplified": "必争之地",
    "traditional": "必爭之地"
  },
  {
    "frequency": 2538,
    "simplified": "唯利是图",
    "traditional": "唯利是圖"
  },
  {
    "frequency": 2538,
    "simplified": "居高临下",
    "traditional": "居高臨下"
  },
  {
    "frequency": 2537,
    "simplified": "事无巨细",
    "traditional": "事無鉅細"
  },
  {
    "frequency": 2536,
    "simplified": "无孔不入",
    "traditional": "無孔不入"
  },
  {
    "frequency": 2535,
    "simplified": "势不可挡",
    "traditional": "勢不可擋"
  },
  {
    "frequency": 2530,
    "simplified": "烟消云散",
    "traditional": "煙消雲散"
  },
  {
    "frequency": 2522,
    "simplified": "席地而坐",
    "traditional": "席地而坐"
  },
  {
    "frequency": 2519,
    "simplified": "豁然开朗",
    "traditional": "豁然開朗"
  },
  {
    "frequency": 2517,
    "simplified": "义愤填膺",
    "traditional": "義憤填膺"
  },
  {
    "frequency": 2514,
    "simplified": "不进则退",
    "traditional": "不進則退"
  },
  {
    "frequency": 2511,
    "simplified": "身先士卒",
    "traditional": "身先士卒"
  },
  {
    "frequency": 2511,
    "simplified": "一概而论",
    "traditional": "一概而論"
  },
  {
    "frequency": 2510,
    "simplified": "敷衍了事",
    "traditional": "敷衍了事"
  },
  {
    "frequency": 2508,
    "simplified": "高枕无忧",
    "traditional": "高枕無憂"
  },
  {
    "frequency": 2507,
    "simplified": "巧立名目",
    "traditional": "巧立名目"
  },
  {
    "frequency": 2503,
    "simplified": "万不得已",
    "traditional": "萬不得已"
  },
  {
    "frequency": 2502,
    "simplified": "震耳欲聋",
    "traditional": "震耳欲聾"
  },
  {
    "frequency": 2499,
    "simplified": "今非昔比",
    "traditional": "今非昔比"
  },
  {
    "frequency": 2494,
    "simplified": "拉帮结派",
    "traditional": "拉幫結派"
  },
  {
    "frequency": 2492,
    "simplified": "摸不着头脑",
    "traditional": "摸不著頭腦"
  },
  {
    "frequency": 2490,
    "simplified": "无忧无虑",
    "traditional": "無憂無慮"
  },
  {
    "frequency": 2486,
    "simplified": "手舞足蹈",
    "traditional": "手舞足蹈"
  },
  {
    "frequency": 2483,
    "simplified": "千呼万唤",
    "traditional": "千呼萬喚"
  },
  {
    "frequency": 2480,
    "simplified": "各取所需",
    "traditional": "各取所需"
  },
  {
    "frequency": 2479,
    "simplified": "遥遥领先",
    "traditional": "遙遙領先"
  },
  {
    "frequency": 2479,
    "simplified": "杳无音信",
    "traditional": "杳無音信"
  },
  {
    "frequency": 2475,
    "simplified": "相濡以沫",
    "traditional": "相濡以沫"
  },
  {
    "frequency": 2470,
    "simplified": "先入为主",
    "traditional": "先入為主"
  },
  {
    "frequency": 2469,
    "simplified": "横七竖八",
    "traditional": "橫七豎八"
  },
  {
    "frequency": 2458,
    "simplified": "痛心疾首",
    "traditional": "痛心疾首"
  },
  {
    "frequency": 2452,
    "simplified": "千军万马",
    "traditional": "千軍萬馬"
  },
  {
    "frequency": 2452,
    "simplified": "可有可无",
    "traditional": "可有可無"
  },
  {
    "frequency": 2450,
    "simplified": "化整为零",
    "traditional": "化整為零"
  },
  {
    "frequency": 2449,
    "simplified": "阳奉阴违",
    "traditional": "陽奉陰違"
  },
  {
    "frequency": 2445,
    "simplified": "沉默寡言",
    "traditional": "沉默寡言"
  },
  {
    "frequency": 2444,
    "simplified": "你追我赶",
    "traditional": "你追我趕"
  },
  {
    "frequency": 2442,
    "simplified": "顺手牵羊",
    "traditional": "順手牽羊"
  },
  {
    "frequency": 2441,
    "simplified": "渐入佳境",
    "traditional": "漸入佳境"
  },
  {
    "frequency": 2433,
    "simplified": "听之任之",
    "traditional": "聽之任之"
  },
  {
    "frequency": 2429,
    "simplified": "束手就擒",
    "traditional": "束手就擒"
  },
  {
    "frequency": 2429,
    "simplified": "心无旁骛",
    "traditional": "心無旁騖"
  },
  {
    "frequency": 2427,
    "simplified": "以防万一",
    "traditional": "以防萬一"
  },
  {
    "frequency": 2427,
    "simplified": "振聋发聩",
    "traditional": "振聾發聵"
  },
  {
    "frequency": 2427,
    "simplified": "杳无音讯",
    "traditional": "杳無音訊"
  },
  {
    "frequency": 2426,
    "simplified": "情有可原",
    "traditional": "情有可原"
  },
  {
    "frequency": 2424,
    "simplified": "尽力而为",
    "traditional": "盡力而為"
  },
  {
    "frequency": 2423,
    "simplified": "投机取巧",
    "traditional": "投機取巧"
  },
  {
    "frequency": 2423,
    "simplified": "小题大做",
    "traditional": "小題大做"
  },
  {
    "frequency": 2422,
    "simplified": "约法三章",
    "traditional": "約法三章"
  },
  {
    "frequency": 2422,
    "simplified": "不屑一顾",
    "traditional": "不屑一顧"
  },
  {
    "frequency": 2416,
    "simplified": "自圆其说",
    "traditional": "自圓其說"
  },
  {
    "frequency": 2412,
    "simplified": "人尽其才",
    "traditional": "人盡其才"
  },
  {
    "frequency": 2405,
    "simplified": "迎来送往",
    "traditional": "迎來送往"
  },
  {
    "frequency": 2402,
    "simplified": "财大气粗",
    "traditional": "財大氣粗"
  },
  {
    "frequency": 2402,
    "simplified": "从容应对",
    "traditional": "從容應對"
  },
  {
    "frequency": 2401,
    "simplified": "随波逐流",
    "traditional": "隨波逐流"
  },
  {
    "frequency": 2398,
    "simplified": "望子成龙",
    "traditional": "望子成龍"
  },
  {
    "frequency": 2395,
    "simplified": "鸡毛蒜皮",
    "traditional": "雞毛蒜皮"
  },
  {
    "frequency": 2394,
    "simplified": "肃然起敬",
    "traditional": "肅然起敬"
  },
  {
    "frequency": 2390,
    "simplified": "公平交易",
    "traditional": "公平交易"
  },
  {
    "frequency": 2387,
    "simplified": "束之高阁",
    "traditional": "束之高閣"
  },
  {
    "frequency": 2387,
    "simplified": "因噎废食",
    "traditional": "因噎廢食"
  },
  {
    "frequency": 2386,
    "simplified": "火光冲天",
    "traditional": "火光沖天"
  },
  {
    "frequency": 2386,
    "simplified": "另起炉灶",
    "traditional": "另起爐灶"
  },
  {
    "frequency": 2386,
    "simplified": "打破常规",
    "traditional": "打破常規"
  },
  {
    "frequency": 2383,
    "simplified": "饮食起居",
    "traditional": "飲食起居"
  },
  {
    "frequency": 2379,
    "simplified": "青黄不接",
    "traditional": "青黃不接"
  },
  {
    "frequency": 2379,
    "simplified": "面面俱到",
    "traditional": "面面俱到"
  },
  {
    "frequency": 2378,
    "simplified": "天涯海角",
    "traditional": "天涯海角"
  },
  {
    "frequency": 2378,
    "simplified": "语无伦次",
    "traditional": "語無倫次"
  },
  {
    "frequency": 2375,
    "simplified": "箭在弦上",
    "traditional": "箭在弦上"
  },
  {
    "frequency": 2373,
    "simplified": "朗朗上口",
    "traditional": "朗朗上口"
  },
  {
    "frequency": 2369,
    "simplified": "舍近求远",
    "traditional": "捨近求遠"
  },
  {
    "frequency": 2367,
    "simplified": "置身事外",
    "traditional": "置身事外"
  },
  {
    "frequency": 2365,
    "simplified": "鞠躬尽瘁",
    "traditional": "鞠躬盡瘁"
  },
  {
    "frequency": 2363,
    "simplified": "活蹦乱跳",
    "traditional": "活蹦亂跳"
  },
  {
    "frequency": 2362,
    "simplified": "不寒而栗",
    "traditional": "不寒而慄"
  },
  {
    "frequency": 2359,
    "simplified": "明辨是非",
    "traditional": "明辨是非"
  },
  {
    "frequency": 2354,
    "simplified": "言简意赅",
    "traditional": "言簡意賅"
  },
  {
    "frequency": 2350,
    "simplified": "鸟语花香",
    "traditional": "鳥語花香"
  },
  {
    "frequency": 2349,
    "simplified": "百思不得其解",
    "traditional": "百思不得其解"
  },
  {
    "frequency": 2347,
    "simplified": "避而不谈",
    "traditional": "避而不談"
  },
  {
    "frequency": 2343,
    "simplified": "头头是道",
    "traditional": "頭頭是道"
  },
  {
    "frequency": 2338,
    "simplified": "安营扎寨",
    "traditional": "安營紮寨"
  },
  {
    "frequency": 2338,
    "simplified": "风尘仆仆",
    "traditional": "風塵僕僕"
  },
  {
    "frequency": 2337,
    "simplified": "前无古人",
    "traditional": "前無古人"
  },
  {
    "frequency": 2336,
    "simplified": "无可非议",
    "traditional": "無可非議"
  },
  {
    "frequency": 2334,
    "simplified": "无所不能",
    "traditional": "無所不能"
  },
  {
    "frequency": 2334,
    "simplified": "筋疲力尽",
    "traditional": "筋疲力盡"
  },
  {
    "frequency": 2333,
    "simplified": "一来二去",
    "traditional": "一來二去"
  },
  {
    "frequency": 2332,
    "simplified": "张灯结彩",
    "traditional": "張燈結綵"
  },
  {
    "frequency": 2332,
    "simplified": "一哄而上",
    "traditional": "一鬨而上"
  },
  {
    "frequency": 2331,
    "simplified": "不由分说",
    "traditional": "不由分說"
  },
  {
    "frequency": 2329,
    "simplified": "难以预料",
    "traditional": "難以預料"
  },
  {
    "frequency": 2329,
    "simplified": "酣畅淋漓",
    "traditional": "酣暢淋漓"
  },
  {
    "frequency": 2325,
    "simplified": "带头作用",
    "traditional": "帶頭作用"
  },
  {
    "frequency": 2324,
    "simplified": "南辕北辙",
    "traditional": "南轅北轍"
  },
  {
    "frequency": 2324,
    "simplified": "自由自在",
    "traditional": "自由自在"
  },
  {
    "frequency": 2319,
    "simplified": "风风火火",
    "traditional": "風風火火"
  },
  {
    "frequency": 2314,
    "simplified": "冒名顶替",
    "traditional": "冒名頂替"
  },
  {
    "frequency": 2313,
    "simplified": "保家卫国",
    "traditional": "保家衛國"
  },
  {
    "frequency": 2312,
    "simplified": "年富力强",
    "traditional": "年富力強"
  },
  {
    "frequency": 2308,
    "simplified": "不义之财",
    "traditional": "不義之財"
  },
  {
    "frequency": 2306,
    "simplified": "事出有因",
    "traditional": "事出有因"
  },
  {
    "frequency": 2305,
    "simplified": "见死不救",
    "traditional": "見死不救"
  },
  {
    "frequency": 2304,
    "simplified": "人烟稀少",
    "traditional": "人煙稀少"
  },
  {
    "frequency": 2304,
    "simplified": "模棱两可",
    "traditional": "模稜兩可"
  },
  {
    "frequency": 2303,
    "simplified": "人迹罕至",
    "traditional": "人跡罕至"
  },
  {
    "frequency": 2302,
    "simplified": "中饱私囊",
    "traditional": "中飽私囊"
  },
  {
    "frequency": 2302,
    "simplified": "三天两头",
    "traditional": "三天兩頭"
  },
  {
    "frequency": 2301,
    "simplified": "一贫如洗",
    "traditional": "一貧如洗"
  },
  {
    "frequency": 2299,
    "simplified": "没日没夜",
    "traditional": "沒日沒夜"
  },
  {
    "frequency": 2295,
    "simplified": "见贤思齐",
    "traditional": "見賢思齊"
  },
  {
    "frequency": 2293,
    "simplified": "戒备森严",
    "traditional": "戒備森嚴"
  },
  {
    "frequency": 2292,
    "simplified": "千奇百怪",
    "traditional": "千奇百怪"
  },
  {
    "frequency": 2289,
    "simplified": "麻痹大意",
    "traditional": "麻痺大意"
  },
  {
    "frequency": 2288,
    "simplified": "满载而归",
    "traditional": "滿載而歸"
  },
  {
    "frequency": 2287,
    "simplified": "至高无上",
    "traditional": "至高無上"
  },
  {
    "frequency": 2286,
    "simplified": "一草一木",
    "traditional": "一草一木"
  },
  {
    "frequency": 2285,
    "simplified": "扬长避短",
    "traditional": "揚長避短"
  },
  {
    "frequency": 2282,
    "simplified": "同甘共苦",
    "traditional": "同甘共苦"
  },
  {
    "frequency": 2279,
    "simplified": "铜墙铁壁",
    "traditional": "銅牆鐵壁"
  },
  {
    "frequency": 2270,
    "simplified": "孜孜以求",
    "traditional": "孜孜以求"
  },
  {
    "frequency": 2267,
    "simplified": "抱头痛哭",
    "traditional": "抱頭痛哭"
  },
  {
    "frequency": 2264,
    "simplified": "移风易俗",
    "traditional": "移風易俗"
  },
  {
    "frequency": 2263,
    "simplified": "独具匠心",
    "traditional": "獨具匠心"
  },
  {
    "frequency": 2261,
    "simplified": "追悔莫及",
    "traditional": "追悔莫及"
  },
  {
    "frequency": 2258,
    "simplified": "久负盛名",
    "traditional": "久負盛名"
  },
  {
    "frequency": 2255,
    "simplified": "过意不去",
    "traditional": "過意不去"
  },
  {
    "frequency": 2255,
    "simplified": "冷嘲热讽",
    "traditional": "冷嘲熱諷"
  },
  {
    "frequency": 2253,
    "simplified": "泛滥成灾",
    "traditional": "氾濫成災"
  },
  {
    "frequency": 2245,
    "simplified": "横冲直撞",
    "traditional": "橫衝直撞"
  },
  {
    "frequency": 2245,
    "simplified": "沾沾自喜",
    "traditional": "沾沾自喜"
  },
  {
    "frequency": 2244,
    "simplified": "有血有肉",
    "traditional": "有血有肉"
  },
  {
    "frequency": 2244,
    "simplified": "争奇斗艳",
    "traditional": "爭奇鬥豔"
  },
  {
    "frequency": 2243,
    "simplified": "精神恍惚",
    "traditional": "精神恍惚"
  },
  {
    "frequency": 2242,
    "simplified": "盘根错节",
    "traditional": "盤根錯節"
  },
  {
    "frequency": 2241,
    "simplified": "大兴土木",
    "traditional": "大興土木"
  },
  {
    "frequency": 2238,
    "simplified": "老泪纵横",
    "traditional": "老淚縱橫"
  },
  {
    "frequency": 2236,
    "simplified": "雄心壮志",
    "traditional": "雄心壯志"
  },
  {
    "frequency": 2234,
    "simplified": "瞒天过海",
    "traditional": "瞞天過海"
  },
  {
    "frequency": 2233,
    "simplified": "丧心病狂",
    "traditional": "喪心病狂"
  },
  {
    "frequency": 2232,
    "simplified": "目不转睛",
    "traditional": "目不轉睛"
  },
  {
    "frequency": 2230,
    "simplified": "相安无事",
    "traditional": "相安無事"
  },
  {
    "frequency": 2229,
    "simplified": "和而不同",
    "traditional": "和而不同"
  },
  {
    "frequency": 2225,
    "simplified": "乐善好施",
    "traditional": "樂善好施"
  },
  {
    "frequency": 2223,
    "simplified": "快马加鞭",
    "traditional": "快馬加鞭"
  },
  {
    "frequency": 2221,
    "simplified": "人心向背",
    "traditional": "人心向背"
  },
  {
    "frequency": 2219,
    "simplified": "无关紧要",
    "traditional": "無關緊要"
  },
  {
    "frequency": 2218,
    "simplified": "入土为安",
    "traditional": "入土為安"
  },
  {
    "frequency": 2218,
    "simplified": "峰回路转",
    "traditional": "峰迴路轉"
  },
  {
    "frequency": 2217,
    "simplified": "闻所未闻",
    "traditional": "聞所未聞"
  },
  {
    "frequency": 2216,
    "simplified": "烫手山芋",
    "traditional": "燙手山芋"
  },
  {
    "frequency": 2216,
    "simplified": "花样百出",
    "traditional": "花樣百出"
  },
  {
    "frequency": 2216,
    "simplified": "手无寸铁",
    "traditional": "手無寸鐵"
  },
  {
    "frequency": 2216,
    "simplified": "据理力争",
    "traditional": "據理力爭"
  },
  {
    "frequency": 2215,
    "simplified": "不虚此行",
    "traditional": "不虛此行"
  },
  {
    "frequency": 2213,
    "simplified": "确有其事",
    "traditional": "確有其事"
  },
  {
    "frequency": 2212,
    "simplified": "漏网之鱼",
    "traditional": "漏網之魚"
  },
  {
    "frequency": 2209,
    "simplified": "乘风破浪",
    "traditional": "乘風破浪"
  },
  {
    "frequency": 2209,
    "simplified": "出类拔萃",
    "traditional": "出類拔萃"
  },
  {
    "frequency": 2206,
    "simplified": "有求必应",
    "traditional": "有求必應"
  },
  {
    "frequency": 2206,
    "simplified": "挖空心思",
    "traditional": "挖空心思"
  },
  {
    "frequency": 2203,
    "simplified": "暴露无遗",
    "traditional": "暴露無遺"
  },
  {
    "frequency": 2203,
    "simplified": "价廉物美",
    "traditional": "價廉物美"
  },
  {
    "frequency": 2201,
    "simplified": "千疮百孔",
    "traditional": "千瘡百孔"
  },
  {
    "frequency": 2199,
    "simplified": "矢口否认",
    "traditional": "矢口否認"
  },
  {
    "frequency": 2199,
    "simplified": "嗤之以鼻",
    "traditional": "嗤之以鼻"
  },
  {
    "frequency": 2199,
    "simplified": "春意盎然",
    "traditional": "春意盎然"
  },
  {
    "frequency": 2197,
    "simplified": "原封不动",
    "traditional": "原封不動"
  },
  {
    "frequency": 2196,
    "simplified": "无可比拟",
    "traditional": "無可比擬"
  },
  {
    "frequency": 2195,
    "simplified": "三番五次",
    "traditional": "三番五次"
  },
  {
    "frequency": 2195,
    "simplified": "登高望远",
    "traditional": "登高望遠"
  },
  {
    "frequency": 2193,
    "simplified": "板上钉钉",
    "traditional": "板上釘釘"
  },
  {
    "frequency": 2192,
    "simplified": "杞人忧天",
    "traditional": "杞人憂天"
  },
  {
    "frequency": 2190,
    "simplified": "心满意足",
    "traditional": "心滿意足"
  },
  {
    "frequency": 2189,
    "simplified": "无所不在",
    "traditional": "無所不在"
  },
  {
    "frequency": 2183,
    "simplified": "一言以蔽之",
    "traditional": "一言以蔽之"
  },
  {
    "frequency": 2182,
    "simplified": "举手投足",
    "traditional": "舉手投足"
  },
  {
    "frequency": 2182,
    "simplified": "动荡不安",
    "traditional": "動盪不安"
  },
  {
    "frequency": 2181,
    "simplified": "东张西望",
    "traditional": "東張西望"
  },
  {
    "frequency": 2179,
    "simplified": "三足鼎立",
    "traditional": "三足鼎立"
  },
  {
    "frequency": 2176,
    "simplified": "物归原主",
    "traditional": "物歸原主"
  },
  {
    "frequency": 2174,
    "simplified": "不远万里",
    "traditional": "不遠萬里"
  },
  {
    "frequency": 2171,
    "simplified": "空中楼阁",
    "traditional": "空中樓閣"
  },
  {
    "frequency": 2169,
    "simplified": "家长里短",
    "traditional": "家長裡短"
  },
  {
    "frequency": 2164,
    "simplified": "通宵达旦",
    "traditional": "通宵達旦"
  },
  {
    "frequency": 2163,
    "simplified": "一掷千金",
    "traditional": "一擲千金"
  },
  {
    "frequency": 2161,
    "simplified": "言之凿凿",
    "traditional": "言之鑿鑿"
  },
  {
    "frequency": 2156,
    "simplified": "挥汗如雨",
    "traditional": "揮汗如雨"
  },
  {
    "frequency": 2155,
    "simplified": "天衣无缝",
    "traditional": "天衣無縫"
  },
  {
    "frequency": 2155,
    "simplified": "不知何故",
    "traditional": "不知何故"
  },
  {
    "frequency": 2151,
    "simplified": "如鱼得水",
    "traditional": "如魚得水"
  },
  {
    "frequency": 2148,
    "simplified": "僧多粥少",
    "traditional": "僧多粥少"
  },
  {
    "frequency": 2147,
    "simplified": "互相推诿",
    "traditional": "互相推諉"
  },
  {
    "frequency": 2146,
    "simplified": "本来面目",
    "traditional": "本來面目"
  },
  {
    "frequency": 2144,
    "simplified": "来者不拒",
    "traditional": "來者不拒"
  },
  {
    "frequency": 2142,
    "simplified": "欣喜若狂",
    "traditional": "欣喜若狂"
  },
  {
    "frequency": 2140,
    "simplified": "呕心沥血",
    "traditional": "嘔心瀝血"
  },
  {
    "frequency": 2139,
    "simplified": "精耕细作",
    "traditional": "精耕細作"
  },
  {
    "frequency": 2138,
    "simplified": "汗马功劳",
    "traditional": "汗馬功勞"
  },
  {
    "frequency": 2138,
    "simplified": "稍纵即逝",
    "traditional": "稍縱即逝"
  },
  {
    "frequency": 2134,
    "simplified": "不得已而为之",
    "traditional": "不得已而為之"
  },
  {
    "frequency": 2133,
    "simplified": "远见卓识",
    "traditional": "遠見卓識"
  },
  {
    "frequency": 2130,
    "simplified": "千钧一发",
    "traditional": "千鈞一髮"
  },
  {
    "frequency": 2129,
    "simplified": "不攻自破",
    "traditional": "不攻自破"
  },
  {
    "frequency": 2127,
    "simplified": "奋发图强",
    "traditional": "奮發圖強"
  },
  {
    "frequency": 2124,
    "simplified": "运筹帷幄",
    "traditional": "運籌帷幄"
  },
  {
    "frequency": 2123,
    "simplified": "同归于尽",
    "traditional": "同歸於盡"
  },
  {
    "frequency": 2120,
    "simplified": "声情并茂",
    "traditional": "聲情並茂"
  },
  {
    "frequency": 2119,
    "simplified": "喜笑颜开",
    "traditional": "喜笑顏開"
  },
  {
    "frequency": 2119,
    "simplified": "就地取材",
    "traditional": "就地取材"
  },
  {
    "frequency": 2118,
    "simplified": "谈笑风生",
    "traditional": "談笑風生"
  },
  {
    "frequency": 2116,
    "simplified": "一本正经",
    "traditional": "一本正經"
  },
  {
    "frequency": 2116,
    "simplified": "按兵不动",
    "traditional": "按兵不動"
  },
  {
    "frequency": 2114,
    "simplified": "真刀真枪",
    "traditional": "真刀真槍"
  },
  {
    "frequency": 2113,
    "simplified": "春风化雨",
    "traditional": "春風化雨"
  },
  {
    "frequency": 2111,
    "simplified": "天罗地网",
    "traditional": "天羅地網"
  },
  {
    "frequency": 2110,
    "simplified": "摩肩接踵",
    "traditional": "摩肩接踵"
  },
  {
    "frequency": 2109,
    "simplified": "飞来横祸",
    "traditional": "飛來橫禍"
  },
  {
    "frequency": 2107,
    "simplified": "胸有成竹",
    "traditional": "胸有成竹"
  },
  {
    "frequency": 2107,
    "simplified": "花样翻新",
    "traditional": "花樣翻新"
  },
  {
    "frequency": 2107,
    "simplified": "依山傍水",
    "traditional": "依山傍水"
  },
  {
    "frequency": 2104,
    "simplified": "虎视眈眈",
    "traditional": "虎視眈眈"
  },
  {
    "frequency": 2104,
    "simplified": "万事大吉",
    "traditional": "萬事大吉"
  },
  {
    "frequency": 2103,
    "simplified": "萎靡不振",
    "traditional": "萎靡不振"
  },
  {
    "frequency": 2103,
    "simplified": "独占鳌头",
    "traditional": "獨佔鰲頭"
  },
  {
    "frequency": 2103,
    "simplified": "古往今来",
    "traditional": "古往今來"
  },
  {
    "frequency": 2100,
    "simplified": "舍己救人",
    "traditional": "捨己救人"
  },
  {
    "frequency": 2095,
    "simplified": "欲罢不能",
    "traditional": "欲罷不能"
  },
  {
    "frequency": 2093,
    "simplified": "敲锣打鼓",
    "traditional": "敲鑼打鼓"
  },
  {
    "frequency": 2092,
    "simplified": "穷凶极恶",
    "traditional": "窮兇極惡"
  },
  {
    "frequency": 2092,
    "simplified": "化险为夷",
    "traditional": "化險為夷"
  },
  {
    "frequency": 2090,
    "simplified": "大快朵颐",
    "traditional": "大快朵頤"
  },
  {
    "frequency": 2089,
    "simplified": "休戚与共",
    "traditional": "休慼與共"
  },
  {
    "frequency": 2084,
    "simplified": "相映成趣",
    "traditional": "相映成趣"
  },
  {
    "frequency": 2080,
    "simplified": "按图索骥",
    "traditional": "按圖索驥"
  },
  {
    "frequency": 2079,
    "simplified": "不偏不倚",
    "traditional": "不偏不倚"
  },
  {
    "frequency": 2077,
    "simplified": "穿针引线",
    "traditional": "穿針引線"
  },
  {
    "frequency": 2073,
    "simplified": "过关斩将",
    "traditional": "過關斬將"
  },
  {
    "frequency": 2072,
    "simplified": "闭门造车",
    "traditional": "閉門造車"
  },
  {
    "frequency": 2071,
    "simplified": "迎头赶上",
    "traditional": "迎頭趕上"
  },
  {
    "frequency": 2071,
    "simplified": "入乡随俗",
    "traditional": "入鄉隨俗"
  },
  {
    "frequency": 2070,
    "simplified": "不堪一击",
    "traditional": "不堪一擊"
  },
  {
    "frequency": 2069,
    "simplified": "满心欢喜",
    "traditional": "滿心歡喜"
  },
  {
    "frequency": 2067,
    "simplified": "啧啧称奇",
    "traditional": "嘖嘖稱奇"
  },
  {
    "frequency": 2067,
    "simplified": "有识之士",
    "traditional": "有識之士"
  },
  {
    "frequency": 2066,
    "simplified": "出尔反尔",
    "traditional": "出爾反爾"
  },
  {
    "frequency": 2065,
    "simplified": "如痴如醉",
    "traditional": "如痴如醉"
  },
  {
    "frequency": 2061,
    "simplified": "天翻地覆",
    "traditional": "天翻地覆"
  },
  {
    "frequency": 2061,
    "simplified": "毁于一旦",
    "traditional": "毀於一旦"
  },
  {
    "frequency": 2059,
    "simplified": "只言片语",
    "traditional": "隻言片語"
  },
  {
    "frequency": 2058,
    "simplified": "仁人志士",
    "traditional": "仁人志士"
  },
  {
    "frequency": 2058,
    "simplified": "不期而遇",
    "traditional": "不期而遇"
  },
  {
    "frequency": 2057,
    "simplified": "疲于奔命",
    "traditional": "疲於奔命"
  },
  {
    "frequency": 2055,
    "simplified": "放眼世界",
    "traditional": "放眼世界"
  },
  {
    "frequency": 2054,
    "simplified": "妙趣横生",
    "traditional": "妙趣橫生"
  },
  {
    "frequency": 2053,
    "simplified": "气势汹汹",
    "traditional": "氣勢洶洶"
  },
  {
    "frequency": 2053,
    "simplified": "大海捞针",
    "traditional": "大海撈針"
  },
  {
    "frequency": 2051,
    "simplified": "似是而非",
    "traditional": "似是而非"
  },
  {
    "frequency": 2051,
    "simplified": "差强人意",
    "traditional": "差強人意"
  },
  {
    "frequency": 2050,
    "simplified": "含辛茹苦",
    "traditional": "含辛茹苦"
  },
  {
    "frequency": 2050,
    "simplified": "风华正茂",
    "traditional": "風華正茂"
  },
  {
    "frequency": 2049,
    "simplified": "贪赃枉法",
    "traditional": "貪贓枉法"
  },
  {
    "frequency": 2049,
    "simplified": "招兵买马",
    "traditional": "招兵買馬"
  },
  {
    "frequency": 2046,
    "simplified": "披荆斩棘",
    "traditional": "披荊斬棘"
  },
  {
    "frequency": 2040,
    "simplified": "风雨飘摇",
    "traditional": "風雨飄搖"
  },
  {
    "frequency": 2040,
    "simplified": "殚精竭虑",
    "traditional": "殫精竭慮"
  },
  {
    "frequency": 2037,
    "simplified": "尽善尽美",
    "traditional": "盡善盡美"
  },
  {
    "frequency": 2035,
    "simplified": "跃然纸上",
    "traditional": "躍然紙上"
  },
  {
    "frequency": 2035,
    "simplified": "豪言壮语",
    "traditional": "豪言壯語"
  },
  {
    "frequency": 2035,
    "simplified": "以偏概全",
    "traditional": "以偏概全"
  },
  {
    "frequency": 2034,
    "simplified": "前功尽弃",
    "traditional": "前功盡棄"
  },
  {
    "frequency": 2031,
    "simplified": "重操旧业",
    "traditional": "重操舊業"
  },
  {
    "frequency": 2031,
    "simplified": "诗情画意",
    "traditional": "詩情畫意"
  },
  {
    "frequency": 2030,
    "simplified": "各自为战",
    "traditional": "各自為戰"
  },
  {
    "frequency": 2029,
    "simplified": "鬼鬼祟祟",
    "traditional": "鬼鬼祟祟"
  },
  {
    "frequency": 2028,
    "simplified": "扪心自问",
    "traditional": "捫心自問"
  },
  {
    "frequency": 2027,
    "simplified": "用心良苦",
    "traditional": "用心良苦"
  },
  {
    "frequency": 2026,
    "simplified": "恰如其分",
    "traditional": "恰如其分"
  },
  {
    "frequency": 2025,
    "simplified": "经久不息",
    "traditional": "經久不息"
  },
  {
    "frequency": 2023,
    "simplified": "千姿百态",
    "traditional": "千姿百態"
  },
  {
    "frequency": 2023,
    "simplified": "步履蹒跚",
    "traditional": "步履蹣跚"
  },
  {
    "frequency": 2022,
    "simplified": "休养生息",
    "traditional": "休養生息"
  },
  {
    "frequency": 2022,
    "simplified": "风靡一时",
    "traditional": "風靡一時"
  },
  {
    "frequency": 2019,
    "simplified": "不明不白",
    "traditional": "不明不白"
  },
  {
    "frequency": 2019,
    "simplified": "重男轻女",
    "traditional": "重男輕女"
  },
  {
    "frequency": 2019,
    "simplified": "唇枪舌剑",
    "traditional": "唇槍舌劍"
  },
  {
    "frequency": 2019,
    "simplified": "家破人亡",
    "traditional": "家破人亡"
  },
  {
    "frequency": 2018,
    "simplified": "东倒西歪",
    "traditional": "東倒西歪"
  },
  {
    "frequency": 2018,
    "simplified": "行色匆匆",
    "traditional": "行色匆匆"
  },
  {
    "frequency": 2018,
    "simplified": "十全十美",
    "traditional": "十全十美"
  },
  {
    "frequency": 2018,
    "simplified": "包罗万象",
    "traditional": "包羅萬象"
  },
  {
    "frequency": 2015,
    "simplified": "不劳而获",
    "traditional": "不勞而獲"
  },
  {
    "frequency": 2003,
    "simplified": "百感交集",
    "traditional": "百感交集"
  },
  {
    "frequency": 2002,
    "simplified": "互通有无",
    "traditional": "互通有無"
  },
  {
    "frequency": 1997,
    "simplified": "国泰民安",
    "traditional": "國泰民安"
  },
  {
    "frequency": 1997,
    "simplified": "西装革履",
    "traditional": "西裝革履"
  },
  {
    "frequency": 1996,
    "simplified": "百年不遇",
    "traditional": "百年不遇"
  },
  {
    "frequency": 1996,
    "simplified": "扶危济困",
    "traditional": "扶危濟困"
  },
  {
    "frequency": 1995,
    "simplified": "和衷共济",
    "traditional": "和衷共濟"
  },
  {
    "frequency": 1995,
    "simplified": "纹丝不动",
    "traditional": "紋絲不動"
  },
  {
    "frequency": 1991,
    "simplified": "人才辈出",
    "traditional": "人才輩出"
  },
  {
    "frequency": 1991,
    "simplified": "艰难困苦",
    "traditional": "艱難困苦"
  },
  {
    "frequency": 1991,
    "simplified": "步履维艰",
    "traditional": "步履維艱"
  },
  {
    "frequency": 1990,
    "simplified": "付之一炬",
    "traditional": "付之一炬"
  },
  {
    "frequency": 1989,
    "simplified": "众望所归",
    "traditional": "眾望所歸"
  },
  {
    "frequency": 1987,
    "simplified": "一干二净",
    "traditional": "一乾二淨"
  },
  {
    "frequency": 1985,
    "simplified": "一走了之",
    "traditional": "一走了之"
  },
  {
    "frequency": 1984,
    "simplified": "红白喜事",
    "traditional": "紅白喜事"
  },
  {
    "frequency": 1983,
    "simplified": "同仇敌忾",
    "traditional": "同仇敵愾"
  },
  {
    "frequency": 1981,
    "simplified": "粗制滥造",
    "traditional": "粗製濫造"
  },
  {
    "frequency": 1980,
    "simplified": "崇山峻岭",
    "traditional": "崇山峻嶺"
  },
  {
    "frequency": 1978,
    "simplified": "回味无穷",
    "traditional": "回味無窮"
  },
  {
    "frequency": 1970,
    "simplified": "有过之而无不及",
    "traditional": "有過之而無不及"
  },
  {
    "frequency": 1969,
    "simplified": "不近人情",
    "traditional": "不近人情"
  },
  {
    "frequency": 1966,
    "simplified": "生死未卜",
    "traditional": "生死未卜"
  },
  {
    "frequency": 1966,
    "simplified": "敬而远之",
    "traditional": "敬而遠之"
  },
  {
    "frequency": 1966,
    "simplified": "不紧不慢",
    "traditional": "不緊不慢"
  },
  {
    "frequency": 1966,
    "simplified": "励精图治",
    "traditional": "勵精圖治"
  },
  {
    "frequency": 1966,
    "simplified": "知法犯法",
    "traditional": "知法犯法"
  },
  {
    "frequency": 1965,
    "simplified": "颠倒黑白",
    "traditional": "顛倒黑白"
  },
  {
    "frequency": 1963,
    "simplified": "门庭若市",
    "traditional": "門庭若市"
  },
  {
    "frequency": 1959,
    "simplified": "两败俱伤",
    "traditional": "兩敗俱傷"
  },
  {
    "frequency": 1955,
    "simplified": "开阔眼界",
    "traditional": "開闊眼界"
  },
  {
    "frequency": 1954,
    "simplified": "劳逸结合",
    "traditional": "勞逸結合"
  },
  {
    "frequency": 1952,
    "simplified": "心血来潮",
    "traditional": "心血來潮"
  },
  {
    "frequency": 1948,
    "simplified": "洁身自好",
    "traditional": "潔身自好"
  },
  {
    "frequency": 1943,
    "simplified": "盛况空前",
    "traditional": "盛況空前"
  },
  {
    "frequency": 1942,
    "simplified": "美其名曰",
    "traditional": "美其名曰"
  },
  {
    "frequency": 1941,
    "simplified": "动之以情",
    "traditional": "動之以情"
  },
  {
    "frequency": 1939,
    "simplified": "十有八九",
    "traditional": "十有八九"
  },
  {
    "frequency": 1937,
    "simplified": "偷梁换柱",
    "traditional": "偷梁換柱"
  },
  {
    "frequency": 1935,
    "simplified": "传为佳话",
    "traditional": "傳為佳話"
  },
  {
    "frequency": 1934,
    "simplified": "灰头土脸",
    "traditional": "灰頭土臉"
  },
  {
    "frequency": 1932,
    "simplified": "精神矍铄",
    "traditional": "精神矍鑠"
  },
  {
    "frequency": 1932,
    "simplified": "信手拈来",
    "traditional": "信手拈來"
  },
  {
    "frequency": 1932,
    "simplified": "偃旗息鼓",
    "traditional": "偃旗息鼓"
  },
  {
    "frequency": 1931,
    "simplified": "大获全胜",
    "traditional": "大獲全勝"
  },
  {
    "frequency": 1931,
    "simplified": "患难与共",
    "traditional": "患難與共"
  },
  {
    "frequency": 1931,
    "simplified": "守株待兔",
    "traditional": "守株待兔"
  },
  {
    "frequency": 1930,
    "simplified": "全军覆没",
    "traditional": "全軍覆沒"
  },
  {
    "frequency": 1929,
    "simplified": "忙忙碌碌",
    "traditional": "忙忙碌碌"
  },
  {
    "frequency": 1929,
    "simplified": "笑容满面",
    "traditional": "笑容滿面"
  },
  {
    "frequency": 1929,
    "simplified": "浮想联翩",
    "traditional": "浮想聯翩"
  },
  {
    "frequency": 1926,
    "simplified": "慷慨激昂",
    "traditional": "慷慨激昂"
  },
  {
    "frequency": 1924,
    "simplified": "安家落户",
    "traditional": "安家落戶"
  },
  {
    "frequency": 1923,
    "simplified": "真情实感",
    "traditional": "真情實感"
  },
  {
    "frequency": 1923,
    "simplified": "形影不离",
    "traditional": "形影不離"
  },
  {
    "frequency": 1921,
    "simplified": "湖光山色",
    "traditional": "湖光山色"
  },
  {
    "frequency": 1920,
    "simplified": "问心无愧",
    "traditional": "問心無愧"
  },
  {
    "frequency": 1920,
    "simplified": "长年累月",
    "traditional": "長年累月"
  },
  {
    "frequency": 1917,
    "simplified": "乍暖还寒",
    "traditional": "乍暖還寒"
  },
  {
    "frequency": 1917,
    "simplified": "多管闲事",
    "traditional": "多管閒事"
  },
  {
    "frequency": 1916,
    "simplified": "后继有人",
    "traditional": "後繼有人"
  },
  {
    "frequency": 1914,
    "simplified": "踌躇满志",
    "traditional": "躊躇滿志"
  },
  {
    "frequency": 1913,
    "simplified": "背水一战",
    "traditional": "背水一戰"
  },
  {
    "frequency": 1911,
    "simplified": "天南海北",
    "traditional": "天南海北"
  },
  {
    "frequency": 1909,
    "simplified": "花花绿绿",
    "traditional": "花花綠綠"
  },
  {
    "frequency": 1909,
    "simplified": "一语道破",
    "traditional": "一語道破"
  },
  {
    "frequency": 1908,
    "simplified": "拨乱反正",
    "traditional": "撥亂反正"
  },
  {
    "frequency": 1908,
    "simplified": "苦心经营",
    "traditional": "苦心經營"
  },
  {
    "frequency": 1907,
    "simplified": "雾里看花",
    "traditional": "霧裡看花"
  },
  {
    "frequency": 1907,
    "simplified": "科班出身",
    "traditional": "科班出身"
  },
  {
    "frequency": 1906,
    "simplified": "振振有词",
    "traditional": "振振有詞"
  },
  {
    "frequency": 1905,
    "simplified": "声泪俱下",
    "traditional": "聲淚俱下"
  },
  {
    "frequency": 1905,
    "simplified": "看家本领",
    "traditional": "看家本領"
  },
  {
    "frequency": 1904,
    "simplified": "不辞而别",
    "traditional": "不辭而別"
  },
  {
    "frequency": 1904,
    "simplified": "敷衍塞责",
    "traditional": "敷衍塞責"
  },
  {
    "frequency": 1903,
    "simplified": "一蹶不振",
    "traditional": "一蹶不振"
  },
  {
    "frequency": 1901,
    "simplified": "放任自流",
    "traditional": "放任自流"
  },
  {
    "frequency": 1896,
    "simplified": "只字不提",
    "traditional": "隻字不提"
  },
  {
    "frequency": 1894,
    "simplified": "趁热打铁",
    "traditional": "趁熱打鐵"
  },
  {
    "frequency": 1894,
    "simplified": "东躲西藏",
    "traditional": "東躲西藏"
  },
  {
    "frequency": 1890,
    "simplified": "痛不欲生",
    "traditional": "痛不欲生"
  },
  {
    "frequency": 1886,
    "simplified": "风和日丽",
    "traditional": "風和日麗"
  },
  {
    "frequency": 1885,
    "simplified": "万里长城",
    "traditional": "萬里長城"
  },
  {
    "frequency": 1880,
    "simplified": "周而复始",
    "traditional": "周而復始"
  },
  {
    "frequency": 1879,
    "simplified": "拆东墙补西墙",
    "traditional": "拆東牆補西牆"
  },
  {
    "frequency": 1878,
    "simplified": "一往无前",
    "traditional": "一往無前"
  },
  {
    "frequency": 1878,
    "simplified": "名声在外",
    "traditional": "名聲在外"
  },
  {
    "frequency": 1877,
    "simplified": "乘胜追击",
    "traditional": "乘勝追擊"
  },
  {
    "frequency": 1876,
    "simplified": "惊叹不已",
    "traditional": "驚歎不已"
  },
  {
    "frequency": 1871,
    "simplified": "煞有介事",
    "traditional": "煞有介事"
  },
  {
    "frequency": 1867,
    "simplified": "温文尔雅",
    "traditional": "溫文爾雅"
  },
  {
    "frequency": 1867,
    "simplified": "夺眶而出",
    "traditional": "奪眶而出"
  },
  {
    "frequency": 1866,
    "simplified": "内忧外患",
    "traditional": "內憂外患"
  },
  {
    "frequency": 1865,
    "simplified": "一锤定音",
    "traditional": "一錘定音"
  },
  {
    "frequency": 1864,
    "simplified": "操之过急",
    "traditional": "操之過急"
  },
  {
    "frequency": 1864,
    "simplified": "严重错误",
    "traditional": "嚴重錯誤"
  },
  {
    "frequency": 1863,
    "simplified": "填海造地",
    "traditional": "填海造地"
  },
  {
    "frequency": 1863,
    "simplified": "心潮澎湃",
    "traditional": "心潮澎湃"
  },
  {
    "frequency": 1863,
    "simplified": "翻来覆去",
    "traditional": "翻來覆去"
  },
  {
    "frequency": 1862,
    "simplified": "斤斤计较",
    "traditional": "斤斤計較"
  },
  {
    "frequency": 1862,
    "simplified": "吉祥如意",
    "traditional": "吉祥如意"
  },
  {
    "frequency": 1859,
    "simplified": "积劳成疾",
    "traditional": "積勞成疾"
  },
  {
    "frequency": 1857,
    "simplified": "甜言蜜语",
    "traditional": "甜言蜜語"
  },
  {
    "frequency": 1856,
    "simplified": "漠不关心",
    "traditional": "漠不關心"
  },
  {
    "frequency": 1854,
    "simplified": "大声疾呼",
    "traditional": "大聲疾呼"
  },
  {
    "frequency": 1853,
    "simplified": "杂乱无章",
    "traditional": "雜亂無章"
  },
  {
    "frequency": 1851,
    "simplified": "长足进展",
    "traditional": "長足進展"
  },
  {
    "frequency": 1850,
    "simplified": "临危不惧",
    "traditional": "臨危不懼"
  },
  {
    "frequency": 1849,
    "simplified": "奋起直追",
    "traditional": "奮起直追"
  },
  {
    "frequency": 1848,
    "simplified": "顶天立地",
    "traditional": "頂天立地"
  },
  {
    "frequency": 1847,
    "simplified": "一鸣惊人",
    "traditional": "一鳴驚人"
  },
  {
    "frequency": 1845,
    "simplified": "一盘散沙",
    "traditional": "一盤散沙"
  },
  {
    "frequency": 1843,
    "simplified": "道听途说",
    "traditional": "道聽途說"
  },
  {
    "frequency": 1843,
    "simplified": "不管不顾",
    "traditional": "不管不顧"
  },
  {
    "frequency": 1842,
    "simplified": "言行一致",
    "traditional": "言行一致"
  },
  {
    "frequency": 1841,
    "simplified": "两全其美",
    "traditional": "兩全其美"
  },
  {
    "frequency": 1840,
    "simplified": "以讹传讹",
    "traditional": "以訛傳訛"
  },
  {
    "frequency": 1840,
    "simplified": "是非曲直",
    "traditional": "是非曲直"
  },
  {
    "frequency": 1837,
    "simplified": "如意算盘",
    "traditional": "如意算盤"
  },
  {
    "frequency": 1834,
    "simplified": "兴风作浪",
    "traditional": "興風作浪"
  },
  {
    "frequency": 1834,
    "simplified": "一生一世",
    "traditional": "一生一世"
  },
  {
    "frequency": 1833,
    "simplified": "风吹日晒",
    "traditional": "風吹日曬"
  },
  {
    "frequency": 1832,
    "simplified": "一尘不染",
    "traditional": "一塵不染"
  },
  {
    "frequency": 1832,
    "simplified": "胆大妄为",
    "traditional": "膽大妄為"
  },
  {
    "frequency": 1831,
    "simplified": "百家争鸣",
    "traditional": "百家爭鳴"
  },
  {
    "frequency": 1829,
    "simplified": "功亏一篑",
    "traditional": "功虧一簣"
  },
  {
    "frequency": 1827,
    "simplified": "前因后果",
    "traditional": "前因後果"
  },
  {
    "frequency": 1827,
    "simplified": "不置可否",
    "traditional": "不置可否"
  },
  {
    "frequency": 1824,
    "simplified": "富丽堂皇",
    "traditional": "富麗堂皇"
  },
  {
    "frequency": 1823,
    "simplified": "专心致志",
    "traditional": "專心致志"
  },
  {
    "frequency": 1821,
    "simplified": "轻举妄动",
    "traditional": "輕舉妄動"
  },
  {
    "frequency": 1820,
    "simplified": "一丝一毫",
    "traditional": "一絲一毫"
  },
  {
    "frequency": 1818,
    "simplified": "顾此失彼",
    "traditional": "顧此失彼"
  },
  {
    "frequency": 1818,
    "simplified": "于事无补",
    "traditional": "於事無補"
  },
  {
    "frequency": 1818,
    "simplified": "粉墨登场",
    "traditional": "粉墨登場"
  },
  {
    "frequency": 1818,
    "simplified": "千变万化",
    "traditional": "千變萬化"
  },
  {
    "frequency": 1815,
    "simplified": "重见天日",
    "traditional": "重見天日"
  },
  {
    "frequency": 1814,
    "simplified": "无法无天",
    "traditional": "無法無天"
  },
  {
    "frequency": 1813,
    "simplified": "大错特错",
    "traditional": "大錯特錯"
  },
  {
    "frequency": 1813,
    "simplified": "颗粒无收",
    "traditional": "顆粒無收"
  },
  {
    "frequency": 1813,
    "simplified": "不以为意",
    "traditional": "不以為意"
  },
  {
    "frequency": 1812,
    "simplified": "坐立不安",
    "traditional": "坐立不安"
  },
  {
    "frequency": 1811,
    "simplified": "花言巧语",
    "traditional": "花言巧語"
  },
  {
    "frequency": 1809,
    "simplified": "心惊胆战",
    "traditional": "心驚膽戰"
  },
  {
    "frequency": 1807,
    "simplified": "势均力敌",
    "traditional": "勢均力敵"
  },
  {
    "frequency": 1807,
    "simplified": "气急败坏",
    "traditional": "氣急敗壞"
  },
  {
    "frequency": 1807,
    "simplified": "留有余地",
    "traditional": "留有餘地"
  },
  {
    "frequency": 1806,
    "simplified": "标新立异",
    "traditional": "標新立異"
  },
  {
    "frequency": 1805,
    "simplified": "步步为营",
    "traditional": "步步為營"
  },
  {
    "frequency": 1802,
    "simplified": "积重难返",
    "traditional": "積重難返"
  },
  {
    "frequency": 1802,
    "simplified": "喃喃自语",
    "traditional": "喃喃自語"
  },
  {
    "frequency": 1800,
    "simplified": "表面文章",
    "traditional": "表面文章"
  },
  {
    "frequency": 1800,
    "simplified": "神不知鬼不觉",
    "traditional": "神不知鬼不覺"
  },
  {
    "frequency": 1800,
    "simplified": "一字一句",
    "traditional": "一字一句"
  },
  {
    "frequency": 1798,
    "simplified": "游山玩水",
    "traditional": "遊山玩水"
  },
  {
    "frequency": 1798,
    "simplified": "自暴自弃",
    "traditional": "自暴自棄"
  },
  {
    "frequency": 1798,
    "simplified": "靠山吃山",
    "traditional": "靠山吃山"
  },
  {
    "frequency": 1798,
    "simplified": "有心无力",
    "traditional": "有心無力"
  },
  {
    "frequency": 1797,
    "simplified": "不得人心",
    "traditional": "不得人心"
  },
  {
    "frequency": 1794,
    "simplified": "囤积居奇",
    "traditional": "囤積居奇"
  },
  {
    "frequency": 1794,
    "simplified": "一知半解",
    "traditional": "一知半解"
  },
  {
    "frequency": 1790,
    "simplified": "绚丽多彩",
    "traditional": "絢麗多彩"
  },
  {
    "frequency": 1788,
    "simplified": "明知故犯",
    "traditional": "明知故犯"
  },
  {
    "frequency": 1787,
    "simplified": "花团锦簇",
    "traditional": "花團錦簇"
  },
  {
    "frequency": 1786,
    "simplified": "情真意切",
    "traditional": "情真意切"
  },
  {
    "frequency": 1785,
    "simplified": "灵丹妙药",
    "traditional": "靈丹妙藥"
  },
  {
    "frequency": 1783,
    "simplified": "毛骨悚然",
    "traditional": "毛骨悚然"
  },
  {
    "frequency": 1780,
    "simplified": "名不副实",
    "traditional": "名不副實"
  },
  {
    "frequency": 1779,
    "simplified": "浑然一体",
    "traditional": "渾然一體"
  },
  {
    "frequency": 1779,
    "simplified": "左顾右盼",
    "traditional": "左顧右盼"
  },
  {
    "frequency": 1776,
    "simplified": "欢天喜地",
    "traditional": "歡天喜地"
  },
  {
    "frequency": 1776,
    "simplified": "前所未见",
    "traditional": "前所未見"
  },
  {
    "frequency": 1776,
    "simplified": "像模像样",
    "traditional": "像模像樣"
  },
  {
    "frequency": 1775,
    "simplified": "海阔天空",
    "traditional": "海闊天空"
  },
  {
    "frequency": 1775,
    "simplified": "受制于人",
    "traditional": "受制於人"
  },
  {
    "frequency": 1774,
    "simplified": "扼腕叹息",
    "traditional": "扼腕嘆息"
  },
  {
    "frequency": 1772,
    "simplified": "独当一面",
    "traditional": "獨當一面"
  },
  {
    "frequency": 1772,
    "simplified": "心惊肉跳",
    "traditional": "心驚肉跳"
  },
  {
    "frequency": 1771,
    "simplified": "危机四伏",
    "traditional": "危機四伏"
  },
  {
    "frequency": 1771,
    "simplified": "如法炮制",
    "traditional": "如法炮製"
  },
  {
    "frequency": 1770,
    "simplified": "彬彬有礼",
    "traditional": "彬彬有禮"
  },
  {
    "frequency": 1767,
    "simplified": "异想天开",
    "traditional": "異想天開"
  },
  {
    "frequency": 1767,
    "simplified": "源头活水",
    "traditional": "源頭活水"
  },
  {
    "frequency": 1766,
    "simplified": "不远千里",
    "traditional": "不遠千里"
  },
  {
    "frequency": 1764,
    "simplified": "固步自封",
    "traditional": "固步自封"
  },
  {
    "frequency": 1764,
    "simplified": "为人师表",
    "traditional": "為人師表"
  },
  {
    "frequency": 1763,
    "simplified": "弥留之际",
    "traditional": "彌留之際"
  },
  {
    "frequency": 1763,
    "simplified": "如日中天",
    "traditional": "如日中天"
  },
  {
    "frequency": 1763,
    "simplified": "物尽其用",
    "traditional": "物盡其用"
  },
  {
    "frequency": 1762,
    "simplified": "一语中的",
    "traditional": "一語中的"
  },
  {
    "frequency": 1761,
    "simplified": "大快人心",
    "traditional": "大快人心"
  },
  {
    "frequency": 1757,
    "simplified": "屡试不爽",
    "traditional": "屢試不爽"
  },
  {
    "frequency": 1757,
    "simplified": "面红耳赤",
    "traditional": "面紅耳赤"
  },
  {
    "frequency": 1756,
    "simplified": "迥然不同",
    "traditional": "迥然不同"
  },
  {
    "frequency": 1755,
    "simplified": "难言之隐",
    "traditional": "難言之隱"
  },
  {
    "frequency": 1754,
    "simplified": "泾渭分明",
    "traditional": "涇渭分明"
  },
  {
    "frequency": 1753,
    "simplified": "大浪淘沙",
    "traditional": "大浪淘沙"
  },
  {
    "frequency": 1753,
    "simplified": "三六九等",
    "traditional": "三六九等"
  },
  {
    "frequency": 1752,
    "simplified": "华而不实",
    "traditional": "華而不實"
  },
  {
    "frequency": 1751,
    "simplified": "扣人心弦",
    "traditional": "扣人心絃"
  },
  {
    "frequency": 1751,
    "simplified": "大失所望",
    "traditional": "大失所望"
  },
  {
    "frequency": 1745,
    "simplified": "破烂不堪",
    "traditional": "破爛不堪"
  },
  {
    "frequency": 1745,
    "simplified": "不可告人",
    "traditional": "不可告人"
  },
  {
    "frequency": 1743,
    "simplified": "驾轻就熟",
    "traditional": "駕輕就熟"
  },
  {
    "frequency": 1742,
    "simplified": "心领神会",
    "traditional": "心領神會"
  },
  {
    "frequency": 1742,
    "simplified": "你死我活",
    "traditional": "你死我活"
  },
  {
    "frequency": 1738,
    "simplified": "一衣带水",
    "traditional": "一衣帶水"
  },
  {
    "frequency": 1736,
    "simplified": "恋恋不舍",
    "traditional": "戀戀不捨"
  },
  {
    "frequency": 1736,
    "simplified": "遍体鳞伤",
    "traditional": "遍體鱗傷"
  },
  {
    "frequency": 1736,
    "simplified": "忽冷忽热",
    "traditional": "忽冷忽熱"
  },
  {
    "frequency": 1734,
    "simplified": "神采奕奕",
    "traditional": "神采奕奕"
  },
  {
    "frequency": 1733,
    "simplified": "翻箱倒柜",
    "traditional": "翻箱倒櫃"
  },
  {
    "frequency": 1732,
    "simplified": "天时地利人和",
    "traditional": "天時地利人和"
  },
  {
    "frequency": 1730,
    "simplified": "干净利落",
    "traditional": "乾淨利落"
  },
  {
    "frequency": 1728,
    "simplified": "独断专行",
    "traditional": "獨斷專行"
  },
  {
    "frequency": 1728,
    "simplified": "处心积虑",
    "traditional": "處心積慮"
  },
  {
    "frequency": 1727,
    "simplified": "切中要害",
    "traditional": "切中要害"
  },
  {
    "frequency": 1725,
    "simplified": "朴实无华",
    "traditional": "樸實無華"
  },
  {
    "frequency": 1721,
    "simplified": "和蔼可亲",
    "traditional": "和藹可親"
  },
  {
    "frequency": 1721,
    "simplified": "地广人稀",
    "traditional": "地廣人稀"
  },
  {
    "frequency": 1719,
    "simplified": "后悔莫及",
    "traditional": "後悔莫及"
  },
  {
    "frequency": 1718,
    "simplified": "乘虚而入",
    "traditional": "乘虛而入"
  },
  {
    "frequency": 1713,
    "simplified": "四分五裂",
    "traditional": "四分五裂"
  },
  {
    "frequency": 1710,
    "simplified": "英姿飒爽",
    "traditional": "英姿颯爽"
  },
  {
    "frequency": 1710,
    "simplified": "望尘莫及",
    "traditional": "望塵莫及"
  },
  {
    "frequency": 1709,
    "simplified": "阴差阳错",
    "traditional": "陰差陽錯"
  },
  {
    "frequency": 1707,
    "simplified": "谦虚谨慎",
    "traditional": "謙虛謹慎"
  },
  {
    "frequency": 1707,
    "simplified": "出其不意",
    "traditional": "出其不意"
  },
  {
    "frequency": 1702,
    "simplified": "虎头蛇尾",
    "traditional": "虎頭蛇尾"
  },
  {
    "frequency": 1701,
    "simplified": "蜻蜓点水",
    "traditional": "蜻蜓點水"
  },
  {
    "frequency": 1701,
    "simplified": "抽丝剥茧",
    "traditional": "抽絲剝繭"
  },
  {
    "frequency": 1701,
    "simplified": "分崩离析",
    "traditional": "分崩離析"
  },
  {
    "frequency": 1700,
    "simplified": "心有余而力不足",
    "traditional": "心有餘而力不足"
  },
  {
    "frequency": 1699,
    "simplified": "千山万水",
    "traditional": "千山萬水"
  },
  {
    "frequency": 1698,
    "simplified": "并行不悖",
    "traditional": "並行不悖"
  },
  {
    "frequency": 1697,
    "simplified": "奔走相告",
    "traditional": "奔走相告"
  },
  {
    "frequency": 1696,
    "simplified": "有问必答",
    "traditional": "有問必答"
  },
  {
    "frequency": 1694,
    "simplified": "铁证如山",
    "traditional": "鐵證如山"
  },
  {
    "frequency": 1694,
    "simplified": "量体裁衣",
    "traditional": "量體裁衣"
  },
  {
    "frequency": 1693,
    "simplified": "狂轰滥炸",
    "traditional": "狂轟濫炸"
  },
  {
    "frequency": 1693,
    "simplified": "完璧归赵",
    "traditional": "完璧歸趙"
  },
  {
    "frequency": 1692,
    "simplified": "无可奉告",
    "traditional": "無可奉告"
  },
  {
    "frequency": 1688,
    "simplified": "挂羊头卖狗肉",
    "traditional": "掛羊頭賣狗肉"
  },
  {
    "frequency": 1686,
    "simplified": "不可动摇",
    "traditional": "不可動搖"
  },
  {
    "frequency": 1684,
    "simplified": "软硬兼施",
    "traditional": "軟硬兼施"
  },
  {
    "frequency": 1682,
    "simplified": "疏而不漏",
    "traditional": "疏而不漏"
  },
  {
    "frequency": 1681,
    "simplified": "闷闷不乐",
    "traditional": "悶悶不樂"
  },
  {
    "frequency": 1681,
    "simplified": "急中生智",
    "traditional": "急中生智"
  },
  {
    "frequency": 1681,
    "simplified": "监守自盗",
    "traditional": "監守自盜"
  },
  {
    "frequency": 1677,
    "simplified": "心心相印",
    "traditional": "心心相印"
  },
  {
    "frequency": 1674,
    "simplified": "人杰地灵",
    "traditional": "人傑地靈"
  },
  {
    "frequency": 1673,
    "simplified": "身不由己",
    "traditional": "身不由己"
  },
  {
    "frequency": 1673,
    "simplified": "不堪回首",
    "traditional": "不堪回首"
  },
  {
    "frequency": 1671,
    "simplified": "生老病死",
    "traditional": "生老病死"
  },
  {
    "frequency": 1670,
    "simplified": "捷报频传",
    "traditional": "捷報頻傳"
  },
  {
    "frequency": 1668,
    "simplified": "破旧不堪",
    "traditional": "破舊不堪"
  },
  {
    "frequency": 1667,
    "simplified": "粗心大意",
    "traditional": "粗心大意"
  },
  {
    "frequency": 1667,
    "simplified": "开宗明义",
    "traditional": "開宗明義"
  },
  {
    "frequency": 1666,
    "simplified": "瓢泼大雨",
    "traditional": "瓢潑大雨"
  },
  {
    "frequency": 1666,
    "simplified": "感人肺腑",
    "traditional": "感人肺腑"
  },
  {
    "frequency": 1665,
    "simplified": "任人唯亲",
    "traditional": "任人唯親"
  },
  {
    "frequency": 1665,
    "simplified": "惴惴不安",
    "traditional": "惴惴不安"
  },
  {
    "frequency": 1663,
    "simplified": "沁人心脾",
    "traditional": "沁人心脾"
  },
  {
    "frequency": 1662,
    "simplified": "言外之意",
    "traditional": "言外之意"
  },
  {
    "frequency": 1662,
    "simplified": "昏昏欲睡",
    "traditional": "昏昏欲睡"
  },
  {
    "frequency": 1661,
    "simplified": "无精打采",
    "traditional": "無精打采"
  },
  {
    "frequency": 1661,
    "simplified": "不出所料",
    "traditional": "不出所料"
  },
  {
    "frequency": 1659,
    "simplified": "行云流水",
    "traditional": "行雲流水"
  },
  {
    "frequency": 1658,
    "simplified": "一穷二白",
    "traditional": "一窮二白"
  },
  {
    "frequency": 1658,
    "simplified": "无所畏惧",
    "traditional": "無所畏懼"
  },
  {
    "frequency": 1657,
    "simplified": "捏了一把汗",
    "traditional": "捏了一把汗"
  },
  {
    "frequency": 1655,
    "simplified": "出人头地",
    "traditional": "出人頭地"
  },
  {
    "frequency": 1652,
    "simplified": "无所顾忌",
    "traditional": "無所顧忌"
  },
  {
    "frequency": 1652,
    "simplified": "切肤之痛",
    "traditional": "切膚之痛"
  },
  {
    "frequency": 1652,
    "simplified": "赤子之心",
    "traditional": "赤子之心"
  },
  {
    "frequency": 1648,
    "simplified": "大功告成",
    "traditional": "大功告成"
  },
  {
    "frequency": 1646,
    "simplified": "拍案叫绝",
    "traditional": "拍案叫絕"
  },
  {
    "frequency": 1644,
    "simplified": "扬眉吐气",
    "traditional": "揚眉吐氣"
  },
  {
    "frequency": 1644,
    "simplified": "举国上下",
    "traditional": "舉國上下"
  },
  {
    "frequency": 1644,
    "simplified": "得过且过",
    "traditional": "得過且過"
  },
  {
    "frequency": 1643,
    "simplified": "换汤不换药",
    "traditional": "換湯不換藥"
  },
  {
    "frequency": 1642,
    "simplified": "趁火打劫",
    "traditional": "趁火打劫"
  },
  {
    "frequency": 1641,
    "simplified": "乌烟瘴气",
    "traditional": "烏煙瘴氣"
  },
  {
    "frequency": 1640,
    "simplified": "见仁见智",
    "traditional": "見仁見智"
  },
  {
    "frequency": 1639,
    "simplified": "寸步不离",
    "traditional": "寸步不離"
  },
  {
    "frequency": 1635,
    "simplified": "风光旖旎",
    "traditional": "風光旖旎"
  },
  {
    "frequency": 1635,
    "simplified": "有口皆碑",
    "traditional": "有口皆碑"
  },
  {
    "frequency": 1635,
    "simplified": "各得其所",
    "traditional": "各得其所"
  },
  {
    "frequency": 1634,
    "simplified": "不痛不痒",
    "traditional": "不痛不癢"
  },
  {
    "frequency": 1633,
    "simplified": "济济一堂",
    "traditional": "濟濟一堂"
  },
  {
    "frequency": 1631,
    "simplified": "毕其功于一役",
    "traditional": "畢其功於一役"
  },
  {
    "frequency": 1630,
    "simplified": "返璞归真",
    "traditional": "返璞歸真"
  },
  {
    "frequency": 1630,
    "simplified": "不慌不忙",
    "traditional": "不慌不忙"
  },
  {
    "frequency": 1628,
    "simplified": "利欲熏心",
    "traditional": "利慾薰心"
  },
  {
    "frequency": 1626,
    "simplified": "才华横溢",
    "traditional": "才華橫溢"
  },
  {
    "frequency": 1625,
    "simplified": "既成事实",
    "traditional": "既成事實"
  },
  {
    "frequency": 1623,
    "simplified": "为国捐躯",
    "traditional": "為國捐軀"
  },
  {
    "frequency": 1623,
    "simplified": "平起平坐",
    "traditional": "平起平坐"
  },
  {
    "frequency": 1621,
    "simplified": "称心如意",
    "traditional": "稱心如意"
  },
  {
    "frequency": 1621,
    "simplified": "各有千秋",
    "traditional": "各有千秋"
  },
  {
    "frequency": 1620,
    "simplified": "叱咤风云",
    "traditional": "叱吒風雲"
  },
  {
    "frequency": 1618,
    "simplified": "不知所终",
    "traditional": "不知所終"
  },
  {
    "frequency": 1618,
    "simplified": "胡说八道",
    "traditional": "胡說八道"
  },
  {
    "frequency": 1618,
    "simplified": "一反常态",
    "traditional": "一反常態"
  },
  {
    "frequency": 1617,
    "simplified": "雁过拔毛",
    "traditional": "雁過拔毛"
  },
  {
    "frequency": 1617,
    "simplified": "毅然决然",
    "traditional": "毅然決然"
  },
  {
    "frequency": 1616,
    "simplified": "打抱不平",
    "traditional": "打抱不平"
  },
  {
    "frequency": 1615,
    "simplified": "颐养天年",
    "traditional": "頤養天年"
  },
  {
    "frequency": 1615,
    "simplified": "怦然心动",
    "traditional": "怦然心動"
  },
  {
    "frequency": 1615,
    "simplified": "呼风唤雨",
    "traditional": "呼風喚雨"
  },
  {
    "frequency": 1613,
    "simplified": "绘声绘色",
    "traditional": "繪聲繪色"
  },
  {
    "frequency": 1612,
    "simplified": "无言以对",
    "traditional": "無言以對"
  },
  {
    "frequency": 1611,
    "simplified": "适可而止",
    "traditional": "適可而止"
  },
  {
    "frequency": 1610,
    "simplified": "漫不经心",
    "traditional": "漫不經心"
  },
  {
    "frequency": 1608,
    "simplified": "艰苦朴素",
    "traditional": "艱苦樸素"
  },
  {
    "frequency": 1607,
    "simplified": "隐隐约约",
    "traditional": "隱隱約約"
  },
  {
    "frequency": 1606,
    "simplified": "金碧辉煌",
    "traditional": "金碧輝煌"
  },
  {
    "frequency": 1606,
    "simplified": "先睹为快",
    "traditional": "先睹為快"
  },
  {
    "frequency": 1604,
    "simplified": "功成名就",
    "traditional": "功成名就"
  },
  {
    "frequency": 1604,
    "simplified": "言谈举止",
    "traditional": "言談舉止"
  },
  {
    "frequency": 1601,
    "simplified": "闻风而动",
    "traditional": "聞風而動"
  },
  {
    "frequency": 1599,
    "simplified": "掩耳盗铃",
    "traditional": "掩耳盜鈴"
  },
  {
    "frequency": 1599,
    "simplified": "家徒四壁",
    "traditional": "家徒四壁"
  },
  {
    "frequency": 1598,
    "simplified": "枪林弹雨",
    "traditional": "槍林彈雨"
  },
  {
    "frequency": 1598,
    "simplified": "如虎添翼",
    "traditional": "如虎添翼"
  },
  {
    "frequency": 1597,
    "simplified": "价值连城",
    "traditional": "價值連城"
  },
  {
    "frequency": 1594,
    "simplified": "见势不妙",
    "traditional": "見勢不妙"
  },
  {
    "frequency": 1594,
    "simplified": "以儆效尤",
    "traditional": "以儆效尤"
  },
  {
    "frequency": 1592,
    "simplified": "不伦不类",
    "traditional": "不倫不類"
  },
  {
    "frequency": 1591,
    "simplified": "身败名裂",
    "traditional": "身敗名裂"
  },
  {
    "frequency": 1590,
    "simplified": "波光粼粼",
    "traditional": "波光粼粼"
  },
  {
    "frequency": 1589,
    "simplified": "旁若无人",
    "traditional": "旁若無人"
  },
  {
    "frequency": 1587,
    "simplified": "轻车熟路",
    "traditional": "輕車熟路"
  },
  {
    "frequency": 1585,
    "simplified": "节衣缩食",
    "traditional": "節衣縮食"
  },
  {
    "frequency": 1584,
    "simplified": "默不作声",
    "traditional": "默不作聲"
  },
  {
    "frequency": 1579,
    "simplified": "肝胆相照",
    "traditional": "肝膽相照"
  },
  {
    "frequency": 1578,
    "simplified": "尽心竭力",
    "traditional": "盡心竭力"
  },
  {
    "frequency": 1578,
    "simplified": "三思而后行",
    "traditional": "三思而後行"
  },
  {
    "frequency": 1575,
    "simplified": "兼容并蓄",
    "traditional": "兼容並蓄"
  },
  {
    "frequency": 1571,
    "simplified": "无懈可击",
    "traditional": "無懈可擊"
  },
  {
    "frequency": 1571,
    "simplified": "行家里手",
    "traditional": "行家裡手"
  },
  {
    "frequency": 1569,
    "simplified": "延年益寿",
    "traditional": "延年益壽"
  },
  {
    "frequency": 1568,
    "simplified": "夸大其词",
    "traditional": "誇大其詞"
  },
  {
    "frequency": 1566,
    "simplified": "雷声大雨点小",
    "traditional": "雷聲大雨點小"
  },
  {
    "frequency": 1564,
    "simplified": "伤筋动骨",
    "traditional": "傷筋動骨"
  },
  {
    "frequency": 1564,
    "simplified": "跋山涉水",
    "traditional": "跋山涉水"
  },
  {
    "frequency": 1563,
    "simplified": "前仆后继",
    "traditional": "前仆後繼"
  },
  {
    "frequency": 1559,
    "simplified": "攻城略地",
    "traditional": "攻城略地"
  },
  {
    "frequency": 1556,
    "simplified": "负隅顽抗",
    "traditional": "負隅頑抗"
  },
  {
    "frequency": 1555,
    "simplified": "捕风捉影",
    "traditional": "捕風捉影"
  },
  {
    "frequency": 1551,
    "simplified": "越俎代庖",
    "traditional": "越俎代庖"
  },
  {
    "frequency": 1550,
    "simplified": "文人墨客",
    "traditional": "文人墨客"
  },
  {
    "frequency": 1549,
    "simplified": "好吃懒做",
    "traditional": "好吃懶做"
  },
  {
    "frequency": 1547,
    "simplified": "祸不单行",
    "traditional": "禍不單行"
  },
  {
    "frequency": 1546,
    "simplified": "万事俱备",
    "traditional": "萬事俱備"
  },
  {
    "frequency": 1546,
    "simplified": "头痛医头",
    "traditional": "頭痛醫頭"
  },
  {
    "frequency": 1546,
    "simplified": "莫衷一是",
    "traditional": "莫衷一是"
  },
  {
    "frequency": 1545,
    "simplified": "无拘无束",
    "traditional": "無拘無束"
  },
  {
    "frequency": 1545,
    "simplified": "牢不可破",
    "traditional": "牢不可破"
  },
  {
    "frequency": 1545,
    "simplified": "指名道姓",
    "traditional": "指名道姓"
  },
  {
    "frequency": 1544,
    "simplified": "坚如磐石",
    "traditional": "堅如磐石"
  },
  {
    "frequency": 1544,
    "simplified": "艰难曲折",
    "traditional": "艱難曲折"
  },
  {
    "frequency": 1543,
    "simplified": "人云亦云",
    "traditional": "人云亦云"
  },
  {
    "frequency": 1538,
    "simplified": "悬崖勒马",
    "traditional": "懸崖勒馬"
  },
  {
    "frequency": 1538,
    "simplified": "多一事不如少一事",
    "traditional": "多一事不如少一事"
  },
  {
    "frequency": 1535,
    "simplified": "雨过天晴",
    "traditional": "雨過天晴"
  },
  {
    "frequency": 1535,
    "simplified": "一举成名",
    "traditional": "一舉成名"
  },
  {
    "frequency": 1533,
    "simplified": "变幻莫测",
    "traditional": "變幻莫測"
  },
  {
    "frequency": 1533,
    "simplified": "与人为善",
    "traditional": "與人為善"
  },
  {
    "frequency": 1533,
    "simplified": "激浊扬清",
    "traditional": "激濁揚清"
  },
  {
    "frequency": 1532,
    "simplified": "灯火辉煌",
    "traditional": "燈火輝煌"
  },
  {
    "frequency": 1532,
    "simplified": "坚定意志",
    "traditional": "堅定意志"
  },
  {
    "frequency": 1531,
    "simplified": "光天化日",
    "traditional": "光天化日"
  },
  {
    "frequency": 1531,
    "simplified": "人心所向",
    "traditional": "人心所向"
  },
  {
    "frequency": 1530,
    "simplified": "七零八落",
    "traditional": "七零八落"
  },
  {
    "frequency": 1528,
    "simplified": "重新做人",
    "traditional": "重新做人"
  },
  {
    "frequency": 1528,
    "simplified": "沧海桑田",
    "traditional": "滄海桑田"
  },
  {
    "frequency": 1527,
    "simplified": "令人作呕",
    "traditional": "令人作嘔"
  },
  {
    "frequency": 1527,
    "simplified": "风雨交加",
    "traditional": "風雨交加"
  },
  {
    "frequency": 1524,
    "simplified": "心力衰竭",
    "traditional": "心力衰竭"
  },
  {
    "frequency": 1524,
    "simplified": "回心转意",
    "traditional": "回心轉意"
  },
  {
    "frequency": 1523,
    "simplified": "望而生畏",
    "traditional": "望而生畏"
  },
  {
    "frequency": 1522,
    "simplified": "畏罪潜逃",
    "traditional": "畏罪潛逃"
  },
  {
    "frequency": 1520,
    "simplified": "一无是处",
    "traditional": "一無是處"
  },
  {
    "frequency": 1518,
    "simplified": "养儿防老",
    "traditional": "養兒防老"
  },
  {
    "frequency": 1518,
    "simplified": "出言不逊",
    "traditional": "出言不遜"
  },
  {
    "frequency": 1518,
    "simplified": "光明磊落",
    "traditional": "光明磊落"
  },
  {
    "frequency": 1517,
    "simplified": "惨绝人寰",
    "traditional": "慘絕人寰"
  },
  {
    "frequency": 1517,
    "simplified": "化为乌有",
    "traditional": "化為烏有"
  },
  {
    "frequency": 1515,
    "simplified": "万家灯火",
    "traditional": "萬家燈火"
  },
  {
    "frequency": 1515,
    "simplified": "煽风点火",
    "traditional": "煽風點火"
  },
  {
    "frequency": 1513,
    "simplified": "吃力不讨好",
    "traditional": "吃力不討好"
  },
  {
    "frequency": 1512,
    "simplified": "力挽狂澜",
    "traditional": "力挽狂瀾"
  },
  {
    "frequency": 1512,
    "simplified": "荡气回肠",
    "traditional": "蕩氣迴腸"
  },
  {
    "frequency": 1511,
    "simplified": "赤身裸体",
    "traditional": "赤身裸體"
  },
  {
    "frequency": 1511,
    "simplified": "诚心诚意",
    "traditional": "誠心誠意"
  },
  {
    "frequency": 1511,
    "simplified": "矫枉过正",
    "traditional": "矯枉過正"
  },
  {
    "frequency": 1509,
    "simplified": "大气磅礴",
    "traditional": "大氣磅礴"
  },
  {
    "frequency": 1509,
    "simplified": "名噪一时",
    "traditional": "名噪一時"
  },
  {
    "frequency": 1505,
    "simplified": "苍白无力",
    "traditional": "蒼白無力"
  },
  {
    "frequency": 1504,
    "simplified": "相亲相爱",
    "traditional": "相親相愛"
  },
  {
    "frequency": 1504,
    "simplified": "神清气爽",
    "traditional": "神清氣爽"
  },
  {
    "frequency": 1503,
    "simplified": "妙语连珠",
    "traditional": "妙語連珠"
  },
  {
    "frequency": 1502,
    "simplified": "慌慌张张",
    "traditional": "慌慌張張"
  },
  {
    "frequency": 1501,
    "simplified": "姹紫嫣红",
    "traditional": "奼紫嫣紅"
  },
  {
    "frequency": 1501,
    "simplified": "吞吞吐吐",
    "traditional": "吞吞吐吐"
  },
  {
    "frequency": 1498,
    "simplified": "见多识广",
    "traditional": "見多識廣"
  },
  {
    "frequency": 1497,
    "simplified": "如临大敌",
    "traditional": "如臨大敵"
  },
  {
    "frequency": 1497,
    "simplified": "有备无患",
    "traditional": "有備無患"
  },
  {
    "frequency": 1497,
    "simplified": "百废待兴",
    "traditional": "百廢待興"
  },
  {
    "frequency": 1497,
    "simplified": "大雨倾盆",
    "traditional": "大雨傾盆"
  },
  {
    "frequency": 1497,
    "simplified": "独辟蹊径",
    "traditional": "獨闢蹊徑"
  },
  {
    "frequency": 1495,
    "simplified": "胡言乱语",
    "traditional": "胡言亂語"
  },
  {
    "frequency": 1490,
    "simplified": "催人泪下",
    "traditional": "催人淚下"
  },
  {
    "frequency": 1488,
    "simplified": "积少成多",
    "traditional": "積少成多"
  },
  {
    "frequency": 1487,
    "simplified": "心力交瘁",
    "traditional": "心力交瘁"
  },
  {
    "frequency": 1487,
    "simplified": "一己之私",
    "traditional": "一己之私"
  },
  {
    "frequency": 1486,
    "simplified": "初出茅庐",
    "traditional": "初出茅廬"
  },
  {
    "frequency": 1486,
    "simplified": "大大咧咧",
    "traditional": "大大咧咧"
  },
  {
    "frequency": 1485,
    "simplified": "浑然天成",
    "traditional": "渾然天成"
  },
  {
    "frequency": 1482,
    "simplified": "真心诚意",
    "traditional": "真心誠意"
  },
  {
    "frequency": 1482,
    "simplified": "南来北往",
    "traditional": "南來北往"
  },
  {
    "frequency": 1478,
    "simplified": "多如牛毛",
    "traditional": "多如牛毛"
  },
  {
    "frequency": 1476,
    "simplified": "心急火燎",
    "traditional": "心急火燎"
  },
  {
    "frequency": 1475,
    "simplified": "颠沛流离",
    "traditional": "顛沛流離"
  },
  {
    "frequency": 1475,
    "simplified": "逆水行舟",
    "traditional": "逆水行舟"
  },
  {
    "frequency": 1474,
    "simplified": "慌不择路",
    "traditional": "慌不擇路"
  },
  {
    "frequency": 1473,
    "simplified": "发号施令",
    "traditional": "發號施令"
  },
  {
    "frequency": 1472,
    "simplified": "投其所好",
    "traditional": "投其所好"
  },
  {
    "frequency": 1470,
    "simplified": "故伎重演",
    "traditional": "故伎重演"
  },
  {
    "frequency": 1467,
    "simplified": "照本宣科",
    "traditional": "照本宣科"
  },
  {
    "frequency": 1466,
    "simplified": "绕道而行",
    "traditional": "繞道而行"
  },
  {
    "frequency": 1465,
    "simplified": "移花接木",
    "traditional": "移花接木"
  },
  {
    "frequency": 1464,
    "simplified": "人人自危",
    "traditional": "人人自危"
  },
  {
    "frequency": 1461,
    "simplified": "共商国是",
    "traditional": "共商國是"
  },
  {
    "frequency": 1461,
    "simplified": "单枪匹马",
    "traditional": "單槍匹馬"
  },
  {
    "frequency": 1461,
    "simplified": "在天之灵",
    "traditional": "在天之靈"
  },
  {
    "frequency": 1461,
    "simplified": "声嘶力竭",
    "traditional": "聲嘶力竭"
  },
  {
    "frequency": 1460,
    "simplified": "多此一举",
    "traditional": "多此一舉"
  },
  {
    "frequency": 1460,
    "simplified": "鱼目混珠",
    "traditional": "魚目混珠"
  },
  {
    "frequency": 1456,
    "simplified": "老实巴交",
    "traditional": "老實巴交"
  },
  {
    "frequency": 1456,
    "simplified": "舟车劳顿",
    "traditional": "舟車勞頓"
  },
  {
    "frequency": 1454,
    "simplified": "稀奇古怪",
    "traditional": "稀奇古怪"
  },
  {
    "frequency": 1453,
    "simplified": "不堪入目",
    "traditional": "不堪入目"
  },
  {
    "frequency": 1453,
    "simplified": "愁眉不展",
    "traditional": "愁眉不展"
  },
  {
    "frequency": 1453,
    "simplified": "百年大计",
    "traditional": "百年大計"
  },
  {
    "frequency": 1453,
    "simplified": "细枝末节",
    "traditional": "細枝末節"
  },
  {
    "frequency": 1453,
    "simplified": "一窍不通",
    "traditional": "一竅不通"
  },
  {
    "frequency": 1450,
    "simplified": "落荒而逃",
    "traditional": "落荒而逃"
  },
  {
    "frequency": 1450,
    "simplified": "和盘托出",
    "traditional": "和盤托出"
  },
  {
    "frequency": 1450,
    "simplified": "美中不足",
    "traditional": "美中不足"
  },
  {
    "frequency": 1449,
    "simplified": "不甘寂寞",
    "traditional": "不甘寂寞"
  },
  {
    "frequency": 1449,
    "simplified": "狭路相逢",
    "traditional": "狹路相逢"
  },
  {
    "frequency": 1448,
    "simplified": "饮水思源",
    "traditional": "飲水思源"
  },
  {
    "frequency": 1447,
    "simplified": "绰绰有余",
    "traditional": "綽綽有餘"
  },
  {
    "frequency": 1445,
    "simplified": "战火纷飞",
    "traditional": "戰火紛飛"
  },
  {
    "frequency": 1445,
    "simplified": "名利双收",
    "traditional": "名利雙收"
  },
  {
    "frequency": 1442,
    "simplified": "思前想后",
    "traditional": "思前想後"
  },
  {
    "frequency": 1442,
    "simplified": "大庭广众",
    "traditional": "大庭廣眾"
  },
  {
    "frequency": 1440,
    "simplified": "精疲力竭",
    "traditional": "精疲力竭"
  },
  {
    "frequency": 1440,
    "simplified": "人人皆知",
    "traditional": "人人皆知"
  },
  {
    "frequency": 1437,
    "simplified": "人赃俱获",
    "traditional": "人贓俱獲"
  },
  {
    "frequency": 1437,
    "simplified": "幸灾乐祸",
    "traditional": "幸災樂禍"
  },
  {
    "frequency": 1434,
    "simplified": "两袖清风",
    "traditional": "兩袖清風"
  },
  {
    "frequency": 1432,
    "simplified": "答非所问",
    "traditional": "答非所問"
  },
  {
    "frequency": 1431,
    "simplified": "简明扼要",
    "traditional": "簡明扼要"
  },
  {
    "frequency": 1431,
    "simplified": "一事无成",
    "traditional": "一事無成"
  },
  {
    "frequency": 1429,
    "simplified": "相形见绌",
    "traditional": "相形見絀"
  },
  {
    "frequency": 1429,
    "simplified": "择优录取",
    "traditional": "擇優錄取"
  },
  {
    "frequency": 1427,
    "simplified": "惊涛骇浪",
    "traditional": "驚濤駭浪"
  },
  {
    "frequency": 1423,
    "simplified": "麻木不仁",
    "traditional": "麻木不仁"
  },
  {
    "frequency": 1421,
    "simplified": "觥筹交错",
    "traditional": "觥籌交錯"
  },
  {
    "frequency": 1420,
    "simplified": "舍生忘死",
    "traditional": "捨生忘死"
  },
  {
    "frequency": 1420,
    "simplified": "反其道而行之",
    "traditional": "反其道而行之"
  },
  {
    "frequency": 1419,
    "simplified": "寿终正寝",
    "traditional": "壽終正寢"
  },
  {
    "frequency": 1419,
    "simplified": "拔苗助长",
    "traditional": "拔苗助長"
  },
  {
    "frequency": 1418,
    "simplified": "除恶务尽",
    "traditional": "除惡務盡"
  },
  {
    "frequency": 1415,
    "simplified": "风驰电掣",
    "traditional": "風馳電掣"
  },
  {
    "frequency": 1415,
    "simplified": "妄自菲薄",
    "traditional": "妄自菲薄"
  },
  {
    "frequency": 1415,
    "simplified": "毫不讳言",
    "traditional": "毫不諱言"
  },
  {
    "frequency": 1414,
    "simplified": "自生自灭",
    "traditional": "自生自滅"
  },
  {
    "frequency": 1413,
    "simplified": "有板有眼",
    "traditional": "有板有眼"
  },
  {
    "frequency": 1413,
    "simplified": "议论风生",
    "traditional": "議論風生"
  },
  {
    "frequency": 1412,
    "simplified": "不可抗拒",
    "traditional": "不可抗拒"
  },
  {
    "frequency": 1410,
    "simplified": "孤立无援",
    "traditional": "孤立無援"
  },
  {
    "frequency": 1409,
    "simplified": "沆瀣一气",
    "traditional": "沆瀣一氣"
  },
  {
    "frequency": 1409,
    "simplified": "喋喋不休",
    "traditional": "喋喋不休"
  },
  {
    "frequency": 1408,
    "simplified": "念念有词",
    "traditional": "唸唸有詞"
  },
  {
    "frequency": 1408,
    "simplified": "弄巧成拙",
    "traditional": "弄巧成拙"
  },
  {
    "frequency": 1408,
    "simplified": "人财两空",
    "traditional": "人財兩空"
  },
  {
    "frequency": 1407,
    "simplified": "亭台楼阁",
    "traditional": "亭臺樓閣"
  },
  {
    "frequency": 1407,
    "simplified": "亲密无间",
    "traditional": "親密無間"
  },
  {
    "frequency": 1406,
    "simplified": "终身大事",
    "traditional": "終身大事"
  },
  {
    "frequency": 1406,
    "simplified": "坚不可摧",
    "traditional": "堅不可摧"
  },
  {
    "frequency": 1404,
    "simplified": "物以稀为贵",
    "traditional": "物以稀為貴"
  },
  {
    "frequency": 1404,
    "simplified": "天花乱坠",
    "traditional": "天花亂墜"
  },
  {
    "frequency": 1403,
    "simplified": "风吹雨打",
    "traditional": "風吹雨打"
  },
  {
    "frequency": 1402,
    "simplified": "异乎寻常",
    "traditional": "異乎尋常"
  },
  {
    "frequency": 1402,
    "simplified": "羊毛出在羊身上",
    "traditional": "羊毛出在羊身上"
  },
  {
    "frequency": 1402,
    "simplified": "千言万语",
    "traditional": "千言萬語"
  },
  {
    "frequency": 1399,
    "simplified": "亦步亦趋",
    "traditional": "亦步亦趨"
  },
  {
    "frequency": 1398,
    "simplified": "惩前毖后",
    "traditional": "懲前毖後"
  },
  {
    "frequency": 1398,
    "simplified": "扶老携幼",
    "traditional": "扶老攜幼"
  },
  {
    "frequency": 1396,
    "simplified": "攻守同盟",
    "traditional": "攻守同盟"
  },
  {
    "frequency": 1394,
    "simplified": "白雪皑皑",
    "traditional": "白雪皚皚"
  },
  {
    "frequency": 1392,
    "simplified": "充耳不闻",
    "traditional": "充耳不聞"
  },
  {
    "frequency": 1392,
    "simplified": "青梅竹马",
    "traditional": "青梅竹馬"
  },
  {
    "frequency": 1392,
    "simplified": "安于现状",
    "traditional": "安於現狀"
  },
  {
    "frequency": 1391,
    "simplified": "一针一线",
    "traditional": "一針一線"
  },
  {
    "frequency": 1390,
    "simplified": "大好河山",
    "traditional": "大好河山"
  },
  {
    "frequency": 1388,
    "simplified": "人才济济",
    "traditional": "人才濟濟"
  },
  {
    "frequency": 1387,
    "simplified": "咎由自取",
    "traditional": "咎由自取"
  },
  {
    "frequency": 1386,
    "simplified": "自学成才",
    "traditional": "自學成才"
  },
  {
    "frequency": 1386,
    "simplified": "高人一等",
    "traditional": "高人一等"
  },
  {
    "frequency": 1385,
    "simplified": "藏污纳垢",
    "traditional": "藏汙納垢"
  },
  {
    "frequency": 1384,
    "simplified": "上行下效",
    "traditional": "上行下效"
  },
  {
    "frequency": 1384,
    "simplified": "口干舌燥",
    "traditional": "口乾舌燥"
  },
  {
    "frequency": 1383,
    "simplified": "灯红酒绿",
    "traditional": "燈紅酒綠"
  },
  {
    "frequency": 1382,
    "simplified": "不分青红皂白",
    "traditional": "不分青紅皂白"
  },
  {
    "frequency": 1377,
    "simplified": "天有不测风云",
    "traditional": "天有不測風雲"
  },
  {
    "frequency": 1377,
    "simplified": "难以企及",
    "traditional": "難以企及"
  },
  {
    "frequency": 1376,
    "simplified": "能说会道",
    "traditional": "能說會道"
  },
  {
    "frequency": 1374,
    "simplified": "无所不用其极",
    "traditional": "無所不用其極"
  },
  {
    "frequency": 1372,
    "simplified": "所向披靡",
    "traditional": "所向披靡"
  },
  {
    "frequency": 1372,
    "simplified": "招架不住",
    "traditional": "招架不住"
  },
  {
    "frequency": 1371,
    "simplified": "自觉自愿",
    "traditional": "自覺自願"
  },
  {
    "frequency": 1370,
    "simplified": "嗷嗷待哺",
    "traditional": "嗷嗷待哺"
  },
  {
    "frequency": 1368,
    "simplified": "砸锅卖铁",
    "traditional": "砸鍋賣鐵"
  },
  {
    "frequency": 1364,
    "simplified": "厚德载物",
    "traditional": "厚德載物"
  },
  {
    "frequency": 1364,
    "simplified": "闪烁其词",
    "traditional": "閃爍其詞"
  },
  {
    "frequency": 1359,
    "simplified": "神通广大",
    "traditional": "神通廣大"
  },
  {
    "frequency": 1358,
    "simplified": "取之不尽",
    "traditional": "取之不盡"
  },
  {
    "frequency": 1357,
    "simplified": "风餐露宿",
    "traditional": "風餐露宿"
  },
  {
    "frequency": 1357,
    "simplified": "大风大浪",
    "traditional": "大風大浪"
  },
  {
    "frequency": 1356,
    "simplified": "细水长流",
    "traditional": "細水長流"
  },
  {
    "frequency": 1356,
    "simplified": "喜上眉梢",
    "traditional": "喜上眉梢"
  },
  {
    "frequency": 1355,
    "simplified": "了然于胸",
    "traditional": "瞭然於胸"
  },
  {
    "frequency": 1354,
    "simplified": "判若两人",
    "traditional": "判若兩人"
  },
  {
    "frequency": 1354,
    "simplified": "关门大吉",
    "traditional": "關門大吉"
  },
  {
    "frequency": 1352,
    "simplified": "火冒三丈",
    "traditional": "火冒三丈"
  },
  {
    "frequency": 1352,
    "simplified": "浑然不觉",
    "traditional": "渾然不覺"
  },
  {
    "frequency": 1352,
    "simplified": "胡作非为",
    "traditional": "胡作非為"
  },
  {
    "frequency": 1351,
    "simplified": "街谈巷议",
    "traditional": "街談巷議"
  },
  {
    "frequency": 1350,
    "simplified": "年逾古稀",
    "traditional": "年逾古稀"
  },
  {
    "frequency": 1350,
    "simplified": "筚路蓝缕",
    "traditional": "篳路藍縷"
  },
  {
    "frequency": 1350,
    "simplified": "自作主张",
    "traditional": "自作主張"
  },
  {
    "frequency": 1347,
    "simplified": "过街老鼠",
    "traditional": "過街老鼠"
  },
  {
    "frequency": 1347,
    "simplified": "天南地北",
    "traditional": "天南地北"
  },
  {
    "frequency": 1346,
    "simplified": "小巫见大巫",
    "traditional": "小巫見大巫"
  },
  {
    "frequency": 1346,
    "simplified": "坑蒙拐骗",
    "traditional": "坑蒙拐騙"
  },
  {
    "frequency": 1345,
    "simplified": "无源之水",
    "traditional": "無源之水"
  },
  {
    "frequency": 1345,
    "simplified": "高不可攀",
    "traditional": "高不可攀"
  },
  {
    "frequency": 1344,
    "simplified": "酒足饭饱",
    "traditional": "酒足飯飽"
  },
  {
    "frequency": 1342,
    "simplified": "啧啧称赞",
    "traditional": "嘖嘖稱讚"
  },
  {
    "frequency": 1340,
    "simplified": "怒不可遏",
    "traditional": "怒不可遏"
  },
  {
    "frequency": 1340,
    "simplified": "头晕目眩",
    "traditional": "頭暈目眩"
  },
  {
    "frequency": 1340,
    "simplified": "夕阳西下",
    "traditional": "夕陽西下"
  },
  {
    "frequency": 1339,
    "simplified": "残缺不全",
    "traditional": "殘缺不全"
  },
  {
    "frequency": 1338,
    "simplified": "引经据典",
    "traditional": "引經據典"
  },
  {
    "frequency": 1337,
    "simplified": "见不得人",
    "traditional": "見不得人"
  },
  {
    "frequency": 1337,
    "simplified": "花花公子",
    "traditional": "花花公子"
  },
  {
    "frequency": 1337,
    "simplified": "饮鸩止渴",
    "traditional": "飲鴆止渴"
  },
  {
    "frequency": 1336,
    "simplified": "滥竽充数",
    "traditional": "濫竽充數"
  },
  {
    "frequency": 1336,
    "simplified": "有名无实",
    "traditional": "有名無實"
  },
  {
    "frequency": 1336,
    "simplified": "五谷丰登",
    "traditional": "五穀豐登"
  },
  {
    "frequency": 1335,
    "simplified": "荣辱与共",
    "traditional": "榮辱與共"
  },
  {
    "frequency": 1335,
    "simplified": "若有所思",
    "traditional": "若有所思"
  },
  {
    "frequency": 1334,
    "simplified": "号啕大哭",
    "traditional": "號啕大哭"
  },
  {
    "frequency": 1334,
    "simplified": "坐而论道",
    "traditional": "坐而論道"
  },
  {
    "frequency": 1333,
    "simplified": "真才实学",
    "traditional": "真才實學"
  },
  {
    "frequency": 1332,
    "simplified": "无足轻重",
    "traditional": "無足輕重"
  },
  {
    "frequency": 1331,
    "simplified": "雅俗共赏",
    "traditional": "雅俗共賞"
  },
  {
    "frequency": 1331,
    "simplified": "拥政爱民",
    "traditional": "擁政愛民"
  },
  {
    "frequency": 1331,
    "simplified": "泪如雨下",
    "traditional": "淚如雨下"
  },
  {
    "frequency": 1331,
    "simplified": "怒气冲冲",
    "traditional": "怒氣衝衝"
  },
  {
    "frequency": 1330,
    "simplified": "独到之处",
    "traditional": "獨到之處"
  },
  {
    "frequency": 1329,
    "simplified": "下不为例",
    "traditional": "下不為例"
  },
  {
    "frequency": 1329,
    "simplified": "任人唯贤",
    "traditional": "任人唯賢"
  },
  {
    "frequency": 1328,
    "simplified": "左右逢源",
    "traditional": "左右逢源"
  },
  {
    "frequency": 1328,
    "simplified": "如获至宝",
    "traditional": "如獲至寶"
  },
  {
    "frequency": 1327,
    "simplified": "一问三不知",
    "traditional": "一問三不知"
  },
  {
    "frequency": 1322,
    "simplified": "论资排辈",
    "traditional": "論資排輩"
  },
  {
    "frequency": 1322,
    "simplified": "无伤大雅",
    "traditional": "無傷大雅"
  },
  {
    "frequency": 1322,
    "simplified": "泥沙俱下",
    "traditional": "泥沙俱下"
  },
  {
    "frequency": 1322,
    "simplified": "感天动地",
    "traditional": "感天動地"
  },
  {
    "frequency": 1321,
    "simplified": "欲言又止",
    "traditional": "欲言又止"
  },
  {
    "frequency": 1321,
    "simplified": "事不关己",
    "traditional": "事不關己"
  },
  {
    "frequency": 1320,
    "simplified": "精美绝伦",
    "traditional": "精美絕倫"
  },
  {
    "frequency": 1318,
    "simplified": "衣衫褴褛",
    "traditional": "衣衫襤褸"
  },
  {
    "frequency": 1318,
    "simplified": "一扫而空",
    "traditional": "一掃而空"
  },
  {
    "frequency": 1317,
    "simplified": "排山倒海",
    "traditional": "排山倒海"
  },
  {
    "frequency": 1317,
    "simplified": "九牛一毛",
    "traditional": "九牛一毛"
  },
  {
    "frequency": 1314,
    "simplified": "灰飞烟灭",
    "traditional": "灰飛煙滅"
  },
  {
    "frequency": 1314,
    "simplified": "一团和气",
    "traditional": "一團和氣"
  },
  {
    "frequency": 1313,
    "simplified": "推心置腹",
    "traditional": "推心置腹"
  },
  {
    "frequency": 1310,
    "simplified": "鬼斧神工",
    "traditional": "鬼斧神工"
  },
  {
    "frequency": 1309,
    "simplified": "永垂不朽",
    "traditional": "永垂不朽"
  },
  {
    "frequency": 1309,
    "simplified": "无穷无尽",
    "traditional": "無窮無盡"
  },
  {
    "frequency": 1308,
    "simplified": "墨守成规",
    "traditional": "墨守成規"
  },
  {
    "frequency": 1308,
    "simplified": "惊弓之鸟",
    "traditional": "驚弓之鳥"
  },
  {
    "frequency": 1307,
    "simplified": "波涛汹涌",
    "traditional": "波濤洶湧"
  },
  {
    "frequency": 1306,
    "simplified": "孤注一掷",
    "traditional": "孤注一擲"
  },
  {
    "frequency": 1305,
    "simplified": "血流如注",
    "traditional": "血流如注"
  },
  {
    "frequency": 1304,
    "simplified": "毛遂自荐",
    "traditional": "毛遂自薦"
  },
  {
    "frequency": 1303,
    "simplified": "大动干戈",
    "traditional": "大動干戈"
  },
  {
    "frequency": 1303,
    "simplified": "水乳交融",
    "traditional": "水乳交融"
  },
  {
    "frequency": 1301,
    "simplified": "繁花似锦",
    "traditional": "繁花似錦"
  },
  {
    "frequency": 1301,
    "simplified": "人浮于事",
    "traditional": "人浮於事"
  },
  {
    "frequency": 1301,
    "simplified": "开天辟地",
    "traditional": "開天闢地"
  },
  {
    "frequency": 1300,
    "simplified": "不成方圆",
    "traditional": "不成方圓"
  },
  {
    "frequency": 1298,
    "simplified": "柳暗花明",
    "traditional": "柳暗花明"
  },
  {
    "frequency": 1298,
    "simplified": "饥肠辘辘",
    "traditional": "飢腸轆轆"
  },
  {
    "frequency": 1297,
    "simplified": "手下留情",
    "traditional": "手下留情"
  },
  {
    "frequency": 1295,
    "simplified": "谨小慎微",
    "traditional": "謹小慎微"
  },
  {
    "frequency": 1294,
    "simplified": "过犹不及",
    "traditional": "過猶不及"
  },
  {
    "frequency": 1294,
    "simplified": "大肆宣传",
    "traditional": "大肆宣傳"
  },
  {
    "frequency": 1293,
    "simplified": "蝇头小利",
    "traditional": "蠅頭小利"
  },
  {
    "frequency": 1293,
    "simplified": "远亲不如近邻",
    "traditional": "遠親不如近鄰"
  },
  {
    "frequency": 1293,
    "simplified": "口耳相传",
    "traditional": "口耳相傳"
  },
  {
    "frequency": 1292,
    "simplified": "众口难调",
    "traditional": "眾口難調"
  },
  {
    "frequency": 1292,
    "simplified": "晕头转向",
    "traditional": "暈頭轉向"
  },
  {
    "frequency": 1290,
    "simplified": "走南闯北",
    "traditional": "走南闖北"
  },
  {
    "frequency": 1290,
    "simplified": "不可理喻",
    "traditional": "不可理喻"
  },
  {
    "frequency": 1287,
    "simplified": "殊途同归",
    "traditional": "殊途同歸"
  },
  {
    "frequency": 1285,
    "simplified": "窃窃私语",
    "traditional": "竊竊私語"
  },
  {
    "frequency": 1284,
    "simplified": "其貌不扬",
    "traditional": "其貌不揚"
  },
  {
    "frequency": 1284,
    "simplified": "求贤若渴",
    "traditional": "求賢若渴"
  },
  {
    "frequency": 1282,
    "simplified": "蜂拥而上",
    "traditional": "蜂擁而上"
  },
  {
    "frequency": 1281,
    "simplified": "狮子大开口",
    "traditional": "獅子大開口"
  },
  {
    "frequency": 1280,
    "simplified": "获益匪浅",
    "traditional": "獲益匪淺"
  },
  {
    "frequency": 1279,
    "simplified": "摇旗呐喊",
    "traditional": "搖旗吶喊"
  },
  {
    "frequency": 1278,
    "simplified": "各有所长",
    "traditional": "各有所長"
  },
  {
    "frequency": 1278,
    "simplified": "人情世故",
    "traditional": "人情世故"
  },
  {
    "frequency": 1277,
    "simplified": "半身不遂",
    "traditional": "半身不遂"
  },
  {
    "frequency": 1276,
    "simplified": "秘而不宣",
    "traditional": "秘而不宣"
  },
  {
    "frequency": 1275,
    "simplified": "借题发挥",
    "traditional": "借題發揮"
  },
  {
    "frequency": 1273,
    "simplified": "朝令夕改",
    "traditional": "朝令夕改"
  },
  {
    "frequency": 1270,
    "simplified": "改弦更张",
    "traditional": "改弦更張"
  },
  {
    "frequency": 1270,
    "simplified": "怨天尤人",
    "traditional": "怨天尤人"
  },
  {
    "frequency": 1269,
    "simplified": "循规蹈矩",
    "traditional": "循規蹈矩"
  },
  {
    "frequency": 1268,
    "simplified": "家家户户",
    "traditional": "家家戶戶"
  },
  {
    "frequency": 1268,
    "simplified": "当头一棒",
    "traditional": "當頭一棒"
  },
  {
    "frequency": 1268,
    "simplified": "哄堂大笑",
    "traditional": "鬨堂大笑"
  },
  {
    "frequency": 1267,
    "simplified": "传宗接代",
    "traditional": "傳宗接代"
  },
  {
    "frequency": 1267,
    "simplified": "完美无缺",
    "traditional": "完美無缺"
  },
  {
    "frequency": 1266,
    "simplified": "金榜题名",
    "traditional": "金榜題名"
  },
  {
    "frequency": 1264,
    "simplified": "黯然失色",
    "traditional": "黯然失色"
  },
  {
    "frequency": 1263,
    "simplified": "救亡图存",
    "traditional": "救亡圖存"
  },
  {
    "frequency": 1263,
    "simplified": "虚张声势",
    "traditional": "虛張聲勢"
  },
  {
    "frequency": 1262,
    "simplified": "博采众长",
    "traditional": "博採眾長"
  },
  {
    "frequency": 1262,
    "simplified": "招摇过市",
    "traditional": "招搖過市"
  },
  {
    "frequency": 1262,
    "simplified": "大而化之",
    "traditional": "大而化之"
  },
  {
    "frequency": 1261,
    "simplified": "事倍功半",
    "traditional": "事倍功半"
  },
  {
    "frequency": 1258,
    "simplified": "不可收拾",
    "traditional": "不可收拾"
  },
  {
    "frequency": 1258,
    "simplified": "心灵手巧",
    "traditional": "心靈手巧"
  },
  {
    "frequency": 1256,
    "simplified": "愚公移山",
    "traditional": "愚公移山"
  },
  {
    "frequency": 1256,
    "simplified": "水深火热",
    "traditional": "水深火熱"
  },
  {
    "frequency": 1255,
    "simplified": "一扫而光",
    "traditional": "一掃而光"
  },
  {
    "frequency": 1255,
    "simplified": "无依无靠",
    "traditional": "無依無靠"
  },
  {
    "frequency": 1254,
    "simplified": "花甲之年",
    "traditional": "花甲之年"
  },
  {
    "frequency": 1254,
    "simplified": "一念之差",
    "traditional": "一念之差"
  },
  {
    "frequency": 1254,
    "simplified": "抛头露面",
    "traditional": "拋頭露面"
  },
  {
    "frequency": 1253,
    "simplified": "打退堂鼓",
    "traditional": "打退堂鼓"
  },
  {
    "frequency": 1251,
    "simplified": "以牙还牙",
    "traditional": "以牙還牙"
  },
  {
    "frequency": 1251,
    "simplified": "两手空空",
    "traditional": "兩手空空"
  },
  {
    "frequency": 1251,
    "simplified": "刚正不阿",
    "traditional": "剛正不阿"
  },
  {
    "frequency": 1250,
    "simplified": "风马牛不相及",
    "traditional": "風馬牛不相及"
  },
  {
    "frequency": 1249,
    "simplified": "哑口无言",
    "traditional": "啞口無言"
  },
  {
    "frequency": 1247,
    "simplified": "宾至如归",
    "traditional": "賓至如歸"
  },
  {
    "frequency": 1246,
    "simplified": "忙里偷闲",
    "traditional": "忙裡偷閒"
  },
  {
    "frequency": 1244,
    "simplified": "发人深思",
    "traditional": "發人深思"
  },
  {
    "frequency": 1244,
    "simplified": "无所不包",
    "traditional": "無所不包"
  },
  {
    "frequency": 1242,
    "simplified": "一臂之力",
    "traditional": "一臂之力"
  },
  {
    "frequency": 1242,
    "simplified": "全国一盘棋",
    "traditional": "全國一盤棋"
  },
  {
    "frequency": 1240,
    "simplified": "裹足不前",
    "traditional": "裹足不前"
  },
  {
    "frequency": 1238,
    "simplified": "百事可乐",
    "traditional": "百事可樂"
  },
  {
    "frequency": 1238,
    "simplified": "知难而退",
    "traditional": "知難而退"
  },
  {
    "frequency": 1237,
    "simplified": "一年之计在于春",
    "traditional": "一年之計在於春"
  },
  {
    "frequency": 1237,
    "simplified": "神情恍惚",
    "traditional": "神情恍惚"
  },
  {
    "frequency": 1237,
    "simplified": "三言两语",
    "traditional": "三言兩語"
  },
  {
    "frequency": 1235,
    "simplified": "心不在焉",
    "traditional": "心不在焉"
  },
  {
    "frequency": 1234,
    "simplified": "隔靴搔痒",
    "traditional": "隔靴搔癢"
  },
  {
    "frequency": 1233,
    "simplified": "昭然若揭",
    "traditional": "昭然若揭"
  },
  {
    "frequency": 1232,
    "simplified": "肺腑之言",
    "traditional": "肺腑之言"
  },
  {
    "frequency": 1230,
    "simplified": "惺惺相惜",
    "traditional": "惺惺相惜"
  },
  {
    "frequency": 1230,
    "simplified": "从容不迫",
    "traditional": "從容不迫"
  },
  {
    "frequency": 1229,
    "simplified": "铁面无私",
    "traditional": "鐵面無私"
  },
  {
    "frequency": 1228,
    "simplified": "悲欢离合",
    "traditional": "悲歡離合"
  },
  {
    "frequency": 1228,
    "simplified": "山珍海味",
    "traditional": "山珍海味"
  },
  {
    "frequency": 1227,
    "simplified": "孤军奋战",
    "traditional": "孤軍奮戰"
  },
  {
    "frequency": 1227,
    "simplified": "深山老林",
    "traditional": "深山老林"
  },
  {
    "frequency": 1225,
    "simplified": "东奔西跑",
    "traditional": "東奔西跑"
  },
  {
    "frequency": 1225,
    "simplified": "文质彬彬",
    "traditional": "文質彬彬"
  },
  {
    "frequency": 1224,
    "simplified": "顶礼膜拜",
    "traditional": "頂禮膜拜"
  },
  {
    "frequency": 1224,
    "simplified": "一丝不挂",
    "traditional": "一絲不掛"
  },
  {
    "frequency": 1224,
    "simplified": "冰冻三尺非一日之寒",
    "traditional": "冰凍三尺非一日之寒"
  },
  {
    "frequency": 1220,
    "simplified": "头疼脑热",
    "traditional": "頭疼腦熱"
  },
  {
    "frequency": 1219,
    "simplified": "天下为公",
    "traditional": "天下為公"
  },
  {
    "frequency": 1219,
    "simplified": "里应外合",
    "traditional": "裡應外合"
  },
  {
    "frequency": 1219,
    "simplified": "一见如故",
    "traditional": "一見如故"
  },
  {
    "frequency": 1217,
    "simplified": "路见不平",
    "traditional": "路見不平"
  },
  {
    "frequency": 1215,
    "simplified": "大发雷霆",
    "traditional": "大發雷霆"
  },
  {
    "frequency": 1214,
    "simplified": "狼吞虎咽",
    "traditional": "狼吞虎嚥"
  },
  {
    "frequency": 1213,
    "simplified": "执迷不悟",
    "traditional": "執迷不悟"
  },
  {
    "frequency": 1212,
    "simplified": "待人接物",
    "traditional": "待人接物"
  },
  {
    "frequency": 1211,
    "simplified": "病急乱投医",
    "traditional": "病急亂投醫"
  },
  {
    "frequency": 1209,
    "simplified": "洗心革面",
    "traditional": "洗心革面"
  },
  {
    "frequency": 1208,
    "simplified": "同病相怜",
    "traditional": "同病相憐"
  },
  {
    "frequency": 1207,
    "simplified": "不治之症",
    "traditional": "不治之症"
  },
  {
    "frequency": 1207,
    "simplified": "神采飞扬",
    "traditional": "神采飛揚"
  },
  {
    "frequency": 1206,
    "simplified": "衣食父母",
    "traditional": "衣食父母"
  },
  {
    "frequency": 1206,
    "simplified": "舍我其谁",
    "traditional": "捨我其誰"
  },
  {
    "frequency": 1204,
    "simplified": "言过其实",
    "traditional": "言過其實"
  },
  {
    "frequency": 1202,
    "simplified": "低级趣味",
    "traditional": "低級趣味"
  },
  {
    "frequency": 1201,
    "simplified": "烂熟于心",
    "traditional": "爛熟於心"
  },
  {
    "frequency": 1201,
    "simplified": "势如破竹",
    "traditional": "勢如破竹"
  },
  {
    "frequency": 1198,
    "simplified": "反目成仇",
    "traditional": "反目成仇"
  },
  {
    "frequency": 1198,
    "simplified": "知己知彼",
    "traditional": "知己知彼"
  },
  {
    "frequency": 1197,
    "simplified": "咬牙切齿",
    "traditional": "咬牙切齒"
  },
  {
    "frequency": 1196,
    "simplified": "以理服人",
    "traditional": "以理服人"
  },
  {
    "frequency": 1195,
    "simplified": "大惊失色",
    "traditional": "大驚失色"
  },
  {
    "frequency": 1195,
    "simplified": "纷纷扬扬",
    "traditional": "紛紛揚揚"
  },
  {
    "frequency": 1194,
    "simplified": "万马奔腾",
    "traditional": "萬馬奔騰"
  },
  {
    "frequency": 1192,
    "simplified": "赤手空拳",
    "traditional": "赤手空拳"
  },
  {
    "frequency": 1192,
    "simplified": "生死关头",
    "traditional": "生死關頭"
  },
  {
    "frequency": 1192,
    "simplified": "韬光养晦",
    "traditional": "韜光養晦"
  },
  {
    "frequency": 1192,
    "simplified": "意气用事",
    "traditional": "意氣用事"
  },
  {
    "frequency": 1190,
    "simplified": "废寝忘食",
    "traditional": "廢寢忘食"
  },
  {
    "frequency": 1188,
    "simplified": "身经百战",
    "traditional": "身經百戰"
  },
  {
    "frequency": 1188,
    "simplified": "分内之事",
    "traditional": "分內之事"
  },
  {
    "frequency": 1185,
    "simplified": "点睛之笔",
    "traditional": "點睛之筆"
  },
  {
    "frequency": 1185,
    "simplified": "满口答应",
    "traditional": "滿口答應"
  },
  {
    "frequency": 1185,
    "simplified": "怒火中烧",
    "traditional": "怒火中燒"
  },
  {
    "frequency": 1185,
    "simplified": "素未谋面",
    "traditional": "素未謀面"
  },
  {
    "frequency": 1184,
    "simplified": "风声鹤唳",
    "traditional": "風聲鶴唳"
  },
  {
    "frequency": 1183,
    "simplified": "自立门户",
    "traditional": "自立門戶"
  },
  {
    "frequency": 1183,
    "simplified": "光彩夺目",
    "traditional": "光彩奪目"
  },
  {
    "frequency": 1182,
    "simplified": "病入膏肓",
    "traditional": "病入膏肓"
  },
  {
    "frequency": 1182,
    "simplified": "满不在乎",
    "traditional": "滿不在乎"
  },
  {
    "frequency": 1181,
    "simplified": "愁眉苦脸",
    "traditional": "愁眉苦臉"
  },
  {
    "frequency": 1181,
    "simplified": "百里挑一",
    "traditional": "百裡挑一"
  },
  {
    "frequency": 1180,
    "simplified": "有利有弊",
    "traditional": "有利有弊"
  },
  {
    "frequency": 1180,
    "simplified": "一览无遗",
    "traditional": "一覽無遺"
  },
  {
    "frequency": 1180,
    "simplified": "多多益善",
    "traditional": "多多益善"
  },
  {
    "frequency": 1180,
    "simplified": "昏昏沉沉",
    "traditional": "昏昏沉沉"
  },
  {
    "frequency": 1179,
    "simplified": "好大喜功",
    "traditional": "好大喜功"
  },
  {
    "frequency": 1178,
    "simplified": "妻离子散",
    "traditional": "妻離子散"
  },
  {
    "frequency": 1178,
    "simplified": "巧夺天工",
    "traditional": "巧奪天工"
  },
  {
    "frequency": 1177,
    "simplified": "守口如瓶",
    "traditional": "守口如瓶"
  },
  {
    "frequency": 1177,
    "simplified": "如坐针毡",
    "traditional": "如坐針氈"
  },
  {
    "frequency": 1176,
    "simplified": "循循善诱",
    "traditional": "循循善誘"
  },
  {
    "frequency": 1176,
    "simplified": "张冠李戴",
    "traditional": "張冠李戴"
  },
  {
    "frequency": 1175,
    "simplified": "无声无息",
    "traditional": "無聲無息"
  },
  {
    "frequency": 1175,
    "simplified": "患得患失",
    "traditional": "患得患失"
  },
  {
    "frequency": 1173,
    "simplified": "政出多门",
    "traditional": "政出多門"
  },
  {
    "frequency": 1173,
    "simplified": "悠然自得",
    "traditional": "悠然自得"
  },
  {
    "frequency": 1172,
    "simplified": "自作聪明",
    "traditional": "自作聰明"
  },
  {
    "frequency": 1172,
    "simplified": "受宠若惊",
    "traditional": "受寵若驚"
  },
  {
    "frequency": 1172,
    "simplified": "临时抱佛脚",
    "traditional": "臨時抱佛腳"
  },
  {
    "frequency": 1171,
    "simplified": "唇齿相依",
    "traditional": "唇齒相依"
  },
  {
    "frequency": 1170,
    "simplified": "娇生惯养",
    "traditional": "嬌生慣養"
  },
  {
    "frequency": 1169,
    "simplified": "平淡无奇",
    "traditional": "平淡無奇"
  },
  {
    "frequency": 1168,
    "simplified": "八仙过海",
    "traditional": "八仙過海"
  },
  {
    "frequency": 1167,
    "simplified": "五光十色",
    "traditional": "五光十色"
  },
  {
    "frequency": 1165,
    "simplified": "与世长辞",
    "traditional": "與世長辭"
  },
  {
    "frequency": 1165,
    "simplified": "正襟危坐",
    "traditional": "正襟危坐"
  },
  {
    "frequency": 1165,
    "simplified": "尽人皆知",
    "traditional": "盡人皆知"
  },
  {
    "frequency": 1164,
    "simplified": "繁文缛节",
    "traditional": "繁文縟節"
  },
  {
    "frequency": 1160,
    "simplified": "吹毛求疵",
    "traditional": "吹毛求疵"
  },
  {
    "frequency": 1159,
    "simplified": "暗度陈仓",
    "traditional": "暗度陳倉"
  },
  {
    "frequency": 1157,
    "simplified": "克己奉公",
    "traditional": "克己奉公"
  },
  {
    "frequency": 1156,
    "simplified": "遮天蔽日",
    "traditional": "遮天蔽日"
  },
  {
    "frequency": 1155,
    "simplified": "大千世界",
    "traditional": "大千世界"
  },
  {
    "frequency": 1155,
    "simplified": "倒行逆施",
    "traditional": "倒行逆施"
  },
  {
    "frequency": 1154,
    "simplified": "因循守旧",
    "traditional": "因循守舊"
  },
  {
    "frequency": 1154,
    "simplified": "一面之词",
    "traditional": "一面之詞"
  },
  {
    "frequency": 1154,
    "simplified": "滴水不漏",
    "traditional": "滴水不漏"
  },
  {
    "frequency": 1153,
    "simplified": "暴涨暴跌",
    "traditional": "暴漲暴跌"
  },
  {
    "frequency": 1151,
    "simplified": "非此即彼",
    "traditional": "非此即彼"
  },
  {
    "frequency": 1150,
    "simplified": "万人空巷",
    "traditional": "萬人空巷"
  },
  {
    "frequency": 1149,
    "simplified": "一棍子打死",
    "traditional": "一棍子打死"
  },
  {
    "frequency": 1148,
    "simplified": "兼收并蓄",
    "traditional": "兼收並蓄"
  },
  {
    "frequency": 1148,
    "simplified": "不同凡响",
    "traditional": "不同凡響"
  },
  {
    "frequency": 1147,
    "simplified": "生死攸关",
    "traditional": "生死攸關"
  },
  {
    "frequency": 1146,
    "simplified": "垂涎欲滴",
    "traditional": "垂涎欲滴"
  },
  {
    "frequency": 1146,
    "simplified": "瞻前顾后",
    "traditional": "瞻前顧後"
  },
  {
    "frequency": 1146,
    "simplified": "推而广之",
    "traditional": "推而廣之"
  },
  {
    "frequency": 1145,
    "simplified": "自投罗网",
    "traditional": "自投羅網"
  },
  {
    "frequency": 1143,
    "simplified": "高风亮节",
    "traditional": "高風亮節"
  },
  {
    "frequency": 1143,
    "simplified": "扶摇直上",
    "traditional": "扶搖直上"
  },
  {
    "frequency": 1141,
    "simplified": "平分秋色",
    "traditional": "平分秋色"
  },
  {
    "frequency": 1140,
    "simplified": "一诺千金",
    "traditional": "一諾千金"
  },
  {
    "frequency": 1139,
    "simplified": "自行其是",
    "traditional": "自行其是"
  },
  {
    "frequency": 1139,
    "simplified": "顾虑重重",
    "traditional": "顧慮重重"
  },
  {
    "frequency": 1137,
    "simplified": "窗明几净",
    "traditional": "窗明几淨"
  },
  {
    "frequency": 1137,
    "simplified": "开源节流",
    "traditional": "開源節流"
  },
  {
    "frequency": 1136,
    "simplified": "唉声叹气",
    "traditional": "唉聲嘆氣"
  },
  {
    "frequency": 1136,
    "simplified": "量入为出",
    "traditional": "量入為出"
  },
  {
    "frequency": 1135,
    "simplified": "随行就市",
    "traditional": "隨行就市"
  },
  {
    "frequency": 1133,
    "simplified": "一飞冲天",
    "traditional": "一飛沖天"
  },
  {
    "frequency": 1131,
    "simplified": "因小失大",
    "traditional": "因小失大"
  },
  {
    "frequency": 1130,
    "simplified": "落叶归根",
    "traditional": "落葉歸根"
  },
  {
    "frequency": 1130,
    "simplified": "分秒必争",
    "traditional": "分秒必爭"
  },
  {
    "frequency": 1130,
    "simplified": "面面相觑",
    "traditional": "面面相覷"
  },
  {
    "frequency": 1130,
    "simplified": "屡战屡败",
    "traditional": "屢戰屢敗"
  },
  {
    "frequency": 1129,
    "simplified": "深更半夜",
    "traditional": "深更半夜"
  },
  {
    "frequency": 1129,
    "simplified": "坐以待毙",
    "traditional": "坐以待斃"
  },
  {
    "frequency": 1127,
    "simplified": "视若无睹",
    "traditional": "視若無睹"
  },
  {
    "frequency": 1125,
    "simplified": "巍然屹立",
    "traditional": "巍然屹立"
  },
  {
    "frequency": 1124,
    "simplified": "节节败退",
    "traditional": "節節敗退"
  },
  {
    "frequency": 1124,
    "simplified": "鼓足干劲",
    "traditional": "鼓足幹勁"
  },
  {
    "frequency": 1123,
    "simplified": "鸦雀无声",
    "traditional": "鴉雀無聲"
  },
  {
    "frequency": 1123,
    "simplified": "亭亭玉立",
    "traditional": "亭亭玉立"
  },
  {
    "frequency": 1122,
    "simplified": "以小见大",
    "traditional": "以小見大"
  },
  {
    "frequency": 1122,
    "simplified": "焦躁不安",
    "traditional": "焦躁不安"
  },
  {
    "frequency": 1122,
    "simplified": "去伪存真",
    "traditional": "去偽存真"
  },
  {
    "frequency": 1121,
    "simplified": "短兵相接",
    "traditional": "短兵相接"
  },
  {
    "frequency": 1121,
    "simplified": "琴棋书画",
    "traditional": "琴棋書畫"
  },
  {
    "frequency": 1121,
    "simplified": "兴师动众",
    "traditional": "興師動眾"
  },
  {
    "frequency": 1121,
    "simplified": "千夫所指",
    "traditional": "千夫所指"
  },
  {
    "frequency": 1119,
    "simplified": "风云突变",
    "traditional": "風雲突變"
  },
  {
    "frequency": 1117,
    "simplified": "如饥似渴",
    "traditional": "如飢似渴"
  },
  {
    "frequency": 1116,
    "simplified": "有气无力",
    "traditional": "有氣無力"
  },
  {
    "frequency": 1116,
    "simplified": "广开言路",
    "traditional": "廣開言路"
  },
  {
    "frequency": 1115,
    "simplified": "威风凛凛",
    "traditional": "威風凜凜"
  },
  {
    "frequency": 1113,
    "simplified": "露出马脚",
    "traditional": "露出馬腳"
  },
  {
    "frequency": 1112,
    "simplified": "百年之后",
    "traditional": "百年之後"
  },
  {
    "frequency": 1111,
    "simplified": "四脚朝天",
    "traditional": "四腳朝天"
  },
  {
    "frequency": 1110,
    "simplified": "见利忘义",
    "traditional": "見利忘義"
  },
  {
    "frequency": 1110,
    "simplified": "捧腹大笑",
    "traditional": "捧腹大笑"
  },
  {
    "frequency": 1108,
    "simplified": "不胜其烦",
    "traditional": "不勝其煩"
  },
  {
    "frequency": 1107,
    "simplified": "出生入死",
    "traditional": "出生入死"
  },
  {
    "frequency": 1106,
    "simplified": "休戚相关",
    "traditional": "休慼相關"
  },
  {
    "frequency": 1106,
    "simplified": "各就各位",
    "traditional": "各就各位"
  },
  {
    "frequency": 1104,
    "simplified": "炉火纯青",
    "traditional": "爐火純青"
  },
  {
    "frequency": 1104,
    "simplified": "浅尝辄止",
    "traditional": "淺嘗輒止"
  },
  {
    "frequency": 1103,
    "simplified": "身强力壮",
    "traditional": "身強力壯"
  },
  {
    "frequency": 1102,
    "simplified": "五脏六腑",
    "traditional": "五臟六腑"
  },
  {
    "frequency": 1101,
    "simplified": "贪官污吏",
    "traditional": "貪官汙吏"
  },
  {
    "frequency": 1100,
    "simplified": "破釜沉舟",
    "traditional": "破釜沉舟"
  },
  {
    "frequency": 1099,
    "simplified": "好逸恶劳",
    "traditional": "好逸惡勞"
  },
  {
    "frequency": 1099,
    "simplified": "罪有应得",
    "traditional": "罪有應得"
  },
  {
    "frequency": 1099,
    "simplified": "庐山真面目",
    "traditional": "廬山真面目"
  },
  {
    "frequency": 1098,
    "simplified": "年轻力壮",
    "traditional": "年輕力壯"
  },
  {
    "frequency": 1098,
    "simplified": "三十而立",
    "traditional": "三十而立"
  },
  {
    "frequency": 1096,
    "simplified": "举棋不定",
    "traditional": "舉棋不定"
  },
  {
    "frequency": 1096,
    "simplified": "郁郁寡欢",
    "traditional": "鬱鬱寡歡"
  },
  {
    "frequency": 1096,
    "simplified": "纠缠不清",
    "traditional": "糾纏不清"
  },
  {
    "frequency": 1095,
    "simplified": "吞云吐雾",
    "traditional": "吞雲吐霧"
  },
  {
    "frequency": 1094,
    "simplified": "明哲保身",
    "traditional": "明哲保身"
  },
  {
    "frequency": 1094,
    "simplified": "抛砖引玉",
    "traditional": "拋磚引玉"
  },
  {
    "frequency": 1090,
    "simplified": "双喜临门",
    "traditional": "雙喜臨門"
  },
  {
    "frequency": 1090,
    "simplified": "大红大紫",
    "traditional": "大紅大紫"
  },
  {
    "frequency": 1090,
    "simplified": "历久弥坚",
    "traditional": "歷久彌堅"
  },
  {
    "frequency": 1090,
    "simplified": "有苦难言",
    "traditional": "有苦難言"
  },
  {
    "frequency": 1089,
    "simplified": "望眼欲穿",
    "traditional": "望眼欲穿"
  },
  {
    "frequency": 1089,
    "simplified": "捷足先登",
    "traditional": "捷足先登"
  },
  {
    "frequency": 1088,
    "simplified": "出于无奈",
    "traditional": "出於無奈"
  },
  {
    "frequency": 1087,
    "simplified": "鞭长莫及",
    "traditional": "鞭長莫及"
  },
  {
    "frequency": 1085,
    "simplified": "平心静气",
    "traditional": "平心靜氣"
  },
  {
    "frequency": 1084,
    "simplified": "含苞待放",
    "traditional": "含苞待放"
  },
  {
    "frequency": 1084,
    "simplified": "如梦初醒",
    "traditional": "如夢初醒"
  },
  {
    "frequency": 1082,
    "simplified": "谢天谢地",
    "traditional": "謝天謝地"
  },
  {
    "frequency": 1082,
    "simplified": "称兄道弟",
    "traditional": "稱兄道弟"
  },
  {
    "frequency": 1082,
    "simplified": "马到成功",
    "traditional": "馬到成功"
  },
  {
    "frequency": 1081,
    "simplified": "骨瘦如柴",
    "traditional": "骨瘦如柴"
  },
  {
    "frequency": 1081,
    "simplified": "开弓没有回头箭",
    "traditional": "開弓沒有回頭箭"
  },
  {
    "frequency": 1081,
    "simplified": "辗转反侧",
    "traditional": "輾轉反側"
  },
  {
    "frequency": 1081,
    "simplified": "千锤百炼",
    "traditional": "千錘百煉"
  },
  {
    "frequency": 1081,
    "simplified": "春寒料峭",
    "traditional": "春寒料峭"
  },
  {
    "frequency": 1080,
    "simplified": "归心似箭",
    "traditional": "歸心似箭"
  },
  {
    "frequency": 1079,
    "simplified": "痛改前非",
    "traditional": "痛改前非"
  },
  {
    "frequency": 1078,
    "simplified": "四面楚歌",
    "traditional": "四面楚歌"
  },
  {
    "frequency": 1077,
    "simplified": "生离死别",
    "traditional": "生離死別"
  },
  {
    "frequency": 1076,
    "simplified": "良师益友",
    "traditional": "良師益友"
  },
  {
    "frequency": 1075,
    "simplified": "己所不欲",
    "traditional": "己所不欲"
  },
  {
    "frequency": 1075,
    "simplified": "后继无人",
    "traditional": "後繼無人"
  },
  {
    "frequency": 1074,
    "simplified": "蓬头垢面",
    "traditional": "蓬頭垢面"
  },
  {
    "frequency": 1074,
    "simplified": "土崩瓦解",
    "traditional": "土崩瓦解"
  },
  {
    "frequency": 1073,
    "simplified": "鼎力相助",
    "traditional": "鼎力相助"
  },
  {
    "frequency": 1073,
    "simplified": "在所不惜",
    "traditional": "在所不惜"
  },
  {
    "frequency": 1073,
    "simplified": "化为泡影",
    "traditional": "化為泡影"
  },
  {
    "frequency": 1073,
    "simplified": "上下一心",
    "traditional": "上下一心"
  },
  {
    "frequency": 1072,
    "simplified": "杀人灭口",
    "traditional": "殺人滅口"
  },
  {
    "frequency": 1071,
    "simplified": "不苟言笑",
    "traditional": "不苟言笑"
  },
  {
    "frequency": 1071,
    "simplified": "垂头丧气",
    "traditional": "垂頭喪氣"
  },
  {
    "frequency": 1071,
    "simplified": "眼疾手快",
    "traditional": "眼疾手快"
  },
  {
    "frequency": 1070,
    "simplified": "勿施于人",
    "traditional": "勿施於人"
  },
  {
    "frequency": 1068,
    "simplified": "海市蜃楼",
    "traditional": "海市蜃樓"
  },
  {
    "frequency": 1067,
    "simplified": "好高骛远",
    "traditional": "好高騖遠"
  },
  {
    "frequency": 1066,
    "simplified": "一笑了之",
    "traditional": "一笑了之"
  },
  {
    "frequency": 1064,
    "simplified": "气壮山河",
    "traditional": "氣壯山河"
  },
  {
    "frequency": 1063,
    "simplified": "非同小可",
    "traditional": "非同小可"
  },
  {
    "frequency": 1063,
    "simplified": "笑逐颜开",
    "traditional": "笑逐顏開"
  },
  {
    "frequency": 1063,
    "simplified": "为非作歹",
    "traditional": "為非作歹"
  },
  {
    "frequency": 1062,
    "simplified": "言犹在耳",
    "traditional": "言猶在耳"
  },
  {
    "frequency": 1061,
    "simplified": "高谈阔论",
    "traditional": "高談闊論"
  },
  {
    "frequency": 1058,
    "simplified": "素昧平生",
    "traditional": "素昧平生"
  },
  {
    "frequency": 1058,
    "simplified": "由浅入深",
    "traditional": "由淺入深"
  },
  {
    "frequency": 1058,
    "simplified": "讳疾忌医",
    "traditional": "諱疾忌醫"
  },
  {
    "frequency": 1058,
    "simplified": "知易行难",
    "traditional": "知易行難"
  },
  {
    "frequency": 1056,
    "simplified": "信口开河",
    "traditional": "信口開河"
  },
  {
    "frequency": 1056,
    "simplified": "十字路口",
    "traditional": "十字路口"
  },
  {
    "frequency": 1055,
    "simplified": "旗鼓相当",
    "traditional": "旗鼓相當"
  },
  {
    "frequency": 1054,
    "simplified": "装聋作哑",
    "traditional": "裝聾作啞"
  },
  {
    "frequency": 1053,
    "simplified": "分庭抗礼",
    "traditional": "分庭抗禮"
  },
  {
    "frequency": 1053,
    "simplified": "门当户对",
    "traditional": "門當戶對"
  },
  {
    "frequency": 1053,
    "simplified": "劈头盖脸",
    "traditional": "劈頭蓋臉"
  },
  {
    "frequency": 1052,
    "simplified": "冒天下之大不韪",
    "traditional": "冒天下之大不韙"
  },
  {
    "frequency": 1052,
    "simplified": "独具一格",
    "traditional": "獨具一格"
  },
  {
    "frequency": 1052,
    "simplified": "无价之宝",
    "traditional": "無價之寶"
  },
  {
    "frequency": 1051,
    "simplified": "忍辱负重",
    "traditional": "忍辱負重"
  },
  {
    "frequency": 1051,
    "simplified": "政通人和",
    "traditional": "政通人和"
  },
  {
    "frequency": 1050,
    "simplified": "唾手可得",
    "traditional": "唾手可得"
  },
  {
    "frequency": 1049,
    "simplified": "乔装打扮",
    "traditional": "喬裝打扮"
  },
  {
    "frequency": 1049,
    "simplified": "峥嵘岁月",
    "traditional": "崢嶸歲月"
  },
  {
    "frequency": 1048,
    "simplified": "天网恢恢",
    "traditional": "天網恢恢"
  },
  {
    "frequency": 1046,
    "simplified": "高山流水",
    "traditional": "高山流水"
  },
  {
    "frequency": 1045,
    "simplified": "言听计从",
    "traditional": "言聽計從"
  },
  {
    "frequency": 1045,
    "simplified": "难以挽回",
    "traditional": "難以挽回"
  },
  {
    "frequency": 1045,
    "simplified": "非比寻常",
    "traditional": "非比尋常"
  },
  {
    "frequency": 1044,
    "simplified": "不声不响",
    "traditional": "不聲不響"
  },
  {
    "frequency": 1043,
    "simplified": "春光明媚",
    "traditional": "春光明媚"
  },
  {
    "frequency": 1042,
    "simplified": "自私自利",
    "traditional": "自私自利"
  },
  {
    "frequency": 1042,
    "simplified": "付诸东流",
    "traditional": "付諸東流"
  },
  {
    "frequency": 1041,
    "simplified": "心烦意乱",
    "traditional": "心煩意亂"
  },
  {
    "frequency": 1041,
    "simplified": "快人快语",
    "traditional": "快人快語"
  },
  {
    "frequency": 1040,
    "simplified": "画龙点睛",
    "traditional": "畫龍點睛"
  },
  {
    "frequency": 1040,
    "simplified": "胡思乱想",
    "traditional": "胡思亂想"
  },
  {
    "frequency": 1039,
    "simplified": "歪门邪道",
    "traditional": "歪門邪道"
  },
  {
    "frequency": 1037,
    "simplified": "引火烧身",
    "traditional": "引火燒身"
  },
  {
    "frequency": 1037,
    "simplified": "竭泽而渔",
    "traditional": "竭澤而漁"
  },
  {
    "frequency": 1037,
    "simplified": "弱肉强食",
    "traditional": "弱肉強食"
  },
  {
    "frequency": 1036,
    "simplified": "寸草不生",
    "traditional": "寸草不生"
  },
  {
    "frequency": 1036,
    "simplified": "明争暗斗",
    "traditional": "明爭暗鬥"
  },
  {
    "frequency": 1035,
    "simplified": "私相授受",
    "traditional": "私相授受"
  },
  {
    "frequency": 1034,
    "simplified": "堂堂正正",
    "traditional": "堂堂正正"
  },
  {
    "frequency": 1033,
    "simplified": "治国安邦",
    "traditional": "治國安邦"
  },
  {
    "frequency": 1033,
    "simplified": "同流合污",
    "traditional": "同流合汙"
  },
  {
    "frequency": 1032,
    "simplified": "畅行无阻",
    "traditional": "暢行無阻"
  },
  {
    "frequency": 1030,
    "simplified": "立足之地",
    "traditional": "立足之地"
  },
  {
    "frequency": 1030,
    "simplified": "凶多吉少",
    "traditional": "凶多吉少"
  },
  {
    "frequency": 1030,
    "simplified": "一文不值",
    "traditional": "一文不值"
  },
  {
    "frequency": 1029,
    "simplified": "逐字逐句",
    "traditional": "逐字逐句"
  },
  {
    "frequency": 1028,
    "simplified": "万象更新",
    "traditional": "萬象更新"
  },
  {
    "frequency": 1028,
    "simplified": "费尽心机",
    "traditional": "費盡心機"
  },
  {
    "frequency": 1027,
    "simplified": "铩羽而归",
    "traditional": "鎩羽而歸"
  },
  {
    "frequency": 1027,
    "simplified": "不足为怪",
    "traditional": "不足為怪"
  },
  {
    "frequency": 1027,
    "simplified": "从中渔利",
    "traditional": "從中漁利"
  },
  {
    "frequency": 1025,
    "simplified": "微言大义",
    "traditional": "微言大義"
  },
  {
    "frequency": 1025,
    "simplified": "眉飞色舞",
    "traditional": "眉飛色舞"
  },
  {
    "frequency": 1023,
    "simplified": "做贼心虚",
    "traditional": "做賊心虛"
  },
  {
    "frequency": 1023,
    "simplified": "连绵不断",
    "traditional": "連綿不斷"
  },
  {
    "frequency": 1022,
    "simplified": "匹夫有责",
    "traditional": "匹夫有責"
  },
  {
    "frequency": 1022,
    "simplified": "重于泰山",
    "traditional": "重於泰山"
  },
  {
    "frequency": 1022,
    "simplified": "视死如归",
    "traditional": "視死如歸"
  },
  {
    "frequency": 1021,
    "simplified": "不怀好意",
    "traditional": "不懷好意"
  },
  {
    "frequency": 1019,
    "simplified": "入木三分",
    "traditional": "入木三分"
  },
  {
    "frequency": 1019,
    "simplified": "忘乎所以",
    "traditional": "忘乎所以"
  },
  {
    "frequency": 1019,
    "simplified": "众人拾柴火焰高",
    "traditional": "眾人拾柴火焰高"
  },
  {
    "frequency": 1017,
    "simplified": "扫地出门",
    "traditional": "掃地出門"
  },
  {
    "frequency": 1016,
    "simplified": "一而再再而三",
    "traditional": "一而再再而三"
  },
  {
    "frequency": 1015,
    "simplified": "老调重弹",
    "traditional": "老調重彈"
  },
  {
    "frequency": 1014,
    "simplified": "授业解惑",
    "traditional": "授業解惑"
  },
  {
    "frequency": 1014,
    "simplified": "一股脑儿",
    "traditional": "一股腦兒"
  },
  {
    "frequency": 1013,
    "simplified": "多事之秋",
    "traditional": "多事之秋"
  },
  {
    "frequency": 1013,
    "simplified": "短小精悍",
    "traditional": "短小精悍"
  },
  {
    "frequency": 1013,
    "simplified": "碌碌无为",
    "traditional": "碌碌無為"
  },
  {
    "frequency": 1012,
    "simplified": "痴人说梦",
    "traditional": "痴人說夢"
  },
  {
    "frequency": 1012,
    "simplified": "擅离职守",
    "traditional": "擅離職守"
  },
  {
    "frequency": 1012,
    "simplified": "无关痛痒",
    "traditional": "無關痛癢"
  },
  {
    "frequency": 1012,
    "simplified": "劫后余生",
    "traditional": "劫後餘生"
  },
  {
    "frequency": 1011,
    "simplified": "抑扬顿挫",
    "traditional": "抑揚頓挫"
  },
  {
    "frequency": 1010,
    "simplified": "不可限量",
    "traditional": "不可限量"
  },
  {
    "frequency": 1010,
    "simplified": "掌上明珠",
    "traditional": "掌上明珠"
  },
  {
    "frequency": 1009,
    "simplified": "大处着眼",
    "traditional": "大處著眼"
  },
  {
    "frequency": 1009,
    "simplified": "岿然不动",
    "traditional": "巋然不動"
  },
  {
    "frequency": 1009,
    "simplified": "水漫金山",
    "traditional": "水漫金山"
  },
  {
    "frequency": 1008,
    "simplified": "牵肠挂肚",
    "traditional": "牽腸掛肚"
  },
  {
    "frequency": 1007,
    "simplified": "登峰造极",
    "traditional": "登峰造極"
  },
  {
    "frequency": 1006,
    "simplified": "度日如年",
    "traditional": "度日如年"
  },
  {
    "frequency": 1005,
    "simplified": "浩如烟海",
    "traditional": "浩如煙海"
  },
  {
    "frequency": 1005,
    "simplified": "大公无私",
    "traditional": "大公無私"
  },
  {
    "frequency": 1004,
    "simplified": "别有洞天",
    "traditional": "別有洞天"
  },
  {
    "frequency": 1003,
    "simplified": "变化多端",
    "traditional": "變化多端"
  },
  {
    "frequency": 1002,
    "simplified": "霸王别姬",
    "traditional": "霸王別姬"
  },
  {
    "frequency": 1001,
    "simplified": "字正腔圆",
    "traditional": "字正腔圓"
  },
  {
    "frequency": 1000,
    "simplified": "天旋地转",
    "traditional": "天旋地轉"
  },
  {
    "frequency": 999,
    "simplified": "后事之师",
    "traditional": "後事之師"
  },
  {
    "frequency": 998,
    "simplified": "防患未然",
    "traditional": "防患未然"
  },
  {
    "frequency": 998,
    "simplified": "九死一生",
    "traditional": "九死一生"
  },
  {
    "frequency": 998,
    "simplified": "惊世骇俗",
    "traditional": "驚世駭俗"
  },
  {
    "frequency": 997,
    "simplified": "放下包袱",
    "traditional": "放下包袱"
  },
  {
    "frequency": 997,
    "simplified": "药到病除",
    "traditional": "藥到病除"
  },
  {
    "frequency": 996,
    "simplified": "曲径通幽",
    "traditional": "曲徑通幽"
  },
  {
    "frequency": 996,
    "simplified": "一波未平一波又起",
    "traditional": "一波未平一波又起"
  },
  {
    "frequency": 996,
    "simplified": "半路出家",
    "traditional": "半路出家"
  },
  {
    "frequency": 995,
    "simplified": "芸芸众生",
    "traditional": "芸芸眾生"
  },
  {
    "frequency": 995,
    "simplified": "反复推敲",
    "traditional": "反覆推敲"
  },
  {
    "frequency": 994,
    "simplified": "生龙活虎",
    "traditional": "生龍活虎"
  },
  {
    "frequency": 993,
    "simplified": "登堂入室",
    "traditional": "登堂入室"
  },
  {
    "frequency": 993,
    "simplified": "一马平川",
    "traditional": "一馬平川"
  },
  {
    "frequency": 992,
    "simplified": "踉踉跄跄",
    "traditional": "踉踉蹌蹌"
  },
  {
    "frequency": 992,
    "simplified": "民办公助",
    "traditional": "民辦公助"
  },
  {
    "frequency": 991,
    "simplified": "大难不死",
    "traditional": "大難不死"
  },
  {
    "frequency": 991,
    "simplified": "一本万利",
    "traditional": "一本萬利"
  },
  {
    "frequency": 991,
    "simplified": "心悦诚服",
    "traditional": "心悅誠服"
  },
  {
    "frequency": 990,
    "simplified": "人间天堂",
    "traditional": "人間天堂"
  },
  {
    "frequency": 988,
    "simplified": "野心勃勃",
    "traditional": "野心勃勃"
  },
  {
    "frequency": 987,
    "simplified": "斗志昂扬",
    "traditional": "鬥志昂揚"
  },
  {
    "frequency": 987,
    "simplified": "假公济私",
    "traditional": "假公濟私"
  },
  {
    "frequency": 986,
    "simplified": "一饮而尽",
    "traditional": "一飲而盡"
  },
  {
    "frequency": 986,
    "simplified": "春华秋实",
    "traditional": "春華秋實"
  },
  {
    "frequency": 986,
    "simplified": "后患无穷",
    "traditional": "後患無窮"
  },
  {
    "frequency": 986,
    "simplified": "独来独往",
    "traditional": "獨來獨往"
  },
  {
    "frequency": 986,
    "simplified": "不可偏废",
    "traditional": "不可偏廢"
  },
  {
    "frequency": 985,
    "simplified": "阳春白雪",
    "traditional": "陽春白雪"
  },
  {
    "frequency": 985,
    "simplified": "旁征博引",
    "traditional": "旁徵博引"
  },
  {
    "frequency": 985,
    "simplified": "九牛二虎之力",
    "traditional": "九牛二虎之力"
  },
  {
    "frequency": 984,
    "simplified": "一年半载",
    "traditional": "一年半載"
  },
  {
    "frequency": 983,
    "simplified": "饥寒交迫",
    "traditional": "飢寒交迫"
  },
  {
    "frequency": 983,
    "simplified": "欺上瞒下",
    "traditional": "欺上瞞下"
  },
  {
    "frequency": 983,
    "simplified": "骑虎难下",
    "traditional": "騎虎難下"
  },
  {
    "frequency": 983,
    "simplified": "装模作样",
    "traditional": "裝模作樣"
  },
  {
    "frequency": 983,
    "simplified": "举目无亲",
    "traditional": "舉目無親"
  },
  {
    "frequency": 981,
    "simplified": "挥金如土",
    "traditional": "揮金如土"
  },
  {
    "frequency": 980,
    "simplified": "畏首畏尾",
    "traditional": "畏首畏尾"
  },
  {
    "frequency": 980,
    "simplified": "无地自容",
    "traditional": "無地自容"
  },
  {
    "frequency": 980,
    "simplified": "投桃报李",
    "traditional": "投桃報李"
  },
  {
    "frequency": 979,
    "simplified": "原形毕露",
    "traditional": "原形畢露"
  },
  {
    "frequency": 979,
    "simplified": "眼高手低",
    "traditional": "眼高手低"
  },
  {
    "frequency": 979,
    "simplified": "断壁残垣",
    "traditional": "斷壁殘垣"
  },
  {
    "frequency": 978,
    "simplified": "天之骄子",
    "traditional": "天之驕子"
  },
  {
    "frequency": 977,
    "simplified": "欲盖弥彰",
    "traditional": "欲蓋彌彰"
  },
  {
    "frequency": 976,
    "simplified": "栋梁之才",
    "traditional": "棟梁之才"
  },
  {
    "frequency": 976,
    "simplified": "肆意妄为",
    "traditional": "肆意妄為"
  },
  {
    "frequency": 975,
    "simplified": "强词夺理",
    "traditional": "強詞奪理"
  },
  {
    "frequency": 975,
    "simplified": "仁者见仁",
    "traditional": "仁者見仁"
  },
  {
    "frequency": 975,
    "simplified": "不二法门",
    "traditional": "不二法門"
  },
  {
    "frequency": 974,
    "simplified": "损人利己",
    "traditional": "損人利己"
  },
  {
    "frequency": 974,
    "simplified": "厚此薄彼",
    "traditional": "厚此薄彼"
  },
  {
    "frequency": 974,
    "simplified": "内外交困",
    "traditional": "內外交困"
  },
  {
    "frequency": 972,
    "simplified": "以邻为壑",
    "traditional": "以鄰為壑"
  },
  {
    "frequency": 972,
    "simplified": "郑重其事",
    "traditional": "鄭重其事"
  },
  {
    "frequency": 969,
    "simplified": "可怜天下父母心",
    "traditional": "可憐天下父母心"
  },
  {
    "frequency": 969,
    "simplified": "生存技能",
    "traditional": "生存技能"
  },
  {
    "frequency": 968,
    "simplified": "光怪陆离",
    "traditional": "光怪陸離"
  },
  {
    "frequency": 967,
    "simplified": "恶意中伤",
    "traditional": "惡意中傷"
  },
  {
    "frequency": 967,
    "simplified": "天上人间",
    "traditional": "天上人間"
  },
  {
    "frequency": 966,
    "simplified": "精诚团结",
    "traditional": "精誠團結"
  },
  {
    "frequency": 965,
    "simplified": "夙夜在公",
    "traditional": "夙夜在公"
  },
  {
    "frequency": 965,
    "simplified": "盗墓笔记",
    "traditional": "盜墓筆記"
  },
  {
    "frequency": 963,
    "simplified": "访贫问苦",
    "traditional": "訪貧問苦"
  },
  {
    "frequency": 963,
    "simplified": "有生力量",
    "traditional": "有生力量"
  },
  {
    "frequency": 963,
    "simplified": "一锤子买卖",
    "traditional": "一錘子買賣"
  },
  {
    "frequency": 962,
    "simplified": "过目不忘",
    "traditional": "過目不忘"
  },
  {
    "frequency": 962,
    "simplified": "近水楼台先得月",
    "traditional": "近水樓臺先得月"
  },
  {
    "frequency": 961,
    "simplified": "喧宾夺主",
    "traditional": "喧賓奪主"
  },
  {
    "frequency": 961,
    "simplified": "病从口入",
    "traditional": "病從口入"
  },
  {
    "frequency": 961,
    "simplified": "懵懵懂懂",
    "traditional": "懵懵懂懂"
  },
  {
    "frequency": 958,
    "simplified": "旧病复发",
    "traditional": "舊病復發"
  },
  {
    "frequency": 958,
    "simplified": "深谋远虑",
    "traditional": "深謀遠慮"
  },
  {
    "frequency": 957,
    "simplified": "花好月圆",
    "traditional": "花好月圓"
  },
  {
    "frequency": 957,
    "simplified": "不知所云",
    "traditional": "不知所云"
  },
  {
    "frequency": 956,
    "simplified": "交头接耳",
    "traditional": "交頭接耳"
  },
  {
    "frequency": 953,
    "simplified": "出神入化",
    "traditional": "出神入化"
  },
  {
    "frequency": 953,
    "simplified": "强加于人",
    "traditional": "強加於人"
  },
  {
    "frequency": 953,
    "simplified": "春风得意",
    "traditional": "春風得意"
  },
  {
    "frequency": 953,
    "simplified": "颐指气使",
    "traditional": "頤指氣使"
  },
  {
    "frequency": 952,
    "simplified": "陈词滥调",
    "traditional": "陳詞濫調"
  },
  {
    "frequency": 952,
    "simplified": "东奔西走",
    "traditional": "東奔西走"
  },
  {
    "frequency": 951,
    "simplified": "穷困潦倒",
    "traditional": "窮困潦倒"
  },
  {
    "frequency": 951,
    "simplified": "不可一世",
    "traditional": "不可一世"
  },
  {
    "frequency": 951,
    "simplified": "神乎其神",
    "traditional": "神乎其神"
  },
  {
    "frequency": 950,
    "simplified": "抚今追昔",
    "traditional": "撫今追昔"
  },
  {
    "frequency": 948,
    "simplified": "长袖善舞",
    "traditional": "長袖善舞"
  },
  {
    "frequency": 947,
    "simplified": "表里如一",
    "traditional": "表裡如一"
  },
  {
    "frequency": 947,
    "simplified": "寅吃卯粮",
    "traditional": "寅吃卯糧"
  },
  {
    "frequency": 946,
    "simplified": "例行公事",
    "traditional": "例行公事"
  },
  {
    "frequency": 946,
    "simplified": "寒冬腊月",
    "traditional": "寒冬臘月"
  },
  {
    "frequency": 945,
    "simplified": "刨根问底",
    "traditional": "刨根問底"
  },
  {
    "frequency": 944,
    "simplified": "自得其乐",
    "traditional": "自得其樂"
  },
  {
    "frequency": 944,
    "simplified": "捏一把汗",
    "traditional": "捏一把汗"
  },
  {
    "frequency": 943,
    "simplified": "六神无主",
    "traditional": "六神無主"
  },
  {
    "frequency": 943,
    "simplified": "躲躲闪闪",
    "traditional": "躲躲閃閃"
  },
  {
    "frequency": 942,
    "simplified": "半夜三更",
    "traditional": "半夜三更"
  },
  {
    "frequency": 941,
    "simplified": "冷眼旁观",
    "traditional": "冷眼旁觀"
  },
  {
    "frequency": 941,
    "simplified": "勃然大怒",
    "traditional": "勃然大怒"
  },
  {
    "frequency": 941,
    "simplified": "先声夺人",
    "traditional": "先聲奪人"
  },
  {
    "frequency": 941,
    "simplified": "人多势众",
    "traditional": "人多勢眾"
  },
  {
    "frequency": 940,
    "simplified": "天长地久",
    "traditional": "天長地久"
  },
  {
    "frequency": 940,
    "simplified": "先斩后奏",
    "traditional": "先斬後奏"
  },
  {
    "frequency": 939,
    "simplified": "力排众议",
    "traditional": "力排眾議"
  },
  {
    "frequency": 936,
    "simplified": "穷途末路",
    "traditional": "窮途末路"
  },
  {
    "frequency": 935,
    "simplified": "机不可失",
    "traditional": "機不可失"
  },
  {
    "frequency": 934,
    "simplified": "听天由命",
    "traditional": "聽天由命"
  },
  {
    "frequency": 933,
    "simplified": "戒骄戒躁",
    "traditional": "戒驕戒躁"
  },
  {
    "frequency": 932,
    "simplified": "得寸进尺",
    "traditional": "得寸進尺"
  },
  {
    "frequency": 931,
    "simplified": "草木皆兵",
    "traditional": "草木皆兵"
  },
  {
    "frequency": 930,
    "simplified": "养老送终",
    "traditional": "養老送終"
  },
  {
    "frequency": 930,
    "simplified": "众口一词",
    "traditional": "眾口一詞"
  },
  {
    "frequency": 929,
    "simplified": "从长计议",
    "traditional": "從長計議"
  },
  {
    "frequency": 929,
    "simplified": "得意之作",
    "traditional": "得意之作"
  },
  {
    "frequency": 928,
    "simplified": "恨铁不成钢",
    "traditional": "恨鐵不成鋼"
  },
  {
    "frequency": 928,
    "simplified": "前事不忘",
    "traditional": "前事不忘"
  },
  {
    "frequency": 927,
    "simplified": "说一不二",
    "traditional": "說一不二"
  },
  {
    "frequency": 926,
    "simplified": "回天乏术",
    "traditional": "回天乏術"
  },
  {
    "frequency": 925,
    "simplified": "头晕眼花",
    "traditional": "頭暈眼花"
  },
  {
    "frequency": 924,
    "simplified": "地大物博",
    "traditional": "地大物博"
  },
  {
    "frequency": 923,
    "simplified": "慎终追远",
    "traditional": "慎終追遠"
  },
  {
    "frequency": 922,
    "simplified": "笑容可掬",
    "traditional": "笑容可掬"
  },
  {
    "frequency": 922,
    "simplified": "功德无量",
    "traditional": "功德無量"
  },
  {
    "frequency": 922,
    "simplified": "虚无缥缈",
    "traditional": "虛無縹緲"
  },
  {
    "frequency": 921,
    "simplified": "官官相护",
    "traditional": "官官相護"
  },
  {
    "frequency": 921,
    "simplified": "四平八稳",
    "traditional": "四平八穩"
  },
  {
    "frequency": 920,
    "simplified": "有生以来",
    "traditional": "有生以來"
  },
  {
    "frequency": 920,
    "simplified": "善罢甘休",
    "traditional": "善罷甘休"
  },
  {
    "frequency": 919,
    "simplified": "开疆拓土",
    "traditional": "開疆拓土"
  },
  {
    "frequency": 917,
    "simplified": "有则改之",
    "traditional": "有則改之"
  },
  {
    "frequency": 917,
    "simplified": "金蝉脱壳",
    "traditional": "金蟬脫殼"
  },
  {
    "frequency": 916,
    "simplified": "过五关斩六将",
    "traditional": "過五關斬六將"
  },
  {
    "frequency": 916,
    "simplified": "大言不惭",
    "traditional": "大言不慚"
  },
  {
    "frequency": 915,
    "simplified": "天真烂漫",
    "traditional": "天真爛漫"
  },
  {
    "frequency": 915,
    "simplified": "山穷水尽",
    "traditional": "山窮水盡"
  },
  {
    "frequency": 915,
    "simplified": "软弱无力",
    "traditional": "軟弱無力"
  },
  {
    "frequency": 914,
    "simplified": "丰衣足食",
    "traditional": "豐衣足食"
  },
  {
    "frequency": 914,
    "simplified": "荒无人烟",
    "traditional": "荒無人煙"
  },
  {
    "frequency": 913,
    "simplified": "概莫能外",
    "traditional": "概莫能外"
  },
  {
    "frequency": 913,
    "simplified": "爱莫能助",
    "traditional": "愛莫能助"
  },
  {
    "frequency": 912,
    "simplified": "忧国忧民",
    "traditional": "憂國憂民"
  },
  {
    "frequency": 911,
    "simplified": "咄咄怪事",
    "traditional": "咄咄怪事"
  },
  {
    "frequency": 911,
    "simplified": "一碗水端平",
    "traditional": "一碗水端平"
  },
  {
    "frequency": 911,
    "simplified": "璀璨夺目",
    "traditional": "璀璨奪目"
  },
  {
    "frequency": 911,
    "simplified": "暴风骤雨",
    "traditional": "暴風驟雨"
  },
  {
    "frequency": 910,
    "simplified": "说来说去",
    "traditional": "說來說去"
  },
  {
    "frequency": 910,
    "simplified": "感激不尽",
    "traditional": "感激不盡"
  },
  {
    "frequency": 909,
    "simplified": "血雨腥风",
    "traditional": "血雨腥風"
  },
  {
    "frequency": 909,
    "simplified": "始作俑者",
    "traditional": "始作俑者"
  },
  {
    "frequency": 907,
    "simplified": "醉翁之意不在酒",
    "traditional": "醉翁之意不在酒"
  },
  {
    "frequency": 906,
    "simplified": "张牙舞爪",
    "traditional": "張牙舞爪"
  },
  {
    "frequency": 906,
    "simplified": "丧尽天良",
    "traditional": "喪盡天良"
  },
  {
    "frequency": 906,
    "simplified": "望闻问切",
    "traditional": "望聞問切"
  },
  {
    "frequency": 905,
    "simplified": "夏日炎炎",
    "traditional": "夏日炎炎"
  },
  {
    "frequency": 905,
    "simplified": "自不待言",
    "traditional": "自不待言"
  },
  {
    "frequency": 905,
    "simplified": "崇洋媚外",
    "traditional": "崇洋媚外"
  },
  {
    "frequency": 903,
    "simplified": "升官发财",
    "traditional": "升官發財"
  },
  {
    "frequency": 901,
    "simplified": "平白无故",
    "traditional": "平白無故"
  },
  {
    "frequency": 901,
    "simplified": "兼容并包",
    "traditional": "兼容並包"
  },
  {
    "frequency": 900,
    "simplified": "心神不宁",
    "traditional": "心神不寧"
  },
  {
    "frequency": 900,
    "simplified": "不冷不热",
    "traditional": "不冷不熱"
  },
  {
    "frequency": 900,
    "simplified": "先天下之忧而忧",
    "traditional": "先天下之憂而憂"
  },
  {
    "frequency": 899,
    "simplified": "勉为其难",
    "traditional": "勉為其難"
  },
  {
    "frequency": 899,
    "simplified": "日夜兼程",
    "traditional": "日夜兼程"
  },
  {
    "frequency": 897,
    "simplified": "白发人送黑发人",
    "traditional": "白髮人送黑髮人"
  },
  {
    "frequency": 897,
    "simplified": "连篇累牍",
    "traditional": "連篇累牘"
  },
  {
    "frequency": 897,
    "simplified": "纵横捭阖",
    "traditional": "縱橫捭闔"
  },
  {
    "frequency": 897,
    "simplified": "扶正祛邪",
    "traditional": "扶正祛邪"
  },
  {
    "frequency": 896,
    "simplified": "舍本逐末",
    "traditional": "捨本逐末"
  },
  {
    "frequency": 896,
    "simplified": "贪得无厌",
    "traditional": "貪得無厭"
  },
  {
    "frequency": 896,
    "simplified": "深居简出",
    "traditional": "深居簡出"
  },
  {
    "frequency": 895,
    "simplified": "浑浑噩噩",
    "traditional": "渾渾噩噩"
  },
  {
    "frequency": 894,
    "simplified": "另眼相看",
    "traditional": "另眼相看"
  },
  {
    "frequency": 893,
    "simplified": "酩酊大醉",
    "traditional": "酩酊大醉"
  },
  {
    "frequency": 893,
    "simplified": "沽名钓誉",
    "traditional": "沽名釣譽"
  },
  {
    "frequency": 893,
    "simplified": "反复无常",
    "traditional": "反覆無常"
  },
  {
    "frequency": 890,
    "simplified": "鹤立鸡群",
    "traditional": "鶴立雞群"
  },
  {
    "frequency": 890,
    "simplified": "求之不得",
    "traditional": "求之不得"
  },
  {
    "frequency": 887,
    "simplified": "当头棒喝",
    "traditional": "當頭棒喝"
  },
  {
    "frequency": 887,
    "simplified": "比翼齐飞",
    "traditional": "比翼齊飛"
  },
  {
    "frequency": 886,
    "simplified": "飞黄腾达",
    "traditional": "飛黃騰達"
  },
  {
    "frequency": 885,
    "simplified": "百尺竿头",
    "traditional": "百尺竿頭"
  },
  {
    "frequency": 884,
    "simplified": "惶恐不安",
    "traditional": "惶恐不安"
  },
  {
    "frequency": 884,
    "simplified": "知难而进",
    "traditional": "知難而進"
  },
  {
    "frequency": 883,
    "simplified": "口出狂言",
    "traditional": "口出狂言"
  },
  {
    "frequency": 883,
    "simplified": "伸手不见五指",
    "traditional": "伸手不見五指"
  },
  {
    "frequency": 881,
    "simplified": "杀鸡取卵",
    "traditional": "殺雞取卵"
  },
  {
    "frequency": 881,
    "simplified": "蜂拥而来",
    "traditional": "蜂擁而來"
  },
  {
    "frequency": 881,
    "simplified": "哭哭啼啼",
    "traditional": "哭哭啼啼"
  },
  {
    "frequency": 881,
    "simplified": "盛极一时",
    "traditional": "盛極一時"
  },
  {
    "frequency": 881,
    "simplified": "误打误撞",
    "traditional": "誤打誤撞"
  },
  {
    "frequency": 881,
    "simplified": "婀娜多姿",
    "traditional": "婀娜多姿"
  },
  {
    "frequency": 880,
    "simplified": "不食人间烟火",
    "traditional": "不食人間煙火"
  },
  {
    "frequency": 880,
    "simplified": "惶惶不可终日",
    "traditional": "惶惶不可終日"
  },
  {
    "frequency": 880,
    "simplified": "气定神闲",
    "traditional": "氣定神閒"
  },
  {
    "frequency": 879,
    "simplified": "死去活来",
    "traditional": "死去活來"
  },
  {
    "frequency": 879,
    "simplified": "经年累月",
    "traditional": "經年累月"
  },
  {
    "frequency": 878,
    "simplified": "齐心合力",
    "traditional": "齊心合力"
  },
  {
    "frequency": 878,
    "simplified": "合纵连横",
    "traditional": "合縱連橫"
  },
  {
    "frequency": 878,
    "simplified": "耳闻目睹",
    "traditional": "耳聞目睹"
  },
  {
    "frequency": 877,
    "simplified": "驰名中外",
    "traditional": "馳名中外"
  },
  {
    "frequency": 877,
    "simplified": "嫌贫爱富",
    "traditional": "嫌貧愛富"
  },
  {
    "frequency": 877,
    "simplified": "宁缺毋滥",
    "traditional": "寧缺毋濫"
  },
  {
    "frequency": 876,
    "simplified": "心向往之",
    "traditional": "心嚮往之"
  },
  {
    "frequency": 875,
    "simplified": "心事重重",
    "traditional": "心事重重"
  },
  {
    "frequency": 875,
    "simplified": "付之东流",
    "traditional": "付之東流"
  },
  {
    "frequency": 875,
    "simplified": "恨之入骨",
    "traditional": "恨之入骨"
  },
  {
    "frequency": 874,
    "simplified": "弱不禁风",
    "traditional": "弱不禁風"
  },
  {
    "frequency": 873,
    "simplified": "悔不当初",
    "traditional": "悔不當初"
  },
  {
    "frequency": 873,
    "simplified": "高朋满座",
    "traditional": "高朋滿座"
  },
  {
    "frequency": 873,
    "simplified": "老无所依",
    "traditional": "老無所依"
  },
  {
    "frequency": 873,
    "simplified": "身怀六甲",
    "traditional": "身懷六甲"
  },
  {
    "frequency": 873,
    "simplified": "三百六十行",
    "traditional": "三百六十行"
  },
  {
    "frequency": 872,
    "simplified": "损人不利己",
    "traditional": "損人不利己"
  },
  {
    "frequency": 872,
    "simplified": "知足常乐",
    "traditional": "知足常樂"
  },
  {
    "frequency": 872,
    "simplified": "睡眼惺忪",
    "traditional": "睡眼惺忪"
  },
  {
    "frequency": 872,
    "simplified": "古为今用",
    "traditional": "古為今用"
  },
  {
    "frequency": 872,
    "simplified": "鼻青脸肿",
    "traditional": "鼻青臉腫"
  },
  {
    "frequency": 870,
    "simplified": "言行不一",
    "traditional": "言行不一"
  },
  {
    "frequency": 870,
    "simplified": "绿草如茵",
    "traditional": "綠草如茵"
  },
  {
    "frequency": 869,
    "simplified": "摇头晃脑",
    "traditional": "搖頭晃腦"
  },
  {
    "frequency": 869,
    "simplified": "崎岖不平",
    "traditional": "崎嶇不平"
  },
  {
    "frequency": 868,
    "simplified": "桃李满天下",
    "traditional": "桃李滿天下"
  },
  {
    "frequency": 868,
    "simplified": "各个击破",
    "traditional": "各個擊破"
  },
  {
    "frequency": 867,
    "simplified": "长篇大论",
    "traditional": "長篇大論"
  },
  {
    "frequency": 865,
    "simplified": "落井下石",
    "traditional": "落井下石"
  },
  {
    "frequency": 864,
    "simplified": "步步高升",
    "traditional": "步步高昇"
  },
  {
    "frequency": 864,
    "simplified": "各行其是",
    "traditional": "各行其是"
  },
  {
    "frequency": 864,
    "simplified": "顺水推舟",
    "traditional": "順水推舟"
  },
  {
    "frequency": 862,
    "simplified": "匠心独运",
    "traditional": "匠心獨運"
  },
  {
    "frequency": 861,
    "simplified": "乱作一团",
    "traditional": "亂作一團"
  },
  {
    "frequency": 861,
    "simplified": "从头至尾",
    "traditional": "從頭至尾"
  },
  {
    "frequency": 860,
    "simplified": "左思右想",
    "traditional": "左思右想"
  },
  {
    "frequency": 860,
    "simplified": "点石成金",
    "traditional": "點石成金"
  },
  {
    "frequency": 860,
    "simplified": "热锅上的蚂蚁",
    "traditional": "熱鍋上的螞蟻"
  },
  {
    "frequency": 859,
    "simplified": "群龙无首",
    "traditional": "群龍無首"
  },
  {
    "frequency": 859,
    "simplified": "近亲繁殖",
    "traditional": "近親繁殖"
  },
  {
    "frequency": 858,
    "simplified": "命中注定",
    "traditional": "命中註定"
  },
  {
    "frequency": 858,
    "simplified": "风花雪月",
    "traditional": "風花雪月"
  },
  {
    "frequency": 858,
    "simplified": "一败涂地",
    "traditional": "一敗塗地"
  },
  {
    "frequency": 857,
    "simplified": "混淆是非",
    "traditional": "混淆是非"
  },
  {
    "frequency": 856,
    "simplified": "雍容华贵",
    "traditional": "雍容華貴"
  },
  {
    "frequency": 855,
    "simplified": "刀光剑影",
    "traditional": "刀光劍影"
  },
  {
    "frequency": 855,
    "simplified": "死于非命",
    "traditional": "死於非命"
  },
  {
    "frequency": 855,
    "simplified": "大雨滂沱",
    "traditional": "大雨滂沱"
  },
  {
    "frequency": 855,
    "simplified": "无以复加",
    "traditional": "無以復加"
  },
  {
    "frequency": 855,
    "simplified": "百无聊赖",
    "traditional": "百無聊賴"
  },
  {
    "frequency": 854,
    "simplified": "改名换姓",
    "traditional": "改名換姓"
  },
  {
    "frequency": 853,
    "simplified": "精疲力尽",
    "traditional": "精疲力盡"
  },
  {
    "frequency": 853,
    "simplified": "夸夸其谈",
    "traditional": "誇誇其談"
  },
  {
    "frequency": 852,
    "simplified": "大权在握",
    "traditional": "大權在握"
  },
  {
    "frequency": 850,
    "simplified": "一线生机",
    "traditional": "一線生機"
  },
  {
    "frequency": 850,
    "simplified": "正大光明",
    "traditional": "正大光明"
  },
  {
    "frequency": 849,
    "simplified": "长驱直入",
    "traditional": "長驅直入"
  },
  {
    "frequency": 849,
    "simplified": "怡然自得",
    "traditional": "怡然自得"
  },
  {
    "frequency": 848,
    "simplified": "利令智昏",
    "traditional": "利令智昏"
  },
  {
    "frequency": 848,
    "simplified": "垂涎三尺",
    "traditional": "垂涎三尺"
  },
  {
    "frequency": 847,
    "simplified": "节外生枝",
    "traditional": "節外生枝"
  },
  {
    "frequency": 847,
    "simplified": "情投意合",
    "traditional": "情投意合"
  },
  {
    "frequency": 847,
    "simplified": "黯然神伤",
    "traditional": "黯然神傷"
  },
  {
    "frequency": 846,
    "simplified": "显山露水",
    "traditional": "顯山露水"
  },
  {
    "frequency": 846,
    "simplified": "龙凤呈祥",
    "traditional": "龍鳳呈祥"
  },
  {
    "frequency": 845,
    "simplified": "衣锦还乡",
    "traditional": "衣錦還鄉"
  },
  {
    "frequency": 844,
    "simplified": "政教合一",
    "traditional": "政教合一"
  },
  {
    "frequency": 844,
    "simplified": "兵戎相见",
    "traditional": "兵戎相見"
  },
  {
    "frequency": 844,
    "simplified": "上传下达",
    "traditional": "上傳下達"
  },
  {
    "frequency": 844,
    "simplified": "吹拉弹唱",
    "traditional": "吹拉彈唱"
  },
  {
    "frequency": 844,
    "simplified": "深仇大恨",
    "traditional": "深仇大恨"
  },
  {
    "frequency": 843,
    "simplified": "声名狼藉",
    "traditional": "聲名狼藉"
  },
  {
    "frequency": 843,
    "simplified": "财务主管",
    "traditional": "財務主管"
  },
  {
    "frequency": 843,
    "simplified": "严丝合缝",
    "traditional": "嚴絲合縫"
  },
  {
    "frequency": 842,
    "simplified": "仗义执言",
    "traditional": "仗義執言"
  },
  {
    "frequency": 841,
    "simplified": "依然如故",
    "traditional": "依然如故"
  },
  {
    "frequency": 840,
    "simplified": "血气方刚",
    "traditional": "血氣方剛"
  },
  {
    "frequency": 840,
    "simplified": "对答如流",
    "traditional": "對答如流"
  },
  {
    "frequency": 840,
    "simplified": "勤学苦练",
    "traditional": "勤學苦練"
  },
  {
    "frequency": 840,
    "simplified": "来去自由",
    "traditional": "來去自由"
  },
  {
    "frequency": 839,
    "simplified": "难于上青天",
    "traditional": "難於上青天"
  },
  {
    "frequency": 839,
    "simplified": "雕梁画栋",
    "traditional": "雕梁畫棟"
  },
  {
    "frequency": 838,
    "simplified": "妇孺皆知",
    "traditional": "婦孺皆知"
  },
  {
    "frequency": 836,
    "simplified": "举重若轻",
    "traditional": "舉重若輕"
  },
  {
    "frequency": 836,
    "simplified": "知无不言",
    "traditional": "知無不言"
  },
  {
    "frequency": 835,
    "simplified": "待价而沽",
    "traditional": "待價而沽"
  },
  {
    "frequency": 835,
    "simplified": "言之有物",
    "traditional": "言之有物"
  },
  {
    "frequency": 835,
    "simplified": "义正词严",
    "traditional": "義正詞嚴"
  },
  {
    "frequency": 834,
    "simplified": "迷途知返",
    "traditional": "迷途知返"
  },
  {
    "frequency": 834,
    "simplified": "变化无常",
    "traditional": "變化無常"
  },
  {
    "frequency": 833,
    "simplified": "大喝一声",
    "traditional": "大喝一聲"
  },
  {
    "frequency": 833,
    "simplified": "高耸入云",
    "traditional": "高聳入雲"
  },
  {
    "frequency": 832,
    "simplified": "一呼百应",
    "traditional": "一呼百應"
  },
  {
    "frequency": 832,
    "simplified": "逢山开路",
    "traditional": "逢山開路"
  },
  {
    "frequency": 831,
    "simplified": "退避三舍",
    "traditional": "退避三舍"
  },
  {
    "frequency": 830,
    "simplified": "人文荟萃",
    "traditional": "人文薈萃"
  },
  {
    "frequency": 829,
    "simplified": "苦中作乐",
    "traditional": "苦中作樂"
  },
  {
    "frequency": 828,
    "simplified": "从善如流",
    "traditional": "從善如流"
  },
  {
    "frequency": 828,
    "simplified": "卧薪尝胆",
    "traditional": "臥薪嚐膽"
  },
  {
    "frequency": 828,
    "simplified": "生搬硬套",
    "traditional": "生搬硬套"
  },
  {
    "frequency": 827,
    "simplified": "非亲非故",
    "traditional": "非親非故"
  },
  {
    "frequency": 826,
    "simplified": "昂首挺胸",
    "traditional": "昂首挺胸"
  },
  {
    "frequency": 825,
    "simplified": "聪明反被聪明误",
    "traditional": "聰明反被聰明誤"
  },
  {
    "frequency": 824,
    "simplified": "鬼使神差",
    "traditional": "鬼使神差"
  },
  {
    "frequency": 823,
    "simplified": "叫苦连天",
    "traditional": "叫苦連天"
  },
  {
    "frequency": 823,
    "simplified": "大势已去",
    "traditional": "大勢已去"
  },
  {
    "frequency": 822,
    "simplified": "无奇不有",
    "traditional": "無奇不有"
  },
  {
    "frequency": 821,
    "simplified": "百年树人",
    "traditional": "百年樹人"
  },
  {
    "frequency": 821,
    "simplified": "戮力同心",
    "traditional": "戮力同心"
  },
  {
    "frequency": 820,
    "simplified": "开国元勋",
    "traditional": "開國元勳"
  },
  {
    "frequency": 820,
    "simplified": "不卑不亢",
    "traditional": "不卑不亢"
  },
  {
    "frequency": 820,
    "simplified": "流言蜚语",
    "traditional": "流言蜚語"
  },
  {
    "frequency": 819,
    "simplified": "委曲求全",
    "traditional": "委曲求全"
  },
  {
    "frequency": 818,
    "simplified": "心想事成",
    "traditional": "心想事成"
  },
  {
    "frequency": 818,
    "simplified": "选贤任能",
    "traditional": "選賢任能"
  },
  {
    "frequency": 818,
    "simplified": "居心叵测",
    "traditional": "居心叵測"
  },
  {
    "frequency": 818,
    "simplified": "年近花甲",
    "traditional": "年近花甲"
  },
  {
    "frequency": 816,
    "simplified": "有志之士",
    "traditional": "有志之士"
  },
  {
    "frequency": 816,
    "simplified": "小恩小惠",
    "traditional": "小恩小惠"
  },
  {
    "frequency": 816,
    "simplified": "挑拨离间",
    "traditional": "挑撥離間"
  },
  {
    "frequency": 816,
    "simplified": "别具匠心",
    "traditional": "別具匠心"
  },
  {
    "frequency": 816,
    "simplified": "慢条斯理",
    "traditional": "慢條斯理"
  },
  {
    "frequency": 815,
    "simplified": "革故鼎新",
    "traditional": "革故鼎新"
  },
  {
    "frequency": 815,
    "simplified": "谆谆教导",
    "traditional": "諄諄教導"
  },
  {
    "frequency": 815,
    "simplified": "罪大恶极",
    "traditional": "罪大惡極"
  },
  {
    "frequency": 814,
    "simplified": "万念俱灰",
    "traditional": "萬念俱灰"
  },
  {
    "frequency": 814,
    "simplified": "装点门面",
    "traditional": "裝點門面"
  },
  {
    "frequency": 813,
    "simplified": "坐享其成",
    "traditional": "坐享其成"
  },
  {
    "frequency": 813,
    "simplified": "放之四海而皆准",
    "traditional": "放之四海而皆準"
  },
  {
    "frequency": 812,
    "simplified": "平步青云",
    "traditional": "平步青雲"
  },
  {
    "frequency": 810,
    "simplified": "音容笑貌",
    "traditional": "音容笑貌"
  },
  {
    "frequency": 810,
    "simplified": "诚惶诚恐",
    "traditional": "誠惶誠恐"
  },
  {
    "frequency": 807,
    "simplified": "达官贵人",
    "traditional": "達官貴人"
  },
  {
    "frequency": 805,
    "simplified": "奇形怪状",
    "traditional": "奇形怪狀"
  },
  {
    "frequency": 805,
    "simplified": "畸形发展",
    "traditional": "畸形發展"
  },
  {
    "frequency": 805,
    "simplified": "黑灯瞎火",
    "traditional": "黑燈瞎火"
  },
  {
    "frequency": 804,
    "simplified": "打得火热",
    "traditional": "打得火熱"
  },
  {
    "frequency": 804,
    "simplified": "秋后算账",
    "traditional": "秋後算賬"
  },
  {
    "frequency": 804,
    "simplified": "狼狈不堪",
    "traditional": "狼狽不堪"
  },
  {
    "frequency": 803,
    "simplified": "披星戴月",
    "traditional": "披星戴月"
  },
  {
    "frequency": 802,
    "simplified": "街坊邻里",
    "traditional": "街坊鄰里"
  },
  {
    "frequency": 802,
    "simplified": "民不聊生",
    "traditional": "民不聊生"
  },
  {
    "frequency": 800,
    "simplified": "依依惜别",
    "traditional": "依依惜別"
  },
  {
    "frequency": 799,
    "simplified": "相见恨晚",
    "traditional": "相見恨晚"
  },
  {
    "frequency": 798,
    "simplified": "贼喊捉贼",
    "traditional": "賊喊捉賊"
  },
  {
    "frequency": 798,
    "simplified": "一日千里",
    "traditional": "一日千里"
  },
  {
    "frequency": 797,
    "simplified": "促膝谈心",
    "traditional": "促膝談心"
  },
  {
    "frequency": 796,
    "simplified": "花天酒地",
    "traditional": "花天酒地"
  },
  {
    "frequency": 796,
    "simplified": "寡不敌众",
    "traditional": "寡不敵眾"
  },
  {
    "frequency": 794,
    "simplified": "杀一儆百",
    "traditional": "殺一儆百"
  },
  {
    "frequency": 793,
    "simplified": "近水楼台",
    "traditional": "近水樓臺"
  },
  {
    "frequency": 793,
    "simplified": "深入骨髓",
    "traditional": "深入骨髓"
  },
  {
    "frequency": 793,
    "simplified": "一板一眼",
    "traditional": "一板一眼"
  },
  {
    "frequency": 793,
    "simplified": "目无法纪",
    "traditional": "目無法紀"
  },
  {
    "frequency": 793,
    "simplified": "望其项背",
    "traditional": "望其項背"
  },
  {
    "frequency": 792,
    "simplified": "为非作恶",
    "traditional": "為非作惡"
  },
  {
    "frequency": 790,
    "simplified": "唯我独尊",
    "traditional": "唯我獨尊"
  },
  {
    "frequency": 790,
    "simplified": "后天下之乐而乐",
    "traditional": "後天下之樂而樂"
  },
  {
    "frequency": 789,
    "simplified": "反躬自省",
    "traditional": "反躬自省"
  },
  {
    "frequency": 789,
    "simplified": "评头论足",
    "traditional": "評頭論足"
  },
  {
    "frequency": 788,
    "simplified": "重整旗鼓",
    "traditional": "重整旗鼓"
  },
  {
    "frequency": 788,
    "simplified": "物是人非",
    "traditional": "物是人非"
  },
  {
    "frequency": 788,
    "simplified": "草长莺飞",
    "traditional": "草長鶯飛"
  },
  {
    "frequency": 787,
    "simplified": "奋笔疾书",
    "traditional": "奮筆疾書"
  },
  {
    "frequency": 787,
    "simplified": "体无完肤",
    "traditional": "體無完膚"
  },
  {
    "frequency": 787,
    "simplified": "大放厥词",
    "traditional": "大放厥詞"
  },
  {
    "frequency": 786,
    "simplified": "刚柔相济",
    "traditional": "剛柔相濟"
  },
  {
    "frequency": 786,
    "simplified": "万紫千红",
    "traditional": "萬紫千紅"
  },
  {
    "frequency": 784,
    "simplified": "惹人注目",
    "traditional": "惹人注目"
  },
  {
    "frequency": 782,
    "simplified": "弹丸之地",
    "traditional": "彈丸之地"
  },
  {
    "frequency": 782,
    "simplified": "心驰神往",
    "traditional": "心馳神往"
  },
  {
    "frequency": 781,
    "simplified": "体贴入微",
    "traditional": "體貼入微"
  },
  {
    "frequency": 781,
    "simplified": "毁誉参半",
    "traditional": "譭譽參半"
  },
  {
    "frequency": 781,
    "simplified": "心浮气躁",
    "traditional": "心浮氣躁"
  },
  {
    "frequency": 780,
    "simplified": "好说歹说",
    "traditional": "好說歹說"
  },
  {
    "frequency": 780,
    "simplified": "深得人心",
    "traditional": "深得人心"
  },
  {
    "frequency": 780,
    "simplified": "前途无量",
    "traditional": "前途無量"
  },
  {
    "frequency": 780,
    "simplified": "一笔勾销",
    "traditional": "一筆勾銷"
  },
  {
    "frequency": 779,
    "simplified": "日出而作",
    "traditional": "日出而作"
  },
  {
    "frequency": 778,
    "simplified": "劫富济贫",
    "traditional": "劫富濟貧"
  },
  {
    "frequency": 778,
    "simplified": "察言观色",
    "traditional": "察言觀色"
  },
  {
    "frequency": 778,
    "simplified": "令人神往",
    "traditional": "令人神往"
  },
  {
    "frequency": 777,
    "simplified": "鼓鼓囊囊",
    "traditional": "鼓鼓囊囊"
  },
  {
    "frequency": 777,
    "simplified": "不毛之地",
    "traditional": "不毛之地"
  },
  {
    "frequency": 776,
    "simplified": "将错就错",
    "traditional": "將錯就錯"
  },
  {
    "frequency": 776,
    "simplified": "魂牵梦萦",
    "traditional": "魂牽夢縈"
  },
  {
    "frequency": 775,
    "simplified": "拿手好戏",
    "traditional": "拿手好戲"
  },
  {
    "frequency": 775,
    "simplified": "行行出状元",
    "traditional": "行行出狀元"
  },
  {
    "frequency": 775,
    "simplified": "冰冻三尺",
    "traditional": "冰凍三尺"
  },
  {
    "frequency": 774,
    "simplified": "自知之明",
    "traditional": "自知之明"
  },
  {
    "frequency": 773,
    "simplified": "字斟句酌",
    "traditional": "字斟句酌"
  },
  {
    "frequency": 773,
    "simplified": "嬉笑怒骂",
    "traditional": "嬉笑怒罵"
  },
  {
    "frequency": 773,
    "simplified": "一箭双雕",
    "traditional": "一箭雙鵰"
  },
  {
    "frequency": 772,
    "simplified": "群雄逐鹿",
    "traditional": "群雄逐鹿"
  },
  {
    "frequency": 772,
    "simplified": "为期不远",
    "traditional": "為期不遠"
  },
  {
    "frequency": 771,
    "simplified": "一波未平",
    "traditional": "一波未平"
  },
  {
    "frequency": 771,
    "simplified": "急不可耐",
    "traditional": "急不可耐"
  },
  {
    "frequency": 770,
    "simplified": "飘忽不定",
    "traditional": "飄忽不定"
  },
  {
    "frequency": 769,
    "simplified": "高歌猛进",
    "traditional": "高歌猛進"
  },
  {
    "frequency": 769,
    "simplified": "不辞劳苦",
    "traditional": "不辭勞苦"
  },
  {
    "frequency": 768,
    "simplified": "活色生香",
    "traditional": "活色生香"
  },
  {
    "frequency": 768,
    "simplified": "同日而语",
    "traditional": "同日而語"
  },
  {
    "frequency": 768,
    "simplified": "硕果仅存",
    "traditional": "碩果僅存"
  },
  {
    "frequency": 768,
    "simplified": "饱经沧桑",
    "traditional": "飽經滄桑"
  },
  {
    "frequency": 767,
    "simplified": "倒背如流",
    "traditional": "倒背如流"
  },
  {
    "frequency": 767,
    "simplified": "勾心斗角",
    "traditional": "勾心鬥角"
  },
  {
    "frequency": 767,
    "simplified": "油盐酱醋",
    "traditional": "油鹽醬醋"
  },
  {
    "frequency": 765,
    "simplified": "英雄本色",
    "traditional": "英雄本色"
  },
  {
    "frequency": 765,
    "simplified": "包打天下",
    "traditional": "包打天下"
  },
  {
    "frequency": 765,
    "simplified": "和风细雨",
    "traditional": "和風細雨"
  },
  {
    "frequency": 765,
    "simplified": "拔出萝卜带出泥",
    "traditional": "拔出蘿蔔帶出泥"
  },
  {
    "frequency": 765,
    "simplified": "以防不测",
    "traditional": "以防不測"
  },
  {
    "frequency": 765,
    "simplified": "年近古稀",
    "traditional": "年近古稀"
  },
  {
    "frequency": 764,
    "simplified": "夺门而出",
    "traditional": "奪門而出"
  },
  {
    "frequency": 763,
    "simplified": "一见倾心",
    "traditional": "一見傾心"
  },
  {
    "frequency": 763,
    "simplified": "不着边际",
    "traditional": "不著邊際"
  },
  {
    "frequency": 763,
    "simplified": "兼济天下",
    "traditional": "兼濟天下"
  },
  {
    "frequency": 761,
    "simplified": "出乎预料",
    "traditional": "出乎預料"
  },
  {
    "frequency": 761,
    "simplified": "满面笑容",
    "traditional": "滿面笑容"
  },
  {
    "frequency": 761,
    "simplified": "炯炯有神",
    "traditional": "炯炯有神"
  },
  {
    "frequency": 760,
    "simplified": "虚位以待",
    "traditional": "虛位以待"
  },
  {
    "frequency": 759,
    "simplified": "养尊处优",
    "traditional": "養尊處優"
  },
  {
    "frequency": 759,
    "simplified": "徒劳无功",
    "traditional": "徒勞無功"
  },
  {
    "frequency": 758,
    "simplified": "闻风丧胆",
    "traditional": "聞風喪膽"
  },
  {
    "frequency": 757,
    "simplified": "耀武扬威",
    "traditional": "耀武揚威"
  },
  {
    "frequency": 757,
    "simplified": "贪污腐化",
    "traditional": "貪汙腐化"
  },
  {
    "frequency": 757,
    "simplified": "故弄玄虚",
    "traditional": "故弄玄虛"
  },
  {
    "frequency": 756,
    "simplified": "兼而有之",
    "traditional": "兼而有之"
  },
  {
    "frequency": 756,
    "simplified": "上下其手",
    "traditional": "上下其手"
  },
  {
    "frequency": 756,
    "simplified": "一面之缘",
    "traditional": "一面之緣"
  },
  {
    "frequency": 756,
    "simplified": "镜花水月",
    "traditional": "鏡花水月"
  },
  {
    "frequency": 755,
    "simplified": "事在人为",
    "traditional": "事在人為"
  },
  {
    "frequency": 755,
    "simplified": "麻雀虽小",
    "traditional": "麻雀雖小"
  },
  {
    "frequency": 755,
    "simplified": "十万火急",
    "traditional": "十萬火急"
  },
  {
    "frequency": 755,
    "simplified": "聪明伶俐",
    "traditional": "聰明伶俐"
  },
  {
    "frequency": 754,
    "simplified": "聚沙成塔",
    "traditional": "聚沙成塔"
  },
  {
    "frequency": 754,
    "simplified": "投机钻营",
    "traditional": "投機鑽營"
  },
  {
    "frequency": 754,
    "simplified": "深不可测",
    "traditional": "深不可測"
  },
  {
    "frequency": 754,
    "simplified": "牢骚满腹",
    "traditional": "牢騷滿腹"
  },
  {
    "frequency": 754,
    "simplified": "清水衙门",
    "traditional": "清水衙門"
  },
  {
    "frequency": 754,
    "simplified": "心花怒放",
    "traditional": "心花怒放"
  },
  {
    "frequency": 753,
    "simplified": "尸位素餐",
    "traditional": "尸位素餐"
  },
  {
    "frequency": 753,
    "simplified": "七手八脚",
    "traditional": "七手八腳"
  },
  {
    "frequency": 753,
    "simplified": "财源滚滚",
    "traditional": "財源滾滾"
  },
  {
    "frequency": 753,
    "simplified": "添油加醋",
    "traditional": "添油加醋"
  },
  {
    "frequency": 753,
    "simplified": "巧取豪夺",
    "traditional": "巧取豪奪"
  },
  {
    "frequency": 751,
    "simplified": "开路先锋",
    "traditional": "開路先鋒"
  },
  {
    "frequency": 751,
    "simplified": "雷电交加",
    "traditional": "雷電交加"
  },
  {
    "frequency": 750,
    "simplified": "珠联璧合",
    "traditional": "珠聯璧合"
  },
  {
    "frequency": 750,
    "simplified": "坐吃山空",
    "traditional": "坐吃山空"
  },
  {
    "frequency": 750,
    "simplified": "口若悬河",
    "traditional": "口若懸河"
  },
  {
    "frequency": 750,
    "simplified": "风度翩翩",
    "traditional": "風度翩翩"
  },
  {
    "frequency": 749,
    "simplified": "一哄而散",
    "traditional": "一鬨而散"
  },
  {
    "frequency": 748,
    "simplified": "如鲠在喉",
    "traditional": "如鯁在喉"
  },
  {
    "frequency": 746,
    "simplified": "出奇制胜",
    "traditional": "出奇制勝"
  },
  {
    "frequency": 746,
    "simplified": "大义凛然",
    "traditional": "大義凜然"
  },
  {
    "frequency": 746,
    "simplified": "一唱一和",
    "traditional": "一唱一和"
  },
  {
    "frequency": 745,
    "simplified": "逆来顺受",
    "traditional": "逆來順受"
  },
  {
    "frequency": 745,
    "simplified": "小巧玲珑",
    "traditional": "小巧玲瓏"
  },
  {
    "frequency": 745,
    "simplified": "暴跳如雷",
    "traditional": "暴跳如雷"
  },
  {
    "frequency": 744,
    "simplified": "云淡风轻",
    "traditional": "雲淡風輕"
  },
  {
    "frequency": 744,
    "simplified": "曲高和寡",
    "traditional": "曲高和寡"
  },
  {
    "frequency": 744,
    "simplified": "传经送宝",
    "traditional": "傳經送寶"
  },
  {
    "frequency": 743,
    "simplified": "改弦易辙",
    "traditional": "改弦易轍"
  },
  {
    "frequency": 742,
    "simplified": "牵强附会",
    "traditional": "牽強附會"
  },
  {
    "frequency": 742,
    "simplified": "振兴中华",
    "traditional": "振興中華"
  },
  {
    "frequency": 741,
    "simplified": "从轻发落",
    "traditional": "從輕發落"
  },
  {
    "frequency": 741,
    "simplified": "满腔热忱",
    "traditional": "滿腔熱忱"
  },
  {
    "frequency": 740,
    "simplified": "消极怠工",
    "traditional": "消極怠工"
  },
  {
    "frequency": 740,
    "simplified": "气焰嚣张",
    "traditional": "氣焰囂張"
  },
  {
    "frequency": 740,
    "simplified": "先知先觉",
    "traditional": "先知先覺"
  },
  {
    "frequency": 740,
    "simplified": "不能自主",
    "traditional": "不能自主"
  },
  {
    "frequency": 739,
    "simplified": "飞檐走壁",
    "traditional": "飛簷走壁"
  },
  {
    "frequency": 738,
    "simplified": "易如反掌",
    "traditional": "易如反掌"
  },
  {
    "frequency": 738,
    "simplified": "一笑置之",
    "traditional": "一笑置之"
  },
  {
    "frequency": 738,
    "simplified": "展翅高飞",
    "traditional": "展翅高飛"
  },
  {
    "frequency": 738,
    "simplified": "马首是瞻",
    "traditional": "馬首是瞻"
  },
  {
    "frequency": 738,
    "simplified": "强国富民",
    "traditional": "強國富民"
  },
  {
    "frequency": 737,
    "simplified": "连绵不绝",
    "traditional": "連綿不絕"
  },
  {
    "frequency": 737,
    "simplified": "惨淡经营",
    "traditional": "慘淡經營"
  },
  {
    "frequency": 737,
    "simplified": "连绵起伏",
    "traditional": "連綿起伏"
  },
  {
    "frequency": 737,
    "simplified": "严刑峻法",
    "traditional": "嚴刑峻法"
  },
  {
    "frequency": 737,
    "simplified": "人所共知",
    "traditional": "人所共知"
  },
  {
    "frequency": 735,
    "simplified": "一五一十",
    "traditional": "一五一十"
  },
  {
    "frequency": 735,
    "simplified": "路人皆知",
    "traditional": "路人皆知"
  },
  {
    "frequency": 733,
    "simplified": "咬文嚼字",
    "traditional": "咬文嚼字"
  },
  {
    "frequency": 733,
    "simplified": "触景生情",
    "traditional": "觸景生情"
  },
  {
    "frequency": 732,
    "simplified": "勿以善小而不为",
    "traditional": "勿以善小而不為"
  },
  {
    "frequency": 731,
    "simplified": "初生牛犊不怕虎",
    "traditional": "初生牛犢不怕虎"
  },
  {
    "frequency": 731,
    "simplified": "抱残守缺",
    "traditional": "抱殘守缺"
  },
  {
    "frequency": 731,
    "simplified": "十年树木",
    "traditional": "十年樹木"
  },
  {
    "frequency": 730,
    "simplified": "桀骜不驯",
    "traditional": "桀驁不馴"
  },
  {
    "frequency": 729,
    "simplified": "万劫不复",
    "traditional": "萬劫不復"
  },
  {
    "frequency": 729,
    "simplified": "先下手为强",
    "traditional": "先下手為強"
  },
  {
    "frequency": 728,
    "simplified": "粉身碎骨",
    "traditional": "粉身碎骨"
  },
  {
    "frequency": 728,
    "simplified": "上天入地",
    "traditional": "上天入地"
  },
  {
    "frequency": 728,
    "simplified": "原来如此",
    "traditional": "原來如此"
  },
  {
    "frequency": 727,
    "simplified": "好事多磨",
    "traditional": "好事多磨"
  },
  {
    "frequency": 726,
    "simplified": "锱铢必较",
    "traditional": "錙銖必較"
  },
  {
    "frequency": 726,
    "simplified": "伤天害理",
    "traditional": "傷天害理"
  },
  {
    "frequency": 726,
    "simplified": "惹是生非",
    "traditional": "惹是生非"
  },
  {
    "frequency": 726,
    "simplified": "钻牛角尖",
    "traditional": "鑽牛角尖"
  },
  {
    "frequency": 726,
    "simplified": "背信弃义",
    "traditional": "背信棄義"
  },
  {
    "frequency": 725,
    "simplified": "白头偕老",
    "traditional": "白頭偕老"
  },
  {
    "frequency": 725,
    "simplified": "赤膊上阵",
    "traditional": "赤膊上陣"
  },
  {
    "frequency": 725,
    "simplified": "成双成对",
    "traditional": "成雙成對"
  },
  {
    "frequency": 723,
    "simplified": "大义灭亲",
    "traditional": "大義滅親"
  },
  {
    "frequency": 723,
    "simplified": "发财致富",
    "traditional": "發財致富"
  },
  {
    "frequency": 721,
    "simplified": "寄人篱下",
    "traditional": "寄人籬下"
  },
  {
    "frequency": 721,
    "simplified": "各色人等",
    "traditional": "各色人等"
  },
  {
    "frequency": 721,
    "simplified": "一路平安",
    "traditional": "一路平安"
  },
  {
    "frequency": 721,
    "simplified": "滴水穿石",
    "traditional": "滴水穿石"
  },
  {
    "frequency": 721,
    "simplified": "大有文章",
    "traditional": "大有文章"
  },
  {
    "frequency": 721,
    "simplified": "死而后已",
    "traditional": "死而後已"
  },
  {
    "frequency": 720,
    "simplified": "源源不绝",
    "traditional": "源源不絕"
  },
  {
    "frequency": 720,
    "simplified": "过从甚密",
    "traditional": "過從甚密"
  },
  {
    "frequency": 720,
    "simplified": "化干戈为玉帛",
    "traditional": "化干戈為玉帛"
  },
  {
    "frequency": 719,
    "simplified": "日以继夜",
    "traditional": "日以繼夜"
  },
  {
    "frequency": 719,
    "simplified": "求全责备",
    "traditional": "求全責備"
  },
  {
    "frequency": 718,
    "simplified": "寸步不让",
    "traditional": "寸步不讓"
  },
  {
    "frequency": 718,
    "simplified": "投石问路",
    "traditional": "投石問路"
  },
  {
    "frequency": 718,
    "simplified": "根深叶茂",
    "traditional": "根深葉茂"
  },
  {
    "frequency": 718,
    "simplified": "灭绝人性",
    "traditional": "滅絕人性"
  },
  {
    "frequency": 717,
    "simplified": "功成身退",
    "traditional": "功成身退"
  },
  {
    "frequency": 717,
    "simplified": "如雷贯耳",
    "traditional": "如雷貫耳"
  },
  {
    "frequency": 717,
    "simplified": "舍己为人",
    "traditional": "捨己為人"
  },
  {
    "frequency": 717,
    "simplified": "万变不离其宗",
    "traditional": "萬變不離其宗"
  },
  {
    "frequency": 717,
    "simplified": "焕发青春",
    "traditional": "煥發青春"
  },
  {
    "frequency": 716,
    "simplified": "骨肉分离",
    "traditional": "骨肉分離"
  },
  {
    "frequency": 715,
    "simplified": "穷乡僻壤",
    "traditional": "窮鄉僻壤"
  },
  {
    "frequency": 714,
    "simplified": "普天同庆",
    "traditional": "普天同慶"
  },
  {
    "frequency": 714,
    "simplified": "马马虎虎",
    "traditional": "馬馬虎虎"
  },
  {
    "frequency": 713,
    "simplified": "旁敲侧击",
    "traditional": "旁敲側擊"
  },
  {
    "frequency": 713,
    "simplified": "先见之明",
    "traditional": "先見之明"
  },
  {
    "frequency": 712,
    "simplified": "倒打一耙",
    "traditional": "倒打一耙"
  },
  {
    "frequency": 711,
    "simplified": "谈天说地",
    "traditional": "談天說地"
  },
  {
    "frequency": 711,
    "simplified": "无事生非",
    "traditional": "無事生非"
  },
  {
    "frequency": 711,
    "simplified": "利益均沾",
    "traditional": "利益均沾"
  },
  {
    "frequency": 709,
    "simplified": "骄傲自满",
    "traditional": "驕傲自滿"
  },
  {
    "frequency": 709,
    "simplified": "力争上游",
    "traditional": "力爭上游"
  },
  {
    "frequency": 709,
    "simplified": "心如刀绞",
    "traditional": "心如刀絞"
  },
  {
    "frequency": 709,
    "simplified": "拖泥带水",
    "traditional": "拖泥帶水"
  },
  {
    "frequency": 709,
    "simplified": "离经叛道",
    "traditional": "離經叛道"
  },
  {
    "frequency": 709,
    "simplified": "吃哑巴亏",
    "traditional": "吃啞巴虧"
  },
  {
    "frequency": 709,
    "simplified": "用之不竭",
    "traditional": "用之不竭"
  },
  {
    "frequency": 708,
    "simplified": "奇装异服",
    "traditional": "奇裝異服"
  },
  {
    "frequency": 708,
    "simplified": "春回大地",
    "traditional": "春回大地"
  },
  {
    "frequency": 708,
    "simplified": "插科打诨",
    "traditional": "插科打諢"
  },
  {
    "frequency": 707,
    "simplified": "推己及人",
    "traditional": "推己及人"
  },
  {
    "frequency": 706,
    "simplified": "将计就计",
    "traditional": "將計就計"
  },
  {
    "frequency": 706,
    "simplified": "无可置疑",
    "traditional": "無可置疑"
  },
  {
    "frequency": 706,
    "simplified": "强人所难",
    "traditional": "強人所難"
  },
  {
    "frequency": 706,
    "simplified": "分文不取",
    "traditional": "分文不取"
  },
  {
    "frequency": 706,
    "simplified": "引狼入室",
    "traditional": "引狼入室"
  },
  {
    "frequency": 706,
    "simplified": "学而优则仕",
    "traditional": "學而優則仕"
  },
  {
    "frequency": 706,
    "simplified": "心狠手辣",
    "traditional": "心狠手辣"
  },
  {
    "frequency": 706,
    "simplified": "若即若离",
    "traditional": "若即若離"
  },
  {
    "frequency": 705,
    "simplified": "不分彼此",
    "traditional": "不分彼此"
  },
  {
    "frequency": 705,
    "simplified": "不费吹灰之力",
    "traditional": "不費吹灰之力"
  },
  {
    "frequency": 704,
    "simplified": "八九不离十",
    "traditional": "八九不離十"
  },
  {
    "frequency": 704,
    "simplified": "南征北战",
    "traditional": "南征北戰"
  },
  {
    "frequency": 703,
    "simplified": "以退为进",
    "traditional": "以退為進"
  },
  {
    "frequency": 701,
    "simplified": "不拘小节",
    "traditional": "不拘小節"
  },
  {
    "frequency": 701,
    "simplified": "死心塌地",
    "traditional": "死心塌地"
  },
  {
    "frequency": 701,
    "simplified": "汹涌澎湃",
    "traditional": "洶湧澎湃"
  },
  {
    "frequency": 700,
    "simplified": "真枪实弹",
    "traditional": "真槍實彈"
  },
  {
    "frequency": 699,
    "simplified": "温情脉脉",
    "traditional": "溫情脈脈"
  },
  {
    "frequency": 699,
    "simplified": "损公肥私",
    "traditional": "損公肥私"
  },
  {
    "frequency": 698,
    "simplified": "贻笑大方",
    "traditional": "貽笑大方"
  },
  {
    "frequency": 698,
    "simplified": "摇头叹息",
    "traditional": "搖頭嘆息"
  },
  {
    "frequency": 698,
    "simplified": "优哉游哉",
    "traditional": "優哉遊哉"
  },
  {
    "frequency": 698,
    "simplified": "天生丽质",
    "traditional": "天生麗質"
  },
  {
    "frequency": 698,
    "simplified": "贤妻良母",
    "traditional": "賢妻良母"
  },
  {
    "frequency": 697,
    "simplified": "斯文扫地",
    "traditional": "斯文掃地"
  },
  {
    "frequency": 697,
    "simplified": "敢作敢为",
    "traditional": "敢作敢為"
  },
  {
    "frequency": 697,
    "simplified": "粗茶淡饭",
    "traditional": "粗茶淡飯"
  },
  {
    "frequency": 696,
    "simplified": "以身殉职",
    "traditional": "以身殉職"
  },
  {
    "frequency": 695,
    "simplified": "趁虚而入",
    "traditional": "趁虛而入"
  },
  {
    "frequency": 695,
    "simplified": "缩手缩脚",
    "traditional": "縮手縮腳"
  },
  {
    "frequency": 694,
    "simplified": "死而复生",
    "traditional": "死而復生"
  },
  {
    "frequency": 694,
    "simplified": "糖衣炮弹",
    "traditional": "糖衣炮彈"
  },
  {
    "frequency": 694,
    "simplified": "安安稳稳",
    "traditional": "安安穩穩"
  },
  {
    "frequency": 694,
    "simplified": "汗牛充栋",
    "traditional": "汗牛充棟"
  },
  {
    "frequency": 692,
    "simplified": "出谋献策",
    "traditional": "出謀獻策"
  },
  {
    "frequency": 692,
    "simplified": "家丑不可外扬",
    "traditional": "家醜不可外揚"
  },
  {
    "frequency": 692,
    "simplified": "望洋兴叹",
    "traditional": "望洋興嘆"
  },
  {
    "frequency": 691,
    "simplified": "蹑手蹑脚",
    "traditional": "躡手躡腳"
  },
  {
    "frequency": 691,
    "simplified": "礼仪之邦",
    "traditional": "禮儀之邦"
  },
  {
    "frequency": 691,
    "simplified": "短斤少两",
    "traditional": "短斤少兩"
  },
  {
    "frequency": 691,
    "simplified": "熟门熟路",
    "traditional": "熟門熟路"
  },
  {
    "frequency": 690,
    "simplified": "鱼水深情",
    "traditional": "魚水深情"
  },
  {
    "frequency": 689,
    "simplified": "亡国灭种",
    "traditional": "亡國滅種"
  },
  {
    "frequency": 688,
    "simplified": "醍醐灌顶",
    "traditional": "醍醐灌頂"
  },
  {
    "frequency": 688,
    "simplified": "一个巴掌拍不响",
    "traditional": "一個巴掌拍不響"
  },
  {
    "frequency": 687,
    "simplified": "化腐朽为神奇",
    "traditional": "化腐朽為神奇"
  },
  {
    "frequency": 686,
    "simplified": "气象万千",
    "traditional": "氣象萬千"
  },
  {
    "frequency": 686,
    "simplified": "一个萝卜一个坑",
    "traditional": "一個蘿蔔一個坑"
  },
  {
    "frequency": 686,
    "simplified": "嫉恶如仇",
    "traditional": "嫉惡如仇"
  },
  {
    "frequency": 686,
    "simplified": "残破不堪",
    "traditional": "殘破不堪"
  },
  {
    "frequency": 686,
    "simplified": "欲速则不达",
    "traditional": "欲速則不達"
  },
  {
    "frequency": 685,
    "simplified": "盛气凌人",
    "traditional": "盛氣凌人"
  },
  {
    "frequency": 685,
    "simplified": "名扬天下",
    "traditional": "名揚天下"
  },
  {
    "frequency": 684,
    "simplified": "多灾多难",
    "traditional": "多災多難"
  },
  {
    "frequency": 684,
    "simplified": "七上八下",
    "traditional": "七上八下"
  },
  {
    "frequency": 684,
    "simplified": "投鼠忌器",
    "traditional": "投鼠忌器"
  },
  {
    "frequency": 684,
    "simplified": "安分守己",
    "traditional": "安分守己"
  },
  {
    "frequency": 683,
    "simplified": "男女老少",
    "traditional": "男女老少"
  },
  {
    "frequency": 683,
    "simplified": "首善之区",
    "traditional": "首善之區"
  },
  {
    "frequency": 683,
    "simplified": "民怨沸腾",
    "traditional": "民怨沸騰"
  },
  {
    "frequency": 683,
    "simplified": "健步如飞",
    "traditional": "健步如飛"
  },
  {
    "frequency": 683,
    "simplified": "赔了夫人又折兵",
    "traditional": "賠了夫人又折兵"
  },
  {
    "frequency": 682,
    "simplified": "相敬如宾",
    "traditional": "相敬如賓"
  },
  {
    "frequency": 682,
    "simplified": "大煞风景",
    "traditional": "大煞風景"
  },
  {
    "frequency": 682,
    "simplified": "妙不可言",
    "traditional": "妙不可言"
  },
  {
    "frequency": 682,
    "simplified": "直抒胸臆",
    "traditional": "直抒胸臆"
  },
  {
    "frequency": 682,
    "simplified": "风云际会",
    "traditional": "風雲際會"
  },
  {
    "frequency": 682,
    "simplified": "矢志不移",
    "traditional": "矢志不移"
  },
  {
    "frequency": 681,
    "simplified": "满城风雨",
    "traditional": "滿城風雨"
  },
  {
    "frequency": 681,
    "simplified": "助纣为虐",
    "traditional": "助紂為虐"
  },
  {
    "frequency": 681,
    "simplified": "不敢苟同",
    "traditional": "不敢苟同"
  },
  {
    "frequency": 681,
    "simplified": "昂首阔步",
    "traditional": "昂首闊步"
  },
  {
    "frequency": 680,
    "simplified": "耳聪目明",
    "traditional": "耳聰目明"
  },
  {
    "frequency": 678,
    "simplified": "十万八千里",
    "traditional": "十萬八千里"
  },
  {
    "frequency": 678,
    "simplified": "几次三番",
    "traditional": "幾次三番"
  },
  {
    "frequency": 677,
    "simplified": "目光短浅",
    "traditional": "目光短淺"
  },
  {
    "frequency": 677,
    "simplified": "进退维谷",
    "traditional": "進退維谷"
  },
  {
    "frequency": 677,
    "simplified": "老死不相往来",
    "traditional": "老死不相往來"
  },
  {
    "frequency": 677,
    "simplified": "叶落归根",
    "traditional": "葉落歸根"
  },
  {
    "frequency": 676,
    "simplified": "文过饰非",
    "traditional": "文過飾非"
  },
  {
    "frequency": 676,
    "simplified": "灿烂辉煌",
    "traditional": "燦爛輝煌"
  },
  {
    "frequency": 676,
    "simplified": "百年好合",
    "traditional": "百年好合"
  },
  {
    "frequency": 676,
    "simplified": "狐假虎威",
    "traditional": "狐假虎威"
  },
  {
    "frequency": 675,
    "simplified": "成败得失",
    "traditional": "成敗得失"
  },
  {
    "frequency": 675,
    "simplified": "浓妆艳抹",
    "traditional": "濃妝豔抹"
  },
  {
    "frequency": 674,
    "simplified": "谋财害命",
    "traditional": "謀財害命"
  },
  {
    "frequency": 674,
    "simplified": "天下兴亡",
    "traditional": "天下興亡"
  },
  {
    "frequency": 673,
    "simplified": "改邪归正",
    "traditional": "改邪歸正"
  },
  {
    "frequency": 672,
    "simplified": "一了百了",
    "traditional": "一了百了"
  },
  {
    "frequency": 671,
    "simplified": "散兵游勇",
    "traditional": "散兵遊勇"
  },
  {
    "frequency": 670,
    "simplified": "恣意妄为",
    "traditional": "恣意妄為"
  },
  {
    "frequency": 670,
    "simplified": "彪形大汉",
    "traditional": "彪形大漢"
  },
  {
    "frequency": 670,
    "simplified": "胆大包天",
    "traditional": "膽大包天"
  },
  {
    "frequency": 670,
    "simplified": "事实胜于雄辩",
    "traditional": "事實勝於雄辯"
  },
  {
    "frequency": 670,
    "simplified": "天各一方",
    "traditional": "天各一方"
  },
  {
    "frequency": 669,
    "simplified": "栉风沐雨",
    "traditional": "櫛風沐雨"
  },
  {
    "frequency": 668,
    "simplified": "磨刀霍霍",
    "traditional": "磨刀霍霍"
  },
  {
    "frequency": 668,
    "simplified": "徘徊不前",
    "traditional": "徘徊不前"
  },
  {
    "frequency": 668,
    "simplified": "各持己见",
    "traditional": "各持己見"
  },
  {
    "frequency": 667,
    "simplified": "杂七杂八",
    "traditional": "雜七雜八"
  },
  {
    "frequency": 667,
    "simplified": "胜券在握",
    "traditional": "勝券在握"
  },
  {
    "frequency": 667,
    "simplified": "一手遮天",
    "traditional": "一手遮天"
  },
  {
    "frequency": 667,
    "simplified": "一言难尽",
    "traditional": "一言難盡"
  },
  {
    "frequency": 667,
    "simplified": "风言风语",
    "traditional": "風言風語"
  },
  {
    "frequency": 666,
    "simplified": "十年寒窗",
    "traditional": "十年寒窗"
  },
  {
    "frequency": 666,
    "simplified": "不乏其人",
    "traditional": "不乏其人"
  },
  {
    "frequency": 665,
    "simplified": "子子孙孙",
    "traditional": "子子孫孫"
  },
  {
    "frequency": 665,
    "simplified": "血战到底",
    "traditional": "血戰到底"
  },
  {
    "frequency": 665,
    "simplified": "瓮中捉鳖",
    "traditional": "甕中捉鱉"
  },
  {
    "frequency": 664,
    "simplified": "少言寡语",
    "traditional": "少言寡語"
  },
  {
    "frequency": 664,
    "simplified": "国色天香",
    "traditional": "國色天香"
  },
  {
    "frequency": 664,
    "simplified": "战无不胜",
    "traditional": "戰無不勝"
  },
  {
    "frequency": 663,
    "simplified": "拨云见日",
    "traditional": "撥雲見日"
  },
  {
    "frequency": 663,
    "simplified": "虚晃一枪",
    "traditional": "虛晃一槍"
  },
  {
    "frequency": 662,
    "simplified": "空前绝后",
    "traditional": "空前絕後"
  },
  {
    "frequency": 662,
    "simplified": "精神焕发",
    "traditional": "精神煥發"
  },
  {
    "frequency": 662,
    "simplified": "如临深渊",
    "traditional": "如臨深淵"
  },
  {
    "frequency": 662,
    "simplified": "缓兵之计",
    "traditional": "緩兵之計"
  },
  {
    "frequency": 661,
    "simplified": "鸿篇巨制",
    "traditional": "鴻篇鉅製"
  },
  {
    "frequency": 661,
    "simplified": "拍案而起",
    "traditional": "拍案而起"
  },
  {
    "frequency": 660,
    "simplified": "画蛇添足",
    "traditional": "畫蛇添足"
  },
  {
    "frequency": 660,
    "simplified": "朝思暮想",
    "traditional": "朝思暮想"
  },
  {
    "frequency": 660,
    "simplified": "巧妇难为无米之炊",
    "traditional": "巧婦難為無米之炊"
  },
  {
    "frequency": 660,
    "simplified": "凶神恶煞",
    "traditional": "凶神惡煞"
  },
  {
    "frequency": 658,
    "simplified": "大肆挥霍",
    "traditional": "大肆揮霍"
  },
  {
    "frequency": 658,
    "simplified": "改朝换代",
    "traditional": "改朝換代"
  },
  {
    "frequency": 658,
    "simplified": "胡搅蛮缠",
    "traditional": "胡攪蠻纏"
  },
  {
    "frequency": 657,
    "simplified": "乌合之众",
    "traditional": "烏合之眾"
  },
  {
    "frequency": 657,
    "simplified": "大禹治水",
    "traditional": "大禹治水"
  },
  {
    "frequency": 657,
    "simplified": "无恶不作",
    "traditional": "無惡不作"
  },
  {
    "frequency": 657,
    "simplified": "谁是谁非",
    "traditional": "誰是誰非"
  },
  {
    "frequency": 657,
    "simplified": "空头支票",
    "traditional": "空頭支票"
  },
  {
    "frequency": 656,
    "simplified": "雄伟壮观",
    "traditional": "雄偉壯觀"
  },
  {
    "frequency": 656,
    "simplified": "神出鬼没",
    "traditional": "神出鬼沒"
  },
  {
    "frequency": 655,
    "simplified": "争风吃醋",
    "traditional": "爭風吃醋"
  },
  {
    "frequency": 655,
    "simplified": "引以为荣",
    "traditional": "引以為榮"
  },
  {
    "frequency": 654,
    "simplified": "滴水成冰",
    "traditional": "滴水成冰"
  },
  {
    "frequency": 654,
    "simplified": "姓甚名谁",
    "traditional": "姓甚名誰"
  },
  {
    "frequency": 653,
    "simplified": "天下太平",
    "traditional": "天下太平"
  },
  {
    "frequency": 653,
    "simplified": "长命百岁",
    "traditional": "長命百歲"
  },
  {
    "frequency": 653,
    "simplified": "忘恩负义",
    "traditional": "忘恩負義"
  },
  {
    "frequency": 653,
    "simplified": "感情用事",
    "traditional": "感情用事"
  },
  {
    "frequency": 652,
    "simplified": "照章办事",
    "traditional": "照章辦事"
  },
  {
    "frequency": 652,
    "simplified": "容光焕发",
    "traditional": "容光煥發"
  },
  {
    "frequency": 652,
    "simplified": "传为美谈",
    "traditional": "傳為美談"
  },
  {
    "frequency": 651,
    "simplified": "穷兵黩武",
    "traditional": "窮兵黷武"
  },
  {
    "frequency": 650,
    "simplified": "一路顺风",
    "traditional": "一路順風"
  },
  {
    "frequency": 650,
    "simplified": "雷霆万钧",
    "traditional": "雷霆萬鈞"
  },
  {
    "frequency": 650,
    "simplified": "为国为民",
    "traditional": "為國為民"
  },
  {
    "frequency": 649,
    "simplified": "自食其果",
    "traditional": "自食其果"
  },
  {
    "frequency": 649,
    "simplified": "半推半就",
    "traditional": "半推半就"
  },
  {
    "frequency": 648,
    "simplified": "茅塞顿开",
    "traditional": "茅塞頓開"
  },
  {
    "frequency": 648,
    "simplified": "蛊惑人心",
    "traditional": "蠱惑人心"
  },
  {
    "frequency": 647,
    "simplified": "头重脚轻",
    "traditional": "頭重腳輕"
  },
  {
    "frequency": 647,
    "simplified": "念兹在兹",
    "traditional": "念茲在茲"
  },
  {
    "frequency": 646,
    "simplified": "趾高气扬",
    "traditional": "趾高氣揚"
  },
  {
    "frequency": 645,
    "simplified": "得而复失",
    "traditional": "得而復失"
  },
  {
    "frequency": 645,
    "simplified": "随遇而安",
    "traditional": "隨遇而安"
  },
  {
    "frequency": 644,
    "simplified": "旧事重提",
    "traditional": "舊事重提"
  },
  {
    "frequency": 644,
    "simplified": "无用武之地",
    "traditional": "無用武之地"
  },
  {
    "frequency": 644,
    "simplified": "形单影只",
    "traditional": "形單影隻"
  },
  {
    "frequency": 644,
    "simplified": "阴魂不散",
    "traditional": "陰魂不散"
  },
  {
    "frequency": 643,
    "simplified": "纲举目张",
    "traditional": "綱舉目張"
  },
  {
    "frequency": 643,
    "simplified": "死气沉沉",
    "traditional": "死氣沉沉"
  },
  {
    "frequency": 642,
    "simplified": "滂沱大雨",
    "traditional": "滂沱大雨"
  },
  {
    "frequency": 642,
    "simplified": "话不投机",
    "traditional": "話不投機"
  },
  {
    "frequency": 642,
    "simplified": "一言九鼎",
    "traditional": "一言九鼎"
  },
  {
    "frequency": 641,
    "simplified": "公说公有理",
    "traditional": "公說公有理"
  },
  {
    "frequency": 641,
    "simplified": "烟波浩渺",
    "traditional": "煙波浩渺"
  },
  {
    "frequency": 640,
    "simplified": "弹尽粮绝",
    "traditional": "彈盡糧絕"
  },
  {
    "frequency": 639,
    "simplified": "人间正道是沧桑",
    "traditional": "人間正道是滄桑"
  },
  {
    "frequency": 639,
    "simplified": "投笔从戎",
    "traditional": "投筆從戎"
  },
  {
    "frequency": 639,
    "simplified": "快刀斩乱麻",
    "traditional": "快刀斬亂麻"
  },
  {
    "frequency": 639,
    "simplified": "斗转星移",
    "traditional": "斗轉星移"
  },
  {
    "frequency": 638,
    "simplified": "豪情壮志",
    "traditional": "豪情壯志"
  },
  {
    "frequency": 638,
    "simplified": "婆婆妈妈",
    "traditional": "婆婆媽媽"
  },
  {
    "frequency": 637,
    "simplified": "一失足成千古恨",
    "traditional": "一失足成千古恨"
  },
  {
    "frequency": 637,
    "simplified": "强弩之末",
    "traditional": "強弩之末"
  },
  {
    "frequency": 637,
    "simplified": "各尽所能",
    "traditional": "各盡所能"
  },
  {
    "frequency": 637,
    "simplified": "大惑不解",
    "traditional": "大惑不解"
  },
  {
    "frequency": 637,
    "simplified": "十恶不赦",
    "traditional": "十惡不赦"
  },
  {
    "frequency": 637,
    "simplified": "错上加错",
    "traditional": "錯上加錯"
  },
  {
    "frequency": 637,
    "simplified": "大展宏图",
    "traditional": "大展宏圖"
  },
  {
    "frequency": 636,
    "simplified": "得意洋洋",
    "traditional": "得意洋洋"
  },
  {
    "frequency": 636,
    "simplified": "言无不尽",
    "traditional": "言無不盡"
  },
  {
    "frequency": 636,
    "simplified": "令人满意",
    "traditional": "令人滿意"
  },
  {
    "frequency": 636,
    "simplified": "似懂非懂",
    "traditional": "似懂非懂"
  },
  {
    "frequency": 636,
    "simplified": "见财起意",
    "traditional": "見財起意"
  },
  {
    "frequency": 635,
    "simplified": "由表及里",
    "traditional": "由表及裡"
  },
  {
    "frequency": 634,
    "simplified": "声东击西",
    "traditional": "聲東擊西"
  },
  {
    "frequency": 634,
    "simplified": "捶胸顿足",
    "traditional": "捶胸頓足"
  },
  {
    "frequency": 633,
    "simplified": "令人捧腹",
    "traditional": "令人捧腹"
  },
  {
    "frequency": 633,
    "simplified": "光辉灿烂",
    "traditional": "光輝燦爛"
  },
  {
    "frequency": 633,
    "simplified": "克敌制胜",
    "traditional": "克敵制勝"
  },
  {
    "frequency": 632,
    "simplified": "闭关锁国",
    "traditional": "閉關鎖國"
  },
  {
    "frequency": 632,
    "simplified": "歌功颂德",
    "traditional": "歌功頌德"
  },
  {
    "frequency": 631,
    "simplified": "动人心魄",
    "traditional": "動人心魄"
  },
  {
    "frequency": 630,
    "simplified": "关怀备至",
    "traditional": "關懷備至"
  },
  {
    "frequency": 628,
    "simplified": "避实就虚",
    "traditional": "避實就虛"
  },
  {
    "frequency": 628,
    "simplified": "鱼贯而出",
    "traditional": "魚貫而出"
  },
  {
    "frequency": 627,
    "simplified": "高抬贵手",
    "traditional": "高抬貴手"
  },
  {
    "frequency": 626,
    "simplified": "苦思冥想",
    "traditional": "苦思冥想"
  },
  {
    "frequency": 626,
    "simplified": "心心念念",
    "traditional": "心心念念"
  },
  {
    "frequency": 626,
    "simplified": "条分缕析",
    "traditional": "條分縷析"
  },
  {
    "frequency": 626,
    "simplified": "与世无争",
    "traditional": "與世無爭"
  },
  {
    "frequency": 625,
    "simplified": "伺机而动",
    "traditional": "伺機而動"
  },
  {
    "frequency": 625,
    "simplified": "迎风招展",
    "traditional": "迎風招展"
  },
  {
    "frequency": 625,
    "simplified": "闲言碎语",
    "traditional": "閒言碎語"
  },
  {
    "frequency": 624,
    "simplified": "大雅之堂",
    "traditional": "大雅之堂"
  },
  {
    "frequency": 624,
    "simplified": "唯唯诺诺",
    "traditional": "唯唯諾諾"
  },
  {
    "frequency": 624,
    "simplified": "提纲挈领",
    "traditional": "提綱挈領"
  },
  {
    "frequency": 624,
    "simplified": "千人一面",
    "traditional": "千人一面"
  },
  {
    "frequency": 623,
    "simplified": "三思而行",
    "traditional": "三思而行"
  },
  {
    "frequency": 622,
    "simplified": "调兵遣将",
    "traditional": "調兵遣將"
  },
  {
    "frequency": 620,
    "simplified": "前言不搭后语",
    "traditional": "前言不搭後語"
  },
  {
    "frequency": 620,
    "simplified": "适者生存",
    "traditional": "適者生存"
  },
  {
    "frequency": 620,
    "simplified": "树欲静而风不止",
    "traditional": "樹欲靜而風不止"
  },
  {
    "frequency": 620,
    "simplified": "大吉大利",
    "traditional": "大吉大利"
  },
  {
    "frequency": 619,
    "simplified": "谆谆告诫",
    "traditional": "諄諄告誡"
  },
  {
    "frequency": 618,
    "simplified": "长生不老",
    "traditional": "長生不老"
  },
  {
    "frequency": 618,
    "simplified": "无坚不摧",
    "traditional": "無堅不摧"
  },
  {
    "frequency": 617,
    "simplified": "眉开眼笑",
    "traditional": "眉開眼笑"
  },
  {
    "frequency": 617,
    "simplified": "语不惊人死不休",
    "traditional": "語不驚人死不休"
  },
  {
    "frequency": 617,
    "simplified": "火树银花",
    "traditional": "火樹銀花"
  },
  {
    "frequency": 616,
    "simplified": "一手包办",
    "traditional": "一手包辦"
  },
  {
    "frequency": 616,
    "simplified": "四书五经",
    "traditional": "四書五經"
  },
  {
    "frequency": 616,
    "simplified": "固若金汤",
    "traditional": "固若金湯"
  },
  {
    "frequency": 616,
    "simplified": "孤家寡人",
    "traditional": "孤家寡人"
  },
  {
    "frequency": 616,
    "simplified": "无师自通",
    "traditional": "無師自通"
  },
  {
    "frequency": 615,
    "simplified": "三顾茅庐",
    "traditional": "三顧茅廬"
  },
  {
    "frequency": 614,
    "simplified": "大腹便便",
    "traditional": "大腹便便"
  },
  {
    "frequency": 614,
    "simplified": "歌舞升平",
    "traditional": "歌舞昇平"
  },
  {
    "frequency": 614,
    "simplified": "势不两立",
    "traditional": "勢不兩立"
  },
  {
    "frequency": 614,
    "simplified": "养精蓄锐",
    "traditional": "養精蓄銳"
  },
  {
    "frequency": 613,
    "simplified": "一往情深",
    "traditional": "一往情深"
  },
  {
    "frequency": 612,
    "simplified": "苦尽甘来",
    "traditional": "苦盡甘來"
  },
  {
    "frequency": 612,
    "simplified": "优柔寡断",
    "traditional": "優柔寡斷"
  },
  {
    "frequency": 612,
    "simplified": "冥思苦想",
    "traditional": "冥思苦想"
  },
  {
    "frequency": 612,
    "simplified": "闻风而逃",
    "traditional": "聞風而逃"
  },
  {
    "frequency": 612,
    "simplified": "结结巴巴",
    "traditional": "結結巴巴"
  },
  {
    "frequency": 611,
    "simplified": "杀人放火",
    "traditional": "殺人放火"
  },
  {
    "frequency": 610,
    "simplified": "营私舞弊",
    "traditional": "營私舞弊"
  },
  {
    "frequency": 610,
    "simplified": "不修边幅",
    "traditional": "不修邊幅"
  },
  {
    "frequency": 610,
    "simplified": "眉毛胡子一把抓",
    "traditional": "眉毛鬍子一把抓"
  },
  {
    "frequency": 610,
    "simplified": "大笔一挥",
    "traditional": "大筆一揮"
  },
  {
    "frequency": 610,
    "simplified": "拉拉扯扯",
    "traditional": "拉拉扯扯"
  },
  {
    "frequency": 609,
    "simplified": "枯燥无味",
    "traditional": "枯燥無味"
  },
  {
    "frequency": 609,
    "simplified": "百闻不如一见",
    "traditional": "百聞不如一見"
  },
  {
    "frequency": 609,
    "simplified": "指鹿为马",
    "traditional": "指鹿為馬"
  },
  {
    "frequency": 609,
    "simplified": "盖棺定论",
    "traditional": "蓋棺定論"
  },
  {
    "frequency": 609,
    "simplified": "久别重逢",
    "traditional": "久別重逢"
  },
  {
    "frequency": 608,
    "simplified": "悔过自新",
    "traditional": "悔過自新"
  },
  {
    "frequency": 608,
    "simplified": "泛泛而谈",
    "traditional": "泛泛而談"
  },
  {
    "frequency": 607,
    "simplified": "投机倒把",
    "traditional": "投機倒把"
  },
  {
    "frequency": 606,
    "simplified": "赴汤蹈火",
    "traditional": "赴湯蹈火"
  },
  {
    "frequency": 606,
    "simplified": "奇谈怪论",
    "traditional": "奇談怪論"
  },
  {
    "frequency": 605,
    "simplified": "上下同心",
    "traditional": "上下同心"
  },
  {
    "frequency": 604,
    "simplified": "腰缠万贯",
    "traditional": "腰纏萬貫"
  },
  {
    "frequency": 604,
    "simplified": "饥不择食",
    "traditional": "飢不擇食"
  },
  {
    "frequency": 604,
    "simplified": "教学相长",
    "traditional": "教學相長"
  },
  {
    "frequency": 604,
    "simplified": "大材小用",
    "traditional": "大材小用"
  },
  {
    "frequency": 604,
    "simplified": "出师不利",
    "traditional": "出師不利"
  },
  {
    "frequency": 604,
    "simplified": "博览群书",
    "traditional": "博覽群書"
  },
  {
    "frequency": 604,
    "simplified": "众星捧月",
    "traditional": "眾星捧月"
  },
  {
    "frequency": 604,
    "simplified": "追本溯源",
    "traditional": "追本溯源"
  },
  {
    "frequency": 604,
    "simplified": "窥见一斑",
    "traditional": "窺見一斑"
  },
  {
    "frequency": 604,
    "simplified": "千真万确",
    "traditional": "千真萬確"
  },
  {
    "frequency": 603,
    "simplified": "单刀直入",
    "traditional": "單刀直入"
  },
  {
    "frequency": 603,
    "simplified": "智者见智",
    "traditional": "智者見智"
  },
  {
    "frequency": 603,
    "simplified": "吃大锅饭",
    "traditional": "吃大鍋飯"
  },
  {
    "frequency": 603,
    "simplified": "乐不可支",
    "traditional": "樂不可支"
  },
  {
    "frequency": 603,
    "simplified": "和气生财",
    "traditional": "和氣生財"
  },
  {
    "frequency": 601,
    "simplified": "民富国强",
    "traditional": "民富國強"
  },
  {
    "frequency": 601,
    "simplified": "瓜熟蒂落",
    "traditional": "瓜熟蒂落"
  },
  {
    "frequency": 600,
    "simplified": "机关算尽",
    "traditional": "機關算盡"
  },
  {
    "frequency": 600,
    "simplified": "无的放矢",
    "traditional": "無的放矢"
  },
  {
    "frequency": 599,
    "simplified": "年逾花甲",
    "traditional": "年逾花甲"
  },
  {
    "frequency": 599,
    "simplified": "满打满算",
    "traditional": "滿打滿算"
  },
  {
    "frequency": 599,
    "simplified": "花拳绣腿",
    "traditional": "花拳繡腿"
  },
  {
    "frequency": 599,
    "simplified": "大举进攻",
    "traditional": "大舉進攻"
  },
  {
    "frequency": 599,
    "simplified": "天女散花",
    "traditional": "天女散花"
  },
  {
    "frequency": 599,
    "simplified": "各不相让",
    "traditional": "各不相讓"
  },
  {
    "frequency": 598,
    "simplified": "俯拾皆是",
    "traditional": "俯拾皆是"
  },
  {
    "frequency": 598,
    "simplified": "陈规陋习",
    "traditional": "陳規陋習"
  },
  {
    "frequency": 598,
    "simplified": "惨无人道",
    "traditional": "慘無人道"
  },
  {
    "frequency": 597,
    "simplified": "无为而治",
    "traditional": "無為而治"
  },
  {
    "frequency": 597,
    "simplified": "浮光掠影",
    "traditional": "浮光掠影"
  },
  {
    "frequency": 597,
    "simplified": "一潭死水",
    "traditional": "一潭死水"
  },
  {
    "frequency": 597,
    "simplified": "一泻千里",
    "traditional": "一瀉千里"
  },
  {
    "frequency": 596,
    "simplified": "零零星星",
    "traditional": "零零星星"
  },
  {
    "frequency": 596,
    "simplified": "得意门生",
    "traditional": "得意門生"
  },
  {
    "frequency": 596,
    "simplified": "毕恭毕敬",
    "traditional": "畢恭畢敬"
  },
  {
    "frequency": 595,
    "simplified": "物极必反",
    "traditional": "物極必反"
  },
  {
    "frequency": 595,
    "simplified": "笑而不答",
    "traditional": "笑而不答"
  },
  {
    "frequency": 595,
    "simplified": "清官难断家务事",
    "traditional": "清官難斷家務事"
  },
  {
    "frequency": 595,
    "simplified": "荣华富贵",
    "traditional": "榮華富貴"
  },
  {
    "frequency": 594,
    "simplified": "疑神疑鬼",
    "traditional": "疑神疑鬼"
  },
  {
    "frequency": 594,
    "simplified": "日理万机",
    "traditional": "日理萬機"
  },
  {
    "frequency": 594,
    "simplified": "宁死不屈",
    "traditional": "寧死不屈"
  },
  {
    "frequency": 593,
    "simplified": "颠扑不破",
    "traditional": "顛撲不破"
  },
  {
    "frequency": 593,
    "simplified": "光宗耀祖",
    "traditional": "光宗耀祖"
  },
  {
    "frequency": 593,
    "simplified": "精雕细刻",
    "traditional": "精雕細刻"
  },
  {
    "frequency": 593,
    "simplified": "图谋不轨",
    "traditional": "圖謀不軌"
  },
  {
    "frequency": 593,
    "simplified": "成竹在胸",
    "traditional": "成竹在胸"
  },
  {
    "frequency": 592,
    "simplified": "忠心耿耿",
    "traditional": "忠心耿耿"
  },
  {
    "frequency": 591,
    "simplified": "有钱有势",
    "traditional": "有錢有勢"
  },
  {
    "frequency": 591,
    "simplified": "相持不下",
    "traditional": "相持不下"
  },
  {
    "frequency": 591,
    "simplified": "返老还童",
    "traditional": "返老還童"
  },
  {
    "frequency": 591,
    "simplified": "反唇相讥",
    "traditional": "反唇相譏"
  },
  {
    "frequency": 591,
    "simplified": "勿以恶小而为之",
    "traditional": "勿以惡小而為之"
  },
  {
    "frequency": 589,
    "simplified": "一花独放",
    "traditional": "一花獨放"
  },
  {
    "frequency": 589,
    "simplified": "哀鸿遍野",
    "traditional": "哀鴻遍野"
  },
  {
    "frequency": 589,
    "simplified": "造谣中伤",
    "traditional": "造謠中傷"
  },
  {
    "frequency": 588,
    "simplified": "十面埋伏",
    "traditional": "十面埋伏"
  },
  {
    "frequency": 587,
    "simplified": "飞扬跋扈",
    "traditional": "飛揚跋扈"
  },
  {
    "frequency": 587,
    "simplified": "争强好胜",
    "traditional": "爭強好勝"
  },
  {
    "frequency": 587,
    "simplified": "既往不咎",
    "traditional": "既往不咎"
  },
  {
    "frequency": 587,
    "simplified": "零敲碎打",
    "traditional": "零敲碎打"
  },
  {
    "frequency": 587,
    "simplified": "日进斗金",
    "traditional": "日進斗金"
  },
  {
    "frequency": 586,
    "simplified": "难兄难弟",
    "traditional": "難兄難弟"
  },
  {
    "frequency": 586,
    "simplified": "尔虞我诈",
    "traditional": "爾虞我詐"
  },
  {
    "frequency": 585,
    "simplified": "喜新厌旧",
    "traditional": "喜新厭舊"
  },
  {
    "frequency": 584,
    "simplified": "自顾不暇",
    "traditional": "自顧不暇"
  },
  {
    "frequency": 584,
    "simplified": "因祸得福",
    "traditional": "因禍得福"
  },
  {
    "frequency": 583,
    "simplified": "兹事体大",
    "traditional": "茲事體大"
  },
  {
    "frequency": 583,
    "simplified": "略胜一筹",
    "traditional": "略勝一籌"
  },
  {
    "frequency": 582,
    "simplified": "鼎鼎大名",
    "traditional": "鼎鼎大名"
  },
  {
    "frequency": 581,
    "simplified": "老当益壮",
    "traditional": "老當益壯"
  },
  {
    "frequency": 581,
    "simplified": "举不胜举",
    "traditional": "舉不勝舉"
  },
  {
    "frequency": 581,
    "simplified": "身外之物",
    "traditional": "身外之物"
  },
  {
    "frequency": 580,
    "simplified": "魔高一丈",
    "traditional": "魔高一丈"
  },
  {
    "frequency": 580,
    "simplified": "量力而为",
    "traditional": "量力而為"
  },
  {
    "frequency": 580,
    "simplified": "孤苦伶仃",
    "traditional": "孤苦伶仃"
  },
  {
    "frequency": 580,
    "simplified": "心直口快",
    "traditional": "心直口快"
  },
  {
    "frequency": 580,
    "simplified": "飒爽英姿",
    "traditional": "颯爽英姿"
  },
  {
    "frequency": 580,
    "simplified": "血肉相连",
    "traditional": "血肉相連"
  },
  {
    "frequency": 580,
    "simplified": "众叛亲离",
    "traditional": "眾叛親離"
  },
  {
    "frequency": 579,
    "simplified": "不惑之年",
    "traditional": "不惑之年"
  },
  {
    "frequency": 579,
    "simplified": "杀鸡儆猴",
    "traditional": "殺雞儆猴"
  },
  {
    "frequency": 578,
    "simplified": "赶尽杀绝",
    "traditional": "趕盡殺絕"
  },
  {
    "frequency": 578,
    "simplified": "千难万险",
    "traditional": "千難萬險"
  },
  {
    "frequency": 578,
    "simplified": "举世无双",
    "traditional": "舉世無雙"
  },
  {
    "frequency": 577,
    "simplified": "胆大心细",
    "traditional": "膽大心細"
  },
  {
    "frequency": 577,
    "simplified": "沧海一粟",
    "traditional": "滄海一粟"
  },
  {
    "frequency": 577,
    "simplified": "洋洋得意",
    "traditional": "洋洋得意"
  },
  {
    "frequency": 577,
    "simplified": "名落孙山",
    "traditional": "名落孫山"
  },
  {
    "frequency": 576,
    "simplified": "以貌取人",
    "traditional": "以貌取人"
  },
  {
    "frequency": 576,
    "simplified": "拐弯抹角",
    "traditional": "拐彎抹角"
  },
  {
    "frequency": 576,
    "simplified": "表里不一",
    "traditional": "表裡不一"
  },
  {
    "frequency": 575,
    "simplified": "乐极生悲",
    "traditional": "樂極生悲"
  },
  {
    "frequency": 575,
    "simplified": "解铃还须系铃人",
    "traditional": "解鈴還須繫鈴人"
  },
  {
    "frequency": 574,
    "simplified": "疾风骤雨",
    "traditional": "疾風驟雨"
  },
  {
    "frequency": 573,
    "simplified": "牙牙学语",
    "traditional": "牙牙學語"
  },
  {
    "frequency": 572,
    "simplified": "无边无际",
    "traditional": "無邊無際"
  },
  {
    "frequency": 572,
    "simplified": "情同手足",
    "traditional": "情同手足"
  },
  {
    "frequency": 572,
    "simplified": "公而忘私",
    "traditional": "公而忘私"
  },
  {
    "frequency": 572,
    "simplified": "三更半夜",
    "traditional": "三更半夜"
  },
  {
    "frequency": 572,
    "simplified": "天长日久",
    "traditional": "天長日久"
  },
  {
    "frequency": 571,
    "simplified": "行尸走肉",
    "traditional": "行屍走肉"
  },
  {
    "frequency": 571,
    "simplified": "有样学样",
    "traditional": "有樣學樣"
  },
  {
    "frequency": 570,
    "simplified": "挑三拣四",
    "traditional": "挑三揀四"
  },
  {
    "frequency": 570,
    "simplified": "忿忿不平",
    "traditional": "忿忿不平"
  },
  {
    "frequency": 570,
    "simplified": "龙腾虎跃",
    "traditional": "龍騰虎躍"
  },
  {
    "frequency": 570,
    "simplified": "息息相通",
    "traditional": "息息相通"
  },
  {
    "frequency": 570,
    "simplified": "春风吹又生",
    "traditional": "春風吹又生"
  },
  {
    "frequency": 569,
    "simplified": "奇货可居",
    "traditional": "奇貨可居"
  },
  {
    "frequency": 569,
    "simplified": "君子之交淡如水",
    "traditional": "君子之交淡如水"
  },
  {
    "frequency": 569,
    "simplified": "言而无信",
    "traditional": "言而無信"
  },
  {
    "frequency": 568,
    "simplified": "慷慨陈词",
    "traditional": "慷慨陳詞"
  },
  {
    "frequency": 568,
    "simplified": "救人一命",
    "traditional": "救人一命"
  },
  {
    "frequency": 567,
    "simplified": "画地为牢",
    "traditional": "畫地為牢"
  },
  {
    "frequency": 567,
    "simplified": "匠心独具",
    "traditional": "匠心獨具"
  },
  {
    "frequency": 567,
    "simplified": "龙马精神",
    "traditional": "龍馬精神"
  },
  {
    "frequency": 566,
    "simplified": "无机可乘",
    "traditional": "無機可乘"
  },
  {
    "frequency": 566,
    "simplified": "荒诞不经",
    "traditional": "荒誕不經"
  },
  {
    "frequency": 566,
    "simplified": "结党营私",
    "traditional": "結黨營私"
  },
  {
    "frequency": 566,
    "simplified": "人丁兴旺",
    "traditional": "人丁興旺"
  },
  {
    "frequency": 566,
    "simplified": "悔之晚矣",
    "traditional": "悔之晚矣"
  },
  {
    "frequency": 565,
    "simplified": "神来之笔",
    "traditional": "神來之筆"
  },
  {
    "frequency": 565,
    "simplified": "生不逢时",
    "traditional": "生不逢時"
  },
  {
    "frequency": 565,
    "simplified": "盲人摸象",
    "traditional": "盲人摸象"
  },
  {
    "frequency": 565,
    "simplified": "百花争艳",
    "traditional": "百花爭豔"
  },
  {
    "frequency": 564,
    "simplified": "寥寥可数",
    "traditional": "寥寥可數"
  },
  {
    "frequency": 564,
    "simplified": "为民请命",
    "traditional": "為民請命"
  },
  {
    "frequency": 564,
    "simplified": "腹背受敌",
    "traditional": "腹背受敵"
  },
  {
    "frequency": 564,
    "simplified": "恃强凌弱",
    "traditional": "恃強凌弱"
  },
  {
    "frequency": 563,
    "simplified": "为富不仁",
    "traditional": "為富不仁"
  },
  {
    "frequency": 563,
    "simplified": "得意忘形",
    "traditional": "得意忘形"
  },
  {
    "frequency": 563,
    "simplified": "丢三落四",
    "traditional": "丟三落四"
  },
  {
    "frequency": 562,
    "simplified": "大家闺秀",
    "traditional": "大家閨秀"
  },
  {
    "frequency": 562,
    "simplified": "厚颜无耻",
    "traditional": "厚顏無恥"
  },
  {
    "frequency": 562,
    "simplified": "响彻云霄",
    "traditional": "響徹雲霄"
  },
  {
    "frequency": 561,
    "simplified": "三长两短",
    "traditional": "三長兩短"
  },
  {
    "frequency": 560,
    "simplified": "斩草除根",
    "traditional": "斬草除根"
  },
  {
    "frequency": 560,
    "simplified": "万水千山",
    "traditional": "萬水千山"
  },
  {
    "frequency": 558,
    "simplified": "过眼云烟",
    "traditional": "過眼雲煙"
  },
  {
    "frequency": 558,
    "simplified": "解囊相助",
    "traditional": "解囊相助"
  },
  {
    "frequency": 558,
    "simplified": "假戏真做",
    "traditional": "假戲真做"
  },
  {
    "frequency": 558,
    "simplified": "坚贞不屈",
    "traditional": "堅貞不屈"
  },
  {
    "frequency": 557,
    "simplified": "挥霍无度",
    "traditional": "揮霍無度"
  },
  {
    "frequency": 557,
    "simplified": "草菅人命",
    "traditional": "草菅人命"
  },
  {
    "frequency": 557,
    "simplified": "管中窥豹",
    "traditional": "管中窺豹"
  },
  {
    "frequency": 556,
    "simplified": "寒来暑往",
    "traditional": "寒來暑往"
  },
  {
    "frequency": 555,
    "simplified": "沉渣泛起",
    "traditional": "沉渣泛起"
  },
  {
    "frequency": 555,
    "simplified": "舍生取义",
    "traditional": "捨生取義"
  },
  {
    "frequency": 555,
    "simplified": "发愤图强",
    "traditional": "發憤圖強"
  },
  {
    "frequency": 555,
    "simplified": "扬汤止沸",
    "traditional": "揚湯止沸"
  },
  {
    "frequency": 554,
    "simplified": "苟延残喘",
    "traditional": "苟延殘喘"
  },
  {
    "frequency": 553,
    "simplified": "鲜艳夺目",
    "traditional": "鮮豔奪目"
  },
  {
    "frequency": 552,
    "simplified": "和颜悦色",
    "traditional": "和顏悅色"
  },
  {
    "frequency": 551,
    "simplified": "索然无味",
    "traditional": "索然無味"
  },
  {
    "frequency": 550,
    "simplified": "颜面扫地",
    "traditional": "顏面掃地"
  },
  {
    "frequency": 550,
    "simplified": "作壁上观",
    "traditional": "作壁上觀"
  },
  {
    "frequency": 549,
    "simplified": "独此一家",
    "traditional": "獨此一家"
  },
  {
    "frequency": 549,
    "simplified": "隔岸观火",
    "traditional": "隔岸觀火"
  },
  {
    "frequency": 549,
    "simplified": "进退失据",
    "traditional": "進退失據"
  },
  {
    "frequency": 549,
    "simplified": "离乡背井",
    "traditional": "離鄉背井"
  },
  {
    "frequency": 549,
    "simplified": "沾亲带故",
    "traditional": "沾親帶故"
  },
  {
    "frequency": 549,
    "simplified": "别无二致",
    "traditional": "別無二致"
  },
  {
    "frequency": 548,
    "simplified": "挑肥拣瘦",
    "traditional": "挑肥揀瘦"
  },
  {
    "frequency": 548,
    "simplified": "认祖归宗",
    "traditional": "認祖歸宗"
  },
  {
    "frequency": 548,
    "simplified": "腥风血雨",
    "traditional": "腥風血雨"
  },
  {
    "frequency": 548,
    "simplified": "贯彻始终",
    "traditional": "貫徹始終"
  },
  {
    "frequency": 548,
    "simplified": "兴趣盎然",
    "traditional": "興趣盎然"
  },
  {
    "frequency": 547,
    "simplified": "开怀畅饮",
    "traditional": "開懷暢飲"
  },
  {
    "frequency": 547,
    "simplified": "人仰马翻",
    "traditional": "人仰馬翻"
  },
  {
    "frequency": 546,
    "simplified": "不徇私情",
    "traditional": "不徇私情"
  },
  {
    "frequency": 546,
    "simplified": "涂脂抹粉",
    "traditional": "塗脂抹粉"
  },
  {
    "frequency": 546,
    "simplified": "波澜起伏",
    "traditional": "波瀾起伏"
  },
  {
    "frequency": 545,
    "simplified": "通情达理",
    "traditional": "通情達理"
  },
  {
    "frequency": 545,
    "simplified": "何乐不为",
    "traditional": "何樂不為"
  },
  {
    "frequency": 545,
    "simplified": "六亲不认",
    "traditional": "六親不認"
  },
  {
    "frequency": 544,
    "simplified": "孤芳自赏",
    "traditional": "孤芳自賞"
  },
  {
    "frequency": 544,
    "simplified": "冷暖自知",
    "traditional": "冷暖自知"
  },
  {
    "frequency": 544,
    "simplified": "无妄之灾",
    "traditional": "無妄之災"
  },
  {
    "frequency": 544,
    "simplified": "长江后浪推前浪",
    "traditional": "長江後浪推前浪"
  },
  {
    "frequency": 544,
    "simplified": "弦外之音",
    "traditional": "弦外之音"
  },
  {
    "frequency": 544,
    "simplified": "富可敌国",
    "traditional": "富可敵國"
  },
  {
    "frequency": 544,
    "simplified": "真凭实据",
    "traditional": "真憑實據"
  },
  {
    "frequency": 543,
    "simplified": "人情冷暖",
    "traditional": "人情冷暖"
  },
  {
    "frequency": 542,
    "simplified": "不学无术",
    "traditional": "不學無術"
  },
  {
    "frequency": 541,
    "simplified": "浪子回头",
    "traditional": "浪子回頭"
  },
  {
    "frequency": 541,
    "simplified": "世道人心",
    "traditional": "世道人心"
  },
  {
    "frequency": 541,
    "simplified": "阿谀奉承",
    "traditional": "阿諛奉承"
  },
  {
    "frequency": 540,
    "simplified": "百尺竿头更进一步",
    "traditional": "百尺竿頭更進一步"
  },
  {
    "frequency": 540,
    "simplified": "自我牺牲",
    "traditional": "自我犧牲"
  },
  {
    "frequency": 540,
    "simplified": "天朗气清",
    "traditional": "天朗氣清"
  },
  {
    "frequency": 540,
    "simplified": "绝处逢生",
    "traditional": "絕處逢生"
  },
  {
    "frequency": 539,
    "simplified": "三下五除二",
    "traditional": "三下五除二"
  },
  {
    "frequency": 539,
    "simplified": "巧舌如簧",
    "traditional": "巧舌如簧"
  },
  {
    "frequency": 539,
    "simplified": "无可匹敌",
    "traditional": "無可匹敵"
  },
  {
    "frequency": 539,
    "simplified": "不值一驳",
    "traditional": "不值一駁"
  },
  {
    "frequency": 538,
    "simplified": "鳏寡孤独",
    "traditional": "鰥寡孤獨"
  },
  {
    "frequency": 538,
    "simplified": "造谣惑众",
    "traditional": "造謠惑眾"
  },
  {
    "frequency": 537,
    "simplified": "蜂拥而入",
    "traditional": "蜂擁而入"
  },
  {
    "frequency": 537,
    "simplified": "轻手轻脚",
    "traditional": "輕手輕腳"
  },
  {
    "frequency": 537,
    "simplified": "引吭高歌",
    "traditional": "引吭高歌"
  },
  {
    "frequency": 536,
    "simplified": "层峦叠嶂",
    "traditional": "層巒疊嶂"
  },
  {
    "frequency": 536,
    "simplified": "晚节不保",
    "traditional": "晚節不保"
  },
  {
    "frequency": 536,
    "simplified": "推三阻四",
    "traditional": "推三阻四"
  },
  {
    "frequency": 536,
    "simplified": "行百里者半九十",
    "traditional": "行百里者半九十"
  },
  {
    "frequency": 535,
    "simplified": "眉清目秀",
    "traditional": "眉清目秀"
  },
  {
    "frequency": 535,
    "simplified": "树大招风",
    "traditional": "樹大招風"
  },
  {
    "frequency": 535,
    "simplified": "英雄辈出",
    "traditional": "英雄輩出"
  },
  {
    "frequency": 533,
    "simplified": "道高一尺",
    "traditional": "道高一尺"
  },
  {
    "frequency": 533,
    "simplified": "身家性命",
    "traditional": "身家性命"
  },
  {
    "frequency": 533,
    "simplified": "奉公守法",
    "traditional": "奉公守法"
  },
  {
    "frequency": 532,
    "simplified": "歪打正着",
    "traditional": "歪打正著"
  },
  {
    "frequency": 532,
    "simplified": "真情实意",
    "traditional": "真情實意"
  },
  {
    "frequency": 532,
    "simplified": "鱼死网破",
    "traditional": "魚死網破"
  },
  {
    "frequency": 532,
    "simplified": "不能自已",
    "traditional": "不能自已"
  },
  {
    "frequency": 532,
    "simplified": "火急火燎",
    "traditional": "火急火燎"
  },
  {
    "frequency": 531,
    "simplified": "百发百中",
    "traditional": "百發百中"
  },
  {
    "frequency": 531,
    "simplified": "猴年马月",
    "traditional": "猴年馬月"
  },
  {
    "frequency": 531,
    "simplified": "略知一二",
    "traditional": "略知一二"
  },
  {
    "frequency": 531,
    "simplified": "临阵脱逃",
    "traditional": "臨陣脫逃"
  },
  {
    "frequency": 530,
    "simplified": "喜形于色",
    "traditional": "喜形於色"
  },
  {
    "frequency": 529,
    "simplified": "吃一堑长一智",
    "traditional": "吃一塹長一智"
  },
  {
    "frequency": 529,
    "simplified": "从中作梗",
    "traditional": "從中作梗"
  },
  {
    "frequency": 528,
    "simplified": "玩世不恭",
    "traditional": "玩世不恭"
  },
  {
    "frequency": 528,
    "simplified": "作茧自缚",
    "traditional": "作繭自縛"
  },
  {
    "frequency": 528,
    "simplified": "品头论足",
    "traditional": "品頭論足"
  },
  {
    "frequency": 527,
    "simplified": "世风日下",
    "traditional": "世風日下"
  },
  {
    "frequency": 527,
    "simplified": "星火燎原",
    "traditional": "星火燎原"
  },
  {
    "frequency": 527,
    "simplified": "瘦骨嶙峋",
    "traditional": "瘦骨嶙峋"
  },
  {
    "frequency": 527,
    "simplified": "其乐无穷",
    "traditional": "其樂無窮"
  },
  {
    "frequency": 526,
    "simplified": "明察秋毫",
    "traditional": "明察秋毫"
  },
  {
    "frequency": 526,
    "simplified": "鱼贯而入",
    "traditional": "魚貫而入"
  },
  {
    "frequency": 525,
    "simplified": "反败为胜",
    "traditional": "反敗為勝"
  },
  {
    "frequency": 525,
    "simplified": "熙来攘往",
    "traditional": "熙來攘往"
  },
  {
    "frequency": 525,
    "simplified": "翻云覆雨",
    "traditional": "翻雲覆雨"
  },
  {
    "frequency": 524,
    "simplified": "人人有份",
    "traditional": "人人有份"
  },
  {
    "frequency": 524,
    "simplified": "远走高飞",
    "traditional": "遠走高飛"
  },
  {
    "frequency": 524,
    "simplified": "惜字如金",
    "traditional": "惜字如金"
  },
  {
    "frequency": 524,
    "simplified": "贻害无穷",
    "traditional": "貽害無窮"
  },
  {
    "frequency": 524,
    "simplified": "失魂落魄",
    "traditional": "失魂落魄"
  },
  {
    "frequency": 523,
    "simplified": "有头有脸",
    "traditional": "有頭有臉"
  },
  {
    "frequency": 523,
    "simplified": "虚怀若谷",
    "traditional": "虛懷若谷"
  },
  {
    "frequency": 523,
    "simplified": "等闲视之",
    "traditional": "等閒視之"
  },
  {
    "frequency": 523,
    "simplified": "纷纷扰扰",
    "traditional": "紛紛擾擾"
  },
  {
    "frequency": 522,
    "simplified": "首尾相连",
    "traditional": "首尾相連"
  },
  {
    "frequency": 521,
    "simplified": "五体投地",
    "traditional": "五體投地"
  },
  {
    "frequency": 521,
    "simplified": "虚与委蛇",
    "traditional": "虛與委蛇"
  },
  {
    "frequency": 521,
    "simplified": "画饼充饥",
    "traditional": "畫餅充飢"
  },
  {
    "frequency": 521,
    "simplified": "黑白分明",
    "traditional": "黑白分明"
  },
  {
    "frequency": 520,
    "simplified": "争权夺利",
    "traditional": "爭權奪利"
  },
  {
    "frequency": 520,
    "simplified": "与民同乐",
    "traditional": "與民同樂"
  },
  {
    "frequency": 519,
    "simplified": "学贯中西",
    "traditional": "學貫中西"
  },
  {
    "frequency": 519,
    "simplified": "滔天罪行",
    "traditional": "滔天罪行"
  },
  {
    "frequency": 519,
    "simplified": "徒有虚名",
    "traditional": "徒有虛名"
  },
  {
    "frequency": 517,
    "simplified": "水天一色",
    "traditional": "水天一色"
  },
  {
    "frequency": 517,
    "simplified": "万古长青",
    "traditional": "萬古長青"
  },
  {
    "frequency": 517,
    "simplified": "白驹过隙",
    "traditional": "白駒過隙"
  },
  {
    "frequency": 517,
    "simplified": "食不果腹",
    "traditional": "食不果腹"
  },
  {
    "frequency": 517,
    "simplified": "十之八九",
    "traditional": "十之八九"
  },
  {
    "frequency": 517,
    "simplified": "爱憎分明",
    "traditional": "愛憎分明"
  },
  {
    "frequency": 517,
    "simplified": "生死相依",
    "traditional": "生死相依"
  },
  {
    "frequency": 517,
    "simplified": "鱼与熊掌",
    "traditional": "魚與熊掌"
  },
  {
    "frequency": 516,
    "simplified": "地主之谊",
    "traditional": "地主之誼"
  },
  {
    "frequency": 516,
    "simplified": "熟能生巧",
    "traditional": "熟能生巧"
  },
  {
    "frequency": 516,
    "simplified": "旗开得胜",
    "traditional": "旗開得勝"
  },
  {
    "frequency": 516,
    "simplified": "心动不如行动",
    "traditional": "心動不如行動"
  },
  {
    "frequency": 515,
    "simplified": "锋芒毕露",
    "traditional": "鋒芒畢露"
  },
  {
    "frequency": 515,
    "simplified": "翻江倒海",
    "traditional": "翻江倒海"
  },
  {
    "frequency": 515,
    "simplified": "反客为主",
    "traditional": "反客為主"
  },
  {
    "frequency": 514,
    "simplified": "下里巴人",
    "traditional": "下里巴人"
  },
  {
    "frequency": 514,
    "simplified": "点头称是",
    "traditional": "點頭稱是"
  },
  {
    "frequency": 514,
    "simplified": "各色各样",
    "traditional": "各色各樣"
  },
  {
    "frequency": 514,
    "simplified": "大权独揽",
    "traditional": "大權獨攬"
  },
  {
    "frequency": 514,
    "simplified": "言之有理",
    "traditional": "言之有理"
  },
  {
    "frequency": 513,
    "simplified": "习惯成自然",
    "traditional": "習慣成自然"
  },
  {
    "frequency": 513,
    "simplified": "生灵涂炭",
    "traditional": "生靈塗炭"
  },
  {
    "frequency": 513,
    "simplified": "偷鸡摸狗",
    "traditional": "偷雞摸狗"
  },
  {
    "frequency": 512,
    "simplified": "打肿脸充胖子",
    "traditional": "打腫臉充胖子"
  },
  {
    "frequency": 512,
    "simplified": "一叶障目",
    "traditional": "一葉障目"
  },
  {
    "frequency": 512,
    "simplified": "玉汝于成",
    "traditional": "玉汝於成"
  },
  {
    "frequency": 511,
    "simplified": "孑然一身",
    "traditional": "孑然一身"
  },
  {
    "frequency": 511,
    "simplified": "一颦一笑",
    "traditional": "一顰一笑"
  },
  {
    "frequency": 511,
    "simplified": "置之度外",
    "traditional": "置之度外"
  },
  {
    "frequency": 511,
    "simplified": "一举成功",
    "traditional": "一舉成功"
  },
  {
    "frequency": 510,
    "simplified": "不白之冤",
    "traditional": "不白之冤"
  },
  {
    "frequency": 509,
    "simplified": "胆小怕事",
    "traditional": "膽小怕事"
  },
  {
    "frequency": 509,
    "simplified": "吐故纳新",
    "traditional": "吐故納新"
  },
  {
    "frequency": 509,
    "simplified": "金童玉女",
    "traditional": "金童玉女"
  },
  {
    "frequency": 509,
    "simplified": "渔翁得利",
    "traditional": "漁翁得利"
  },
  {
    "frequency": 508,
    "simplified": "招贤纳士",
    "traditional": "招賢納士"
  },
  {
    "frequency": 508,
    "simplified": "出淤泥而不染",
    "traditional": "出淤泥而不染"
  },
  {
    "frequency": 508,
    "simplified": "丧权辱国",
    "traditional": "喪權辱國"
  },
  {
    "frequency": 508,
    "simplified": "言不由衷",
    "traditional": "言不由衷"
  },
  {
    "frequency": 508,
    "simplified": "破涕为笑",
    "traditional": "破涕為笑"
  },
  {
    "frequency": 508,
    "simplified": "道貌岸然",
    "traditional": "道貌岸然"
  },
  {
    "frequency": 507,
    "simplified": "为民除害",
    "traditional": "為民除害"
  },
  {
    "frequency": 507,
    "simplified": "不问青红皂白",
    "traditional": "不問青紅皂白"
  },
  {
    "frequency": 507,
    "simplified": "碧空如洗",
    "traditional": "碧空如洗"
  },
  {
    "frequency": 507,
    "simplified": "柳暗花明又一村",
    "traditional": "柳暗花明又一村"
  },
  {
    "frequency": 507,
    "simplified": "骄奢淫逸",
    "traditional": "驕奢淫逸"
  },
  {
    "frequency": 507,
    "simplified": "忠贞不渝",
    "traditional": "忠貞不渝"
  },
  {
    "frequency": 506,
    "simplified": "兼听则明",
    "traditional": "兼聽則明"
  },
  {
    "frequency": 506,
    "simplified": "心慈手软",
    "traditional": "心慈手軟"
  },
  {
    "frequency": 506,
    "simplified": "名满天下",
    "traditional": "名滿天下"
  },
  {
    "frequency": 505,
    "simplified": "具体而微",
    "traditional": "具體而微"
  },
  {
    "frequency": 505,
    "simplified": "悲天悯人",
    "traditional": "悲天憫人"
  },
  {
    "frequency": 504,
    "simplified": "固执己见",
    "traditional": "固執己見"
  },
  {
    "frequency": 504,
    "simplified": "吃不了兜着走",
    "traditional": "吃不了兜著走"
  },
  {
    "frequency": 504,
    "simplified": "一刀两断",
    "traditional": "一刀兩斷"
  },
  {
    "frequency": 504,
    "simplified": "鹿死谁手",
    "traditional": "鹿死誰手"
  },
  {
    "frequency": 504,
    "simplified": "无可救药",
    "traditional": "無可救藥"
  },
  {
    "frequency": 504,
    "simplified": "一官半职",
    "traditional": "一官半職"
  },
  {
    "frequency": 503,
    "simplified": "江河日下",
    "traditional": "江河日下"
  },
  {
    "frequency": 503,
    "simplified": "妄自尊大",
    "traditional": "妄自尊大"
  },
  {
    "frequency": 502,
    "simplified": "囫囵吞枣",
    "traditional": "囫圇吞棗"
  },
  {
    "frequency": 502,
    "simplified": "三心二意",
    "traditional": "三心二意"
  },
  {
    "frequency": 501,
    "simplified": "花枝招展",
    "traditional": "花枝招展"
  },
  {
    "frequency": 501,
    "simplified": "饱经风霜",
    "traditional": "飽經風霜"
  },
  {
    "frequency": 501,
    "simplified": "各显其能",
    "traditional": "各顯其能"
  },
  {
    "frequency": 501,
    "simplified": "夫唱妇随",
    "traditional": "夫唱婦隨"
  },
  {
    "frequency": 499,
    "simplified": "揠苗助长",
    "traditional": "揠苗助長"
  },
  {
    "frequency": 499,
    "simplified": "满山遍野",
    "traditional": "滿山遍野"
  },
  {
    "frequency": 499,
    "simplified": "含饴弄孙",
    "traditional": "含飴弄孫"
  },
  {
    "frequency": 499,
    "simplified": "丝丝入扣",
    "traditional": "絲絲入扣"
  },
  {
    "frequency": 498,
    "simplified": "偏听偏信",
    "traditional": "偏聽偏信"
  },
  {
    "frequency": 498,
    "simplified": "七情六欲",
    "traditional": "七情六慾"
  },
  {
    "frequency": 498,
    "simplified": "以柔克刚",
    "traditional": "以柔克剛"
  },
  {
    "frequency": 498,
    "simplified": "闭门不出",
    "traditional": "閉門不出"
  },
  {
    "frequency": 498,
    "simplified": "枕戈待旦",
    "traditional": "枕戈待旦"
  },
  {
    "frequency": 498,
    "simplified": "破旧立新",
    "traditional": "破舊立新"
  },
  {
    "frequency": 497,
    "simplified": "头昏眼花",
    "traditional": "頭昏眼花"
  },
  {
    "frequency": 497,
    "simplified": "罄竹难书",
    "traditional": "罄竹難書"
  },
  {
    "frequency": 497,
    "simplified": "有百害而无一利",
    "traditional": "有百害而無一利"
  },
  {
    "frequency": 497,
    "simplified": "魂飞魄散",
    "traditional": "魂飛魄散"
  },
  {
    "frequency": 497,
    "simplified": "破镜重圆",
    "traditional": "破鏡重圓"
  },
  {
    "frequency": 496,
    "simplified": "针尖对麦芒",
    "traditional": "針尖對麥芒"
  },
  {
    "frequency": 496,
    "simplified": "毫无疑义",
    "traditional": "毫無疑義"
  },
  {
    "frequency": 495,
    "simplified": "动人心弦",
    "traditional": "動人心絃"
  },
  {
    "frequency": 494,
    "simplified": "暗无天日",
    "traditional": "暗無天日"
  },
  {
    "frequency": 494,
    "simplified": "血流成河",
    "traditional": "血流成河"
  },
  {
    "frequency": 494,
    "simplified": "信口雌黄",
    "traditional": "信口雌黃"
  },
  {
    "frequency": 493,
    "simplified": "愤世嫉俗",
    "traditional": "憤世嫉俗"
  },
  {
    "frequency": 493,
    "simplified": "打情骂俏",
    "traditional": "打情罵俏"
  },
  {
    "frequency": 493,
    "simplified": "厉兵秣马",
    "traditional": "厲兵秣馬"
  },
  {
    "frequency": 492,
    "simplified": "有伤风化",
    "traditional": "有傷風化"
  },
  {
    "frequency": 492,
    "simplified": "红杏出墙",
    "traditional": "紅杏出牆"
  },
  {
    "frequency": 492,
    "simplified": "精忠报国",
    "traditional": "精忠報國"
  },
  {
    "frequency": 492,
    "simplified": "街坊四邻",
    "traditional": "街坊四鄰"
  },
  {
    "frequency": 492,
    "simplified": "兵临城下",
    "traditional": "兵臨城下"
  },
  {
    "frequency": 492,
    "simplified": "心如刀割",
    "traditional": "心如刀割"
  },
  {
    "frequency": 492,
    "simplified": "慈眉善目",
    "traditional": "慈眉善目"
  },
  {
    "frequency": 491,
    "simplified": "藏龙卧虎",
    "traditional": "藏龍臥虎"
  },
  {
    "frequency": 491,
    "simplified": "腾云驾雾",
    "traditional": "騰雲駕霧"
  },
  {
    "frequency": 491,
    "simplified": "风烛残年",
    "traditional": "風燭殘年"
  },
  {
    "frequency": 491,
    "simplified": "口惠而实不至",
    "traditional": "口惠而實不至"
  },
  {
    "frequency": 490,
    "simplified": "高不成低不就",
    "traditional": "高不成低不就"
  },
  {
    "frequency": 490,
    "simplified": "三头六臂",
    "traditional": "三頭六臂"
  },
  {
    "frequency": 490,
    "simplified": "鬼迷心窍",
    "traditional": "鬼迷心竅"
  },
  {
    "frequency": 489,
    "simplified": "挥洒自如",
    "traditional": "揮灑自如"
  },
  {
    "frequency": 489,
    "simplified": "文武双全",
    "traditional": "文武雙全"
  },
  {
    "frequency": 489,
    "simplified": "后发制人",
    "traditional": "後發制人"
  },
  {
    "frequency": 489,
    "simplified": "狼狈为奸",
    "traditional": "狼狽為奸"
  },
  {
    "frequency": 488,
    "simplified": "公事公办",
    "traditional": "公事公辦"
  },
  {
    "frequency": 488,
    "simplified": "别有风味",
    "traditional": "別有風味"
  },
  {
    "frequency": 487,
    "simplified": "义正辞严",
    "traditional": "義正辭嚴"
  },
  {
    "frequency": 487,
    "simplified": "金科玉律",
    "traditional": "金科玉律"
  },
  {
    "frequency": 487,
    "simplified": "貌合神离",
    "traditional": "貌合神離"
  },
  {
    "frequency": 486,
    "simplified": "狗急跳墙",
    "traditional": "狗急跳牆"
  },
  {
    "frequency": 486,
    "simplified": "借酒浇愁",
    "traditional": "借酒澆愁"
  },
  {
    "frequency": 486,
    "simplified": "隔行如隔山",
    "traditional": "隔行如隔山"
  },
  {
    "frequency": 486,
    "simplified": "男尊女卑",
    "traditional": "男尊女卑"
  },
  {
    "frequency": 486,
    "simplified": "花里胡哨",
    "traditional": "花裡胡哨"
  },
  {
    "frequency": 486,
    "simplified": "装腔作势",
    "traditional": "裝腔作勢"
  },
  {
    "frequency": 485,
    "simplified": "头痛医头脚痛医脚",
    "traditional": "頭痛醫頭腳痛醫腳"
  },
  {
    "frequency": 485,
    "simplified": "无病呻吟",
    "traditional": "無病呻吟"
  },
  {
    "frequency": 484,
    "simplified": "本固邦宁",
    "traditional": "本固邦寧"
  },
  {
    "frequency": 483,
    "simplified": "气吞山河",
    "traditional": "氣吞山河"
  },
  {
    "frequency": 483,
    "simplified": "忆苦思甜",
    "traditional": "憶苦思甜"
  },
  {
    "frequency": 483,
    "simplified": "兵荒马乱",
    "traditional": "兵荒馬亂"
  },
  {
    "frequency": 482,
    "simplified": "摧枯拉朽",
    "traditional": "摧枯拉朽"
  },
  {
    "frequency": 482,
    "simplified": "奇花异草",
    "traditional": "奇花異草"
  },
  {
    "frequency": 482,
    "simplified": "入情入理",
    "traditional": "入情入理"
  },
  {
    "frequency": 481,
    "simplified": "常胜将军",
    "traditional": "常勝將軍"
  },
  {
    "frequency": 481,
    "simplified": "铮铮铁骨",
    "traditional": "錚錚鐵骨"
  },
  {
    "frequency": 481,
    "simplified": "事不宜迟",
    "traditional": "事不宜遲"
  },
  {
    "frequency": 481,
    "simplified": "自相残杀",
    "traditional": "自相殘殺"
  },
  {
    "frequency": 480,
    "simplified": "难舍难分",
    "traditional": "難捨難分"
  },
  {
    "frequency": 480,
    "simplified": "妙手回春",
    "traditional": "妙手回春"
  },
  {
    "frequency": 480,
    "simplified": "奇耻大辱",
    "traditional": "奇恥大辱"
  },
  {
    "frequency": 480,
    "simplified": "变化莫测",
    "traditional": "變化莫測"
  },
  {
    "frequency": 480,
    "simplified": "山崩地裂",
    "traditional": "山崩地裂"
  },
  {
    "frequency": 480,
    "simplified": "卧虎藏龙",
    "traditional": "臥虎藏龍"
  },
  {
    "frequency": 480,
    "simplified": "周游列国",
    "traditional": "周遊列國"
  },
  {
    "frequency": 479,
    "simplified": "如入无人之境",
    "traditional": "如入無人之境"
  },
  {
    "frequency": 479,
    "simplified": "祸国殃民",
    "traditional": "禍國殃民"
  },
  {
    "frequency": 479,
    "simplified": "稳操胜券",
    "traditional": "穩操勝券"
  },
  {
    "frequency": 477,
    "simplified": "凶相毕露",
    "traditional": "兇相畢露"
  },
  {
    "frequency": 477,
    "simplified": "以毒攻毒",
    "traditional": "以毒攻毒"
  },
  {
    "frequency": 476,
    "simplified": "不惜工本",
    "traditional": "不惜工本"
  },
  {
    "frequency": 476,
    "simplified": "有始有终",
    "traditional": "有始有終"
  },
  {
    "frequency": 476,
    "simplified": "坐冷板凳",
    "traditional": "坐冷板凳"
  },
  {
    "frequency": 476,
    "simplified": "风雪交加",
    "traditional": "風雪交加"
  },
  {
    "frequency": 475,
    "simplified": "切中时弊",
    "traditional": "切中時弊"
  },
  {
    "frequency": 475,
    "simplified": "天昏地暗",
    "traditional": "天昏地暗"
  },
  {
    "frequency": 475,
    "simplified": "前仰后合",
    "traditional": "前仰後合"
  },
  {
    "frequency": 475,
    "simplified": "悲观厌世",
    "traditional": "悲觀厭世"
  },
  {
    "frequency": 475,
    "simplified": "珠光宝气",
    "traditional": "珠光寶氣"
  },
  {
    "frequency": 474,
    "simplified": "此地无银三百两",
    "traditional": "此地無銀三百兩"
  },
  {
    "frequency": 474,
    "simplified": "生死与共",
    "traditional": "生死與共"
  },
  {
    "frequency": 473,
    "simplified": "用武之地",
    "traditional": "用武之地"
  },
  {
    "frequency": 473,
    "simplified": "一来一往",
    "traditional": "一來一往"
  },
  {
    "frequency": 473,
    "simplified": "必先利其器",
    "traditional": "必先利其器"
  },
  {
    "frequency": 471,
    "simplified": "事必躬亲",
    "traditional": "事必躬親"
  },
  {
    "frequency": 471,
    "simplified": "春捂秋冻",
    "traditional": "春捂秋凍"
  },
  {
    "frequency": 471,
    "simplified": "金戈铁马",
    "traditional": "金戈鐵馬"
  },
  {
    "frequency": 471,
    "simplified": "血光之灾",
    "traditional": "血光之災"
  },
  {
    "frequency": 470,
    "simplified": "国富民强",
    "traditional": "國富民強"
  },
  {
    "frequency": 470,
    "simplified": "多难兴邦",
    "traditional": "多難興邦"
  },
  {
    "frequency": 470,
    "simplified": "多愁善感",
    "traditional": "多愁善感"
  },
  {
    "frequency": 470,
    "simplified": "大逆不道",
    "traditional": "大逆不道"
  },
  {
    "frequency": 469,
    "simplified": "在劫难逃",
    "traditional": "在劫難逃"
  },
  {
    "frequency": 469,
    "simplified": "昏天黑地",
    "traditional": "昏天黑地"
  },
  {
    "frequency": 469,
    "simplified": "灰心丧气",
    "traditional": "灰心喪氣"
  },
  {
    "frequency": 469,
    "simplified": "千里之行",
    "traditional": "千里之行"
  },
  {
    "frequency": 468,
    "simplified": "精兵简政",
    "traditional": "精兵簡政"
  },
  {
    "frequency": 468,
    "simplified": "自讨苦吃",
    "traditional": "自討苦吃"
  },
  {
    "frequency": 467,
    "simplified": "后会无期",
    "traditional": "後會無期"
  },
  {
    "frequency": 467,
    "simplified": "卖官鬻爵",
    "traditional": "賣官鬻爵"
  },
  {
    "frequency": 467,
    "simplified": "不谋其政",
    "traditional": "不謀其政"
  },
  {
    "frequency": 466,
    "simplified": "由近及远",
    "traditional": "由近及遠"
  },
  {
    "frequency": 466,
    "simplified": "死不瞑目",
    "traditional": "死不瞑目"
  },
  {
    "frequency": 466,
    "simplified": "恍如隔世",
    "traditional": "恍如隔世"
  },
  {
    "frequency": 466,
    "simplified": "如此而已",
    "traditional": "如此而已"
  },
  {
    "frequency": 465,
    "simplified": "情窦初开",
    "traditional": "情竇初開"
  },
  {
    "frequency": 464,
    "simplified": "聚众滋事",
    "traditional": "聚眾滋事"
  },
  {
    "frequency": 463,
    "simplified": "悲从中来",
    "traditional": "悲從中來"
  },
  {
    "frequency": 463,
    "simplified": "一不做二不休",
    "traditional": "一不做二不休"
  },
  {
    "frequency": 462,
    "simplified": "噤若寒蝉",
    "traditional": "噤若寒蟬"
  },
  {
    "frequency": 462,
    "simplified": "一望无垠",
    "traditional": "一望無垠"
  },
  {
    "frequency": 462,
    "simplified": "不管三七二十一",
    "traditional": "不管三七二十一"
  },
  {
    "frequency": 462,
    "simplified": "卿卿我我",
    "traditional": "卿卿我我"
  },
  {
    "frequency": 461,
    "simplified": "一吐为快",
    "traditional": "一吐為快"
  },
  {
    "frequency": 461,
    "simplified": "经营惨淡",
    "traditional": "經營慘淡"
  },
  {
    "frequency": 461,
    "simplified": "铁板钉钉",
    "traditional": "鐵板釘釘"
  },
  {
    "frequency": 461,
    "simplified": "畸轻畸重",
    "traditional": "畸輕畸重"
  },
  {
    "frequency": 460,
    "simplified": "瑞雪兆丰年",
    "traditional": "瑞雪兆豐年"
  },
  {
    "frequency": 460,
    "simplified": "口是心非",
    "traditional": "口是心非"
  },
  {
    "frequency": 460,
    "simplified": "中庸之道",
    "traditional": "中庸之道"
  },
  {
    "frequency": 460,
    "simplified": "去粗取精",
    "traditional": "去粗取精"
  },
  {
    "frequency": 459,
    "simplified": "苍松翠柏",
    "traditional": "蒼松翠柏"
  },
  {
    "frequency": 459,
    "simplified": "至理名言",
    "traditional": "至理名言"
  },
  {
    "frequency": 458,
    "simplified": "物华天宝",
    "traditional": "物華天寶"
  },
  {
    "frequency": 458,
    "simplified": "大喜过望",
    "traditional": "大喜過望"
  },
  {
    "frequency": 458,
    "simplified": "草草了事",
    "traditional": "草草了事"
  },
  {
    "frequency": 458,
    "simplified": "分毫不差",
    "traditional": "分毫不差"
  },
  {
    "frequency": 458,
    "simplified": "自作自受",
    "traditional": "自作自受"
  },
  {
    "frequency": 458,
    "simplified": "百依百顺",
    "traditional": "百依百順"
  },
  {
    "frequency": 458,
    "simplified": "作恶多端",
    "traditional": "作惡多端"
  },
  {
    "frequency": 458,
    "simplified": "一哄而起",
    "traditional": "一鬨而起"
  },
  {
    "frequency": 458,
    "simplified": "逍遥自在",
    "traditional": "逍遙自在"
  },
  {
    "frequency": 458,
    "simplified": "刻舟求剑",
    "traditional": "刻舟求劍"
  },
  {
    "frequency": 457,
    "simplified": "荒郊野外",
    "traditional": "荒郊野外"
  },
  {
    "frequency": 457,
    "simplified": "工欲善其事",
    "traditional": "工欲善其事"
  },
  {
    "frequency": 457,
    "simplified": "想入非非",
    "traditional": "想入非非"
  },
  {
    "frequency": 457,
    "simplified": "卓尔不群",
    "traditional": "卓爾不群"
  },
  {
    "frequency": 457,
    "simplified": "智勇双全",
    "traditional": "智勇雙全"
  },
  {
    "frequency": 457,
    "simplified": "才子佳人",
    "traditional": "才子佳人"
  },
  {
    "frequency": 456,
    "simplified": "藕断丝连",
    "traditional": "藕斷絲連"
  },
  {
    "frequency": 456,
    "simplified": "斯斯文文",
    "traditional": "斯斯文文"
  },
  {
    "frequency": 456,
    "simplified": "泰然自若",
    "traditional": "泰然自若"
  },
  {
    "frequency": 456,
    "simplified": "闻过则喜",
    "traditional": "聞過則喜"
  },
  {
    "frequency": 456,
    "simplified": "大步流星",
    "traditional": "大步流星"
  },
  {
    "frequency": 456,
    "simplified": "可望而不可即",
    "traditional": "可望而不可即"
  },
  {
    "frequency": 456,
    "simplified": "财源广进",
    "traditional": "財源廣進"
  },
  {
    "frequency": 455,
    "simplified": "尾大不掉",
    "traditional": "尾大不掉"
  },
  {
    "frequency": 454,
    "simplified": "山雨欲来风满楼",
    "traditional": "山雨欲來風滿樓"
  },
  {
    "frequency": 454,
    "simplified": "泰然处之",
    "traditional": "泰然處之"
  },
  {
    "frequency": 454,
    "simplified": "虎头虎脑",
    "traditional": "虎頭虎腦"
  },
  {
    "frequency": 454,
    "simplified": "宠辱不惊",
    "traditional": "寵辱不驚"
  },
  {
    "frequency": 454,
    "simplified": "自身难保",
    "traditional": "自身難保"
  },
  {
    "frequency": 453,
    "simplified": "深明大义",
    "traditional": "深明大義"
  },
  {
    "frequency": 453,
    "simplified": "一病不起",
    "traditional": "一病不起"
  },
  {
    "frequency": 452,
    "simplified": "故步自封",
    "traditional": "故步自封"
  },
  {
    "frequency": 452,
    "simplified": "尊师重道",
    "traditional": "尊師重道"
  },
  {
    "frequency": 452,
    "simplified": "无迹可寻",
    "traditional": "無跡可尋"
  },
  {
    "frequency": 452,
    "simplified": "骁勇善战",
    "traditional": "驍勇善戰"
  },
  {
    "frequency": 452,
    "simplified": "能言善辩",
    "traditional": "能言善辯"
  },
  {
    "frequency": 452,
    "simplified": "善男信女",
    "traditional": "善男信女"
  },
  {
    "frequency": 451,
    "simplified": "常备不懈",
    "traditional": "常備不懈"
  },
  {
    "frequency": 451,
    "simplified": "家有儿女",
    "traditional": "家有兒女"
  },
  {
    "frequency": 451,
    "simplified": "心存芥蒂",
    "traditional": "心存芥蒂"
  },
  {
    "frequency": 451,
    "simplified": "不能忘怀",
    "traditional": "不能忘懷"
  },
  {
    "frequency": 450,
    "simplified": "无出其右",
    "traditional": "無出其右"
  },
  {
    "frequency": 450,
    "simplified": "拂袖而去",
    "traditional": "拂袖而去"
  },
  {
    "frequency": 450,
    "simplified": "敲山震虎",
    "traditional": "敲山震虎"
  },
  {
    "frequency": 450,
    "simplified": "各执己见",
    "traditional": "各執己見"
  },
  {
    "frequency": 450,
    "simplified": "老骥伏枥",
    "traditional": "老驥伏櫪"
  },
  {
    "frequency": 450,
    "simplified": "襟怀坦白",
    "traditional": "襟懷坦白"
  },
  {
    "frequency": 449,
    "simplified": "战战兢兢",
    "traditional": "戰戰兢兢"
  },
  {
    "frequency": 449,
    "simplified": "童叟无欺",
    "traditional": "童叟無欺"
  },
  {
    "frequency": 449,
    "simplified": "说时迟那时快",
    "traditional": "說時遲那時快"
  },
  {
    "frequency": 449,
    "simplified": "垂死挣扎",
    "traditional": "垂死掙扎"
  },
  {
    "frequency": 449,
    "simplified": "比翼双飞",
    "traditional": "比翼雙飛"
  },
  {
    "frequency": 449,
    "simplified": "八面玲珑",
    "traditional": "八面玲瓏"
  },
  {
    "frequency": 448,
    "simplified": "永不磨灭",
    "traditional": "永不磨滅"
  },
  {
    "frequency": 448,
    "simplified": "自愧不如",
    "traditional": "自愧不如"
  },
  {
    "frequency": 448,
    "simplified": "丢人现眼",
    "traditional": "丟人現眼"
  },
  {
    "frequency": 447,
    "simplified": "串通一气",
    "traditional": "串通一氣"
  },
  {
    "frequency": 447,
    "simplified": "居心不良",
    "traditional": "居心不良"
  },
  {
    "frequency": 447,
    "simplified": "老谋深算",
    "traditional": "老謀深算"
  },
  {
    "frequency": 446,
    "simplified": "粗枝大叶",
    "traditional": "粗枝大葉"
  },
  {
    "frequency": 446,
    "simplified": "因时制宜",
    "traditional": "因時制宜"
  },
  {
    "frequency": 446,
    "simplified": "合而为一",
    "traditional": "合而為一"
  },
  {
    "frequency": 446,
    "simplified": "人事不省",
    "traditional": "人事不省"
  },
  {
    "frequency": 446,
    "simplified": "言而有信",
    "traditional": "言而有信"
  },
  {
    "frequency": 445,
    "simplified": "聊胜于无",
    "traditional": "聊勝於無"
  },
  {
    "frequency": 444,
    "simplified": "问寒问暖",
    "traditional": "問寒問暖"
  },
  {
    "frequency": 444,
    "simplified": "精明能干",
    "traditional": "精明能幹"
  },
  {
    "frequency": 443,
    "simplified": "颠倒是非",
    "traditional": "顛倒是非"
  },
  {
    "frequency": 443,
    "simplified": "一元复始",
    "traditional": "一元復始"
  },
  {
    "frequency": 443,
    "simplified": "啧有烦言",
    "traditional": "嘖有煩言"
  },
  {
    "frequency": 443,
    "simplified": "哑然失笑",
    "traditional": "啞然失笑"
  },
  {
    "frequency": 443,
    "simplified": "礼义廉耻",
    "traditional": "禮義廉恥"
  },
  {
    "frequency": 442,
    "simplified": "老态龙钟",
    "traditional": "老態龍鍾"
  },
  {
    "frequency": 442,
    "simplified": "漫无边际",
    "traditional": "漫無邊際"
  },
  {
    "frequency": 442,
    "simplified": "男女有别",
    "traditional": "男女有別"
  },
  {
    "frequency": 441,
    "simplified": "坐收渔利",
    "traditional": "坐收漁利"
  },
  {
    "frequency": 441,
    "simplified": "感激涕零",
    "traditional": "感激涕零"
  },
  {
    "frequency": 441,
    "simplified": "童心未泯",
    "traditional": "童心未泯"
  },
  {
    "frequency": 441,
    "simplified": "感恩戴德",
    "traditional": "感恩戴德"
  },
  {
    "frequency": 441,
    "simplified": "冲昏头脑",
    "traditional": "衝昏頭腦"
  },
  {
    "frequency": 440,
    "simplified": "天方夜谭",
    "traditional": "天方夜譚"
  },
  {
    "frequency": 440,
    "simplified": "捉摸不定",
    "traditional": "捉摸不定"
  },
  {
    "frequency": 440,
    "simplified": "气宇轩昂",
    "traditional": "氣宇軒昂"
  },
  {
    "frequency": 440,
    "simplified": "极目远眺",
    "traditional": "極目遠眺"
  },
  {
    "frequency": 439,
    "simplified": "高深莫测",
    "traditional": "高深莫測"
  },
  {
    "frequency": 439,
    "simplified": "扭扭捏捏",
    "traditional": "扭扭捏捏"
  },
  {
    "frequency": 439,
    "simplified": "见钱眼开",
    "traditional": "見錢眼開"
  },
  {
    "frequency": 438,
    "simplified": "左右开弓",
    "traditional": "左右開弓"
  },
  {
    "frequency": 438,
    "simplified": "狂风骤雨",
    "traditional": "狂風驟雨"
  },
  {
    "frequency": 438,
    "simplified": "靠水吃水",
    "traditional": "靠水吃水"
  },
  {
    "frequency": 438,
    "simplified": "面黄肌瘦",
    "traditional": "面黃肌瘦"
  },
  {
    "frequency": 437,
    "simplified": "有勇有谋",
    "traditional": "有勇有謀"
  },
  {
    "frequency": 437,
    "simplified": "百口莫辩",
    "traditional": "百口莫辯"
  },
  {
    "frequency": 437,
    "simplified": "高山仰止",
    "traditional": "高山仰止"
  },
  {
    "frequency": 436,
    "simplified": "兴师问罪",
    "traditional": "興師問罪"
  },
  {
    "frequency": 436,
    "simplified": "水滴石穿",
    "traditional": "水滴石穿"
  },
  {
    "frequency": 435,
    "simplified": "心腹大患",
    "traditional": "心腹大患"
  },
  {
    "frequency": 435,
    "simplified": "大书特书",
    "traditional": "大書特書"
  },
  {
    "frequency": 434,
    "simplified": "改天换地",
    "traditional": "改天換地"
  },
  {
    "frequency": 434,
    "simplified": "恩将仇报",
    "traditional": "恩將仇報"
  },
  {
    "frequency": 433,
    "simplified": "弥天大谎",
    "traditional": "彌天大謊"
  },
  {
    "frequency": 433,
    "simplified": "来者不善",
    "traditional": "來者不善"
  },
  {
    "frequency": 433,
    "simplified": "人间地狱",
    "traditional": "人間地獄"
  },
  {
    "frequency": 433,
    "simplified": "放长线钓大鱼",
    "traditional": "放長線釣大魚"
  },
  {
    "frequency": 432,
    "simplified": "奔流不息",
    "traditional": "奔流不息"
  },
  {
    "frequency": 432,
    "simplified": "曲终人散",
    "traditional": "曲終人散"
  },
  {
    "frequency": 432,
    "simplified": "谦谦君子",
    "traditional": "謙謙君子"
  },
  {
    "frequency": 432,
    "simplified": "龙飞凤舞",
    "traditional": "龍飛鳳舞"
  },
  {
    "frequency": 432,
    "simplified": "幡然悔悟",
    "traditional": "幡然悔悟"
  },
  {
    "frequency": 432,
    "simplified": "古道热肠",
    "traditional": "古道熱腸"
  },
  {
    "frequency": 431,
    "simplified": "鸡犬升天",
    "traditional": "雞犬升天"
  },
  {
    "frequency": 431,
    "simplified": "丈二和尚摸不着头脑",
    "traditional": "丈二和尚摸不著頭腦"
  },
  {
    "frequency": 430,
    "simplified": "故态复萌",
    "traditional": "故態復萌"
  },
  {
    "frequency": 430,
    "simplified": "手到擒来",
    "traditional": "手到擒來"
  },
  {
    "frequency": 430,
    "simplified": "怀才不遇",
    "traditional": "懷才不遇"
  },
  {
    "frequency": 429,
    "simplified": "人心不古",
    "traditional": "人心不古"
  },
  {
    "frequency": 429,
    "simplified": "触类旁通",
    "traditional": "觸類旁通"
  },
  {
    "frequency": 429,
    "simplified": "余音绕梁",
    "traditional": "餘音繞梁"
  },
  {
    "frequency": 429,
    "simplified": "千里之堤",
    "traditional": "千里之堤"
  },
  {
    "frequency": 428,
    "simplified": "数典忘祖",
    "traditional": "數典忘祖"
  },
  {
    "frequency": 428,
    "simplified": "师出有名",
    "traditional": "師出有名"
  },
  {
    "frequency": 428,
    "simplified": "滚瓜烂熟",
    "traditional": "滾瓜爛熟"
  },
  {
    "frequency": 428,
    "simplified": "分而治之",
    "traditional": "分而治之"
  },
  {
    "frequency": 427,
    "simplified": "及时行乐",
    "traditional": "及時行樂"
  },
  {
    "frequency": 427,
    "simplified": "战天斗地",
    "traditional": "戰天鬥地"
  },
  {
    "frequency": 427,
    "simplified": "楚楚动人",
    "traditional": "楚楚動人"
  },
  {
    "frequency": 426,
    "simplified": "何必当初",
    "traditional": "何必當初"
  },
  {
    "frequency": 426,
    "simplified": "虚情假意",
    "traditional": "虛情假意"
  },
  {
    "frequency": 426,
    "simplified": "干净利索",
    "traditional": "乾淨利索"
  },
  {
    "frequency": 426,
    "simplified": "半死不活",
    "traditional": "半死不活"
  },
  {
    "frequency": 426,
    "simplified": "海誓山盟",
    "traditional": "海誓山盟"
  },
  {
    "frequency": 426,
    "simplified": "臭不可闻",
    "traditional": "臭不可聞"
  },
  {
    "frequency": 425,
    "simplified": "肝肠寸断",
    "traditional": "肝腸寸斷"
  },
  {
    "frequency": 425,
    "simplified": "一统天下",
    "traditional": "一統天下"
  },
  {
    "frequency": 424,
    "simplified": "自吹自擂",
    "traditional": "自吹自擂"
  },
  {
    "frequency": 424,
    "simplified": "删繁就简",
    "traditional": "刪繁就簡"
  },
  {
    "frequency": 424,
    "simplified": "魔高一尺",
    "traditional": "魔高一尺"
  },
  {
    "frequency": 424,
    "simplified": "分外妖娆",
    "traditional": "分外妖嬈"
  },
  {
    "frequency": 424,
    "simplified": "不露声色",
    "traditional": "不露聲色"
  },
  {
    "frequency": 423,
    "simplified": "转眼之间",
    "traditional": "轉眼之間"
  },
  {
    "frequency": 423,
    "simplified": "打入冷宫",
    "traditional": "打入冷宮"
  },
  {
    "frequency": 422,
    "simplified": "如胶似漆",
    "traditional": "如膠似漆"
  },
  {
    "frequency": 422,
    "simplified": "三教九流",
    "traditional": "三教九流"
  },
  {
    "frequency": 422,
    "simplified": "龇牙咧嘴",
    "traditional": "齜牙咧嘴"
  },
  {
    "frequency": 422,
    "simplified": "群起而攻之",
    "traditional": "群起而攻之"
  },
  {
    "frequency": 422,
    "simplified": "旖旎风光",
    "traditional": "旖旎風光"
  },
  {
    "frequency": 422,
    "simplified": "同床异梦",
    "traditional": "同床異夢"
  },
  {
    "frequency": 422,
    "simplified": "人心涣散",
    "traditional": "人心渙散"
  },
  {
    "frequency": 421,
    "simplified": "鸡飞狗跳",
    "traditional": "雞飛狗跳"
  },
  {
    "frequency": 421,
    "simplified": "人无完人",
    "traditional": "人無完人"
  },
  {
    "frequency": 421,
    "simplified": "糊里糊涂",
    "traditional": "糊里糊塗"
  },
  {
    "frequency": 420,
    "simplified": "朝发夕至",
    "traditional": "朝發夕至"
  },
  {
    "frequency": 420,
    "simplified": "欢声雷动",
    "traditional": "歡聲雷動"
  },
  {
    "frequency": 420,
    "simplified": "盛情难却",
    "traditional": "盛情難卻"
  },
  {
    "frequency": 420,
    "simplified": "谈虎色变",
    "traditional": "談虎色變"
  },
  {
    "frequency": 420,
    "simplified": "罪加一等",
    "traditional": "罪加一等"
  },
  {
    "frequency": 420,
    "simplified": "世态炎凉",
    "traditional": "世態炎涼"
  },
  {
    "frequency": 420,
    "simplified": "以德报怨",
    "traditional": "以德報怨"
  },
  {
    "frequency": 419,
    "simplified": "乔迁之喜",
    "traditional": "喬遷之喜"
  },
  {
    "frequency": 419,
    "simplified": "殃及池鱼",
    "traditional": "殃及池魚"
  },
  {
    "frequency": 419,
    "simplified": "大雨如注",
    "traditional": "大雨如注"
  },
  {
    "frequency": 419,
    "simplified": "庞然大物",
    "traditional": "龐然大物"
  },
  {
    "frequency": 418,
    "simplified": "瓜田李下",
    "traditional": "瓜田李下"
  },
  {
    "frequency": 418,
    "simplified": "授人以柄",
    "traditional": "授人以柄"
  },
  {
    "frequency": 418,
    "simplified": "群英荟萃",
    "traditional": "群英薈萃"
  },
  {
    "frequency": 418,
    "simplified": "论功行赏",
    "traditional": "論功行賞"
  },
  {
    "frequency": 418,
    "simplified": "塞上江南",
    "traditional": "塞上江南"
  },
  {
    "frequency": 417,
    "simplified": "起承转合",
    "traditional": "起承轉合"
  },
  {
    "frequency": 417,
    "simplified": "壮志豪情",
    "traditional": "壯志豪情"
  },
  {
    "frequency": 417,
    "simplified": "小家子气",
    "traditional": "小家子氣"
  },
  {
    "frequency": 417,
    "simplified": "人亡政息",
    "traditional": "人亡政息"
  },
  {
    "frequency": 417,
    "simplified": "东施效颦",
    "traditional": "東施效顰"
  },
  {
    "frequency": 417,
    "simplified": "时势造英雄",
    "traditional": "時勢造英雄"
  },
  {
    "frequency": 417,
    "simplified": "饭来张口",
    "traditional": "飯來張口"
  },
  {
    "frequency": 417,
    "simplified": "乘人之危",
    "traditional": "乘人之危"
  },
  {
    "frequency": 417,
    "simplified": "远涉重洋",
    "traditional": "遠涉重洋"
  },
  {
    "frequency": 417,
    "simplified": "不三不四",
    "traditional": "不三不四"
  },
  {
    "frequency": 417,
    "simplified": "妖魔鬼怪",
    "traditional": "妖魔鬼怪"
  },
  {
    "frequency": 417,
    "simplified": "拱手相让",
    "traditional": "拱手相讓"
  },
  {
    "frequency": 416,
    "simplified": "削足适履",
    "traditional": "削足適履"
  },
  {
    "frequency": 416,
    "simplified": "形势逼人",
    "traditional": "形勢逼人"
  },
  {
    "frequency": 415,
    "simplified": "五雷轰顶",
    "traditional": "五雷轟頂"
  },
  {
    "frequency": 415,
    "simplified": "抱成一团",
    "traditional": "抱成一團"
  },
  {
    "frequency": 415,
    "simplified": "功名利禄",
    "traditional": "功名利祿"
  },
  {
    "frequency": 415,
    "simplified": "良辰吉日",
    "traditional": "良辰吉日"
  },
  {
    "frequency": 415,
    "simplified": "百战不殆",
    "traditional": "百戰不殆"
  },
  {
    "frequency": 414,
    "simplified": "奖罚分明",
    "traditional": "獎罰分明"
  },
  {
    "frequency": 414,
    "simplified": "不堪入耳",
    "traditional": "不堪入耳"
  },
  {
    "frequency": 414,
    "simplified": "洋为中用",
    "traditional": "洋為中用"
  },
  {
    "frequency": 413,
    "simplified": "附庸风雅",
    "traditional": "附庸風雅"
  },
  {
    "frequency": 413,
    "simplified": "孟母三迁",
    "traditional": "孟母三遷"
  },
  {
    "frequency": 413,
    "simplified": "入室弟子",
    "traditional": "入室弟子"
  },
  {
    "frequency": 413,
    "simplified": "生气勃勃",
    "traditional": "生氣勃勃"
  },
  {
    "frequency": 413,
    "simplified": "国难当头",
    "traditional": "國難當頭"
  },
  {
    "frequency": 413,
    "simplified": "泪如泉涌",
    "traditional": "淚如泉湧"
  },
  {
    "frequency": 412,
    "simplified": "寓意深远",
    "traditional": "寓意深遠"
  },
  {
    "frequency": 412,
    "simplified": "闲情逸致",
    "traditional": "閒情逸致"
  },
  {
    "frequency": 412,
    "simplified": "弃之可惜",
    "traditional": "棄之可惜"
  },
  {
    "frequency": 412,
    "simplified": "若有若无",
    "traditional": "若有若無"
  },
  {
    "frequency": 412,
    "simplified": "一语双关",
    "traditional": "一語雙關"
  },
  {
    "frequency": 411,
    "simplified": "飞禽走兽",
    "traditional": "飛禽走獸"
  },
  {
    "frequency": 411,
    "simplified": "牛郎织女",
    "traditional": "牛郎織女"
  },
  {
    "frequency": 411,
    "simplified": "莺歌燕舞",
    "traditional": "鶯歌燕舞"
  },
  {
    "frequency": 411,
    "simplified": "集腋成裘",
    "traditional": "集腋成裘"
  },
  {
    "frequency": 411,
    "simplified": "半生不熟",
    "traditional": "半生不熟"
  },
  {
    "frequency": 411,
    "simplified": "百战百胜",
    "traditional": "百戰百勝"
  },
  {
    "frequency": 411,
    "simplified": "财迷心窍",
    "traditional": "財迷心竅"
  },
  {
    "frequency": 410,
    "simplified": "风霜雨雪",
    "traditional": "風霜雨雪"
  },
  {
    "frequency": 410,
    "simplified": "事不关己高高挂起",
    "traditional": "事不關己高高掛起"
  },
  {
    "frequency": 410,
    "simplified": "皮之不存",
    "traditional": "皮之不存"
  },
  {
    "frequency": 410,
    "simplified": "披头散发",
    "traditional": "披頭散髮"
  },
  {
    "frequency": 410,
    "simplified": "倾巢而出",
    "traditional": "傾巢而出"
  },
  {
    "frequency": 409,
    "simplified": "天涯若比邻",
    "traditional": "天涯若比鄰"
  },
  {
    "frequency": 409,
    "simplified": "道高一丈",
    "traditional": "道高一丈"
  },
  {
    "frequency": 409,
    "simplified": "咬紧牙关",
    "traditional": "咬緊牙關"
  },
  {
    "frequency": 409,
    "simplified": "目中无人",
    "traditional": "目中無人"
  },
  {
    "frequency": 409,
    "simplified": "汗如雨下",
    "traditional": "汗如雨下"
  },
  {
    "frequency": 408,
    "simplified": "束手束脚",
    "traditional": "束手束腳"
  },
  {
    "frequency": 408,
    "simplified": "揭竿而起",
    "traditional": "揭竿而起"
  },
  {
    "frequency": 407,
    "simplified": "拍案惊奇",
    "traditional": "拍案驚奇"
  },
  {
    "frequency": 407,
    "simplified": "追根究底",
    "traditional": "追根究底"
  },
  {
    "frequency": 406,
    "simplified": "大家风范",
    "traditional": "大家風範"
  },
  {
    "frequency": 406,
    "simplified": "昼夜兼程",
    "traditional": "晝夜兼程"
  },
  {
    "frequency": 405,
    "simplified": "面不改色",
    "traditional": "面不改色"
  },
  {
    "frequency": 405,
    "simplified": "稳如泰山",
    "traditional": "穩如泰山"
  },
  {
    "frequency": 405,
    "simplified": "三十六计",
    "traditional": "三十六計"
  },
  {
    "frequency": 405,
    "simplified": "事后诸葛亮",
    "traditional": "事後諸葛亮"
  },
  {
    "frequency": 404,
    "simplified": "搬弄是非",
    "traditional": "搬弄是非"
  },
  {
    "frequency": 404,
    "simplified": "情非得已",
    "traditional": "情非得已"
  },
  {
    "frequency": 404,
    "simplified": "望穿秋水",
    "traditional": "望穿秋水"
  },
  {
    "frequency": 403,
    "simplified": "风姿绰约",
    "traditional": "風姿綽約"
  },
  {
    "frequency": 403,
    "simplified": "黔驴技穷",
    "traditional": "黔驢技窮"
  },
  {
    "frequency": 403,
    "simplified": "叠床架屋",
    "traditional": "疊床架屋"
  },
  {
    "frequency": 402,
    "simplified": "百般刁难",
    "traditional": "百般刁難"
  },
  {
    "frequency": 402,
    "simplified": "闲杂人等",
    "traditional": "閒雜人等"
  },
  {
    "frequency": 401,
    "simplified": "殷鉴不远",
    "traditional": "殷鑑不遠"
  },
  {
    "frequency": 401,
    "simplified": "影影绰绰",
    "traditional": "影影綽綽"
  },
  {
    "frequency": 401,
    "simplified": "无亲无故",
    "traditional": "無親無故"
  },
  {
    "frequency": 401,
    "simplified": "不可救药",
    "traditional": "不可救藥"
  },
  {
    "frequency": 400,
    "simplified": "火中取栗",
    "traditional": "火中取栗"
  },
  {
    "frequency": 400,
    "simplified": "奉为圭臬",
    "traditional": "奉為圭臬"
  },
  {
    "frequency": 400,
    "simplified": "生财有道",
    "traditional": "生財有道"
  },
  {
    "frequency": 400,
    "simplified": "笼络人心",
    "traditional": "籠絡人心"
  },
  {
    "frequency": 399,
    "simplified": "不破不立",
    "traditional": "不破不立"
  },
  {
    "frequency": 399,
    "simplified": "黄道吉日",
    "traditional": "黃道吉日"
  },
  {
    "frequency": 399,
    "simplified": "化零为整",
    "traditional": "化零為整"
  },
  {
    "frequency": 399,
    "simplified": "惶惶不安",
    "traditional": "惶惶不安"
  },
  {
    "frequency": 399,
    "simplified": "依葫芦画瓢",
    "traditional": "依葫蘆畫瓢"
  },
  {
    "frequency": 399,
    "simplified": "造谣生事",
    "traditional": "造謠生事"
  },
  {
    "frequency": 398,
    "simplified": "上情下达",
    "traditional": "上情下達"
  },
  {
    "frequency": 398,
    "simplified": "开山鼻祖",
    "traditional": "開山鼻祖"
  },
  {
    "frequency": 398,
    "simplified": "野火烧不尽",
    "traditional": "野火燒不盡"
  },
  {
    "frequency": 397,
    "simplified": "皮开肉绽",
    "traditional": "皮開肉綻"
  },
  {
    "frequency": 397,
    "simplified": "嬉皮笑脸",
    "traditional": "嬉皮笑臉"
  },
  {
    "frequency": 397,
    "simplified": "大器晚成",
    "traditional": "大器晚成"
  },
  {
    "frequency": 397,
    "simplified": "一鼻子灰",
    "traditional": "一鼻子灰"
  },
  {
    "frequency": 397,
    "simplified": "倾巢出动",
    "traditional": "傾巢出動"
  },
  {
    "frequency": 397,
    "simplified": "诲人不倦",
    "traditional": "誨人不倦"
  },
  {
    "frequency": 396,
    "simplified": "一步登天",
    "traditional": "一步登天"
  },
  {
    "frequency": 396,
    "simplified": "安之若素",
    "traditional": "安之若素"
  },
  {
    "frequency": 396,
    "simplified": "但求无过",
    "traditional": "但求無過"
  },
  {
    "frequency": 396,
    "simplified": "洛阳纸贵",
    "traditional": "洛陽紙貴"
  },
  {
    "frequency": 396,
    "simplified": "个中滋味",
    "traditional": "箇中滋味"
  },
  {
    "frequency": 395,
    "simplified": "前所未闻",
    "traditional": "前所未聞"
  },
  {
    "frequency": 395,
    "simplified": "夜郎自大",
    "traditional": "夜郎自大"
  },
  {
    "frequency": 395,
    "simplified": "有鼻子有眼",
    "traditional": "有鼻子有眼"
  },
  {
    "frequency": 395,
    "simplified": "伶牙俐齿",
    "traditional": "伶牙俐齒"
  },
  {
    "frequency": 394,
    "simplified": "一毛不拔",
    "traditional": "一毛不拔"
  },
  {
    "frequency": 394,
    "simplified": "果然如此",
    "traditional": "果然如此"
  },
  {
    "frequency": 394,
    "simplified": "故土难离",
    "traditional": "故土難離"
  },
  {
    "frequency": 394,
    "simplified": "甘拜下风",
    "traditional": "甘拜下風"
  },
  {
    "frequency": 393,
    "simplified": "如履平地",
    "traditional": "如履平地"
  },
  {
    "frequency": 393,
    "simplified": "冷言冷语",
    "traditional": "冷言冷語"
  },
  {
    "frequency": 392,
    "simplified": "花前月下",
    "traditional": "花前月下"
  },
  {
    "frequency": 392,
    "simplified": "百鸟朝凤",
    "traditional": "百鳥朝鳳"
  },
  {
    "frequency": 392,
    "simplified": "毛将焉附",
    "traditional": "毛將焉附"
  },
  {
    "frequency": 391,
    "simplified": "犬牙交错",
    "traditional": "犬牙交錯"
  },
  {
    "frequency": 391,
    "simplified": "多快好省",
    "traditional": "多快好省"
  },
  {
    "frequency": 391,
    "simplified": "朝不保夕",
    "traditional": "朝不保夕"
  },
  {
    "frequency": 391,
    "simplified": "大江东去",
    "traditional": "大江東去"
  },
  {
    "frequency": 391,
    "simplified": "开门七件事",
    "traditional": "開門七件事"
  },
  {
    "frequency": 391,
    "simplified": "挂一漏万",
    "traditional": "掛一漏萬"
  },
  {
    "frequency": 390,
    "simplified": "鸠占鹊巢",
    "traditional": "鳩佔鵲巢"
  },
  {
    "frequency": 390,
    "simplified": "满脸堆笑",
    "traditional": "滿臉堆笑"
  },
  {
    "frequency": 390,
    "simplified": "人定胜天",
    "traditional": "人定勝天"
  },
  {
    "frequency": 389,
    "simplified": "顷刻之间",
    "traditional": "頃刻之間"
  },
  {
    "frequency": 389,
    "simplified": "天作之合",
    "traditional": "天作之合"
  },
  {
    "frequency": 389,
    "simplified": "鱼米之乡",
    "traditional": "魚米之鄉"
  },
  {
    "frequency": 389,
    "simplified": "绵延不断",
    "traditional": "綿延不斷"
  },
  {
    "frequency": 389,
    "simplified": "回头是岸",
    "traditional": "回頭是岸"
  },
  {
    "frequency": 389,
    "simplified": "吃喝玩乐",
    "traditional": "吃喝玩樂"
  },
  {
    "frequency": 389,
    "simplified": "作奸犯科",
    "traditional": "作奸犯科"
  },
  {
    "frequency": 389,
    "simplified": "满腔热血",
    "traditional": "滿腔熱血"
  },
  {
    "frequency": 388,
    "simplified": "流芳百世",
    "traditional": "流芳百世"
  },
  {
    "frequency": 388,
    "simplified": "矫揉造作",
    "traditional": "矯揉造作"
  },
  {
    "frequency": 388,
    "simplified": "从一而终",
    "traditional": "從一而終"
  },
  {
    "frequency": 388,
    "simplified": "急流勇退",
    "traditional": "急流勇退"
  },
  {
    "frequency": 388,
    "simplified": "命途多舛",
    "traditional": "命途多舛"
  },
  {
    "frequency": 388,
    "simplified": "玩物丧志",
    "traditional": "玩物喪志"
  },
  {
    "frequency": 387,
    "simplified": "含沙射影",
    "traditional": "含沙射影"
  },
  {
    "frequency": 387,
    "simplified": "乐不思蜀",
    "traditional": "樂不思蜀"
  },
  {
    "frequency": 387,
    "simplified": "四面出击",
    "traditional": "四面出擊"
  },
  {
    "frequency": 387,
    "simplified": "此起彼落",
    "traditional": "此起彼落"
  },
  {
    "frequency": 387,
    "simplified": "文以载道",
    "traditional": "文以載道"
  },
  {
    "frequency": 385,
    "simplified": "自取灭亡",
    "traditional": "自取滅亡"
  },
  {
    "frequency": 385,
    "simplified": "养生之道",
    "traditional": "養生之道"
  },
  {
    "frequency": 384,
    "simplified": "睁一眼闭一眼",
    "traditional": "睜一眼閉一眼"
  },
  {
    "frequency": 384,
    "simplified": "封官许愿",
    "traditional": "封官許願"
  },
  {
    "frequency": 384,
    "simplified": "叶公好龙",
    "traditional": "葉公好龍"
  },
  {
    "frequency": 384,
    "simplified": "动辄得咎",
    "traditional": "動輒得咎"
  },
  {
    "frequency": 384,
    "simplified": "名扬四海",
    "traditional": "名揚四海"
  },
  {
    "frequency": 384,
    "simplified": "九霄云外",
    "traditional": "九霄雲外"
  },
  {
    "frequency": 383,
    "simplified": "欺世盗名",
    "traditional": "欺世盜名"
  },
  {
    "frequency": 383,
    "simplified": "寸土不让",
    "traditional": "寸土不讓"
  },
  {
    "frequency": 383,
    "simplified": "声色犬马",
    "traditional": "聲色犬馬"
  },
  {
    "frequency": 383,
    "simplified": "如梦方醒",
    "traditional": "如夢方醒"
  },
  {
    "frequency": 383,
    "simplified": "水调歌头",
    "traditional": "水調歌頭"
  },
  {
    "frequency": 383,
    "simplified": "至圣先师",
    "traditional": "至聖先師"
  },
  {
    "frequency": 382,
    "simplified": "夜长梦多",
    "traditional": "夜長夢多"
  },
  {
    "frequency": 382,
    "simplified": "目不识丁",
    "traditional": "目不識丁"
  },
  {
    "frequency": 382,
    "simplified": "千难万难",
    "traditional": "千難萬難"
  },
  {
    "frequency": 382,
    "simplified": "侠肝义胆",
    "traditional": "俠肝義膽"
  },
  {
    "frequency": 382,
    "simplified": "富甲一方",
    "traditional": "富甲一方"
  },
  {
    "frequency": 382,
    "simplified": "纵横驰骋",
    "traditional": "縱橫馳騁"
  },
  {
    "frequency": 382,
    "simplified": "执法如山",
    "traditional": "執法如山"
  },
  {
    "frequency": 382,
    "simplified": "罪孽深重",
    "traditional": "罪孽深重"
  },
  {
    "frequency": 381,
    "simplified": "万里无云",
    "traditional": "萬里無雲"
  },
  {
    "frequency": 381,
    "simplified": "乘兴而来",
    "traditional": "乘興而來"
  },
  {
    "frequency": 381,
    "simplified": "打马虎眼",
    "traditional": "打馬虎眼"
  },
  {
    "frequency": 381,
    "simplified": "劳燕分飞",
    "traditional": "勞燕分飛"
  },
  {
    "frequency": 381,
    "simplified": "钢筋铁骨",
    "traditional": "鋼筋鐵骨"
  },
  {
    "frequency": 381,
    "simplified": "自怨自艾",
    "traditional": "自怨自艾"
  },
  {
    "frequency": 381,
    "simplified": "齐天大圣",
    "traditional": "齊天大聖"
  },
  {
    "frequency": 381,
    "simplified": "粉饰太平",
    "traditional": "粉飾太平"
  },
  {
    "frequency": 380,
    "simplified": "不落俗套",
    "traditional": "不落俗套"
  },
  {
    "frequency": 380,
    "simplified": "新婚燕尔",
    "traditional": "新婚燕爾"
  },
  {
    "frequency": 380,
    "simplified": "鸣金收兵",
    "traditional": "鳴金收兵"
  },
  {
    "frequency": 380,
    "simplified": "蔚为大观",
    "traditional": "蔚為大觀"
  },
  {
    "frequency": 380,
    "simplified": "仓皇出逃",
    "traditional": "倉皇出逃"
  },
  {
    "frequency": 379,
    "simplified": "不以为耻",
    "traditional": "不以為恥"
  },
  {
    "frequency": 379,
    "simplified": "自有公论",
    "traditional": "自有公論"
  },
  {
    "frequency": 379,
    "simplified": "无远弗届",
    "traditional": "無遠弗屆"
  },
  {
    "frequency": 379,
    "simplified": "百花盛开",
    "traditional": "百花盛開"
  },
  {
    "frequency": 379,
    "simplified": "口说无凭",
    "traditional": "口說無憑"
  },
  {
    "frequency": 379,
    "simplified": "不求有功",
    "traditional": "不求有功"
  },
  {
    "frequency": 378,
    "simplified": "不舍昼夜",
    "traditional": "不捨晝夜"
  },
  {
    "frequency": 377,
    "simplified": "无立足之地",
    "traditional": "無立足之地"
  },
  {
    "frequency": 377,
    "simplified": "白头到老",
    "traditional": "白頭到老"
  },
  {
    "frequency": 377,
    "simplified": "书声琅琅",
    "traditional": "書聲琅琅"
  },
  {
    "frequency": 377,
    "simplified": "自甘堕落",
    "traditional": "自甘墮落"
  },
  {
    "frequency": 376,
    "simplified": "喜怒无常",
    "traditional": "喜怒無常"
  },
  {
    "frequency": 376,
    "simplified": "笑口常开",
    "traditional": "笑口常開"
  },
  {
    "frequency": 376,
    "simplified": "自惭形秽",
    "traditional": "自慚形穢"
  },
  {
    "frequency": 376,
    "simplified": "志士仁人",
    "traditional": "志士仁人"
  },
  {
    "frequency": 375,
    "simplified": "无巧不成书",
    "traditional": "無巧不成書"
  },
  {
    "frequency": 375,
    "simplified": "九泉之下",
    "traditional": "九泉之下"
  },
  {
    "frequency": 375,
    "simplified": "怒发冲冠",
    "traditional": "怒髮衝冠"
  },
  {
    "frequency": 375,
    "simplified": "东挪西借",
    "traditional": "東挪西借"
  },
  {
    "frequency": 374,
    "simplified": "心怀鬼胎",
    "traditional": "心懷鬼胎"
  },
  {
    "frequency": 374,
    "simplified": "重振旗鼓",
    "traditional": "重振旗鼓"
  },
  {
    "frequency": 374,
    "simplified": "刀耕火种",
    "traditional": "刀耕火種"
  },
  {
    "frequency": 374,
    "simplified": "名垂青史",
    "traditional": "名垂青史"
  },
  {
    "frequency": 373,
    "simplified": "井水不犯河水",
    "traditional": "井水不犯河水"
  },
  {
    "frequency": 373,
    "simplified": "萍水相逢",
    "traditional": "萍水相逢"
  },
  {
    "frequency": 373,
    "simplified": "出头之日",
    "traditional": "出頭之日"
  },
  {
    "frequency": 373,
    "simplified": "两肋插刀",
    "traditional": "兩肋插刀"
  },
  {
    "frequency": 372,
    "simplified": "烽火连天",
    "traditional": "烽火連天"
  },
  {
    "frequency": 372,
    "simplified": "断子绝孙",
    "traditional": "斷子絕孫"
  },
  {
    "frequency": 372,
    "simplified": "忙中出错",
    "traditional": "忙中出錯"
  },
  {
    "frequency": 372,
    "simplified": "不骄不躁",
    "traditional": "不驕不躁"
  },
  {
    "frequency": 372,
    "simplified": "仁至义尽",
    "traditional": "仁至義盡"
  },
  {
    "frequency": 372,
    "simplified": "不足挂齿",
    "traditional": "不足掛齒"
  },
  {
    "frequency": 371,
    "simplified": "舞文弄墨",
    "traditional": "舞文弄墨"
  },
  {
    "frequency": 371,
    "simplified": "迷惑不解",
    "traditional": "迷惑不解"
  },
  {
    "frequency": 371,
    "simplified": "波谲云诡",
    "traditional": "波譎雲詭"
  },
  {
    "frequency": 371,
    "simplified": "大难临头",
    "traditional": "大難臨頭"
  },
  {
    "frequency": 371,
    "simplified": "欲擒故纵",
    "traditional": "欲擒故縱"
  },
  {
    "frequency": 370,
    "simplified": "锦衣玉食",
    "traditional": "錦衣玉食"
  },
  {
    "frequency": 370,
    "simplified": "坐卧不安",
    "traditional": "坐臥不安"
  },
  {
    "frequency": 370,
    "simplified": "高头大马",
    "traditional": "高頭大馬"
  },
  {
    "frequency": 370,
    "simplified": "瑕不掩瑜",
    "traditional": "瑕不掩瑜"
  },
  {
    "frequency": 370,
    "simplified": "风流韵事",
    "traditional": "風流韻事"
  },
  {
    "frequency": 370,
    "simplified": "等量齐观",
    "traditional": "等量齊觀"
  },
  {
    "frequency": 369,
    "simplified": "放荡不羁",
    "traditional": "放蕩不羈"
  },
  {
    "frequency": 369,
    "simplified": "迎头痛击",
    "traditional": "迎頭痛擊"
  },
  {
    "frequency": 369,
    "simplified": "活到老学到老",
    "traditional": "活到老學到老"
  },
  {
    "frequency": 369,
    "simplified": "借尸还魂",
    "traditional": "借屍還魂"
  },
  {
    "frequency": 369,
    "simplified": "光阴荏苒",
    "traditional": "光陰荏苒"
  },
  {
    "frequency": 369,
    "simplified": "穷则思变",
    "traditional": "窮則思變"
  },
  {
    "frequency": 369,
    "simplified": "生杀予夺",
    "traditional": "生殺予奪"
  },
  {
    "frequency": 368,
    "simplified": "心术不正",
    "traditional": "心術不正"
  },
  {
    "frequency": 368,
    "simplified": "拍板定案",
    "traditional": "拍板定案"
  },
  {
    "frequency": 368,
    "simplified": "倚老卖老",
    "traditional": "倚老賣老"
  },
  {
    "frequency": 368,
    "simplified": "榜上无名",
    "traditional": "榜上無名"
  },
  {
    "frequency": 368,
    "simplified": "求知若渴",
    "traditional": "求知若渴"
  },
  {
    "frequency": 368,
    "simplified": "装疯卖傻",
    "traditional": "裝瘋賣傻"
  },
  {
    "frequency": 367,
    "simplified": "只欠东风",
    "traditional": "只欠東風"
  },
  {
    "frequency": 367,
    "simplified": "眉来眼去",
    "traditional": "眉來眼去"
  },
  {
    "frequency": 367,
    "simplified": "白山黑水",
    "traditional": "白山黑水"
  },
  {
    "frequency": 367,
    "simplified": "沧海横流",
    "traditional": "滄海橫流"
  },
  {
    "frequency": 367,
    "simplified": "衣冠楚楚",
    "traditional": "衣冠楚楚"
  },
  {
    "frequency": 367,
    "simplified": "火烧眉毛",
    "traditional": "火燒眉毛"
  },
  {
    "frequency": 367,
    "simplified": "弄假成真",
    "traditional": "弄假成真"
  },
  {
    "frequency": 366,
    "simplified": "痴心妄想",
    "traditional": "痴心妄想"
  },
  {
    "frequency": 366,
    "simplified": "满园春色",
    "traditional": "滿園春色"
  },
  {
    "frequency": 366,
    "simplified": "真命天子",
    "traditional": "真命天子"
  },
  {
    "frequency": 366,
    "simplified": "名不正言不顺",
    "traditional": "名不正言不順"
  },
  {
    "frequency": 366,
    "simplified": "渔翁之利",
    "traditional": "漁翁之利"
  },
  {
    "frequency": 366,
    "simplified": "兵不血刃",
    "traditional": "兵不血刃"
  },
  {
    "frequency": 366,
    "simplified": "无米之炊",
    "traditional": "無米之炊"
  },
  {
    "frequency": 365,
    "simplified": "查无实据",
    "traditional": "查無實據"
  },
  {
    "frequency": 365,
    "simplified": "伤风败俗",
    "traditional": "傷風敗俗"
  },
  {
    "frequency": 365,
    "simplified": "狐朋狗友",
    "traditional": "狐朋狗友"
  },
  {
    "frequency": 365,
    "simplified": "满腹牢骚",
    "traditional": "滿腹牢騷"
  },
  {
    "frequency": 365,
    "simplified": "鸡犬不宁",
    "traditional": "雞犬不寧"
  },
  {
    "frequency": 365,
    "simplified": "锦囊妙计",
    "traditional": "錦囊妙計"
  },
  {
    "frequency": 365,
    "simplified": "未老先衰",
    "traditional": "未老先衰"
  },
  {
    "frequency": 365,
    "simplified": "狐狸尾巴",
    "traditional": "狐狸尾巴"
  },
  {
    "frequency": 365,
    "simplified": "一石二鸟",
    "traditional": "一石二鳥"
  },
  {
    "frequency": 364,
    "simplified": "自我解嘲",
    "traditional": "自我解嘲"
  },
  {
    "frequency": 364,
    "simplified": "喝西北风",
    "traditional": "喝西北風"
  },
  {
    "frequency": 364,
    "simplified": "搔首弄姿",
    "traditional": "搔首弄姿"
  },
  {
    "frequency": 363,
    "simplified": "大费周折",
    "traditional": "大費周折"
  },
  {
    "frequency": 363,
    "simplified": "以天下为己任",
    "traditional": "以天下為己任"
  },
  {
    "frequency": 363,
    "simplified": "不预则废",
    "traditional": "不預則廢"
  },
  {
    "frequency": 363,
    "simplified": "百密一疏",
    "traditional": "百密一疏"
  },
  {
    "frequency": 363,
    "simplified": "大动肝火",
    "traditional": "大動肝火"
  },
  {
    "frequency": 362,
    "simplified": "浩然之气",
    "traditional": "浩然之氣"
  },
  {
    "frequency": 362,
    "simplified": "死无对证",
    "traditional": "死無對證"
  },
  {
    "frequency": 362,
    "simplified": "为虎作伥",
    "traditional": "為虎作倀"
  },
  {
    "frequency": 362,
    "simplified": "千秋万代",
    "traditional": "千秋萬代"
  },
  {
    "frequency": 362,
    "simplified": "精诚所至",
    "traditional": "精誠所至"
  },
  {
    "frequency": 362,
    "simplified": "时来运转",
    "traditional": "時來運轉"
  },
  {
    "frequency": 362,
    "simplified": "初露锋芒",
    "traditional": "初露鋒芒"
  },
  {
    "frequency": 362,
    "simplified": "血迹斑斑",
    "traditional": "血跡斑斑"
  },
  {
    "frequency": 361,
    "simplified": "家财万贯",
    "traditional": "家財萬貫"
  },
  {
    "frequency": 361,
    "simplified": "民脂民膏",
    "traditional": "民脂民膏"
  },
  {
    "frequency": 360,
    "simplified": "待字闺中",
    "traditional": "待字閨中"
  },
  {
    "frequency": 360,
    "simplified": "无则加勉",
    "traditional": "無則加勉"
  },
  {
    "frequency": 359,
    "simplified": "反戈一击",
    "traditional": "反戈一擊"
  },
  {
    "frequency": 359,
    "simplified": "溘然长逝",
    "traditional": "溘然長逝"
  },
  {
    "frequency": 359,
    "simplified": "邪不压正",
    "traditional": "邪不壓正"
  },
  {
    "frequency": 359,
    "simplified": "唱对台戏",
    "traditional": "唱對臺戲"
  },
  {
    "frequency": 359,
    "simplified": "寻欢作乐",
    "traditional": "尋歡作樂"
  },
  {
    "frequency": 358,
    "simplified": "止于至善",
    "traditional": "止於至善"
  },
  {
    "frequency": 358,
    "simplified": "形形色色",
    "traditional": "形形色色"
  },
  {
    "frequency": 358,
    "simplified": "有一搭没一搭",
    "traditional": "有一搭沒一搭"
  },
  {
    "frequency": 358,
    "simplified": "永无宁日",
    "traditional": "永無寧日"
  },
  {
    "frequency": 357,
    "simplified": "树碑立传",
    "traditional": "樹碑立傳"
  },
  {
    "frequency": 357,
    "simplified": "鼎鼎有名",
    "traditional": "鼎鼎有名"
  },
  {
    "frequency": 357,
    "simplified": "天不怕地不怕",
    "traditional": "天不怕地不怕"
  },
  {
    "frequency": 357,
    "simplified": "青出于蓝而胜于蓝",
    "traditional": "青出於藍而勝於藍"
  },
  {
    "frequency": 356,
    "simplified": "岂有此理",
    "traditional": "豈有此理"
  },
  {
    "frequency": 356,
    "simplified": "除暴安良",
    "traditional": "除暴安良"
  },
  {
    "frequency": 356,
    "simplified": "自鸣得意",
    "traditional": "自鳴得意"
  },
  {
    "frequency": 356,
    "simplified": "落英缤纷",
    "traditional": "落英繽紛"
  },
  {
    "frequency": 356,
    "simplified": "差之毫厘",
    "traditional": "差之毫釐"
  },
  {
    "frequency": 356,
    "simplified": "百无禁忌",
    "traditional": "百無禁忌"
  },
  {
    "frequency": 356,
    "simplified": "宽以待人",
    "traditional": "寬以待人"
  },
  {
    "frequency": 355,
    "simplified": "迅雷不及掩耳",
    "traditional": "迅雷不及掩耳"
  },
  {
    "frequency": 355,
    "simplified": "醉生梦死",
    "traditional": "醉生夢死"
  },
  {
    "frequency": 355,
    "simplified": "风流倜傥",
    "traditional": "風流倜儻"
  },
  {
    "frequency": 355,
    "simplified": "见风使舵",
    "traditional": "見風使舵"
  },
  {
    "frequency": 355,
    "simplified": "赶鸭子上架",
    "traditional": "趕鴨子上架"
  },
  {
    "frequency": 354,
    "simplified": "不见天日",
    "traditional": "不見天日"
  },
  {
    "frequency": 354,
    "simplified": "抖擞精神",
    "traditional": "抖擻精神"
  },
  {
    "frequency": 354,
    "simplified": "悠闲自在",
    "traditional": "悠閒自在"
  },
  {
    "frequency": 353,
    "simplified": "颠三倒四",
    "traditional": "顛三倒四"
  },
  {
    "frequency": 353,
    "simplified": "盖棺论定",
    "traditional": "蓋棺論定"
  },
  {
    "frequency": 353,
    "simplified": "烂醉如泥",
    "traditional": "爛醉如泥"
  },
  {
    "frequency": 353,
    "simplified": "口不择言",
    "traditional": "口不擇言"
  },
  {
    "frequency": 352,
    "simplified": "安危与共",
    "traditional": "安危與共"
  },
  {
    "frequency": 352,
    "simplified": "两厢情愿",
    "traditional": "兩廂情願"
  },
  {
    "frequency": 351,
    "simplified": "大开大合",
    "traditional": "大開大合"
  },
  {
    "frequency": 351,
    "simplified": "刺刀见红",
    "traditional": "刺刀見紅"
  },
  {
    "frequency": 351,
    "simplified": "忠言逆耳",
    "traditional": "忠言逆耳"
  },
  {
    "frequency": 351,
    "simplified": "金石为开",
    "traditional": "金石為開"
  },
  {
    "frequency": 351,
    "simplified": "临阵磨枪",
    "traditional": "臨陣磨槍"
  },
  {
    "frequency": 351,
    "simplified": "悬崖绝壁",
    "traditional": "懸崖絕壁"
  },
  {
    "frequency": 350,
    "simplified": "拔刀相助",
    "traditional": "拔刀相助"
  },
  {
    "frequency": 350,
    "simplified": "孤陋寡闻",
    "traditional": "孤陋寡聞"
  },
  {
    "frequency": 350,
    "simplified": "百炼成钢",
    "traditional": "百鍊成鋼"
  },
  {
    "frequency": 350,
    "simplified": "抓耳挠腮",
    "traditional": "抓耳撓腮"
  },
  {
    "frequency": 350,
    "simplified": "难解难分",
    "traditional": "難解難分"
  },
  {
    "frequency": 350,
    "simplified": "一声不响",
    "traditional": "一聲不響"
  },
  {
    "frequency": 350,
    "simplified": "温故知新",
    "traditional": "溫故知新"
  },
  {
    "frequency": 349,
    "simplified": "屏气凝神",
    "traditional": "屏氣凝神"
  },
  {
    "frequency": 349,
    "simplified": "字字珠玑",
    "traditional": "字字珠璣"
  },
  {
    "frequency": 349,
    "simplified": "千恩万谢",
    "traditional": "千恩萬謝"
  },
  {
    "frequency": 349,
    "simplified": "花红柳绿",
    "traditional": "花紅柳綠"
  },
  {
    "frequency": 348,
    "simplified": "天高皇帝远",
    "traditional": "天高皇帝遠"
  },
  {
    "frequency": 348,
    "simplified": "鞭辟入里",
    "traditional": "鞭辟入裡"
  },
  {
    "frequency": 348,
    "simplified": "繁荣兴旺",
    "traditional": "繁榮興旺"
  },
  {
    "frequency": 348,
    "simplified": "疾恶如仇",
    "traditional": "疾惡如仇"
  },
  {
    "frequency": 347,
    "simplified": "披麻戴孝",
    "traditional": "披麻戴孝"
  },
  {
    "frequency": 347,
    "simplified": "聪明智慧",
    "traditional": "聰明智慧"
  },
  {
    "frequency": 347,
    "simplified": "师道尊严",
    "traditional": "師道尊嚴"
  },
  {
    "frequency": 347,
    "simplified": "大做文章",
    "traditional": "大做文章"
  },
  {
    "frequency": 347,
    "simplified": "等闲之辈",
    "traditional": "等閒之輩"
  },
  {
    "frequency": 346,
    "simplified": "风行一时",
    "traditional": "風行一時"
  },
  {
    "frequency": 346,
    "simplified": "奇珍异宝",
    "traditional": "奇珍異寶"
  },
  {
    "frequency": 346,
    "simplified": "欲壑难填",
    "traditional": "慾壑難填"
  },
  {
    "frequency": 346,
    "simplified": "远水解不了近渴",
    "traditional": "遠水解不了近渴"
  },
  {
    "frequency": 346,
    "simplified": "狡兔三窟",
    "traditional": "狡兔三窟"
  },
  {
    "frequency": 345,
    "simplified": "木已成舟",
    "traditional": "木已成舟"
  },
  {
    "frequency": 345,
    "simplified": "粮草先行",
    "traditional": "糧草先行"
  },
  {
    "frequency": 345,
    "simplified": "上梁不正下梁歪",
    "traditional": "上梁不正下梁歪"
  },
  {
    "frequency": 344,
    "simplified": "自寻短见",
    "traditional": "自尋短見"
  },
  {
    "frequency": 344,
    "simplified": "推崇备至",
    "traditional": "推崇備至"
  },
  {
    "frequency": 344,
    "simplified": "招财进宝",
    "traditional": "招財進寶"
  },
  {
    "frequency": 343,
    "simplified": "孤军作战",
    "traditional": "孤軍作戰"
  },
  {
    "frequency": 343,
    "simplified": "卓有成就",
    "traditional": "卓有成就"
  },
  {
    "frequency": 343,
    "simplified": "虚虚实实",
    "traditional": "虛虛實實"
  },
  {
    "frequency": 343,
    "simplified": "害人不浅",
    "traditional": "害人不淺"
  },
  {
    "frequency": 343,
    "simplified": "足智多谋",
    "traditional": "足智多謀"
  },
  {
    "frequency": 342,
    "simplified": "祸从天降",
    "traditional": "禍從天降"
  },
  {
    "frequency": 342,
    "simplified": "青天白日",
    "traditional": "青天白日"
  },
  {
    "frequency": 341,
    "simplified": "问长问短",
    "traditional": "問長問短"
  },
  {
    "frequency": 341,
    "simplified": "全民皆兵",
    "traditional": "全民皆兵"
  },
  {
    "frequency": 341,
    "simplified": "避人耳目",
    "traditional": "避人耳目"
  },
  {
    "frequency": 341,
    "simplified": "赏罚分明",
    "traditional": "賞罰分明"
  },
  {
    "frequency": 341,
    "simplified": "逼上梁山",
    "traditional": "逼上梁山"
  },
  {
    "frequency": 341,
    "simplified": "纨绔子弟",
    "traditional": "紈絝子弟"
  },
  {
    "frequency": 340,
    "simplified": "不分伯仲",
    "traditional": "不分伯仲"
  },
  {
    "frequency": 340,
    "simplified": "一语不发",
    "traditional": "一語不發"
  },
  {
    "frequency": 340,
    "simplified": "庸人自扰",
    "traditional": "庸人自擾"
  },
  {
    "frequency": 340,
    "simplified": "小家碧玉",
    "traditional": "小家碧玉"
  },
  {
    "frequency": 340,
    "simplified": "十里洋场",
    "traditional": "十里洋場"
  },
  {
    "frequency": 340,
    "simplified": "不知怎的",
    "traditional": "不知怎的"
  },
  {
    "frequency": 340,
    "simplified": "赤胆忠心",
    "traditional": "赤膽忠心"
  },
  {
    "frequency": 340,
    "simplified": "官运亨通",
    "traditional": "官運亨通"
  },
  {
    "frequency": 340,
    "simplified": "满腹经纶",
    "traditional": "滿腹經綸"
  },
  {
    "frequency": 340,
    "simplified": "洁身自爱",
    "traditional": "潔身自愛"
  },
  {
    "frequency": 340,
    "simplified": "知人善任",
    "traditional": "知人善任"
  },
  {
    "frequency": 339,
    "simplified": "盛名之下",
    "traditional": "盛名之下"
  },
  {
    "frequency": 339,
    "simplified": "掩鼻而过",
    "traditional": "掩鼻而過"
  },
  {
    "frequency": 339,
    "simplified": "卑躬屈膝",
    "traditional": "卑躬屈膝"
  },
  {
    "frequency": 339,
    "simplified": "讲信修睦",
    "traditional": "講信修睦"
  },
  {
    "frequency": 339,
    "simplified": "深山密林",
    "traditional": "深山密林"
  },
  {
    "frequency": 338,
    "simplified": "空洞无物",
    "traditional": "空洞無物"
  },
  {
    "frequency": 338,
    "simplified": "绵绵不绝",
    "traditional": "綿綿不絕"
  },
  {
    "frequency": 337,
    "simplified": "壮志未酬",
    "traditional": "壯志未酬"
  },
  {
    "frequency": 337,
    "simplified": "左支右绌",
    "traditional": "左支右絀"
  },
  {
    "frequency": 337,
    "simplified": "请君入瓮",
    "traditional": "請君入甕"
  },
  {
    "frequency": 337,
    "simplified": "眼观六路",
    "traditional": "眼觀六路"
  },
  {
    "frequency": 337,
    "simplified": "功败垂成",
    "traditional": "功敗垂成"
  },
  {
    "frequency": 337,
    "simplified": "兴利除弊",
    "traditional": "興利除弊"
  },
  {
    "frequency": 337,
    "simplified": "过河拆桥",
    "traditional": "過河拆橋"
  },
  {
    "frequency": 336,
    "simplified": "含情脉脉",
    "traditional": "含情脈脈"
  },
  {
    "frequency": 336,
    "simplified": "怅然若失",
    "traditional": "悵然若失"
  },
  {
    "frequency": 336,
    "simplified": "道高一尺魔高一丈",
    "traditional": "道高一尺魔高一丈"
  },
  {
    "frequency": 336,
    "simplified": "忧心如焚",
    "traditional": "憂心如焚"
  },
  {
    "frequency": 336,
    "simplified": "急起直追",
    "traditional": "急起直追"
  },
  {
    "frequency": 336,
    "simplified": "玲珑剔透",
    "traditional": "玲瓏剔透"
  },
  {
    "frequency": 336,
    "simplified": "神魂颠倒",
    "traditional": "神魂顛倒"
  },
  {
    "frequency": 335,
    "simplified": "名闻遐迩",
    "traditional": "名聞遐邇"
  },
  {
    "frequency": 335,
    "simplified": "女扮男装",
    "traditional": "女扮男裝"
  },
  {
    "frequency": 335,
    "simplified": "得道多助",
    "traditional": "得道多助"
  },
  {
    "frequency": 334,
    "simplified": "甘之如饴",
    "traditional": "甘之如飴"
  },
  {
    "frequency": 334,
    "simplified": "相视而笑",
    "traditional": "相視而笑"
  },
  {
    "frequency": 334,
    "simplified": "滑天下之大稽",
    "traditional": "滑天下之大稽"
  },
  {
    "frequency": 334,
    "simplified": "臭味相投",
    "traditional": "臭味相投"
  },
  {
    "frequency": 334,
    "simplified": "鼓乐齐鸣",
    "traditional": "鼓樂齊鳴"
  },
  {
    "frequency": 334,
    "simplified": "狂妄自大",
    "traditional": "狂妄自大"
  },
  {
    "frequency": 334,
    "simplified": "高出一筹",
    "traditional": "高出一籌"
  },
  {
    "frequency": 334,
    "simplified": "丑态百出",
    "traditional": "醜態百出"
  },
  {
    "frequency": 333,
    "simplified": "苦心孤诣",
    "traditional": "苦心孤詣"
  },
  {
    "frequency": 333,
    "simplified": "凡夫俗子",
    "traditional": "凡夫俗子"
  },
  {
    "frequency": 333,
    "simplified": "破绽百出",
    "traditional": "破綻百出"
  },
  {
    "frequency": 333,
    "simplified": "真心真意",
    "traditional": "真心真意"
  },
  {
    "frequency": 333,
    "simplified": "只此一家",
    "traditional": "只此一家"
  },
  {
    "frequency": 333,
    "simplified": "祸从口出",
    "traditional": "禍從口出"
  },
  {
    "frequency": 333,
    "simplified": "探头探脑",
    "traditional": "探頭探腦"
  },
  {
    "frequency": 332,
    "simplified": "以弱胜强",
    "traditional": "以弱勝強"
  },
  {
    "frequency": 332,
    "simplified": "身体发肤",
    "traditional": "身體髮膚"
  },
  {
    "frequency": 332,
    "simplified": "九天揽月",
    "traditional": "九天攬月"
  },
  {
    "frequency": 331,
    "simplified": "缠绵悱恻",
    "traditional": "纏綿悱惻"
  },
  {
    "frequency": 331,
    "simplified": "月黑风高",
    "traditional": "月黑風高"
  },
  {
    "frequency": 331,
    "simplified": "历尽沧桑",
    "traditional": "歷盡滄桑"
  },
  {
    "frequency": 331,
    "simplified": "缺衣少食",
    "traditional": "缺衣少食"
  },
  {
    "frequency": 331,
    "simplified": "飞蛾扑火",
    "traditional": "飛蛾撲火"
  },
  {
    "frequency": 331,
    "simplified": "普天之下",
    "traditional": "普天之下"
  },
  {
    "frequency": 330,
    "simplified": "溃于蚁穴",
    "traditional": "潰於蟻穴"
  },
  {
    "frequency": 330,
    "simplified": "十拿九稳",
    "traditional": "十拿九穩"
  },
  {
    "frequency": 330,
    "simplified": "山高水长",
    "traditional": "山高水長"
  },
  {
    "frequency": 330,
    "simplified": "与人方便",
    "traditional": "與人方便"
  },
  {
    "frequency": 330,
    "simplified": "欢喜冤家",
    "traditional": "歡喜冤家"
  },
  {
    "frequency": 330,
    "simplified": "如泣如诉",
    "traditional": "如泣如訴"
  },
  {
    "frequency": 329,
    "simplified": "千古绝唱",
    "traditional": "千古絕唱"
  },
  {
    "frequency": 329,
    "simplified": "恬不知耻",
    "traditional": "恬不知恥"
  },
  {
    "frequency": 329,
    "simplified": "一分一毫",
    "traditional": "一分一毫"
  },
  {
    "frequency": 329,
    "simplified": "杨柳依依",
    "traditional": "楊柳依依"
  },
  {
    "frequency": 328,
    "simplified": "落日余晖",
    "traditional": "落日餘暉"
  },
  {
    "frequency": 328,
    "simplified": "满面春风",
    "traditional": "滿面春風"
  },
  {
    "frequency": 328,
    "simplified": "下情上达",
    "traditional": "下情上達"
  },
  {
    "frequency": 328,
    "simplified": "鞍前马后",
    "traditional": "鞍前馬後"
  },
  {
    "frequency": 327,
    "simplified": "飞沙走石",
    "traditional": "飛沙走石"
  },
  {
    "frequency": 327,
    "simplified": "养痈遗患",
    "traditional": "養癰遺患"
  },
  {
    "frequency": 327,
    "simplified": "大而无当",
    "traditional": "大而無當"
  },
  {
    "frequency": 327,
    "simplified": "面目狰狞",
    "traditional": "面目猙獰"
  },
  {
    "frequency": 327,
    "simplified": "长吁短叹",
    "traditional": "長吁短嘆"
  },
  {
    "frequency": 327,
    "simplified": "浪迹天涯",
    "traditional": "浪跡天涯"
  },
  {
    "frequency": 327,
    "simplified": "振臂一呼",
    "traditional": "振臂一呼"
  },
  {
    "frequency": 326,
    "simplified": "逼不得已",
    "traditional": "逼不得已"
  },
  {
    "frequency": 326,
    "simplified": "夜不闭户",
    "traditional": "夜不閉戶"
  },
  {
    "frequency": 326,
    "simplified": "蝇营狗苟",
    "traditional": "蠅營狗苟"
  },
  {
    "frequency": 326,
    "simplified": "自我表现",
    "traditional": "自我表現"
  },
  {
    "frequency": 325,
    "simplified": "悬崖峭壁",
    "traditional": "懸崖峭壁"
  },
  {
    "frequency": 325,
    "simplified": "真金不怕火炼",
    "traditional": "真金不怕火煉"
  },
  {
    "frequency": 325,
    "simplified": "下自成蹊",
    "traditional": "下自成蹊"
  },
  {
    "frequency": 324,
    "simplified": "坚强不屈",
    "traditional": "堅強不屈"
  },
  {
    "frequency": 324,
    "simplified": "洋洋自得",
    "traditional": "洋洋自得"
  },
  {
    "frequency": 324,
    "simplified": "蛮横无理",
    "traditional": "蠻橫無理"
  },
  {
    "frequency": 324,
    "simplified": "睹物思人",
    "traditional": "睹物思人"
  },
  {
    "frequency": 324,
    "simplified": "明日黄花",
    "traditional": "明日黃花"
  },
  {
    "frequency": 324,
    "simplified": "另谋高就",
    "traditional": "另謀高就"
  },
  {
    "frequency": 324,
    "simplified": "迂回曲折",
    "traditional": "迂迴曲折"
  },
  {
    "frequency": 324,
    "simplified": "四海一家",
    "traditional": "四海一家"
  },
  {
    "frequency": 324,
    "simplified": "百年难遇",
    "traditional": "百年難遇"
  },
  {
    "frequency": 324,
    "simplified": "怵目惊心",
    "traditional": "怵目驚心"
  },
  {
    "frequency": 324,
    "simplified": "鸟枪换炮",
    "traditional": "鳥槍換炮"
  },
  {
    "frequency": 323,
    "simplified": "杀气腾腾",
    "traditional": "殺氣騰騰"
  },
  {
    "frequency": 323,
    "simplified": "摇摇摆摆",
    "traditional": "搖搖擺擺"
  },
  {
    "frequency": 323,
    "simplified": "来而不往非礼也",
    "traditional": "來而不往非禮也"
  },
  {
    "frequency": 322,
    "simplified": "置之死地而后生",
    "traditional": "置之死地而後生"
  },
  {
    "frequency": 322,
    "simplified": "万全之策",
    "traditional": "萬全之策"
  },
  {
    "frequency": 322,
    "simplified": "夙兴夜寐",
    "traditional": "夙興夜寐"
  },
  {
    "frequency": 322,
    "simplified": "顽固不化",
    "traditional": "頑固不化"
  },
  {
    "frequency": 321,
    "simplified": "离心离德",
    "traditional": "離心離德"
  },
  {
    "frequency": 321,
    "simplified": "恍若隔世",
    "traditional": "恍若隔世"
  },
  {
    "frequency": 321,
    "simplified": "逢凶化吉",
    "traditional": "逢凶化吉"
  },
  {
    "frequency": 321,
    "simplified": "威风八面",
    "traditional": "威風八面"
  },
  {
    "frequency": 321,
    "simplified": "作威作福",
    "traditional": "作威作福"
  },
  {
    "frequency": 321,
    "simplified": "巾帼英雄",
    "traditional": "巾幗英雄"
  },
  {
    "frequency": 320,
    "simplified": "以暴易暴",
    "traditional": "以暴易暴"
  },
  {
    "frequency": 320,
    "simplified": "前人栽树",
    "traditional": "前人栽樹"
  },
  {
    "frequency": 320,
    "simplified": "东拉西扯",
    "traditional": "東拉西扯"
  },
  {
    "frequency": 320,
    "simplified": "衣来伸手",
    "traditional": "衣來伸手"
  },
  {
    "frequency": 320,
    "simplified": "师出无名",
    "traditional": "師出無名"
  },
  {
    "frequency": 320,
    "simplified": "成人之美",
    "traditional": "成人之美"
  },
  {
    "frequency": 320,
    "simplified": "满盘皆输",
    "traditional": "滿盤皆輸"
  },
  {
    "frequency": 319,
    "simplified": "桃红柳绿",
    "traditional": "桃紅柳綠"
  },
  {
    "frequency": 319,
    "simplified": "仁者见仁智者见智",
    "traditional": "仁者見仁智者見智"
  },
  {
    "frequency": 319,
    "simplified": "寸土必争",
    "traditional": "寸土必爭"
  },
  {
    "frequency": 319,
    "simplified": "随声附和",
    "traditional": "隨聲附和"
  },
  {
    "frequency": 319,
    "simplified": "秀色可餐",
    "traditional": "秀色可餐"
  },
  {
    "frequency": 319,
    "simplified": "先礼后兵",
    "traditional": "先禮後兵"
  },
  {
    "frequency": 319,
    "simplified": "没有不透风的墙",
    "traditional": "沒有不透風的牆"
  },
  {
    "frequency": 318,
    "simplified": "信马由缰",
    "traditional": "信馬由韁"
  },
  {
    "frequency": 318,
    "simplified": "万箭穿心",
    "traditional": "萬箭穿心"
  },
  {
    "frequency": 318,
    "simplified": "威武不能屈",
    "traditional": "威武不能屈"
  },
  {
    "frequency": 317,
    "simplified": "浩气长存",
    "traditional": "浩氣長存"
  },
  {
    "frequency": 317,
    "simplified": "桃李不言",
    "traditional": "桃李不言"
  },
  {
    "frequency": 317,
    "simplified": "精妙绝伦",
    "traditional": "精妙絕倫"
  },
  {
    "frequency": 317,
    "simplified": "成王败寇",
    "traditional": "成王敗寇"
  },
  {
    "frequency": 316,
    "simplified": "欺人太甚",
    "traditional": "欺人太甚"
  },
  {
    "frequency": 316,
    "simplified": "楚河汉界",
    "traditional": "楚河漢界"
  },
  {
    "frequency": 316,
    "simplified": "不留余地",
    "traditional": "不留餘地"
  },
  {
    "frequency": 316,
    "simplified": "姑息养奸",
    "traditional": "姑息養奸"
  },
  {
    "frequency": 316,
    "simplified": "耳提面命",
    "traditional": "耳提面命"
  },
  {
    "frequency": 316,
    "simplified": "戎马生涯",
    "traditional": "戎馬生涯"
  },
  {
    "frequency": 316,
    "simplified": "兵马未动",
    "traditional": "兵馬未動"
  },
  {
    "frequency": 316,
    "simplified": "孤掌难鸣",
    "traditional": "孤掌難鳴"
  },
  {
    "frequency": 316,
    "simplified": "聪明能干",
    "traditional": "聰明能幹"
  },
  {
    "frequency": 316,
    "simplified": "仰面朝天",
    "traditional": "仰面朝天"
  },
  {
    "frequency": 316,
    "simplified": "贫病交加",
    "traditional": "貧病交加"
  },
  {
    "frequency": 315,
    "simplified": "以德服人",
    "traditional": "以德服人"
  },
  {
    "frequency": 315,
    "simplified": "鸡犬相闻",
    "traditional": "雞犬相聞"
  },
  {
    "frequency": 315,
    "simplified": "阴谋诡计",
    "traditional": "陰謀詭計"
  },
  {
    "frequency": 315,
    "simplified": "明修栈道",
    "traditional": "明修棧道"
  },
  {
    "frequency": 315,
    "simplified": "替天行道",
    "traditional": "替天行道"
  },
  {
    "frequency": 314,
    "simplified": "毫无二致",
    "traditional": "毫無二致"
  },
  {
    "frequency": 314,
    "simplified": "朝三暮四",
    "traditional": "朝三暮四"
  },
  {
    "frequency": 314,
    "simplified": "不求上进",
    "traditional": "不求上進"
  },
  {
    "frequency": 314,
    "simplified": "麻雀虽小五脏俱全",
    "traditional": "麻雀雖小五臟俱全"
  },
  {
    "frequency": 314,
    "simplified": "暴殄天物",
    "traditional": "暴殄天物"
  },
  {
    "frequency": 314,
    "simplified": "古木参天",
    "traditional": "古木參天"
  },
  {
    "frequency": 313,
    "simplified": "取之不竭",
    "traditional": "取之不竭"
  },
  {
    "frequency": 313,
    "simplified": "拉大旗作虎皮",
    "traditional": "拉大旗作虎皮"
  },
  {
    "frequency": 313,
    "simplified": "拱手让人",
    "traditional": "拱手讓人"
  },
  {
    "frequency": 313,
    "simplified": "不知天高地厚",
    "traditional": "不知天高地厚"
  },
  {
    "frequency": 313,
    "simplified": "三寸不烂之舌",
    "traditional": "三寸不爛之舌"
  },
  {
    "frequency": 312,
    "simplified": "蜂拥而出",
    "traditional": "蜂擁而出"
  },
  {
    "frequency": 312,
    "simplified": "巴山蜀水",
    "traditional": "巴山蜀水"
  },
  {
    "frequency": 312,
    "simplified": "冰清玉洁",
    "traditional": "冰清玉潔"
  },
  {
    "frequency": 312,
    "simplified": "天下大乱",
    "traditional": "天下大亂"
  },
  {
    "frequency": 312,
    "simplified": "山盟海誓",
    "traditional": "山盟海誓"
  },
  {
    "frequency": 311,
    "simplified": "出口成章",
    "traditional": "出口成章"
  },
  {
    "frequency": 311,
    "simplified": "七七八八",
    "traditional": "七七八八"
  },
  {
    "frequency": 311,
    "simplified": "书香世家",
    "traditional": "書香世家"
  },
  {
    "frequency": 311,
    "simplified": "淡然处之",
    "traditional": "淡然處之"
  },
  {
    "frequency": 311,
    "simplified": "保存实力",
    "traditional": "保存實力"
  },
  {
    "frequency": 310,
    "simplified": "自命不凡",
    "traditional": "自命不凡"
  },
  {
    "frequency": 310,
    "simplified": "衣不蔽体",
    "traditional": "衣不蔽體"
  },
  {
    "frequency": 310,
    "simplified": "有所顾忌",
    "traditional": "有所顧忌"
  },
  {
    "frequency": 310,
    "simplified": "闭口不言",
    "traditional": "閉口不言"
  },
  {
    "frequency": 310,
    "simplified": "立此存照",
    "traditional": "立此存照"
  },
  {
    "frequency": 310,
    "simplified": "不疾不徐",
    "traditional": "不疾不徐"
  },
  {
    "frequency": 309,
    "simplified": "温良恭俭让",
    "traditional": "溫良恭儉讓"
  },
  {
    "frequency": 309,
    "simplified": "反咬一口",
    "traditional": "反咬一口"
  },
  {
    "frequency": 309,
    "simplified": "笨手笨脚",
    "traditional": "笨手笨腳"
  },
  {
    "frequency": 309,
    "simplified": "窈窕淑女",
    "traditional": "窈窕淑女"
  },
  {
    "frequency": 309,
    "simplified": "稍逊一筹",
    "traditional": "稍遜一籌"
  },
  {
    "frequency": 309,
    "simplified": "金鸡独立",
    "traditional": "金雞獨立"
  },
  {
    "frequency": 309,
    "simplified": "身在曹营心在汉",
    "traditional": "身在曹營心在漢"
  },
  {
    "frequency": 309,
    "simplified": "能文能武",
    "traditional": "能文能武"
  },
  {
    "frequency": 308,
    "simplified": "狭路相逢勇者胜",
    "traditional": "狹路相逢勇者勝"
  },
  {
    "frequency": 308,
    "simplified": "客死他乡",
    "traditional": "客死他鄉"
  },
  {
    "frequency": 308,
    "simplified": "八仙过海各显神通",
    "traditional": "八仙過海各顯神通"
  },
  {
    "frequency": 307,
    "simplified": "天崩地裂",
    "traditional": "天崩地裂"
  },
  {
    "frequency": 306,
    "simplified": "年幼无知",
    "traditional": "年幼無知"
  },
  {
    "frequency": 306,
    "simplified": "吊儿郎当",
    "traditional": "吊兒郎當"
  },
  {
    "frequency": 306,
    "simplified": "善有善报",
    "traditional": "善有善報"
  },
  {
    "frequency": 306,
    "simplified": "身正不怕影子斜",
    "traditional": "身正不怕影子斜"
  },
  {
    "frequency": 306,
    "simplified": "刚愎自用",
    "traditional": "剛愎自用"
  },
  {
    "frequency": 306,
    "simplified": "南腔北调",
    "traditional": "南腔北調"
  },
  {
    "frequency": 306,
    "simplified": "人以群分",
    "traditional": "人以群分"
  },
  {
    "frequency": 306,
    "simplified": "好自为之",
    "traditional": "好自為之"
  },
  {
    "frequency": 306,
    "simplified": "有来有往",
    "traditional": "有來有往"
  },
  {
    "frequency": 306,
    "simplified": "命丧黄泉",
    "traditional": "命喪黃泉"
  },
  {
    "frequency": 306,
    "simplified": "铁石心肠",
    "traditional": "鐵石心腸"
  },
  {
    "frequency": 306,
    "simplified": "今生今世",
    "traditional": "今生今世"
  },
  {
    "frequency": 305,
    "simplified": "人非圣贤",
    "traditional": "人非聖賢"
  },
  {
    "frequency": 304,
    "simplified": "尖酸刻薄",
    "traditional": "尖酸刻薄"
  },
  {
    "frequency": 304,
    "simplified": "落花流水",
    "traditional": "落花流水"
  },
  {
    "frequency": 304,
    "simplified": "耳听八方",
    "traditional": "耳聽八方"
  },
  {
    "frequency": 304,
    "simplified": "喜不自胜",
    "traditional": "喜不自勝"
  },
  {
    "frequency": 304,
    "simplified": "望文生义",
    "traditional": "望文生義"
  },
  {
    "frequency": 304,
    "simplified": "情意绵绵",
    "traditional": "情意綿綿"
  },
  {
    "frequency": 303,
    "simplified": "遇水架桥",
    "traditional": "遇水架橋"
  },
  {
    "frequency": 303,
    "simplified": "鲤鱼跳龙门",
    "traditional": "鯉魚跳龍門"
  },
  {
    "frequency": 303,
    "simplified": "包办代替",
    "traditional": "包辦代替"
  },
  {
    "frequency": 303,
    "simplified": "逢场作戏",
    "traditional": "逢場作戲"
  },
  {
    "frequency": 303,
    "simplified": "旁观者清",
    "traditional": "旁觀者清"
  },
  {
    "frequency": 303,
    "simplified": "面目可憎",
    "traditional": "面目可憎"
  },
  {
    "frequency": 303,
    "simplified": "小鸟依人",
    "traditional": "小鳥依人"
  },
  {
    "frequency": 303,
    "simplified": "缄口不言",
    "traditional": "緘口不言"
  },
  {
    "frequency": 303,
    "simplified": "畏缩不前",
    "traditional": "畏縮不前"
  },
  {
    "frequency": 302,
    "simplified": "胸怀大志",
    "traditional": "胸懷大志"
  },
  {
    "frequency": 302,
    "simplified": "一决胜负",
    "traditional": "一決勝負"
  },
  {
    "frequency": 302,
    "simplified": "一叶知秋",
    "traditional": "一葉知秋"
  },
  {
    "frequency": 302,
    "simplified": "互为表里",
    "traditional": "互為表裡"
  },
  {
    "frequency": 302,
    "simplified": "井底之蛙",
    "traditional": "井底之蛙"
  },
  {
    "frequency": 302,
    "simplified": "多行不义必自毙",
    "traditional": "多行不義必自斃"
  },
  {
    "frequency": 302,
    "simplified": "装神弄鬼",
    "traditional": "裝神弄鬼"
  },
  {
    "frequency": 302,
    "simplified": "物以类聚",
    "traditional": "物以類聚"
  },
  {
    "frequency": 301,
    "simplified": "风轻云淡",
    "traditional": "風輕雲淡"
  },
  {
    "frequency": 301,
    "simplified": "鸡飞蛋打",
    "traditional": "雞飛蛋打"
  },
  {
    "frequency": 301,
    "simplified": "无往不胜",
    "traditional": "無往不勝"
  },
  {
    "frequency": 301,
    "simplified": "因陋就简",
    "traditional": "因陋就簡"
  },
  {
    "frequency": 301,
    "simplified": "败兴而归",
    "traditional": "敗興而歸"
  },
  {
    "frequency": 300,
    "simplified": "魂不守舍",
    "traditional": "魂不守舍"
  },
  {
    "frequency": 300,
    "simplified": "媒妁之言",
    "traditional": "媒妁之言"
  },
  {
    "frequency": 300,
    "simplified": "功德圆满",
    "traditional": "功德圓滿"
  },
  {
    "frequency": 299,
    "simplified": "略逊一筹",
    "traditional": "略遜一籌"
  },
  {
    "frequency": 299,
    "simplified": "乘其不备",
    "traditional": "乘其不備"
  },
  {
    "frequency": 299,
    "simplified": "良辰美景",
    "traditional": "良辰美景"
  },
  {
    "frequency": 299,
    "simplified": "以眼还眼",
    "traditional": "以眼還眼"
  },
  {
    "frequency": 298,
    "simplified": "不乏先例",
    "traditional": "不乏先例"
  },
  {
    "frequency": 298,
    "simplified": "生米煮成熟饭",
    "traditional": "生米煮成熟飯"
  },
  {
    "frequency": 298,
    "simplified": "紫气东来",
    "traditional": "紫氣東來"
  },
  {
    "frequency": 298,
    "simplified": "宽宏大量",
    "traditional": "寬宏大量"
  },
  {
    "frequency": 298,
    "simplified": "风华绝代",
    "traditional": "風華絕代"
  },
  {
    "frequency": 298,
    "simplified": "口传心授",
    "traditional": "口傳心授"
  },
  {
    "frequency": 298,
    "simplified": "杯弓蛇影",
    "traditional": "杯弓蛇影"
  },
  {
    "frequency": 298,
    "simplified": "恶语相加",
    "traditional": "惡語相加"
  },
  {
    "frequency": 297,
    "simplified": "如醉如痴",
    "traditional": "如醉如痴"
  },
  {
    "frequency": 297,
    "simplified": "适逢其时",
    "traditional": "適逢其時"
  },
  {
    "frequency": 297,
    "simplified": "三番两次",
    "traditional": "三番兩次"
  },
  {
    "frequency": 297,
    "simplified": "不上不下",
    "traditional": "不上不下"
  },
  {
    "frequency": 296,
    "simplified": "低声下气",
    "traditional": "低聲下氣"
  },
  {
    "frequency": 296,
    "simplified": "依样画葫芦",
    "traditional": "依樣畫葫蘆"
  },
  {
    "frequency": 296,
    "simplified": "一分耕耘一分收获",
    "traditional": "一分耕耘一分收穫"
  },
  {
    "frequency": 296,
    "simplified": "火上加油",
    "traditional": "火上加油"
  },
  {
    "frequency": 295,
    "simplified": "日薄西山",
    "traditional": "日薄西山"
  },
  {
    "frequency": 295,
    "simplified": "目空一切",
    "traditional": "目空一切"
  },
  {
    "frequency": 294,
    "simplified": "项庄舞剑",
    "traditional": "項莊舞劍"
  },
  {
    "frequency": 294,
    "simplified": "倩女幽魂",
    "traditional": "倩女幽魂"
  },
  {
    "frequency": 294,
    "simplified": "泥牛入海",
    "traditional": "泥牛入海"
  },
  {
    "frequency": 294,
    "simplified": "心高气傲",
    "traditional": "心高氣傲"
  },
  {
    "frequency": 294,
    "simplified": "降格以求",
    "traditional": "降格以求"
  },
  {
    "frequency": 294,
    "simplified": "唇亡齿寒",
    "traditional": "唇亡齒寒"
  },
  {
    "frequency": 294,
    "simplified": "难以名状",
    "traditional": "難以名狀"
  },
  {
    "frequency": 294,
    "simplified": "香消玉殒",
    "traditional": "香消玉殞"
  },
  {
    "frequency": 294,
    "simplified": "富国强兵",
    "traditional": "富國強兵"
  },
  {
    "frequency": 293,
    "simplified": "爱屋及乌",
    "traditional": "愛屋及烏"
  },
  {
    "frequency": 293,
    "simplified": "不求甚解",
    "traditional": "不求甚解"
  },
  {
    "frequency": 293,
    "simplified": "屈打成招",
    "traditional": "屈打成招"
  },
  {
    "frequency": 293,
    "simplified": "拔刀相向",
    "traditional": "拔刀相向"
  },
  {
    "frequency": 293,
    "simplified": "称王称霸",
    "traditional": "稱王稱霸"
  },
  {
    "frequency": 292,
    "simplified": "独步天下",
    "traditional": "獨步天下"
  },
  {
    "frequency": 292,
    "simplified": "门户之见",
    "traditional": "門戶之見"
  },
  {
    "frequency": 292,
    "simplified": "名山大川",
    "traditional": "名山大川"
  },
  {
    "frequency": 292,
    "simplified": "自掘坟墓",
    "traditional": "自掘墳墓"
  },
  {
    "frequency": 292,
    "simplified": "志得意满",
    "traditional": "志得意滿"
  },
  {
    "frequency": 292,
    "simplified": "半真半假",
    "traditional": "半真半假"
  },
  {
    "frequency": 291,
    "simplified": "分化瓦解",
    "traditional": "分化瓦解"
  },
  {
    "frequency": 291,
    "simplified": "人微言轻",
    "traditional": "人微言輕"
  },
  {
    "frequency": 290,
    "simplified": "一星半点",
    "traditional": "一星半點"
  },
  {
    "frequency": 290,
    "simplified": "不识时务",
    "traditional": "不識時務"
  },
  {
    "frequency": 290,
    "simplified": "心腹之患",
    "traditional": "心腹之患"
  },
  {
    "frequency": 289,
    "simplified": "才貌双全",
    "traditional": "才貌雙全"
  },
  {
    "frequency": 289,
    "simplified": "天下无敌",
    "traditional": "天下無敵"
  },
  {
    "frequency": 289,
    "simplified": "穷奢极欲",
    "traditional": "窮奢極欲"
  },
  {
    "frequency": 288,
    "simplified": "有色眼镜",
    "traditional": "有色眼鏡"
  },
  {
    "frequency": 288,
    "simplified": "少不更事",
    "traditional": "少不更事"
  },
  {
    "frequency": 288,
    "simplified": "外强中干",
    "traditional": "外強中乾"
  },
  {
    "frequency": 288,
    "simplified": "身首异处",
    "traditional": "身首異處"
  },
  {
    "frequency": 288,
    "simplified": "冷若冰霜",
    "traditional": "冷若冰霜"
  },
  {
    "frequency": 288,
    "simplified": "一人得道",
    "traditional": "一人得道"
  },
  {
    "frequency": 288,
    "simplified": "独木难支",
    "traditional": "獨木難支"
  },
  {
    "frequency": 287,
    "simplified": "忘战必危",
    "traditional": "忘戰必危"
  },
  {
    "frequency": 287,
    "simplified": "旁门左道",
    "traditional": "旁門左道"
  },
  {
    "frequency": 287,
    "simplified": "贩夫走卒",
    "traditional": "販夫走卒"
  },
  {
    "frequency": 287,
    "simplified": "学无止境",
    "traditional": "學無止境"
  },
  {
    "frequency": 287,
    "simplified": "口齿伶俐",
    "traditional": "口齒伶俐"
  },
  {
    "frequency": 287,
    "simplified": "二龙戏珠",
    "traditional": "二龍戲珠"
  },
  {
    "frequency": 287,
    "simplified": "坐井观天",
    "traditional": "坐井觀天"
  },
  {
    "frequency": 286,
    "simplified": "说风凉话",
    "traditional": "說風涼話"
  },
  {
    "frequency": 286,
    "simplified": "喜从天降",
    "traditional": "喜從天降"
  },
  {
    "frequency": 286,
    "simplified": "同室操戈",
    "traditional": "同室操戈"
  },
  {
    "frequency": 286,
    "simplified": "鱼跃龙门",
    "traditional": "魚躍龍門"
  },
  {
    "frequency": 286,
    "simplified": "话里有话",
    "traditional": "話裡有話"
  },
  {
    "frequency": 285,
    "simplified": "不甚了了",
    "traditional": "不甚了了"
  },
  {
    "frequency": 285,
    "simplified": "秋风扫落叶",
    "traditional": "秋風掃落葉"
  },
  {
    "frequency": 285,
    "simplified": "力透纸背",
    "traditional": "力透紙背"
  },
  {
    "frequency": 285,
    "simplified": "天网恢恢疏而不漏",
    "traditional": "天網恢恢疏而不漏"
  },
  {
    "frequency": 285,
    "simplified": "聊以自慰",
    "traditional": "聊以自慰"
  },
  {
    "frequency": 285,
    "simplified": "反求诸己",
    "traditional": "反求諸己"
  },
  {
    "frequency": 285,
    "simplified": "完好无缺",
    "traditional": "完好無缺"
  },
  {
    "frequency": 284,
    "simplified": "调虎离山",
    "traditional": "調虎離山"
  },
  {
    "frequency": 284,
    "simplified": "血肉横飞",
    "traditional": "血肉橫飛"
  },
  {
    "frequency": 283,
    "simplified": "开卷有益",
    "traditional": "開卷有益"
  },
  {
    "frequency": 283,
    "simplified": "欲加之罪",
    "traditional": "欲加之罪"
  },
  {
    "frequency": 283,
    "simplified": "门户开放",
    "traditional": "門戶開放"
  },
  {
    "frequency": 283,
    "simplified": "正气凛然",
    "traditional": "正氣凜然"
  },
  {
    "frequency": 282,
    "simplified": "偏安一隅",
    "traditional": "偏安一隅"
  },
  {
    "frequency": 282,
    "simplified": "水能载舟",
    "traditional": "水能載舟"
  },
  {
    "frequency": 282,
    "simplified": "解甲归田",
    "traditional": "解甲歸田"
  },
  {
    "frequency": 281,
    "simplified": "达则兼济天下",
    "traditional": "達則兼濟天下"
  },
  {
    "frequency": 281,
    "simplified": "覆水难收",
    "traditional": "覆水難收"
  },
  {
    "frequency": 281,
    "simplified": "富贵不能淫",
    "traditional": "富貴不能淫"
  },
  {
    "frequency": 281,
    "simplified": "七拼八凑",
    "traditional": "七拼八湊"
  },
  {
    "frequency": 280,
    "simplified": "酗酒滋事",
    "traditional": "酗酒滋事"
  },
  {
    "frequency": 280,
    "simplified": "拈花惹草",
    "traditional": "拈花惹草"
  },
  {
    "frequency": 279,
    "simplified": "吃里扒外",
    "traditional": "吃裡扒外"
  },
  {
    "frequency": 279,
    "simplified": "杂乱无序",
    "traditional": "雜亂無序"
  },
  {
    "frequency": 279,
    "simplified": "明火执仗",
    "traditional": "明火執仗"
  },
  {
    "frequency": 279,
    "simplified": "天下一家",
    "traditional": "天下一家"
  },
  {
    "frequency": 279,
    "simplified": "皇亲国戚",
    "traditional": "皇親國戚"
  },
  {
    "frequency": 279,
    "simplified": "俯拾即是",
    "traditional": "俯拾即是"
  },
  {
    "frequency": 279,
    "simplified": "广种薄收",
    "traditional": "廣種薄收"
  },
  {
    "frequency": 278,
    "simplified": "不自量力",
    "traditional": "不自量力"
  },
  {
    "frequency": 278,
    "simplified": "告老还乡",
    "traditional": "告老還鄉"
  },
  {
    "frequency": 278,
    "simplified": "声如洪钟",
    "traditional": "聲如洪鐘"
  },
  {
    "frequency": 278,
    "simplified": "词不达意",
    "traditional": "詞不達意"
  },
  {
    "frequency": 278,
    "simplified": "听而不闻",
    "traditional": "聽而不聞"
  },
  {
    "frequency": 277,
    "simplified": "予取予求",
    "traditional": "予取予求"
  },
  {
    "frequency": 277,
    "simplified": "豆蔻年华",
    "traditional": "豆蔻年華"
  },
  {
    "frequency": 277,
    "simplified": "因果报应",
    "traditional": "因果報應"
  },
  {
    "frequency": 277,
    "simplified": "痛快淋漓",
    "traditional": "痛快淋漓"
  },
  {
    "frequency": 276,
    "simplified": "贫贱不能移",
    "traditional": "貧賤不能移"
  },
  {
    "frequency": 276,
    "simplified": "放虎归山",
    "traditional": "放虎歸山"
  },
  {
    "frequency": 276,
    "simplified": "有福同享",
    "traditional": "有福同享"
  },
  {
    "frequency": 276,
    "simplified": "前不着村后不着店",
    "traditional": "前不著村後不著店"
  },
  {
    "frequency": 276,
    "simplified": "风俗人情",
    "traditional": "風俗人情"
  },
  {
    "frequency": 275,
    "simplified": "三十年河东",
    "traditional": "三十年河東"
  },
  {
    "frequency": 275,
    "simplified": "特立独行",
    "traditional": "特立獨行"
  },
  {
    "frequency": 275,
    "simplified": "同床共枕",
    "traditional": "同床共枕"
  },
  {
    "frequency": 275,
    "simplified": "一拥而入",
    "traditional": "一擁而入"
  },
  {
    "frequency": 275,
    "simplified": "养兵千日",
    "traditional": "養兵千日"
  },
  {
    "frequency": 275,
    "simplified": "妙笔生花",
    "traditional": "妙筆生花"
  },
  {
    "frequency": 275,
    "simplified": "礼轻情意重",
    "traditional": "禮輕情意重"
  },
  {
    "frequency": 274,
    "simplified": "苦大仇深",
    "traditional": "苦大仇深"
  },
  {
    "frequency": 274,
    "simplified": "水火不相容",
    "traditional": "水火不相容"
  },
  {
    "frequency": 274,
    "simplified": "出以公心",
    "traditional": "出以公心"
  },
  {
    "frequency": 274,
    "simplified": "路不拾遗",
    "traditional": "路不拾遺"
  },
  {
    "frequency": 274,
    "simplified": "路遥知马力",
    "traditional": "路遙知馬力"
  },
  {
    "frequency": 274,
    "simplified": "过眼烟云",
    "traditional": "過眼煙雲"
  },
  {
    "frequency": 274,
    "simplified": "功夫之王",
    "traditional": "功夫之王"
  },
  {
    "frequency": 274,
    "simplified": "手足之情",
    "traditional": "手足之情"
  },
  {
    "frequency": 274,
    "simplified": "满腹狐疑",
    "traditional": "滿腹狐疑"
  },
  {
    "frequency": 273,
    "simplified": "本乡本土",
    "traditional": "本鄉本土"
  },
  {
    "frequency": 273,
    "simplified": "声色俱厉",
    "traditional": "聲色俱厲"
  },
  {
    "frequency": 273,
    "simplified": "家道中落",
    "traditional": "家道中落"
  },
  {
    "frequency": 273,
    "simplified": "面授机宜",
    "traditional": "面授機宜"
  },
  {
    "frequency": 273,
    "simplified": "后来者居上",
    "traditional": "後來者居上"
  },
  {
    "frequency": 272,
    "simplified": "物竞天择",
    "traditional": "物競天擇"
  },
  {
    "frequency": 272,
    "simplified": "磨刀不误砍柴工",
    "traditional": "磨刀不誤砍柴工"
  },
  {
    "frequency": 272,
    "simplified": "探囊取物",
    "traditional": "探囊取物"
  },
  {
    "frequency": 272,
    "simplified": "病魔缠身",
    "traditional": "病魔纏身"
  },
  {
    "frequency": 272,
    "simplified": "强颜欢笑",
    "traditional": "強顏歡笑"
  },
  {
    "frequency": 272,
    "simplified": "正人君子",
    "traditional": "正人君子"
  },
  {
    "frequency": 272,
    "simplified": "人神共愤",
    "traditional": "人神共憤"
  },
  {
    "frequency": 271,
    "simplified": "不知下落",
    "traditional": "不知下落"
  },
  {
    "frequency": 271,
    "simplified": "惠风和畅",
    "traditional": "惠風和暢"
  },
  {
    "frequency": 271,
    "simplified": "暮气沉沉",
    "traditional": "暮氣沉沉"
  },
  {
    "frequency": 271,
    "simplified": "化敌为友",
    "traditional": "化敵為友"
  },
  {
    "frequency": 271,
    "simplified": "轻言细语",
    "traditional": "輕言細語"
  },
  {
    "frequency": 271,
    "simplified": "决一死战",
    "traditional": "決一死戰"
  },
  {
    "frequency": 270,
    "simplified": "毫不介意",
    "traditional": "毫不介意"
  },
  {
    "frequency": 270,
    "simplified": "梳妆打扮",
    "traditional": "梳妝打扮"
  },
  {
    "frequency": 270,
    "simplified": "安然无事",
    "traditional": "安然無事"
  },
  {
    "frequency": 270,
    "simplified": "否极泰来",
    "traditional": "否極泰來"
  },
  {
    "frequency": 270,
    "simplified": "尸横遍野",
    "traditional": "屍橫遍野"
  },
  {
    "frequency": 270,
    "simplified": "楚楚可怜",
    "traditional": "楚楚可憐"
  },
  {
    "frequency": 269,
    "simplified": "春色满园",
    "traditional": "春色滿園"
  },
  {
    "frequency": 269,
    "simplified": "一表人才",
    "traditional": "一表人才"
  },
  {
    "frequency": 269,
    "simplified": "谬以千里",
    "traditional": "謬以千里"
  },
  {
    "frequency": 269,
    "simplified": "自讨没趣",
    "traditional": "自討沒趣"
  },
  {
    "frequency": 269,
    "simplified": "旭日东升",
    "traditional": "旭日東昇"
  },
  {
    "frequency": 269,
    "simplified": "弹无虚发",
    "traditional": "彈無虛發"
  },
  {
    "frequency": 268,
    "simplified": "回天无力",
    "traditional": "迴天無力"
  },
  {
    "frequency": 268,
    "simplified": "克勤克俭",
    "traditional": "克勤克儉"
  },
  {
    "frequency": 268,
    "simplified": "来日方长",
    "traditional": "來日方長"
  },
  {
    "frequency": 268,
    "simplified": "骨肉相连",
    "traditional": "骨肉相連"
  },
  {
    "frequency": 268,
    "simplified": "公正无私",
    "traditional": "公正無私"
  },
  {
    "frequency": 268,
    "simplified": "伯仲之间",
    "traditional": "伯仲之間"
  },
  {
    "frequency": 267,
    "simplified": "恶有恶报",
    "traditional": "惡有惡報"
  },
  {
    "frequency": 267,
    "simplified": "光芒万丈",
    "traditional": "光芒萬丈"
  },
  {
    "frequency": 267,
    "simplified": "呆若木鸡",
    "traditional": "呆若木雞"
  },
  {
    "frequency": 266,
    "simplified": "有钱能使鬼推磨",
    "traditional": "有錢能使鬼推磨"
  },
  {
    "frequency": 266,
    "simplified": "博学多才",
    "traditional": "博學多才"
  },
  {
    "frequency": 266,
    "simplified": "黯淡无光",
    "traditional": "黯淡無光"
  },
  {
    "frequency": 266,
    "simplified": "挤眉弄眼",
    "traditional": "擠眉弄眼"
  },
  {
    "frequency": 266,
    "simplified": "顺水人情",
    "traditional": "順水人情"
  },
  {
    "frequency": 266,
    "simplified": "横生枝节",
    "traditional": "橫生枝節"
  },
  {
    "frequency": 266,
    "simplified": "妻儿老小",
    "traditional": "妻兒老小"
  },
  {
    "frequency": 266,
    "simplified": "愚昧无知",
    "traditional": "愚昧無知"
  },
  {
    "frequency": 266,
    "simplified": "锦绣前程",
    "traditional": "錦繡前程"
  },
  {
    "frequency": 266,
    "simplified": "臭名远扬",
    "traditional": "臭名遠揚"
  },
  {
    "frequency": 265,
    "simplified": "见机行事",
    "traditional": "見機行事"
  },
  {
    "frequency": 265,
    "simplified": "疾风暴雨",
    "traditional": "疾風暴雨"
  },
  {
    "frequency": 265,
    "simplified": "少年老成",
    "traditional": "少年老成"
  },
  {
    "frequency": 265,
    "simplified": "南橘北枳",
    "traditional": "南橘北枳"
  },
  {
    "frequency": 265,
    "simplified": "千斤重担",
    "traditional": "千斤重擔"
  },
  {
    "frequency": 265,
    "simplified": "兵来将挡",
    "traditional": "兵來將擋"
  },
  {
    "frequency": 264,
    "simplified": "五大三粗",
    "traditional": "五大三粗"
  },
  {
    "frequency": 264,
    "simplified": "闭关自守",
    "traditional": "閉關自守"
  },
  {
    "frequency": 264,
    "simplified": "清规戒律",
    "traditional": "清規戒律"
  },
  {
    "frequency": 264,
    "simplified": "俭以养德",
    "traditional": "儉以養德"
  },
  {
    "frequency": 264,
    "simplified": "横平竖直",
    "traditional": "橫平豎直"
  },
  {
    "frequency": 264,
    "simplified": "时移世易",
    "traditional": "時移世易"
  },
  {
    "frequency": 264,
    "simplified": "仗势欺人",
    "traditional": "仗勢欺人"
  },
  {
    "frequency": 263,
    "simplified": "有言在先",
    "traditional": "有言在先"
  },
  {
    "frequency": 263,
    "simplified": "患难夫妻",
    "traditional": "患難夫妻"
  },
  {
    "frequency": 262,
    "simplified": "改换门庭",
    "traditional": "改換門庭"
  },
  {
    "frequency": 262,
    "simplified": "己所不欲勿施于人",
    "traditional": "己所不欲勿施於人"
  },
  {
    "frequency": 262,
    "simplified": "全盘托出",
    "traditional": "全盤托出"
  },
  {
    "frequency": 262,
    "simplified": "壮志凌云",
    "traditional": "壯志凌雲"
  },
  {
    "frequency": 262,
    "simplified": "玩火自焚",
    "traditional": "玩火自焚"
  },
  {
    "frequency": 262,
    "simplified": "戴罪立功",
    "traditional": "戴罪立功"
  },
  {
    "frequency": 262,
    "simplified": "以礼相待",
    "traditional": "以禮相待"
  },
  {
    "frequency": 261,
    "simplified": "掐头去尾",
    "traditional": "掐頭去尾"
  },
  {
    "frequency": 261,
    "simplified": "纸上得来终觉浅",
    "traditional": "紙上得來終覺淺"
  },
  {
    "frequency": 261,
    "simplified": "至死不渝",
    "traditional": "至死不渝"
  },
  {
    "frequency": 261,
    "simplified": "难登大雅之堂",
    "traditional": "難登大雅之堂"
  },
  {
    "frequency": 261,
    "simplified": "无所不有",
    "traditional": "無所不有"
  },
  {
    "frequency": 261,
    "simplified": "与虎谋皮",
    "traditional": "與虎謀皮"
  },
  {
    "frequency": 261,
    "simplified": "国家栋梁",
    "traditional": "國家棟梁"
  },
  {
    "frequency": 260,
    "simplified": "密锣紧鼓",
    "traditional": "密鑼緊鼓"
  },
  {
    "frequency": 260,
    "simplified": "取信于人",
    "traditional": "取信於人"
  },
  {
    "frequency": 260,
    "simplified": "安贫乐道",
    "traditional": "安貧樂道"
  },
  {
    "frequency": 260,
    "simplified": "穷则独善其身",
    "traditional": "窮則獨善其身"
  },
  {
    "frequency": 259,
    "simplified": "唠唠叨叨",
    "traditional": "嘮嘮叨叨"
  },
  {
    "frequency": 259,
    "simplified": "患难之交",
    "traditional": "患難之交"
  },
  {
    "frequency": 259,
    "simplified": "刀下留人",
    "traditional": "刀下留人"
  },
  {
    "frequency": 259,
    "simplified": "云蒸霞蔚",
    "traditional": "雲蒸霞蔚"
  },
  {
    "frequency": 259,
    "simplified": "破罐破摔",
    "traditional": "破罐破摔"
  },
  {
    "frequency": 258,
    "simplified": "牛鬼蛇神",
    "traditional": "牛鬼蛇神"
  },
  {
    "frequency": 258,
    "simplified": "劳苦功高",
    "traditional": "勞苦功高"
  },
  {
    "frequency": 258,
    "simplified": "以卵击石",
    "traditional": "以卵擊石"
  },
  {
    "frequency": 258,
    "simplified": "兵强马壮",
    "traditional": "兵強馬壯"
  },
  {
    "frequency": 258,
    "simplified": "有案可查",
    "traditional": "有案可查"
  },
  {
    "frequency": 258,
    "simplified": "有志者事竟成",
    "traditional": "有志者事竟成"
  },
  {
    "frequency": 258,
    "simplified": "先公后私",
    "traditional": "先公後私"
  },
  {
    "frequency": 258,
    "simplified": "过江之鲫",
    "traditional": "過江之鯽"
  },
  {
    "frequency": 258,
    "simplified": "膘肥体壮",
    "traditional": "膘肥體壯"
  },
  {
    "frequency": 258,
    "simplified": "默默无语",
    "traditional": "默默無語"
  },
  {
    "frequency": 257,
    "simplified": "收回成命",
    "traditional": "收回成命"
  },
  {
    "frequency": 257,
    "simplified": "有棱有角",
    "traditional": "有稜有角"
  },
  {
    "frequency": 257,
    "simplified": "回光返照",
    "traditional": "迴光返照"
  },
  {
    "frequency": 257,
    "simplified": "空口无凭",
    "traditional": "空口無憑"
  },
  {
    "frequency": 257,
    "simplified": "枯枝败叶",
    "traditional": "枯枝敗葉"
  },
  {
    "frequency": 257,
    "simplified": "日久见人心",
    "traditional": "日久見人心"
  },
  {
    "frequency": 257,
    "simplified": "孰能无过",
    "traditional": "孰能無過"
  },
  {
    "frequency": 257,
    "simplified": "高高挂起",
    "traditional": "高高掛起"
  },
  {
    "frequency": 256,
    "simplified": "横行无忌",
    "traditional": "橫行無忌"
  },
  {
    "frequency": 256,
    "simplified": "谷贱伤农",
    "traditional": "穀賤傷農"
  },
  {
    "frequency": 256,
    "simplified": "君子之交",
    "traditional": "君子之交"
  },
  {
    "frequency": 255,
    "simplified": "碧水青山",
    "traditional": "碧水青山"
  },
  {
    "frequency": 255,
    "simplified": "握手言欢",
    "traditional": "握手言歡"
  },
  {
    "frequency": 255,
    "simplified": "自求多福",
    "traditional": "自求多福"
  },
  {
    "frequency": 255,
    "simplified": "无所不知",
    "traditional": "無所不知"
  },
  {
    "frequency": 255,
    "simplified": "刚直不阿",
    "traditional": "剛直不阿"
  },
  {
    "frequency": 255,
    "simplified": "出人意外",
    "traditional": "出人意外"
  },
  {
    "frequency": 255,
    "simplified": "艺高人胆大",
    "traditional": "藝高人膽大"
  },
  {
    "frequency": 255,
    "simplified": "世上无难事",
    "traditional": "世上無難事"
  },
  {
    "frequency": 254,
    "simplified": "唯命是从",
    "traditional": "唯命是從"
  },
  {
    "frequency": 254,
    "simplified": "不可捉摸",
    "traditional": "不可捉摸"
  },
  {
    "frequency": 254,
    "simplified": "没精打采",
    "traditional": "沒精打采"
  },
  {
    "frequency": 254,
    "simplified": "关门闭户",
    "traditional": "關門閉戶"
  },
  {
    "frequency": 254,
    "simplified": "三男两女",
    "traditional": "三男兩女"
  },
  {
    "frequency": 254,
    "simplified": "冤冤相报",
    "traditional": "冤冤相報"
  },
  {
    "frequency": 254,
    "simplified": "决胜千里",
    "traditional": "決勝千里"
  },
  {
    "frequency": 254,
    "simplified": "离群索居",
    "traditional": "離群索居"
  },
  {
    "frequency": 254,
    "simplified": "江湖骗子",
    "traditional": "江湖騙子"
  },
  {
    "frequency": 253,
    "simplified": "城门失火",
    "traditional": "城門失火"
  },
  {
    "frequency": 253,
    "simplified": "不言不语",
    "traditional": "不言不語"
  },
  {
    "frequency": 253,
    "simplified": "弊绝风清",
    "traditional": "弊絕風清"
  },
  {
    "frequency": 252,
    "simplified": "大智大勇",
    "traditional": "大智大勇"
  },
  {
    "frequency": 252,
    "simplified": "一条道走到黑",
    "traditional": "一條道走到黑"
  },
  {
    "frequency": 252,
    "simplified": "低三下四",
    "traditional": "低三下四"
  },
  {
    "frequency": 252,
    "simplified": "自成一家",
    "traditional": "自成一家"
  },
  {
    "frequency": 252,
    "simplified": "应付自如",
    "traditional": "應付自如"
  },
  {
    "frequency": 251,
    "simplified": "不咸不淡",
    "traditional": "不鹹不淡"
  },
  {
    "frequency": 251,
    "simplified": "直上直下",
    "traditional": "直上直下"
  },
  {
    "frequency": 251,
    "simplified": "不打不相识",
    "traditional": "不打不相識"
  },
  {
    "frequency": 251,
    "simplified": "以文会友",
    "traditional": "以文會友"
  },
  {
    "frequency": 251,
    "simplified": "势不可当",
    "traditional": "勢不可當"
  },
  {
    "frequency": 251,
    "simplified": "失道寡助",
    "traditional": "失道寡助"
  },
  {
    "frequency": 251,
    "simplified": "礼崩乐坏",
    "traditional": "禮崩樂壞"
  },
  {
    "frequency": 250,
    "simplified": "寝食不安",
    "traditional": "寢食不安"
  },
  {
    "frequency": 250,
    "simplified": "九五之尊",
    "traditional": "九五之尊"
  },
  {
    "frequency": 250,
    "simplified": "自成一格",
    "traditional": "自成一格"
  },
  {
    "frequency": 249,
    "simplified": "除旧布新",
    "traditional": "除舊佈新"
  },
  {
    "frequency": 249,
    "simplified": "怜香惜玉",
    "traditional": "憐香惜玉"
  },
  {
    "frequency": 249,
    "simplified": "一发而不可收拾",
    "traditional": "一發而不可收拾"
  },
  {
    "frequency": 249,
    "simplified": "三人成虎",
    "traditional": "三人成虎"
  },
  {
    "frequency": 249,
    "simplified": "振振有辞",
    "traditional": "振振有辭"
  },
  {
    "frequency": 249,
    "simplified": "鹬蚌相争",
    "traditional": "鷸蚌相爭"
  },
  {
    "frequency": 249,
    "simplified": "偷天换日",
    "traditional": "偷天換日"
  },
  {
    "frequency": 249,
    "simplified": "同心合力",
    "traditional": "同心合力"
  },
  {
    "frequency": 248,
    "simplified": "照葫芦画瓢",
    "traditional": "照葫蘆畫瓢"
  },
  {
    "frequency": 248,
    "simplified": "不共戴天",
    "traditional": "不共戴天"
  },
  {
    "frequency": 248,
    "simplified": "目光炯炯",
    "traditional": "目光炯炯"
  },
  {
    "frequency": 248,
    "simplified": "大事化小小事化了",
    "traditional": "大事化小小事化了"
  },
  {
    "frequency": 248,
    "simplified": "洁白无瑕",
    "traditional": "潔白無瑕"
  },
  {
    "frequency": 248,
    "simplified": "言为心声",
    "traditional": "言為心聲"
  },
  {
    "frequency": 248,
    "simplified": "鸣锣开道",
    "traditional": "鳴鑼開道"
  },
  {
    "frequency": 248,
    "simplified": "雄才大略",
    "traditional": "雄才大略"
  },
  {
    "frequency": 247,
    "simplified": "不干不净",
    "traditional": "不乾不淨"
  },
  {
    "frequency": 246,
    "simplified": "旧话重提",
    "traditional": "舊話重提"
  },
  {
    "frequency": 246,
    "simplified": "无风不起浪",
    "traditional": "無風不起浪"
  },
  {
    "frequency": 246,
    "simplified": "晨钟暮鼓",
    "traditional": "晨鐘暮鼓"
  },
  {
    "frequency": 246,
    "simplified": "时不再来",
    "traditional": "時不再來"
  },
  {
    "frequency": 246,
    "simplified": "倾国倾城",
    "traditional": "傾國傾城"
  },
  {
    "frequency": 246,
    "simplified": "如花似玉",
    "traditional": "如花似玉"
  },
  {
    "frequency": 246,
    "simplified": "小脚女人",
    "traditional": "小腳女人"
  },
  {
    "frequency": 246,
    "simplified": "爱惜羽毛",
    "traditional": "愛惜羽毛"
  },
  {
    "frequency": 246,
    "simplified": "茂林修竹",
    "traditional": "茂林修竹"
  },
  {
    "frequency": 246,
    "simplified": "不足为外人道",
    "traditional": "不足為外人道"
  },
  {
    "frequency": 245,
    "simplified": "百步穿杨",
    "traditional": "百步穿楊"
  },
  {
    "frequency": 245,
    "simplified": "五毒俱全",
    "traditional": "五毒俱全"
  },
  {
    "frequency": 245,
    "simplified": "踌躇不前",
    "traditional": "躊躇不前"
  },
  {
    "frequency": 245,
    "simplified": "未卜先知",
    "traditional": "未卜先知"
  },
  {
    "frequency": 245,
    "simplified": "含苞欲放",
    "traditional": "含苞欲放"
  },
  {
    "frequency": 245,
    "simplified": "百思不解",
    "traditional": "百思不解"
  },
  {
    "frequency": 245,
    "simplified": "咫尺天涯",
    "traditional": "咫尺天涯"
  },
  {
    "frequency": 244,
    "simplified": "满面红光",
    "traditional": "滿面紅光"
  },
  {
    "frequency": 244,
    "simplified": "旧瓶装新酒",
    "traditional": "舊瓶裝新酒"
  },
  {
    "frequency": 244,
    "simplified": "神龙见首不见尾",
    "traditional": "神龍見首不見尾"
  },
  {
    "frequency": 244,
    "simplified": "倾囊相助",
    "traditional": "傾囊相助"
  },
  {
    "frequency": 244,
    "simplified": "排除异己",
    "traditional": "排除異己"
  },
  {
    "frequency": 244,
    "simplified": "志在四方",
    "traditional": "志在四方"
  },
  {
    "frequency": 243,
    "simplified": "才华出众",
    "traditional": "才華出眾"
  },
  {
    "frequency": 243,
    "simplified": "独揽大权",
    "traditional": "獨攬大權"
  },
  {
    "frequency": 243,
    "simplified": "一定之规",
    "traditional": "一定之規"
  },
  {
    "frequency": 243,
    "simplified": "英雄所见略同",
    "traditional": "英雄所見略同"
  },
  {
    "frequency": 243,
    "simplified": "垂帘听政",
    "traditional": "垂簾聽政"
  },
  {
    "frequency": 243,
    "simplified": "以逸待劳",
    "traditional": "以逸待勞"
  },
  {
    "frequency": 243,
    "simplified": "脚不沾地",
    "traditional": "腳不沾地"
  },
  {
    "frequency": 243,
    "simplified": "安家立业",
    "traditional": "安家立業"
  },
  {
    "frequency": 242,
    "simplified": "后生可畏",
    "traditional": "後生可畏"
  },
  {
    "frequency": 242,
    "simplified": "神情自若",
    "traditional": "神情自若"
  },
  {
    "frequency": 242,
    "simplified": "天理难容",
    "traditional": "天理難容"
  },
  {
    "frequency": 242,
    "simplified": "半梦半醒",
    "traditional": "半夢半醒"
  },
  {
    "frequency": 242,
    "simplified": "自卖自夸",
    "traditional": "自賣自誇"
  },
  {
    "frequency": 241,
    "simplified": "万籁俱寂",
    "traditional": "萬籟俱寂"
  },
  {
    "frequency": 241,
    "simplified": "于心何忍",
    "traditional": "於心何忍"
  },
  {
    "frequency": 241,
    "simplified": "徒劳无益",
    "traditional": "徒勞無益"
  },
  {
    "frequency": 240,
    "simplified": "邯郸学步",
    "traditional": "邯鄲學步"
  },
  {
    "frequency": 240,
    "simplified": "自食恶果",
    "traditional": "自食惡果"
  },
  {
    "frequency": 240,
    "simplified": "大彻大悟",
    "traditional": "大徹大悟"
  },
  {
    "frequency": 240,
    "simplified": "能工巧匠",
    "traditional": "能工巧匠"
  },
  {
    "frequency": 240,
    "simplified": "无可估量",
    "traditional": "無可估量"
  },
  {
    "frequency": 239,
    "simplified": "轻装前进",
    "traditional": "輕裝前進"
  },
  {
    "frequency": 239,
    "simplified": "四海为家",
    "traditional": "四海為家"
  },
  {
    "frequency": 239,
    "simplified": "相生相克",
    "traditional": "相生相剋"
  },
  {
    "frequency": 239,
    "simplified": "居功自傲",
    "traditional": "居功自傲"
  },
  {
    "frequency": 239,
    "simplified": "青出于蓝",
    "traditional": "青出於藍"
  },
  {
    "frequency": 239,
    "simplified": "今不如昔",
    "traditional": "今不如昔"
  },
  {
    "frequency": 238,
    "simplified": "意在沛公",
    "traditional": "意在沛公"
  },
  {
    "frequency": 238,
    "simplified": "有口难辩",
    "traditional": "有口難辯"
  },
  {
    "frequency": 238,
    "simplified": "指桑骂槐",
    "traditional": "指桑罵槐"
  },
  {
    "frequency": 238,
    "simplified": "养虎为患",
    "traditional": "養虎為患"
  },
  {
    "frequency": 237,
    "simplified": "言归正传",
    "traditional": "言歸正傳"
  },
  {
    "frequency": 237,
    "simplified": "三寸金莲",
    "traditional": "三寸金蓮"
  },
  {
    "frequency": 237,
    "simplified": "东方不亮西方亮",
    "traditional": "東方不亮西方亮"
  },
  {
    "frequency": 237,
    "simplified": "格物致知",
    "traditional": "格物致知"
  },
  {
    "frequency": 237,
    "simplified": "是可忍孰不可忍",
    "traditional": "是可忍孰不可忍"
  },
  {
    "frequency": 237,
    "simplified": "时运不济",
    "traditional": "時運不濟"
  },
  {
    "frequency": 237,
    "simplified": "心神不定",
    "traditional": "心神不定"
  },
  {
    "frequency": 237,
    "simplified": "水火无情",
    "traditional": "水火無情"
  },
  {
    "frequency": 237,
    "simplified": "似水流年",
    "traditional": "似水流年"
  },
  {
    "frequency": 237,
    "simplified": "男耕女织",
    "traditional": "男耕女織"
  },
  {
    "frequency": 237,
    "simplified": "鸡犬之声相闻",
    "traditional": "雞犬之聲相聞"
  },
  {
    "frequency": 236,
    "simplified": "望梅止渴",
    "traditional": "望梅止渴"
  },
  {
    "frequency": 236,
    "simplified": "羊肠小道",
    "traditional": "羊腸小道"
  },
  {
    "frequency": 236,
    "simplified": "自寻烦恼",
    "traditional": "自尋煩惱"
  },
  {
    "frequency": 236,
    "simplified": "蜕化变质",
    "traditional": "蛻化變質"
  },
  {
    "frequency": 236,
    "simplified": "劳师动众",
    "traditional": "勞師動眾"
  },
  {
    "frequency": 236,
    "simplified": "兵败如山倒",
    "traditional": "兵敗如山倒"
  },
  {
    "frequency": 236,
    "simplified": "接风洗尘",
    "traditional": "接風洗塵"
  },
  {
    "frequency": 236,
    "simplified": "拈轻怕重",
    "traditional": "拈輕怕重"
  },
  {
    "frequency": 236,
    "simplified": "秀外慧中",
    "traditional": "秀外慧中"
  },
  {
    "frequency": 235,
    "simplified": "自不量力",
    "traditional": "自不量力"
  },
  {
    "frequency": 235,
    "simplified": "说来话长",
    "traditional": "說來話長"
  },
  {
    "frequency": 235,
    "simplified": "风卷残云",
    "traditional": "風捲殘雲"
  },
  {
    "frequency": 234,
    "simplified": "敢作敢当",
    "traditional": "敢作敢當"
  },
  {
    "frequency": 234,
    "simplified": "穷山恶水",
    "traditional": "窮山惡水"
  },
  {
    "frequency": 234,
    "simplified": "龙争虎斗",
    "traditional": "龍爭虎鬥"
  },
  {
    "frequency": 234,
    "simplified": "拼死拼活",
    "traditional": "拼死拼活"
  },
  {
    "frequency": 234,
    "simplified": "百折不回",
    "traditional": "百折不回"
  },
  {
    "frequency": 234,
    "simplified": "傲然挺立",
    "traditional": "傲然挺立"
  },
  {
    "frequency": 234,
    "simplified": "学富五车",
    "traditional": "學富五車"
  },
  {
    "frequency": 234,
    "simplified": "俗不可耐",
    "traditional": "俗不可耐"
  },
  {
    "frequency": 234,
    "simplified": "流水不腐",
    "traditional": "流水不腐"
  },
  {
    "frequency": 233,
    "simplified": "取之不尽用之不竭",
    "traditional": "取之不盡用之不竭"
  },
  {
    "frequency": 233,
    "simplified": "一传十十传百",
    "traditional": "一傳十十傳百"
  },
  {
    "frequency": 233,
    "simplified": "民生凋敝",
    "traditional": "民生凋敝"
  },
  {
    "frequency": 233,
    "simplified": "思绪万千",
    "traditional": "思緒萬千"
  },
  {
    "frequency": 232,
    "simplified": "所向无敌",
    "traditional": "所向無敵"
  },
  {
    "frequency": 232,
    "simplified": "奔波劳碌",
    "traditional": "奔波勞碌"
  },
  {
    "frequency": 232,
    "simplified": "因人制宜",
    "traditional": "因人制宜"
  },
  {
    "frequency": 232,
    "simplified": "弹冠相庆",
    "traditional": "彈冠相慶"
  },
  {
    "frequency": 232,
    "simplified": "不以规矩",
    "traditional": "不以規矩"
  },
  {
    "frequency": 232,
    "simplified": "方寸之地",
    "traditional": "方寸之地"
  },
  {
    "frequency": 232,
    "simplified": "成年累月",
    "traditional": "成年累月"
  },
  {
    "frequency": 231,
    "simplified": "群魔乱舞",
    "traditional": "群魔亂舞"
  },
  {
    "frequency": 231,
    "simplified": "钻木取火",
    "traditional": "鑽木取火"
  },
  {
    "frequency": 231,
    "simplified": "壁垒森严",
    "traditional": "壁壘森嚴"
  },
  {
    "frequency": 231,
    "simplified": "清心寡欲",
    "traditional": "清心寡慾"
  },
  {
    "frequency": 231,
    "simplified": "下回分解",
    "traditional": "下回分解"
  },
  {
    "frequency": 231,
    "simplified": "阴错阳差",
    "traditional": "陰錯陽差"
  },
  {
    "frequency": 231,
    "simplified": "仙风道骨",
    "traditional": "仙風道骨"
  },
  {
    "frequency": 231,
    "simplified": "以身殉国",
    "traditional": "以身殉國"
  },
  {
    "frequency": 231,
    "simplified": "男儿有泪不轻弹",
    "traditional": "男兒有淚不輕彈"
  },
  {
    "frequency": 230,
    "simplified": "鼠目寸光",
    "traditional": "鼠目寸光"
  },
  {
    "frequency": 230,
    "simplified": "瞄准射击",
    "traditional": "瞄準射擊"
  },
  {
    "frequency": 230,
    "simplified": "逼良为娼",
    "traditional": "逼良為娼"
  },
  {
    "frequency": 230,
    "simplified": "千回百转",
    "traditional": "千迴百轉"
  },
  {
    "frequency": 230,
    "simplified": "凄风冷雨",
    "traditional": "悽風冷雨"
  },
  {
    "frequency": 230,
    "simplified": "益寿延年",
    "traditional": "益壽延年"
  },
  {
    "frequency": 230,
    "simplified": "又红又专",
    "traditional": "又紅又專"
  },
  {
    "frequency": 230,
    "simplified": "涸泽而渔",
    "traditional": "涸澤而漁"
  },
  {
    "frequency": 229,
    "simplified": "目光如炬",
    "traditional": "目光如炬"
  },
  {
    "frequency": 229,
    "simplified": "处之泰然",
    "traditional": "處之泰然"
  },
  {
    "frequency": 229,
    "simplified": "五花大绑",
    "traditional": "五花大綁"
  },
  {
    "frequency": 229,
    "simplified": "针头线脑",
    "traditional": "針頭線腦"
  },
  {
    "frequency": 229,
    "simplified": "一张一弛",
    "traditional": "一張一弛"
  },
  {
    "frequency": 229,
    "simplified": "至善至美",
    "traditional": "至善至美"
  },
  {
    "frequency": 229,
    "simplified": "绵里藏针",
    "traditional": "綿裡藏針"
  },
  {
    "frequency": 228,
    "simplified": "不越雷池",
    "traditional": "不越雷池"
  },
  {
    "frequency": 228,
    "simplified": "手眼通天",
    "traditional": "手眼通天"
  },
  {
    "frequency": 228,
    "simplified": "愁云惨雾",
    "traditional": "愁雲慘霧"
  },
  {
    "frequency": 227,
    "simplified": "不绝如缕",
    "traditional": "不絕如縷"
  },
  {
    "frequency": 227,
    "simplified": "一钱不值",
    "traditional": "一錢不值"
  },
  {
    "frequency": 227,
    "simplified": "心慌意乱",
    "traditional": "心慌意亂"
  },
  {
    "frequency": 227,
    "simplified": "贪生怕死",
    "traditional": "貪生怕死"
  },
  {
    "frequency": 226,
    "simplified": "庖丁解牛",
    "traditional": "庖丁解牛"
  },
  {
    "frequency": 226,
    "simplified": "苦难深重",
    "traditional": "苦難深重"
  },
  {
    "frequency": 226,
    "simplified": "狼烟四起",
    "traditional": "狼煙四起"
  },
  {
    "frequency": 226,
    "simplified": "亦庄亦谐",
    "traditional": "亦莊亦諧"
  },
  {
    "frequency": 225,
    "simplified": "点头哈腰",
    "traditional": "點頭哈腰"
  },
  {
    "frequency": 224,
    "simplified": "鉴往知来",
    "traditional": "鑑往知來"
  },
  {
    "frequency": 224,
    "simplified": "狰狞面目",
    "traditional": "猙獰面目"
  },
  {
    "frequency": 224,
    "simplified": "女娲补天",
    "traditional": "女媧補天"
  },
  {
    "frequency": 224,
    "simplified": "春去秋来",
    "traditional": "春去秋來"
  },
  {
    "frequency": 224,
    "simplified": "少见多怪",
    "traditional": "少見多怪"
  },
  {
    "frequency": 224,
    "simplified": "五十步笑百步",
    "traditional": "五十步笑百步"
  },
  {
    "frequency": 224,
    "simplified": "早知今日",
    "traditional": "早知今日"
  },
  {
    "frequency": 223,
    "simplified": "吃里爬外",
    "traditional": "吃裡爬外"
  },
  {
    "frequency": 223,
    "simplified": "富贵吉祥",
    "traditional": "富貴吉祥"
  },
  {
    "frequency": 223,
    "simplified": "惜墨如金",
    "traditional": "惜墨如金"
  },
  {
    "frequency": 223,
    "simplified": "不敢越雷池一步",
    "traditional": "不敢越雷池一步"
  },
  {
    "frequency": 223,
    "simplified": "南郭先生",
    "traditional": "南郭先生"
  },
  {
    "frequency": 223,
    "simplified": "不懂装懂",
    "traditional": "不懂裝懂"
  },
  {
    "frequency": 223,
    "simplified": "鼓乐喧天",
    "traditional": "鼓樂喧天"
  },
  {
    "frequency": 223,
    "simplified": "广袤无垠",
    "traditional": "廣袤無垠"
  },
  {
    "frequency": 223,
    "simplified": "大树底下好乘凉",
    "traditional": "大樹底下好乘涼"
  },
  {
    "frequency": 223,
    "simplified": "照猫画虎",
    "traditional": "照貓畫虎"
  },
  {
    "frequency": 223,
    "simplified": "永志不忘",
    "traditional": "永誌不忘"
  },
  {
    "frequency": 222,
    "simplified": "光阴似箭",
    "traditional": "光陰似箭"
  },
  {
    "frequency": 222,
    "simplified": "鸣冤叫屈",
    "traditional": "鳴冤叫屈"
  },
  {
    "frequency": 222,
    "simplified": "青史留名",
    "traditional": "青史留名"
  },
  {
    "frequency": 222,
    "simplified": "自视甚高",
    "traditional": "自視甚高"
  },
  {
    "frequency": 222,
    "simplified": "是非分明",
    "traditional": "是非分明"
  },
  {
    "frequency": 222,
    "simplified": "破除迷信",
    "traditional": "破除迷信"
  },
  {
    "frequency": 222,
    "simplified": "山重水复",
    "traditional": "山重水複"
  },
  {
    "frequency": 221,
    "simplified": "择善而从",
    "traditional": "擇善而從"
  },
  {
    "frequency": 221,
    "simplified": "州官放火",
    "traditional": "州官放火"
  },
  {
    "frequency": 221,
    "simplified": "眼明手快",
    "traditional": "眼明手快"
  },
  {
    "frequency": 221,
    "simplified": "牛头不对马嘴",
    "traditional": "牛頭不對馬嘴"
  },
  {
    "frequency": 221,
    "simplified": "志在千里",
    "traditional": "志在千里"
  },
  {
    "frequency": 221,
    "simplified": "酒酣耳热",
    "traditional": "酒酣耳熱"
  },
  {
    "frequency": 221,
    "simplified": "遗臭万年",
    "traditional": "遺臭萬年"
  },
  {
    "frequency": 220,
    "simplified": "不祥之兆",
    "traditional": "不祥之兆"
  },
  {
    "frequency": 220,
    "simplified": "东挪西凑",
    "traditional": "東挪西湊"
  },
  {
    "frequency": 220,
    "simplified": "风雨如晦",
    "traditional": "風雨如晦"
  },
  {
    "frequency": 220,
    "simplified": "摇头摆尾",
    "traditional": "搖頭擺尾"
  },
  {
    "frequency": 220,
    "simplified": "泼妇骂街",
    "traditional": "潑婦罵街"
  },
  {
    "frequency": 220,
    "simplified": "必有近忧",
    "traditional": "必有近憂"
  },
  {
    "frequency": 220,
    "simplified": "风雨不改",
    "traditional": "風雨不改"
  },
  {
    "frequency": 219,
    "simplified": "浪子回头金不换",
    "traditional": "浪子回頭金不換"
  },
  {
    "frequency": 219,
    "simplified": "不可胜数",
    "traditional": "不可勝數"
  },
  {
    "frequency": 219,
    "simplified": "无心插柳柳成荫",
    "traditional": "無心插柳柳成蔭"
  },
  {
    "frequency": 219,
    "simplified": "局促不安",
    "traditional": "侷促不安"
  },
  {
    "frequency": 219,
    "simplified": "仪表堂堂",
    "traditional": "儀表堂堂"
  },
  {
    "frequency": 219,
    "simplified": "欺软怕硬",
    "traditional": "欺軟怕硬"
  },
  {
    "frequency": 218,
    "simplified": "打开天窗说亮话",
    "traditional": "打開天窗說亮話"
  },
  {
    "frequency": 218,
    "simplified": "趋炎附势",
    "traditional": "趨炎附勢"
  },
  {
    "frequency": 218,
    "simplified": "狗血淋头",
    "traditional": "狗血淋頭"
  },
  {
    "frequency": 218,
    "simplified": "与时偕行",
    "traditional": "與時偕行"
  },
  {
    "frequency": 218,
    "simplified": "飘飘欲仙",
    "traditional": "飄飄欲仙"
  },
  {
    "frequency": 218,
    "simplified": "偷偷摸摸",
    "traditional": "偷偷摸摸"
  },
  {
    "frequency": 218,
    "simplified": "脚踏两只船",
    "traditional": "腳踏兩隻船"
  },
  {
    "frequency": 218,
    "simplified": "一夫当关",
    "traditional": "一夫當關"
  },
  {
    "frequency": 217,
    "simplified": "鹤发童颜",
    "traditional": "鶴髮童顏"
  },
  {
    "frequency": 217,
    "simplified": "大地回春",
    "traditional": "大地回春"
  },
  {
    "frequency": 217,
    "simplified": "沸反盈天",
    "traditional": "沸反盈天"
  },
  {
    "frequency": 217,
    "simplified": "事不过三",
    "traditional": "事不過三"
  },
  {
    "frequency": 217,
    "simplified": "开疆辟土",
    "traditional": "開疆闢土"
  },
  {
    "frequency": 217,
    "simplified": "有条有理",
    "traditional": "有條有理"
  },
  {
    "frequency": 217,
    "simplified": "悔恨交加",
    "traditional": "悔恨交加"
  },
  {
    "frequency": 217,
    "simplified": "牛刀小试",
    "traditional": "牛刀小試"
  },
  {
    "frequency": 217,
    "simplified": "只许州官放火",
    "traditional": "只許州官放火"
  },
  {
    "frequency": 216,
    "simplified": "洞若观火",
    "traditional": "洞若觀火"
  },
  {
    "frequency": 216,
    "simplified": "一决雌雄",
    "traditional": "一決雌雄"
  },
  {
    "frequency": 216,
    "simplified": "种瓜得瓜",
    "traditional": "種瓜得瓜"
  },
  {
    "frequency": 216,
    "simplified": "玉树临风",
    "traditional": "玉樹臨風"
  },
  {
    "frequency": 216,
    "simplified": "封疆大吏",
    "traditional": "封疆大吏"
  },
  {
    "frequency": 216,
    "simplified": "毫不利己",
    "traditional": "毫不利己"
  },
  {
    "frequency": 216,
    "simplified": "出乎意外",
    "traditional": "出乎意外"
  },
  {
    "frequency": 216,
    "simplified": "伯乐相马",
    "traditional": "伯樂相馬"
  },
  {
    "frequency": 215,
    "simplified": "一息尚存",
    "traditional": "一息尚存"
  },
  {
    "frequency": 215,
    "simplified": "云开雾散",
    "traditional": "雲開霧散"
  },
  {
    "frequency": 215,
    "simplified": "珍禽异兽",
    "traditional": "珍禽異獸"
  },
  {
    "frequency": 215,
    "simplified": "比肩而立",
    "traditional": "比肩而立"
  },
  {
    "frequency": 215,
    "simplified": "精明强干",
    "traditional": "精明強幹"
  },
  {
    "frequency": 215,
    "simplified": "心如止水",
    "traditional": "心如止水"
  },
  {
    "frequency": 215,
    "simplified": "星星之火可以燎原",
    "traditional": "星星之火可以燎原"
  },
  {
    "frequency": 215,
    "simplified": "死无葬身之地",
    "traditional": "死無葬身之地"
  },
  {
    "frequency": 214,
    "simplified": "大智若愚",
    "traditional": "大智若愚"
  },
  {
    "frequency": 214,
    "simplified": "仁义道德",
    "traditional": "仁義道德"
  },
  {
    "frequency": 214,
    "simplified": "洋洋洒洒",
    "traditional": "洋洋灑灑"
  },
  {
    "frequency": 214,
    "simplified": "锦绣河山",
    "traditional": "錦繡河山"
  },
  {
    "frequency": 214,
    "simplified": "东西南北",
    "traditional": "東西南北"
  },
  {
    "frequency": 214,
    "simplified": "棒打鸳鸯",
    "traditional": "棒打鴛鴦"
  },
  {
    "frequency": 214,
    "simplified": "两小无猜",
    "traditional": "兩小無猜"
  },
  {
    "frequency": 213,
    "simplified": "不识庐山真面目",
    "traditional": "不識廬山真面目"
  },
  {
    "frequency": 213,
    "simplified": "做小动作",
    "traditional": "做小動作"
  },
  {
    "frequency": 213,
    "simplified": "金风送爽",
    "traditional": "金風送爽"
  },
  {
    "frequency": 213,
    "simplified": "冤家路窄",
    "traditional": "冤家路窄"
  },
  {
    "frequency": 213,
    "simplified": "情景交融",
    "traditional": "情景交融"
  },
  {
    "frequency": 212,
    "simplified": "左邻右里",
    "traditional": "左鄰右里"
  },
  {
    "frequency": 212,
    "simplified": "软弱无能",
    "traditional": "軟弱無能"
  },
  {
    "frequency": 212,
    "simplified": "耍嘴皮子",
    "traditional": "耍嘴皮子"
  },
  {
    "frequency": 212,
    "simplified": "缘木求鱼",
    "traditional": "緣木求魚"
  },
  {
    "frequency": 212,
    "simplified": "仁者乐山",
    "traditional": "仁者樂山"
  },
  {
    "frequency": 212,
    "simplified": "手不释卷",
    "traditional": "手不釋卷"
  },
  {
    "frequency": 212,
    "simplified": "格杀勿论",
    "traditional": "格殺勿論"
  },
  {
    "frequency": 212,
    "simplified": "莫逆之交",
    "traditional": "莫逆之交"
  },
  {
    "frequency": 212,
    "simplified": "等米下锅",
    "traditional": "等米下鍋"
  },
  {
    "frequency": 211,
    "simplified": "变化无穷",
    "traditional": "變化無窮"
  },
  {
    "frequency": 211,
    "simplified": "宝刀未老",
    "traditional": "寶刀未老"
  },
  {
    "frequency": 211,
    "simplified": "别无他物",
    "traditional": "別無他物"
  },
  {
    "frequency": 211,
    "simplified": "杀身之祸",
    "traditional": "殺身之禍"
  },
  {
    "frequency": 211,
    "simplified": "苟且偷生",
    "traditional": "苟且偷生"
  },
  {
    "frequency": 211,
    "simplified": "寥若晨星",
    "traditional": "寥若晨星"
  },
  {
    "frequency": 210,
    "simplified": "无往不利",
    "traditional": "無往不利"
  },
  {
    "frequency": 210,
    "simplified": "庸庸碌碌",
    "traditional": "庸庸碌碌"
  },
  {
    "frequency": 210,
    "simplified": "心猿意马",
    "traditional": "心猿意馬"
  },
  {
    "frequency": 210,
    "simplified": "大呼小叫",
    "traditional": "大呼小叫"
  },
  {
    "frequency": 210,
    "simplified": "人同此心",
    "traditional": "人同此心"
  },
  {
    "frequency": 210,
    "simplified": "河东狮吼",
    "traditional": "河東獅吼"
  },
  {
    "frequency": 210,
    "simplified": "大模大样",
    "traditional": "大模大樣"
  },
  {
    "frequency": 210,
    "simplified": "专横跋扈",
    "traditional": "專橫跋扈"
  },
  {
    "frequency": 210,
    "simplified": "淡泊明志",
    "traditional": "淡泊明志"
  },
  {
    "frequency": 210,
    "simplified": "人各有志",
    "traditional": "人各有志"
  },
  {
    "frequency": 210,
    "simplified": "动荡不定",
    "traditional": "動盪不定"
  },
  {
    "frequency": 210,
    "simplified": "气贯长虹",
    "traditional": "氣貫長虹"
  },
  {
    "frequency": 210,
    "simplified": "以人为镜",
    "traditional": "以人為鏡"
  },
  {
    "frequency": 209,
    "simplified": "众星拱月",
    "traditional": "眾星拱月"
  },
  {
    "frequency": 209,
    "simplified": "嫁祸于人",
    "traditional": "嫁禍於人"
  },
  {
    "frequency": 209,
    "simplified": "对牛弹琴",
    "traditional": "對牛彈琴"
  },
  {
    "frequency": 209,
    "simplified": "择其善者而从之",
    "traditional": "擇其善者而從之"
  },
  {
    "frequency": 209,
    "simplified": "寻死觅活",
    "traditional": "尋死覓活"
  },
  {
    "frequency": 209,
    "simplified": "难分难解",
    "traditional": "難分難解"
  },
  {
    "frequency": 209,
    "simplified": "地老天荒",
    "traditional": "地老天荒"
  },
  {
    "frequency": 209,
    "simplified": "飞针走线",
    "traditional": "飛針走線"
  },
  {
    "frequency": 209,
    "simplified": "好勇斗狠",
    "traditional": "好勇鬥狠"
  },
  {
    "frequency": 208,
    "simplified": "头痛脑热",
    "traditional": "頭痛腦熱"
  },
  {
    "frequency": 208,
    "simplified": "黄粱一梦",
    "traditional": "黃粱一夢"
  },
  {
    "frequency": 208,
    "simplified": "国破家亡",
    "traditional": "國破家亡"
  },
  {
    "frequency": 208,
    "simplified": "横眉冷对",
    "traditional": "橫眉冷對"
  },
  {
    "frequency": 208,
    "simplified": "一时一刻",
    "traditional": "一時一刻"
  },
  {
    "frequency": 208,
    "simplified": "积土成山",
    "traditional": "積土成山"
  },
  {
    "frequency": 208,
    "simplified": "泰山压顶",
    "traditional": "泰山壓頂"
  },
  {
    "frequency": 208,
    "simplified": "塞翁失马",
    "traditional": "塞翁失馬"
  },
  {
    "frequency": 207,
    "simplified": "惊恐万状",
    "traditional": "驚恐萬狀"
  },
  {
    "frequency": 207,
    "simplified": "勤能补拙",
    "traditional": "勤能補拙"
  },
  {
    "frequency": 207,
    "simplified": "玉石俱焚",
    "traditional": "玉石俱焚"
  },
  {
    "frequency": 207,
    "simplified": "临阵退缩",
    "traditional": "臨陣退縮"
  },
  {
    "frequency": 207,
    "simplified": "有胆有识",
    "traditional": "有膽有識"
  },
  {
    "frequency": 207,
    "simplified": "晓以利害",
    "traditional": "曉以利害"
  },
  {
    "frequency": 207,
    "simplified": "宾客盈门",
    "traditional": "賓客盈門"
  },
  {
    "frequency": 207,
    "simplified": "断绝往来",
    "traditional": "斷絕往來"
  },
  {
    "frequency": 207,
    "simplified": "党同伐异",
    "traditional": "黨同伐異"
  },
  {
    "frequency": 207,
    "simplified": "吃穿用度",
    "traditional": "吃穿用度"
  },
  {
    "frequency": 207,
    "simplified": "分进合击",
    "traditional": "分進合擊"
  },
  {
    "frequency": 206,
    "simplified": "高山峻岭",
    "traditional": "高山峻嶺"
  },
  {
    "frequency": 206,
    "simplified": "味同嚼蜡",
    "traditional": "味同嚼蠟"
  },
  {
    "frequency": 206,
    "simplified": "五洲四海",
    "traditional": "五洲四海"
  },
  {
    "frequency": 206,
    "simplified": "内查外调",
    "traditional": "內查外調"
  },
  {
    "frequency": 205,
    "simplified": "天下无双",
    "traditional": "天下無雙"
  },
  {
    "frequency": 205,
    "simplified": "人而无信",
    "traditional": "人而無信"
  },
  {
    "frequency": 205,
    "simplified": "老气横秋",
    "traditional": "老氣橫秋"
  },
  {
    "frequency": 205,
    "simplified": "文弱书生",
    "traditional": "文弱書生"
  },
  {
    "frequency": 205,
    "simplified": "女中豪杰",
    "traditional": "女中豪傑"
  },
  {
    "frequency": 205,
    "simplified": "不容分说",
    "traditional": "不容分說"
  },
  {
    "frequency": 205,
    "simplified": "变幻无常",
    "traditional": "變幻無常"
  },
  {
    "frequency": 205,
    "simplified": "炮火连天",
    "traditional": "炮火連天"
  },
  {
    "frequency": 205,
    "simplified": "人无远虑",
    "traditional": "人無遠慮"
  },
  {
    "frequency": 204,
    "simplified": "遇人不淑",
    "traditional": "遇人不淑"
  },
  {
    "frequency": 204,
    "simplified": "破铜烂铁",
    "traditional": "破銅爛鐵"
  },
  {
    "frequency": 204,
    "simplified": "代人受过",
    "traditional": "代人受過"
  },
  {
    "frequency": 204,
    "simplified": "宝刀不老",
    "traditional": "寶刀不老"
  },
  {
    "frequency": 204,
    "simplified": "此一时彼一时",
    "traditional": "此一時彼一時"
  },
  {
    "frequency": 204,
    "simplified": "瓮中之鳖",
    "traditional": "甕中之鱉"
  },
  {
    "frequency": 203,
    "simplified": "春蚕到死丝方尽",
    "traditional": "春蠶到死絲方盡"
  },
  {
    "frequency": 203,
    "simplified": "蓬蓬勃勃",
    "traditional": "蓬蓬勃勃"
  },
  {
    "frequency": 203,
    "simplified": "平铺直叙",
    "traditional": "平鋪直敘"
  },
  {
    "frequency": 203,
    "simplified": "鹦鹉学舌",
    "traditional": "鸚鵡學舌"
  },
  {
    "frequency": 203,
    "simplified": "生死之交",
    "traditional": "生死之交"
  },
  {
    "frequency": 203,
    "simplified": "水来土掩",
    "traditional": "水來土掩"
  },
  {
    "frequency": 203,
    "simplified": "评头品足",
    "traditional": "評頭品足"
  },
  {
    "frequency": 203,
    "simplified": "金玉良言",
    "traditional": "金玉良言"
  },
  {
    "frequency": 203,
    "simplified": "孔孟之道",
    "traditional": "孔孟之道"
  },
  {
    "frequency": 202,
    "simplified": "刻苦耐劳",
    "traditional": "刻苦耐勞"
  },
  {
    "frequency": 202,
    "simplified": "留得青山在",
    "traditional": "留得青山在"
  },
  {
    "frequency": 202,
    "simplified": "寿比南山",
    "traditional": "壽比南山"
  },
  {
    "frequency": 202,
    "simplified": "君子协定",
    "traditional": "君子協定"
  },
  {
    "frequency": 202,
    "simplified": "青云直上",
    "traditional": "青雲直上"
  },
  {
    "frequency": 201,
    "simplified": "白日做梦",
    "traditional": "白日做夢"
  },
  {
    "frequency": 201,
    "simplified": "口服心服",
    "traditional": "口服心服"
  },
  {
    "frequency": 201,
    "simplified": "闻风而至",
    "traditional": "聞風而至"
  },
  {
    "frequency": 201,
    "simplified": "梁上君子",
    "traditional": "梁上君子"
  },
  {
    "frequency": 201,
    "simplified": "上下同欲",
    "traditional": "上下同欲"
  },
  {
    "frequency": 201,
    "simplified": "不打自招",
    "traditional": "不打自招"
  },
  {
    "frequency": 200,
    "simplified": "朝野上下",
    "traditional": "朝野上下"
  },
  {
    "frequency": 200,
    "simplified": "山高皇帝远",
    "traditional": "山高皇帝遠"
  },
  {
    "frequency": 200,
    "simplified": "天造地设",
    "traditional": "天造地設"
  },
  {
    "frequency": 200,
    "simplified": "文武兼备",
    "traditional": "文武兼備"
  },
  {
    "frequency": 200,
    "simplified": "报仇雪恨",
    "traditional": "報仇雪恨"
  },
  {
    "frequency": 200,
    "simplified": "事业有成",
    "traditional": "事業有成"
  },
  {
    "frequency": 200,
    "simplified": "残羹剩饭",
    "traditional": "殘羹剩飯"
  },
  {
    "frequency": 199,
    "simplified": "见物不见人",
    "traditional": "見物不見人"
  },
  {
    "frequency": 199,
    "simplified": "福禄寿喜",
    "traditional": "福祿壽喜"
  },
  {
    "frequency": 199,
    "simplified": "锐不可当",
    "traditional": "銳不可當"
  },
  {
    "frequency": 199,
    "simplified": "悲喜交集",
    "traditional": "悲喜交集"
  },
  {
    "frequency": 199,
    "simplified": "一脉相传",
    "traditional": "一脈相傳"
  },
  {
    "frequency": 198,
    "simplified": "名闻天下",
    "traditional": "名聞天下"
  },
  {
    "frequency": 198,
    "simplified": "好事不出门",
    "traditional": "好事不出門"
  },
  {
    "frequency": 198,
    "simplified": "人不犯我",
    "traditional": "人不犯我"
  },
  {
    "frequency": 198,
    "simplified": "旧地重游",
    "traditional": "舊地重遊"
  },
  {
    "frequency": 198,
    "simplified": "如芒在背",
    "traditional": "如芒在背"
  },
  {
    "frequency": 198,
    "simplified": "极乐世界",
    "traditional": "極樂世界"
  },
  {
    "frequency": 198,
    "simplified": "当局者迷",
    "traditional": "當局者迷"
  },
  {
    "frequency": 198,
    "simplified": "命在旦夕",
    "traditional": "命在旦夕"
  },
  {
    "frequency": 198,
    "simplified": "手无缚鸡之力",
    "traditional": "手無縛雞之力"
  },
  {
    "frequency": 197,
    "simplified": "亲仁善邻",
    "traditional": "親仁善鄰"
  },
  {
    "frequency": 197,
    "simplified": "插翅难逃",
    "traditional": "插翅難逃"
  },
  {
    "frequency": 197,
    "simplified": "立锥之地",
    "traditional": "立錐之地"
  },
  {
    "frequency": 197,
    "simplified": "兵贵神速",
    "traditional": "兵貴神速"
  },
  {
    "frequency": 197,
    "simplified": "三阳开泰",
    "traditional": "三陽開泰"
  },
  {
    "frequency": 197,
    "simplified": "各人自扫门前雪",
    "traditional": "各人自掃門前雪"
  },
  {
    "frequency": 197,
    "simplified": "笨鸟先飞",
    "traditional": "笨鳥先飛"
  },
  {
    "frequency": 197,
    "simplified": "棋逢对手",
    "traditional": "棋逢對手"
  },
  {
    "frequency": 196,
    "simplified": "有凭有据",
    "traditional": "有憑有據"
  },
  {
    "frequency": 196,
    "simplified": "要死要活",
    "traditional": "要死要活"
  },
  {
    "frequency": 196,
    "simplified": "傲慢无礼",
    "traditional": "傲慢無禮"
  },
  {
    "frequency": 196,
    "simplified": "逆耳之言",
    "traditional": "逆耳之言"
  },
  {
    "frequency": 196,
    "simplified": "病来如山倒",
    "traditional": "病來如山倒"
  },
  {
    "frequency": 196,
    "simplified": "壁立千仞",
    "traditional": "壁立千仞"
  },
  {
    "frequency": 196,
    "simplified": "郎才女貌",
    "traditional": "郎才女貌"
  },
  {
    "frequency": 196,
    "simplified": "风韵犹存",
    "traditional": "風韻猶存"
  },
  {
    "frequency": 196,
    "simplified": "单刀赴会",
    "traditional": "單刀赴會"
  },
  {
    "frequency": 195,
    "simplified": "英雄豪杰",
    "traditional": "英雄豪傑"
  },
  {
    "frequency": 195,
    "simplified": "出人意表",
    "traditional": "出人意表"
  },
  {
    "frequency": 195,
    "simplified": "诛心之论",
    "traditional": "誅心之論"
  },
  {
    "frequency": 195,
    "simplified": "成由勤俭败由奢",
    "traditional": "成由勤儉敗由奢"
  },
  {
    "frequency": 195,
    "simplified": "流年不利",
    "traditional": "流年不利"
  },
  {
    "frequency": 195,
    "simplified": "三省吾身",
    "traditional": "三省吾身"
  },
  {
    "frequency": 195,
    "simplified": "天无绝人之路",
    "traditional": "天無絕人之路"
  },
  {
    "frequency": 194,
    "simplified": "色胆包天",
    "traditional": "色膽包天"
  },
  {
    "frequency": 194,
    "simplified": "精神百倍",
    "traditional": "精神百倍"
  },
  {
    "frequency": 194,
    "simplified": "外柔内刚",
    "traditional": "外柔內剛"
  },
  {
    "frequency": 194,
    "simplified": "比上不足",
    "traditional": "比上不足"
  },
  {
    "frequency": 194,
    "simplified": "眼不见为净",
    "traditional": "眼不見為淨"
  },
  {
    "frequency": 194,
    "simplified": "谈古论今",
    "traditional": "談古論今"
  },
  {
    "frequency": 194,
    "simplified": "近朱者赤",
    "traditional": "近朱者赤"
  },
  {
    "frequency": 194,
    "simplified": "一命呜呼",
    "traditional": "一命嗚呼"
  },
  {
    "frequency": 194,
    "simplified": "逐鹿中原",
    "traditional": "逐鹿中原"
  },
  {
    "frequency": 194,
    "simplified": "至亲好友",
    "traditional": "至親好友"
  },
  {
    "frequency": 193,
    "simplified": "排斥异己",
    "traditional": "排斥異己"
  },
  {
    "frequency": 193,
    "simplified": "暴露目标",
    "traditional": "暴露目標"
  },
  {
    "frequency": 192,
    "simplified": "分文未取",
    "traditional": "分文未取"
  },
  {
    "frequency": 192,
    "simplified": "一日夫妻百日恩",
    "traditional": "一日夫妻百日恩"
  },
  {
    "frequency": 192,
    "simplified": "杀人不眨眼",
    "traditional": "殺人不眨眼"
  },
  {
    "frequency": 192,
    "simplified": "定国安邦",
    "traditional": "定國安邦"
  },
  {
    "frequency": 192,
    "simplified": "一块石头落了地",
    "traditional": "一塊石頭落了地"
  },
  {
    "frequency": 192,
    "simplified": "林林总总",
    "traditional": "林林總總"
  },
  {
    "frequency": 192,
    "simplified": "江山如画",
    "traditional": "江山如畫"
  },
  {
    "frequency": 192,
    "simplified": "甘苦与共",
    "traditional": "甘苦與共"
  },
  {
    "frequency": 192,
    "simplified": "久病成医",
    "traditional": "久病成醫"
  },
  {
    "frequency": 192,
    "simplified": "败絮其中",
    "traditional": "敗絮其中"
  },
  {
    "frequency": 191,
    "simplified": "承先启后",
    "traditional": "承先啟後"
  },
  {
    "frequency": 191,
    "simplified": "盗亦有道",
    "traditional": "盜亦有道"
  },
  {
    "frequency": 191,
    "simplified": "变动不居",
    "traditional": "變動不居"
  },
  {
    "frequency": 191,
    "simplified": "同声相应",
    "traditional": "同聲相應"
  },
  {
    "frequency": 191,
    "simplified": "凄风苦雨",
    "traditional": "悽風苦雨"
  },
  {
    "frequency": 191,
    "simplified": "好人难做",
    "traditional": "好人難做"
  },
  {
    "frequency": 191,
    "simplified": "人有旦夕祸福",
    "traditional": "人有旦夕禍福"
  },
  {
    "frequency": 191,
    "simplified": "遗世独立",
    "traditional": "遺世獨立"
  },
  {
    "frequency": 191,
    "simplified": "惊天地泣鬼神",
    "traditional": "驚天地泣鬼神"
  },
  {
    "frequency": 191,
    "simplified": "出水芙蓉",
    "traditional": "出水芙蓉"
  },
  {
    "frequency": 190,
    "simplified": "将功补过",
    "traditional": "將功補過"
  },
  {
    "frequency": 190,
    "simplified": "言之成理",
    "traditional": "言之成理"
  },
  {
    "frequency": 190,
    "simplified": "七老八十",
    "traditional": "七老八十"
  },
  {
    "frequency": 190,
    "simplified": "笔走龙蛇",
    "traditional": "筆走龍蛇"
  },
  {
    "frequency": 190,
    "simplified": "从恶如崩",
    "traditional": "從惡如崩"
  },
  {
    "frequency": 190,
    "simplified": "挂免战牌",
    "traditional": "掛免戰牌"
  },
  {
    "frequency": 189,
    "simplified": "种豆得豆",
    "traditional": "種豆得豆"
  },
  {
    "frequency": 189,
    "simplified": "长篇累牍",
    "traditional": "長篇累牘"
  },
  {
    "frequency": 189,
    "simplified": "苦乐不均",
    "traditional": "苦樂不均"
  },
  {
    "frequency": 189,
    "simplified": "满天星斗",
    "traditional": "滿天星斗"
  },
  {
    "frequency": 189,
    "simplified": "心中无数",
    "traditional": "心中無數"
  },
  {
    "frequency": 189,
    "simplified": "心怀叵测",
    "traditional": "心懷叵測"
  },
  {
    "frequency": 189,
    "simplified": "万夫莫开",
    "traditional": "萬夫莫開"
  },
  {
    "frequency": 189,
    "simplified": "怒气冲天",
    "traditional": "怒氣沖天"
  },
  {
    "frequency": 189,
    "simplified": "手到病除",
    "traditional": "手到病除"
  },
  {
    "frequency": 188,
    "simplified": "鹰击长空",
    "traditional": "鷹擊長空"
  },
  {
    "frequency": 188,
    "simplified": "长江七号",
    "traditional": "長江七號"
  },
  {
    "frequency": 188,
    "simplified": "民为邦本",
    "traditional": "民為邦本"
  },
  {
    "frequency": 188,
    "simplified": "同声同气",
    "traditional": "同聲同氣"
  },
  {
    "frequency": 188,
    "simplified": "红袖添香",
    "traditional": "紅袖添香"
  },
  {
    "frequency": 188,
    "simplified": "人财两失",
    "traditional": "人財兩失"
  },
  {
    "frequency": 188,
    "simplified": "不可企及",
    "traditional": "不可企及"
  },
  {
    "frequency": 187,
    "simplified": "一面之交",
    "traditional": "一面之交"
  },
  {
    "frequency": 187,
    "simplified": "零打碎敲",
    "traditional": "零打碎敲"
  },
  {
    "frequency": 187,
    "simplified": "无立锥之地",
    "traditional": "無立錐之地"
  },
  {
    "frequency": 187,
    "simplified": "坐失良机",
    "traditional": "坐失良機"
  },
  {
    "frequency": 187,
    "simplified": "饶有兴味",
    "traditional": "饒有興味"
  },
  {
    "frequency": 187,
    "simplified": "从谏如流",
    "traditional": "從諫如流"
  },
  {
    "frequency": 187,
    "simplified": "铸剑为犁",
    "traditional": "鑄劍為犁"
  },
  {
    "frequency": 186,
    "simplified": "死皮赖脸",
    "traditional": "死皮賴臉"
  },
  {
    "frequency": 186,
    "simplified": "胼手胝足",
    "traditional": "胼手胝足"
  },
  {
    "frequency": 186,
    "simplified": "暗送秋波",
    "traditional": "暗送秋波"
  },
  {
    "frequency": 186,
    "simplified": "古圣先贤",
    "traditional": "古聖先賢"
  },
  {
    "frequency": 186,
    "simplified": "天理不容",
    "traditional": "天理不容"
  },
  {
    "frequency": 185,
    "simplified": "学而时习之",
    "traditional": "學而時習之"
  },
  {
    "frequency": 185,
    "simplified": "舐犊情深",
    "traditional": "舐犢情深"
  },
  {
    "frequency": 185,
    "simplified": "飞龙在天",
    "traditional": "飛龍在天"
  },
  {
    "frequency": 185,
    "simplified": "恩重如山",
    "traditional": "恩重如山"
  },
  {
    "frequency": 185,
    "simplified": "无牵无挂",
    "traditional": "無牽無掛"
  },
  {
    "frequency": 185,
    "simplified": "雄赳赳气昂昂",
    "traditional": "雄赳赳氣昂昂"
  },
  {
    "frequency": 185,
    "simplified": "感慨万端",
    "traditional": "感慨萬端"
  },
  {
    "frequency": 185,
    "simplified": "诚心实意",
    "traditional": "誠心實意"
  },
  {
    "frequency": 185,
    "simplified": "坚贞不渝",
    "traditional": "堅貞不渝"
  },
  {
    "frequency": 184,
    "simplified": "先人后己",
    "traditional": "先人後己"
  },
  {
    "frequency": 184,
    "simplified": "金玉其外",
    "traditional": "金玉其外"
  },
  {
    "frequency": 184,
    "simplified": "在所不辞",
    "traditional": "在所不辭"
  },
  {
    "frequency": 184,
    "simplified": "惟利是图",
    "traditional": "惟利是圖"
  },
  {
    "frequency": 184,
    "simplified": "正经八百",
    "traditional": "正經八百"
  },
  {
    "frequency": 184,
    "simplified": "良药苦口",
    "traditional": "良藥苦口"
  },
  {
    "frequency": 184,
    "simplified": "死马当活马医",
    "traditional": "死馬當活馬醫"
  },
  {
    "frequency": 184,
    "simplified": "修齐治平",
    "traditional": "修齊治平"
  },
  {
    "frequency": 184,
    "simplified": "怒目而视",
    "traditional": "怒目而視"
  },
  {
    "frequency": 184,
    "simplified": "大有所为",
    "traditional": "大有所為"
  },
  {
    "frequency": 184,
    "simplified": "图财害命",
    "traditional": "圖財害命"
  },
  {
    "frequency": 184,
    "simplified": "女大当嫁",
    "traditional": "女大當嫁"
  },
  {
    "frequency": 184,
    "simplified": "池鱼之殃",
    "traditional": "池魚之殃"
  },
  {
    "frequency": 183,
    "simplified": "壮心不已",
    "traditional": "壯心不已"
  },
  {
    "frequency": 183,
    "simplified": "轻歌曼舞",
    "traditional": "輕歌曼舞"
  },
  {
    "frequency": 183,
    "simplified": "没头没脑",
    "traditional": "沒頭沒腦"
  },
  {
    "frequency": 183,
    "simplified": "不知深浅",
    "traditional": "不知深淺"
  },
  {
    "frequency": 183,
    "simplified": "全心全力",
    "traditional": "全心全力"
  },
  {
    "frequency": 183,
    "simplified": "难如登天",
    "traditional": "難如登天"
  },
  {
    "frequency": 183,
    "simplified": "赌咒发誓",
    "traditional": "賭咒發誓"
  },
  {
    "frequency": 182,
    "simplified": "一介书生",
    "traditional": "一介書生"
  },
  {
    "frequency": 182,
    "simplified": "男大当婚",
    "traditional": "男大當婚"
  },
  {
    "frequency": 182,
    "simplified": "重峦叠嶂",
    "traditional": "重巒疊嶂"
  },
  {
    "frequency": 182,
    "simplified": "杀人越货",
    "traditional": "殺人越貨"
  },
  {
    "frequency": 182,
    "simplified": "草船借箭",
    "traditional": "草船借箭"
  },
  {
    "frequency": 182,
    "simplified": "坐山观虎斗",
    "traditional": "坐山觀虎鬥"
  },
  {
    "frequency": 182,
    "simplified": "罪责难逃",
    "traditional": "罪責難逃"
  },
  {
    "frequency": 182,
    "simplified": "奋勇当先",
    "traditional": "奮勇當先"
  },
  {
    "frequency": 182,
    "simplified": "博古通今",
    "traditional": "博古通今"
  },
  {
    "frequency": 182,
    "simplified": "从善如登",
    "traditional": "從善如登"
  },
  {
    "frequency": 182,
    "simplified": "瘦死的骆驼比马大",
    "traditional": "瘦死的駱駝比馬大"
  },
  {
    "frequency": 181,
    "simplified": "心怀忐忑",
    "traditional": "心懷忐忑"
  },
  {
    "frequency": 181,
    "simplified": "看破红尘",
    "traditional": "看破紅塵"
  },
  {
    "frequency": 181,
    "simplified": "梨花带雨",
    "traditional": "梨花帶雨"
  },
  {
    "frequency": 181,
    "simplified": "千里之行始于足下",
    "traditional": "千里之行始於足下"
  },
  {
    "frequency": 181,
    "simplified": "男欢女爱",
    "traditional": "男歡女愛"
  },
  {
    "frequency": 181,
    "simplified": "闯荡江湖",
    "traditional": "闖蕩江湖"
  },
  {
    "frequency": 181,
    "simplified": "以攻为守",
    "traditional": "以攻為守"
  },
  {
    "frequency": 181,
    "simplified": "丢卒保车",
    "traditional": "丟卒保車"
  },
  {
    "frequency": 181,
    "simplified": "爬山涉水",
    "traditional": "爬山涉水"
  },
  {
    "frequency": 181,
    "simplified": "一文不名",
    "traditional": "一文不名"
  },
  {
    "frequency": 180,
    "simplified": "苛捐杂税",
    "traditional": "苛捐雜稅"
  },
  {
    "frequency": 180,
    "simplified": "心乱如麻",
    "traditional": "心亂如麻"
  },
  {
    "frequency": 180,
    "simplified": "喷薄欲出",
    "traditional": "噴薄欲出"
  },
  {
    "frequency": 180,
    "simplified": "半丝半缕",
    "traditional": "半絲半縷"
  },
  {
    "frequency": 180,
    "simplified": "变幻无穷",
    "traditional": "變幻無窮"
  },
  {
    "frequency": 180,
    "simplified": "积沙成塔",
    "traditional": "積沙成塔"
  },
  {
    "frequency": 179,
    "simplified": "目不斜视",
    "traditional": "目不斜視"
  },
  {
    "frequency": 179,
    "simplified": "心细如发",
    "traditional": "心細如髮"
  },
  {
    "frequency": 179,
    "simplified": "乌七八糟",
    "traditional": "烏七八糟"
  },
  {
    "frequency": 178,
    "simplified": "黄雀在后",
    "traditional": "黃雀在後"
  },
  {
    "frequency": 178,
    "simplified": "春和景明",
    "traditional": "春和景明"
  },
  {
    "frequency": 178,
    "simplified": "攻无不克",
    "traditional": "攻無不克"
  },
  {
    "frequency": 178,
    "simplified": "金无足赤",
    "traditional": "金無足赤"
  },
  {
    "frequency": 178,
    "simplified": "戒急用忍",
    "traditional": "戒急用忍"
  },
  {
    "frequency": 178,
    "simplified": "钟灵毓秀",
    "traditional": "鍾靈毓秀"
  },
  {
    "frequency": 177,
    "simplified": "半斤八两",
    "traditional": "半斤八兩"
  },
  {
    "frequency": 177,
    "simplified": "生生死死",
    "traditional": "生生死死"
  },
  {
    "frequency": 177,
    "simplified": "土豪劣绅",
    "traditional": "土豪劣紳"
  },
  {
    "frequency": 177,
    "simplified": "跳梁小丑",
    "traditional": "跳梁小丑"
  },
  {
    "frequency": 177,
    "simplified": "人生自古谁无死",
    "traditional": "人生自古誰無死"
  },
  {
    "frequency": 177,
    "simplified": "略见一斑",
    "traditional": "略見一斑"
  },
  {
    "frequency": 177,
    "simplified": "相貌堂堂",
    "traditional": "相貌堂堂"
  },
  {
    "frequency": 176,
    "simplified": "蔚成风气",
    "traditional": "蔚成風氣"
  },
  {
    "frequency": 176,
    "simplified": "有则改之无则加勉",
    "traditional": "有則改之無則加勉"
  },
  {
    "frequency": 176,
    "simplified": "成也萧何",
    "traditional": "成也蕭何"
  },
  {
    "frequency": 176,
    "simplified": "远交近攻",
    "traditional": "遠交近攻"
  },
  {
    "frequency": 176,
    "simplified": "一团漆黑",
    "traditional": "一團漆黑"
  },
  {
    "frequency": 176,
    "simplified": "怡然自乐",
    "traditional": "怡然自樂"
  },
  {
    "frequency": 175,
    "simplified": "毛手毛脚",
    "traditional": "毛手毛腳"
  },
  {
    "frequency": 175,
    "simplified": "惹火烧身",
    "traditional": "惹火燒身"
  },
  {
    "frequency": 175,
    "simplified": "风急浪高",
    "traditional": "風急浪高"
  },
  {
    "frequency": 175,
    "simplified": "孤军深入",
    "traditional": "孤軍深入"
  },
  {
    "frequency": 175,
    "simplified": "天外有天",
    "traditional": "天外有天"
  },
  {
    "frequency": 175,
    "simplified": "回眸一笑",
    "traditional": "回眸一笑"
  },
  {
    "frequency": 175,
    "simplified": "莺飞草长",
    "traditional": "鶯飛草長"
  },
  {
    "frequency": 174,
    "simplified": "好为人师",
    "traditional": "好為人師"
  },
  {
    "frequency": 174,
    "simplified": "暧昧不明",
    "traditional": "曖昧不明"
  },
  {
    "frequency": 174,
    "simplified": "眉头一皱",
    "traditional": "眉頭一皺"
  },
  {
    "frequency": 174,
    "simplified": "小肚鸡肠",
    "traditional": "小肚雞腸"
  },
  {
    "frequency": 174,
    "simplified": "不耻下问",
    "traditional": "不恥下問"
  },
  {
    "frequency": 174,
    "simplified": "神经错乱",
    "traditional": "神經錯亂"
  },
  {
    "frequency": 174,
    "simplified": "事过境迁",
    "traditional": "事過境遷"
  },
  {
    "frequency": 173,
    "simplified": "身单力薄",
    "traditional": "身單力薄"
  },
  {
    "frequency": 173,
    "simplified": "残羹冷炙",
    "traditional": "殘羹冷炙"
  },
  {
    "frequency": 173,
    "simplified": "日落西山",
    "traditional": "日落西山"
  },
  {
    "frequency": 173,
    "simplified": "对症用药",
    "traditional": "對症用藥"
  },
  {
    "frequency": 173,
    "simplified": "家书抵万金",
    "traditional": "家書抵萬金"
  },
  {
    "frequency": 173,
    "simplified": "普度众生",
    "traditional": "普度眾生"
  },
  {
    "frequency": 173,
    "simplified": "慷慨就义",
    "traditional": "慷慨就義"
  },
  {
    "frequency": 173,
    "simplified": "五子登科",
    "traditional": "五子登科"
  },
  {
    "frequency": 173,
    "simplified": "洗耳恭听",
    "traditional": "洗耳恭聽"
  },
  {
    "frequency": 172,
    "simplified": "面目一新",
    "traditional": "面目一新"
  },
  {
    "frequency": 172,
    "simplified": "文如其人",
    "traditional": "文如其人"
  },
  {
    "frequency": 172,
    "simplified": "大水冲了龙王庙",
    "traditional": "大水衝了龍王廟"
  },
  {
    "frequency": 172,
    "simplified": "顾影自怜",
    "traditional": "顧影自憐"
  },
  {
    "frequency": 172,
    "simplified": "另眼相待",
    "traditional": "另眼相待"
  },
  {
    "frequency": 172,
    "simplified": "对酒当歌",
    "traditional": "對酒當歌"
  },
  {
    "frequency": 172,
    "simplified": "积善成德",
    "traditional": "積善成德"
  },
  {
    "frequency": 172,
    "simplified": "举世皆知",
    "traditional": "舉世皆知"
  },
  {
    "frequency": 172,
    "simplified": "节哀顺变",
    "traditional": "節哀順變"
  },
  {
    "frequency": 172,
    "simplified": "义薄云天",
    "traditional": "義薄雲天"
  },
  {
    "frequency": 172,
    "simplified": "三皇五帝",
    "traditional": "三皇五帝"
  },
  {
    "frequency": 171,
    "simplified": "闲云野鹤",
    "traditional": "閒雲野鶴"
  },
  {
    "frequency": 171,
    "simplified": "汪洋大海",
    "traditional": "汪洋大海"
  },
  {
    "frequency": 171,
    "simplified": "洗手不干",
    "traditional": "洗手不幹"
  },
  {
    "frequency": 171,
    "simplified": "狗皮膏药",
    "traditional": "狗皮膏藥"
  },
  {
    "frequency": 171,
    "simplified": "方便之门",
    "traditional": "方便之門"
  },
  {
    "frequency": 171,
    "simplified": "驴唇不对马嘴",
    "traditional": "驢唇不對馬嘴"
  },
  {
    "frequency": 171,
    "simplified": "怪力乱神",
    "traditional": "怪力亂神"
  },
  {
    "frequency": 171,
    "simplified": "蹉跎岁月",
    "traditional": "蹉跎歲月"
  },
  {
    "frequency": 171,
    "simplified": "大红大绿",
    "traditional": "大紅大綠"
  },
  {
    "frequency": 171,
    "simplified": "各取所长",
    "traditional": "各取所長"
  },
  {
    "frequency": 171,
    "simplified": "打小算盘",
    "traditional": "打小算盤"
  },
  {
    "frequency": 170,
    "simplified": "拒人于千里之外",
    "traditional": "拒人於千里之外"
  },
  {
    "frequency": 170,
    "simplified": "临别赠言",
    "traditional": "臨別贈言"
  },
  {
    "frequency": 170,
    "simplified": "锦绣山河",
    "traditional": "錦繡山河"
  },
  {
    "frequency": 170,
    "simplified": "何患无辞",
    "traditional": "何患無辭"
  },
  {
    "frequency": 170,
    "simplified": "柔情蜜意",
    "traditional": "柔情蜜意"
  },
  {
    "frequency": 170,
    "simplified": "风流人物",
    "traditional": "風流人物"
  },
  {
    "frequency": 170,
    "simplified": "失之毫厘",
    "traditional": "失之毫釐"
  },
  {
    "frequency": 170,
    "simplified": "何罪之有",
    "traditional": "何罪之有"
  },
  {
    "frequency": 169,
    "simplified": "徒有其名",
    "traditional": "徒有其名"
  },
  {
    "frequency": 169,
    "simplified": "原封未动",
    "traditional": "原封未動"
  },
  {
    "frequency": 169,
    "simplified": "前事不忘后事之师",
    "traditional": "前事不忘後事之師"
  },
  {
    "frequency": 169,
    "simplified": "刀枪入库",
    "traditional": "刀槍入庫"
  },
  {
    "frequency": 169,
    "simplified": "天府之国",
    "traditional": "天府之國"
  },
  {
    "frequency": 169,
    "simplified": "阴阳怪气",
    "traditional": "陰陽怪氣"
  },
  {
    "frequency": 169,
    "simplified": "膀大腰圆",
    "traditional": "膀大腰圓"
  },
  {
    "frequency": 169,
    "simplified": "家学渊源",
    "traditional": "家學淵源"
  },
  {
    "frequency": 169,
    "simplified": "得饶人处且饶人",
    "traditional": "得饒人處且饒人"
  },
  {
    "frequency": 169,
    "simplified": "前呼后拥",
    "traditional": "前呼後擁"
  },
  {
    "frequency": 169,
    "simplified": "孝悌忠信",
    "traditional": "孝悌忠信"
  },
  {
    "frequency": 169,
    "simplified": "任凭风浪起",
    "traditional": "任憑風浪起"
  },
  {
    "frequency": 169,
    "simplified": "终南捷径",
    "traditional": "終南捷徑"
  },
  {
    "frequency": 168,
    "simplified": "壁垒分明",
    "traditional": "壁壘分明"
  },
  {
    "frequency": 168,
    "simplified": "硕大无比",
    "traditional": "碩大無比"
  },
  {
    "frequency": 168,
    "simplified": "马革裹尸",
    "traditional": "馬革裹屍"
  },
  {
    "frequency": 168,
    "simplified": "望风而逃",
    "traditional": "望風而逃"
  },
  {
    "frequency": 168,
    "simplified": "可望不可即",
    "traditional": "可望不可即"
  },
  {
    "frequency": 168,
    "simplified": "近悦远来",
    "traditional": "近悅遠來"
  },
  {
    "frequency": 168,
    "simplified": "悄然无声",
    "traditional": "悄然無聲"
  },
  {
    "frequency": 168,
    "simplified": "封妻荫子",
    "traditional": "封妻廕子"
  },
  {
    "frequency": 168,
    "simplified": "李代桃僵",
    "traditional": "李代桃僵"
  },
  {
    "frequency": 168,
    "simplified": "纤尘不染",
    "traditional": "纖塵不染"
  },
  {
    "frequency": 168,
    "simplified": "温文儒雅",
    "traditional": "溫文儒雅"
  },
  {
    "frequency": 167,
    "simplified": "金玉满堂",
    "traditional": "金玉滿堂"
  },
  {
    "frequency": 167,
    "simplified": "以观后效",
    "traditional": "以觀後效"
  },
  {
    "frequency": 167,
    "simplified": "逸闻趣事",
    "traditional": "逸聞趣事"
  },
  {
    "frequency": 167,
    "simplified": "地久天长",
    "traditional": "地久天長"
  },
  {
    "frequency": 167,
    "simplified": "列祖列宗",
    "traditional": "列祖列宗"
  },
  {
    "frequency": 167,
    "simplified": "既来之则安之",
    "traditional": "既來之則安之"
  },
  {
    "frequency": 167,
    "simplified": "贫困潦倒",
    "traditional": "貧困潦倒"
  },
  {
    "frequency": 166,
    "simplified": "一家之言",
    "traditional": "一家之言"
  },
  {
    "frequency": 166,
    "simplified": "遮人耳目",
    "traditional": "遮人耳目"
  },
  {
    "frequency": 166,
    "simplified": "雕虫小技",
    "traditional": "雕蟲小技"
  },
  {
    "frequency": 166,
    "simplified": "三跪九叩",
    "traditional": "三跪九叩"
  },
  {
    "frequency": 166,
    "simplified": "百年大业",
    "traditional": "百年大業"
  },
  {
    "frequency": 166,
    "simplified": "神气活现",
    "traditional": "神氣活現"
  },
  {
    "frequency": 166,
    "simplified": "虾兵蟹将",
    "traditional": "蝦兵蟹將"
  },
  {
    "frequency": 166,
    "simplified": "大显神通",
    "traditional": "大顯神通"
  },
  {
    "frequency": 166,
    "simplified": "沃野千里",
    "traditional": "沃野千里"
  },
  {
    "frequency": 166,
    "simplified": "反躬自问",
    "traditional": "反躬自問"
  },
  {
    "frequency": 166,
    "simplified": "不顾大局",
    "traditional": "不顧大局"
  },
  {
    "frequency": 165,
    "simplified": "话中有话",
    "traditional": "話中有話"
  },
  {
    "frequency": 165,
    "simplified": "利害得失",
    "traditional": "利害得失"
  },
  {
    "frequency": 165,
    "simplified": "坚壁清野",
    "traditional": "堅壁清野"
  },
  {
    "frequency": 165,
    "simplified": "千叮万嘱",
    "traditional": "千叮萬囑"
  },
  {
    "frequency": 165,
    "simplified": "精卫填海",
    "traditional": "精衛填海"
  },
  {
    "frequency": 165,
    "simplified": "人言可畏",
    "traditional": "人言可畏"
  },
  {
    "frequency": 165,
    "simplified": "一片汪洋",
    "traditional": "一片汪洋"
  },
  {
    "frequency": 165,
    "simplified": "兔子不吃窝边草",
    "traditional": "兔子不吃窩邊草"
  },
  {
    "frequency": 165,
    "simplified": "一长一短",
    "traditional": "一長一短"
  },
  {
    "frequency": 165,
    "simplified": "家贼难防",
    "traditional": "家賊難防"
  },
  {
    "frequency": 165,
    "simplified": "耳鬓厮磨",
    "traditional": "耳鬢廝磨"
  },
  {
    "frequency": 164,
    "simplified": "实心实意",
    "traditional": "實心實意"
  },
  {
    "frequency": 164,
    "simplified": "危如累卵",
    "traditional": "危如累卵"
  },
  {
    "frequency": 164,
    "simplified": "正中下怀",
    "traditional": "正中下懷"
  },
  {
    "frequency": 164,
    "simplified": "始乱终弃",
    "traditional": "始亂終棄"
  },
  {
    "frequency": 164,
    "simplified": "鬼哭狼嚎",
    "traditional": "鬼哭狼嚎"
  },
  {
    "frequency": 164,
    "simplified": "清汤寡水",
    "traditional": "清湯寡水"
  },
  {
    "frequency": 164,
    "simplified": "巧言令色",
    "traditional": "巧言令色"
  },
  {
    "frequency": 164,
    "simplified": "负荆请罪",
    "traditional": "負荊請罪"
  },
  {
    "frequency": 164,
    "simplified": "靡靡之音",
    "traditional": "靡靡之音"
  },
  {
    "frequency": 164,
    "simplified": "风吹浪打",
    "traditional": "風吹浪打"
  },
  {
    "frequency": 164,
    "simplified": "围魏救赵",
    "traditional": "圍魏救趙"
  },
  {
    "frequency": 163,
    "simplified": "不求有功但求无过",
    "traditional": "不求有功但求無過"
  },
  {
    "frequency": 163,
    "simplified": "一代不如一代",
    "traditional": "一代不如一代"
  },
  {
    "frequency": 163,
    "simplified": "一目十行",
    "traditional": "一目十行"
  },
  {
    "frequency": 163,
    "simplified": "开国功臣",
    "traditional": "開國功臣"
  },
  {
    "frequency": 163,
    "simplified": "披肝沥胆",
    "traditional": "披肝瀝膽"
  },
  {
    "frequency": 163,
    "simplified": "震天动地",
    "traditional": "震天動地"
  },
  {
    "frequency": 163,
    "simplified": "公报私仇",
    "traditional": "公報私仇"
  },
  {
    "frequency": 163,
    "simplified": "墨迹未干",
    "traditional": "墨跡未乾"
  },
  {
    "frequency": 163,
    "simplified": "父慈子孝",
    "traditional": "父慈子孝"
  },
  {
    "frequency": 162,
    "simplified": "引而不发",
    "traditional": "引而不發"
  },
  {
    "frequency": 162,
    "simplified": "吹吹打打",
    "traditional": "吹吹打打"
  },
  {
    "frequency": 162,
    "simplified": "张三李四",
    "traditional": "張三李四"
  },
  {
    "frequency": 162,
    "simplified": "奉若神明",
    "traditional": "奉若神明"
  },
  {
    "frequency": 162,
    "simplified": "张口结舌",
    "traditional": "張口結舌"
  },
  {
    "frequency": 162,
    "simplified": "损兵折将",
    "traditional": "損兵折將"
  },
  {
    "frequency": 162,
    "simplified": "重起炉灶",
    "traditional": "重起爐灶"
  },
  {
    "frequency": 161,
    "simplified": "视为畏途",
    "traditional": "視為畏途"
  },
  {
    "frequency": 161,
    "simplified": "徒子徒孙",
    "traditional": "徒子徒孫"
  },
  {
    "frequency": 161,
    "simplified": "首鼠两端",
    "traditional": "首鼠兩端"
  },
  {
    "frequency": 161,
    "simplified": "守身如玉",
    "traditional": "守身如玉"
  },
  {
    "frequency": 161,
    "simplified": "断垣残壁",
    "traditional": "斷垣殘壁"
  },
  {
    "frequency": 161,
    "simplified": "国将不国",
    "traditional": "國將不國"
  },
  {
    "frequency": 161,
    "simplified": "一片丹心",
    "traditional": "一片丹心"
  },
  {
    "frequency": 161,
    "simplified": "岁月峥嵘",
    "traditional": "歲月崢嶸"
  },
  {
    "frequency": 161,
    "simplified": "能屈能伸",
    "traditional": "能屈能伸"
  },
  {
    "frequency": 161,
    "simplified": "万马齐喑",
    "traditional": "萬馬齊喑"
  },
  {
    "frequency": 161,
    "simplified": "精锐之师",
    "traditional": "精銳之師"
  },
  {
    "frequency": 161,
    "simplified": "枯木逢春",
    "traditional": "枯木逢春"
  },
  {
    "frequency": 161,
    "simplified": "成名成家",
    "traditional": "成名成家"
  },
  {
    "frequency": 161,
    "simplified": "日久天长",
    "traditional": "日久天長"
  },
  {
    "frequency": 161,
    "simplified": "立地成佛",
    "traditional": "立地成佛"
  },
  {
    "frequency": 160,
    "simplified": "安不忘危",
    "traditional": "安不忘危"
  },
  {
    "frequency": 160,
    "simplified": "天下归心",
    "traditional": "天下歸心"
  },
  {
    "frequency": 160,
    "simplified": "如箭在弦",
    "traditional": "如箭在弦"
  },
  {
    "frequency": 160,
    "simplified": "游移不定",
    "traditional": "游移不定"
  },
  {
    "frequency": 160,
    "simplified": "如狼似虎",
    "traditional": "如狼似虎"
  },
  {
    "frequency": 160,
    "simplified": "孤立无助",
    "traditional": "孤立無助"
  },
  {
    "frequency": 160,
    "simplified": "砥柱中流",
    "traditional": "砥柱中流"
  },
  {
    "frequency": 160,
    "simplified": "另眼看待",
    "traditional": "另眼看待"
  },
  {
    "frequency": 159,
    "simplified": "长话短说",
    "traditional": "長話短說"
  },
  {
    "frequency": 159,
    "simplified": "吆五喝六",
    "traditional": "吆五喝六"
  },
  {
    "frequency": 159,
    "simplified": "学非所用",
    "traditional": "學非所用"
  },
  {
    "frequency": 159,
    "simplified": "红男绿女",
    "traditional": "紅男綠女"
  },
  {
    "frequency": 159,
    "simplified": "同气相求",
    "traditional": "同氣相求"
  },
  {
    "frequency": 159,
    "simplified": "众口铄金",
    "traditional": "眾口鑠金"
  },
  {
    "frequency": 159,
    "simplified": "临机处置",
    "traditional": "臨機處置"
  },
  {
    "frequency": 159,
    "simplified": "天知地知",
    "traditional": "天知地知"
  },
  {
    "frequency": 159,
    "simplified": "王顾左右而言他",
    "traditional": "王顧左右而言他"
  },
  {
    "frequency": 159,
    "simplified": "苍翠欲滴",
    "traditional": "蒼翠欲滴"
  },
  {
    "frequency": 158,
    "simplified": "积习难改",
    "traditional": "積習難改"
  },
  {
    "frequency": 158,
    "simplified": "哀莫大于心死",
    "traditional": "哀莫大於心死"
  },
  {
    "frequency": 158,
    "simplified": "一柱擎天",
    "traditional": "一柱擎天"
  },
  {
    "frequency": 158,
    "simplified": "兄弟阋于墙",
    "traditional": "兄弟鬩於牆"
  },
  {
    "frequency": 158,
    "simplified": "言多必失",
    "traditional": "言多必失"
  },
  {
    "frequency": 158,
    "simplified": "湮没无闻",
    "traditional": "湮沒無聞"
  },
  {
    "frequency": 158,
    "simplified": "螳臂当车",
    "traditional": "螳臂當車"
  },
  {
    "frequency": 158,
    "simplified": "见猎心喜",
    "traditional": "見獵心喜"
  },
  {
    "frequency": 158,
    "simplified": "千刀万剐",
    "traditional": "千刀萬剮"
  },
  {
    "frequency": 158,
    "simplified": "福如东海",
    "traditional": "福如東海"
  },
  {
    "frequency": 158,
    "simplified": "不败之地",
    "traditional": "不敗之地"
  },
  {
    "frequency": 157,
    "simplified": "老成持重",
    "traditional": "老成持重"
  },
  {
    "frequency": 157,
    "simplified": "横挑鼻子竖挑眼",
    "traditional": "橫挑鼻子豎挑眼"
  },
  {
    "frequency": 157,
    "simplified": "横冲直闯",
    "traditional": "橫衝直闖"
  },
  {
    "frequency": 157,
    "simplified": "不知所以",
    "traditional": "不知所以"
  },
  {
    "frequency": 157,
    "simplified": "闻者足戒",
    "traditional": "聞者足戒"
  },
  {
    "frequency": 157,
    "simplified": "置之脑后",
    "traditional": "置之腦後"
  },
  {
    "frequency": 157,
    "simplified": "初试啼声",
    "traditional": "初試啼聲"
  },
  {
    "frequency": 157,
    "simplified": "出口伤人",
    "traditional": "出口傷人"
  },
  {
    "frequency": 157,
    "simplified": "一通百通",
    "traditional": "一通百通"
  },
  {
    "frequency": 157,
    "simplified": "绵绵不断",
    "traditional": "綿綿不斷"
  },
  {
    "frequency": 157,
    "simplified": "阿猫阿狗",
    "traditional": "阿貓阿狗"
  },
  {
    "frequency": 157,
    "simplified": "闻鸡起舞",
    "traditional": "聞雞起舞"
  },
  {
    "frequency": 157,
    "simplified": "敝帚自珍",
    "traditional": "敝帚自珍"
  },
  {
    "frequency": 157,
    "simplified": "英雄无用武之地",
    "traditional": "英雄無用武之地"
  },
  {
    "frequency": 156,
    "simplified": "色厉内荏",
    "traditional": "色厲內荏"
  },
  {
    "frequency": 156,
    "simplified": "火烧火燎",
    "traditional": "火燒火燎"
  },
  {
    "frequency": 156,
    "simplified": "富商巨贾",
    "traditional": "富商巨賈"
  },
  {
    "frequency": 156,
    "simplified": "自由放任",
    "traditional": "自由放任"
  },
  {
    "frequency": 156,
    "simplified": "如烹小鲜",
    "traditional": "如烹小鮮"
  },
  {
    "frequency": 156,
    "simplified": "亲临其境",
    "traditional": "親臨其境"
  },
  {
    "frequency": 156,
    "simplified": "树倒猢狲散",
    "traditional": "樹倒猢猻散"
  },
  {
    "frequency": 156,
    "simplified": "擒贼先擒王",
    "traditional": "擒賊先擒王"
  },
  {
    "frequency": 156,
    "simplified": "曲意逢迎",
    "traditional": "曲意逢迎"
  },
  {
    "frequency": 156,
    "simplified": "土洋结合",
    "traditional": "土洋結合"
  },
  {
    "frequency": 156,
    "simplified": "魔高一尺道高一丈",
    "traditional": "魔高一尺道高一丈"
  },
  {
    "frequency": 156,
    "simplified": "举案齐眉",
    "traditional": "舉案齊眉"
  },
  {
    "frequency": 156,
    "simplified": "螳螂捕蝉",
    "traditional": "螳螂捕蟬"
  },
  {
    "frequency": 155,
    "simplified": "墙倒众人推",
    "traditional": "牆倒眾人推"
  },
  {
    "frequency": 155,
    "simplified": "王侯将相",
    "traditional": "王侯將相"
  },
  {
    "frequency": 155,
    "simplified": "丢盔弃甲",
    "traditional": "丟盔棄甲"
  },
  {
    "frequency": 155,
    "simplified": "威武不屈",
    "traditional": "威武不屈"
  },
  {
    "frequency": 155,
    "simplified": "置之不顾",
    "traditional": "置之不顧"
  },
  {
    "frequency": 155,
    "simplified": "凤冠霞帔",
    "traditional": "鳳冠霞帔"
  },
  {
    "frequency": 155,
    "simplified": "积水成渊",
    "traditional": "積水成淵"
  },
  {
    "frequency": 155,
    "simplified": "蝇头小楷",
    "traditional": "蠅頭小楷"
  },
  {
    "frequency": 154,
    "simplified": "缺吃少穿",
    "traditional": "缺吃少穿"
  },
  {
    "frequency": 154,
    "simplified": "夫妻反目",
    "traditional": "夫妻反目"
  },
  {
    "frequency": 154,
    "simplified": "滔天大罪",
    "traditional": "滔天大罪"
  },
  {
    "frequency": 154,
    "simplified": "水火之中",
    "traditional": "水火之中"
  },
  {
    "frequency": 154,
    "simplified": "长幼有序",
    "traditional": "長幼有序"
  },
  {
    "frequency": 154,
    "simplified": "弃暗投明",
    "traditional": "棄暗投明"
  },
  {
    "frequency": 154,
    "simplified": "无所不为",
    "traditional": "無所不為"
  },
  {
    "frequency": 154,
    "simplified": "敢怒而不敢言",
    "traditional": "敢怒而不敢言"
  },
  {
    "frequency": 154,
    "simplified": "狼子野心",
    "traditional": "狼子野心"
  },
  {
    "frequency": 154,
    "simplified": "三朝元老",
    "traditional": "三朝元老"
  },
  {
    "frequency": 153,
    "simplified": "心急吃不了热豆腐",
    "traditional": "心急吃不了熱豆腐"
  },
  {
    "frequency": 153,
    "simplified": "茹毛饮血",
    "traditional": "茹毛飲血"
  },
  {
    "frequency": 153,
    "simplified": "疾风知劲草",
    "traditional": "疾風知勁草"
  },
  {
    "frequency": 153,
    "simplified": "慷慨悲歌",
    "traditional": "慷慨悲歌"
  },
  {
    "frequency": 153,
    "simplified": "耳顺之年",
    "traditional": "耳順之年"
  },
  {
    "frequency": 153,
    "simplified": "姿态万千",
    "traditional": "姿態萬千"
  },
  {
    "frequency": 153,
    "simplified": "踏破铁鞋无觅处",
    "traditional": "踏破鐵鞋無覓處"
  },
  {
    "frequency": 153,
    "simplified": "欢呼雀跃",
    "traditional": "歡呼雀躍"
  },
  {
    "frequency": 152,
    "simplified": "打入另册",
    "traditional": "打入另冊"
  },
  {
    "frequency": 152,
    "simplified": "搜肠刮肚",
    "traditional": "搜腸刮肚"
  },
  {
    "frequency": 152,
    "simplified": "付之一笑",
    "traditional": "付之一笑"
  },
  {
    "frequency": 152,
    "simplified": "一路风尘",
    "traditional": "一路風塵"
  },
  {
    "frequency": 152,
    "simplified": "聪明过人",
    "traditional": "聰明過人"
  },
  {
    "frequency": 152,
    "simplified": "从心所欲",
    "traditional": "從心所欲"
  },
  {
    "frequency": 152,
    "simplified": "难分难舍",
    "traditional": "難分難捨"
  },
  {
    "frequency": 152,
    "simplified": "小道消息",
    "traditional": "小道消息"
  },
  {
    "frequency": 152,
    "simplified": "孰不可忍",
    "traditional": "孰不可忍"
  },
  {
    "frequency": 152,
    "simplified": "魑魅魍魉",
    "traditional": "魑魅魍魎"
  },
  {
    "frequency": 152,
    "simplified": "只见树木",
    "traditional": "只見樹木"
  },
  {
    "frequency": 152,
    "simplified": "独霸一方",
    "traditional": "獨霸一方"
  },
  {
    "frequency": 152,
    "simplified": "隐忍不发",
    "traditional": "隱忍不發"
  },
  {
    "frequency": 151,
    "simplified": "不在其位",
    "traditional": "不在其位"
  },
  {
    "frequency": 151,
    "simplified": "胸中有数",
    "traditional": "胸中有數"
  },
  {
    "frequency": 151,
    "simplified": "超然物外",
    "traditional": "超然物外"
  },
  {
    "frequency": 151,
    "simplified": "四大皆空",
    "traditional": "四大皆空"
  },
  {
    "frequency": 151,
    "simplified": "后浪推前浪",
    "traditional": "後浪推前浪"
  },
  {
    "frequency": 151,
    "simplified": "买椟还珠",
    "traditional": "買櫝還珠"
  },
  {
    "frequency": 151,
    "simplified": "鸡零狗碎",
    "traditional": "雞零狗碎"
  },
  {
    "frequency": 151,
    "simplified": "阿谀逢迎",
    "traditional": "阿諛逢迎"
  },
  {
    "frequency": 151,
    "simplified": "生花妙笔",
    "traditional": "生花妙筆"
  },
  {
    "frequency": 151,
    "simplified": "一字千金",
    "traditional": "一字千金"
  },
  {
    "frequency": 151,
    "simplified": "男儿膝下有黄金",
    "traditional": "男兒膝下有黃金"
  },
  {
    "frequency": 151,
    "simplified": "成何体统",
    "traditional": "成何體統"
  },
  {
    "frequency": 151,
    "simplified": "以怨报德",
    "traditional": "以怨報德"
  },
  {
    "frequency": 151,
    "simplified": "千沟万壑",
    "traditional": "千溝萬壑"
  },
  {
    "frequency": 151,
    "simplified": "形影相随",
    "traditional": "形影相隨"
  },
  {
    "frequency": 151,
    "simplified": "近墨者黑",
    "traditional": "近墨者黑"
  },
  {
    "frequency": 151,
    "simplified": "本性难移",
    "traditional": "本性難移"
  },
  {
    "frequency": 151,
    "simplified": "比上不足比下有余",
    "traditional": "比上不足比下有餘"
  },
  {
    "frequency": 151,
    "simplified": "一挥而就",
    "traditional": "一揮而就"
  },
  {
    "frequency": 150,
    "simplified": "虚度年华",
    "traditional": "虛度年華"
  },
  {
    "frequency": 150,
    "simplified": "郁郁不得志",
    "traditional": "鬱郁不得志"
  },
  {
    "frequency": 150,
    "simplified": "闭目塞听",
    "traditional": "閉目塞聽"
  },
  {
    "frequency": 150,
    "simplified": "救苦救难",
    "traditional": "救苦救難"
  },
  {
    "frequency": 150,
    "simplified": "分家析产",
    "traditional": "分家析產"
  },
  {
    "frequency": 150,
    "simplified": "垂暮之年",
    "traditional": "垂暮之年"
  },
  {
    "frequency": 150,
    "simplified": "拾人牙慧",
    "traditional": "拾人牙慧"
  },
  {
    "frequency": 149,
    "simplified": "自食其言",
    "traditional": "自食其言"
  },
  {
    "frequency": 149,
    "simplified": "三纲五常",
    "traditional": "三綱五常"
  },
  {
    "frequency": 149,
    "simplified": "尺有所短",
    "traditional": "尺有所短"
  },
  {
    "frequency": 149,
    "simplified": "各奔前程",
    "traditional": "各奔前程"
  },
  {
    "frequency": 149,
    "simplified": "黄粱美梦",
    "traditional": "黃粱美夢"
  },
  {
    "frequency": 149,
    "simplified": "肆意横行",
    "traditional": "肆意橫行"
  },
  {
    "frequency": 149,
    "simplified": "表里山河",
    "traditional": "表裡山河"
  },
  {
    "frequency": 149,
    "simplified": "金屋藏娇",
    "traditional": "金屋藏嬌"
  },
  {
    "frequency": 149,
    "simplified": "相对无言",
    "traditional": "相對無言"
  },
  {
    "frequency": 149,
    "simplified": "寸有所长",
    "traditional": "寸有所長"
  },
  {
    "frequency": 149,
    "simplified": "嗟来之食",
    "traditional": "嗟來之食"
  },
  {
    "frequency": 149,
    "simplified": "不足为虑",
    "traditional": "不足為慮"
  },
  {
    "frequency": 149,
    "simplified": "急公好义",
    "traditional": "急公好義"
  },
  {
    "frequency": 149,
    "simplified": "新仇旧恨",
    "traditional": "新仇舊恨"
  },
  {
    "frequency": 149,
    "simplified": "贪心不足",
    "traditional": "貪心不足"
  },
  {
    "frequency": 149,
    "simplified": "焚书坑儒",
    "traditional": "焚書坑儒"
  },
  {
    "frequency": 149,
    "simplified": "若烹小鲜",
    "traditional": "若烹小鮮"
  },
  {
    "frequency": 149,
    "simplified": "食不甘味",
    "traditional": "食不甘味"
  },
  {
    "frequency": 149,
    "simplified": "油嘴滑舌",
    "traditional": "油嘴滑舌"
  },
  {
    "frequency": 148,
    "simplified": "全知全能",
    "traditional": "全知全能"
  },
  {
    "frequency": 148,
    "simplified": "他乡遇故知",
    "traditional": "他鄉遇故知"
  },
  {
    "frequency": 148,
    "simplified": "国仇家恨",
    "traditional": "國仇家恨"
  },
  {
    "frequency": 148,
    "simplified": "力所不及",
    "traditional": "力所不及"
  },
  {
    "frequency": 148,
    "simplified": "花容月貌",
    "traditional": "花容月貌"
  },
  {
    "frequency": 148,
    "simplified": "坎坷不平",
    "traditional": "坎坷不平"
  },
  {
    "frequency": 148,
    "simplified": "恶贯满盈",
    "traditional": "惡貫滿盈"
  },
  {
    "frequency": 148,
    "simplified": "横征暴敛",
    "traditional": "橫徵暴斂"
  },
  {
    "frequency": 148,
    "simplified": "人老珠黄",
    "traditional": "人老珠黃"
  },
  {
    "frequency": 148,
    "simplified": "言归于好",
    "traditional": "言歸於好"
  },
  {
    "frequency": 148,
    "simplified": "漠然置之",
    "traditional": "漠然置之"
  },
  {
    "frequency": 148,
    "simplified": "误人子弟",
    "traditional": "誤人子弟"
  },
  {
    "frequency": 148,
    "simplified": "四海之内皆兄弟",
    "traditional": "四海之內皆兄弟"
  },
  {
    "frequency": 148,
    "simplified": "爱民如子",
    "traditional": "愛民如子"
  },
  {
    "frequency": 148,
    "simplified": "识时务者为俊杰",
    "traditional": "識時務者為俊傑"
  },
  {
    "frequency": 148,
    "simplified": "剥茧抽丝",
    "traditional": "剝繭抽絲"
  },
  {
    "frequency": 147,
    "simplified": "困兽犹斗",
    "traditional": "困獸猶鬥"
  },
  {
    "frequency": 147,
    "simplified": "必经之路",
    "traditional": "必經之路"
  },
  {
    "frequency": 147,
    "simplified": "立身处世",
    "traditional": "立身處世"
  },
  {
    "frequency": 147,
    "simplified": "乔装改扮",
    "traditional": "喬裝改扮"
  },
  {
    "frequency": 147,
    "simplified": "不敢造次",
    "traditional": "不敢造次"
  },
  {
    "frequency": 147,
    "simplified": "同出一辙",
    "traditional": "同出一轍"
  },
  {
    "frequency": 147,
    "simplified": "震古烁今",
    "traditional": "震古爍今"
  },
  {
    "frequency": 147,
    "simplified": "争名夺利",
    "traditional": "爭名奪利"
  },
  {
    "frequency": 147,
    "simplified": "言者无罪",
    "traditional": "言者無罪"
  },
  {
    "frequency": 147,
    "simplified": "放浪形骸",
    "traditional": "放浪形骸"
  },
  {
    "frequency": 146,
    "simplified": "选贤与能",
    "traditional": "選賢與能"
  },
  {
    "frequency": 146,
    "simplified": "六畜兴旺",
    "traditional": "六畜興旺"
  },
  {
    "frequency": 146,
    "simplified": "金玉良缘",
    "traditional": "金玉良緣"
  },
  {
    "frequency": 146,
    "simplified": "戴绿帽子",
    "traditional": "戴綠帽子"
  },
  {
    "frequency": 146,
    "simplified": "作如是观",
    "traditional": "作如是觀"
  },
  {
    "frequency": 146,
    "simplified": "孔武有力",
    "traditional": "孔武有力"
  },
  {
    "frequency": 146,
    "simplified": "打个照面",
    "traditional": "打個照面"
  },
  {
    "frequency": 146,
    "simplified": "卷帙浩繁",
    "traditional": "卷帙浩繁"
  },
  {
    "frequency": 146,
    "simplified": "备而不用",
    "traditional": "備而不用"
  },
  {
    "frequency": 145,
    "simplified": "青红皂白",
    "traditional": "青紅皂白"
  },
  {
    "frequency": 145,
    "simplified": "独出心裁",
    "traditional": "獨出心裁"
  },
  {
    "frequency": 145,
    "simplified": "万里迢迢",
    "traditional": "萬里迢迢"
  },
  {
    "frequency": 145,
    "simplified": "大恩大德",
    "traditional": "大恩大德"
  },
  {
    "frequency": 145,
    "simplified": "赞口不绝",
    "traditional": "讚口不絕"
  },
  {
    "frequency": 145,
    "simplified": "江东父老",
    "traditional": "江東父老"
  },
  {
    "frequency": 145,
    "simplified": "等而下之",
    "traditional": "等而下之"
  },
  {
    "frequency": 145,
    "simplified": "南柯一梦",
    "traditional": "南柯一夢"
  },
  {
    "frequency": 145,
    "simplified": "江洋大盗",
    "traditional": "江洋大盜"
  },
  {
    "frequency": 145,
    "simplified": "山明水秀",
    "traditional": "山明水秀"
  },
  {
    "frequency": 145,
    "simplified": "风尘女子",
    "traditional": "風塵女子"
  },
  {
    "frequency": 145,
    "simplified": "身在福中不知福",
    "traditional": "身在福中不知福"
  },
  {
    "frequency": 145,
    "simplified": "面有难色",
    "traditional": "面有難色"
  },
  {
    "frequency": 145,
    "simplified": "身教重于言教",
    "traditional": "身教重於言教"
  },
  {
    "frequency": 145,
    "simplified": "披坚执锐",
    "traditional": "披堅執銳"
  },
  {
    "frequency": 145,
    "simplified": "渺无人烟",
    "traditional": "渺無人煙"
  },
  {
    "frequency": 145,
    "simplified": "天渊之别",
    "traditional": "天淵之別"
  },
  {
    "frequency": 144,
    "simplified": "公正廉明",
    "traditional": "公正廉明"
  },
  {
    "frequency": 144,
    "simplified": "君子好逑",
    "traditional": "君子好逑"
  },
  {
    "frequency": 144,
    "simplified": "当替罪羊",
    "traditional": "當替罪羊"
  },
  {
    "frequency": 144,
    "simplified": "闭门思过",
    "traditional": "閉門思過"
  },
  {
    "frequency": 144,
    "simplified": "眉目传情",
    "traditional": "眉目傳情"
  },
  {
    "frequency": 144,
    "simplified": "攻心为上",
    "traditional": "攻心為上"
  },
  {
    "frequency": 144,
    "simplified": "大敌当前",
    "traditional": "大敵當前"
  },
  {
    "frequency": 144,
    "simplified": "出污泥而不染",
    "traditional": "出汙泥而不染"
  },
  {
    "frequency": 144,
    "simplified": "愁眉紧锁",
    "traditional": "愁眉緊鎖"
  },
  {
    "frequency": 143,
    "simplified": "点头之交",
    "traditional": "點頭之交"
  },
  {
    "frequency": 143,
    "simplified": "打蛇打七寸",
    "traditional": "打蛇打七寸"
  },
  {
    "frequency": 143,
    "simplified": "插翅难飞",
    "traditional": "插翅難飛"
  },
  {
    "frequency": 143,
    "simplified": "以一当十",
    "traditional": "以一當十"
  },
  {
    "frequency": 143,
    "simplified": "修旧利废",
    "traditional": "修舊利廢"
  },
  {
    "frequency": 143,
    "simplified": "苦口良药",
    "traditional": "苦口良藥"
  },
  {
    "frequency": 143,
    "simplified": "见惯不惊",
    "traditional": "見慣不驚"
  },
  {
    "frequency": 143,
    "simplified": "就地正法",
    "traditional": "就地正法"
  },
  {
    "frequency": 143,
    "simplified": "好好先生",
    "traditional": "好好先生"
  },
  {
    "frequency": 142,
    "simplified": "得失成败",
    "traditional": "得失成敗"
  },
  {
    "frequency": 142,
    "simplified": "有始无终",
    "traditional": "有始無終"
  },
  {
    "frequency": 142,
    "simplified": "重赏之下",
    "traditional": "重賞之下"
  },
  {
    "frequency": 142,
    "simplified": "生生世世",
    "traditional": "生生世世"
  },
  {
    "frequency": 142,
    "simplified": "比肩接踵",
    "traditional": "比肩接踵"
  },
  {
    "frequency": 142,
    "simplified": "狗血喷头",
    "traditional": "狗血噴頭"
  },
  {
    "frequency": 142,
    "simplified": "纸里包不住火",
    "traditional": "紙裡包不住火"
  },
  {
    "frequency": 142,
    "simplified": "坐卧不宁",
    "traditional": "坐臥不寧"
  },
  {
    "frequency": 142,
    "simplified": "人小鬼大",
    "traditional": "人小鬼大"
  },
  {
    "frequency": 142,
    "simplified": "冷眼相待",
    "traditional": "冷眼相待"
  },
  {
    "frequency": 142,
    "simplified": "甜酸苦辣",
    "traditional": "甜酸苦辣"
  },
  {
    "frequency": 142,
    "simplified": "泽被后世",
    "traditional": "澤被後世"
  },
  {
    "frequency": 142,
    "simplified": "自我治疗",
    "traditional": "自我治療"
  },
  {
    "frequency": 142,
    "simplified": "水至清则无鱼",
    "traditional": "水至清則無魚"
  },
  {
    "frequency": 142,
    "simplified": "勤学好问",
    "traditional": "勤學好問"
  },
  {
    "frequency": 142,
    "simplified": "哀而不伤",
    "traditional": "哀而不傷"
  },
  {
    "frequency": 141,
    "simplified": "伉俪情深",
    "traditional": "伉儷情深"
  },
  {
    "frequency": 141,
    "simplified": "身价百倍",
    "traditional": "身價百倍"
  },
  {
    "frequency": 141,
    "simplified": "三生有幸",
    "traditional": "三生有幸"
  },
  {
    "frequency": 141,
    "simplified": "非宁静无以致远",
    "traditional": "非寧靜無以致遠"
  },
  {
    "frequency": 141,
    "simplified": "只见树木不见森林",
    "traditional": "只見樹木不見森林"
  },
  {
    "frequency": 141,
    "simplified": "目不暇给",
    "traditional": "目不暇給"
  },
  {
    "frequency": 141,
    "simplified": "情深义重",
    "traditional": "情深義重"
  },
  {
    "frequency": 141,
    "simplified": "大音希声",
    "traditional": "大音希聲"
  },
  {
    "frequency": 140,
    "simplified": "九九归一",
    "traditional": "九九歸一"
  },
  {
    "frequency": 140,
    "simplified": "户枢不蠹",
    "traditional": "戶樞不蠹"
  },
  {
    "frequency": 140,
    "simplified": "上兵伐谋",
    "traditional": "上兵伐謀"
  },
  {
    "frequency": 140,
    "simplified": "黄钟大吕",
    "traditional": "黃鐘大呂"
  },
  {
    "frequency": 140,
    "simplified": "驰名世界",
    "traditional": "馳名世界"
  },
  {
    "frequency": 140,
    "simplified": "今朝有酒今朝醉",
    "traditional": "今朝有酒今朝醉"
  },
  {
    "frequency": 140,
    "simplified": "睚眦必报",
    "traditional": "睚眥必報"
  },
  {
    "frequency": 140,
    "simplified": "心宽体胖",
    "traditional": "心寬體胖"
  },
  {
    "frequency": 140,
    "simplified": "画虎不成反类犬",
    "traditional": "畫虎不成反類犬"
  },
  {
    "frequency": 139,
    "simplified": "不平则鸣",
    "traditional": "不平則鳴"
  },
  {
    "frequency": 139,
    "simplified": "秋收冬藏",
    "traditional": "秋收冬藏"
  },
  {
    "frequency": 139,
    "simplified": "门禁森严",
    "traditional": "門禁森嚴"
  },
  {
    "frequency": 139,
    "simplified": "冤家对头",
    "traditional": "冤家對頭"
  },
  {
    "frequency": 139,
    "simplified": "英雄气短",
    "traditional": "英雄氣短"
  },
  {
    "frequency": 139,
    "simplified": "奇思妙想",
    "traditional": "奇思妙想"
  },
  {
    "frequency": 139,
    "simplified": "安土重迁",
    "traditional": "安土重遷"
  },
  {
    "frequency": 139,
    "simplified": "白纸黑字",
    "traditional": "白紙黑字"
  },
  {
    "frequency": 139,
    "simplified": "干脆利落",
    "traditional": "乾脆利落"
  },
  {
    "frequency": 139,
    "simplified": "寡廉鲜耻",
    "traditional": "寡廉鮮恥"
  },
  {
    "frequency": 139,
    "simplified": "两面三刀",
    "traditional": "兩面三刀"
  },
  {
    "frequency": 138,
    "simplified": "一日之计在于晨",
    "traditional": "一日之計在於晨"
  },
  {
    "frequency": 138,
    "simplified": "一丘之貉",
    "traditional": "一丘之貉"
  },
  {
    "frequency": 138,
    "simplified": "凌云壮志",
    "traditional": "凌雲壯志"
  },
  {
    "frequency": 138,
    "simplified": "内外夹攻",
    "traditional": "內外夾攻"
  },
  {
    "frequency": 138,
    "simplified": "威胁利诱",
    "traditional": "威脅利誘"
  },
  {
    "frequency": 138,
    "simplified": "一手一脚",
    "traditional": "一手一腳"
  },
  {
    "frequency": 138,
    "simplified": "温柔敦厚",
    "traditional": "溫柔敦厚"
  },
  {
    "frequency": 138,
    "simplified": "窒碍难行",
    "traditional": "窒礙難行"
  },
  {
    "frequency": 138,
    "simplified": "坐言起行",
    "traditional": "坐言起行"
  },
  {
    "frequency": 138,
    "simplified": "缓不济急",
    "traditional": "緩不濟急"
  },
  {
    "frequency": 138,
    "simplified": "鱼肉百姓",
    "traditional": "魚肉百姓"
  },
  {
    "frequency": 138,
    "simplified": "马放南山",
    "traditional": "馬放南山"
  },
  {
    "frequency": 138,
    "simplified": "无关大局",
    "traditional": "無關大局"
  },
  {
    "frequency": 138,
    "simplified": "放下屠刀",
    "traditional": "放下屠刀"
  },
  {
    "frequency": 138,
    "simplified": "死有余辜",
    "traditional": "死有餘辜"
  },
  {
    "frequency": 138,
    "simplified": "后会有期",
    "traditional": "後會有期"
  },
  {
    "frequency": 137,
    "simplified": "独木不成林",
    "traditional": "獨木不成林"
  },
  {
    "frequency": 137,
    "simplified": "做一天和尚撞一天钟",
    "traditional": "做一天和尚撞一天鐘"
  },
  {
    "frequency": 137,
    "simplified": "死得其所",
    "traditional": "死得其所"
  },
  {
    "frequency": 137,
    "simplified": "弃笔从戎",
    "traditional": "棄筆從戎"
  },
  {
    "frequency": 137,
    "simplified": "兄弟阋墙",
    "traditional": "兄弟鬩牆"
  },
  {
    "frequency": 137,
    "simplified": "班门弄斧",
    "traditional": "班門弄斧"
  },
  {
    "frequency": 137,
    "simplified": "虚有其表",
    "traditional": "虛有其表"
  },
  {
    "frequency": 137,
    "simplified": "道德文章",
    "traditional": "道德文章"
  },
  {
    "frequency": 137,
    "simplified": "意气相投",
    "traditional": "意氣相投"
  },
  {
    "frequency": 137,
    "simplified": "文韬武略",
    "traditional": "文韜武略"
  },
  {
    "frequency": 137,
    "simplified": "万物之灵",
    "traditional": "萬物之靈"
  },
  {
    "frequency": 137,
    "simplified": "鼾声如雷",
    "traditional": "鼾聲如雷"
  },
  {
    "frequency": 137,
    "simplified": "畏葸不前",
    "traditional": "畏葸不前"
  },
  {
    "frequency": 136,
    "simplified": "胸无大志",
    "traditional": "胸無大志"
  },
  {
    "frequency": 136,
    "simplified": "借刀杀人",
    "traditional": "借刀殺人"
  },
  {
    "frequency": 136,
    "simplified": "外圆内方",
    "traditional": "外圓內方"
  },
  {
    "frequency": 136,
    "simplified": "欲速不达",
    "traditional": "欲速不達"
  },
  {
    "frequency": 136,
    "simplified": "千娇百媚",
    "traditional": "千嬌百媚"
  },
  {
    "frequency": 135,
    "simplified": "同生共死",
    "traditional": "同生共死"
  },
  {
    "frequency": 135,
    "simplified": "担当不起",
    "traditional": "擔當不起"
  },
  {
    "frequency": 135,
    "simplified": "心明眼亮",
    "traditional": "心明眼亮"
  },
  {
    "frequency": 135,
    "simplified": "驷马难追",
    "traditional": "駟馬難追"
  },
  {
    "frequency": 135,
    "simplified": "大梦初醒",
    "traditional": "大夢初醒"
  },
  {
    "frequency": 135,
    "simplified": "漆黑一团",
    "traditional": "漆黑一團"
  },
  {
    "frequency": 135,
    "simplified": "权宜之策",
    "traditional": "權宜之策"
  },
  {
    "frequency": 135,
    "simplified": "趋吉避凶",
    "traditional": "趨吉避凶"
  },
  {
    "frequency": 135,
    "simplified": "芒刺在背",
    "traditional": "芒刺在背"
  },
  {
    "frequency": 135,
    "simplified": "人生七十古来稀",
    "traditional": "人生七十古來稀"
  },
  {
    "frequency": 135,
    "simplified": "绝顶聪明",
    "traditional": "絕頂聰明"
  },
  {
    "frequency": 135,
    "simplified": "点铁成金",
    "traditional": "點鐵成金"
  },
  {
    "frequency": 135,
    "simplified": "一时半刻",
    "traditional": "一時半刻"
  },
  {
    "frequency": 135,
    "simplified": "有头有尾",
    "traditional": "有頭有尾"
  },
  {
    "frequency": 135,
    "simplified": "步步登高",
    "traditional": "步步登高"
  },
  {
    "frequency": 135,
    "simplified": "三姑六婆",
    "traditional": "三姑六婆"
  },
  {
    "frequency": 135,
    "simplified": "全军覆灭",
    "traditional": "全軍覆滅"
  },
  {
    "frequency": 134,
    "simplified": "心有灵犀一点通",
    "traditional": "心有靈犀一點通"
  },
  {
    "frequency": 134,
    "simplified": "精确瞄准",
    "traditional": "精確瞄準"
  },
  {
    "frequency": 134,
    "simplified": "淡而无味",
    "traditional": "淡而無味"
  },
  {
    "frequency": 134,
    "simplified": "贼心不死",
    "traditional": "賊心不死"
  },
  {
    "frequency": 134,
    "simplified": "马到功成",
    "traditional": "馬到功成"
  },
  {
    "frequency": 134,
    "simplified": "鸿鹄之志",
    "traditional": "鴻鵠之志"
  },
  {
    "frequency": 134,
    "simplified": "玫瑰人生",
    "traditional": "玫瑰人生"
  },
  {
    "frequency": 134,
    "simplified": "是是非非",
    "traditional": "是是非非"
  },
  {
    "frequency": 134,
    "simplified": "精神错乱",
    "traditional": "精神錯亂"
  },
  {
    "frequency": 133,
    "simplified": "言之无物",
    "traditional": "言之無物"
  },
  {
    "frequency": 133,
    "simplified": "鸡鸣狗盗",
    "traditional": "雞鳴狗盜"
  },
  {
    "frequency": 133,
    "simplified": "娇小玲珑",
    "traditional": "嬌小玲瓏"
  },
  {
    "frequency": 133,
    "simplified": "明枪暗箭",
    "traditional": "明槍暗箭"
  },
  {
    "frequency": 133,
    "simplified": "怡情养性",
    "traditional": "怡情養性"
  },
  {
    "frequency": 133,
    "simplified": "泪眼汪汪",
    "traditional": "淚眼汪汪"
  },
  {
    "frequency": 133,
    "simplified": "步履矫健",
    "traditional": "步履矯健"
  },
  {
    "frequency": 132,
    "simplified": "斑驳陆离",
    "traditional": "斑駁陸離"
  },
  {
    "frequency": 132,
    "simplified": "宾朋满座",
    "traditional": "賓朋滿座"
  },
  {
    "frequency": 132,
    "simplified": "富国强民",
    "traditional": "富國強民"
  },
  {
    "frequency": 132,
    "simplified": "见异思迁",
    "traditional": "見異思遷"
  },
  {
    "frequency": 132,
    "simplified": "哼哼唧唧",
    "traditional": "哼哼唧唧"
  },
  {
    "frequency": 132,
    "simplified": "从容就义",
    "traditional": "從容就義"
  },
  {
    "frequency": 132,
    "simplified": "救急不救穷",
    "traditional": "救急不救窮"
  },
  {
    "frequency": 132,
    "simplified": "出头露面",
    "traditional": "出頭露面"
  },
  {
    "frequency": 132,
    "simplified": "荒谬绝伦",
    "traditional": "荒謬絕倫"
  },
  {
    "frequency": 132,
    "simplified": "后人乘凉",
    "traditional": "後人乘涼"
  },
  {
    "frequency": 132,
    "simplified": "排除万难",
    "traditional": "排除萬難"
  },
  {
    "frequency": 132,
    "simplified": "捐弃前嫌",
    "traditional": "捐棄前嫌"
  },
  {
    "frequency": 132,
    "simplified": "舌战群儒",
    "traditional": "舌戰群儒"
  },
  {
    "frequency": 132,
    "simplified": "诡计多端",
    "traditional": "詭計多端"
  },
  {
    "frequency": 132,
    "simplified": "舍本求末",
    "traditional": "捨本求末"
  },
  {
    "frequency": 132,
    "simplified": "书香门第",
    "traditional": "書香門第"
  },
  {
    "frequency": 132,
    "simplified": "十八般兵器",
    "traditional": "十八般兵器"
  },
  {
    "frequency": 131,
    "simplified": "才高八斗",
    "traditional": "才高八斗"
  },
  {
    "frequency": 131,
    "simplified": "敌众我寡",
    "traditional": "敵眾我寡"
  },
  {
    "frequency": 131,
    "simplified": "老鼠过街",
    "traditional": "老鼠過街"
  },
  {
    "frequency": 131,
    "simplified": "不可言传",
    "traditional": "不可言傳"
  },
  {
    "frequency": 131,
    "simplified": "三从四德",
    "traditional": "三從四德"
  },
  {
    "frequency": 131,
    "simplified": "忠孝节义",
    "traditional": "忠孝節義"
  },
  {
    "frequency": 131,
    "simplified": "路见不平拔刀相助",
    "traditional": "路見不平拔刀相助"
  },
  {
    "frequency": 131,
    "simplified": "日甚一日",
    "traditional": "日甚一日"
  },
  {
    "frequency": 131,
    "simplified": "业精于勤",
    "traditional": "業精於勤"
  },
  {
    "frequency": 131,
    "simplified": "破竹之势",
    "traditional": "破竹之勢"
  },
  {
    "frequency": 130,
    "simplified": "远水不解近渴",
    "traditional": "遠水不解近渴"
  },
  {
    "frequency": 130,
    "simplified": "归去来兮",
    "traditional": "歸去來兮"
  },
  {
    "frequency": 130,
    "simplified": "一着不慎",
    "traditional": "一著不慎"
  },
  {
    "frequency": 130,
    "simplified": "有过之无不及",
    "traditional": "有過之無不及"
  },
  {
    "frequency": 130,
    "simplified": "妙语如珠",
    "traditional": "妙語如珠"
  },
  {
    "frequency": 130,
    "simplified": "学而不厌",
    "traditional": "學而不厭"
  },
  {
    "frequency": 130,
    "simplified": "人怕出名猪怕壮",
    "traditional": "人怕出名豬怕壯"
  },
  {
    "frequency": 130,
    "simplified": "宁静致远",
    "traditional": "寧靜致遠"
  },
  {
    "frequency": 130,
    "simplified": "打家劫舍",
    "traditional": "打家劫舍"
  },
  {
    "frequency": 130,
    "simplified": "杀人如麻",
    "traditional": "殺人如麻"
  },
  {
    "frequency": 130,
    "simplified": "包藏祸心",
    "traditional": "包藏禍心"
  },
  {
    "frequency": 129,
    "simplified": "百万雄师",
    "traditional": "百萬雄師"
  },
  {
    "frequency": 129,
    "simplified": "愚不可及",
    "traditional": "愚不可及"
  },
  {
    "frequency": 129,
    "simplified": "无名小卒",
    "traditional": "無名小卒"
  },
  {
    "frequency": 129,
    "simplified": "黄袍加身",
    "traditional": "黃袍加身"
  },
  {
    "frequency": 129,
    "simplified": "火力集中",
    "traditional": "火力集中"
  },
  {
    "frequency": 129,
    "simplified": "五谷不分",
    "traditional": "五穀不分"
  },
  {
    "frequency": 129,
    "simplified": "不忍卒读",
    "traditional": "不忍卒讀"
  },
  {
    "frequency": 129,
    "simplified": "怨气冲天",
    "traditional": "怨氣沖天"
  },
  {
    "frequency": 128,
    "simplified": "不知好歹",
    "traditional": "不知好歹"
  },
  {
    "frequency": 128,
    "simplified": "欢蹦乱跳",
    "traditional": "歡蹦亂跳"
  },
  {
    "frequency": 128,
    "simplified": "竹篮打水",
    "traditional": "竹籃打水"
  },
  {
    "frequency": 128,
    "simplified": "非我族类",
    "traditional": "非我族類"
  },
  {
    "frequency": 128,
    "simplified": "呼天抢地",
    "traditional": "呼天搶地"
  },
  {
    "frequency": 128,
    "simplified": "水木清华",
    "traditional": "水木清華"
  },
  {
    "frequency": 128,
    "simplified": "愁肠百结",
    "traditional": "愁腸百結"
  },
  {
    "frequency": 128,
    "simplified": "车到山前必有路",
    "traditional": "車到山前必有路"
  },
  {
    "frequency": 128,
    "simplified": "只可意会",
    "traditional": "只可意會"
  },
  {
    "frequency": 128,
    "simplified": "如切如磋",
    "traditional": "如切如磋"
  },
  {
    "frequency": 128,
    "simplified": "近乡情怯",
    "traditional": "近鄉情怯"
  },
  {
    "frequency": 128,
    "simplified": "如人饮水",
    "traditional": "如人飲水"
  },
  {
    "frequency": 128,
    "simplified": "死而无憾",
    "traditional": "死而無憾"
  },
  {
    "frequency": 128,
    "simplified": "海枯石烂",
    "traditional": "海枯石爛"
  },
  {
    "frequency": 128,
    "simplified": "萧规曹随",
    "traditional": "蕭規曹隨"
  },
  {
    "frequency": 128,
    "simplified": "秦晋之好",
    "traditional": "秦晉之好"
  },
  {
    "frequency": 127,
    "simplified": "任其自然",
    "traditional": "任其自然"
  },
  {
    "frequency": 127,
    "simplified": "戎马倥偬",
    "traditional": "戎馬倥傯"
  },
  {
    "frequency": 127,
    "simplified": "一清二白",
    "traditional": "一清二白"
  },
  {
    "frequency": 127,
    "simplified": "临渊羡鱼",
    "traditional": "臨淵羨魚"
  },
  {
    "frequency": 127,
    "simplified": "理屈词穷",
    "traditional": "理屈詞窮"
  },
  {
    "frequency": 127,
    "simplified": "虎口拔牙",
    "traditional": "虎口拔牙"
  },
  {
    "frequency": 127,
    "simplified": "前思后想",
    "traditional": "前思後想"
  },
  {
    "frequency": 127,
    "simplified": "削铁如泥",
    "traditional": "削鐵如泥"
  },
  {
    "frequency": 127,
    "simplified": "太平无事",
    "traditional": "太平無事"
  },
  {
    "frequency": 127,
    "simplified": "溢美之辞",
    "traditional": "溢美之辭"
  },
  {
    "frequency": 127,
    "simplified": "一片焦土",
    "traditional": "一片焦土"
  },
  {
    "frequency": 127,
    "simplified": "势单力孤",
    "traditional": "勢單力孤"
  },
  {
    "frequency": 127,
    "simplified": "抱头鼠窜",
    "traditional": "抱頭鼠竄"
  },
  {
    "frequency": 127,
    "simplified": "流落他乡",
    "traditional": "流落他鄉"
  },
  {
    "frequency": 127,
    "simplified": "虎背熊腰",
    "traditional": "虎背熊腰"
  },
  {
    "frequency": 126,
    "simplified": "有害无利",
    "traditional": "有害無利"
  },
  {
    "frequency": 126,
    "simplified": "天荒地老",
    "traditional": "天荒地老"
  },
  {
    "frequency": 126,
    "simplified": "死不悔改",
    "traditional": "死不悔改"
  },
  {
    "frequency": 126,
    "simplified": "面如土色",
    "traditional": "面如土色"
  },
  {
    "frequency": 126,
    "simplified": "流芳千古",
    "traditional": "流芳千古"
  },
  {
    "frequency": 126,
    "simplified": "遁入空门",
    "traditional": "遁入空門"
  },
  {
    "frequency": 126,
    "simplified": "触目皆是",
    "traditional": "觸目皆是"
  },
  {
    "frequency": 126,
    "simplified": "前无古人后无来者",
    "traditional": "前無古人後無來者"
  },
  {
    "frequency": 126,
    "simplified": "邪门歪道",
    "traditional": "邪門歪道"
  },
  {
    "frequency": 126,
    "simplified": "有缘千里来相会",
    "traditional": "有緣千里來相會"
  },
  {
    "frequency": 126,
    "simplified": "天大地大",
    "traditional": "天大地大"
  },
  {
    "frequency": 126,
    "simplified": "老奸巨猾",
    "traditional": "老奸巨猾"
  },
  {
    "frequency": 126,
    "simplified": "收之桑榆",
    "traditional": "收之桑榆"
  },
  {
    "frequency": 125,
    "simplified": "七扭八歪",
    "traditional": "七扭八歪"
  },
  {
    "frequency": 125,
    "simplified": "利害相关",
    "traditional": "利害相關"
  },
  {
    "frequency": 125,
    "simplified": "呼朋唤友",
    "traditional": "呼朋喚友"
  },
  {
    "frequency": 125,
    "simplified": "了若指掌",
    "traditional": "瞭若指掌"
  },
  {
    "frequency": 125,
    "simplified": "云泥之别",
    "traditional": "雲泥之別"
  },
  {
    "frequency": 125,
    "simplified": "无影无形",
    "traditional": "無影無形"
  },
  {
    "frequency": 125,
    "simplified": "低吟浅唱",
    "traditional": "低吟淺唱"
  },
  {
    "frequency": 125,
    "simplified": "粗中有细",
    "traditional": "粗中有細"
  },
  {
    "frequency": 125,
    "simplified": "忘年之交",
    "traditional": "忘年之交"
  },
  {
    "frequency": 125,
    "simplified": "力不能及",
    "traditional": "力不能及"
  },
  {
    "frequency": 125,
    "simplified": "踟蹰不前",
    "traditional": "踟躕不前"
  },
  {
    "frequency": 125,
    "simplified": "不分胜负",
    "traditional": "不分勝負"
  },
  {
    "frequency": 124,
    "simplified": "重赏之下必有勇夫",
    "traditional": "重賞之下必有勇夫"
  },
  {
    "frequency": 124,
    "simplified": "以德报德",
    "traditional": "以德報德"
  },
  {
    "frequency": 124,
    "simplified": "十室九空",
    "traditional": "十室九空"
  },
  {
    "frequency": 124,
    "simplified": "溜须拍马",
    "traditional": "溜鬚拍馬"
  },
  {
    "frequency": 124,
    "simplified": "初露头角",
    "traditional": "初露頭角"
  },
  {
    "frequency": 124,
    "simplified": "聚少成多",
    "traditional": "聚少成多"
  },
  {
    "frequency": 124,
    "simplified": "打落水狗",
    "traditional": "打落水狗"
  },
  {
    "frequency": 124,
    "simplified": "以绝后患",
    "traditional": "以絕後患"
  },
  {
    "frequency": 124,
    "simplified": "默默不语",
    "traditional": "默默不語"
  },
  {
    "frequency": 124,
    "simplified": "人生如梦",
    "traditional": "人生如夢"
  },
  {
    "frequency": 124,
    "simplified": "十指连心",
    "traditional": "十指連心"
  },
  {
    "frequency": 124,
    "simplified": "离题万里",
    "traditional": "離題萬里"
  },
  {
    "frequency": 124,
    "simplified": "干脆利索",
    "traditional": "乾脆利索"
  },
  {
    "frequency": 124,
    "simplified": "誉满天下",
    "traditional": "譽滿天下"
  },
  {
    "frequency": 124,
    "simplified": "天下乌鸦一般黑",
    "traditional": "天下烏鴉一般黑"
  },
  {
    "frequency": 123,
    "simplified": "击中要害",
    "traditional": "擊中要害"
  },
  {
    "frequency": 123,
    "simplified": "片言只语",
    "traditional": "片言隻語"
  },
  {
    "frequency": 123,
    "simplified": "七零八碎",
    "traditional": "七零八碎"
  },
  {
    "frequency": 123,
    "simplified": "军令如山",
    "traditional": "軍令如山"
  },
  {
    "frequency": 123,
    "simplified": "驰骋疆场",
    "traditional": "馳騁疆場"
  },
  {
    "frequency": 123,
    "simplified": "无所忌惮",
    "traditional": "無所忌憚"
  },
  {
    "frequency": 123,
    "simplified": "昏天暗地",
    "traditional": "昏天暗地"
  },
  {
    "frequency": 123,
    "simplified": "经天纬地",
    "traditional": "經天緯地"
  },
  {
    "frequency": 123,
    "simplified": "好心好意",
    "traditional": "好心好意"
  },
  {
    "frequency": 122,
    "simplified": "披红戴花",
    "traditional": "披紅戴花"
  },
  {
    "frequency": 122,
    "simplified": "法力无边",
    "traditional": "法力無邊"
  },
  {
    "frequency": 122,
    "simplified": "嫣然一笑",
    "traditional": "嫣然一笑"
  },
  {
    "frequency": 122,
    "simplified": "器宇轩昂",
    "traditional": "器宇軒昂"
  },
  {
    "frequency": 122,
    "simplified": "人逢喜事精神爽",
    "traditional": "人逢喜事精神爽"
  },
  {
    "frequency": 122,
    "simplified": "计上心来",
    "traditional": "計上心來"
  },
  {
    "frequency": 122,
    "simplified": "电光石火",
    "traditional": "電光石火"
  },
  {
    "frequency": 122,
    "simplified": "轻如鸿毛",
    "traditional": "輕如鴻毛"
  },
  {
    "frequency": 122,
    "simplified": "龙蛇混杂",
    "traditional": "龍蛇混雜"
  },
  {
    "frequency": 122,
    "simplified": "今夕何夕",
    "traditional": "今夕何夕"
  },
  {
    "frequency": 122,
    "simplified": "攀龙附凤",
    "traditional": "攀龍附鳳"
  },
  {
    "frequency": 122,
    "simplified": "触景伤情",
    "traditional": "觸景傷情"
  },
  {
    "frequency": 122,
    "simplified": "歃血为盟",
    "traditional": "歃血為盟"
  },
  {
    "frequency": 122,
    "simplified": "攻其不备",
    "traditional": "攻其不備"
  },
  {
    "frequency": 122,
    "simplified": "失之东隅",
    "traditional": "失之東隅"
  },
  {
    "frequency": 121,
    "simplified": "前人栽树后人乘凉",
    "traditional": "前人栽樹後人乘涼"
  },
  {
    "frequency": 121,
    "simplified": "万寿无疆",
    "traditional": "萬壽無疆"
  },
  {
    "frequency": 121,
    "simplified": "看家本事",
    "traditional": "看家本事"
  },
  {
    "frequency": 121,
    "simplified": "有头无尾",
    "traditional": "有頭無尾"
  },
  {
    "frequency": 121,
    "simplified": "秋毫无犯",
    "traditional": "秋毫無犯"
  },
  {
    "frequency": 121,
    "simplified": "亲痛仇快",
    "traditional": "親痛仇快"
  },
  {
    "frequency": 121,
    "simplified": "未定之天",
    "traditional": "未定之天"
  },
  {
    "frequency": 121,
    "simplified": "无官一身轻",
    "traditional": "無官一身輕"
  },
  {
    "frequency": 121,
    "simplified": "知我罪我",
    "traditional": "知我罪我"
  },
  {
    "frequency": 121,
    "simplified": "一脉相通",
    "traditional": "一脈相通"
  },
  {
    "frequency": 121,
    "simplified": "千里之堤毁于蚁穴",
    "traditional": "千里之堤毀於蟻穴"
  },
  {
    "frequency": 121,
    "simplified": "春风满面",
    "traditional": "春風滿面"
  },
  {
    "frequency": 121,
    "simplified": "父债子还",
    "traditional": "父債子還"
  },
  {
    "frequency": 121,
    "simplified": "吉星高照",
    "traditional": "吉星高照"
  },
  {
    "frequency": 121,
    "simplified": "燎原之火",
    "traditional": "燎原之火"
  },
  {
    "frequency": 121,
    "simplified": "傲然屹立",
    "traditional": "傲然屹立"
  },
  {
    "frequency": 121,
    "simplified": "生拉硬扯",
    "traditional": "生拉硬扯"
  },
  {
    "frequency": 121,
    "simplified": "挨门挨户",
    "traditional": "挨門挨戶"
  },
  {
    "frequency": 120,
    "simplified": "扭亏增盈",
    "traditional": "扭虧增盈"
  },
  {
    "frequency": 120,
    "simplified": "树大根深",
    "traditional": "樹大根深"
  },
  {
    "frequency": 120,
    "simplified": "乳臭未干",
    "traditional": "乳臭未乾"
  },
  {
    "frequency": 120,
    "simplified": "天人之际",
    "traditional": "天人之際"
  },
  {
    "frequency": 120,
    "simplified": "汪洋恣肆",
    "traditional": "汪洋恣肆"
  },
  {
    "frequency": 120,
    "simplified": "反攻倒算",
    "traditional": "反攻倒算"
  },
  {
    "frequency": 120,
    "simplified": "心口不一",
    "traditional": "心口不一"
  },
  {
    "frequency": 120,
    "simplified": "未能免俗",
    "traditional": "未能免俗"
  },
  {
    "frequency": 120,
    "simplified": "乐而忘返",
    "traditional": "樂而忘返"
  },
  {
    "frequency": 119,
    "simplified": "故技重演",
    "traditional": "故技重演"
  },
  {
    "frequency": 119,
    "simplified": "天摇地动",
    "traditional": "天搖地動"
  },
  {
    "frequency": 119,
    "simplified": "人困马乏",
    "traditional": "人困馬乏"
  },
  {
    "frequency": 119,
    "simplified": "故作高深",
    "traditional": "故作高深"
  },
  {
    "frequency": 119,
    "simplified": "洞天福地",
    "traditional": "洞天福地"
  },
  {
    "frequency": 119,
    "simplified": "各有所好",
    "traditional": "各有所好"
  },
  {
    "frequency": 119,
    "simplified": "关门打狗",
    "traditional": "關門打狗"
  },
  {
    "frequency": 119,
    "simplified": "没大没小",
    "traditional": "沒大沒小"
  },
  {
    "frequency": 119,
    "simplified": "孝子贤孙",
    "traditional": "孝子賢孫"
  },
  {
    "frequency": 119,
    "simplified": "低眉顺眼",
    "traditional": "低眉順眼"
  },
  {
    "frequency": 119,
    "simplified": "失败是成功之母",
    "traditional": "失敗是成功之母"
  },
  {
    "frequency": 119,
    "simplified": "余波荡漾",
    "traditional": "餘波盪漾"
  },
  {
    "frequency": 119,
    "simplified": "有口难言",
    "traditional": "有口難言"
  },
  {
    "frequency": 119,
    "simplified": "徇情枉法",
    "traditional": "徇情枉法"
  },
  {
    "frequency": 119,
    "simplified": "斩尽杀绝",
    "traditional": "斬盡殺絕"
  },
  {
    "frequency": 118,
    "simplified": "之乎者也",
    "traditional": "之乎者也"
  },
  {
    "frequency": 118,
    "simplified": "天塌地陷",
    "traditional": "天塌地陷"
  },
  {
    "frequency": 118,
    "simplified": "鲜克有终",
    "traditional": "鮮克有終"
  },
  {
    "frequency": 118,
    "simplified": "痴男怨女",
    "traditional": "痴男怨女"
  },
  {
    "frequency": 118,
    "simplified": "非淡泊无以明志",
    "traditional": "非淡泊無以明志"
  },
  {
    "frequency": 118,
    "simplified": "血海深仇",
    "traditional": "血海深仇"
  },
  {
    "frequency": 118,
    "simplified": "山光水色",
    "traditional": "山光水色"
  },
  {
    "frequency": 118,
    "simplified": "杜绝后患",
    "traditional": "杜絕後患"
  },
  {
    "frequency": 118,
    "simplified": "事无大小",
    "traditional": "事無大小"
  },
  {
    "frequency": 118,
    "simplified": "一己之见",
    "traditional": "一己之見"
  },
  {
    "frequency": 118,
    "simplified": "士农工商",
    "traditional": "士農工商"
  },
  {
    "frequency": 118,
    "simplified": "协力同心",
    "traditional": "協力同心"
  },
  {
    "frequency": 118,
    "simplified": "焦灼不安",
    "traditional": "焦灼不安"
  },
  {
    "frequency": 118,
    "simplified": "笑里藏刀",
    "traditional": "笑裡藏刀"
  },
  {
    "frequency": 118,
    "simplified": "心惊胆寒",
    "traditional": "心驚膽寒"
  },
  {
    "frequency": 118,
    "simplified": "一言既出",
    "traditional": "一言既出"
  },
  {
    "frequency": 118,
    "simplified": "我为鱼肉",
    "traditional": "我為魚肉"
  },
  {
    "frequency": 118,
    "simplified": "谈情说爱",
    "traditional": "談情說愛"
  },
  {
    "frequency": 118,
    "simplified": "雁过留声",
    "traditional": "雁過留聲"
  },
  {
    "frequency": 117,
    "simplified": "财运亨通",
    "traditional": "財運亨通"
  },
  {
    "frequency": 117,
    "simplified": "名师出高徒",
    "traditional": "名師出高徒"
  },
  {
    "frequency": 117,
    "simplified": "兼善天下",
    "traditional": "兼善天下"
  },
  {
    "frequency": 117,
    "simplified": "必有勇夫",
    "traditional": "必有勇夫"
  },
  {
    "frequency": 117,
    "simplified": "谋事在人",
    "traditional": "謀事在人"
  },
  {
    "frequency": 117,
    "simplified": "恭贺新禧",
    "traditional": "恭賀新禧"
  },
  {
    "frequency": 117,
    "simplified": "神气十足",
    "traditional": "神氣十足"
  },
  {
    "frequency": 117,
    "simplified": "丧家之犬",
    "traditional": "喪家之犬"
  },
  {
    "frequency": 117,
    "simplified": "习焉不察",
    "traditional": "習焉不察"
  },
  {
    "frequency": 117,
    "simplified": "哭天喊地",
    "traditional": "哭天喊地"
  },
  {
    "frequency": 117,
    "simplified": "混世魔王",
    "traditional": "混世魔王"
  },
  {
    "frequency": 117,
    "simplified": "食不厌精",
    "traditional": "食不厭精"
  },
  {
    "frequency": 117,
    "simplified": "回天之力",
    "traditional": "回天之力"
  },
  {
    "frequency": 117,
    "simplified": "荟萃一堂",
    "traditional": "薈萃一堂"
  },
  {
    "frequency": 117,
    "simplified": "不成体统",
    "traditional": "不成體統"
  },
  {
    "frequency": 117,
    "simplified": "翩翩少年",
    "traditional": "翩翩少年"
  },
  {
    "frequency": 117,
    "simplified": "祸起萧墙",
    "traditional": "禍起蕭牆"
  },
  {
    "frequency": 117,
    "simplified": "鹏程万里",
    "traditional": "鵬程萬里"
  },
  {
    "frequency": 117,
    "simplified": "横扫千军",
    "traditional": "橫掃千軍"
  },
  {
    "frequency": 117,
    "simplified": "一寸光阴一寸金",
    "traditional": "一寸光陰一寸金"
  },
  {
    "frequency": 117,
    "simplified": "承欢膝下",
    "traditional": "承歡膝下"
  },
  {
    "frequency": 117,
    "simplified": "劳而无功",
    "traditional": "勞而無功"
  },
  {
    "frequency": 117,
    "simplified": "俯首帖耳",
    "traditional": "俯首帖耳"
  },
  {
    "frequency": 117,
    "simplified": "左拥右抱",
    "traditional": "左擁右抱"
  },
  {
    "frequency": 116,
    "simplified": "怒火攻心",
    "traditional": "怒火攻心"
  },
  {
    "frequency": 116,
    "simplified": "人烟稠密",
    "traditional": "人煙稠密"
  },
  {
    "frequency": 116,
    "simplified": "见所未见",
    "traditional": "見所未見"
  },
  {
    "frequency": 116,
    "simplified": "调和鼎鼐",
    "traditional": "調和鼎鼐"
  },
  {
    "frequency": 116,
    "simplified": "四体不勤",
    "traditional": "四體不勤"
  },
  {
    "frequency": 116,
    "simplified": "走马看花",
    "traditional": "走馬看花"
  },
  {
    "frequency": 116,
    "simplified": "馋涎欲滴",
    "traditional": "饞涎欲滴"
  },
  {
    "frequency": 116,
    "simplified": "各为其主",
    "traditional": "各為其主"
  },
  {
    "frequency": 116,
    "simplified": "仪态万方",
    "traditional": "儀態萬方"
  },
  {
    "frequency": 116,
    "simplified": "万事俱备只欠东风",
    "traditional": "萬事俱備只欠東風"
  },
  {
    "frequency": 116,
    "simplified": "草莽英雄",
    "traditional": "草莽英雄"
  },
  {
    "frequency": 116,
    "simplified": "寻花问柳",
    "traditional": "尋花問柳"
  },
  {
    "frequency": 115,
    "simplified": "以己度人",
    "traditional": "以己度人"
  },
  {
    "frequency": 115,
    "simplified": "敷衍搪塞",
    "traditional": "敷衍搪塞"
  },
  {
    "frequency": 115,
    "simplified": "亘古未有",
    "traditional": "亙古未有"
  },
  {
    "frequency": 115,
    "simplified": "恶语中伤",
    "traditional": "惡語中傷"
  },
  {
    "frequency": 115,
    "simplified": "直抒己见",
    "traditional": "直抒己見"
  },
  {
    "frequency": 115,
    "simplified": "不明事理",
    "traditional": "不明事理"
  },
  {
    "frequency": 115,
    "simplified": "公私兼顾",
    "traditional": "公私兼顧"
  },
  {
    "frequency": 115,
    "simplified": "雄姿英发",
    "traditional": "雄姿英發"
  },
  {
    "frequency": 115,
    "simplified": "暮鼓晨钟",
    "traditional": "暮鼓晨鐘"
  },
  {
    "frequency": 115,
    "simplified": "要言不烦",
    "traditional": "要言不煩"
  },
  {
    "frequency": 115,
    "simplified": "星星之火",
    "traditional": "星星之火"
  },
  {
    "frequency": 115,
    "simplified": "先忧后乐",
    "traditional": "先憂後樂"
  },
  {
    "frequency": 115,
    "simplified": "余音袅袅",
    "traditional": "餘音嫋嫋"
  },
  {
    "frequency": 114,
    "simplified": "衣来伸手饭来张口",
    "traditional": "衣來伸手飯來張口"
  },
  {
    "frequency": 114,
    "simplified": "趁人之危",
    "traditional": "趁人之危"
  },
  {
    "frequency": 114,
    "simplified": "从容自如",
    "traditional": "從容自如"
  },
  {
    "frequency": 114,
    "simplified": "卑鄙无耻",
    "traditional": "卑鄙無恥"
  },
  {
    "frequency": 114,
    "simplified": "明德惟馨",
    "traditional": "明德惟馨"
  },
  {
    "frequency": 114,
    "simplified": "春秋笔法",
    "traditional": "春秋筆法"
  },
  {
    "frequency": 114,
    "simplified": "花无百日红",
    "traditional": "花無百日紅"
  },
  {
    "frequency": 114,
    "simplified": "雍容大度",
    "traditional": "雍容大度"
  },
  {
    "frequency": 114,
    "simplified": "岁岁平安",
    "traditional": "歲歲平安"
  },
  {
    "frequency": 114,
    "simplified": "洞房花烛",
    "traditional": "洞房花燭"
  },
  {
    "frequency": 114,
    "simplified": "浮皮潦草",
    "traditional": "浮皮潦草"
  },
  {
    "frequency": 114,
    "simplified": "瞎子摸象",
    "traditional": "瞎子摸象"
  },
  {
    "frequency": 114,
    "simplified": "踽踽独行",
    "traditional": "踽踽獨行"
  },
  {
    "frequency": 114,
    "simplified": "赏心乐事",
    "traditional": "賞心樂事"
  },
  {
    "frequency": 114,
    "simplified": "碍手碍脚",
    "traditional": "礙手礙腳"
  },
  {
    "frequency": 114,
    "simplified": "无所不及",
    "traditional": "無所不及"
  },
  {
    "frequency": 114,
    "simplified": "靡不有初",
    "traditional": "靡不有初"
  },
  {
    "frequency": 114,
    "simplified": "疾言厉色",
    "traditional": "疾言厲色"
  },
  {
    "frequency": 114,
    "simplified": "防微虑远",
    "traditional": "防微慮遠"
  },
  {
    "frequency": 114,
    "simplified": "娓娓而谈",
    "traditional": "娓娓而談"
  },
  {
    "frequency": 113,
    "simplified": "毁于蚁穴",
    "traditional": "毀於蟻穴"
  },
  {
    "frequency": 113,
    "simplified": "丹凤朝阳",
    "traditional": "丹鳳朝陽"
  },
  {
    "frequency": 113,
    "simplified": "老马识途",
    "traditional": "老馬識途"
  },
  {
    "frequency": 113,
    "simplified": "英姿勃勃",
    "traditional": "英姿勃勃"
  },
  {
    "frequency": 113,
    "simplified": "人地生疏",
    "traditional": "人地生疏"
  },
  {
    "frequency": 113,
    "simplified": "三天打鱼",
    "traditional": "三天打魚"
  },
  {
    "frequency": 113,
    "simplified": "白费力气",
    "traditional": "白費力氣"
  },
  {
    "frequency": 113,
    "simplified": "创业维艰",
    "traditional": "創業維艱"
  },
  {
    "frequency": 113,
    "simplified": "诡谲多变",
    "traditional": "詭譎多變"
  },
  {
    "frequency": 113,
    "simplified": "只可意会不可言传",
    "traditional": "只可意會不可言傳"
  },
  {
    "frequency": 113,
    "simplified": "不死不活",
    "traditional": "不死不活"
  },
  {
    "frequency": 113,
    "simplified": "七窍流血",
    "traditional": "七竅流血"
  },
  {
    "frequency": 113,
    "simplified": "装傻充愣",
    "traditional": "裝傻充愣"
  },
  {
    "frequency": 112,
    "simplified": "好言好语",
    "traditional": "好言好語"
  },
  {
    "frequency": 112,
    "simplified": "这山望着那山高",
    "traditional": "這山望著那山高"
  },
  {
    "frequency": 112,
    "simplified": "七弯八拐",
    "traditional": "七彎八拐"
  },
  {
    "frequency": 112,
    "simplified": "裙带关系",
    "traditional": "裙帶關係"
  },
  {
    "frequency": 112,
    "simplified": "是非颠倒",
    "traditional": "是非顛倒"
  },
  {
    "frequency": 112,
    "simplified": "珠圆玉润",
    "traditional": "珠圓玉潤"
  },
  {
    "frequency": 112,
    "simplified": "大有起色",
    "traditional": "大有起色"
  },
  {
    "frequency": 112,
    "simplified": "判若云泥",
    "traditional": "判若雲泥"
  },
  {
    "frequency": 112,
    "simplified": "狗尾续貂",
    "traditional": "狗尾續貂"
  },
  {
    "frequency": 112,
    "simplified": "汗流满面",
    "traditional": "汗流滿面"
  },
  {
    "frequency": 112,
    "simplified": "迟疑不决",
    "traditional": "遲疑不決"
  },
  {
    "frequency": 112,
    "simplified": "三年五载",
    "traditional": "三年五載"
  },
  {
    "frequency": 112,
    "simplified": "雕龙画凤",
    "traditional": "雕龍畫鳳"
  },
  {
    "frequency": 112,
    "simplified": "新人新事",
    "traditional": "新人新事"
  },
  {
    "frequency": 112,
    "simplified": "城下之盟",
    "traditional": "城下之盟"
  },
  {
    "frequency": 112,
    "simplified": "年深日久",
    "traditional": "年深日久"
  },
  {
    "frequency": 111,
    "simplified": "高人一筹",
    "traditional": "高人一籌"
  },
  {
    "frequency": 111,
    "simplified": "借花献佛",
    "traditional": "借花獻佛"
  },
  {
    "frequency": 111,
    "simplified": "仁心仁术",
    "traditional": "仁心仁術"
  },
  {
    "frequency": 111,
    "simplified": "借古喻今",
    "traditional": "借古喻今"
  },
  {
    "frequency": 111,
    "simplified": "一无所得",
    "traditional": "一無所得"
  },
  {
    "frequency": 111,
    "simplified": "弃恶从善",
    "traditional": "棄惡從善"
  },
  {
    "frequency": 111,
    "simplified": "举国一致",
    "traditional": "舉國一致"
  },
  {
    "frequency": 111,
    "simplified": "饱学之士",
    "traditional": "飽學之士"
  },
  {
    "frequency": 111,
    "simplified": "付诸一炬",
    "traditional": "付諸一炬"
  },
  {
    "frequency": 111,
    "simplified": "金枝玉叶",
    "traditional": "金枝玉葉"
  },
  {
    "frequency": 111,
    "simplified": "用其所长",
    "traditional": "用其所長"
  },
  {
    "frequency": 111,
    "simplified": "摩肩擦踵",
    "traditional": "摩肩擦踵"
  },
  {
    "frequency": 111,
    "simplified": "日行千里",
    "traditional": "日行千里"
  },
  {
    "frequency": 110,
    "simplified": "下笔如有神",
    "traditional": "下筆如有神"
  },
  {
    "frequency": 110,
    "simplified": "三个臭皮匠",
    "traditional": "三個臭皮匠"
  },
  {
    "frequency": 110,
    "simplified": "动如脱兔",
    "traditional": "動如脫兔"
  },
  {
    "frequency": 110,
    "simplified": "便宜行事",
    "traditional": "便宜行事"
  },
  {
    "frequency": 110,
    "simplified": "不登大雅之堂",
    "traditional": "不登大雅之堂"
  },
  {
    "frequency": 110,
    "simplified": "行将就木",
    "traditional": "行將就木"
  },
  {
    "frequency": 110,
    "simplified": "坐怀不乱",
    "traditional": "坐懷不亂"
  },
  {
    "frequency": 110,
    "simplified": "翻手为云覆手为雨",
    "traditional": "翻手為雲覆手為雨"
  },
  {
    "frequency": 110,
    "simplified": "三人行必有我师",
    "traditional": "三人行必有我師"
  },
  {
    "frequency": 110,
    "simplified": "开山祖师",
    "traditional": "開山祖師"
  },
  {
    "frequency": 110,
    "simplified": "恶语伤人",
    "traditional": "惡語傷人"
  },
  {
    "frequency": 110,
    "simplified": "男婚女嫁",
    "traditional": "男婚女嫁"
  },
  {
    "frequency": 109,
    "simplified": "螳臂挡车",
    "traditional": "螳臂擋車"
  },
  {
    "frequency": 109,
    "simplified": "不可名状",
    "traditional": "不可名狀"
  },
  {
    "frequency": 109,
    "simplified": "阳关大道",
    "traditional": "陽關大道"
  },
  {
    "frequency": 109,
    "simplified": "言不及义",
    "traditional": "言不及義"
  },
  {
    "frequency": 109,
    "simplified": "逆我者亡",
    "traditional": "逆我者亡"
  },
  {
    "frequency": 109,
    "simplified": "礼贤下士",
    "traditional": "禮賢下士"
  },
  {
    "frequency": 109,
    "simplified": "分身无术",
    "traditional": "分身無術"
  },
  {
    "frequency": 109,
    "simplified": "脱缰之马",
    "traditional": "脫韁之馬"
  },
  {
    "frequency": 109,
    "simplified": "妖言惑众",
    "traditional": "妖言惑眾"
  },
  {
    "frequency": 109,
    "simplified": "三思后行",
    "traditional": "三思後行"
  },
  {
    "frequency": 109,
    "simplified": "默默无言",
    "traditional": "默默無言"
  },
  {
    "frequency": 109,
    "simplified": "太岁头上动土",
    "traditional": "太歲頭上動土"
  },
  {
    "frequency": 109,
    "simplified": "老大徒伤悲",
    "traditional": "老大徒傷悲"
  },
  {
    "frequency": 109,
    "simplified": "白面书生",
    "traditional": "白面書生"
  },
  {
    "frequency": 109,
    "simplified": "葬身鱼腹",
    "traditional": "葬身魚腹"
  },
  {
    "frequency": 109,
    "simplified": "不测风云",
    "traditional": "不測風雲"
  },
  {
    "frequency": 108,
    "simplified": "似笑非笑",
    "traditional": "似笑非笑"
  },
  {
    "frequency": 108,
    "simplified": "破格录用",
    "traditional": "破格錄用"
  },
  {
    "frequency": 108,
    "simplified": "损人害己",
    "traditional": "損人害己"
  },
  {
    "frequency": 108,
    "simplified": "心心相通",
    "traditional": "心心相通"
  },
  {
    "frequency": 108,
    "simplified": "恃才傲物",
    "traditional": "恃才傲物"
  },
  {
    "frequency": 108,
    "simplified": "知彼知己",
    "traditional": "知彼知己"
  },
  {
    "frequency": 108,
    "simplified": "大厦将倾",
    "traditional": "大廈將傾"
  },
  {
    "frequency": 108,
    "simplified": "不肖子孙",
    "traditional": "不肖子孫"
  },
  {
    "frequency": 108,
    "simplified": "声誉鹊起",
    "traditional": "聲譽鵲起"
  },
  {
    "frequency": 108,
    "simplified": "玄之又玄",
    "traditional": "玄之又玄"
  },
  {
    "frequency": 108,
    "simplified": "不可言喻",
    "traditional": "不可言喻"
  },
  {
    "frequency": 108,
    "simplified": "血债累累",
    "traditional": "血債累累"
  },
  {
    "frequency": 108,
    "simplified": "纵横天下",
    "traditional": "縱橫天下"
  },
  {
    "frequency": 108,
    "simplified": "金声玉振",
    "traditional": "金聲玉振"
  },
  {
    "frequency": 108,
    "simplified": "秉笔直书",
    "traditional": "秉筆直書"
  },
  {
    "frequency": 108,
    "simplified": "遗老遗少",
    "traditional": "遺老遺少"
  },
  {
    "frequency": 107,
    "simplified": "敬业乐群",
    "traditional": "敬業樂群"
  },
  {
    "frequency": 107,
    "simplified": "人面桃花",
    "traditional": "人面桃花"
  },
  {
    "frequency": 107,
    "simplified": "心比天高",
    "traditional": "心比天高"
  },
  {
    "frequency": 107,
    "simplified": "洋洋大观",
    "traditional": "洋洋大觀"
  },
  {
    "frequency": 107,
    "simplified": "琼浆玉液",
    "traditional": "瓊漿玉液"
  },
  {
    "frequency": 107,
    "simplified": "惟命是从",
    "traditional": "惟命是從"
  },
  {
    "frequency": 107,
    "simplified": "无所不至",
    "traditional": "無所不至"
  },
  {
    "frequency": 107,
    "simplified": "气息奄奄",
    "traditional": "氣息奄奄"
  },
  {
    "frequency": 107,
    "simplified": "东风压倒西风",
    "traditional": "東風壓倒西風"
  },
  {
    "frequency": 107,
    "simplified": "以此类推",
    "traditional": "以此類推"
  },
  {
    "frequency": 107,
    "simplified": "逝者如斯",
    "traditional": "逝者如斯"
  },
  {
    "frequency": 107,
    "simplified": "不尴不尬",
    "traditional": "不尷不尬"
  },
  {
    "frequency": 107,
    "simplified": "吹糠见米",
    "traditional": "吹糠見米"
  },
  {
    "frequency": 106,
    "simplified": "迟暮之年",
    "traditional": "遲暮之年"
  },
  {
    "frequency": 106,
    "simplified": "明知故问",
    "traditional": "明知故問"
  },
  {
    "frequency": 106,
    "simplified": "一望无边",
    "traditional": "一望無邊"
  },
  {
    "frequency": 106,
    "simplified": "扼腕长叹",
    "traditional": "扼腕長嘆"
  },
  {
    "frequency": 106,
    "simplified": "良莠不分",
    "traditional": "良莠不分"
  },
  {
    "frequency": 106,
    "simplified": "文人相轻",
    "traditional": "文人相輕"
  },
  {
    "frequency": 106,
    "simplified": "曾经沧海",
    "traditional": "曾經滄海"
  },
  {
    "frequency": 106,
    "simplified": "铁树开花",
    "traditional": "鐵樹開花"
  },
  {
    "frequency": 106,
    "simplified": "烈火烹油",
    "traditional": "烈火烹油"
  },
  {
    "frequency": 106,
    "simplified": "浓妆淡抹",
    "traditional": "濃妝淡抹"
  },
  {
    "frequency": 106,
    "simplified": "别有滋味",
    "traditional": "別有滋味"
  },
  {
    "frequency": 106,
    "simplified": "衣香鬓影",
    "traditional": "衣香鬢影"
  },
  {
    "frequency": 106,
    "simplified": "下逐客令",
    "traditional": "下逐客令"
  },
  {
    "frequency": 106,
    "simplified": "大慈大悲",
    "traditional": "大慈大悲"
  },
  {
    "frequency": 106,
    "simplified": "门户洞开",
    "traditional": "門戶洞開"
  },
  {
    "frequency": 106,
    "simplified": "兴利除害",
    "traditional": "興利除害"
  },
  {
    "frequency": 106,
    "simplified": "熔于一炉",
    "traditional": "熔於一爐"
  },
  {
    "frequency": 106,
    "simplified": "以其人之道",
    "traditional": "以其人之道"
  },
  {
    "frequency": 106,
    "simplified": "当耳边风",
    "traditional": "當耳邊風"
  },
  {
    "frequency": 106,
    "simplified": "情深似海",
    "traditional": "情深似海"
  },
  {
    "frequency": 106,
    "simplified": "克己复礼",
    "traditional": "克己復禮"
  },
  {
    "frequency": 106,
    "simplified": "须发皆白",
    "traditional": "鬚髮皆白"
  },
  {
    "frequency": 106,
    "simplified": "泄露天机",
    "traditional": "洩露天機"
  },
  {
    "frequency": 105,
    "simplified": "毁家纾难",
    "traditional": "毀家紓難"
  },
  {
    "frequency": 105,
    "simplified": "心如死灰",
    "traditional": "心如死灰"
  },
  {
    "frequency": 105,
    "simplified": "若有所悟",
    "traditional": "若有所悟"
  },
  {
    "frequency": 105,
    "simplified": "不敢问津",
    "traditional": "不敢問津"
  },
  {
    "frequency": 105,
    "simplified": "心醉神迷",
    "traditional": "心醉神迷"
  },
  {
    "frequency": 105,
    "simplified": "大权旁落",
    "traditional": "大權旁落"
  },
  {
    "frequency": 105,
    "simplified": "情人眼里出西施",
    "traditional": "情人眼裡出西施"
  },
  {
    "frequency": 105,
    "simplified": "正正经经",
    "traditional": "正正經經"
  },
  {
    "frequency": 105,
    "simplified": "竭尽心力",
    "traditional": "竭盡心力"
  },
  {
    "frequency": 105,
    "simplified": "眼不见心不烦",
    "traditional": "眼不見心不煩"
  },
  {
    "frequency": 105,
    "simplified": "里通外国",
    "traditional": "裡通外國"
  },
  {
    "frequency": 105,
    "simplified": "对天发誓",
    "traditional": "對天發誓"
  },
  {
    "frequency": 105,
    "simplified": "慌作一团",
    "traditional": "慌作一團"
  },
  {
    "frequency": 105,
    "simplified": "一无所成",
    "traditional": "一無所成"
  },
  {
    "frequency": 105,
    "simplified": "积非成是",
    "traditional": "積非成是"
  },
  {
    "frequency": 105,
    "simplified": "一点半点",
    "traditional": "一點半點"
  },
  {
    "frequency": 104,
    "simplified": "饮食男女",
    "traditional": "飲食男女"
  },
  {
    "frequency": 104,
    "simplified": "能者多劳",
    "traditional": "能者多勞"
  },
  {
    "frequency": 104,
    "simplified": "翻手为云",
    "traditional": "翻手為雲"
  },
  {
    "frequency": 104,
    "simplified": "打破沙锅问到底",
    "traditional": "打破沙鍋問到底"
  },
  {
    "frequency": 104,
    "simplified": "重温旧梦",
    "traditional": "重溫舊夢"
  },
  {
    "frequency": 104,
    "simplified": "惊诧莫名",
    "traditional": "驚詫莫名"
  },
  {
    "frequency": 104,
    "simplified": "虎落平阳",
    "traditional": "虎落平陽"
  },
  {
    "frequency": 104,
    "simplified": "磨嘴皮子",
    "traditional": "磨嘴皮子"
  },
  {
    "frequency": 104,
    "simplified": "当耳旁风",
    "traditional": "當耳旁風"
  },
  {
    "frequency": 104,
    "simplified": "浓荫蔽日",
    "traditional": "濃蔭蔽日"
  },
  {
    "frequency": 104,
    "simplified": "嫁鸡随鸡",
    "traditional": "嫁雞隨雞"
  },
  {
    "frequency": 104,
    "simplified": "食古不化",
    "traditional": "食古不化"
  },
  {
    "frequency": 104,
    "simplified": "仰人鼻息",
    "traditional": "仰人鼻息"
  },
  {
    "frequency": 104,
    "simplified": "干打雷不下雨",
    "traditional": "乾打雷不下雨"
  },
  {
    "frequency": 104,
    "simplified": "求大同存小异",
    "traditional": "求大同存小異"
  },
  {
    "frequency": 104,
    "simplified": "福星高照",
    "traditional": "福星高照"
  },
  {
    "frequency": 104,
    "simplified": "皓首穷经",
    "traditional": "皓首窮經"
  },
  {
    "frequency": 104,
    "simplified": "此伏彼起",
    "traditional": "此伏彼起"
  },
  {
    "frequency": 104,
    "simplified": "喜怒不形于色",
    "traditional": "喜怒不形於色"
  },
  {
    "frequency": 103,
    "simplified": "儿行千里母担忧",
    "traditional": "兒行千里母擔憂"
  },
  {
    "frequency": 103,
    "simplified": "直捣黄龙",
    "traditional": "直搗黃龍"
  },
  {
    "frequency": 103,
    "simplified": "若要人不知",
    "traditional": "若要人不知"
  },
  {
    "frequency": 103,
    "simplified": "绿林好汉",
    "traditional": "綠林好漢"
  },
  {
    "frequency": 103,
    "simplified": "寂寂无闻",
    "traditional": "寂寂無聞"
  },
  {
    "frequency": 103,
    "simplified": "神色自若",
    "traditional": "神色自若"
  },
  {
    "frequency": 103,
    "simplified": "荒诞无稽",
    "traditional": "荒誕無稽"
  },
  {
    "frequency": 103,
    "simplified": "巨细无遗",
    "traditional": "鉅細無遺"
  },
  {
    "frequency": 103,
    "simplified": "晓以大义",
    "traditional": "曉以大義"
  },
  {
    "frequency": 103,
    "simplified": "五味俱全",
    "traditional": "五味俱全"
  },
  {
    "frequency": 103,
    "simplified": "语不惊人",
    "traditional": "語不驚人"
  },
  {
    "frequency": 103,
    "simplified": "良禽择木",
    "traditional": "良禽擇木"
  },
  {
    "frequency": 103,
    "simplified": "人非草木",
    "traditional": "人非草木"
  },
  {
    "frequency": 102,
    "simplified": "靠山吃山靠水吃水",
    "traditional": "靠山吃山靠水吃水"
  },
  {
    "frequency": 102,
    "simplified": "无可奈何花落去",
    "traditional": "無可奈何花落去"
  },
  {
    "frequency": 102,
    "simplified": "巴山夜雨",
    "traditional": "巴山夜雨"
  },
  {
    "frequency": 102,
    "simplified": "姜太公钓鱼",
    "traditional": "姜太公釣魚"
  },
  {
    "frequency": 102,
    "simplified": "举止大方",
    "traditional": "舉止大方"
  },
  {
    "frequency": 102,
    "simplified": "酒池肉林",
    "traditional": "酒池肉林"
  },
  {
    "frequency": 102,
    "simplified": "还我河山",
    "traditional": "還我河山"
  },
  {
    "frequency": 102,
    "simplified": "求人不如求己",
    "traditional": "求人不如求己"
  },
  {
    "frequency": 102,
    "simplified": "生吞活剥",
    "traditional": "生吞活剝"
  },
  {
    "frequency": 102,
    "simplified": "日上三竿",
    "traditional": "日上三竿"
  },
  {
    "frequency": 102,
    "simplified": "以身许国",
    "traditional": "以身許國"
  },
  {
    "frequency": 102,
    "simplified": "抱薪救火",
    "traditional": "抱薪救火"
  },
  {
    "frequency": 102,
    "simplified": "前俯后仰",
    "traditional": "前俯後仰"
  },
  {
    "frequency": 102,
    "simplified": "小国寡民",
    "traditional": "小國寡民"
  },
  {
    "frequency": 102,
    "simplified": "连中三元",
    "traditional": "連中三元"
  },
  {
    "frequency": 102,
    "simplified": "黄发垂髫",
    "traditional": "黃髮垂髫"
  },
  {
    "frequency": 102,
    "simplified": "东风浩荡",
    "traditional": "東風浩蕩"
  },
  {
    "frequency": 102,
    "simplified": "吹皱一池春水",
    "traditional": "吹皺一池春水"
  },
  {
    "frequency": 102,
    "simplified": "长歌当哭",
    "traditional": "長歌當哭"
  },
  {
    "frequency": 101,
    "simplified": "神乎其技",
    "traditional": "神乎其技"
  },
  {
    "frequency": 101,
    "simplified": "顺我者昌",
    "traditional": "順我者昌"
  },
  {
    "frequency": 101,
    "simplified": "长江天堑",
    "traditional": "長江天塹"
  },
  {
    "frequency": 101,
    "simplified": "杳无踪迹",
    "traditional": "杳無蹤跡"
  },
  {
    "frequency": 101,
    "simplified": "人为刀俎",
    "traditional": "人為刀俎"
  },
  {
    "frequency": 101,
    "simplified": "晨光熹微",
    "traditional": "晨光熹微"
  },
  {
    "frequency": 101,
    "simplified": "圣殿骑士",
    "traditional": "聖殿騎士"
  },
  {
    "frequency": 101,
    "simplified": "令人喷饭",
    "traditional": "令人噴飯"
  },
  {
    "frequency": 101,
    "simplified": "棋高一着",
    "traditional": "棋高一著"
  },
  {
    "frequency": 101,
    "simplified": "文武之道",
    "traditional": "文武之道"
  },
  {
    "frequency": 101,
    "simplified": "文治武功",
    "traditional": "文治武功"
  },
  {
    "frequency": 101,
    "simplified": "气数已尽",
    "traditional": "氣數已盡"
  },
  {
    "frequency": 101,
    "simplified": "青面獠牙",
    "traditional": "青面獠牙"
  },
  {
    "frequency": 101,
    "simplified": "呆头呆脑",
    "traditional": "呆頭呆腦"
  },
  {
    "frequency": 101,
    "simplified": "修桥补路",
    "traditional": "修橋補路"
  },
  {
    "frequency": 101,
    "simplified": "杀身成仁",
    "traditional": "殺身成仁"
  },
  {
    "frequency": 101,
    "simplified": "食不知味",
    "traditional": "食不知味"
  },
  {
    "frequency": 101,
    "simplified": "甘心情愿",
    "traditional": "甘心情願"
  },
  {
    "frequency": 101,
    "simplified": "一人做事一人当",
    "traditional": "一人做事一人當"
  },
  {
    "frequency": 101,
    "simplified": "罢黜百家",
    "traditional": "罷黜百家"
  },
  {
    "frequency": 100,
    "simplified": "朝朝暮暮",
    "traditional": "朝朝暮暮"
  },
  {
    "frequency": 100,
    "simplified": "明心见性",
    "traditional": "明心見性"
  },
  {
    "frequency": 100,
    "simplified": "好色之徒",
    "traditional": "好色之徒"
  },
  {
    "frequency": 100,
    "simplified": "墙里开花墙外香",
    "traditional": "牆裡開花牆外香"
  },
  {
    "frequency": 100,
    "simplified": "冤有头债有主",
    "traditional": "冤有頭債有主"
  },
  {
    "frequency": 100,
    "simplified": "寻根究底",
    "traditional": "尋根究底"
  },
  {
    "frequency": 100,
    "simplified": "冥顽不灵",
    "traditional": "冥頑不靈"
  },
  {
    "frequency": 100,
    "simplified": "博闻强记",
    "traditional": "博聞強記"
  },
  {
    "frequency": 100,
    "simplified": "一往直前",
    "traditional": "一往直前"
  },
  {
    "frequency": 100,
    "simplified": "猖獗一时",
    "traditional": "猖獗一時"
  },
  {
    "frequency": 100,
    "simplified": "取其精华去其糟粕",
    "traditional": "取其精華去其糟粕"
  },
  {
    "frequency": 100,
    "simplified": "自高自大",
    "traditional": "自高自大"
  },
  {
    "frequency": 99,
    "simplified": "船坚炮利",
    "traditional": "船堅炮利"
  },
  {
    "frequency": 99,
    "simplified": "嘉言懿行",
    "traditional": "嘉言懿行"
  },
  {
    "frequency": 99,
    "simplified": "轻徭薄赋",
    "traditional": "輕徭薄賦"
  },
  {
    "frequency": 99,
    "simplified": "明眸皓齿",
    "traditional": "明眸皓齒"
  },
  {
    "frequency": 99,
    "simplified": "兴味索然",
    "traditional": "興味索然"
  },
  {
    "frequency": 99,
    "simplified": "喷云吐雾",
    "traditional": "噴雲吐霧"
  },
  {
    "frequency": 99,
    "simplified": "海晏河清",
    "traditional": "海晏河清"
  },
  {
    "frequency": 99,
    "simplified": "人不可貌相",
    "traditional": "人不可貌相"
  },
  {
    "frequency": 99,
    "simplified": "山水相连",
    "traditional": "山水相連"
  },
  {
    "frequency": 99,
    "simplified": "一鳞半爪",
    "traditional": "一鱗半爪"
  },
  {
    "frequency": 99,
    "simplified": "道不同不相为谋",
    "traditional": "道不同不相為謀"
  },
  {
    "frequency": 99,
    "simplified": "儿女亲家",
    "traditional": "兒女親家"
  },
  {
    "frequency": 99,
    "simplified": "抱头大哭",
    "traditional": "抱頭大哭"
  },
  {
    "frequency": 98,
    "simplified": "不教而诛",
    "traditional": "不教而誅"
  },
  {
    "frequency": 98,
    "simplified": "干柴烈火",
    "traditional": "乾柴烈火"
  },
  {
    "frequency": 98,
    "simplified": "天高地厚",
    "traditional": "天高地厚"
  },
  {
    "frequency": 98,
    "simplified": "千里之堤溃于蚁穴",
    "traditional": "千里之堤潰於蟻穴"
  },
  {
    "frequency": 98,
    "simplified": "鲍鱼之肆",
    "traditional": "鮑魚之肆"
  },
  {
    "frequency": 98,
    "simplified": "悬梁刺股",
    "traditional": "懸梁刺股"
  },
  {
    "frequency": 98,
    "simplified": "齐齐整整",
    "traditional": "齊齊整整"
  },
  {
    "frequency": 98,
    "simplified": "遐迩闻名",
    "traditional": "遐邇聞名"
  },
  {
    "frequency": 98,
    "simplified": "清风明月",
    "traditional": "清風明月"
  },
  {
    "frequency": 98,
    "simplified": "大发慈悲",
    "traditional": "大發慈悲"
  },
  {
    "frequency": 98,
    "simplified": "内圣外王",
    "traditional": "內聖外王"
  },
  {
    "frequency": 98,
    "simplified": "兔死狐悲",
    "traditional": "兔死狐悲"
  },
  {
    "frequency": 97,
    "simplified": "龙生九子",
    "traditional": "龍生九子"
  },
  {
    "frequency": 97,
    "simplified": "天诛地灭",
    "traditional": "天誅地滅"
  },
  {
    "frequency": 97,
    "simplified": "多费口舌",
    "traditional": "多費口舌"
  },
  {
    "frequency": 97,
    "simplified": "秣马厉兵",
    "traditional": "秣馬厲兵"
  },
  {
    "frequency": 97,
    "simplified": "遗患无穷",
    "traditional": "遺患無窮"
  },
  {
    "frequency": 97,
    "simplified": "岁月蹉跎",
    "traditional": "歲月蹉跎"
  },
  {
    "frequency": 97,
    "simplified": "引车卖浆",
    "traditional": "引車賣漿"
  },
  {
    "frequency": 97,
    "simplified": "刀子嘴豆腐心",
    "traditional": "刀子嘴豆腐心"
  },
  {
    "frequency": 97,
    "simplified": "铸成大错",
    "traditional": "鑄成大錯"
  },
  {
    "frequency": 97,
    "simplified": "姑妄听之",
    "traditional": "姑妄聽之"
  },
  {
    "frequency": 97,
    "simplified": "亦可覆舟",
    "traditional": "亦可覆舟"
  },
  {
    "frequency": 97,
    "simplified": "不得善终",
    "traditional": "不得善終"
  },
  {
    "frequency": 97,
    "simplified": "和衣而卧",
    "traditional": "和衣而臥"
  },
  {
    "frequency": 97,
    "simplified": "屁滚尿流",
    "traditional": "屁滾尿流"
  },
  {
    "frequency": 96,
    "simplified": "一人得道鸡犬升天",
    "traditional": "一人得道雞犬升天"
  },
  {
    "frequency": 96,
    "simplified": "富贵荣华",
    "traditional": "富貴榮華"
  },
  {
    "frequency": 96,
    "simplified": "修心养性",
    "traditional": "修心養性"
  },
  {
    "frequency": 96,
    "simplified": "此风不可长",
    "traditional": "此風不可長"
  },
  {
    "frequency": 96,
    "simplified": "不仁不义",
    "traditional": "不仁不義"
  },
  {
    "frequency": 96,
    "simplified": "仪态万千",
    "traditional": "儀態萬千"
  },
  {
    "frequency": 96,
    "simplified": "胆小如鼠",
    "traditional": "膽小如鼠"
  },
  {
    "frequency": 96,
    "simplified": "沉心静气",
    "traditional": "沉心靜氣"
  },
  {
    "frequency": 96,
    "simplified": "风流才子",
    "traditional": "風流才子"
  },
  {
    "frequency": 96,
    "simplified": "无所用心",
    "traditional": "無所用心"
  },
  {
    "frequency": 96,
    "simplified": "亲者痛仇者快",
    "traditional": "親者痛仇者快"
  },
  {
    "frequency": 96,
    "simplified": "百无一用",
    "traditional": "百無一用"
  },
  {
    "frequency": 96,
    "simplified": "百花争妍",
    "traditional": "百花爭妍"
  },
  {
    "frequency": 96,
    "simplified": "前怕狼后怕虎",
    "traditional": "前怕狼後怕虎"
  },
  {
    "frequency": 95,
    "simplified": "寸步难移",
    "traditional": "寸步難移"
  },
  {
    "frequency": 95,
    "simplified": "无人之境",
    "traditional": "無人之境"
  },
  {
    "frequency": 95,
    "simplified": "养痈成患",
    "traditional": "養癰成患"
  },
  {
    "frequency": 95,
    "simplified": "击楫中流",
    "traditional": "擊楫中流"
  },
  {
    "frequency": 95,
    "simplified": "老有所终",
    "traditional": "老有所終"
  },
  {
    "frequency": 95,
    "simplified": "不怕一万就怕万一",
    "traditional": "不怕一萬就怕萬一"
  },
  {
    "frequency": 95,
    "simplified": "五福临门",
    "traditional": "五福臨門"
  },
  {
    "frequency": 95,
    "simplified": "知恩报恩",
    "traditional": "知恩報恩"
  },
  {
    "frequency": 95,
    "simplified": "盲人骑瞎马",
    "traditional": "盲人騎瞎馬"
  },
  {
    "frequency": 95,
    "simplified": "人多嘴杂",
    "traditional": "人多嘴雜"
  },
  {
    "frequency": 95,
    "simplified": "风清气爽",
    "traditional": "風清氣爽"
  },
  {
    "frequency": 95,
    "simplified": "天下无难事",
    "traditional": "天下無難事"
  },
  {
    "frequency": 95,
    "simplified": "惊魂不定",
    "traditional": "驚魂不定"
  },
  {
    "frequency": 94,
    "simplified": "沉鱼落雁",
    "traditional": "沉魚落雁"
  },
  {
    "frequency": 94,
    "simplified": "铭心刻骨",
    "traditional": "銘心刻骨"
  },
  {
    "frequency": 94,
    "simplified": "帝王将相",
    "traditional": "帝王將相"
  },
  {
    "frequency": 94,
    "simplified": "虚应故事",
    "traditional": "虛應故事"
  },
  {
    "frequency": 94,
    "simplified": "学海无涯",
    "traditional": "學海無涯"
  },
  {
    "frequency": 94,
    "simplified": "饿殍遍野",
    "traditional": "餓殍遍野"
  },
  {
    "frequency": 94,
    "simplified": "雏鹰展翅",
    "traditional": "雛鷹展翅"
  },
  {
    "frequency": 94,
    "simplified": "图穷匕见",
    "traditional": "圖窮匕見"
  },
  {
    "frequency": 94,
    "simplified": "狼狈逃窜",
    "traditional": "狼狽逃竄"
  },
  {
    "frequency": 94,
    "simplified": "黑云压城城欲摧",
    "traditional": "黑雲壓城城欲摧"
  },
  {
    "frequency": 94,
    "simplified": "无名小辈",
    "traditional": "無名小輩"
  },
  {
    "frequency": 94,
    "simplified": "光荣岁月",
    "traditional": "光榮歲月"
  },
  {
    "frequency": 94,
    "simplified": "闲言闲语",
    "traditional": "閒言閒語"
  },
  {
    "frequency": 94,
    "simplified": "秉公办理",
    "traditional": "秉公辦理"
  },
  {
    "frequency": 94,
    "simplified": "月明星稀",
    "traditional": "月明星稀"
  },
  {
    "frequency": 94,
    "simplified": "多谋善断",
    "traditional": "多謀善斷"
  },
  {
    "frequency": 94,
    "simplified": "杀人不见血",
    "traditional": "殺人不見血"
  },
  {
    "frequency": 94,
    "simplified": "儿孙自有儿孙福",
    "traditional": "兒孫自有兒孫福"
  },
  {
    "frequency": 94,
    "simplified": "刨根究底",
    "traditional": "刨根究底"
  },
  {
    "frequency": 94,
    "simplified": "一望而知",
    "traditional": "一望而知"
  },
  {
    "frequency": 94,
    "simplified": "木牛流马",
    "traditional": "木牛流馬"
  },
  {
    "frequency": 94,
    "simplified": "一时之选",
    "traditional": "一時之選"
  },
  {
    "frequency": 93,
    "simplified": "殷忧启圣",
    "traditional": "殷憂啟聖"
  },
  {
    "frequency": 93,
    "simplified": "血性男儿",
    "traditional": "血性男兒"
  },
  {
    "frequency": 93,
    "simplified": "气味相投",
    "traditional": "氣味相投"
  },
  {
    "frequency": 93,
    "simplified": "闭月羞花",
    "traditional": "閉月羞花"
  },
  {
    "frequency": 93,
    "simplified": "胯下之辱",
    "traditional": "胯下之辱"
  },
  {
    "frequency": 93,
    "simplified": "含笑九泉",
    "traditional": "含笑九泉"
  },
  {
    "frequency": 93,
    "simplified": "惊喜交加",
    "traditional": "驚喜交加"
  },
  {
    "frequency": 93,
    "simplified": "永矢弗谖",
    "traditional": "永矢弗諼"
  },
  {
    "frequency": 93,
    "simplified": "物换星移",
    "traditional": "物換星移"
  },
  {
    "frequency": 93,
    "simplified": "安邦定国",
    "traditional": "安邦定國"
  },
  {
    "frequency": 93,
    "simplified": "喊冤叫屈",
    "traditional": "喊冤叫屈"
  },
  {
    "frequency": 93,
    "simplified": "宁为玉碎",
    "traditional": "寧為玉碎"
  },
  {
    "frequency": 93,
    "simplified": "势如水火",
    "traditional": "勢如水火"
  },
  {
    "frequency": 93,
    "simplified": "积谷防饥",
    "traditional": "積穀防饑"
  },
  {
    "frequency": 92,
    "simplified": "愁云惨淡",
    "traditional": "愁雲慘淡"
  },
  {
    "frequency": 92,
    "simplified": "丹书铁券",
    "traditional": "丹書鐵券"
  },
  {
    "frequency": 92,
    "simplified": "料事如神",
    "traditional": "料事如神"
  },
  {
    "frequency": 92,
    "simplified": "同气连枝",
    "traditional": "同氣連枝"
  },
  {
    "frequency": 92,
    "simplified": "若有所失",
    "traditional": "若有所失"
  },
  {
    "frequency": 92,
    "simplified": "其言也善",
    "traditional": "其言也善"
  },
  {
    "frequency": 92,
    "simplified": "没齿难忘",
    "traditional": "沒齒難忘"
  },
  {
    "frequency": 92,
    "simplified": "千里送鹅毛",
    "traditional": "千里送鵝毛"
  },
  {
    "frequency": 92,
    "simplified": "饱食终日",
    "traditional": "飽食終日"
  },
  {
    "frequency": 92,
    "simplified": "无关宏旨",
    "traditional": "無關宏旨"
  },
  {
    "frequency": 92,
    "simplified": "杯盘狼藉",
    "traditional": "杯盤狼藉"
  },
  {
    "frequency": 92,
    "simplified": "早知今日何必当初",
    "traditional": "早知今日何必當初"
  },
  {
    "frequency": 92,
    "simplified": "杞人之忧",
    "traditional": "杞人之憂"
  },
  {
    "frequency": 92,
    "simplified": "识文断字",
    "traditional": "識文斷字"
  },
  {
    "frequency": 92,
    "simplified": "三山五岳",
    "traditional": "三山五嶽"
  },
  {
    "frequency": 92,
    "simplified": "人才难得",
    "traditional": "人才難得"
  },
  {
    "frequency": 92,
    "simplified": "讲经说法",
    "traditional": "講經說法"
  },
  {
    "frequency": 92,
    "simplified": "耳根清净",
    "traditional": "耳根清淨"
  },
  {
    "frequency": 91,
    "simplified": "玉树琼枝",
    "traditional": "玉樹瓊枝"
  },
  {
    "frequency": 91,
    "simplified": "切齿痛恨",
    "traditional": "切齒痛恨"
  },
  {
    "frequency": 91,
    "simplified": "子丑寅卯",
    "traditional": "子醜寅卯"
  },
  {
    "frequency": 91,
    "simplified": "客随主便",
    "traditional": "客隨主便"
  },
  {
    "frequency": 91,
    "simplified": "参差错落",
    "traditional": "參差錯落"
  },
  {
    "frequency": 91,
    "simplified": "钩心斗角",
    "traditional": "鉤心鬥角"
  },
  {
    "frequency": 91,
    "simplified": "不知就里",
    "traditional": "不知就裡"
  },
  {
    "frequency": 91,
    "simplified": "添枝加叶",
    "traditional": "添枝加葉"
  },
  {
    "frequency": 91,
    "simplified": "天外飞来",
    "traditional": "天外飛來"
  },
  {
    "frequency": 91,
    "simplified": "奇技淫巧",
    "traditional": "奇技淫巧"
  },
  {
    "frequency": 91,
    "simplified": "倒果为因",
    "traditional": "倒果為因"
  },
  {
    "frequency": 91,
    "simplified": "砍瓜切菜",
    "traditional": "砍瓜切菜"
  },
  {
    "frequency": 91,
    "simplified": "挟天子以令诸侯",
    "traditional": "挾天子以令諸侯"
  },
  {
    "frequency": 91,
    "simplified": "文人学士",
    "traditional": "文人學士"
  },
  {
    "frequency": 90,
    "simplified": "惺惺作态",
    "traditional": "惺惺作態"
  },
  {
    "frequency": 90,
    "simplified": "泰山北斗",
    "traditional": "泰山北斗"
  },
  {
    "frequency": 90,
    "simplified": "士为知己者死",
    "traditional": "士為知己者死"
  },
  {
    "frequency": 90,
    "simplified": "改恶从善",
    "traditional": "改惡從善"
  },
  {
    "frequency": 90,
    "simplified": "仗义疏财",
    "traditional": "仗義疏財"
  },
  {
    "frequency": 90,
    "simplified": "转弯抹角",
    "traditional": "轉彎抹角"
  },
  {
    "frequency": 90,
    "simplified": "怒火冲天",
    "traditional": "怒火沖天"
  },
  {
    "frequency": 90,
    "simplified": "不为五斗米折腰",
    "traditional": "不為五斗米折腰"
  },
  {
    "frequency": 90,
    "simplified": "水能载舟亦能覆舟",
    "traditional": "水能載舟亦能覆舟"
  },
  {
    "frequency": 90,
    "simplified": "有约在先",
    "traditional": "有約在先"
  },
  {
    "frequency": 90,
    "simplified": "跃马扬鞭",
    "traditional": "躍馬揚鞭"
  },
  {
    "frequency": 89,
    "simplified": "举步艰难",
    "traditional": "舉步艱難"
  },
  {
    "frequency": 89,
    "simplified": "长夜漫漫",
    "traditional": "長夜漫漫"
  },
  {
    "frequency": 89,
    "simplified": "贪多嚼不烂",
    "traditional": "貪多嚼不爛"
  },
  {
    "frequency": 89,
    "simplified": "威信扫地",
    "traditional": "威信掃地"
  },
  {
    "frequency": 89,
    "simplified": "曲里拐弯",
    "traditional": "曲裡拐彎"
  },
  {
    "frequency": 89,
    "simplified": "夸父逐日",
    "traditional": "夸父逐日"
  },
  {
    "frequency": 89,
    "simplified": "踏破铁鞋",
    "traditional": "踏破鐵鞋"
  },
  {
    "frequency": 89,
    "simplified": "舍身求法",
    "traditional": "捨身求法"
  },
  {
    "frequency": 89,
    "simplified": "一块石头落地",
    "traditional": "一塊石頭落地"
  },
  {
    "frequency": 89,
    "simplified": "专门利人",
    "traditional": "專門利人"
  },
  {
    "frequency": 89,
    "simplified": "枉费心机",
    "traditional": "枉費心機"
  },
  {
    "frequency": 89,
    "simplified": "眼观六路耳听八方",
    "traditional": "眼觀六路耳聽八方"
  },
  {
    "frequency": 89,
    "simplified": "薄情寡义",
    "traditional": "薄情寡義"
  },
  {
    "frequency": 89,
    "simplified": "遥遥相对",
    "traditional": "遙遙相對"
  },
  {
    "frequency": 89,
    "simplified": "盖世英雄",
    "traditional": "蓋世英雄"
  },
  {
    "frequency": 89,
    "simplified": "得陇望蜀",
    "traditional": "得隴望蜀"
  },
  {
    "frequency": 89,
    "simplified": "食不下咽",
    "traditional": "食不下咽"
  },
  {
    "frequency": 89,
    "simplified": "江山易改",
    "traditional": "江山易改"
  },
  {
    "frequency": 89,
    "simplified": "利害攸关",
    "traditional": "利害攸關"
  },
  {
    "frequency": 89,
    "simplified": "没头苍蝇",
    "traditional": "沒頭蒼蠅"
  },
  {
    "frequency": 89,
    "simplified": "谈笑有鸿儒",
    "traditional": "談笑有鴻儒"
  },
  {
    "frequency": 89,
    "simplified": "舍命救人",
    "traditional": "捨命救人"
  },
  {
    "frequency": 88,
    "simplified": "扶危救困",
    "traditional": "扶危救困"
  },
  {
    "frequency": 88,
    "simplified": "刀枪剑戟",
    "traditional": "刀槍劍戟"
  },
  {
    "frequency": 88,
    "simplified": "大头小尾",
    "traditional": "大頭小尾"
  },
  {
    "frequency": 88,
    "simplified": "绝口不谈",
    "traditional": "絕口不談"
  },
  {
    "frequency": 88,
    "simplified": "在此一举",
    "traditional": "在此一舉"
  },
  {
    "frequency": 88,
    "simplified": "当断不断",
    "traditional": "當斷不斷"
  },
  {
    "frequency": 88,
    "simplified": "成事不足",
    "traditional": "成事不足"
  },
  {
    "frequency": 88,
    "simplified": "忠肝义胆",
    "traditional": "忠肝義膽"
  },
  {
    "frequency": 88,
    "simplified": "静若处子",
    "traditional": "靜若處子"
  },
  {
    "frequency": 88,
    "simplified": "身无长物",
    "traditional": "身無長物"
  },
  {
    "frequency": 88,
    "simplified": "成败在此一举",
    "traditional": "成敗在此一舉"
  },
  {
    "frequency": 88,
    "simplified": "胜读十年书",
    "traditional": "勝讀十年書"
  },
  {
    "frequency": 88,
    "simplified": "成群结伙",
    "traditional": "成群結夥"
  },
  {
    "frequency": 88,
    "simplified": "冲口而出",
    "traditional": "衝口而出"
  },
  {
    "frequency": 88,
    "simplified": "暗箭伤人",
    "traditional": "暗箭傷人"
  },
  {
    "frequency": 88,
    "simplified": "城门失火殃及池鱼",
    "traditional": "城門失火殃及池魚"
  },
  {
    "frequency": 88,
    "simplified": "不药而愈",
    "traditional": "不藥而癒"
  },
  {
    "frequency": 88,
    "simplified": "杳无踪影",
    "traditional": "杳無蹤影"
  },
  {
    "frequency": 88,
    "simplified": "目不忍睹",
    "traditional": "目不忍睹"
  },
  {
    "frequency": 87,
    "simplified": "泰山压顶不弯腰",
    "traditional": "泰山壓頂不彎腰"
  },
  {
    "frequency": 87,
    "simplified": "得意之笔",
    "traditional": "得意之筆"
  },
  {
    "frequency": 87,
    "simplified": "吹胡子瞪眼",
    "traditional": "吹鬍子瞪眼"
  },
  {
    "frequency": 87,
    "simplified": "始于足下",
    "traditional": "始於足下"
  },
  {
    "frequency": 87,
    "simplified": "海角天涯",
    "traditional": "海角天涯"
  },
  {
    "frequency": 87,
    "simplified": "招蜂引蝶",
    "traditional": "招蜂引蝶"
  },
  {
    "frequency": 87,
    "simplified": "恩断义绝",
    "traditional": "恩斷義絕"
  },
  {
    "frequency": 87,
    "simplified": "不识抬举",
    "traditional": "不識抬舉"
  },
  {
    "frequency": 87,
    "simplified": "力有未逮",
    "traditional": "力有未逮"
  },
  {
    "frequency": 87,
    "simplified": "离奇古怪",
    "traditional": "離奇古怪"
  },
  {
    "frequency": 87,
    "simplified": "片甲不留",
    "traditional": "片甲不留"
  },
  {
    "frequency": 87,
    "simplified": "不知凡几",
    "traditional": "不知凡幾"
  },
  {
    "frequency": 87,
    "simplified": "清廉正直",
    "traditional": "清廉正直"
  },
  {
    "frequency": 87,
    "simplified": "油腔滑调",
    "traditional": "油腔滑調"
  },
  {
    "frequency": 87,
    "simplified": "一触即溃",
    "traditional": "一觸即潰"
  },
  {
    "frequency": 87,
    "simplified": "邪不胜正",
    "traditional": "邪不勝正"
  },
  {
    "frequency": 87,
    "simplified": "糟糠之妻",
    "traditional": "糟糠之妻"
  },
  {
    "frequency": 87,
    "simplified": "熬更守夜",
    "traditional": "熬更守夜"
  },
  {
    "frequency": 87,
    "simplified": "桃之夭夭",
    "traditional": "桃之夭夭"
  },
  {
    "frequency": 87,
    "simplified": "源源而来",
    "traditional": "源源而來"
  },
  {
    "frequency": 87,
    "simplified": "济世救人",
    "traditional": "濟世救人"
  },
  {
    "frequency": 87,
    "simplified": "娓娓动听",
    "traditional": "娓娓動聽"
  },
  {
    "frequency": 87,
    "simplified": "一天一地",
    "traditional": "一天一地"
  },
  {
    "frequency": 87,
    "simplified": "头昏目眩",
    "traditional": "頭昏目眩"
  },
  {
    "frequency": 86,
    "simplified": "莫此为甚",
    "traditional": "莫此為甚"
  },
  {
    "frequency": 86,
    "simplified": "亲如手足",
    "traditional": "親如手足"
  },
  {
    "frequency": 86,
    "simplified": "空话连篇",
    "traditional": "空話連篇"
  },
  {
    "frequency": 86,
    "simplified": "百孔千疮",
    "traditional": "百孔千瘡"
  },
  {
    "frequency": 86,
    "simplified": "唇红齿白",
    "traditional": "唇紅齒白"
  },
  {
    "frequency": 86,
    "simplified": "买卖公平",
    "traditional": "買賣公平"
  },
  {
    "frequency": 86,
    "simplified": "水中捞月",
    "traditional": "水中撈月"
  },
  {
    "frequency": 86,
    "simplified": "以直报怨",
    "traditional": "以直報怨"
  },
  {
    "frequency": 86,
    "simplified": "言人人殊",
    "traditional": "言人人殊"
  },
  {
    "frequency": 86,
    "simplified": "谬种流传",
    "traditional": "謬種流傳"
  },
  {
    "frequency": 86,
    "simplified": "艺高胆大",
    "traditional": "藝高膽大"
  },
  {
    "frequency": 86,
    "simplified": "名垂千古",
    "traditional": "名垂千古"
  },
  {
    "frequency": 86,
    "simplified": "七十二行",
    "traditional": "七十二行"
  },
  {
    "frequency": 86,
    "simplified": "十二金钗",
    "traditional": "十二金釵"
  },
  {
    "frequency": 86,
    "simplified": "一物降一物",
    "traditional": "一物降一物"
  },
  {
    "frequency": 86,
    "simplified": "如痴如狂",
    "traditional": "如痴如狂"
  },
  {
    "frequency": 86,
    "simplified": "海底捞针",
    "traditional": "海底撈針"
  },
  {
    "frequency": 86,
    "simplified": "少年夫妻老来伴",
    "traditional": "少年夫妻老來伴"
  },
  {
    "frequency": 85,
    "simplified": "沁人肺腑",
    "traditional": "沁人肺腑"
  },
  {
    "frequency": 85,
    "simplified": "自命清高",
    "traditional": "自命清高"
  },
  {
    "frequency": 85,
    "simplified": "一手包揽",
    "traditional": "一手包攬"
  },
  {
    "frequency": 85,
    "simplified": "酒后失言",
    "traditional": "酒後失言"
  },
  {
    "frequency": 85,
    "simplified": "人之将死",
    "traditional": "人之將死"
  },
  {
    "frequency": 85,
    "simplified": "觊觎之心",
    "traditional": "覬覦之心"
  },
  {
    "frequency": 85,
    "simplified": "明升暗降",
    "traditional": "明升暗降"
  },
  {
    "frequency": 85,
    "simplified": "国无宁日",
    "traditional": "國無寧日"
  },
  {
    "frequency": 85,
    "simplified": "贼眉鼠眼",
    "traditional": "賊眉鼠眼"
  },
  {
    "frequency": 85,
    "simplified": "相辅而行",
    "traditional": "相輔而行"
  },
  {
    "frequency": 85,
    "simplified": "不落窠臼",
    "traditional": "不落窠臼"
  },
  {
    "frequency": 85,
    "simplified": "相沿成习",
    "traditional": "相沿成習"
  },
  {
    "frequency": 85,
    "simplified": "人为财死",
    "traditional": "人為財死"
  },
  {
    "frequency": 85,
    "simplified": "春花秋月",
    "traditional": "春花秋月"
  },
  {
    "frequency": 85,
    "simplified": "择邻而居",
    "traditional": "擇鄰而居"
  },
  {
    "frequency": 85,
    "simplified": "松鹤延年",
    "traditional": "松鶴延年"
  },
  {
    "frequency": 85,
    "simplified": "官逼民反",
    "traditional": "官逼民反"
  },
  {
    "frequency": 85,
    "simplified": "求仁得仁",
    "traditional": "求仁得仁"
  },
  {
    "frequency": 84,
    "simplified": "临危授命",
    "traditional": "臨危授命"
  },
  {
    "frequency": 84,
    "simplified": "一人之下",
    "traditional": "一人之下"
  },
  {
    "frequency": 84,
    "simplified": "好事之徒",
    "traditional": "好事之徒"
  },
  {
    "frequency": 84,
    "simplified": "神机妙算",
    "traditional": "神機妙算"
  },
  {
    "frequency": 84,
    "simplified": "筋疲力竭",
    "traditional": "筋疲力竭"
  },
  {
    "frequency": 84,
    "simplified": "人心不足蛇吞象",
    "traditional": "人心不足蛇吞象"
  },
  {
    "frequency": 84,
    "simplified": "云谲波诡",
    "traditional": "雲譎波詭"
  },
  {
    "frequency": 84,
    "simplified": "独断独行",
    "traditional": "獨斷獨行"
  },
  {
    "frequency": 84,
    "simplified": "绫罗绸缎",
    "traditional": "綾羅綢緞"
  },
  {
    "frequency": 84,
    "simplified": "以小人之心",
    "traditional": "以小人之心"
  },
  {
    "frequency": 84,
    "simplified": "当一天和尚撞一天钟",
    "traditional": "當一天和尚撞一天鐘"
  },
  {
    "frequency": 84,
    "simplified": "班师回朝",
    "traditional": "班師回朝"
  },
  {
    "frequency": 84,
    "simplified": "渺无音讯",
    "traditional": "渺無音訊"
  },
  {
    "frequency": 84,
    "simplified": "说长道短",
    "traditional": "說長道短"
  },
  {
    "frequency": 84,
    "simplified": "秋水伊人",
    "traditional": "秋水伊人"
  },
  {
    "frequency": 84,
    "simplified": "侧目而视",
    "traditional": "側目而視"
  },
  {
    "frequency": 84,
    "simplified": "光复旧物",
    "traditional": "光復舊物"
  },
  {
    "frequency": 83,
    "simplified": "水性杨花",
    "traditional": "水性楊花"
  },
  {
    "frequency": 83,
    "simplified": "罪恶滔天",
    "traditional": "罪惡滔天"
  },
  {
    "frequency": 83,
    "simplified": "魂不附体",
    "traditional": "魂不附體"
  },
  {
    "frequency": 83,
    "simplified": "行有余力",
    "traditional": "行有餘力"
  },
  {
    "frequency": 83,
    "simplified": "东跑西颠",
    "traditional": "東跑西顛"
  },
  {
    "frequency": 83,
    "simplified": "面不改色心不跳",
    "traditional": "面不改色心不跳"
  },
  {
    "frequency": 83,
    "simplified": "包罗万有",
    "traditional": "包羅萬有"
  },
  {
    "frequency": 83,
    "simplified": "海阔天高",
    "traditional": "海闊天高"
  },
  {
    "frequency": 83,
    "simplified": "胡服骑射",
    "traditional": "胡服騎射"
  },
  {
    "frequency": 83,
    "simplified": "以其昏昏",
    "traditional": "以其昏昏"
  },
  {
    "frequency": 83,
    "simplified": "居大不易",
    "traditional": "居大不易"
  },
  {
    "frequency": 83,
    "simplified": "三妻四妾",
    "traditional": "三妻四妾"
  },
  {
    "frequency": 83,
    "simplified": "胜败乃兵家常事",
    "traditional": "勝敗乃兵家常事"
  },
  {
    "frequency": 82,
    "simplified": "参差不一",
    "traditional": "參差不一"
  },
  {
    "frequency": 82,
    "simplified": "肥头大耳",
    "traditional": "肥頭大耳"
  },
  {
    "frequency": 82,
    "simplified": "夸父追日",
    "traditional": "夸父追日"
  },
  {
    "frequency": 82,
    "simplified": "明修栈道暗度陈仓",
    "traditional": "明修棧道暗度陳倉"
  },
  {
    "frequency": 82,
    "simplified": "无可讳言",
    "traditional": "無可諱言"
  },
  {
    "frequency": 82,
    "simplified": "不知轻重",
    "traditional": "不知輕重"
  },
  {
    "frequency": 82,
    "simplified": "鼎足而立",
    "traditional": "鼎足而立"
  },
  {
    "frequency": 82,
    "simplified": "一朝权在手",
    "traditional": "一朝權在手"
  },
  {
    "frequency": 82,
    "simplified": "舍得一身剐",
    "traditional": "捨得一身剮"
  },
  {
    "frequency": 82,
    "simplified": "司马昭之心路人皆知",
    "traditional": "司馬昭之心路人皆知"
  },
  {
    "frequency": 81,
    "simplified": "空口说白话",
    "traditional": "空口說白話"
  },
  {
    "frequency": 81,
    "simplified": "碧空万里",
    "traditional": "碧空萬里"
  },
  {
    "frequency": 81,
    "simplified": "宁折不弯",
    "traditional": "寧折不彎"
  },
  {
    "frequency": 81,
    "simplified": "乐天知命",
    "traditional": "樂天知命"
  },
  {
    "frequency": 81,
    "simplified": "不知死活",
    "traditional": "不知死活"
  },
  {
    "frequency": 81,
    "simplified": "月下老人",
    "traditional": "月下老人"
  },
  {
    "frequency": 81,
    "simplified": "绣花枕头",
    "traditional": "繡花枕頭"
  },
  {
    "frequency": 81,
    "simplified": "男盗女娼",
    "traditional": "男盜女娼"
  },
  {
    "frequency": 81,
    "simplified": "敬谢不敏",
    "traditional": "敬謝不敏"
  },
  {
    "frequency": 81,
    "simplified": "视如珍宝",
    "traditional": "視如珍寶"
  },
  {
    "frequency": 81,
    "simplified": "废话连篇",
    "traditional": "廢話連篇"
  },
  {
    "frequency": 81,
    "simplified": "万古流芳",
    "traditional": "萬古流芳"
  },
  {
    "frequency": 81,
    "simplified": "好整以暇",
    "traditional": "好整以暇"
  },
  {
    "frequency": 81,
    "simplified": "不知有汉",
    "traditional": "不知有漢"
  },
  {
    "frequency": 81,
    "simplified": "皮之不存毛将焉附",
    "traditional": "皮之不存毛將焉附"
  },
  {
    "frequency": 81,
    "simplified": "箭在弦上不得不发",
    "traditional": "箭在弦上不得不發"
  },
  {
    "frequency": 81,
    "simplified": "结发夫妻",
    "traditional": "結髮夫妻"
  },
  {
    "frequency": 81,
    "simplified": "归根结蒂",
    "traditional": "歸根結蒂"
  },
  {
    "frequency": 80,
    "simplified": "剑胆琴心",
    "traditional": "劍膽琴心"
  },
  {
    "frequency": 80,
    "simplified": "一叶障目不见泰山",
    "traditional": "一葉障目不見泰山"
  },
  {
    "frequency": 80,
    "simplified": "束手待毙",
    "traditional": "束手待斃"
  },
  {
    "frequency": 80,
    "simplified": "另请高明",
    "traditional": "另請高明"
  },
  {
    "frequency": 80,
    "simplified": "水可载舟",
    "traditional": "水可載舟"
  },
  {
    "frequency": 80,
    "simplified": "难以理喻",
    "traditional": "難以理喻"
  },
  {
    "frequency": 80,
    "simplified": "穷且益坚",
    "traditional": "窮且益堅"
  },
  {
    "frequency": 80,
    "simplified": "大将风度",
    "traditional": "大將風度"
  },
  {
    "frequency": 80,
    "simplified": "鞠躬尽瘁死而后已",
    "traditional": "鞠躬盡瘁死而後已"
  },
  {
    "frequency": 80,
    "simplified": "匹夫之勇",
    "traditional": "匹夫之勇"
  },
  {
    "frequency": 80,
    "simplified": "蓬荜生辉",
    "traditional": "蓬蓽生輝"
  },
  {
    "frequency": 80,
    "simplified": "明镜高悬",
    "traditional": "明鏡高懸"
  },
  {
    "frequency": 80,
    "simplified": "自轻自贱",
    "traditional": "自輕自賤"
  },
  {
    "frequency": 80,
    "simplified": "螳螂捕蝉黄雀在后",
    "traditional": "螳螂捕蟬黃雀在後"
  },
  {
    "frequency": 80,
    "simplified": "赤地千里",
    "traditional": "赤地千里"
  },
  {
    "frequency": 80,
    "simplified": "移山填海",
    "traditional": "移山填海"
  },
  {
    "frequency": 79,
    "simplified": "争前恐后",
    "traditional": "爭前恐後"
  },
  {
    "frequency": 79,
    "simplified": "前堵后追",
    "traditional": "前堵後追"
  },
  {
    "frequency": 79,
    "simplified": "拆东补西",
    "traditional": "拆東補西"
  },
  {
    "frequency": 79,
    "simplified": "空谷幽兰",
    "traditional": "空谷幽蘭"
  },
  {
    "frequency": 79,
    "simplified": "彻底澄清",
    "traditional": "徹底澄清"
  },
  {
    "frequency": 79,
    "simplified": "视同儿戏",
    "traditional": "視同兒戲"
  },
  {
    "frequency": 79,
    "simplified": "女大十八变",
    "traditional": "女大十八變"
  },
  {
    "frequency": 79,
    "simplified": "灿若繁星",
    "traditional": "燦若繁星"
  },
  {
    "frequency": 79,
    "simplified": "乘龙快婿",
    "traditional": "乘龍快婿"
  },
  {
    "frequency": 79,
    "simplified": "日月如梭",
    "traditional": "日月如梭"
  },
  {
    "frequency": 79,
    "simplified": "宵衣旰食",
    "traditional": "宵衣旰食"
  },
  {
    "frequency": 79,
    "simplified": "穿凿附会",
    "traditional": "穿鑿附會"
  },
  {
    "frequency": 79,
    "simplified": "形容憔悴",
    "traditional": "形容憔悴"
  },
  {
    "frequency": 78,
    "simplified": "竹报平安",
    "traditional": "竹報平安"
  },
  {
    "frequency": 78,
    "simplified": "坐地分赃",
    "traditional": "坐地分贓"
  },
  {
    "frequency": 78,
    "simplified": "百废待举",
    "traditional": "百廢待舉"
  },
  {
    "frequency": 78,
    "simplified": "东郭先生",
    "traditional": "東郭先生"
  },
  {
    "frequency": 78,
    "simplified": "开物成务",
    "traditional": "開物成務"
  },
  {
    "frequency": 78,
    "simplified": "敬老尊贤",
    "traditional": "敬老尊賢"
  },
  {
    "frequency": 78,
    "simplified": "不名一文",
    "traditional": "不名一文"
  },
  {
    "frequency": 78,
    "simplified": "极而言之",
    "traditional": "極而言之"
  },
  {
    "frequency": 78,
    "simplified": "宛转悠扬",
    "traditional": "宛轉悠揚"
  },
  {
    "frequency": 78,
    "simplified": "同心戮力",
    "traditional": "同心戮力"
  },
  {
    "frequency": 78,
    "simplified": "力所不逮",
    "traditional": "力所不逮"
  },
  {
    "frequency": 78,
    "simplified": "躬行实践",
    "traditional": "躬行實踐"
  },
  {
    "frequency": 78,
    "simplified": "割据一方",
    "traditional": "割據一方"
  },
  {
    "frequency": 78,
    "simplified": "身历其境",
    "traditional": "身歷其境"
  },
  {
    "frequency": 78,
    "simplified": "奉天承运",
    "traditional": "奉天承運"
  },
  {
    "frequency": 78,
    "simplified": "定于一尊",
    "traditional": "定於一尊"
  },
  {
    "frequency": 78,
    "simplified": "无容身之地",
    "traditional": "無容身之地"
  },
  {
    "frequency": 78,
    "simplified": "老子英雄儿好汉",
    "traditional": "老子英雄兒好漢"
  },
  {
    "frequency": 78,
    "simplified": "看菜吃饭",
    "traditional": "看菜吃飯"
  },
  {
    "frequency": 78,
    "simplified": "不矜细行",
    "traditional": "不矜細行"
  },
  {
    "frequency": 78,
    "simplified": "花香鸟语",
    "traditional": "花香鳥語"
  },
  {
    "frequency": 78,
    "simplified": "放火烧山",
    "traditional": "放火燒山"
  },
  {
    "frequency": 78,
    "simplified": "分文不值",
    "traditional": "分文不值"
  },
  {
    "frequency": 78,
    "simplified": "饱经风雨",
    "traditional": "飽經風雨"
  },
  {
    "frequency": 78,
    "simplified": "红颜薄命",
    "traditional": "紅顏薄命"
  },
  {
    "frequency": 78,
    "simplified": "衣不解带",
    "traditional": "衣不解帶"
  },
  {
    "frequency": 78,
    "simplified": "不足为训",
    "traditional": "不足為訓"
  },
  {
    "frequency": 78,
    "simplified": "过而能改",
    "traditional": "過而能改"
  },
  {
    "frequency": 77,
    "simplified": "宏图大志",
    "traditional": "宏圖大志"
  },
  {
    "frequency": 77,
    "simplified": "雨打风吹",
    "traditional": "雨打風吹"
  },
  {
    "frequency": 77,
    "simplified": "视为儿戏",
    "traditional": "視為兒戲"
  },
  {
    "frequency": 77,
    "simplified": "小康之家",
    "traditional": "小康之家"
  },
  {
    "frequency": 77,
    "simplified": "明媒正娶",
    "traditional": "明媒正娶"
  },
  {
    "frequency": 77,
    "simplified": "前倨后恭",
    "traditional": "前倨後恭"
  },
  {
    "frequency": 77,
    "simplified": "春风浩荡",
    "traditional": "春風浩蕩"
  },
  {
    "frequency": 77,
    "simplified": "宏图大略",
    "traditional": "宏圖大略"
  },
  {
    "frequency": 77,
    "simplified": "令人齿冷",
    "traditional": "令人齒冷"
  },
  {
    "frequency": 77,
    "simplified": "低声细语",
    "traditional": "低聲細語"
  },
  {
    "frequency": 77,
    "simplified": "所见略同",
    "traditional": "所見略同"
  },
  {
    "frequency": 77,
    "simplified": "千山万壑",
    "traditional": "千山萬壑"
  },
  {
    "frequency": 77,
    "simplified": "自以为得计",
    "traditional": "自以為得計"
  },
  {
    "frequency": 77,
    "simplified": "一朝天子一朝臣",
    "traditional": "一朝天子一朝臣"
  },
  {
    "frequency": 77,
    "simplified": "感慨系之",
    "traditional": "感慨系之"
  },
  {
    "frequency": 77,
    "simplified": "一个半个",
    "traditional": "一個半個"
  },
  {
    "frequency": 77,
    "simplified": "躬逢其盛",
    "traditional": "躬逢其盛"
  },
  {
    "frequency": 77,
    "simplified": "强奸民意",
    "traditional": "強姦民意"
  },
  {
    "frequency": 77,
    "simplified": "养家活口",
    "traditional": "養家活口"
  },
  {
    "frequency": 77,
    "simplified": "四面受敌",
    "traditional": "四面受敵"
  },
  {
    "frequency": 76,
    "simplified": "千门万户",
    "traditional": "千門萬戶"
  },
  {
    "frequency": 76,
    "simplified": "物阜民丰",
    "traditional": "物阜民豐"
  },
  {
    "frequency": 76,
    "simplified": "人穷志短",
    "traditional": "人窮志短"
  },
  {
    "frequency": 76,
    "simplified": "星移斗转",
    "traditional": "星移斗轉"
  },
  {
    "frequency": 76,
    "simplified": "兵不厌诈",
    "traditional": "兵不厭詐"
  },
  {
    "frequency": 76,
    "simplified": "来去无踪",
    "traditional": "來去無蹤"
  },
  {
    "frequency": 76,
    "simplified": "混淆黑白",
    "traditional": "混淆黑白"
  },
  {
    "frequency": 76,
    "simplified": "借古讽今",
    "traditional": "借古諷今"
  },
  {
    "frequency": 76,
    "simplified": "支吾其词",
    "traditional": "支吾其詞"
  },
  {
    "frequency": 76,
    "simplified": "嫁狗随狗",
    "traditional": "嫁狗隨狗"
  },
  {
    "frequency": 76,
    "simplified": "光可鉴人",
    "traditional": "光可鑑人"
  },
  {
    "frequency": 76,
    "simplified": "长幼尊卑",
    "traditional": "長幼尊卑"
  },
  {
    "frequency": 76,
    "simplified": "不辨真伪",
    "traditional": "不辨真偽"
  },
  {
    "frequency": 76,
    "simplified": "地灵人杰",
    "traditional": "地靈人傑"
  },
  {
    "frequency": 76,
    "simplified": "始终不懈",
    "traditional": "始終不懈"
  },
  {
    "frequency": 75,
    "simplified": "家贫如洗",
    "traditional": "家貧如洗"
  },
  {
    "frequency": 75,
    "simplified": "街头巷议",
    "traditional": "街頭巷議"
  },
  {
    "frequency": 75,
    "simplified": "龙盘虎踞",
    "traditional": "龍盤虎踞"
  },
  {
    "frequency": 75,
    "simplified": "尽释前嫌",
    "traditional": "盡釋前嫌"
  },
  {
    "frequency": 75,
    "simplified": "鸟为食亡",
    "traditional": "鳥為食亡"
  },
  {
    "frequency": 75,
    "simplified": "败事有余",
    "traditional": "敗事有餘"
  },
  {
    "frequency": 75,
    "simplified": "富而好礼",
    "traditional": "富而好禮"
  },
  {
    "frequency": 75,
    "simplified": "天若有情天亦老",
    "traditional": "天若有情天亦老"
  },
  {
    "frequency": 75,
    "simplified": "狼奔豕突",
    "traditional": "狼奔豕突"
  },
  {
    "frequency": 75,
    "simplified": "不吝赐教",
    "traditional": "不吝賜教"
  },
  {
    "frequency": 75,
    "simplified": "琼楼玉宇",
    "traditional": "瓊樓玉宇"
  },
  {
    "frequency": 75,
    "simplified": "长风破浪",
    "traditional": "長風破浪"
  },
  {
    "frequency": 75,
    "simplified": "俯首听命",
    "traditional": "俯首聽命"
  },
  {
    "frequency": 75,
    "simplified": "当众出丑",
    "traditional": "當眾出醜"
  },
  {
    "frequency": 75,
    "simplified": "求才若渴",
    "traditional": "求才若渴"
  },
  {
    "frequency": 75,
    "simplified": "皮笑肉不笑",
    "traditional": "皮笑肉不笑"
  },
  {
    "frequency": 75,
    "simplified": "粥少僧多",
    "traditional": "粥少僧多"
  },
  {
    "frequency": 75,
    "simplified": "双宿双飞",
    "traditional": "雙宿雙飛"
  },
  {
    "frequency": 75,
    "simplified": "鲜衣怒马",
    "traditional": "鮮衣怒馬"
  },
  {
    "frequency": 74,
    "simplified": "福寿双全",
    "traditional": "福壽雙全"
  },
  {
    "frequency": 74,
    "simplified": "死乞白赖",
    "traditional": "死乞白賴"
  },
  {
    "frequency": 74,
    "simplified": "非驴非马",
    "traditional": "非驢非馬"
  },
  {
    "frequency": 74,
    "simplified": "额手称庆",
    "traditional": "額手稱慶"
  },
  {
    "frequency": 74,
    "simplified": "生米做成熟饭",
    "traditional": "生米做成熟飯"
  },
  {
    "frequency": 74,
    "simplified": "述而不作",
    "traditional": "述而不作"
  },
  {
    "frequency": 74,
    "simplified": "每下愈况",
    "traditional": "每下愈況"
  },
  {
    "frequency": 74,
    "simplified": "宽宏大度",
    "traditional": "寬宏大度"
  },
  {
    "frequency": 74,
    "simplified": "读书破万卷",
    "traditional": "讀書破萬卷"
  },
  {
    "frequency": 74,
    "simplified": "物伤其类",
    "traditional": "物傷其類"
  },
  {
    "frequency": 74,
    "simplified": "流言止于智者",
    "traditional": "流言止於智者"
  },
  {
    "frequency": 74,
    "simplified": "回肠荡气",
    "traditional": "迴腸蕩氣"
  },
  {
    "frequency": 74,
    "simplified": "有眼无珠",
    "traditional": "有眼無珠"
  },
  {
    "frequency": 74,
    "simplified": "决一胜负",
    "traditional": "決一勝負"
  },
  {
    "frequency": 74,
    "simplified": "彼此彼此",
    "traditional": "彼此彼此"
  },
  {
    "frequency": 74,
    "simplified": "行而不远",
    "traditional": "行而不遠"
  },
  {
    "frequency": 74,
    "simplified": "弹尽援绝",
    "traditional": "彈盡援絕"
  },
  {
    "frequency": 74,
    "simplified": "年老色衰",
    "traditional": "年老色衰"
  },
  {
    "frequency": 74,
    "simplified": "祛病延年",
    "traditional": "祛病延年"
  },
  {
    "frequency": 74,
    "simplified": "青出于蓝胜于蓝",
    "traditional": "青出於藍勝於藍"
  },
  {
    "frequency": 73,
    "simplified": "碧血丹心",
    "traditional": "碧血丹心"
  },
  {
    "frequency": 73,
    "simplified": "万头攒动",
    "traditional": "萬頭攢動"
  },
  {
    "frequency": 73,
    "simplified": "认贼作父",
    "traditional": "認賊作父"
  },
  {
    "frequency": 73,
    "simplified": "惟我独尊",
    "traditional": "惟我獨尊"
  },
  {
    "frequency": 73,
    "simplified": "人穷志不短",
    "traditional": "人窮志不短"
  },
  {
    "frequency": 73,
    "simplified": "其实难副",
    "traditional": "其實難副"
  },
  {
    "frequency": 73,
    "simplified": "走为上策",
    "traditional": "走為上策"
  },
  {
    "frequency": 73,
    "simplified": "一碧万顷",
    "traditional": "一碧萬頃"
  },
  {
    "frequency": 73,
    "simplified": "天打雷劈",
    "traditional": "天打雷劈"
  },
  {
    "frequency": 73,
    "simplified": "月朗星稀",
    "traditional": "月朗星稀"
  },
  {
    "frequency": 73,
    "simplified": "好汉不吃眼前亏",
    "traditional": "好漢不吃眼前虧"
  },
  {
    "frequency": 73,
    "simplified": "袒胸露背",
    "traditional": "袒胸露背"
  },
  {
    "frequency": 73,
    "simplified": "身心交瘁",
    "traditional": "身心交瘁"
  },
  {
    "frequency": 73,
    "simplified": "不如归去",
    "traditional": "不如歸去"
  },
  {
    "frequency": 73,
    "simplified": "明月清风",
    "traditional": "明月清風"
  },
  {
    "frequency": 73,
    "simplified": "比手画脚",
    "traditional": "比手畫腳"
  },
  {
    "frequency": 73,
    "simplified": "雀屏中选",
    "traditional": "雀屏中選"
  },
  {
    "frequency": 72,
    "simplified": "游必有方",
    "traditional": "遊必有方"
  },
  {
    "frequency": 72,
    "simplified": "买空卖空",
    "traditional": "買空賣空"
  },
  {
    "frequency": 72,
    "simplified": "袅袅婷婷",
    "traditional": "嫋嫋婷婷"
  },
  {
    "frequency": 72,
    "simplified": "癞蛤蟆想吃天鹅肉",
    "traditional": "癩蛤蟆想吃天鵝肉"
  },
  {
    "frequency": 72,
    "simplified": "料峭春寒",
    "traditional": "料峭春寒"
  },
  {
    "frequency": 72,
    "simplified": "锦绣江山",
    "traditional": "錦繡江山"
  },
  {
    "frequency": 72,
    "simplified": "感恩图报",
    "traditional": "感恩圖報"
  },
  {
    "frequency": 72,
    "simplified": "敢怒不敢言",
    "traditional": "敢怒不敢言"
  },
  {
    "frequency": 72,
    "simplified": "孤魂野鬼",
    "traditional": "孤魂野鬼"
  },
  {
    "frequency": 72,
    "simplified": "千里姻缘一线牵",
    "traditional": "千里姻緣一線牽"
  },
  {
    "frequency": 72,
    "simplified": "山摇地动",
    "traditional": "山搖地動"
  },
  {
    "frequency": 72,
    "simplified": "加官进爵",
    "traditional": "加官進爵"
  },
  {
    "frequency": 72,
    "simplified": "率土之滨",
    "traditional": "率土之濱"
  },
  {
    "frequency": 72,
    "simplified": "必有我师",
    "traditional": "必有我師"
  },
  {
    "frequency": 72,
    "simplified": "束手无措",
    "traditional": "束手無措"
  },
  {
    "frequency": 71,
    "simplified": "寻踪觅迹",
    "traditional": "尋蹤覓跡"
  },
  {
    "frequency": 71,
    "simplified": "铮铮铁汉",
    "traditional": "錚錚鐵漢"
  },
  {
    "frequency": 71,
    "simplified": "脍不厌细",
    "traditional": "膾不厭細"
  },
  {
    "frequency": 71,
    "simplified": "笔墨官司",
    "traditional": "筆墨官司"
  },
  {
    "frequency": 71,
    "simplified": "绝代佳人",
    "traditional": "絕代佳人"
  },
  {
    "frequency": 71,
    "simplified": "聪明睿智",
    "traditional": "聰明睿智"
  },
  {
    "frequency": 71,
    "simplified": "荆楚岁时记",
    "traditional": "荊楚歲時記"
  },
  {
    "frequency": 71,
    "simplified": "高不可及",
    "traditional": "高不可及"
  },
  {
    "frequency": 71,
    "simplified": "隔墙有耳",
    "traditional": "隔牆有耳"
  },
  {
    "frequency": 71,
    "simplified": "争强斗狠",
    "traditional": "爭強鬥狠"
  },
  {
    "frequency": 71,
    "simplified": "天涯咫尺",
    "traditional": "天涯咫尺"
  },
  {
    "frequency": 71,
    "simplified": "先入之见",
    "traditional": "先入之見"
  },
  {
    "frequency": 71,
    "simplified": "盘古开天地",
    "traditional": "盤古開天地"
  },
  {
    "frequency": 70,
    "simplified": "半懂不懂",
    "traditional": "半懂不懂"
  },
  {
    "frequency": 70,
    "simplified": "吴下阿蒙",
    "traditional": "吳下阿蒙"
  },
  {
    "frequency": 70,
    "simplified": "斜风细雨",
    "traditional": "斜風細雨"
  },
  {
    "frequency": 70,
    "simplified": "厚古薄今",
    "traditional": "厚古薄今"
  },
  {
    "frequency": 70,
    "simplified": "应答如流",
    "traditional": "應答如流"
  },
  {
    "frequency": 70,
    "simplified": "老鼠过街人人喊打",
    "traditional": "老鼠過街人人喊打"
  },
  {
    "frequency": 70,
    "simplified": "一曝十寒",
    "traditional": "一曝十寒"
  },
  {
    "frequency": 70,
    "simplified": "同心共济",
    "traditional": "同心共濟"
  },
  {
    "frequency": 70,
    "simplified": "蚕食鲸吞",
    "traditional": "蠶食鯨吞"
  },
  {
    "frequency": 70,
    "simplified": "月朗风清",
    "traditional": "月朗風清"
  },
  {
    "frequency": 70,
    "simplified": "有来无回",
    "traditional": "有來無回"
  },
  {
    "frequency": 70,
    "simplified": "百川归海",
    "traditional": "百川歸海"
  },
  {
    "frequency": 70,
    "simplified": "无所不通",
    "traditional": "無所不通"
  },
  {
    "frequency": 70,
    "simplified": "远亲近邻",
    "traditional": "遠親近鄰"
  },
  {
    "frequency": 70,
    "simplified": "有勇无谋",
    "traditional": "有勇無謀"
  },
  {
    "frequency": 70,
    "simplified": "博闻强识",
    "traditional": "博聞強識"
  },
  {
    "frequency": 70,
    "simplified": "惠而不费",
    "traditional": "惠而不費"
  },
  {
    "frequency": 70,
    "simplified": "杳无人烟",
    "traditional": "杳無人煙"
  },
  {
    "frequency": 70,
    "simplified": "正心诚意",
    "traditional": "正心誠意"
  },
  {
    "frequency": 70,
    "simplified": "掰开揉碎",
    "traditional": "掰開揉碎"
  },
  {
    "frequency": 70,
    "simplified": "慎终如始",
    "traditional": "慎終如始"
  },
  {
    "frequency": 70,
    "simplified": "鸡鸣犬吠",
    "traditional": "雞鳴犬吠"
  },
  {
    "frequency": 70,
    "simplified": "拒人千里之外",
    "traditional": "拒人千里之外"
  },
  {
    "frequency": 69,
    "simplified": "一语破的",
    "traditional": "一語破的"
  },
  {
    "frequency": 69,
    "simplified": "河清海晏",
    "traditional": "河清海晏"
  },
  {
    "frequency": 69,
    "simplified": "徘徊观望",
    "traditional": "徘徊觀望"
  },
  {
    "frequency": 69,
    "simplified": "冰雪聪明",
    "traditional": "冰雪聰明"
  },
  {
    "frequency": 69,
    "simplified": "虎踞龙盘",
    "traditional": "虎踞龍盤"
  },
  {
    "frequency": 69,
    "simplified": "世态人情",
    "traditional": "世態人情"
  },
  {
    "frequency": 69,
    "simplified": "破门而出",
    "traditional": "破門而出"
  },
  {
    "frequency": 69,
    "simplified": "成败萧何",
    "traditional": "成敗蕭何"
  },
  {
    "frequency": 69,
    "simplified": "书香人家",
    "traditional": "書香人家"
  },
  {
    "frequency": 69,
    "simplified": "不为瓦全",
    "traditional": "不為瓦全"
  },
  {
    "frequency": 69,
    "simplified": "船到桥头自然直",
    "traditional": "船到橋頭自然直"
  },
  {
    "frequency": 69,
    "simplified": "幕天席地",
    "traditional": "幕天席地"
  },
  {
    "frequency": 69,
    "simplified": "敢想敢说",
    "traditional": "敢想敢說"
  },
  {
    "frequency": 69,
    "simplified": "百业萧条",
    "traditional": "百業蕭條"
  },
  {
    "frequency": 69,
    "simplified": "郁郁苍苍",
    "traditional": "鬱郁蒼蒼"
  },
  {
    "frequency": 69,
    "simplified": "海底捞月",
    "traditional": "海底撈月"
  },
  {
    "frequency": 69,
    "simplified": "好学不倦",
    "traditional": "好學不倦"
  },
  {
    "frequency": 69,
    "simplified": "尊姓大名",
    "traditional": "尊姓大名"
  },
  {
    "frequency": 69,
    "simplified": "三句话不离本行",
    "traditional": "三句話不離本行"
  },
  {
    "frequency": 69,
    "simplified": "一口吃个胖子",
    "traditional": "一口吃個胖子"
  },
  {
    "frequency": 69,
    "simplified": "暮色苍茫",
    "traditional": "暮色蒼茫"
  },
  {
    "frequency": 69,
    "simplified": "不是冤家不聚头",
    "traditional": "不是冤家不聚頭"
  },
  {
    "frequency": 69,
    "simplified": "俯仰之间",
    "traditional": "俯仰之間"
  },
  {
    "frequency": 69,
    "simplified": "忠孝两全",
    "traditional": "忠孝兩全"
  },
  {
    "frequency": 69,
    "simplified": "鱼贯而行",
    "traditional": "魚貫而行"
  },
  {
    "frequency": 69,
    "simplified": "奴颜婢膝",
    "traditional": "奴顏婢膝"
  },
  {
    "frequency": 68,
    "simplified": "琴瑟和谐",
    "traditional": "琴瑟和諧"
  },
  {
    "frequency": 68,
    "simplified": "朴素无华",
    "traditional": "樸素無華"
  },
  {
    "frequency": 68,
    "simplified": "颠来倒去",
    "traditional": "顛來倒去"
  },
  {
    "frequency": 68,
    "simplified": "隐名埋姓",
    "traditional": "隱名埋姓"
  },
  {
    "frequency": 68,
    "simplified": "十年树木百年树人",
    "traditional": "十年樹木百年樹人"
  },
  {
    "frequency": 68,
    "simplified": "假手于人",
    "traditional": "假手於人"
  },
  {
    "frequency": 68,
    "simplified": "半新不旧",
    "traditional": "半新不舊"
  },
  {
    "frequency": 68,
    "simplified": "遥遥在望",
    "traditional": "遙遙在望"
  },
  {
    "frequency": 68,
    "simplified": "凿壁偷光",
    "traditional": "鑿壁偷光"
  },
  {
    "frequency": 68,
    "simplified": "车载斗量",
    "traditional": "車載斗量"
  },
  {
    "frequency": 68,
    "simplified": "美人迟暮",
    "traditional": "美人遲暮"
  },
  {
    "frequency": 68,
    "simplified": "抱打不平",
    "traditional": "抱打不平"
  },
  {
    "frequency": 68,
    "simplified": "事缓则圆",
    "traditional": "事緩則圓"
  },
  {
    "frequency": 68,
    "simplified": "精力过人",
    "traditional": "精力過人"
  },
  {
    "frequency": 67,
    "simplified": "无可置喙",
    "traditional": "無可置喙"
  },
  {
    "frequency": 67,
    "simplified": "地利人和",
    "traditional": "地利人和"
  },
  {
    "frequency": 67,
    "simplified": "蟾宫折桂",
    "traditional": "蟾宮折桂"
  },
  {
    "frequency": 67,
    "simplified": "谈笑自如",
    "traditional": "談笑自如"
  },
  {
    "frequency": 67,
    "simplified": "冰雪严寒",
    "traditional": "冰雪嚴寒"
  },
  {
    "frequency": 67,
    "simplified": "心灰意懒",
    "traditional": "心灰意懶"
  },
  {
    "frequency": 67,
    "simplified": "以战养战",
    "traditional": "以戰養戰"
  },
  {
    "frequency": 67,
    "simplified": "愣头愣脑",
    "traditional": "愣頭愣腦"
  },
  {
    "frequency": 67,
    "simplified": "岁寒三友",
    "traditional": "歲寒三友"
  },
  {
    "frequency": 67,
    "simplified": "一言为定",
    "traditional": "一言為定"
  },
  {
    "frequency": 67,
    "simplified": "四海升平",
    "traditional": "四海昇平"
  },
  {
    "frequency": 67,
    "simplified": "难乎其难",
    "traditional": "難乎其難"
  },
  {
    "frequency": 67,
    "simplified": "环肥燕瘦",
    "traditional": "環肥燕瘦"
  },
  {
    "frequency": 67,
    "simplified": "传为笑谈",
    "traditional": "傳為笑談"
  },
  {
    "frequency": 67,
    "simplified": "山长水远",
    "traditional": "山長水遠"
  },
  {
    "frequency": 67,
    "simplified": "怪模怪样",
    "traditional": "怪模怪樣"
  },
  {
    "frequency": 67,
    "simplified": "立功赎罪",
    "traditional": "立功贖罪"
  },
  {
    "frequency": 67,
    "simplified": "能掐会算",
    "traditional": "能掐會算"
  },
  {
    "frequency": 67,
    "simplified": "是非得失",
    "traditional": "是非得失"
  },
  {
    "frequency": 67,
    "simplified": "撒泼打滚",
    "traditional": "撒潑打滾"
  },
  {
    "frequency": 67,
    "simplified": "进退有度",
    "traditional": "進退有度"
  },
  {
    "frequency": 67,
    "simplified": "狗拿耗子",
    "traditional": "狗拿耗子"
  },
  {
    "frequency": 67,
    "simplified": "不足为凭",
    "traditional": "不足為憑"
  },
  {
    "frequency": 67,
    "simplified": "一日不见",
    "traditional": "一日不見"
  },
  {
    "frequency": 67,
    "simplified": "名震一时",
    "traditional": "名震一時"
  },
  {
    "frequency": 67,
    "simplified": "立德立言",
    "traditional": "立德立言"
  },
  {
    "frequency": 67,
    "simplified": "暗箭难防",
    "traditional": "暗箭難防"
  },
  {
    "frequency": 66,
    "simplified": "不容置喙",
    "traditional": "不容置喙"
  },
  {
    "frequency": 66,
    "simplified": "以丰补歉",
    "traditional": "以豐補歉"
  },
  {
    "frequency": 66,
    "simplified": "当面锣对面鼓",
    "traditional": "當面鑼對面鼓"
  },
  {
    "frequency": 66,
    "simplified": "豁达大度",
    "traditional": "豁達大度"
  },
  {
    "frequency": 66,
    "simplified": "年逾不惑",
    "traditional": "年逾不惑"
  },
  {
    "frequency": 66,
    "simplified": "令人起敬",
    "traditional": "令人起敬"
  },
  {
    "frequency": 66,
    "simplified": "君臣佐使",
    "traditional": "君臣佐使"
  },
  {
    "frequency": 66,
    "simplified": "成也萧何败也萧何",
    "traditional": "成也蕭何敗也蕭何"
  },
  {
    "frequency": 66,
    "simplified": "八面威风",
    "traditional": "八面威風"
  },
  {
    "frequency": 66,
    "simplified": "福寿康宁",
    "traditional": "福壽康寧"
  },
  {
    "frequency": 66,
    "simplified": "功臣自居",
    "traditional": "功臣自居"
  },
  {
    "frequency": 66,
    "simplified": "有闻必录",
    "traditional": "有聞必錄"
  },
  {
    "frequency": 66,
    "simplified": "黯然销魂",
    "traditional": "黯然銷魂"
  },
  {
    "frequency": 66,
    "simplified": "形影相吊",
    "traditional": "形影相弔"
  },
  {
    "frequency": 66,
    "simplified": "股掌之上",
    "traditional": "股掌之上"
  },
  {
    "frequency": 66,
    "simplified": "止戈为武",
    "traditional": "止戈為武"
  },
  {
    "frequency": 66,
    "simplified": "天机不可泄露",
    "traditional": "天機不可洩露"
  },
  {
    "frequency": 66,
    "simplified": "瞎子摸鱼",
    "traditional": "瞎子摸魚"
  },
  {
    "frequency": 66,
    "simplified": "杯酒释兵权",
    "traditional": "杯酒釋兵權"
  },
  {
    "frequency": 66,
    "simplified": "公平正直",
    "traditional": "公平正直"
  },
  {
    "frequency": 66,
    "simplified": "投鞭断流",
    "traditional": "投鞭斷流"
  },
  {
    "frequency": 66,
    "simplified": "茕茕孑立",
    "traditional": "煢煢孑立"
  },
  {
    "frequency": 66,
    "simplified": "堂皇富丽",
    "traditional": "堂皇富麗"
  },
  {
    "frequency": 66,
    "simplified": "昏头昏脑",
    "traditional": "昏頭昏腦"
  },
  {
    "frequency": 66,
    "simplified": "倚强凌弱",
    "traditional": "倚強凌弱"
  },
  {
    "frequency": 66,
    "simplified": "急不及待",
    "traditional": "急不及待"
  },
  {
    "frequency": 65,
    "simplified": "人多手杂",
    "traditional": "人多手雜"
  },
  {
    "frequency": 65,
    "simplified": "旁逸斜出",
    "traditional": "旁逸斜出"
  },
  {
    "frequency": 65,
    "simplified": "逞强好胜",
    "traditional": "逞強好勝"
  },
  {
    "frequency": 65,
    "simplified": "呼之即来",
    "traditional": "呼之即來"
  },
  {
    "frequency": 65,
    "simplified": "夜阑人静",
    "traditional": "夜闌人靜"
  },
  {
    "frequency": 65,
    "simplified": "纯属骗局",
    "traditional": "純屬騙局"
  },
  {
    "frequency": 65,
    "simplified": "以人为鉴",
    "traditional": "以人為鑑"
  },
  {
    "frequency": 65,
    "simplified": "绕梁三日",
    "traditional": "繞梁三日"
  },
  {
    "frequency": 65,
    "simplified": "垂手可得",
    "traditional": "垂手可得"
  },
  {
    "frequency": 65,
    "simplified": "酣然入梦",
    "traditional": "酣然入夢"
  },
  {
    "frequency": 65,
    "simplified": "言者谆谆",
    "traditional": "言者諄諄"
  },
  {
    "frequency": 65,
    "simplified": "贪财好色",
    "traditional": "貪財好色"
  },
  {
    "frequency": 65,
    "simplified": "八方支持",
    "traditional": "八方支持"
  },
  {
    "frequency": 65,
    "simplified": "上无片瓦",
    "traditional": "上無片瓦"
  },
  {
    "frequency": 65,
    "simplified": "山高水远",
    "traditional": "山高水遠"
  },
  {
    "frequency": 65,
    "simplified": "子为父隐",
    "traditional": "子為父隱"
  },
  {
    "frequency": 65,
    "simplified": "狗仗人势",
    "traditional": "狗仗人勢"
  },
  {
    "frequency": 65,
    "simplified": "慎重其事",
    "traditional": "慎重其事"
  },
  {
    "frequency": 65,
    "simplified": "军容风纪",
    "traditional": "軍容風紀"
  },
  {
    "frequency": 65,
    "simplified": "默默无声",
    "traditional": "默默無聲"
  },
  {
    "frequency": 65,
    "simplified": "不过尔尔",
    "traditional": "不過爾爾"
  },
  {
    "frequency": 65,
    "simplified": "浑身是胆",
    "traditional": "渾身是膽"
  },
  {
    "frequency": 65,
    "simplified": "古稀之年",
    "traditional": "古稀之年"
  },
  {
    "frequency": 65,
    "simplified": "寸草春晖",
    "traditional": "寸草春暉"
  },
  {
    "frequency": 65,
    "simplified": "脑满肠肥",
    "traditional": "腦滿腸肥"
  },
  {
    "frequency": 64,
    "simplified": "画中有诗",
    "traditional": "畫中有詩"
  },
  {
    "frequency": 64,
    "simplified": "肝脑涂地",
    "traditional": "肝腦塗地"
  },
  {
    "frequency": 64,
    "simplified": "挨门逐户",
    "traditional": "挨門逐戶"
  },
  {
    "frequency": 64,
    "simplified": "人模狗样",
    "traditional": "人模狗樣"
  },
  {
    "frequency": 64,
    "simplified": "枯瘦如柴",
    "traditional": "枯瘦如柴"
  },
  {
    "frequency": 64,
    "simplified": "云消雾散",
    "traditional": "雲消霧散"
  },
  {
    "frequency": 64,
    "simplified": "朝秦暮楚",
    "traditional": "朝秦暮楚"
  },
  {
    "frequency": 64,
    "simplified": "区区小事",
    "traditional": "區區小事"
  },
  {
    "frequency": 64,
    "simplified": "大巧若拙",
    "traditional": "大巧若拙"
  },
  {
    "frequency": 64,
    "simplified": "立于不败",
    "traditional": "立於不敗"
  },
  {
    "frequency": 64,
    "simplified": "羽扇纶巾",
    "traditional": "羽扇綸巾"
  },
  {
    "frequency": 64,
    "simplified": "敢怒敢言",
    "traditional": "敢怒敢言"
  },
  {
    "frequency": 64,
    "simplified": "慢声细语",
    "traditional": "慢聲細語"
  },
  {
    "frequency": 64,
    "simplified": "时移势易",
    "traditional": "時移勢易"
  },
  {
    "frequency": 64,
    "simplified": "柔肠寸断",
    "traditional": "柔腸寸斷"
  },
  {
    "frequency": 64,
    "simplified": "其不善者而改之",
    "traditional": "其不善者而改之"
  },
  {
    "frequency": 64,
    "simplified": "一无所长",
    "traditional": "一無所長"
  },
  {
    "frequency": 64,
    "simplified": "举止言谈",
    "traditional": "舉止言談"
  },
  {
    "frequency": 64,
    "simplified": "尺寸之功",
    "traditional": "尺寸之功"
  },
  {
    "frequency": 64,
    "simplified": "见龙卸甲",
    "traditional": "見龍卸甲"
  },
  {
    "frequency": 64,
    "simplified": "罪该万死",
    "traditional": "罪該萬死"
  },
  {
    "frequency": 64,
    "simplified": "沾花惹草",
    "traditional": "沾花惹草"
  },
  {
    "frequency": 64,
    "simplified": "文武全才",
    "traditional": "文武全才"
  },
  {
    "frequency": 64,
    "simplified": "虽死犹生",
    "traditional": "雖死猶生"
  },
  {
    "frequency": 64,
    "simplified": "无补于事",
    "traditional": "無補於事"
  },
  {
    "frequency": 63,
    "simplified": "一唱三叹",
    "traditional": "一唱三嘆"
  },
  {
    "frequency": 63,
    "simplified": "草蛇灰线",
    "traditional": "草蛇灰線"
  },
  {
    "frequency": 63,
    "simplified": "不入虎穴",
    "traditional": "不入虎穴"
  },
  {
    "frequency": 63,
    "simplified": "用尽心机",
    "traditional": "用盡心機"
  },
  {
    "frequency": 63,
    "simplified": "地动山摇",
    "traditional": "地動山搖"
  },
  {
    "frequency": 63,
    "simplified": "东歪西倒",
    "traditional": "東歪西倒"
  },
  {
    "frequency": 63,
    "simplified": "杏花春雨",
    "traditional": "杏花春雨"
  },
  {
    "frequency": 63,
    "simplified": "弹指之间",
    "traditional": "彈指之間"
  },
  {
    "frequency": 63,
    "simplified": "敏而好学",
    "traditional": "敏而好學"
  },
  {
    "frequency": 63,
    "simplified": "细微末节",
    "traditional": "細微末節"
  },
  {
    "frequency": 63,
    "simplified": "母慈子孝",
    "traditional": "母慈子孝"
  },
  {
    "frequency": 63,
    "simplified": "欲加之罪何患无辞",
    "traditional": "欲加之罪何患無辭"
  },
  {
    "frequency": 63,
    "simplified": "别树一帜",
    "traditional": "別樹一幟"
  },
  {
    "frequency": 63,
    "simplified": "长生不死",
    "traditional": "長生不死"
  },
  {
    "frequency": 63,
    "simplified": "好声好气",
    "traditional": "好聲好氣"
  },
  {
    "frequency": 63,
    "simplified": "一箭之遥",
    "traditional": "一箭之遙"
  },
  {
    "frequency": 63,
    "simplified": "祸福相依",
    "traditional": "禍福相依"
  },
  {
    "frequency": 63,
    "simplified": "兵来将挡水来土掩",
    "traditional": "兵來將擋水來土掩"
  },
  {
    "frequency": 63,
    "simplified": "烈士暮年",
    "traditional": "烈士暮年"
  },
  {
    "frequency": 63,
    "simplified": "有耻且格",
    "traditional": "有恥且格"
  },
  {
    "frequency": 63,
    "simplified": "心口如一",
    "traditional": "心口如一"
  },
  {
    "frequency": 63,
    "simplified": "吃软不吃硬",
    "traditional": "吃軟不吃硬"
  },
  {
    "frequency": 63,
    "simplified": "万世师表",
    "traditional": "萬世師表"
  },
  {
    "frequency": 63,
    "simplified": "万语千言",
    "traditional": "萬語千言"
  },
  {
    "frequency": 62,
    "simplified": "奉为至宝",
    "traditional": "奉為至寶"
  },
  {
    "frequency": 62,
    "simplified": "诲淫诲盗",
    "traditional": "誨淫誨盜"
  },
  {
    "frequency": 62,
    "simplified": "不相为谋",
    "traditional": "不相為謀"
  },
  {
    "frequency": 62,
    "simplified": "为五斗米折腰",
    "traditional": "為五斗米折腰"
  },
  {
    "frequency": 62,
    "simplified": "浮生若梦",
    "traditional": "浮生若夢"
  },
  {
    "frequency": 62,
    "simplified": "吉凶祸福",
    "traditional": "吉凶禍福"
  },
  {
    "frequency": 62,
    "simplified": "话不投机半句多",
    "traditional": "話不投機半句多"
  },
  {
    "frequency": 62,
    "simplified": "名缰利锁",
    "traditional": "名韁利鎖"
  },
  {
    "frequency": 62,
    "simplified": "前车可鉴",
    "traditional": "前車可鑑"
  },
  {
    "frequency": 62,
    "simplified": "五方杂处",
    "traditional": "五方雜處"
  },
  {
    "frequency": 62,
    "simplified": "十字街口",
    "traditional": "十字街口"
  },
  {
    "frequency": 62,
    "simplified": "混混沌沌",
    "traditional": "混混沌沌"
  },
  {
    "frequency": 62,
    "simplified": "泛泛之交",
    "traditional": "泛泛之交"
  },
  {
    "frequency": 62,
    "simplified": "多不胜数",
    "traditional": "多不勝數"
  },
  {
    "frequency": 62,
    "simplified": "交口赞誉",
    "traditional": "交口讚譽"
  },
  {
    "frequency": 62,
    "simplified": "顾盼生辉",
    "traditional": "顧盼生輝"
  },
  {
    "frequency": 62,
    "simplified": "鱼肉乡里",
    "traditional": "魚肉鄉里"
  },
  {
    "frequency": 62,
    "simplified": "狂风恶浪",
    "traditional": "狂風惡浪"
  },
  {
    "frequency": 62,
    "simplified": "父为子隐",
    "traditional": "父為子隱"
  },
  {
    "frequency": 62,
    "simplified": "流年似水",
    "traditional": "流年似水"
  },
  {
    "frequency": 62,
    "simplified": "春生夏长",
    "traditional": "春生夏長"
  },
  {
    "frequency": 62,
    "simplified": "音容宛在",
    "traditional": "音容宛在"
  },
  {
    "frequency": 62,
    "simplified": "鸡鸣狗吠",
    "traditional": "雞鳴狗吠"
  },
  {
    "frequency": 62,
    "simplified": "才疏学浅",
    "traditional": "才疏學淺"
  },
  {
    "frequency": 62,
    "simplified": "西出阳关无故人",
    "traditional": "西出陽關無故人"
  },
  {
    "frequency": 62,
    "simplified": "防民之口",
    "traditional": "防民之口"
  },
  {
    "frequency": 61,
    "simplified": "人世沧桑",
    "traditional": "人世滄桑"
  },
  {
    "frequency": 61,
    "simplified": "别来无恙",
    "traditional": "別來無恙"
  },
  {
    "frequency": 61,
    "simplified": "波平浪静",
    "traditional": "波平浪靜"
  },
  {
    "frequency": 61,
    "simplified": "钟鸣鼎食",
    "traditional": "鐘鳴鼎食"
  },
  {
    "frequency": 61,
    "simplified": "金玉其外败絮其中",
    "traditional": "金玉其外敗絮其中"
  },
  {
    "frequency": 61,
    "simplified": "来处不易",
    "traditional": "來處不易"
  },
  {
    "frequency": 61,
    "simplified": "铁面无情",
    "traditional": "鐵面無情"
  },
  {
    "frequency": 61,
    "simplified": "逼人太甚",
    "traditional": "逼人太甚"
  },
  {
    "frequency": 61,
    "simplified": "瓜分豆剖",
    "traditional": "瓜分豆剖"
  },
  {
    "frequency": 61,
    "simplified": "赤身露体",
    "traditional": "赤身露體"
  },
  {
    "frequency": 61,
    "simplified": "卖国求荣",
    "traditional": "賣國求榮"
  },
  {
    "frequency": 61,
    "simplified": "狂涛巨浪",
    "traditional": "狂濤巨浪"
  },
  {
    "frequency": 61,
    "simplified": "安家乐业",
    "traditional": "安家樂業"
  },
  {
    "frequency": 61,
    "simplified": "改弦易张",
    "traditional": "改弦易張"
  },
  {
    "frequency": 61,
    "simplified": "置之死地",
    "traditional": "置之死地"
  },
  {
    "frequency": 61,
    "simplified": "低头哈腰",
    "traditional": "低頭哈腰"
  },
  {
    "frequency": 61,
    "simplified": "不见兔子不撒鹰",
    "traditional": "不見兔子不撒鷹"
  },
  {
    "frequency": 61,
    "simplified": "手疾眼快",
    "traditional": "手疾眼快"
  },
  {
    "frequency": 61,
    "simplified": "相机而动",
    "traditional": "相機而動"
  },
  {
    "frequency": 61,
    "simplified": "一夫当关万夫莫开",
    "traditional": "一夫當關萬夫莫開"
  },
  {
    "frequency": 61,
    "simplified": "百年之好",
    "traditional": "百年之好"
  },
  {
    "frequency": 61,
    "simplified": "山乡巨变",
    "traditional": "山鄉鉅變"
  },
  {
    "frequency": 61,
    "simplified": "有凤来仪",
    "traditional": "有鳳來儀"
  },
  {
    "frequency": 61,
    "simplified": "心无挂碍",
    "traditional": "心無掛礙"
  },
  {
    "frequency": 60,
    "simplified": "谈笑自若",
    "traditional": "談笑自若"
  },
  {
    "frequency": 60,
    "simplified": "寓意深长",
    "traditional": "寓意深長"
  },
  {
    "frequency": 60,
    "simplified": "嫉贤妒能",
    "traditional": "嫉賢妒能"
  },
  {
    "frequency": 60,
    "simplified": "楼台亭阁",
    "traditional": "樓臺亭閣"
  },
  {
    "frequency": 60,
    "simplified": "养虎遗患",
    "traditional": "養虎遺患"
  },
  {
    "frequency": 60,
    "simplified": "鹊巢鸠占",
    "traditional": "鵲巢鳩佔"
  },
  {
    "frequency": 60,
    "simplified": "锄强扶弱",
    "traditional": "鋤強扶弱"
  },
  {
    "frequency": 60,
    "simplified": "乘机而入",
    "traditional": "乘機而入"
  },
  {
    "frequency": 60,
    "simplified": "满目青山",
    "traditional": "滿目青山"
  },
  {
    "frequency": 60,
    "simplified": "诗中有画",
    "traditional": "詩中有畫"
  },
  {
    "frequency": 60,
    "simplified": "债多不愁",
    "traditional": "債多不愁"
  },
  {
    "frequency": 60,
    "simplified": "一男半女",
    "traditional": "一男半女"
  },
  {
    "frequency": 60,
    "simplified": "为善最乐",
    "traditional": "為善最樂"
  },
  {
    "frequency": 60,
    "simplified": "人不知鬼不觉",
    "traditional": "人不知鬼不覺"
  },
  {
    "frequency": 60,
    "simplified": "深信不疑",
    "traditional": "深信不疑"
  },
  {
    "frequency": 60,
    "simplified": "老于世故",
    "traditional": "老於世故"
  },
  {
    "frequency": 60,
    "simplified": "白云苍狗",
    "traditional": "白雲蒼狗"
  },
  {
    "frequency": 60,
    "simplified": "转战千里",
    "traditional": "轉戰千里"
  },
  {
    "frequency": 60,
    "simplified": "丁丁当当",
    "traditional": "丁丁當當"
  },
  {
    "frequency": 60,
    "simplified": "胸中块垒",
    "traditional": "胸中塊壘"
  },
  {
    "frequency": 60,
    "simplified": "大门不出二门不迈",
    "traditional": "大門不出二門不邁"
  },
  {
    "frequency": 60,
    "simplified": "清静无为",
    "traditional": "清靜無為"
  },
  {
    "frequency": 60,
    "simplified": "旭日初升",
    "traditional": "旭日初昇"
  },
  {
    "frequency": 60,
    "simplified": "春满人间",
    "traditional": "春滿人間"
  },
  {
    "frequency": 60,
    "simplified": "阴曹地府",
    "traditional": "陰曹地府"
  },
  {
    "frequency": 60,
    "simplified": "人事不知",
    "traditional": "人事不知"
  },
  {
    "frequency": 60,
    "simplified": "扶摇而上",
    "traditional": "扶搖而上"
  },
  {
    "frequency": 59,
    "simplified": "辩才无碍",
    "traditional": "辯才無礙"
  },
  {
    "frequency": 59,
    "simplified": "海不扬波",
    "traditional": "海不揚波"
  },
  {
    "frequency": 59,
    "simplified": "焚膏继晷",
    "traditional": "焚膏繼晷"
  },
  {
    "frequency": 59,
    "simplified": "庄周梦蝶",
    "traditional": "莊周夢蝶"
  },
  {
    "frequency": 59,
    "simplified": "极目远望",
    "traditional": "極目遠望"
  },
  {
    "frequency": 59,
    "simplified": "存乎一心",
    "traditional": "存乎一心"
  },
  {
    "frequency": 59,
    "simplified": "相形失色",
    "traditional": "相形失色"
  },
  {
    "frequency": 59,
    "simplified": "名门闺秀",
    "traditional": "名門閨秀"
  },
  {
    "frequency": 59,
    "simplified": "十字街头",
    "traditional": "十字街頭"
  },
  {
    "frequency": 59,
    "simplified": "忸怩作态",
    "traditional": "忸怩作態"
  },
  {
    "frequency": 59,
    "simplified": "调和阴阳",
    "traditional": "調和陰陽"
  },
  {
    "frequency": 59,
    "simplified": "知情不举",
    "traditional": "知情不舉"
  },
  {
    "frequency": 59,
    "simplified": "用兵如神",
    "traditional": "用兵如神"
  },
  {
    "frequency": 59,
    "simplified": "霄壤之别",
    "traditional": "霄壤之別"
  },
  {
    "frequency": 59,
    "simplified": "雷霆一击",
    "traditional": "雷霆一擊"
  },
  {
    "frequency": 59,
    "simplified": "偏信则暗",
    "traditional": "偏信則闇"
  },
  {
    "frequency": 59,
    "simplified": "响遏行云",
    "traditional": "響遏行雲"
  },
  {
    "frequency": 59,
    "simplified": "观者如云",
    "traditional": "觀者如雲"
  },
  {
    "frequency": 59,
    "simplified": "百花生日",
    "traditional": "百花生日"
  },
  {
    "frequency": 59,
    "simplified": "相见时难别亦难",
    "traditional": "相見時難別亦難"
  },
  {
    "frequency": 59,
    "simplified": "不分轩轾",
    "traditional": "不分軒輊"
  },
  {
    "frequency": 59,
    "simplified": "我见犹怜",
    "traditional": "我見猶憐"
  },
  {
    "frequency": 59,
    "simplified": "即兴之作",
    "traditional": "即興之作"
  },
  {
    "frequency": 59,
    "simplified": "焉得虎子",
    "traditional": "焉得虎子"
  },
  {
    "frequency": 59,
    "simplified": "小不忍则乱大谋",
    "traditional": "小不忍則亂大謀"
  },
  {
    "frequency": 59,
    "simplified": "积年累月",
    "traditional": "積年累月"
  },
  {
    "frequency": 58,
    "simplified": "无敌于天下",
    "traditional": "無敵於天下"
  },
  {
    "frequency": 58,
    "simplified": "义结金兰",
    "traditional": "義結金蘭"
  },
  {
    "frequency": 58,
    "simplified": "姜是老的辣",
    "traditional": "薑是老的辣"
  },
  {
    "frequency": 58,
    "simplified": "翩若惊鸿",
    "traditional": "翩若驚鴻"
  },
  {
    "frequency": 58,
    "simplified": "兄友弟恭",
    "traditional": "兄友弟恭"
  },
  {
    "frequency": 58,
    "simplified": "男大当婚女大当嫁",
    "traditional": "男大當婚女大當嫁"
  },
  {
    "frequency": 58,
    "simplified": "如丧考妣",
    "traditional": "如喪考妣"
  },
  {
    "frequency": 58,
    "simplified": "玉不琢不成器",
    "traditional": "玉不琢不成器"
  },
  {
    "frequency": 58,
    "simplified": "博拉尔德",
    "traditional": "博拉爾德"
  },
  {
    "frequency": 58,
    "simplified": "两面夹攻",
    "traditional": "兩面夾攻"
  },
  {
    "frequency": 58,
    "simplified": "敲骨吸髓",
    "traditional": "敲骨吸髓"
  },
  {
    "frequency": 58,
    "simplified": "横行天下",
    "traditional": "橫行天下"
  },
  {
    "frequency": 58,
    "simplified": "人活一张脸",
    "traditional": "人活一張臉"
  },
  {
    "frequency": 58,
    "simplified": "寻根问底",
    "traditional": "尋根問底"
  },
  {
    "frequency": 58,
    "simplified": "罪恶深重",
    "traditional": "罪惡深重"
  },
  {
    "frequency": 58,
    "simplified": "有口无心",
    "traditional": "有口無心"
  },
  {
    "frequency": 58,
    "simplified": "正直无私",
    "traditional": "正直無私"
  },
  {
    "frequency": 58,
    "simplified": "年老力衰",
    "traditional": "年老力衰"
  },
  {
    "frequency": 58,
    "simplified": "流言飞语",
    "traditional": "流言飛語"
  },
  {
    "frequency": 57,
    "simplified": "烈火见真金",
    "traditional": "烈火見真金"
  },
  {
    "frequency": 57,
    "simplified": "问鼎中原",
    "traditional": "問鼎中原"
  },
  {
    "frequency": 57,
    "simplified": "百般折磨",
    "traditional": "百般折磨"
  },
  {
    "frequency": 57,
    "simplified": "出将入相",
    "traditional": "出將入相"
  },
  {
    "frequency": 57,
    "simplified": "开花结实",
    "traditional": "開花結實"
  },
  {
    "frequency": 57,
    "simplified": "一则以喜",
    "traditional": "一則以喜"
  },
  {
    "frequency": 57,
    "simplified": "以身试险",
    "traditional": "以身試險"
  },
  {
    "frequency": 57,
    "simplified": "公道合理",
    "traditional": "公道合理"
  },
  {
    "frequency": 57,
    "simplified": "天知地知你知我知",
    "traditional": "天知地知你知我知"
  },
  {
    "frequency": 57,
    "simplified": "送往迎来",
    "traditional": "送往迎來"
  },
  {
    "frequency": 57,
    "simplified": "血口喷人",
    "traditional": "血口噴人"
  },
  {
    "frequency": 57,
    "simplified": "衮衮诸公",
    "traditional": "袞袞諸公"
  },
  {
    "frequency": 57,
    "simplified": "落草为寇",
    "traditional": "落草為寇"
  },
  {
    "frequency": 57,
    "simplified": "凤凰于飞",
    "traditional": "鳳凰于飛"
  },
  {
    "frequency": 57,
    "simplified": "是非之心",
    "traditional": "是非之心"
  },
  {
    "frequency": 57,
    "simplified": "离乡别井",
    "traditional": "離鄉別井"
  },
  {
    "frequency": 57,
    "simplified": "口蜜腹剑",
    "traditional": "口蜜腹劍"
  },
  {
    "frequency": 57,
    "simplified": "避实击虚",
    "traditional": "避實擊虛"
  },
  {
    "frequency": 57,
    "simplified": "不幸而言中",
    "traditional": "不幸而言中"
  },
  {
    "frequency": 57,
    "simplified": "七窍生烟",
    "traditional": "七竅生煙"
  },
  {
    "frequency": 57,
    "simplified": "雕栏玉砌",
    "traditional": "雕欄玉砌"
  },
  {
    "frequency": 57,
    "simplified": "君子一言",
    "traditional": "君子一言"
  },
  {
    "frequency": 57,
    "simplified": "青枝绿叶",
    "traditional": "青枝綠葉"
  },
  {
    "frequency": 57,
    "simplified": "说千道万",
    "traditional": "說千道萬"
  },
  {
    "frequency": 57,
    "simplified": "明眸善睐",
    "traditional": "明眸善睞"
  },
  {
    "frequency": 57,
    "simplified": "首尾两端",
    "traditional": "首尾兩端"
  },
  {
    "frequency": 57,
    "simplified": "财不露白",
    "traditional": "財不露白"
  },
  {
    "frequency": 57,
    "simplified": "披沙拣金",
    "traditional": "披沙揀金"
  },
  {
    "frequency": 57,
    "simplified": "衣冠禽兽",
    "traditional": "衣冠禽獸"
  },
  {
    "frequency": 57,
    "simplified": "人寿年丰",
    "traditional": "人壽年豐"
  },
  {
    "frequency": 57,
    "simplified": "略高一筹",
    "traditional": "略高一籌"
  },
  {
    "frequency": 56,
    "simplified": "水光山色",
    "traditional": "水光山色"
  },
  {
    "frequency": 56,
    "simplified": "奸淫掳掠",
    "traditional": "姦淫擄掠"
  },
  {
    "frequency": 56,
    "simplified": "六道轮回",
    "traditional": "六道輪迴"
  },
  {
    "frequency": 56,
    "simplified": "柳绿花红",
    "traditional": "柳綠花紅"
  },
  {
    "frequency": 56,
    "simplified": "永垂青史",
    "traditional": "永垂青史"
  },
  {
    "frequency": 56,
    "simplified": "自愧弗如",
    "traditional": "自愧弗如"
  },
  {
    "frequency": 56,
    "simplified": "养兵千日用兵一时",
    "traditional": "養兵千日用兵一時"
  },
  {
    "frequency": 56,
    "simplified": "刀山火海",
    "traditional": "刀山火海"
  },
  {
    "frequency": 56,
    "simplified": "刻骨仇恨",
    "traditional": "刻骨仇恨"
  },
  {
    "frequency": 56,
    "simplified": "畸重畸轻",
    "traditional": "畸重畸輕"
  },
  {
    "frequency": 56,
    "simplified": "足不出门",
    "traditional": "足不出門"
  },
  {
    "frequency": 56,
    "simplified": "吹面不寒杨柳风",
    "traditional": "吹面不寒楊柳風"
  },
  {
    "frequency": 56,
    "simplified": "以子之矛攻子之盾",
    "traditional": "以子之矛攻子之盾"
  },
  {
    "frequency": 56,
    "simplified": "不知其可",
    "traditional": "不知其可"
  },
  {
    "frequency": 56,
    "simplified": "不见棺材不掉泪",
    "traditional": "不見棺材不掉淚"
  },
  {
    "frequency": 56,
    "simplified": "天下本无事",
    "traditional": "天下本無事"
  },
  {
    "frequency": 56,
    "simplified": "摇尾乞怜",
    "traditional": "搖尾乞憐"
  },
  {
    "frequency": 56,
    "simplified": "一片冰心",
    "traditional": "一片冰心"
  },
  {
    "frequency": 56,
    "simplified": "积小成大",
    "traditional": "積小成大"
  },
  {
    "frequency": 56,
    "simplified": "平地一声雷",
    "traditional": "平地一聲雷"
  },
  {
    "frequency": 56,
    "simplified": "死不足惜",
    "traditional": "死不足惜"
  },
  {
    "frequency": 56,
    "simplified": "人多眼杂",
    "traditional": "人多眼雜"
  },
  {
    "frequency": 56,
    "simplified": "弄巧反拙",
    "traditional": "弄巧反拙"
  },
  {
    "frequency": 56,
    "simplified": "初试锋芒",
    "traditional": "初試鋒芒"
  },
  {
    "frequency": 55,
    "simplified": "大仁大义",
    "traditional": "大仁大義"
  },
  {
    "frequency": 55,
    "simplified": "无可无不可",
    "traditional": "無可無不可"
  },
  {
    "frequency": 55,
    "simplified": "短小精干",
    "traditional": "短小精幹"
  },
  {
    "frequency": 55,
    "simplified": "绿肥红瘦",
    "traditional": "綠肥紅瘦"
  },
  {
    "frequency": 55,
    "simplified": "夫子自道",
    "traditional": "夫子自道"
  },
  {
    "frequency": 55,
    "simplified": "人非圣贤孰能无过",
    "traditional": "人非聖賢孰能無過"
  },
  {
    "frequency": 55,
    "simplified": "哭天抹泪",
    "traditional": "哭天抹淚"
  },
  {
    "frequency": 55,
    "simplified": "煞费心机",
    "traditional": "煞費心機"
  },
  {
    "frequency": 55,
    "simplified": "走为上计",
    "traditional": "走為上計"
  },
  {
    "frequency": 55,
    "simplified": "覆巢之下无完卵",
    "traditional": "覆巢之下無完卵"
  },
  {
    "frequency": 55,
    "simplified": "莫可奈何",
    "traditional": "莫可奈何"
  },
  {
    "frequency": 55,
    "simplified": "笼中之鸟",
    "traditional": "籠中之鳥"
  },
  {
    "frequency": 55,
    "simplified": "决一雌雄",
    "traditional": "決一雌雄"
  },
  {
    "frequency": 55,
    "simplified": "民胞物与",
    "traditional": "民胞物與"
  },
  {
    "frequency": 55,
    "simplified": "小人得志",
    "traditional": "小人得志"
  },
  {
    "frequency": 55,
    "simplified": "铁壁铜墙",
    "traditional": "鐵壁銅牆"
  },
  {
    "frequency": 55,
    "simplified": "穷奢极侈",
    "traditional": "窮奢極侈"
  },
  {
    "frequency": 55,
    "simplified": "扬幡招魂",
    "traditional": "揚幡招魂"
  },
  {
    "frequency": 55,
    "simplified": "硕大无朋",
    "traditional": "碩大無朋"
  },
  {
    "frequency": 55,
    "simplified": "狗头军师",
    "traditional": "狗頭軍師"
  },
  {
    "frequency": 55,
    "simplified": "神思恍惚",
    "traditional": "神思恍惚"
  },
  {
    "frequency": 55,
    "simplified": "徐娘半老",
    "traditional": "徐娘半老"
  },
  {
    "frequency": 55,
    "simplified": "贵在知心",
    "traditional": "貴在知心"
  },
  {
    "frequency": 55,
    "simplified": "驽马十驾",
    "traditional": "駑馬十駕"
  },
  {
    "frequency": 55,
    "simplified": "佶屈聱牙",
    "traditional": "佶屈聱牙"
  },
  {
    "frequency": 55,
    "simplified": "以古为镜",
    "traditional": "以古為鏡"
  },
  {
    "frequency": 55,
    "simplified": "救民于水火",
    "traditional": "救民於水火"
  },
  {
    "frequency": 55,
    "simplified": "引以为耻",
    "traditional": "引以為恥"
  },
  {
    "frequency": 54,
    "simplified": "八字没一撇",
    "traditional": "八字沒一撇"
  },
  {
    "frequency": 54,
    "simplified": "鼎足之势",
    "traditional": "鼎足之勢"
  },
  {
    "frequency": 54,
    "simplified": "称心满意",
    "traditional": "稱心滿意"
  },
  {
    "frequency": 54,
    "simplified": "有其父必有其子",
    "traditional": "有其父必有其子"
  },
  {
    "frequency": 54,
    "simplified": "饱暖思淫欲",
    "traditional": "飽暖思淫慾"
  },
  {
    "frequency": 54,
    "simplified": "天时不如地利",
    "traditional": "天時不如地利"
  },
  {
    "frequency": 54,
    "simplified": "不值一哂",
    "traditional": "不值一哂"
  },
  {
    "frequency": 54,
    "simplified": "藏头露尾",
    "traditional": "藏頭露尾"
  },
  {
    "frequency": 54,
    "simplified": "芬芳馥郁",
    "traditional": "芬芳馥郁"
  },
  {
    "frequency": 54,
    "simplified": "危急存亡",
    "traditional": "危急存亡"
  },
  {
    "frequency": 54,
    "simplified": "私心杂念",
    "traditional": "私心雜念"
  },
  {
    "frequency": 54,
    "simplified": "百读不厌",
    "traditional": "百讀不厭"
  },
  {
    "frequency": 54,
    "simplified": "借坡下驴",
    "traditional": "借坡下驢"
  },
  {
    "frequency": 54,
    "simplified": "儿女情长",
    "traditional": "兒女情長"
  },
  {
    "frequency": 54,
    "simplified": "篡党夺权",
    "traditional": "篡黨奪權"
  },
  {
    "frequency": 54,
    "simplified": "草草收兵",
    "traditional": "草草收兵"
  },
  {
    "frequency": 54,
    "simplified": "太平盛世",
    "traditional": "太平盛世"
  },
  {
    "frequency": 54,
    "simplified": "将功赎罪",
    "traditional": "將功贖罪"
  },
  {
    "frequency": 54,
    "simplified": "刁钻古怪",
    "traditional": "刁鑽古怪"
  },
  {
    "frequency": 54,
    "simplified": "四方八面",
    "traditional": "四方八面"
  },
  {
    "frequency": 54,
    "simplified": "不识好歹",
    "traditional": "不識好歹"
  },
  {
    "frequency": 54,
    "simplified": "得意之色",
    "traditional": "得意之色"
  },
  {
    "frequency": 54,
    "simplified": "上知天文下知地理",
    "traditional": "上知天文下知地理"
  },
  {
    "frequency": 54,
    "simplified": "十二万分",
    "traditional": "十二萬分"
  },
  {
    "frequency": 54,
    "simplified": "弃如敝屣",
    "traditional": "棄如敝屣"
  },
  {
    "frequency": 54,
    "simplified": "火上添油",
    "traditional": "火上添油"
  },
  {
    "frequency": 53,
    "simplified": "相煎何急",
    "traditional": "相煎何急"
  },
  {
    "frequency": 53,
    "simplified": "洞察秋毫",
    "traditional": "洞察秋毫"
  },
  {
    "frequency": 53,
    "simplified": "两虎相争",
    "traditional": "兩虎相爭"
  },
  {
    "frequency": 53,
    "simplified": "本小利薄",
    "traditional": "本小利薄"
  },
  {
    "frequency": 53,
    "simplified": "弥天大祸",
    "traditional": "彌天大禍"
  },
  {
    "frequency": 53,
    "simplified": "稍胜一筹",
    "traditional": "稍勝一籌"
  },
  {
    "frequency": 53,
    "simplified": "喃喃细语",
    "traditional": "喃喃細語"
  },
  {
    "frequency": 53,
    "simplified": "残兵败将",
    "traditional": "殘兵敗將"
  },
  {
    "frequency": 53,
    "simplified": "悠游自在",
    "traditional": "悠遊自在"
  },
  {
    "frequency": 53,
    "simplified": "大吹大擂",
    "traditional": "大吹大擂"
  },
  {
    "frequency": 53,
    "simplified": "风云变色",
    "traditional": "風雲變色"
  },
  {
    "frequency": 53,
    "simplified": "只知其一",
    "traditional": "只知其一"
  },
  {
    "frequency": 53,
    "simplified": "头悬梁锥刺股",
    "traditional": "頭懸梁錐刺股"
  },
  {
    "frequency": 53,
    "simplified": "毫不利己专门利人",
    "traditional": "毫不利己專門利人"
  },
  {
    "frequency": 53,
    "simplified": "送旧迎新",
    "traditional": "送舊迎新"
  },
  {
    "frequency": 53,
    "simplified": "漫天开价",
    "traditional": "漫天開價"
  },
  {
    "frequency": 53,
    "simplified": "蜚短流长",
    "traditional": "蜚短流長"
  },
  {
    "frequency": 53,
    "simplified": "聚讼纷纭",
    "traditional": "聚訟紛紜"
  },
  {
    "frequency": 53,
    "simplified": "地利不如人和",
    "traditional": "地利不如人和"
  },
  {
    "frequency": 53,
    "simplified": "一物不知",
    "traditional": "一物不知"
  },
  {
    "frequency": 53,
    "simplified": "深恶痛疾",
    "traditional": "深惡痛疾"
  },
  {
    "frequency": 53,
    "simplified": "餐风露宿",
    "traditional": "餐風露宿"
  },
  {
    "frequency": 53,
    "simplified": "一孔之见",
    "traditional": "一孔之見"
  },
  {
    "frequency": 53,
    "simplified": "屡次三番",
    "traditional": "屢次三番"
  },
  {
    "frequency": 53,
    "simplified": "大谬不然",
    "traditional": "大謬不然"
  },
  {
    "frequency": 53,
    "simplified": "贪小失大",
    "traditional": "貪小失大"
  },
  {
    "frequency": 52,
    "simplified": "百足之虫",
    "traditional": "百足之蟲"
  },
  {
    "frequency": 52,
    "simplified": "先小人后君子",
    "traditional": "先小人後君子"
  },
  {
    "frequency": 52,
    "simplified": "轻于鸿毛",
    "traditional": "輕於鴻毛"
  },
  {
    "frequency": 52,
    "simplified": "于今为烈",
    "traditional": "於今為烈"
  },
  {
    "frequency": 52,
    "simplified": "丢盔卸甲",
    "traditional": "丟盔卸甲"
  },
  {
    "frequency": 52,
    "simplified": "雍容典雅",
    "traditional": "雍容典雅"
  },
  {
    "frequency": 52,
    "simplified": "六根清净",
    "traditional": "六根清淨"
  },
  {
    "frequency": 52,
    "simplified": "无从置喙",
    "traditional": "無從置喙"
  },
  {
    "frequency": 52,
    "simplified": "排难解纷",
    "traditional": "排難解紛"
  },
  {
    "frequency": 52,
    "simplified": "诗礼传家",
    "traditional": "詩禮傳家"
  },
  {
    "frequency": 52,
    "simplified": "非分之想",
    "traditional": "非分之想"
  },
  {
    "frequency": 52,
    "simplified": "驻颜有术",
    "traditional": "駐顏有術"
  },
  {
    "frequency": 52,
    "simplified": "白手兴家",
    "traditional": "白手興家"
  },
  {
    "frequency": 52,
    "simplified": "宽大为怀",
    "traditional": "寬大為懷"
  },
  {
    "frequency": 52,
    "simplified": "白浪滔天",
    "traditional": "白浪滔天"
  },
  {
    "frequency": 52,
    "simplified": "以夷制夷",
    "traditional": "以夷制夷"
  },
  {
    "frequency": 52,
    "simplified": "淡泊以明志",
    "traditional": "淡泊以明志"
  },
  {
    "frequency": 52,
    "simplified": "置之死地而后快",
    "traditional": "置之死地而後快"
  },
  {
    "frequency": 51,
    "simplified": "后悔不及",
    "traditional": "後悔不及"
  },
  {
    "frequency": 51,
    "simplified": "晓风残月",
    "traditional": "曉風殘月"
  },
  {
    "frequency": 51,
    "simplified": "金口玉言",
    "traditional": "金口玉言"
  },
  {
    "frequency": 51,
    "simplified": "脉脉含情",
    "traditional": "脈脈含情"
  },
  {
    "frequency": 51,
    "simplified": "甘之若饴",
    "traditional": "甘之若飴"
  },
  {
    "frequency": 51,
    "simplified": "知人知面不知心",
    "traditional": "知人知面不知心"
  },
  {
    "frequency": 51,
    "simplified": "神不守舍",
    "traditional": "神不守舍"
  },
  {
    "frequency": 51,
    "simplified": "士别三日",
    "traditional": "士別三日"
  },
  {
    "frequency": 51,
    "simplified": "戴高帽子",
    "traditional": "戴高帽子"
  },
  {
    "frequency": 51,
    "simplified": "丑态毕露",
    "traditional": "醜態畢露"
  },
  {
    "frequency": 51,
    "simplified": "人人得而诛之",
    "traditional": "人人得而誅之"
  },
  {
    "frequency": 51,
    "simplified": "崛地而起",
    "traditional": "崛地而起"
  },
  {
    "frequency": 51,
    "simplified": "少安毋躁",
    "traditional": "少安毋躁"
  },
  {
    "frequency": 51,
    "simplified": "涕泪交加",
    "traditional": "涕淚交加"
  },
  {
    "frequency": 51,
    "simplified": "森严壁垒",
    "traditional": "森嚴壁壘"
  },
  {
    "frequency": 51,
    "simplified": "不足为据",
    "traditional": "不足為據"
  },
  {
    "frequency": 51,
    "simplified": "百病丛生",
    "traditional": "百病叢生"
  },
  {
    "frequency": 51,
    "simplified": "坦然自若",
    "traditional": "坦然自若"
  },
  {
    "frequency": 51,
    "simplified": "酒囊饭袋",
    "traditional": "酒囊飯袋"
  },
  {
    "frequency": 51,
    "simplified": "相反相成",
    "traditional": "相反相成"
  },
  {
    "frequency": 51,
    "simplified": "水过地皮湿",
    "traditional": "水過地皮溼"
  },
  {
    "frequency": 50,
    "simplified": "聪颖过人",
    "traditional": "聰穎過人"
  },
  {
    "frequency": 50,
    "simplified": "急如星火",
    "traditional": "急如星火"
  },
  {
    "frequency": 50,
    "simplified": "妇人之仁",
    "traditional": "婦人之仁"
  },
  {
    "frequency": 50,
    "simplified": "兵马未动粮草先行",
    "traditional": "兵馬未動糧草先行"
  },
  {
    "frequency": 50,
    "simplified": "夜不成寐",
    "traditional": "夜不成寐"
  },
  {
    "frequency": 50,
    "simplified": "一动不如一静",
    "traditional": "一動不如一靜"
  },
  {
    "frequency": 50,
    "simplified": "新来乍到",
    "traditional": "新來乍到"
  },
  {
    "frequency": 50,
    "simplified": "血染沙场",
    "traditional": "血染沙場"
  },
  {
    "frequency": 50,
    "simplified": "不求闻达",
    "traditional": "不求聞達"
  },
  {
    "frequency": 50,
    "simplified": "不生不灭",
    "traditional": "不生不滅"
  },
  {
    "frequency": 50,
    "simplified": "不蔓不枝",
    "traditional": "不蔓不枝"
  },
  {
    "frequency": 50,
    "simplified": "史不绝书",
    "traditional": "史不絕書"
  },
  {
    "frequency": 50,
    "simplified": "成事不足败事有余",
    "traditional": "成事不足敗事有餘"
  },
  {
    "frequency": 50,
    "simplified": "撒豆成兵",
    "traditional": "撒豆成兵"
  },
  {
    "frequency": 50,
    "simplified": "脉络分明",
    "traditional": "脈絡分明"
  },
  {
    "frequency": 50,
    "simplified": "峨冠博带",
    "traditional": "峨冠博帶"
  },
  {
    "frequency": 50,
    "simplified": "饱汉不知饿汉饥",
    "traditional": "飽漢不知餓漢飢"
  },
  {
    "frequency": 50,
    "simplified": "一抔黄土",
    "traditional": "一抔黃土"
  },
  {
    "frequency": 50,
    "simplified": "杀鸡骇猴",
    "traditional": "殺雞駭猴"
  },
  {
    "frequency": 50,
    "simplified": "首善之地",
    "traditional": "首善之地"
  },
  {
    "frequency": 50,
    "simplified": "饱经忧患",
    "traditional": "飽經憂患"
  },
  {
    "frequency": 49,
    "simplified": "人无远虑必有近忧",
    "traditional": "人無遠慮必有近憂"
  },
  {
    "frequency": 49,
    "simplified": "脸红耳赤",
    "traditional": "臉紅耳赤"
  },
  {
    "frequency": 49,
    "simplified": "法不阿贵",
    "traditional": "法不阿貴"
  },
  {
    "frequency": 49,
    "simplified": "期期艾艾",
    "traditional": "期期艾艾"
  },
  {
    "frequency": 49,
    "simplified": "缩衣节食",
    "traditional": "縮衣節食"
  },
  {
    "frequency": 49,
    "simplified": "轻装简从",
    "traditional": "輕裝簡從"
  },
  {
    "frequency": 49,
    "simplified": "所费不赀",
    "traditional": "所費不貲"
  },
  {
    "frequency": 49,
    "simplified": "积毁销骨",
    "traditional": "積毀銷骨"
  },
  {
    "frequency": 49,
    "simplified": "唾面自干",
    "traditional": "唾面自乾"
  },
  {
    "frequency": 49,
    "simplified": "浩浩汤汤",
    "traditional": "浩浩湯湯"
  },
  {
    "frequency": 49,
    "simplified": "真伪莫辨",
    "traditional": "真偽莫辨"
  },
  {
    "frequency": 49,
    "simplified": "福无双至",
    "traditional": "福無雙至"
  },
  {
    "frequency": 49,
    "simplified": "猜拳行令",
    "traditional": "猜拳行令"
  },
  {
    "frequency": 49,
    "simplified": "不无小补",
    "traditional": "不無小補"
  },
  {
    "frequency": 49,
    "simplified": "勇者不惧",
    "traditional": "勇者不懼"
  },
  {
    "frequency": 49,
    "simplified": "顾头不顾尾",
    "traditional": "顧頭不顧尾"
  },
  {
    "frequency": 49,
    "simplified": "青灯黄卷",
    "traditional": "青燈黃卷"
  },
  {
    "frequency": 49,
    "simplified": "人间重晚晴",
    "traditional": "人間重晚晴"
  },
  {
    "frequency": 49,
    "simplified": "官样文章",
    "traditional": "官樣文章"
  },
  {
    "frequency": 49,
    "simplified": "转忧为喜",
    "traditional": "轉憂為喜"
  },
  {
    "frequency": 49,
    "simplified": "心焦如焚",
    "traditional": "心焦如焚"
  },
  {
    "frequency": 49,
    "simplified": "一枕黄粱",
    "traditional": "一枕黃粱"
  },
  {
    "frequency": 49,
    "simplified": "言之谆谆",
    "traditional": "言之諄諄"
  },
  {
    "frequency": 49,
    "simplified": "单丝不成线",
    "traditional": "單絲不成線"
  },
  {
    "frequency": 49,
    "simplified": "逢山开道",
    "traditional": "逢山開道"
  },
  {
    "frequency": 49,
    "simplified": "将熊熊一窝",
    "traditional": "將熊熊一窩"
  },
  {
    "frequency": 49,
    "simplified": "意在言外",
    "traditional": "意在言外"
  },
  {
    "frequency": 49,
    "simplified": "宝马香车",
    "traditional": "寶馬香車"
  },
  {
    "frequency": 48,
    "simplified": "追根求源",
    "traditional": "追根求源"
  },
  {
    "frequency": 48,
    "simplified": "铁嘴钢牙",
    "traditional": "鐵嘴鋼牙"
  },
  {
    "frequency": 48,
    "simplified": "借贷无门",
    "traditional": "借貸無門"
  },
  {
    "frequency": 48,
    "simplified": "放纵不羁",
    "traditional": "放縱不羈"
  },
  {
    "frequency": 48,
    "simplified": "倏忽之间",
    "traditional": "倏忽之間"
  },
  {
    "frequency": 48,
    "simplified": "开国元老",
    "traditional": "開國元老"
  },
  {
    "frequency": 48,
    "simplified": "苦不聊生",
    "traditional": "苦不聊生"
  },
  {
    "frequency": 48,
    "simplified": "命里注定",
    "traditional": "命裡註定"
  },
  {
    "frequency": 48,
    "simplified": "一笑一颦",
    "traditional": "一笑一顰"
  },
  {
    "frequency": 48,
    "simplified": "只知其一不知其二",
    "traditional": "只知其一不知其二"
  },
  {
    "frequency": 48,
    "simplified": "尔俸尔禄",
    "traditional": "爾俸爾祿"
  },
  {
    "frequency": 48,
    "simplified": "卖儿卖女",
    "traditional": "賣兒賣女"
  },
  {
    "frequency": 48,
    "simplified": "千金不换",
    "traditional": "千金不換"
  },
  {
    "frequency": 48,
    "simplified": "三宫六院",
    "traditional": "三宮六院"
  },
  {
    "frequency": 48,
    "simplified": "士可杀不可辱",
    "traditional": "士可殺不可辱"
  },
  {
    "frequency": 48,
    "simplified": "金刚怒目",
    "traditional": "金剛怒目"
  },
  {
    "frequency": 48,
    "simplified": "余味无穷",
    "traditional": "餘味無窮"
  },
  {
    "frequency": 48,
    "simplified": "文采风流",
    "traditional": "文采風流"
  },
  {
    "frequency": 48,
    "simplified": "众口相传",
    "traditional": "眾口相傳"
  },
  {
    "frequency": 48,
    "simplified": "五里雾中",
    "traditional": "五里霧中"
  },
  {
    "frequency": 48,
    "simplified": "老羞成怒",
    "traditional": "老羞成怒"
  },
  {
    "frequency": 48,
    "simplified": "天不作美",
    "traditional": "天不作美"
  },
  {
    "frequency": 48,
    "simplified": "穷家富路",
    "traditional": "窮家富路"
  },
  {
    "frequency": 48,
    "simplified": "犯上作乱",
    "traditional": "犯上作亂"
  },
  {
    "frequency": 48,
    "simplified": "知人论世",
    "traditional": "知人論世"
  },
  {
    "frequency": 48,
    "simplified": "数见不鲜",
    "traditional": "數見不鮮"
  },
  {
    "frequency": 48,
    "simplified": "言笑晏晏",
    "traditional": "言笑晏晏"
  },
  {
    "frequency": 48,
    "simplified": "骨肉至亲",
    "traditional": "骨肉至親"
  },
  {
    "frequency": 48,
    "simplified": "整军经武",
    "traditional": "整軍經武"
  },
  {
    "frequency": 48,
    "simplified": "寿山福海",
    "traditional": "壽山福海"
  },
  {
    "frequency": 48,
    "simplified": "天清气朗",
    "traditional": "天清氣朗"
  },
  {
    "frequency": 47,
    "simplified": "拒人千里",
    "traditional": "拒人千里"
  },
  {
    "frequency": 47,
    "simplified": "绳锯木断",
    "traditional": "繩鋸木斷"
  },
  {
    "frequency": 47,
    "simplified": "打铁趁热",
    "traditional": "打鐵趁熱"
  },
  {
    "frequency": 47,
    "simplified": "艰深晦涩",
    "traditional": "艱深晦澀"
  },
  {
    "frequency": 47,
    "simplified": "皇天不负苦心人",
    "traditional": "皇天不負苦心人"
  },
  {
    "frequency": 47,
    "simplified": "恒河沙数",
    "traditional": "恆河沙數"
  },
  {
    "frequency": 47,
    "simplified": "旁枝末节",
    "traditional": "旁枝末節"
  },
  {
    "frequency": 47,
    "simplified": "面如死灰",
    "traditional": "面如死灰"
  },
  {
    "frequency": 47,
    "simplified": "不避艰险",
    "traditional": "不避艱險"
  },
  {
    "frequency": 47,
    "simplified": "南船北马",
    "traditional": "南船北馬"
  },
  {
    "frequency": 47,
    "simplified": "少不经事",
    "traditional": "少不經事"
  },
  {
    "frequency": 47,
    "simplified": "无隙可乘",
    "traditional": "無隙可乘"
  },
  {
    "frequency": 47,
    "simplified": "酒肉朋友",
    "traditional": "酒肉朋友"
  },
  {
    "frequency": 47,
    "simplified": "闭门读书",
    "traditional": "閉門讀書"
  },
  {
    "frequency": 47,
    "simplified": "防民之口甚于防川",
    "traditional": "防民之口甚於防川"
  },
  {
    "frequency": 47,
    "simplified": "三拳两脚",
    "traditional": "三拳兩腳"
  },
  {
    "frequency": 47,
    "simplified": "谆谆善诱",
    "traditional": "諄諄善誘"
  },
  {
    "frequency": 47,
    "simplified": "以守为攻",
    "traditional": "以守為攻"
  },
  {
    "frequency": 47,
    "simplified": "狼心狗肺",
    "traditional": "狼心狗肺"
  },
  {
    "frequency": 47,
    "simplified": "过路财神",
    "traditional": "過路財神"
  },
  {
    "frequency": 47,
    "simplified": "霞光万道",
    "traditional": "霞光萬道"
  },
  {
    "frequency": 47,
    "simplified": "明枪易躲",
    "traditional": "明槍易躲"
  },
  {
    "frequency": 47,
    "simplified": "驰名天下",
    "traditional": "馳名天下"
  },
  {
    "frequency": 47,
    "simplified": "智者千虑",
    "traditional": "智者千慮"
  },
  {
    "frequency": 47,
    "simplified": "离合悲欢",
    "traditional": "離合悲歡"
  },
  {
    "frequency": 47,
    "simplified": "亦复如是",
    "traditional": "亦復如是"
  },
  {
    "frequency": 47,
    "simplified": "见利思义",
    "traditional": "見利思義"
  },
  {
    "frequency": 47,
    "simplified": "父母之邦",
    "traditional": "父母之邦"
  },
  {
    "frequency": 47,
    "simplified": "万里长征",
    "traditional": "萬里長征"
  },
  {
    "frequency": 47,
    "simplified": "万事胜意",
    "traditional": "萬事勝意"
  },
  {
    "frequency": 47,
    "simplified": "血泪斑斑",
    "traditional": "血淚斑斑"
  },
  {
    "frequency": 46,
    "simplified": "何足挂齿",
    "traditional": "何足掛齒"
  },
  {
    "frequency": 46,
    "simplified": "稀世之宝",
    "traditional": "稀世之寶"
  },
  {
    "frequency": 46,
    "simplified": "议论纷纭",
    "traditional": "議論紛紜"
  },
  {
    "frequency": 46,
    "simplified": "日思夜盼",
    "traditional": "日思夜盼"
  },
  {
    "frequency": 46,
    "simplified": "进道若退",
    "traditional": "進道若退"
  },
  {
    "frequency": 46,
    "simplified": "迁怒于人",
    "traditional": "遷怒於人"
  },
  {
    "frequency": 46,
    "simplified": "广征博引",
    "traditional": "廣徵博引"
  },
  {
    "frequency": 46,
    "simplified": "豺狼虎豹",
    "traditional": "豺狼虎豹"
  },
  {
    "frequency": 46,
    "simplified": "百废俱兴",
    "traditional": "百廢俱興"
  },
  {
    "frequency": 46,
    "simplified": "半文半白",
    "traditional": "半文半白"
  },
  {
    "frequency": 46,
    "simplified": "掎角之势",
    "traditional": "掎角之勢"
  },
  {
    "frequency": 46,
    "simplified": "别有天地",
    "traditional": "別有天地"
  },
  {
    "frequency": 46,
    "simplified": "惊慌失色",
    "traditional": "驚慌失色"
  },
  {
    "frequency": 46,
    "simplified": "大有可观",
    "traditional": "大有可觀"
  },
  {
    "frequency": 46,
    "simplified": "要而言之",
    "traditional": "要而言之"
  },
  {
    "frequency": 46,
    "simplified": "恻隐之心",
    "traditional": "惻隱之心"
  },
  {
    "frequency": 46,
    "simplified": "栉比鳞次",
    "traditional": "櫛比鱗次"
  },
  {
    "frequency": 46,
    "simplified": "岁月不居",
    "traditional": "歲月不居"
  },
  {
    "frequency": 46,
    "simplified": "无始无终",
    "traditional": "無始無終"
  },
  {
    "frequency": 46,
    "simplified": "夹枪带棒",
    "traditional": "夾槍帶棒"
  },
  {
    "frequency": 46,
    "simplified": "曲不离口",
    "traditional": "曲不離口"
  },
  {
    "frequency": 46,
    "simplified": "旷世奇才",
    "traditional": "曠世奇才"
  },
  {
    "frequency": 46,
    "simplified": "从容自在",
    "traditional": "從容自在"
  },
  {
    "frequency": 46,
    "simplified": "香车宝马",
    "traditional": "香車寶馬"
  },
  {
    "frequency": 46,
    "simplified": "寓情于景",
    "traditional": "寓情於景"
  },
  {
    "frequency": 46,
    "simplified": "狗屁不通",
    "traditional": "狗屁不通"
  },
  {
    "frequency": 46,
    "simplified": "桃李遍天下",
    "traditional": "桃李遍天下"
  },
  {
    "frequency": 46,
    "simplified": "打铁先得自身硬",
    "traditional": "打鐵先得自身硬"
  },
  {
    "frequency": 46,
    "simplified": "弃旧图新",
    "traditional": "棄舊圖新"
  },
  {
    "frequency": 46,
    "simplified": "杀父之仇",
    "traditional": "殺父之仇"
  },
  {
    "frequency": 46,
    "simplified": "令出必行",
    "traditional": "令出必行"
  },
  {
    "frequency": 46,
    "simplified": "视而不见听而不闻",
    "traditional": "視而不見聽而不聞"
  },
  {
    "frequency": 45,
    "simplified": "不到黄河心不死",
    "traditional": "不到黃河心不死"
  },
  {
    "frequency": 45,
    "simplified": "深宅大院",
    "traditional": "深宅大院"
  },
  {
    "frequency": 45,
    "simplified": "凭空捏造",
    "traditional": "憑空捏造"
  },
  {
    "frequency": 45,
    "simplified": "趑趄不前",
    "traditional": "趑趄不前"
  },
  {
    "frequency": 45,
    "simplified": "四肢百骸",
    "traditional": "四肢百骸"
  },
  {
    "frequency": 45,
    "simplified": "莫可名状",
    "traditional": "莫可名狀"
  },
  {
    "frequency": 45,
    "simplified": "截长补短",
    "traditional": "截長補短"
  },
  {
    "frequency": 45,
    "simplified": "半部论语治天下",
    "traditional": "半部論語治天下"
  },
  {
    "frequency": 45,
    "simplified": "痛入骨髓",
    "traditional": "痛入骨髓"
  },
  {
    "frequency": 45,
    "simplified": "兔死狗烹",
    "traditional": "兔死狗烹"
  },
  {
    "frequency": 45,
    "simplified": "勿谓言之不预也",
    "traditional": "勿謂言之不預也"
  },
  {
    "frequency": 45,
    "simplified": "哀兵必胜",
    "traditional": "哀兵必勝"
  },
  {
    "frequency": 45,
    "simplified": "仰之弥高",
    "traditional": "仰之彌高"
  },
  {
    "frequency": 45,
    "simplified": "苦海无边",
    "traditional": "苦海無邊"
  },
  {
    "frequency": 45,
    "simplified": "富贵在天",
    "traditional": "富貴在天"
  },
  {
    "frequency": 45,
    "simplified": "别出新意",
    "traditional": "別出新意"
  },
  {
    "frequency": 45,
    "simplified": "知其不可而为之",
    "traditional": "知其不可而為之"
  },
  {
    "frequency": 45,
    "simplified": "毫无所知",
    "traditional": "毫無所知"
  },
  {
    "frequency": 45,
    "simplified": "形销骨立",
    "traditional": "形銷骨立"
  },
  {
    "frequency": 45,
    "simplified": "一日三省",
    "traditional": "一日三省"
  },
  {
    "frequency": 45,
    "simplified": "吉人自有天相",
    "traditional": "吉人自有天相"
  },
  {
    "frequency": 45,
    "simplified": "位极人臣",
    "traditional": "位極人臣"
  },
  {
    "frequency": 45,
    "simplified": "荒唐无稽",
    "traditional": "荒唐無稽"
  },
  {
    "frequency": 45,
    "simplified": "雪泥鸿爪",
    "traditional": "雪泥鴻爪"
  },
  {
    "frequency": 45,
    "simplified": "存而不论",
    "traditional": "存而不論"
  },
  {
    "frequency": 45,
    "simplified": "临渴掘井",
    "traditional": "臨渴掘井"
  },
  {
    "frequency": 45,
    "simplified": "生死不渝",
    "traditional": "生死不渝"
  },
  {
    "frequency": 45,
    "simplified": "莫测高深",
    "traditional": "莫測高深"
  },
  {
    "frequency": 45,
    "simplified": "东游西逛",
    "traditional": "東遊西逛"
  },
  {
    "frequency": 45,
    "simplified": "酒色财气",
    "traditional": "酒色財氣"
  },
  {
    "frequency": 45,
    "simplified": "寻章摘句",
    "traditional": "尋章摘句"
  },
  {
    "frequency": 44,
    "simplified": "开门揖盗",
    "traditional": "開門揖盜"
  },
  {
    "frequency": 44,
    "simplified": "文房四宝",
    "traditional": "文房四寶"
  },
  {
    "frequency": 44,
    "simplified": "风月无边",
    "traditional": "風月無邊"
  },
  {
    "frequency": 44,
    "simplified": "寝不安席",
    "traditional": "寢不安席"
  },
  {
    "frequency": 44,
    "simplified": "纷纷攘攘",
    "traditional": "紛紛攘攘"
  },
  {
    "frequency": 44,
    "simplified": "再三再四",
    "traditional": "再三再四"
  },
  {
    "frequency": 44,
    "simplified": "死记硬背",
    "traditional": "死記硬背"
  },
  {
    "frequency": 44,
    "simplified": "从容自若",
    "traditional": "從容自若"
  },
  {
    "frequency": 44,
    "simplified": "安如泰山",
    "traditional": "安如泰山"
  },
  {
    "frequency": 44,
    "simplified": "志大才疏",
    "traditional": "志大才疏"
  },
  {
    "frequency": 44,
    "simplified": "油光可鉴",
    "traditional": "油光可鑑"
  },
  {
    "frequency": 44,
    "simplified": "斩关夺隘",
    "traditional": "斬關奪隘"
  },
  {
    "frequency": 44,
    "simplified": "一报还一报",
    "traditional": "一報還一報"
  },
  {
    "frequency": 44,
    "simplified": "不见棺材不落泪",
    "traditional": "不見棺材不落淚"
  },
  {
    "frequency": 44,
    "simplified": "若明若暗",
    "traditional": "若明若暗"
  },
  {
    "frequency": 44,
    "simplified": "瞒上欺下",
    "traditional": "瞞上欺下"
  },
  {
    "frequency": 44,
    "simplified": "愧不敢当",
    "traditional": "愧不敢當"
  },
  {
    "frequency": 44,
    "simplified": "清闲自在",
    "traditional": "清閒自在"
  },
  {
    "frequency": 44,
    "simplified": "剑及履及",
    "traditional": "劍及履及"
  },
  {
    "frequency": 44,
    "simplified": "金马碧鸡",
    "traditional": "金馬碧雞"
  },
  {
    "frequency": 44,
    "simplified": "甚于防川",
    "traditional": "甚於防川"
  },
  {
    "frequency": 44,
    "simplified": "豪放不羁",
    "traditional": "豪放不羈"
  },
  {
    "frequency": 44,
    "simplified": "人情世态",
    "traditional": "人情世態"
  },
  {
    "frequency": 44,
    "simplified": "冷血动物",
    "traditional": "冷血動物"
  },
  {
    "frequency": 44,
    "simplified": "囊萤映雪",
    "traditional": "囊螢映雪"
  },
  {
    "frequency": 44,
    "simplified": "秀才不出门",
    "traditional": "秀才不出門"
  },
  {
    "frequency": 44,
    "simplified": "大得人心",
    "traditional": "大得人心"
  },
  {
    "frequency": 44,
    "simplified": "一口一声",
    "traditional": "一口一聲"
  },
  {
    "frequency": 44,
    "simplified": "下笔千言",
    "traditional": "下筆千言"
  },
  {
    "frequency": 43,
    "simplified": "贼头贼脑",
    "traditional": "賊頭賊腦"
  },
  {
    "frequency": 43,
    "simplified": "余音缭绕",
    "traditional": "餘音繚繞"
  },
  {
    "frequency": 43,
    "simplified": "一往而深",
    "traditional": "一往而深"
  },
  {
    "frequency": 43,
    "simplified": "弥天大罪",
    "traditional": "彌天大罪"
  },
  {
    "frequency": 43,
    "simplified": "风牛马不相及",
    "traditional": "風牛馬不相及"
  },
  {
    "frequency": 43,
    "simplified": "显露头角",
    "traditional": "顯露頭角"
  },
  {
    "frequency": 43,
    "simplified": "沉郁顿挫",
    "traditional": "沉鬱頓挫"
  },
  {
    "frequency": 43,
    "simplified": "千金一诺",
    "traditional": "千金一諾"
  },
  {
    "frequency": 43,
    "simplified": "争妍斗艳",
    "traditional": "爭妍鬥豔"
  },
  {
    "frequency": 43,
    "simplified": "大喊大叫",
    "traditional": "大喊大叫"
  },
  {
    "frequency": 43,
    "simplified": "危急存亡之秋",
    "traditional": "危急存亡之秋"
  },
  {
    "frequency": 43,
    "simplified": "拉拉杂杂",
    "traditional": "拉拉雜雜"
  },
  {
    "frequency": 43,
    "simplified": "密不通风",
    "traditional": "密不通風"
  },
  {
    "frequency": 43,
    "simplified": "交杯换盏",
    "traditional": "交杯換盞"
  },
  {
    "frequency": 43,
    "simplified": "为人作嫁",
    "traditional": "為人作嫁"
  },
  {
    "frequency": 43,
    "simplified": "风流云散",
    "traditional": "風流雲散"
  },
  {
    "frequency": 43,
    "simplified": "姑妄言之",
    "traditional": "姑妄言之"
  },
  {
    "frequency": 43,
    "simplified": "予取予夺",
    "traditional": "予取予奪"
  },
  {
    "frequency": 43,
    "simplified": "滴水成河",
    "traditional": "滴水成河"
  },
  {
    "frequency": 43,
    "simplified": "江天一色",
    "traditional": "江天一色"
  },
  {
    "frequency": 43,
    "simplified": "油光水滑",
    "traditional": "油光水滑"
  },
  {
    "frequency": 43,
    "simplified": "何其相似乃尔",
    "traditional": "何其相似乃爾"
  },
  {
    "frequency": 43,
    "simplified": "万万千千",
    "traditional": "萬萬千千"
  },
  {
    "frequency": 43,
    "simplified": "蛇蝎心肠",
    "traditional": "蛇蠍心腸"
  },
  {
    "frequency": 43,
    "simplified": "日月经天",
    "traditional": "日月經天"
  },
  {
    "frequency": 43,
    "simplified": "临机应变",
    "traditional": "臨機應變"
  },
  {
    "frequency": 43,
    "simplified": "步人后尘",
    "traditional": "步人後塵"
  },
  {
    "frequency": 43,
    "simplified": "无源之水无本之木",
    "traditional": "無源之水無本之木"
  },
  {
    "frequency": 43,
    "simplified": "索然寡味",
    "traditional": "索然寡味"
  },
  {
    "frequency": 43,
    "simplified": "大发议论",
    "traditional": "大發議論"
  },
  {
    "frequency": 42,
    "simplified": "薪尽火传",
    "traditional": "薪盡火傳"
  },
  {
    "frequency": 42,
    "simplified": "异香扑鼻",
    "traditional": "異香撲鼻"
  },
  {
    "frequency": 42,
    "simplified": "抚今思昔",
    "traditional": "撫今思昔"
  },
  {
    "frequency": 42,
    "simplified": "兵多将广",
    "traditional": "兵多將廣"
  },
  {
    "frequency": 42,
    "simplified": "老之将至",
    "traditional": "老之將至"
  },
  {
    "frequency": 42,
    "simplified": "俯仰无愧",
    "traditional": "俯仰無愧"
  },
  {
    "frequency": 42,
    "simplified": "言出法随",
    "traditional": "言出法隨"
  },
  {
    "frequency": 42,
    "simplified": "巫山云雨",
    "traditional": "巫山雲雨"
  },
  {
    "frequency": 42,
    "simplified": "再造之恩",
    "traditional": "再造之恩"
  },
  {
    "frequency": 42,
    "simplified": "大中至正",
    "traditional": "大中至正"
  },
  {
    "frequency": 42,
    "simplified": "天差地远",
    "traditional": "天差地遠"
  },
  {
    "frequency": 42,
    "simplified": "独往独来",
    "traditional": "獨往獨來"
  },
  {
    "frequency": 42,
    "simplified": "说东道西",
    "traditional": "說東道西"
  },
  {
    "frequency": 42,
    "simplified": "杀伐决断",
    "traditional": "殺伐決斷"
  },
  {
    "frequency": 42,
    "simplified": "兵无常势",
    "traditional": "兵無常勢"
  },
  {
    "frequency": 42,
    "simplified": "不揣冒昧",
    "traditional": "不揣冒昧"
  },
  {
    "frequency": 42,
    "simplified": "笔酣墨饱",
    "traditional": "筆酣墨飽"
  },
  {
    "frequency": 42,
    "simplified": "东摇西摆",
    "traditional": "東搖西擺"
  },
  {
    "frequency": 42,
    "simplified": "不容置辩",
    "traditional": "不容置辯"
  },
  {
    "frequency": 42,
    "simplified": "乐而不淫",
    "traditional": "樂而不淫"
  },
  {
    "frequency": 42,
    "simplified": "百岁之后",
    "traditional": "百歲之後"
  },
  {
    "frequency": 42,
    "simplified": "誓死不屈",
    "traditional": "誓死不屈"
  },
  {
    "frequency": 42,
    "simplified": "能者为师",
    "traditional": "能者為師"
  },
  {
    "frequency": 42,
    "simplified": "挨打受骂",
    "traditional": "挨打受罵"
  },
  {
    "frequency": 42,
    "simplified": "视死如生",
    "traditional": "視死如生"
  },
  {
    "frequency": 42,
    "simplified": "生财之道",
    "traditional": "生財之道"
  },
  {
    "frequency": 42,
    "simplified": "无风三尺浪",
    "traditional": "無風三尺浪"
  },
  {
    "frequency": 42,
    "simplified": "浪迹江湖",
    "traditional": "浪跡江湖"
  },
  {
    "frequency": 42,
    "simplified": "人心隔肚皮",
    "traditional": "人心隔肚皮"
  },
  {
    "frequency": 42,
    "simplified": "东游西荡",
    "traditional": "東遊西蕩"
  },
  {
    "frequency": 42,
    "simplified": "不测之忧",
    "traditional": "不測之憂"
  },
  {
    "frequency": 42,
    "simplified": "加油添醋",
    "traditional": "加油添醋"
  },
  {
    "frequency": 42,
    "simplified": "牛高马大",
    "traditional": "牛高馬大"
  },
  {
    "frequency": 42,
    "simplified": "爱财如命",
    "traditional": "愛財如命"
  },
  {
    "frequency": 42,
    "simplified": "立身行事",
    "traditional": "立身行事"
  },
  {
    "frequency": 42,
    "simplified": "管鲍之交",
    "traditional": "管鮑之交"
  },
  {
    "frequency": 42,
    "simplified": "入地无门",
    "traditional": "入地無門"
  },
  {
    "frequency": 42,
    "simplified": "恩怨分明",
    "traditional": "恩怨分明"
  },
  {
    "frequency": 42,
    "simplified": "和光同尘",
    "traditional": "和光同塵"
  },
  {
    "frequency": 42,
    "simplified": "骨肉离散",
    "traditional": "骨肉離散"
  },
  {
    "frequency": 42,
    "simplified": "出门在外",
    "traditional": "出門在外"
  },
  {
    "frequency": 42,
    "simplified": "顿足捶胸",
    "traditional": "頓足捶胸"
  },
  {
    "frequency": 42,
    "simplified": "言必信行必果",
    "traditional": "言必信行必果"
  },
  {
    "frequency": 42,
    "simplified": "必有一失",
    "traditional": "必有一失"
  },
  {
    "frequency": 42,
    "simplified": "虱多不痒",
    "traditional": "蝨多不癢"
  },
  {
    "frequency": 41,
    "simplified": "相机行事",
    "traditional": "相機行事"
  },
  {
    "frequency": 41,
    "simplified": "好善乐施",
    "traditional": "好善樂施"
  },
  {
    "frequency": 41,
    "simplified": "宾客如云",
    "traditional": "賓客如雲"
  },
  {
    "frequency": 41,
    "simplified": "来者可追",
    "traditional": "來者可追"
  },
  {
    "frequency": 41,
    "simplified": "摇唇鼓舌",
    "traditional": "搖唇鼓舌"
  },
  {
    "frequency": 41,
    "simplified": "项庄舞剑意在沛公",
    "traditional": "項莊舞劍意在沛公"
  },
  {
    "frequency": 41,
    "simplified": "含英咀华",
    "traditional": "含英咀華"
  },
  {
    "frequency": 41,
    "simplified": "勒索敲诈",
    "traditional": "勒索敲詐"
  },
  {
    "frequency": 41,
    "simplified": "自我陶醉",
    "traditional": "自我陶醉"
  },
  {
    "frequency": 41,
    "simplified": "炼石补天",
    "traditional": "煉石補天"
  },
  {
    "frequency": 41,
    "simplified": "安步当车",
    "traditional": "安步當車"
  },
  {
    "frequency": 41,
    "simplified": "昼伏夜行",
    "traditional": "晝伏夜行"
  },
  {
    "frequency": 41,
    "simplified": "骨肉相残",
    "traditional": "骨肉相殘"
  },
  {
    "frequency": 41,
    "simplified": "对症之药",
    "traditional": "對症之藥"
  },
  {
    "frequency": 41,
    "simplified": "自我吹嘘",
    "traditional": "自我吹噓"
  },
  {
    "frequency": 41,
    "simplified": "自出机杼",
    "traditional": "自出機杼"
  },
  {
    "frequency": 41,
    "simplified": "来回来去",
    "traditional": "來回來去"
  },
  {
    "frequency": 41,
    "simplified": "瞬息之间",
    "traditional": "瞬息之間"
  },
  {
    "frequency": 41,
    "simplified": "密密层层",
    "traditional": "密密層層"
  },
  {
    "frequency": 41,
    "simplified": "十八层地狱",
    "traditional": "十八層地獄"
  },
  {
    "frequency": 41,
    "simplified": "一是一二是二",
    "traditional": "一是一二是二"
  },
  {
    "frequency": 41,
    "simplified": "诱敌深入",
    "traditional": "誘敵深入"
  },
  {
    "frequency": 41,
    "simplified": "双管猎枪",
    "traditional": "雙管獵槍"
  },
  {
    "frequency": 41,
    "simplified": "朽木不可雕",
    "traditional": "朽木不可雕"
  },
  {
    "frequency": 41,
    "simplified": "程门立雪",
    "traditional": "程門立雪"
  },
  {
    "frequency": 41,
    "simplified": "风土人情",
    "traditional": "風土人情"
  },
  {
    "frequency": 41,
    "simplified": "平时不烧香",
    "traditional": "平時不燒香"
  },
  {
    "frequency": 41,
    "simplified": "人之常情",
    "traditional": "人之常情"
  },
  {
    "frequency": 41,
    "simplified": "岁寒知松柏",
    "traditional": "歲寒知松柏"
  },
  {
    "frequency": 41,
    "simplified": "杜鹃啼血",
    "traditional": "杜鵑啼血"
  },
  {
    "frequency": 41,
    "simplified": "饿虎扑食",
    "traditional": "餓虎撲食"
  },
  {
    "frequency": 41,
    "simplified": "功到自然成",
    "traditional": "功到自然成"
  },
  {
    "frequency": 41,
    "simplified": "旧调重弹",
    "traditional": "舊調重彈"
  },
  {
    "frequency": 40,
    "simplified": "周公吐哺",
    "traditional": "周公吐哺"
  },
  {
    "frequency": 40,
    "simplified": "名重一时",
    "traditional": "名重一時"
  },
  {
    "frequency": 40,
    "simplified": "拣了芝麻丢了西瓜",
    "traditional": "揀了芝麻丟了西瓜"
  },
  {
    "frequency": 40,
    "simplified": "载沉载浮",
    "traditional": "載沉載浮"
  },
  {
    "frequency": 40,
    "simplified": "无人之地",
    "traditional": "無人之地"
  },
  {
    "frequency": 40,
    "simplified": "蓬生麻中",
    "traditional": "蓬生麻中"
  },
  {
    "frequency": 40,
    "simplified": "富商大贾",
    "traditional": "富商大賈"
  },
  {
    "frequency": 40,
    "simplified": "竖子成名",
    "traditional": "豎子成名"
  },
  {
    "frequency": 40,
    "simplified": "一笔抹杀",
    "traditional": "一筆抹殺"
  },
  {
    "frequency": 40,
    "simplified": "膏腴之地",
    "traditional": "膏腴之地"
  },
  {
    "frequency": 40,
    "simplified": "道路以目",
    "traditional": "道路以目"
  },
  {
    "frequency": 40,
    "simplified": "独排众议",
    "traditional": "獨排眾議"
  },
  {
    "frequency": 40,
    "simplified": "推三推四",
    "traditional": "推三推四"
  },
  {
    "frequency": 40,
    "simplified": "胸无点墨",
    "traditional": "胸無點墨"
  },
  {
    "frequency": 40,
    "simplified": "误入歧途",
    "traditional": "誤入歧途"
  },
  {
    "frequency": 40,
    "simplified": "攻其一点不及其余",
    "traditional": "攻其一點不及其餘"
  },
  {
    "frequency": 40,
    "simplified": "舍己为公",
    "traditional": "捨己為公"
  },
  {
    "frequency": 40,
    "simplified": "瘦骨如柴",
    "traditional": "瘦骨如柴"
  },
  {
    "frequency": 40,
    "simplified": "妙手偶得",
    "traditional": "妙手偶得"
  },
  {
    "frequency": 40,
    "simplified": "顾盼生姿",
    "traditional": "顧盼生姿"
  },
  {
    "frequency": 40,
    "simplified": "放马后炮",
    "traditional": "放馬後炮"
  },
  {
    "frequency": 40,
    "simplified": "卓然不群",
    "traditional": "卓然不群"
  },
  {
    "frequency": 40,
    "simplified": "所答非所问",
    "traditional": "所答非所問"
  },
  {
    "frequency": 40,
    "simplified": "决胜于千里之外",
    "traditional": "決勝於千里之外"
  },
  {
    "frequency": 40,
    "simplified": "诸恶莫作",
    "traditional": "諸惡莫作"
  },
  {
    "frequency": 40,
    "simplified": "人弃我取",
    "traditional": "人棄我取"
  },
  {
    "frequency": 40,
    "simplified": "浓眉大眼",
    "traditional": "濃眉大眼"
  },
  {
    "frequency": 40,
    "simplified": "外方内圆",
    "traditional": "外方內圓"
  },
  {
    "frequency": 40,
    "simplified": "杳如黄鹤",
    "traditional": "杳如黃鶴"
  },
  {
    "frequency": 40,
    "simplified": "酒后无德",
    "traditional": "酒後無德"
  },
  {
    "frequency": 40,
    "simplified": "断线风筝",
    "traditional": "斷線風箏"
  },
  {
    "frequency": 40,
    "simplified": "江山易改本性难移",
    "traditional": "江山易改本性難移"
  },
  {
    "frequency": 40,
    "simplified": "十目所视",
    "traditional": "十目所視"
  },
  {
    "frequency": 40,
    "simplified": "芝兰之室",
    "traditional": "芝蘭之室"
  },
  {
    "frequency": 40,
    "simplified": "吹牛拍马",
    "traditional": "吹牛拍馬"
  },
  {
    "frequency": 40,
    "simplified": "荦荦大者",
    "traditional": "犖犖大者"
  },
  {
    "frequency": 40,
    "simplified": "钻心刺骨",
    "traditional": "鑽心刺骨"
  },
  {
    "frequency": 40,
    "simplified": "无可名状",
    "traditional": "無可名狀"
  },
  {
    "frequency": 40,
    "simplified": "三十六行",
    "traditional": "三十六行"
  },
  {
    "frequency": 40,
    "simplified": "是非自有公论",
    "traditional": "是非自有公論"
  },
  {
    "frequency": 39,
    "simplified": "鼎新革故",
    "traditional": "鼎新革故"
  },
  {
    "frequency": 39,
    "simplified": "小户人家",
    "traditional": "小戶人家"
  },
  {
    "frequency": 39,
    "simplified": "尖嘴猴腮",
    "traditional": "尖嘴猴腮"
  },
  {
    "frequency": 39,
    "simplified": "大放光明",
    "traditional": "大放光明"
  },
  {
    "frequency": 39,
    "simplified": "碎尸万段",
    "traditional": "碎屍萬段"
  },
  {
    "frequency": 39,
    "simplified": "无所不晓",
    "traditional": "無所不曉"
  },
  {
    "frequency": 39,
    "simplified": "谓予不信",
    "traditional": "謂予不信"
  },
  {
    "frequency": 39,
    "simplified": "人间天上",
    "traditional": "人間天上"
  },
  {
    "frequency": 39,
    "simplified": "卖弄风骚",
    "traditional": "賣弄風騷"
  },
  {
    "frequency": 39,
    "simplified": "焚林而猎",
    "traditional": "焚林而獵"
  },
  {
    "frequency": 39,
    "simplified": "舍身为国",
    "traditional": "捨身為國"
  },
  {
    "frequency": 39,
    "simplified": "无风起浪",
    "traditional": "無風起浪"
  },
  {
    "frequency": 39,
    "simplified": "茫无头绪",
    "traditional": "茫無頭緒"
  },
  {
    "frequency": 39,
    "simplified": "五行八作",
    "traditional": "五行八作"
  },
  {
    "frequency": 39,
    "simplified": "风行草偃",
    "traditional": "風行草偃"
  },
  {
    "frequency": 39,
    "simplified": "适逢其会",
    "traditional": "適逢其會"
  },
  {
    "frequency": 39,
    "simplified": "奇光异彩",
    "traditional": "奇光異彩"
  },
  {
    "frequency": 39,
    "simplified": "瓦釜雷鸣",
    "traditional": "瓦釜雷鳴"
  },
  {
    "frequency": 39,
    "simplified": "败军之将",
    "traditional": "敗軍之將"
  },
  {
    "frequency": 39,
    "simplified": "落落大方",
    "traditional": "落落大方"
  },
  {
    "frequency": 39,
    "simplified": "外刚内柔",
    "traditional": "外剛內柔"
  },
  {
    "frequency": 39,
    "simplified": "直认不讳",
    "traditional": "直認不諱"
  },
  {
    "frequency": 39,
    "simplified": "急赤白脸",
    "traditional": "急赤白臉"
  },
  {
    "frequency": 39,
    "simplified": "众怒难犯",
    "traditional": "眾怒難犯"
  },
  {
    "frequency": 39,
    "simplified": "白璧无瑕",
    "traditional": "白璧無瑕"
  },
  {
    "frequency": 39,
    "simplified": "坐收渔人之利",
    "traditional": "坐收漁人之利"
  },
  {
    "frequency": 39,
    "simplified": "弃若敝屣",
    "traditional": "棄若敝屣"
  },
  {
    "frequency": 39,
    "simplified": "仁义之师",
    "traditional": "仁義之師"
  },
  {
    "frequency": 39,
    "simplified": "名山胜水",
    "traditional": "名山勝水"
  },
  {
    "frequency": 39,
    "simplified": "白色恐怖",
    "traditional": "白色恐怖"
  },
  {
    "frequency": 39,
    "simplified": "昏头转向",
    "traditional": "昏頭轉向"
  },
  {
    "frequency": 39,
    "simplified": "疮痍满目",
    "traditional": "瘡痍滿目"
  },
  {
    "frequency": 39,
    "simplified": "龙潭虎穴",
    "traditional": "龍潭虎穴"
  },
  {
    "frequency": 39,
    "simplified": "顺时而动",
    "traditional": "順時而動"
  },
  {
    "frequency": 39,
    "simplified": "皇天后土",
    "traditional": "皇天后土"
  },
  {
    "frequency": 39,
    "simplified": "香火不绝",
    "traditional": "香火不絕"
  },
  {
    "frequency": 39,
    "simplified": "沐猴而冠",
    "traditional": "沐猴而冠"
  },
  {
    "frequency": 39,
    "simplified": "露水夫妻",
    "traditional": "露水夫妻"
  },
  {
    "frequency": 39,
    "simplified": "人为刀俎我为鱼肉",
    "traditional": "人為刀俎我為魚肉"
  },
  {
    "frequency": 39,
    "simplified": "功高震主",
    "traditional": "功高震主"
  },
  {
    "frequency": 39,
    "simplified": "江河行地",
    "traditional": "江河行地"
  },
  {
    "frequency": 39,
    "simplified": "知无不言言无不尽",
    "traditional": "知無不言言無不盡"
  },
  {
    "frequency": 39,
    "simplified": "山南海北",
    "traditional": "山南海北"
  },
  {
    "frequency": 39,
    "simplified": "沧海遗珠",
    "traditional": "滄海遺珠"
  },
  {
    "frequency": 39,
    "simplified": "油头粉面",
    "traditional": "油頭粉面"
  },
  {
    "frequency": 38,
    "simplified": "拈花微笑",
    "traditional": "拈花微笑"
  },
  {
    "frequency": 38,
    "simplified": "人面兽心",
    "traditional": "人面獸心"
  },
  {
    "frequency": 38,
    "simplified": "抽刀断水",
    "traditional": "抽刀斷水"
  },
  {
    "frequency": 38,
    "simplified": "嘻皮笑脸",
    "traditional": "嘻皮笑臉"
  },
  {
    "frequency": 38,
    "simplified": "梅妻鹤子",
    "traditional": "梅妻鶴子"
  },
  {
    "frequency": 38,
    "simplified": "云中白鹤",
    "traditional": "雲中白鶴"
  },
  {
    "frequency": 38,
    "simplified": "婆娑起舞",
    "traditional": "婆娑起舞"
  },
  {
    "frequency": 38,
    "simplified": "人心大快",
    "traditional": "人心大快"
  },
  {
    "frequency": 38,
    "simplified": "捉刀代笔",
    "traditional": "捉刀代筆"
  },
  {
    "frequency": 38,
    "simplified": "屏声静气",
    "traditional": "屏聲靜氣"
  },
  {
    "frequency": 38,
    "simplified": "表里一致",
    "traditional": "表裡一致"
  },
  {
    "frequency": 38,
    "simplified": "深山幽谷",
    "traditional": "深山幽谷"
  },
  {
    "frequency": 38,
    "simplified": "焚琴煮鹤",
    "traditional": "焚琴煮鶴"
  },
  {
    "frequency": 38,
    "simplified": "国家兴亡匹夫有责",
    "traditional": "國家興亡匹夫有責"
  },
  {
    "frequency": 38,
    "simplified": "稗官野史",
    "traditional": "稗官野史"
  },
  {
    "frequency": 38,
    "simplified": "断断续续",
    "traditional": "斷斷續續"
  },
  {
    "frequency": 38,
    "simplified": "花花世界",
    "traditional": "花花世界"
  },
  {
    "frequency": 38,
    "simplified": "上天无路",
    "traditional": "上天無路"
  },
  {
    "frequency": 38,
    "simplified": "恶声恶气",
    "traditional": "惡聲惡氣"
  },
  {
    "frequency": 38,
    "simplified": "不情之请",
    "traditional": "不情之請"
  },
  {
    "frequency": 38,
    "simplified": "流水无情",
    "traditional": "流水無情"
  },
  {
    "frequency": 38,
    "simplified": "万死不辞",
    "traditional": "萬死不辭"
  },
  {
    "frequency": 38,
    "simplified": "下车伊始",
    "traditional": "下車伊始"
  },
  {
    "frequency": 38,
    "simplified": "长乐未央",
    "traditional": "長樂未央"
  },
  {
    "frequency": 38,
    "simplified": "流离颠沛",
    "traditional": "流離顛沛"
  },
  {
    "frequency": 38,
    "simplified": "不违农时",
    "traditional": "不違農時"
  },
  {
    "frequency": 38,
    "simplified": "游目骋怀",
    "traditional": "遊目騁懷"
  },
  {
    "frequency": 38,
    "simplified": "黯然伤神",
    "traditional": "黯然傷神"
  },
  {
    "frequency": 38,
    "simplified": "扬名四海",
    "traditional": "揚名四海"
  },
  {
    "frequency": 38,
    "simplified": "天兵天将",
    "traditional": "天兵天將"
  },
  {
    "frequency": 38,
    "simplified": "人情之常",
    "traditional": "人情之常"
  },
  {
    "frequency": 38,
    "simplified": "过门不入",
    "traditional": "過門不入"
  },
  {
    "frequency": 38,
    "simplified": "创巨痛深",
    "traditional": "創鉅痛深"
  },
  {
    "frequency": 38,
    "simplified": "超凡入圣",
    "traditional": "超凡入聖"
  },
  {
    "frequency": 38,
    "simplified": "成败利钝",
    "traditional": "成敗利鈍"
  },
  {
    "frequency": 38,
    "simplified": "东征西讨",
    "traditional": "東征西討"
  },
  {
    "frequency": 37,
    "simplified": "千依百顺",
    "traditional": "千依百順"
  },
  {
    "frequency": 37,
    "simplified": "学然后知不足",
    "traditional": "學然後知不足"
  },
  {
    "frequency": 37,
    "simplified": "追根问底",
    "traditional": "追根問底"
  },
  {
    "frequency": 37,
    "simplified": "血盆大口",
    "traditional": "血盆大口"
  },
  {
    "frequency": 37,
    "simplified": "串亲访友",
    "traditional": "串親訪友"
  },
  {
    "frequency": 37,
    "simplified": "非学无以广才",
    "traditional": "非學無以廣才"
  },
  {
    "frequency": 37,
    "simplified": "囊中取物",
    "traditional": "囊中取物"
  },
  {
    "frequency": 37,
    "simplified": "耸入云霄",
    "traditional": "聳入雲霄"
  },
  {
    "frequency": 37,
    "simplified": "进德修业",
    "traditional": "進德修業"
  },
  {
    "frequency": 37,
    "simplified": "盘根问底",
    "traditional": "盤根問底"
  },
  {
    "frequency": 37,
    "simplified": "君子固穷",
    "traditional": "君子固窮"
  },
  {
    "frequency": 37,
    "simplified": "丁是丁卯是卯",
    "traditional": "丁是丁卯是卯"
  },
  {
    "frequency": 37,
    "simplified": "过河卒子",
    "traditional": "過河卒子"
  },
  {
    "frequency": 37,
    "simplified": "忍辱偷生",
    "traditional": "忍辱偷生"
  },
  {
    "frequency": 37,
    "simplified": "有进无退",
    "traditional": "有進無退"
  },
  {
    "frequency": 37,
    "simplified": "八万四千",
    "traditional": "八萬四千"
  },
  {
    "frequency": 37,
    "simplified": "衣锦夜行",
    "traditional": "衣錦夜行"
  },
  {
    "frequency": 37,
    "simplified": "人心难测",
    "traditional": "人心難測"
  },
  {
    "frequency": 37,
    "simplified": "天下兴亡匹夫有责",
    "traditional": "天下興亡匹夫有責"
  },
  {
    "frequency": 37,
    "simplified": "非同儿戏",
    "traditional": "非同兒戲"
  },
  {
    "frequency": 37,
    "simplified": "以子之矛",
    "traditional": "以子之矛"
  },
  {
    "frequency": 37,
    "simplified": "大题小做",
    "traditional": "大題小做"
  },
  {
    "frequency": 37,
    "simplified": "白刀子进红刀子出",
    "traditional": "白刀子進紅刀子出"
  },
  {
    "frequency": 37,
    "simplified": "敬若神明",
    "traditional": "敬若神明"
  },
  {
    "frequency": 37,
    "simplified": "牢骚太盛防肠断",
    "traditional": "牢騷太盛防腸斷"
  },
  {
    "frequency": 37,
    "simplified": "如椽之笔",
    "traditional": "如椽之筆"
  },
  {
    "frequency": 37,
    "simplified": "人不犯我我不犯人",
    "traditional": "人不犯我我不犯人"
  },
  {
    "frequency": 37,
    "simplified": "罪魁祸首",
    "traditional": "罪魁禍首"
  },
  {
    "frequency": 37,
    "simplified": "挂冠求去",
    "traditional": "掛冠求去"
  },
  {
    "frequency": 37,
    "simplified": "千难万苦",
    "traditional": "千難萬苦"
  },
  {
    "frequency": 37,
    "simplified": "小手小脚",
    "traditional": "小手小腳"
  },
  {
    "frequency": 37,
    "simplified": "千姿万态",
    "traditional": "千姿萬態"
  },
  {
    "frequency": 37,
    "simplified": "鲸吞蚕食",
    "traditional": "鯨吞蠶食"
  },
  {
    "frequency": 37,
    "simplified": "一误再误",
    "traditional": "一誤再誤"
  },
  {
    "frequency": 37,
    "simplified": "玉洁冰清",
    "traditional": "玉潔冰清"
  },
  {
    "frequency": 37,
    "simplified": "无事不登三宝殿",
    "traditional": "無事不登三寶殿"
  },
  {
    "frequency": 37,
    "simplified": "视为知己",
    "traditional": "視為知己"
  },
  {
    "frequency": 37,
    "simplified": "挈妇将雏",
    "traditional": "挈婦將雛"
  },
  {
    "frequency": 37,
    "simplified": "不见经传",
    "traditional": "不見經傳"
  },
  {
    "frequency": 37,
    "simplified": "一掷百万",
    "traditional": "一擲百萬"
  },
  {
    "frequency": 37,
    "simplified": "风吹云散",
    "traditional": "風吹雲散"
  },
  {
    "frequency": 37,
    "simplified": "克己慎行",
    "traditional": "克己慎行"
  },
  {
    "frequency": 37,
    "simplified": "喟然长叹",
    "traditional": "喟然長嘆"
  },
  {
    "frequency": 37,
    "simplified": "蚍蜉撼树",
    "traditional": "蚍蜉撼樹"
  },
  {
    "frequency": 37,
    "simplified": "知止不殆",
    "traditional": "知止不殆"
  },
  {
    "frequency": 37,
    "simplified": "芙蓉出水",
    "traditional": "芙蓉出水"
  },
  {
    "frequency": 37,
    "simplified": "转悲为喜",
    "traditional": "轉悲為喜"
  },
  {
    "frequency": 37,
    "simplified": "大张声势",
    "traditional": "大張聲勢"
  },
  {
    "frequency": 37,
    "simplified": "断井颓垣",
    "traditional": "斷井頹垣"
  },
  {
    "frequency": 36,
    "simplified": "风中之烛",
    "traditional": "風中之燭"
  },
  {
    "frequency": 36,
    "simplified": "多言多语",
    "traditional": "多言多語"
  },
  {
    "frequency": 36,
    "simplified": "卖文为生",
    "traditional": "賣文為生"
  },
  {
    "frequency": 36,
    "simplified": "耳朵起茧",
    "traditional": "耳朵起繭"
  },
  {
    "frequency": 36,
    "simplified": "民生在勤",
    "traditional": "民生在勤"
  },
  {
    "frequency": 36,
    "simplified": "没轻没重",
    "traditional": "沒輕沒重"
  },
  {
    "frequency": 36,
    "simplified": "舍命陪君子",
    "traditional": "捨命陪君子"
  },
  {
    "frequency": 36,
    "simplified": "持盈保泰",
    "traditional": "持盈保泰"
  },
  {
    "frequency": 36,
    "simplified": "一人之下万人之上",
    "traditional": "一人之下萬人之上"
  },
  {
    "frequency": 36,
    "simplified": "清风两袖",
    "traditional": "清風兩袖"
  },
  {
    "frequency": 36,
    "simplified": "大放悲声",
    "traditional": "大放悲聲"
  },
  {
    "frequency": 36,
    "simplified": "视民如伤",
    "traditional": "視民如傷"
  },
  {
    "frequency": 36,
    "simplified": "四时八节",
    "traditional": "四時八節"
  },
  {
    "frequency": 36,
    "simplified": "威风扫地",
    "traditional": "威風掃地"
  },
  {
    "frequency": 36,
    "simplified": "一时三刻",
    "traditional": "一時三刻"
  },
  {
    "frequency": 36,
    "simplified": "如人饮水冷暖自知",
    "traditional": "如人飲水冷暖自知"
  },
  {
    "frequency": 36,
    "simplified": "迟疑不定",
    "traditional": "遲疑不定"
  },
  {
    "frequency": 36,
    "simplified": "二者不可得兼",
    "traditional": "二者不可得兼"
  },
  {
    "frequency": 36,
    "simplified": "梦幻泡影",
    "traditional": "夢幻泡影"
  },
  {
    "frequency": 36,
    "simplified": "慨然应允",
    "traditional": "慨然應允"
  },
  {
    "frequency": 36,
    "simplified": "言之无文",
    "traditional": "言之無文"
  },
  {
    "frequency": 36,
    "simplified": "人来客往",
    "traditional": "人來客往"
  },
  {
    "frequency": 36,
    "simplified": "形只影单",
    "traditional": "形隻影單"
  },
  {
    "frequency": 36,
    "simplified": "虎口逃生",
    "traditional": "虎口逃生"
  },
  {
    "frequency": 36,
    "simplified": "骄兵必败",
    "traditional": "驕兵必敗"
  },
  {
    "frequency": 36,
    "simplified": "穷极无聊",
    "traditional": "窮極無聊"
  },
  {
    "frequency": 36,
    "simplified": "顾盼自雄",
    "traditional": "顧盼自雄"
  },
  {
    "frequency": 36,
    "simplified": "以古喻今",
    "traditional": "以古喻今"
  },
  {
    "frequency": 36,
    "simplified": "胜不骄败不馁",
    "traditional": "勝不驕敗不餒"
  },
  {
    "frequency": 36,
    "simplified": "窥豹一斑",
    "traditional": "窺豹一斑"
  },
  {
    "frequency": 36,
    "simplified": "传诵一时",
    "traditional": "傳誦一時"
  },
  {
    "frequency": 36,
    "simplified": "地覆天翻",
    "traditional": "地覆天翻"
  },
  {
    "frequency": 36,
    "simplified": "不识大体",
    "traditional": "不識大體"
  },
  {
    "frequency": 36,
    "simplified": "治丝益棼",
    "traditional": "治絲益棼"
  },
  {
    "frequency": 36,
    "simplified": "知命之年",
    "traditional": "知命之年"
  },
  {
    "frequency": 36,
    "simplified": "居功厥伟",
    "traditional": "居功厥偉"
  },
  {
    "frequency": 36,
    "simplified": "指腹为婚",
    "traditional": "指腹為婚"
  },
  {
    "frequency": 36,
    "simplified": "由衷之言",
    "traditional": "由衷之言"
  },
  {
    "frequency": 36,
    "simplified": "绝路逢生",
    "traditional": "絕路逢生"
  },
  {
    "frequency": 36,
    "simplified": "甘居人后",
    "traditional": "甘居人後"
  },
  {
    "frequency": 36,
    "simplified": "终成泡影",
    "traditional": "終成泡影"
  },
  {
    "frequency": 36,
    "simplified": "令出如山",
    "traditional": "令出如山"
  },
  {
    "frequency": 36,
    "simplified": "临事而惧",
    "traditional": "臨事而懼"
  },
  {
    "frequency": 36,
    "simplified": "呵欠连天",
    "traditional": "呵欠連天"
  },
  {
    "frequency": 36,
    "simplified": "久旱逢甘雨",
    "traditional": "久旱逢甘雨"
  },
  {
    "frequency": 35,
    "simplified": "行成于思",
    "traditional": "行成於思"
  },
  {
    "frequency": 35,
    "simplified": "鸾凤和鸣",
    "traditional": "鸞鳳和鳴"
  },
  {
    "frequency": 35,
    "simplified": "大嚷大叫",
    "traditional": "大嚷大叫"
  },
  {
    "frequency": 35,
    "simplified": "口出不逊",
    "traditional": "口出不遜"
  },
  {
    "frequency": 35,
    "simplified": "一蹴可几",
    "traditional": "一蹴可幾"
  },
  {
    "frequency": 35,
    "simplified": "惊疑不定",
    "traditional": "驚疑不定"
  },
  {
    "frequency": 35,
    "simplified": "银样镴枪头",
    "traditional": "銀樣鑞槍頭"
  },
  {
    "frequency": 35,
    "simplified": "气喘如牛",
    "traditional": "氣喘如牛"
  },
  {
    "frequency": 35,
    "simplified": "计上心头",
    "traditional": "計上心頭"
  },
  {
    "frequency": 35,
    "simplified": "蜀中无大将",
    "traditional": "蜀中無大將"
  },
  {
    "frequency": 35,
    "simplified": "形格势禁",
    "traditional": "形格勢禁"
  },
  {
    "frequency": 35,
    "simplified": "险遭不测",
    "traditional": "險遭不測"
  },
  {
    "frequency": 35,
    "simplified": "连战皆捷",
    "traditional": "連戰皆捷"
  },
  {
    "frequency": 35,
    "simplified": "吉人天相",
    "traditional": "吉人天相"
  },
  {
    "frequency": 35,
    "simplified": "偷鸡不着蚀把米",
    "traditional": "偷雞不著蝕把米"
  },
  {
    "frequency": 35,
    "simplified": "嫁鸡随鸡嫁狗随狗",
    "traditional": "嫁雞隨雞嫁狗隨狗"
  },
  {
    "frequency": 35,
    "simplified": "犁庭扫穴",
    "traditional": "犁庭掃穴"
  },
  {
    "frequency": 35,
    "simplified": "安邦治国",
    "traditional": "安邦治國"
  },
  {
    "frequency": 35,
    "simplified": "立业成家",
    "traditional": "立業成家"
  },
  {
    "frequency": 35,
    "simplified": "穿红着绿",
    "traditional": "穿紅著綠"
  },
  {
    "frequency": 35,
    "simplified": "肆虐横行",
    "traditional": "肆虐橫行"
  },
  {
    "frequency": 35,
    "simplified": "激昂慷慨",
    "traditional": "激昂慷慨"
  },
  {
    "frequency": 35,
    "simplified": "鞍马劳顿",
    "traditional": "鞍馬勞頓"
  },
  {
    "frequency": 35,
    "simplified": "舍身成仁",
    "traditional": "捨身成仁"
  },
  {
    "frequency": 35,
    "simplified": "爽心悦目",
    "traditional": "爽心悅目"
  },
  {
    "frequency": 35,
    "simplified": "取精用宏",
    "traditional": "取精用宏"
  },
  {
    "frequency": 35,
    "simplified": "以古为鉴",
    "traditional": "以古為鑑"
  },
  {
    "frequency": 35,
    "simplified": "慷慨赴义",
    "traditional": "慷慨赴義"
  },
  {
    "frequency": 35,
    "simplified": "中外合璧",
    "traditional": "中外合璧"
  },
  {
    "frequency": 35,
    "simplified": "知足者常乐",
    "traditional": "知足者常樂"
  },
  {
    "frequency": 35,
    "simplified": "目无尊长",
    "traditional": "目無尊長"
  },
  {
    "frequency": 35,
    "simplified": "假仁假义",
    "traditional": "假仁假義"
  },
  {
    "frequency": 35,
    "simplified": "规行矩步",
    "traditional": "規行矩步"
  },
  {
    "frequency": 35,
    "simplified": "漫天遍野",
    "traditional": "漫天遍野"
  },
  {
    "frequency": 35,
    "simplified": "同轴电缆",
    "traditional": "同軸電纜"
  },
  {
    "frequency": 35,
    "simplified": "人生路不熟",
    "traditional": "人生路不熟"
  },
  {
    "frequency": 35,
    "simplified": "眼明心亮",
    "traditional": "眼明心亮"
  },
  {
    "frequency": 35,
    "simplified": "穷山僻壤",
    "traditional": "窮山僻壤"
  },
  {
    "frequency": 35,
    "simplified": "瞠乎其后",
    "traditional": "瞠乎其後"
  },
  {
    "frequency": 35,
    "simplified": "麻姑献寿",
    "traditional": "麻姑獻壽"
  },
  {
    "frequency": 35,
    "simplified": "奇风异俗",
    "traditional": "奇風異俗"
  },
  {
    "frequency": 35,
    "simplified": "悔之莫及",
    "traditional": "悔之莫及"
  },
  {
    "frequency": 35,
    "simplified": "一无所求",
    "traditional": "一無所求"
  },
  {
    "frequency": 35,
    "simplified": "卑之无甚高论",
    "traditional": "卑之無甚高論"
  },
  {
    "frequency": 35,
    "simplified": "载舟覆舟",
    "traditional": "載舟覆舟"
  },
  {
    "frequency": 35,
    "simplified": "民贵君轻",
    "traditional": "民貴君輕"
  },
  {
    "frequency": 35,
    "simplified": "有眼不识泰山",
    "traditional": "有眼不識泰山"
  },
  {
    "frequency": 35,
    "simplified": "选贤举能",
    "traditional": "選賢舉能"
  },
  {
    "frequency": 35,
    "simplified": "仇人相见",
    "traditional": "仇人相見"
  },
  {
    "frequency": 35,
    "simplified": "事出无奈",
    "traditional": "事出無奈"
  },
  {
    "frequency": 35,
    "simplified": "小时了了",
    "traditional": "小時了了"
  },
  {
    "frequency": 34,
    "simplified": "星星点点",
    "traditional": "星星點點"
  },
  {
    "frequency": 34,
    "simplified": "半斤对八两",
    "traditional": "半斤對八兩"
  },
  {
    "frequency": 34,
    "simplified": "骨鲠在喉",
    "traditional": "骨鯁在喉"
  },
  {
    "frequency": 34,
    "simplified": "和气致祥",
    "traditional": "和氣致祥"
  },
  {
    "frequency": 34,
    "simplified": "尽信书不如无书",
    "traditional": "盡信書不如無書"
  },
  {
    "frequency": 34,
    "simplified": "空谷足音",
    "traditional": "空谷足音"
  },
  {
    "frequency": 34,
    "simplified": "不入虎穴焉得虎子",
    "traditional": "不入虎穴焉得虎子"
  },
  {
    "frequency": 34,
    "simplified": "文理不通",
    "traditional": "文理不通"
  },
  {
    "frequency": 34,
    "simplified": "孺子可教",
    "traditional": "孺子可教"
  },
  {
    "frequency": 34,
    "simplified": "坐拥书城",
    "traditional": "坐擁書城"
  },
  {
    "frequency": 34,
    "simplified": "如坐春风",
    "traditional": "如坐春風"
  },
  {
    "frequency": 34,
    "simplified": "乱臣贼子",
    "traditional": "亂臣賊子"
  },
  {
    "frequency": 34,
    "simplified": "未为不可",
    "traditional": "未為不可"
  },
  {
    "frequency": 34,
    "simplified": "千秋万世",
    "traditional": "千秋萬世"
  },
  {
    "frequency": 34,
    "simplified": "头角峥嵘",
    "traditional": "頭角崢嶸"
  },
  {
    "frequency": 34,
    "simplified": "不足为道",
    "traditional": "不足為道"
  },
  {
    "frequency": 34,
    "simplified": "谬误百出",
    "traditional": "謬誤百出"
  },
  {
    "frequency": 34,
    "simplified": "七步成诗",
    "traditional": "七步成詩"
  },
  {
    "frequency": 34,
    "simplified": "迎神赛会",
    "traditional": "迎神賽會"
  },
  {
    "frequency": 34,
    "simplified": "丝竹管弦",
    "traditional": "絲竹管絃"
  },
  {
    "frequency": 34,
    "simplified": "清华东门",
    "traditional": "清華東門"
  },
  {
    "frequency": 34,
    "simplified": "怀璧其罪",
    "traditional": "懷璧其罪"
  },
  {
    "frequency": 34,
    "simplified": "天理昭昭",
    "traditional": "天理昭昭"
  },
  {
    "frequency": 34,
    "simplified": "纡尊降贵",
    "traditional": "紆尊降貴"
  },
  {
    "frequency": 34,
    "simplified": "人心齐泰山移",
    "traditional": "人心齊泰山移"
  },
  {
    "frequency": 34,
    "simplified": "不徐不疾",
    "traditional": "不徐不疾"
  },
  {
    "frequency": 34,
    "simplified": "羽毛丰满",
    "traditional": "羽毛豐滿"
  },
  {
    "frequency": 34,
    "simplified": "黄口小儿",
    "traditional": "黃口小兒"
  },
  {
    "frequency": 34,
    "simplified": "临深履薄",
    "traditional": "臨深履薄"
  },
  {
    "frequency": 34,
    "simplified": "急急如律令",
    "traditional": "急急如律令"
  },
  {
    "frequency": 34,
    "simplified": "行不更名",
    "traditional": "行不更名"
  },
  {
    "frequency": 34,
    "simplified": "水碧山青",
    "traditional": "水碧山青"
  },
  {
    "frequency": 34,
    "simplified": "百足之虫死而不僵",
    "traditional": "百足之蟲死而不僵"
  },
  {
    "frequency": 34,
    "simplified": "易地而处",
    "traditional": "易地而處"
  },
  {
    "frequency": 34,
    "simplified": "残渣余孽",
    "traditional": "殘渣餘孽"
  },
  {
    "frequency": 34,
    "simplified": "留恋不舍",
    "traditional": "留戀不捨"
  },
  {
    "frequency": 34,
    "simplified": "开科取士",
    "traditional": "開科取士"
  },
  {
    "frequency": 34,
    "simplified": "漫无止境",
    "traditional": "漫無止境"
  },
  {
    "frequency": 34,
    "simplified": "意义深长",
    "traditional": "意義深長"
  },
  {
    "frequency": 34,
    "simplified": "臧否人物",
    "traditional": "臧否人物"
  },
  {
    "frequency": 34,
    "simplified": "仓皇失措",
    "traditional": "倉皇失措"
  },
  {
    "frequency": 34,
    "simplified": "牛之一毛",
    "traditional": "牛之一毛"
  },
  {
    "frequency": 34,
    "simplified": "履险如夷",
    "traditional": "履險如夷"
  },
  {
    "frequency": 34,
    "simplified": "食言而肥",
    "traditional": "食言而肥"
  },
  {
    "frequency": 34,
    "simplified": "成千成万",
    "traditional": "成千成萬"
  },
  {
    "frequency": 34,
    "simplified": "历历可见",
    "traditional": "歷歷可見"
  },
  {
    "frequency": 34,
    "simplified": "花花型警",
    "traditional": "花花型警"
  },
  {
    "frequency": 33,
    "simplified": "求神问卜",
    "traditional": "求神問卜"
  },
  {
    "frequency": 33,
    "simplified": "操纵自如",
    "traditional": "操縱自如"
  },
  {
    "frequency": 33,
    "simplified": "求其友声",
    "traditional": "求其友聲"
  },
  {
    "frequency": 33,
    "simplified": "老王卖瓜",
    "traditional": "老王賣瓜"
  },
  {
    "frequency": 33,
    "simplified": "百花齐放百家争鸣",
    "traditional": "百花齊放百家爭鳴"
  },
  {
    "frequency": 33,
    "simplified": "殚精竭力",
    "traditional": "殫精竭力"
  },
  {
    "frequency": 33,
    "simplified": "不知所言",
    "traditional": "不知所言"
  },
  {
    "frequency": 33,
    "simplified": "零乱不堪",
    "traditional": "零亂不堪"
  },
  {
    "frequency": 33,
    "simplified": "反哺之情",
    "traditional": "反哺之情"
  },
  {
    "frequency": 33,
    "simplified": "三朋四友",
    "traditional": "三朋四友"
  },
  {
    "frequency": 33,
    "simplified": "奔腾澎湃",
    "traditional": "奔騰澎湃"
  },
  {
    "frequency": 33,
    "simplified": "塞北江南",
    "traditional": "塞北江南"
  },
  {
    "frequency": 33,
    "simplified": "目迷五色",
    "traditional": "目迷五色"
  },
  {
    "frequency": 33,
    "simplified": "有案可稽",
    "traditional": "有案可稽"
  },
  {
    "frequency": 33,
    "simplified": "挖肉补疮",
    "traditional": "挖肉補瘡"
  },
  {
    "frequency": 33,
    "simplified": "切磋琢磨",
    "traditional": "切磋琢磨"
  },
  {
    "frequency": 33,
    "simplified": "出师有名",
    "traditional": "出師有名"
  },
  {
    "frequency": 33,
    "simplified": "饕餮之徒",
    "traditional": "饕餮之徒"
  },
  {
    "frequency": 33,
    "simplified": "夹道欢呼",
    "traditional": "夾道歡呼"
  },
  {
    "frequency": 33,
    "simplified": "年高德劭",
    "traditional": "年高德劭"
  },
  {
    "frequency": 33,
    "simplified": "江汉朝宗",
    "traditional": "江漢朝宗"
  },
  {
    "frequency": 33,
    "simplified": "逐句逐字",
    "traditional": "逐句逐字"
  },
  {
    "frequency": 33,
    "simplified": "观者云集",
    "traditional": "觀者雲集"
  },
  {
    "frequency": 33,
    "simplified": "一隅之地",
    "traditional": "一隅之地"
  },
  {
    "frequency": 33,
    "simplified": "观者如堵",
    "traditional": "觀者如堵"
  },
  {
    "frequency": 33,
    "simplified": "五马分尸",
    "traditional": "五馬分屍"
  },
  {
    "frequency": 33,
    "simplified": "釜底之鱼",
    "traditional": "釜底之魚"
  },
  {
    "frequency": 33,
    "simplified": "旦夕之间",
    "traditional": "旦夕之間"
  },
  {
    "frequency": 33,
    "simplified": "好学深思",
    "traditional": "好學深思"
  },
  {
    "frequency": 33,
    "simplified": "欺人之谈",
    "traditional": "欺人之談"
  },
  {
    "frequency": 33,
    "simplified": "进身之阶",
    "traditional": "進身之階"
  },
  {
    "frequency": 33,
    "simplified": "五短身材",
    "traditional": "五短身材"
  },
  {
    "frequency": 33,
    "simplified": "积善之家必有余庆",
    "traditional": "積善之家必有餘慶"
  },
  {
    "frequency": 33,
    "simplified": "扬清抑浊",
    "traditional": "揚清抑濁"
  },
  {
    "frequency": 33,
    "simplified": "汉贼不两立",
    "traditional": "漢賊不兩立"
  },
  {
    "frequency": 33,
    "simplified": "刀光血影",
    "traditional": "刀光血影"
  },
  {
    "frequency": 33,
    "simplified": "以管窥豹",
    "traditional": "以管窺豹"
  },
  {
    "frequency": 33,
    "simplified": "荒淫无道",
    "traditional": "荒淫無道"
  },
  {
    "frequency": 33,
    "simplified": "顺我者昌逆我者亡",
    "traditional": "順我者昌逆我者亡"
  },
  {
    "frequency": 33,
    "simplified": "瓮声瓮气",
    "traditional": "甕聲甕氣"
  },
  {
    "frequency": 33,
    "simplified": "擒贼擒王",
    "traditional": "擒賊擒王"
  },
  {
    "frequency": 33,
    "simplified": "不可言状",
    "traditional": "不可言狀"
  },
  {
    "frequency": 33,
    "simplified": "亢龙有悔",
    "traditional": "亢龍有悔"
  },
  {
    "frequency": 33,
    "simplified": "怨天怨地",
    "traditional": "怨天怨地"
  },
  {
    "frequency": 33,
    "simplified": "自由泛滥",
    "traditional": "自由氾濫"
  },
  {
    "frequency": 33,
    "simplified": "无功受禄",
    "traditional": "無功受祿"
  },
  {
    "frequency": 33,
    "simplified": "强将手下无弱兵",
    "traditional": "強將手下無弱兵"
  },
  {
    "frequency": 33,
    "simplified": "放浪不羁",
    "traditional": "放浪不羈"
  },
  {
    "frequency": 33,
    "simplified": "鹅毛大雪",
    "traditional": "鵝毛大雪"
  },
  {
    "frequency": 32,
    "simplified": "毫无逊色",
    "traditional": "毫無遜色"
  },
  {
    "frequency": 32,
    "simplified": "风行水上",
    "traditional": "風行水上"
  },
  {
    "frequency": 32,
    "simplified": "高头讲章",
    "traditional": "高頭講章"
  },
  {
    "frequency": 32,
    "simplified": "满目琳琅",
    "traditional": "滿目琳琅"
  },
  {
    "frequency": 32,
    "simplified": "一言中的",
    "traditional": "一言中的"
  },
  {
    "frequency": 32,
    "simplified": "出于意外",
    "traditional": "出於意外"
  },
  {
    "frequency": 32,
    "simplified": "失败为成功之母",
    "traditional": "失敗為成功之母"
  },
  {
    "frequency": 32,
    "simplified": "贫贱不移",
    "traditional": "貧賤不移"
  },
  {
    "frequency": 32,
    "simplified": "慨当以慷",
    "traditional": "慨當以慷"
  },
  {
    "frequency": 32,
    "simplified": "础润而雨",
    "traditional": "礎潤而雨"
  },
  {
    "frequency": 32,
    "simplified": "名士风流",
    "traditional": "名士風流"
  },
  {
    "frequency": 32,
    "simplified": "抑郁寡欢",
    "traditional": "抑鬱寡歡"
  },
  {
    "frequency": 32,
    "simplified": "去头去尾",
    "traditional": "去頭去尾"
  },
  {
    "frequency": 32,
    "simplified": "听其自然",
    "traditional": "聽其自然"
  },
  {
    "frequency": 32,
    "simplified": "肤如凝脂",
    "traditional": "膚如凝脂"
  },
  {
    "frequency": 32,
    "simplified": "百花凋零",
    "traditional": "百花凋零"
  },
  {
    "frequency": 32,
    "simplified": "黄钟毁弃",
    "traditional": "黃鐘毀棄"
  },
  {
    "frequency": 32,
    "simplified": "杳无人迹",
    "traditional": "杳無人跡"
  },
  {
    "frequency": 32,
    "simplified": "百折不屈",
    "traditional": "百折不屈"
  },
  {
    "frequency": 32,
    "simplified": "千峰万壑",
    "traditional": "千峰萬壑"
  },
  {
    "frequency": 32,
    "simplified": "三申五令",
    "traditional": "三申五令"
  },
  {
    "frequency": 32,
    "simplified": "忧谗畏讥",
    "traditional": "憂讒畏譏"
  },
  {
    "frequency": 32,
    "simplified": "落花有意",
    "traditional": "落花有意"
  },
  {
    "frequency": 32,
    "simplified": "信口胡诌",
    "traditional": "信口胡謅"
  },
  {
    "frequency": 32,
    "simplified": "见风转舵",
    "traditional": "見風轉舵"
  },
  {
    "frequency": 32,
    "simplified": "免开尊口",
    "traditional": "免開尊口"
  },
  {
    "frequency": 32,
    "simplified": "河海不择细流",
    "traditional": "河海不擇細流"
  },
  {
    "frequency": 32,
    "simplified": "夫贵妻荣",
    "traditional": "夫貴妻榮"
  },
  {
    "frequency": 32,
    "simplified": "上有天堂下有苏杭",
    "traditional": "上有天堂下有蘇杭"
  },
  {
    "frequency": 32,
    "simplified": "存亡续绝",
    "traditional": "存亡續絕"
  },
  {
    "frequency": 32,
    "simplified": "三千里江山",
    "traditional": "三千里江山"
  },
  {
    "frequency": 32,
    "simplified": "它山之石可以攻玉",
    "traditional": "它山之石可以攻玉"
  },
  {
    "frequency": 32,
    "simplified": "一瓣心香",
    "traditional": "一瓣心香"
  },
  {
    "frequency": 32,
    "simplified": "恭敬不如从命",
    "traditional": "恭敬不如從命"
  },
  {
    "frequency": 32,
    "simplified": "踌躇不决",
    "traditional": "躊躇不決"
  },
  {
    "frequency": 32,
    "simplified": "百折千回",
    "traditional": "百折千回"
  },
  {
    "frequency": 32,
    "simplified": "乘隙而入",
    "traditional": "乘隙而入"
  },
  {
    "frequency": 32,
    "simplified": "面无人色",
    "traditional": "面無人色"
  },
  {
    "frequency": 32,
    "simplified": "青山不老",
    "traditional": "青山不老"
  },
  {
    "frequency": 32,
    "simplified": "黑白混淆",
    "traditional": "黑白混淆"
  },
  {
    "frequency": 32,
    "simplified": "富贵逼人",
    "traditional": "富貴逼人"
  },
  {
    "frequency": 32,
    "simplified": "口含天宪",
    "traditional": "口含天憲"
  },
  {
    "frequency": 32,
    "simplified": "李广难封",
    "traditional": "李廣難封"
  },
  {
    "frequency": 32,
    "simplified": "博学多闻",
    "traditional": "博學多聞"
  },
  {
    "frequency": 32,
    "simplified": "知足不辱",
    "traditional": "知足不辱"
  },
  {
    "frequency": 32,
    "simplified": "鬼头鬼脑",
    "traditional": "鬼頭鬼腦"
  },
  {
    "frequency": 32,
    "simplified": "有志不在年高",
    "traditional": "有志不在年高"
  },
  {
    "frequency": 32,
    "simplified": "与人方便自己方便",
    "traditional": "與人方便自己方便"
  },
  {
    "frequency": 32,
    "simplified": "初生之犊",
    "traditional": "初生之犢"
  },
  {
    "frequency": 32,
    "simplified": "仰不愧天",
    "traditional": "仰不愧天"
  },
  {
    "frequency": 32,
    "simplified": "吴头楚尾",
    "traditional": "吳頭楚尾"
  },
  {
    "frequency": 32,
    "simplified": "半壁河山",
    "traditional": "半壁河山"
  },
  {
    "frequency": 32,
    "simplified": "不差毫厘",
    "traditional": "不差毫釐"
  },
  {
    "frequency": 32,
    "simplified": "犀牛望月",
    "traditional": "犀牛望月"
  },
  {
    "frequency": 32,
    "simplified": "杯中之物",
    "traditional": "杯中之物"
  },
  {
    "frequency": 32,
    "simplified": "杳无消息",
    "traditional": "杳無消息"
  },
  {
    "frequency": 32,
    "simplified": "宠辱皆忘",
    "traditional": "寵辱皆忘"
  },
  {
    "frequency": 32,
    "simplified": "兴国安邦",
    "traditional": "興國安邦"
  },
  {
    "frequency": 32,
    "simplified": "含血喷人",
    "traditional": "含血噴人"
  },
  {
    "frequency": 32,
    "simplified": "牛头马面",
    "traditional": "牛頭馬面"
  },
  {
    "frequency": 32,
    "simplified": "龙生龙凤生凤",
    "traditional": "龍生龍鳳生鳳"
  },
  {
    "frequency": 31,
    "simplified": "马前泼水",
    "traditional": "馬前潑水"
  },
  {
    "frequency": 31,
    "simplified": "诚心正意",
    "traditional": "誠心正意"
  },
  {
    "frequency": 31,
    "simplified": "拳不离手",
    "traditional": "拳不離手"
  },
  {
    "frequency": 31,
    "simplified": "沦落风尘",
    "traditional": "淪落風塵"
  },
  {
    "frequency": 31,
    "simplified": "明白如话",
    "traditional": "明白如話"
  },
  {
    "frequency": 31,
    "simplified": "才德兼备",
    "traditional": "才德兼備"
  },
  {
    "frequency": 31,
    "simplified": "田连阡陌",
    "traditional": "田連阡陌"
  },
  {
    "frequency": 31,
    "simplified": "天理人情",
    "traditional": "天理人情"
  },
  {
    "frequency": 31,
    "simplified": "百弊丛生",
    "traditional": "百弊叢生"
  },
  {
    "frequency": 31,
    "simplified": "可乘之隙",
    "traditional": "可乘之隙"
  },
  {
    "frequency": 31,
    "simplified": "万贯家财",
    "traditional": "萬貫家財"
  },
  {
    "frequency": 31,
    "simplified": "恩威并重",
    "traditional": "恩威並重"
  },
  {
    "frequency": 31,
    "simplified": "玉液琼浆",
    "traditional": "玉液瓊漿"
  },
  {
    "frequency": 31,
    "simplified": "迟疑观望",
    "traditional": "遲疑觀望"
  },
  {
    "frequency": 31,
    "simplified": "夙夜匪懈",
    "traditional": "夙夜匪懈"
  },
  {
    "frequency": 31,
    "simplified": "画栋雕梁",
    "traditional": "畫棟雕梁"
  },
  {
    "frequency": 31,
    "simplified": "寂然无声",
    "traditional": "寂然無聲"
  },
  {
    "frequency": 31,
    "simplified": "笨嘴拙舌",
    "traditional": "笨嘴拙舌"
  },
  {
    "frequency": 31,
    "simplified": "一箭之地",
    "traditional": "一箭之地"
  },
  {
    "frequency": 31,
    "simplified": "欲扬先抑",
    "traditional": "欲揚先抑"
  },
  {
    "frequency": 31,
    "simplified": "吉日良辰",
    "traditional": "吉日良辰"
  },
  {
    "frequency": 31,
    "simplified": "朗朗乾坤",
    "traditional": "朗朗乾坤"
  },
  {
    "frequency": 31,
    "simplified": "肉眼凡胎",
    "traditional": "肉眼凡胎"
  },
  {
    "frequency": 31,
    "simplified": "求过于供",
    "traditional": "求過於供"
  },
  {
    "frequency": 31,
    "simplified": "青灯古佛",
    "traditional": "青燈古佛"
  },
  {
    "frequency": 31,
    "simplified": "铜壶滴漏",
    "traditional": "銅壺滴漏"
  },
  {
    "frequency": 31,
    "simplified": "泥古不化",
    "traditional": "泥古不化"
  },
  {
    "frequency": 31,
    "simplified": "慷慨激扬",
    "traditional": "慷慨激揚"
  },
  {
    "frequency": 31,
    "simplified": "凭空臆造",
    "traditional": "憑空臆造"
  },
  {
    "frequency": 31,
    "simplified": "装潢门面",
    "traditional": "裝潢門面"
  },
  {
    "frequency": 31,
    "simplified": "薄技在身",
    "traditional": "薄技在身"
  },
  {
    "frequency": 31,
    "simplified": "目不忍视",
    "traditional": "目不忍視"
  },
  {
    "frequency": 31,
    "simplified": "上不着天",
    "traditional": "上不著天"
  },
  {
    "frequency": 31,
    "simplified": "不关痛痒",
    "traditional": "不關痛癢"
  },
  {
    "frequency": 31,
    "simplified": "罚不当罪",
    "traditional": "罰不當罪"
  },
  {
    "frequency": 31,
    "simplified": "谈天论地",
    "traditional": "談天論地"
  },
  {
    "frequency": 31,
    "simplified": "名实相副",
    "traditional": "名實相副"
  },
  {
    "frequency": 31,
    "simplified": "攻子之盾",
    "traditional": "攻子之盾"
  },
  {
    "frequency": 31,
    "simplified": "不差上下",
    "traditional": "不差上下"
  },
  {
    "frequency": 31,
    "simplified": "强中更有强中手",
    "traditional": "強中更有強中手"
  },
  {
    "frequency": 31,
    "simplified": "关心民瘼",
    "traditional": "關心民瘼"
  },
  {
    "frequency": 31,
    "simplified": "睥睨一切",
    "traditional": "睥睨一切"
  },
  {
    "frequency": 31,
    "simplified": "有福同享有难同当",
    "traditional": "有福同享有難同當"
  },
  {
    "frequency": 31,
    "simplified": "母以子贵",
    "traditional": "母以子貴"
  },
  {
    "frequency": 31,
    "simplified": "经纬万端",
    "traditional": "經緯萬端"
  },
  {
    "frequency": 31,
    "simplified": "惩一儆百",
    "traditional": "懲一儆百"
  },
  {
    "frequency": 30,
    "simplified": "三月不知肉味",
    "traditional": "三月不知肉味"
  },
  {
    "frequency": 30,
    "simplified": "梦笔生花",
    "traditional": "夢筆生花"
  },
  {
    "frequency": 30,
    "simplified": "满山满谷",
    "traditional": "滿山滿谷"
  },
  {
    "frequency": 30,
    "simplified": "草率从事",
    "traditional": "草率從事"
  },
  {
    "frequency": 30,
    "simplified": "其奈我何",
    "traditional": "其奈我何"
  },
  {
    "frequency": 30,
    "simplified": "逢山开路遇水搭桥",
    "traditional": "逢山開路遇水搭橋"
  },
  {
    "frequency": 30,
    "simplified": "酒绿灯红",
    "traditional": "酒綠燈紅"
  },
  {
    "frequency": 30,
    "simplified": "月圆花好",
    "traditional": "月圓花好"
  },
  {
    "frequency": 30,
    "simplified": "知遇之恩",
    "traditional": "知遇之恩"
  },
  {
    "frequency": 30,
    "simplified": "略窥一斑",
    "traditional": "略窺一斑"
  },
  {
    "frequency": 30,
    "simplified": "奇花异卉",
    "traditional": "奇花異卉"
  },
  {
    "frequency": 30,
    "simplified": "好骑者堕",
    "traditional": "好騎者墮"
  },
  {
    "frequency": 30,
    "simplified": "左右两难",
    "traditional": "左右兩難"
  },
  {
    "frequency": 30,
    "simplified": "人心叵测",
    "traditional": "人心叵測"
  },
  {
    "frequency": 30,
    "simplified": "三心两意",
    "traditional": "三心兩意"
  },
  {
    "frequency": 30,
    "simplified": "九死不悔",
    "traditional": "九死不悔"
  },
  {
    "frequency": 30,
    "simplified": "飞珠溅玉",
    "traditional": "飛珠濺玉"
  },
  {
    "frequency": 30,
    "simplified": "出乖露丑",
    "traditional": "出乖露醜"
  },
  {
    "frequency": 30,
    "simplified": "怀忧丧志",
    "traditional": "懷憂喪志"
  },
  {
    "frequency": 30,
    "simplified": "天王老子",
    "traditional": "天王老子"
  },
  {
    "frequency": 30,
    "simplified": "大度包容",
    "traditional": "大度包容"
  },
  {
    "frequency": 30,
    "simplified": "翩翩公子",
    "traditional": "翩翩公子"
  },
  {
    "frequency": 30,
    "simplified": "心神恍惚",
    "traditional": "心神恍惚"
  },
  {
    "frequency": 30,
    "simplified": "不在其位不谋其政",
    "traditional": "不在其位不謀其政"
  },
  {
    "frequency": 30,
    "simplified": "人多口杂",
    "traditional": "人多口雜"
  },
  {
    "frequency": 30,
    "simplified": "庐山真面",
    "traditional": "廬山真面"
  },
  {
    "frequency": 30,
    "simplified": "鼻孔朝天",
    "traditional": "鼻孔朝天"
  },
  {
    "frequency": 30,
    "simplified": "一悲一喜",
    "traditional": "一悲一喜"
  },
  {
    "frequency": 30,
    "simplified": "避难就易",
    "traditional": "避難就易"
  },
  {
    "frequency": 30,
    "simplified": "活龙活现",
    "traditional": "活龍活現"
  },
  {
    "frequency": 30,
    "simplified": "晕晕沉沉",
    "traditional": "暈暈沉沉"
  },
  {
    "frequency": 30,
    "simplified": "解民倒悬",
    "traditional": "解民倒懸"
  },
  {
    "frequency": 30,
    "simplified": "不知肉味",
    "traditional": "不知肉味"
  },
  {
    "frequency": 30,
    "simplified": "仇人相见分外眼红",
    "traditional": "仇人相見分外眼紅"
  },
  {
    "frequency": 30,
    "simplified": "女流之辈",
    "traditional": "女流之輩"
  },
  {
    "frequency": 30,
    "simplified": "报仇雪耻",
    "traditional": "報仇雪恥"
  },
  {
    "frequency": 30,
    "simplified": "羊肠小径",
    "traditional": "羊腸小徑"
  },
  {
    "frequency": 30,
    "simplified": "鸟尽弓藏",
    "traditional": "鳥盡弓藏"
  },
  {
    "frequency": 30,
    "simplified": "如见其人",
    "traditional": "如見其人"
  },
  {
    "frequency": 30,
    "simplified": "小惩大诫",
    "traditional": "小懲大誡"
  },
  {
    "frequency": 30,
    "simplified": "饱以老拳",
    "traditional": "飽以老拳"
  },
  {
    "frequency": 30,
    "simplified": "出头的椽子先烂",
    "traditional": "出頭的椽子先爛"
  },
  {
    "frequency": 30,
    "simplified": "不系之舟",
    "traditional": "不繫之舟"
  },
  {
    "frequency": 30,
    "simplified": "权倾天下",
    "traditional": "權傾天下"
  },
  {
    "frequency": 30,
    "simplified": "未竟之志",
    "traditional": "未竟之志"
  },
  {
    "frequency": 30,
    "simplified": "手脚干净",
    "traditional": "手腳乾淨"
  },
  {
    "frequency": 30,
    "simplified": "不改其乐",
    "traditional": "不改其樂"
  },
  {
    "frequency": 30,
    "simplified": "大肆铺张",
    "traditional": "大肆鋪張"
  },
  {
    "frequency": 30,
    "simplified": "刻画入微",
    "traditional": "刻畫入微"
  },
  {
    "frequency": 30,
    "simplified": "东扯西拉",
    "traditional": "東扯西拉"
  },
  {
    "frequency": 30,
    "simplified": "曲意迎合",
    "traditional": "曲意迎合"
  },
  {
    "frequency": 30,
    "simplified": "不平之鸣",
    "traditional": "不平之鳴"
  },
  {
    "frequency": 30,
    "simplified": "三寸之舌",
    "traditional": "三寸之舌"
  },
  {
    "frequency": 30,
    "simplified": "铁马金戈",
    "traditional": "鐵馬金戈"
  },
  {
    "frequency": 30,
    "simplified": "洒扫应对",
    "traditional": "灑掃應對"
  },
  {
    "frequency": 30,
    "simplified": "图穷匕首见",
    "traditional": "圖窮匕首見"
  },
  {
    "frequency": 30,
    "simplified": "冯唐易老",
    "traditional": "馮唐易老"
  },
  {
    "frequency": 30,
    "simplified": "以其昏昏使人昭昭",
    "traditional": "以其昏昏使人昭昭"
  },
  {
    "frequency": 29,
    "simplified": "不知老之将至",
    "traditional": "不知老之將至"
  },
  {
    "frequency": 29,
    "simplified": "百无一用是书生",
    "traditional": "百無一用是書生"
  },
  {
    "frequency": 29,
    "simplified": "肉食者鄙",
    "traditional": "肉食者鄙"
  },
  {
    "frequency": 29,
    "simplified": "识途老马",
    "traditional": "識途老馬"
  },
  {
    "frequency": 29,
    "simplified": "日久弥新",
    "traditional": "日久彌新"
  },
  {
    "frequency": 29,
    "simplified": "天堂地狱",
    "traditional": "天堂地獄"
  },
  {
    "frequency": 29,
    "simplified": "仆仆风尘",
    "traditional": "僕僕風塵"
  },
  {
    "frequency": 29,
    "simplified": "漫天叫价",
    "traditional": "漫天叫價"
  },
  {
    "frequency": 29,
    "simplified": "铁画银钩",
    "traditional": "鐵畫銀鉤"
  },
  {
    "frequency": 29,
    "simplified": "一着不慎满盘皆输",
    "traditional": "一著不慎滿盤皆輸"
  },
  {
    "frequency": 29,
    "simplified": "啼饥号寒",
    "traditional": "啼飢號寒"
  },
  {
    "frequency": 29,
    "simplified": "鲁难未已",
    "traditional": "魯難未已"
  },
  {
    "frequency": 29,
    "simplified": "涕泗横流",
    "traditional": "涕泗橫流"
  },
  {
    "frequency": 29,
    "simplified": "饶有风趣",
    "traditional": "饒有風趣"
  },
  {
    "frequency": 29,
    "simplified": "不能登大雅之堂",
    "traditional": "不能登大雅之堂"
  },
  {
    "frequency": 29,
    "simplified": "日暮途穷",
    "traditional": "日暮途窮"
  },
  {
    "frequency": 29,
    "simplified": "负重致远",
    "traditional": "負重致遠"
  },
  {
    "frequency": 29,
    "simplified": "徒托空言",
    "traditional": "徒託空言"
  },
  {
    "frequency": 29,
    "simplified": "月白风清",
    "traditional": "月白風清"
  },
  {
    "frequency": 29,
    "simplified": "付诸一笑",
    "traditional": "付諸一笑"
  },
  {
    "frequency": 29,
    "simplified": "光辉夺目",
    "traditional": "光輝奪目"
  },
  {
    "frequency": 29,
    "simplified": "生于忧患死于安乐",
    "traditional": "生於憂患死於安樂"
  },
  {
    "frequency": 29,
    "simplified": "十八般武艺",
    "traditional": "十八般武藝"
  },
  {
    "frequency": 29,
    "simplified": "声气相通",
    "traditional": "聲氣相通"
  },
  {
    "frequency": 29,
    "simplified": "听其言而观其行",
    "traditional": "聽其言而觀其行"
  },
  {
    "frequency": 29,
    "simplified": "追风逐日",
    "traditional": "追風逐日"
  },
  {
    "frequency": 29,
    "simplified": "教导有方",
    "traditional": "教導有方"
  },
  {
    "frequency": 29,
    "simplified": "苟且偷安",
    "traditional": "苟且偷安"
  },
  {
    "frequency": 29,
    "simplified": "相忍为国",
    "traditional": "相忍為國"
  },
  {
    "frequency": 29,
    "simplified": "枭首示众",
    "traditional": "梟首示眾"
  },
  {
    "frequency": 29,
    "simplified": "久闻大名",
    "traditional": "久聞大名"
  },
  {
    "frequency": 29,
    "simplified": "国富民安",
    "traditional": "國富民安"
  },
  {
    "frequency": 29,
    "simplified": "骇浪惊涛",
    "traditional": "駭浪驚濤"
  },
  {
    "frequency": 29,
    "simplified": "月晕而风",
    "traditional": "月暈而風"
  },
  {
    "frequency": 29,
    "simplified": "吟风弄月",
    "traditional": "吟風弄月"
  },
  {
    "frequency": 29,
    "simplified": "雪里送炭",
    "traditional": "雪裡送炭"
  },
  {
    "frequency": 29,
    "simplified": "如之奈何",
    "traditional": "如之奈何"
  },
  {
    "frequency": 29,
    "simplified": "茫然若失",
    "traditional": "茫然若失"
  },
  {
    "frequency": 29,
    "simplified": "翩翩风度",
    "traditional": "翩翩風度"
  },
  {
    "frequency": 29,
    "simplified": "半生半熟",
    "traditional": "半生半熟"
  },
  {
    "frequency": 29,
    "simplified": "五劳七伤",
    "traditional": "五勞七傷"
  },
  {
    "frequency": 29,
    "simplified": "言有尽而意无穷",
    "traditional": "言有盡而意無窮"
  },
  {
    "frequency": 29,
    "simplified": "杯觥交错",
    "traditional": "杯觥交錯"
  },
  {
    "frequency": 29,
    "simplified": "有贼心没贼胆",
    "traditional": "有賊心沒賊膽"
  },
  {
    "frequency": 29,
    "simplified": "耿耿忠心",
    "traditional": "耿耿忠心"
  },
  {
    "frequency": 29,
    "simplified": "天不假年",
    "traditional": "天不假年"
  },
  {
    "frequency": 29,
    "simplified": "整旧如新",
    "traditional": "整舊如新"
  },
  {
    "frequency": 29,
    "simplified": "东藏西躲",
    "traditional": "東藏西躲"
  },
  {
    "frequency": 29,
    "simplified": "眼中钉肉中刺",
    "traditional": "眼中釘肉中刺"
  },
  {
    "frequency": 29,
    "simplified": "开合自如",
    "traditional": "開合自如"
  },
  {
    "frequency": 29,
    "simplified": "不得其详",
    "traditional": "不得其詳"
  },
  {
    "frequency": 29,
    "simplified": "风刀霜剑",
    "traditional": "風刀霜劍"
  },
  {
    "frequency": 29,
    "simplified": "胶柱鼓瑟",
    "traditional": "膠柱鼓瑟"
  },
  {
    "frequency": 29,
    "simplified": "龙精虎猛",
    "traditional": "龍精虎猛"
  },
  {
    "frequency": 29,
    "simplified": "性命交关",
    "traditional": "性命交關"
  },
  {
    "frequency": 29,
    "simplified": "半饥半饱",
    "traditional": "半飢半飽"
  },
  {
    "frequency": 28,
    "simplified": "不可胜计",
    "traditional": "不可勝計"
  },
  {
    "frequency": 28,
    "simplified": "泰山不让土壤",
    "traditional": "泰山不讓土壤"
  },
  {
    "frequency": 28,
    "simplified": "人不为己天诛地灭",
    "traditional": "人不為己天誅地滅"
  },
  {
    "frequency": 28,
    "simplified": "大地春回",
    "traditional": "大地春回"
  },
  {
    "frequency": 28,
    "simplified": "民膏民脂",
    "traditional": "民膏民脂"
  },
  {
    "frequency": 28,
    "simplified": "脸红耳热",
    "traditional": "臉紅耳熱"
  },
  {
    "frequency": 28,
    "simplified": "业精于勤荒于嬉",
    "traditional": "業精於勤荒於嬉"
  },
  {
    "frequency": 28,
    "simplified": "宁为玉碎不为瓦全",
    "traditional": "寧為玉碎不為瓦全"
  },
  {
    "frequency": 28,
    "simplified": "鬼话连篇",
    "traditional": "鬼話連篇"
  },
  {
    "frequency": 28,
    "simplified": "惟精惟一",
    "traditional": "惟精惟一"
  },
  {
    "frequency": 28,
    "simplified": "恍如梦境",
    "traditional": "恍如夢境"
  },
  {
    "frequency": 28,
    "simplified": "迁客骚人",
    "traditional": "遷客騷人"
  },
  {
    "frequency": 28,
    "simplified": "人欢马叫",
    "traditional": "人歡馬叫"
  },
  {
    "frequency": 28,
    "simplified": "春生夏长秋收冬藏",
    "traditional": "春生夏長秋收冬藏"
  },
  {
    "frequency": 28,
    "simplified": "威震天下",
    "traditional": "威震天下"
  },
  {
    "frequency": 28,
    "simplified": "吐气扬眉",
    "traditional": "吐氣揚眉"
  },
  {
    "frequency": 28,
    "simplified": "卑鄙龌龊",
    "traditional": "卑鄙齷齪"
  },
  {
    "frequency": 28,
    "simplified": "心急如火",
    "traditional": "心急如火"
  },
  {
    "frequency": 28,
    "simplified": "鼻青眼肿",
    "traditional": "鼻青眼腫"
  },
  {
    "frequency": 28,
    "simplified": "你言我语",
    "traditional": "你言我語"
  },
  {
    "frequency": 28,
    "simplified": "一丘一壑",
    "traditional": "一丘一壑"
  },
  {
    "frequency": 28,
    "simplified": "老僧入定",
    "traditional": "老僧入定"
  },
  {
    "frequency": 28,
    "simplified": "官官相卫",
    "traditional": "官官相衛"
  },
  {
    "frequency": 28,
    "simplified": "勇冠三军",
    "traditional": "勇冠三軍"
  },
  {
    "frequency": 28,
    "simplified": "信赏必罚",
    "traditional": "信賞必罰"
  },
  {
    "frequency": 28,
    "simplified": "憎爱分明",
    "traditional": "憎愛分明"
  },
  {
    "frequency": 28,
    "simplified": "一言兴邦",
    "traditional": "一言興邦"
  },
  {
    "frequency": 28,
    "simplified": "桂子飘香",
    "traditional": "桂子飄香"
  },
  {
    "frequency": 28,
    "simplified": "以勤补拙",
    "traditional": "以勤補拙"
  },
  {
    "frequency": 28,
    "simplified": "跑了和尚跑不了庙",
    "traditional": "跑了和尚跑不了廟"
  },
  {
    "frequency": 28,
    "simplified": "强中自有强中手",
    "traditional": "強中自有強中手"
  },
  {
    "frequency": 28,
    "simplified": "离情别绪",
    "traditional": "離情別緒"
  },
  {
    "frequency": 28,
    "simplified": "七零八散",
    "traditional": "七零八散"
  },
  {
    "frequency": 28,
    "simplified": "市井无赖",
    "traditional": "市井無賴"
  },
  {
    "frequency": 28,
    "simplified": "悠悠荡荡",
    "traditional": "悠悠盪盪"
  },
  {
    "frequency": 28,
    "simplified": "量才录用",
    "traditional": "量才錄用"
  },
  {
    "frequency": 28,
    "simplified": "不露锋芒",
    "traditional": "不露鋒芒"
  },
  {
    "frequency": 28,
    "simplified": "宦海浮沉",
    "traditional": "宦海浮沉"
  },
  {
    "frequency": 28,
    "simplified": "清新俊逸",
    "traditional": "清新俊逸"
  },
  {
    "frequency": 28,
    "simplified": "英姿焕发",
    "traditional": "英姿煥發"
  },
  {
    "frequency": 28,
    "simplified": "话里带刺",
    "traditional": "話裡帶刺"
  },
  {
    "frequency": 28,
    "simplified": "有隙可乘",
    "traditional": "有隙可乘"
  },
  {
    "frequency": 28,
    "simplified": "玲珑小巧",
    "traditional": "玲瓏小巧"
  },
  {
    "frequency": 28,
    "simplified": "风清月朗",
    "traditional": "風清月朗"
  },
  {
    "frequency": 28,
    "simplified": "月满则亏",
    "traditional": "月滿則虧"
  },
  {
    "frequency": 28,
    "simplified": "百万雄兵",
    "traditional": "百萬雄兵"
  },
  {
    "frequency": 28,
    "simplified": "举措失当",
    "traditional": "舉措失當"
  },
  {
    "frequency": 28,
    "simplified": "民不畏死",
    "traditional": "民不畏死"
  },
  {
    "frequency": 28,
    "simplified": "残汤剩饭",
    "traditional": "殘湯剩飯"
  },
  {
    "frequency": 28,
    "simplified": "洪钟大吕",
    "traditional": "洪鐘大呂"
  },
  {
    "frequency": 28,
    "simplified": "好生之德",
    "traditional": "好生之德"
  },
  {
    "frequency": 28,
    "simplified": "不贪为宝",
    "traditional": "不貪為寶"
  },
  {
    "frequency": 28,
    "simplified": "喘息未定",
    "traditional": "喘息未定"
  },
  {
    "frequency": 28,
    "simplified": "一命归西",
    "traditional": "一命歸西"
  },
  {
    "frequency": 28,
    "simplified": "假戏成真",
    "traditional": "假戲成真"
  },
  {
    "frequency": 28,
    "simplified": "不服水土",
    "traditional": "不服水土"
  },
  {
    "frequency": 28,
    "simplified": "博采众议",
    "traditional": "博採眾議"
  },
  {
    "frequency": 28,
    "simplified": "乐业安居",
    "traditional": "樂業安居"
  },
  {
    "frequency": 28,
    "simplified": "酒醉饭饱",
    "traditional": "酒醉飯飽"
  },
  {
    "frequency": 28,
    "simplified": "富贵不淫",
    "traditional": "富貴不淫"
  },
  {
    "frequency": 28,
    "simplified": "宜室宜家",
    "traditional": "宜室宜家"
  },
  {
    "frequency": 28,
    "simplified": "非一日之寒",
    "traditional": "非一日之寒"
  },
  {
    "frequency": 28,
    "simplified": "言简意深",
    "traditional": "言簡意深"
  },
  {
    "frequency": 28,
    "simplified": "干卿何事",
    "traditional": "干卿何事"
  },
  {
    "frequency": 28,
    "simplified": "陈陈相因",
    "traditional": "陳陳相因"
  },
  {
    "frequency": 28,
    "simplified": "缩头缩脑",
    "traditional": "縮頭縮腦"
  },
  {
    "frequency": 28,
    "simplified": "慌张失措",
    "traditional": "慌張失措"
  },
  {
    "frequency": 28,
    "simplified": "打躬作揖",
    "traditional": "打躬作揖"
  },
  {
    "frequency": 28,
    "simplified": "面有菜色",
    "traditional": "面有菜色"
  },
  {
    "frequency": 28,
    "simplified": "只此一家别无分店",
    "traditional": "只此一家別無分店"
  },
  {
    "frequency": 27,
    "simplified": "桑间濮上",
    "traditional": "桑間濮上"
  },
  {
    "frequency": 27,
    "simplified": "文情并茂",
    "traditional": "文情並茂"
  },
  {
    "frequency": 27,
    "simplified": "偶一为之",
    "traditional": "偶一為之"
  },
  {
    "frequency": 27,
    "simplified": "心旌摇曳",
    "traditional": "心旌搖曳"
  },
  {
    "frequency": 27,
    "simplified": "引以为憾",
    "traditional": "引以為憾"
  },
  {
    "frequency": 27,
    "simplified": "将功折罪",
    "traditional": "將功折罪"
  },
  {
    "frequency": 27,
    "simplified": "片瓦不留",
    "traditional": "片瓦不留"
  },
  {
    "frequency": 27,
    "simplified": "费心劳神",
    "traditional": "費心勞神"
  },
  {
    "frequency": 27,
    "simplified": "丈二和尚",
    "traditional": "丈二和尚"
  },
  {
    "frequency": 27,
    "simplified": "扇枕温衾",
    "traditional": "扇枕溫衾"
  },
  {
    "frequency": 27,
    "simplified": "藏之名山",
    "traditional": "藏之名山"
  },
  {
    "frequency": 27,
    "simplified": "王祥卧冰",
    "traditional": "王祥臥冰"
  },
  {
    "frequency": 27,
    "simplified": "柔肠百转",
    "traditional": "柔腸百轉"
  },
  {
    "frequency": 27,
    "simplified": "从宽发落",
    "traditional": "從寬發落"
  },
  {
    "frequency": 27,
    "simplified": "二人同心",
    "traditional": "二人同心"
  },
  {
    "frequency": 27,
    "simplified": "音信杳无",
    "traditional": "音信杳無"
  },
  {
    "frequency": 27,
    "simplified": "等因奉此",
    "traditional": "等因奉此"
  },
  {
    "frequency": 27,
    "simplified": "生而知之",
    "traditional": "生而知之"
  },
  {
    "frequency": 27,
    "simplified": "明珠暗投",
    "traditional": "明珠暗投"
  },
  {
    "frequency": 27,
    "simplified": "真人不露相",
    "traditional": "真人不露相"
  },
  {
    "frequency": 27,
    "simplified": "不忍释卷",
    "traditional": "不忍釋卷"
  },
  {
    "frequency": 27,
    "simplified": "秋月春风",
    "traditional": "秋月春風"
  },
  {
    "frequency": 27,
    "simplified": "奉为楷模",
    "traditional": "奉為楷模"
  },
  {
    "frequency": 27,
    "simplified": "香草美人",
    "traditional": "香草美人"
  },
  {
    "frequency": 27,
    "simplified": "春宵一刻值千金",
    "traditional": "春宵一刻值千金"
  },
  {
    "frequency": 27,
    "simplified": "杀鸡焉用牛刀",
    "traditional": "殺雞焉用牛刀"
  },
  {
    "frequency": 27,
    "simplified": "热锅上蚂蚁",
    "traditional": "熱鍋上螞蟻"
  },
  {
    "frequency": 27,
    "simplified": "殿堂楼阁",
    "traditional": "殿堂樓閣"
  },
  {
    "frequency": 27,
    "simplified": "一路货色",
    "traditional": "一路貨色"
  },
  {
    "frequency": 27,
    "simplified": "精诚所至金石为开",
    "traditional": "精誠所至金石為開"
  },
  {
    "frequency": 27,
    "simplified": "食洋不化",
    "traditional": "食洋不化"
  },
  {
    "frequency": 27,
    "simplified": "乐以忘忧",
    "traditional": "樂以忘憂"
  },
  {
    "frequency": 27,
    "simplified": "因循苟且",
    "traditional": "因循苟且"
  },
  {
    "frequency": 27,
    "simplified": "金鼓齐鸣",
    "traditional": "金鼓齊鳴"
  },
  {
    "frequency": 27,
    "simplified": "嚣张一时",
    "traditional": "囂張一時"
  },
  {
    "frequency": 27,
    "simplified": "狗咬吕洞宾",
    "traditional": "狗咬呂洞賓"
  },
  {
    "frequency": 27,
    "simplified": "男女老幼",
    "traditional": "男女老幼"
  },
  {
    "frequency": 27,
    "simplified": "嘤其鸣矣",
    "traditional": "嚶其鳴矣"
  },
  {
    "frequency": 27,
    "simplified": "神闲气定",
    "traditional": "神閒氣定"
  },
  {
    "frequency": 27,
    "simplified": "允执厥中",
    "traditional": "允執厥中"
  },
  {
    "frequency": 27,
    "simplified": "狂涛骇浪",
    "traditional": "狂濤駭浪"
  },
  {
    "frequency": 27,
    "simplified": "有负众望",
    "traditional": "有負眾望"
  },
  {
    "frequency": 27,
    "simplified": "横眉怒目",
    "traditional": "橫眉怒目"
  },
  {
    "frequency": 27,
    "simplified": "孤儿寡妇",
    "traditional": "孤兒寡婦"
  },
  {
    "frequency": 27,
    "simplified": "贵人多忘事",
    "traditional": "貴人多忘事"
  },
  {
    "frequency": 27,
    "simplified": "武艺超群",
    "traditional": "武藝超群"
  },
  {
    "frequency": 27,
    "simplified": "搬石砸脚",
    "traditional": "搬石砸腳"
  },
  {
    "frequency": 27,
    "simplified": "三元及第",
    "traditional": "三元及第"
  },
  {
    "frequency": 27,
    "simplified": "相时而动",
    "traditional": "相時而動"
  },
  {
    "frequency": 27,
    "simplified": "慎始敬终",
    "traditional": "慎始敬終"
  },
  {
    "frequency": 27,
    "simplified": "盛名之下其实难副",
    "traditional": "盛名之下其實難副"
  },
  {
    "frequency": 27,
    "simplified": "大人先生",
    "traditional": "大人先生"
  },
  {
    "frequency": 27,
    "simplified": "乱世英雄",
    "traditional": "亂世英雄"
  },
  {
    "frequency": 27,
    "simplified": "有财有势",
    "traditional": "有財有勢"
  },
  {
    "frequency": 27,
    "simplified": "齐驱并进",
    "traditional": "齊驅並進"
  },
  {
    "frequency": 27,
    "simplified": "严于律已",
    "traditional": "嚴於律已"
  },
  {
    "frequency": 27,
    "simplified": "福地洞天",
    "traditional": "福地洞天"
  },
  {
    "frequency": 27,
    "simplified": "寻幽探胜",
    "traditional": "尋幽探勝"
  },
  {
    "frequency": 27,
    "simplified": "烽火四起",
    "traditional": "烽火四起"
  },
  {
    "frequency": 27,
    "simplified": "光风霁月",
    "traditional": "光風霽月"
  },
  {
    "frequency": 26,
    "simplified": "齐家治国",
    "traditional": "齊家治國"
  },
  {
    "frequency": 26,
    "simplified": "亡国之音",
    "traditional": "亡國之音"
  },
  {
    "frequency": 26,
    "simplified": "关山阻隔",
    "traditional": "關山阻隔"
  },
  {
    "frequency": 26,
    "simplified": "千古罪人",
    "traditional": "千古罪人"
  },
  {
    "frequency": 26,
    "simplified": "昂头挺胸",
    "traditional": "昂頭挺胸"
  },
  {
    "frequency": 26,
    "simplified": "榆木疙瘩",
    "traditional": "榆木疙瘩"
  },
  {
    "frequency": 26,
    "simplified": "儿女之情",
    "traditional": "兒女之情"
  },
  {
    "frequency": 26,
    "simplified": "孟母择邻",
    "traditional": "孟母擇鄰"
  },
  {
    "frequency": 26,
    "simplified": "餐风饮露",
    "traditional": "餐風飲露"
  },
  {
    "frequency": 26,
    "simplified": "无踪无影",
    "traditional": "無蹤無影"
  },
  {
    "frequency": 26,
    "simplified": "人五人六",
    "traditional": "人五人六"
  },
  {
    "frequency": 26,
    "simplified": "剜肉补疮",
    "traditional": "剜肉補瘡"
  },
  {
    "frequency": 26,
    "simplified": "清风朗月",
    "traditional": "清風朗月"
  },
  {
    "frequency": 26,
    "simplified": "逸趣横生",
    "traditional": "逸趣橫生"
  },
  {
    "frequency": 26,
    "simplified": "出敌不意",
    "traditional": "出敵不意"
  },
  {
    "frequency": 26,
    "simplified": "怙恶不悛",
    "traditional": "怙惡不悛"
  },
  {
    "frequency": 26,
    "simplified": "朝生暮死",
    "traditional": "朝生暮死"
  },
  {
    "frequency": 26,
    "simplified": "将本求利",
    "traditional": "將本求利"
  },
  {
    "frequency": 26,
    "simplified": "以心传心",
    "traditional": "以心傳心"
  },
  {
    "frequency": 26,
    "simplified": "千年万载",
    "traditional": "千年萬載"
  },
  {
    "frequency": 26,
    "simplified": "大有其人",
    "traditional": "大有其人"
  },
  {
    "frequency": 26,
    "simplified": "摧眉折腰",
    "traditional": "摧眉折腰"
  },
  {
    "frequency": 26,
    "simplified": "单人匹马",
    "traditional": "單人匹馬"
  },
  {
    "frequency": 26,
    "simplified": "身在江湖",
    "traditional": "身在江湖"
  },
  {
    "frequency": 26,
    "simplified": "治国安民",
    "traditional": "治國安民"
  },
  {
    "frequency": 26,
    "simplified": "又见一帘幽梦",
    "traditional": "又見一簾幽夢"
  },
  {
    "frequency": 26,
    "simplified": "味如嚼蜡",
    "traditional": "味如嚼蠟"
  },
  {
    "frequency": 26,
    "simplified": "求生不得",
    "traditional": "求生不得"
  },
  {
    "frequency": 26,
    "simplified": "涕泪交流",
    "traditional": "涕淚交流"
  },
  {
    "frequency": 26,
    "simplified": "吉凶未卜",
    "traditional": "吉凶未卜"
  },
  {
    "frequency": 26,
    "simplified": "不孚众望",
    "traditional": "不孚眾望"
  },
  {
    "frequency": 26,
    "simplified": "千古不朽",
    "traditional": "千古不朽"
  },
  {
    "frequency": 26,
    "simplified": "拈花一笑",
    "traditional": "拈花一笑"
  },
  {
    "frequency": 26,
    "simplified": "神完气足",
    "traditional": "神完氣足"
  },
  {
    "frequency": 26,
    "simplified": "贿赂公行",
    "traditional": "賄賂公行"
  },
  {
    "frequency": 26,
    "simplified": "却之不恭",
    "traditional": "卻之不恭"
  },
  {
    "frequency": 26,
    "simplified": "星月交辉",
    "traditional": "星月交輝"
  },
  {
    "frequency": 26,
    "simplified": "聊备一格",
    "traditional": "聊備一格"
  },
  {
    "frequency": 26,
    "simplified": "各有所短",
    "traditional": "各有所短"
  },
  {
    "frequency": 26,
    "simplified": "喜逐颜开",
    "traditional": "喜逐顏開"
  },
  {
    "frequency": 26,
    "simplified": "过目成诵",
    "traditional": "過目成誦"
  },
  {
    "frequency": 26,
    "simplified": "无边无垠",
    "traditional": "無邊無垠"
  },
  {
    "frequency": 26,
    "simplified": "日月无光",
    "traditional": "日月無光"
  },
  {
    "frequency": 26,
    "simplified": "凌云之志",
    "traditional": "凌雲之志"
  },
  {
    "frequency": 26,
    "simplified": "哀哀父母",
    "traditional": "哀哀父母"
  },
  {
    "frequency": 26,
    "simplified": "脚不点地",
    "traditional": "腳不點地"
  },
  {
    "frequency": 26,
    "simplified": "求贤如渴",
    "traditional": "求賢如渴"
  },
  {
    "frequency": 26,
    "simplified": "荦荦大端",
    "traditional": "犖犖大端"
  },
  {
    "frequency": 26,
    "simplified": "驴头不对马嘴",
    "traditional": "驢頭不對馬嘴"
  },
  {
    "frequency": 26,
    "simplified": "门户之争",
    "traditional": "門戶之爭"
  },
  {
    "frequency": 26,
    "simplified": "一字之师",
    "traditional": "一字之師"
  },
  {
    "frequency": 26,
    "simplified": "安如磐石",
    "traditional": "安如磐石"
  },
  {
    "frequency": 26,
    "simplified": "降尊纡贵",
    "traditional": "降尊紆貴"
  },
  {
    "frequency": 26,
    "simplified": "南征北讨",
    "traditional": "南征北討"
  },
  {
    "frequency": 26,
    "simplified": "羊续悬鱼",
    "traditional": "羊續懸魚"
  },
  {
    "frequency": 26,
    "simplified": "满脸春风",
    "traditional": "滿臉春風"
  },
  {
    "frequency": 26,
    "simplified": "绝世佳人",
    "traditional": "絕世佳人"
  },
  {
    "frequency": 26,
    "simplified": "颠簸不破",
    "traditional": "顛簸不破"
  },
  {
    "frequency": 26,
    "simplified": "急人之困",
    "traditional": "急人之困"
  },
  {
    "frequency": 25,
    "simplified": "为渊驱鱼",
    "traditional": "為淵驅魚"
  },
  {
    "frequency": 25,
    "simplified": "白沙在涅",
    "traditional": "白沙在涅"
  },
  {
    "frequency": 25,
    "simplified": "才情横溢",
    "traditional": "才情橫溢"
  },
  {
    "frequency": 25,
    "simplified": "竭忠尽智",
    "traditional": "竭忠盡智"
  },
  {
    "frequency": 25,
    "simplified": "墙头马上",
    "traditional": "牆頭馬上"
  },
  {
    "frequency": 25,
    "simplified": "相煎太急",
    "traditional": "相煎太急"
  },
  {
    "frequency": 25,
    "simplified": "出师无名",
    "traditional": "出師無名"
  },
  {
    "frequency": 25,
    "simplified": "纵虎归山",
    "traditional": "縱虎歸山"
  },
  {
    "frequency": 25,
    "simplified": "不咎既往",
    "traditional": "不咎既往"
  },
  {
    "frequency": 25,
    "simplified": "存心不良",
    "traditional": "存心不良"
  },
  {
    "frequency": 25,
    "simplified": "浴火凤凰",
    "traditional": "浴火鳳凰"
  },
  {
    "frequency": 25,
    "simplified": "毁誉不一",
    "traditional": "譭譽不一"
  },
  {
    "frequency": 25,
    "simplified": "万应灵药",
    "traditional": "萬應靈藥"
  },
  {
    "frequency": 25,
    "simplified": "凤凰来仪",
    "traditional": "鳳凰來儀"
  },
  {
    "frequency": 25,
    "simplified": "傻头傻脑",
    "traditional": "傻頭傻腦"
  },
  {
    "frequency": 25,
    "simplified": "年深月久",
    "traditional": "年深月久"
  },
  {
    "frequency": 25,
    "simplified": "张皇失措",
    "traditional": "張皇失措"
  },
  {
    "frequency": 25,
    "simplified": "射人先射马",
    "traditional": "射人先射馬"
  },
  {
    "frequency": 25,
    "simplified": "卧床不起",
    "traditional": "臥床不起"
  },
  {
    "frequency": 25,
    "simplified": "众寡悬殊",
    "traditional": "眾寡懸殊"
  },
  {
    "frequency": 25,
    "simplified": "言必有据",
    "traditional": "言必有據"
  },
  {
    "frequency": 25,
    "simplified": "不顾死活",
    "traditional": "不顧死活"
  },
  {
    "frequency": 25,
    "simplified": "山鸣谷应",
    "traditional": "山鳴谷應"
  },
  {
    "frequency": 25,
    "simplified": "国而忘家",
    "traditional": "國而忘家"
  },
  {
    "frequency": 25,
    "simplified": "郁郁不乐",
    "traditional": "鬱鬱不樂"
  },
  {
    "frequency": 25,
    "simplified": "一身二任",
    "traditional": "一身二任"
  },
  {
    "frequency": 25,
    "simplified": "瓜瓞绵绵",
    "traditional": "瓜瓞綿綿"
  },
  {
    "frequency": 25,
    "simplified": "胜友如云",
    "traditional": "勝友如雲"
  },
  {
    "frequency": 25,
    "simplified": "桃花流水",
    "traditional": "桃花流水"
  },
  {
    "frequency": 25,
    "simplified": "枝节横生",
    "traditional": "枝節橫生"
  },
  {
    "frequency": 25,
    "simplified": "抚掌大笑",
    "traditional": "撫掌大笑"
  },
  {
    "frequency": 25,
    "simplified": "残花败柳",
    "traditional": "殘花敗柳"
  },
  {
    "frequency": 25,
    "simplified": "强龙不压地头蛇",
    "traditional": "強龍不壓地頭蛇"
  },
  {
    "frequency": 25,
    "simplified": "探赜索隐",
    "traditional": "探賾索隱"
  },
  {
    "frequency": 25,
    "simplified": "诗酒风流",
    "traditional": "詩酒風流"
  },
  {
    "frequency": 25,
    "simplified": "济困扶危",
    "traditional": "濟困扶危"
  },
  {
    "frequency": 25,
    "simplified": "知足知止",
    "traditional": "知足知止"
  },
  {
    "frequency": 25,
    "simplified": "永生永世",
    "traditional": "永生永世"
  },
  {
    "frequency": 25,
    "simplified": "苦心积虑",
    "traditional": "苦心積慮"
  },
  {
    "frequency": 25,
    "simplified": "日出而作日入而息",
    "traditional": "日出而作日入而息"
  },
  {
    "frequency": 25,
    "simplified": "前人种树后人乘凉",
    "traditional": "前人種樹後人乘涼"
  },
  {
    "frequency": 25,
    "simplified": "济世安邦",
    "traditional": "濟世安邦"
  },
  {
    "frequency": 25,
    "simplified": "超然独立",
    "traditional": "超然獨立"
  },
  {
    "frequency": 25,
    "simplified": "将门虎子",
    "traditional": "將門虎子"
  },
  {
    "frequency": 25,
    "simplified": "竹篱茅舍",
    "traditional": "竹籬茅舍"
  },
  {
    "frequency": 25,
    "simplified": "臭名昭彰",
    "traditional": "臭名昭彰"
  },
  {
    "frequency": 25,
    "simplified": "一日不见如隔三秋",
    "traditional": "一日不見如隔三秋"
  },
  {
    "frequency": 25,
    "simplified": "粉妆玉砌",
    "traditional": "粉妝玉砌"
  },
  {
    "frequency": 25,
    "simplified": "鸢飞鱼跃",
    "traditional": "鳶飛魚躍"
  },
  {
    "frequency": 25,
    "simplified": "片瓦无存",
    "traditional": "片瓦無存"
  },
  {
    "frequency": 25,
    "simplified": "案牍劳形",
    "traditional": "案牘勞形"
  },
  {
    "frequency": 25,
    "simplified": "片言只字",
    "traditional": "片言隻字"
  },
  {
    "frequency": 25,
    "simplified": "丰姿绰约",
    "traditional": "丰姿綽約"
  },
  {
    "frequency": 25,
    "simplified": "春风雨露",
    "traditional": "春風雨露"
  },
  {
    "frequency": 25,
    "simplified": "光焰万丈",
    "traditional": "光焰萬丈"
  },
  {
    "frequency": 25,
    "simplified": "笔下生花",
    "traditional": "筆下生花"
  },
  {
    "frequency": 25,
    "simplified": "豺狼当道",
    "traditional": "豺狼當道"
  },
  {
    "frequency": 25,
    "simplified": "别无长物",
    "traditional": "別無長物"
  },
  {
    "frequency": 25,
    "simplified": "涂炭生灵",
    "traditional": "塗炭生靈"
  },
  {
    "frequency": 25,
    "simplified": "不厌其详",
    "traditional": "不厭其詳"
  },
  {
    "frequency": 25,
    "simplified": "丹青妙手",
    "traditional": "丹青妙手"
  },
  {
    "frequency": 25,
    "simplified": "叨陪末座",
    "traditional": "叨陪末座"
  },
  {
    "frequency": 25,
    "simplified": "步履艰辛",
    "traditional": "步履艱辛"
  },
  {
    "frequency": 25,
    "simplified": "犬马之劳",
    "traditional": "犬馬之勞"
  },
  {
    "frequency": 25,
    "simplified": "没头没脸",
    "traditional": "沒頭沒臉"
  },
  {
    "frequency": 25,
    "simplified": "不自由毋宁死",
    "traditional": "不自由毋寧死"
  },
  {
    "frequency": 25,
    "simplified": "万古长存",
    "traditional": "萬古長存"
  },
  {
    "frequency": 24,
    "simplified": "间不容发",
    "traditional": "間不容髮"
  },
  {
    "frequency": 24,
    "simplified": "气壮如牛",
    "traditional": "氣壯如牛"
  },
  {
    "frequency": 24,
    "simplified": "十年生聚",
    "traditional": "十年生聚"
  },
  {
    "frequency": 24,
    "simplified": "不看僧面看佛面",
    "traditional": "不看僧面看佛面"
  },
  {
    "frequency": 24,
    "simplified": "损己利人",
    "traditional": "損己利人"
  },
  {
    "frequency": 24,
    "simplified": "糟糠之妻不下堂",
    "traditional": "糟糠之妻不下堂"
  },
  {
    "frequency": 24,
    "simplified": "道骨仙风",
    "traditional": "道骨仙風"
  },
  {
    "frequency": 24,
    "simplified": "推本溯源",
    "traditional": "推本溯源"
  },
  {
    "frequency": 24,
    "simplified": "万事亨通",
    "traditional": "萬事亨通"
  },
  {
    "frequency": 24,
    "simplified": "乘兴而来败兴而归",
    "traditional": "乘興而來敗興而歸"
  },
  {
    "frequency": 24,
    "simplified": "腹心之疾",
    "traditional": "腹心之疾"
  },
  {
    "frequency": 24,
    "simplified": "东成西就",
    "traditional": "東成西就"
  },
  {
    "frequency": 24,
    "simplified": "齐烟九点",
    "traditional": "齊煙九點"
  },
  {
    "frequency": 24,
    "simplified": "告贷无门",
    "traditional": "告貸無門"
  },
  {
    "frequency": 24,
    "simplified": "白首方悔读书迟",
    "traditional": "白首方悔讀書遲"
  },
  {
    "frequency": 24,
    "simplified": "车如流水马如龙",
    "traditional": "車如流水馬如龍"
  },
  {
    "frequency": 24,
    "simplified": "二八年华",
    "traditional": "二八年華"
  },
  {
    "frequency": 24,
    "simplified": "冲冠一怒为红颜",
    "traditional": "衝冠一怒為紅顏"
  },
  {
    "frequency": 24,
    "simplified": "诸子百家",
    "traditional": "諸子百家"
  },
  {
    "frequency": 24,
    "simplified": "骑马找马",
    "traditional": "騎馬找馬"
  },
  {
    "frequency": 24,
    "simplified": "满坑满谷",
    "traditional": "滿坑滿谷"
  },
  {
    "frequency": 24,
    "simplified": "如簧之舌",
    "traditional": "如簧之舌"
  },
  {
    "frequency": 24,
    "simplified": "擦脂抹粉",
    "traditional": "擦脂抹粉"
  },
  {
    "frequency": 24,
    "simplified": "物以类聚人以群分",
    "traditional": "物以類聚人以群分"
  },
  {
    "frequency": 24,
    "simplified": "嬉笑怒骂皆成文章",
    "traditional": "嬉笑怒罵皆成文章"
  },
  {
    "frequency": 24,
    "simplified": "陌路相逢",
    "traditional": "陌路相逢"
  },
  {
    "frequency": 24,
    "simplified": "如诉如泣",
    "traditional": "如訴如泣"
  },
  {
    "frequency": 24,
    "simplified": "倾城倾国",
    "traditional": "傾城傾國"
  },
  {
    "frequency": 24,
    "simplified": "不知进退",
    "traditional": "不知進退"
  },
  {
    "frequency": 24,
    "simplified": "无头无尾",
    "traditional": "無頭無尾"
  },
  {
    "frequency": 24,
    "simplified": "将欲取之",
    "traditional": "將欲取之"
  },
  {
    "frequency": 24,
    "simplified": "卖身投靠",
    "traditional": "賣身投靠"
  },
  {
    "frequency": 24,
    "simplified": "不虞之誉",
    "traditional": "不虞之譽"
  },
  {
    "frequency": 24,
    "simplified": "粉妆玉琢",
    "traditional": "粉妝玉琢"
  },
  {
    "frequency": 24,
    "simplified": "浩若烟海",
    "traditional": "浩若煙海"
  },
  {
    "frequency": 24,
    "simplified": "骚人墨客",
    "traditional": "騷人墨客"
  },
  {
    "frequency": 24,
    "simplified": "不分敌我",
    "traditional": "不分敵我"
  },
  {
    "frequency": 24,
    "simplified": "一无可取",
    "traditional": "一無可取"
  },
  {
    "frequency": 24,
    "simplified": "扶弱抑强",
    "traditional": "扶弱抑強"
  },
  {
    "frequency": 24,
    "simplified": "丹心碧血",
    "traditional": "丹心碧血"
  },
  {
    "frequency": 24,
    "simplified": "言近旨远",
    "traditional": "言近旨遠"
  },
  {
    "frequency": 24,
    "simplified": "傲霜斗雪",
    "traditional": "傲霜鬥雪"
  },
  {
    "frequency": 24,
    "simplified": "子曰诗云",
    "traditional": "子曰詩云"
  },
  {
    "frequency": 24,
    "simplified": "抑强扶弱",
    "traditional": "抑強扶弱"
  },
  {
    "frequency": 24,
    "simplified": "一回生两回熟",
    "traditional": "一回生兩回熟"
  },
  {
    "frequency": 24,
    "simplified": "难以逆料",
    "traditional": "難以逆料"
  },
  {
    "frequency": 24,
    "simplified": "不立文字",
    "traditional": "不立文字"
  },
  {
    "frequency": 24,
    "simplified": "爱钱如命",
    "traditional": "愛錢如命"
  },
  {
    "frequency": 24,
    "simplified": "三三五五",
    "traditional": "三三五五"
  },
  {
    "frequency": 24,
    "simplified": "神工鬼斧",
    "traditional": "神工鬼斧"
  },
  {
    "frequency": 24,
    "simplified": "种瓜得瓜种豆得豆",
    "traditional": "種瓜得瓜種豆得豆"
  },
  {
    "frequency": 24,
    "simplified": "秋风落叶",
    "traditional": "秋風落葉"
  },
  {
    "frequency": 24,
    "simplified": "万应灵丹",
    "traditional": "萬應靈丹"
  },
  {
    "frequency": 24,
    "simplified": "孜孜矻矻",
    "traditional": "孜孜矻矻"
  },
  {
    "frequency": 24,
    "simplified": "挫骨扬灰",
    "traditional": "挫骨揚灰"
  },
  {
    "frequency": 24,
    "simplified": "信笔涂鸦",
    "traditional": "信筆塗鴉"
  },
  {
    "frequency": 24,
    "simplified": "神清气和",
    "traditional": "神清氣和"
  },
  {
    "frequency": 24,
    "simplified": "沉思默想",
    "traditional": "沉思默想"
  },
  {
    "frequency": 24,
    "simplified": "个中三昧",
    "traditional": "箇中三昧"
  },
  {
    "frequency": 24,
    "simplified": "光阴虚度",
    "traditional": "光陰虛度"
  },
  {
    "frequency": 24,
    "simplified": "厚今薄古",
    "traditional": "厚今薄古"
  },
  {
    "frequency": 24,
    "simplified": "匹夫无罪",
    "traditional": "匹夫無罪"
  },
  {
    "frequency": 24,
    "simplified": "洪福齐天",
    "traditional": "洪福齊天"
  },
  {
    "frequency": 24,
    "simplified": "铭记不忘",
    "traditional": "銘記不忘"
  },
  {
    "frequency": 24,
    "simplified": "泛泛之谈",
    "traditional": "泛泛之談"
  },
  {
    "frequency": 23,
    "simplified": "轻诺寡信",
    "traditional": "輕諾寡信"
  },
  {
    "frequency": 23,
    "simplified": "群而不党",
    "traditional": "群而不黨"
  },
  {
    "frequency": 23,
    "simplified": "百媚千娇",
    "traditional": "百媚千嬌"
  },
  {
    "frequency": 23,
    "simplified": "淡妆浓抹",
    "traditional": "淡妝濃抹"
  },
  {
    "frequency": 23,
    "simplified": "落落寡合",
    "traditional": "落落寡合"
  },
  {
    "frequency": 23,
    "simplified": "荒淫无耻",
    "traditional": "荒淫無恥"
  },
  {
    "frequency": 23,
    "simplified": "悔之不及",
    "traditional": "悔之不及"
  },
  {
    "frequency": 23,
    "simplified": "兵连祸结",
    "traditional": "兵連禍結"
  },
  {
    "frequency": 23,
    "simplified": "旧瓶新酒",
    "traditional": "舊瓶新酒"
  },
  {
    "frequency": 23,
    "simplified": "惊喜若狂",
    "traditional": "驚喜若狂"
  },
  {
    "frequency": 23,
    "simplified": "万目睽睽",
    "traditional": "萬目睽睽"
  },
  {
    "frequency": 23,
    "simplified": "相逢恨晚",
    "traditional": "相逢恨晚"
  },
  {
    "frequency": 23,
    "simplified": "井井有序",
    "traditional": "井井有序"
  },
  {
    "frequency": 23,
    "simplified": "朝乾夕惕",
    "traditional": "朝乾夕惕"
  },
  {
    "frequency": 23,
    "simplified": "天随人愿",
    "traditional": "天隨人願"
  },
  {
    "frequency": 23,
    "simplified": "兴致索然",
    "traditional": "興致索然"
  },
  {
    "frequency": 23,
    "simplified": "多嘴多舌",
    "traditional": "多嘴多舌"
  },
  {
    "frequency": 23,
    "simplified": "旷古未有",
    "traditional": "曠古未有"
  },
  {
    "frequency": 23,
    "simplified": "饮马长江",
    "traditional": "飲馬長江"
  },
  {
    "frequency": 23,
    "simplified": "群起效尤",
    "traditional": "群起效尤"
  },
  {
    "frequency": 23,
    "simplified": "判若霄壤",
    "traditional": "判若霄壤"
  },
  {
    "frequency": 23,
    "simplified": "救灾恤患",
    "traditional": "救災恤患"
  },
  {
    "frequency": 23,
    "simplified": "蚁穴溃堤",
    "traditional": "蟻穴潰堤"
  },
  {
    "frequency": 23,
    "simplified": "穷愁潦倒",
    "traditional": "窮愁潦倒"
  },
  {
    "frequency": 23,
    "simplified": "穷形尽相",
    "traditional": "窮形盡相"
  },
  {
    "frequency": 23,
    "simplified": "箭无虚发",
    "traditional": "箭無虛發"
  },
  {
    "frequency": 23,
    "simplified": "不亢不卑",
    "traditional": "不亢不卑"
  },
  {
    "frequency": 23,
    "simplified": "前程万里",
    "traditional": "前程萬里"
  },
  {
    "frequency": 23,
    "simplified": "名利兼收",
    "traditional": "名利兼收"
  },
  {
    "frequency": 23,
    "simplified": "水可载舟亦可覆舟",
    "traditional": "水可載舟亦可覆舟"
  },
  {
    "frequency": 23,
    "simplified": "历历可数",
    "traditional": "歷歷可數"
  },
  {
    "frequency": 23,
    "simplified": "信口胡言",
    "traditional": "信口胡言"
  },
  {
    "frequency": 23,
    "simplified": "空空道人",
    "traditional": "空空道人"
  },
  {
    "frequency": 23,
    "simplified": "骂不绝口",
    "traditional": "罵不絕口"
  },
  {
    "frequency": 23,
    "simplified": "仇深似海",
    "traditional": "仇深似海"
  },
  {
    "frequency": 23,
    "simplified": "褒衣博带",
    "traditional": "褒衣博帶"
  },
  {
    "frequency": 23,
    "simplified": "纲纪废弛",
    "traditional": "綱紀廢弛"
  },
  {
    "frequency": 23,
    "simplified": "应付裕如",
    "traditional": "應付裕如"
  },
  {
    "frequency": 23,
    "simplified": "食而不化",
    "traditional": "食而不化"
  },
  {
    "frequency": 23,
    "simplified": "以身报国",
    "traditional": "以身報國"
  },
  {
    "frequency": 23,
    "simplified": "铮铮有声",
    "traditional": "錚錚有聲"
  },
  {
    "frequency": 23,
    "simplified": "如闻其声",
    "traditional": "如聞其聲"
  },
  {
    "frequency": 23,
    "simplified": "招降纳叛",
    "traditional": "招降納叛"
  },
  {
    "frequency": 23,
    "simplified": "坚苦卓绝",
    "traditional": "堅苦卓絕"
  },
  {
    "frequency": 23,
    "simplified": "居无求安",
    "traditional": "居無求安"
  },
  {
    "frequency": 23,
    "simplified": "应对如流",
    "traditional": "應對如流"
  },
  {
    "frequency": 23,
    "simplified": "杀鸡吓猴",
    "traditional": "殺雞嚇猴"
  },
  {
    "frequency": 23,
    "simplified": "天公地道",
    "traditional": "天公地道"
  },
  {
    "frequency": 23,
    "simplified": "举贤任能",
    "traditional": "舉賢任能"
  },
  {
    "frequency": 23,
    "simplified": "无事生事",
    "traditional": "無事生事"
  },
  {
    "frequency": 23,
    "simplified": "顺水顺风",
    "traditional": "順水順風"
  },
  {
    "frequency": 23,
    "simplified": "一字千钧",
    "traditional": "一字千鈞"
  },
  {
    "frequency": 23,
    "simplified": "非志无以成学",
    "traditional": "非志無以成學"
  },
  {
    "frequency": 23,
    "simplified": "乘热打铁",
    "traditional": "乘熱打鐵"
  },
  {
    "frequency": 23,
    "simplified": "顾前不顾后",
    "traditional": "顧前不顧後"
  },
  {
    "frequency": 23,
    "simplified": "超群出众",
    "traditional": "超群出眾"
  },
  {
    "frequency": 23,
    "simplified": "失之东隅收之桑榆",
    "traditional": "失之東隅收之桑榆"
  },
  {
    "frequency": 23,
    "simplified": "取义成仁",
    "traditional": "取義成仁"
  },
  {
    "frequency": 23,
    "simplified": "稳操胜算",
    "traditional": "穩操勝算"
  },
  {
    "frequency": 23,
    "simplified": "一代楷模",
    "traditional": "一代楷模"
  },
  {
    "frequency": 23,
    "simplified": "福至心灵",
    "traditional": "福至心靈"
  },
  {
    "frequency": 23,
    "simplified": "送君千里",
    "traditional": "送君千里"
  },
  {
    "frequency": 23,
    "simplified": "安内攘外",
    "traditional": "安內攘外"
  },
  {
    "frequency": 23,
    "simplified": "你唱我和",
    "traditional": "你唱我和"
  },
  {
    "frequency": 23,
    "simplified": "燕瘦环肥",
    "traditional": "燕瘦環肥"
  },
  {
    "frequency": 23,
    "simplified": "报应不爽",
    "traditional": "報應不爽"
  },
  {
    "frequency": 23,
    "simplified": "呢喃细语",
    "traditional": "呢喃細語"
  },
  {
    "frequency": 23,
    "simplified": "穷寇莫追",
    "traditional": "窮寇莫追"
  },
  {
    "frequency": 23,
    "simplified": "贪天之功",
    "traditional": "貪天之功"
  },
  {
    "frequency": 23,
    "simplified": "现世现报",
    "traditional": "現世現報"
  },
  {
    "frequency": 23,
    "simplified": "不世之功",
    "traditional": "不世之功"
  },
  {
    "frequency": 23,
    "simplified": "手胼足胝",
    "traditional": "手胼足胝"
  },
  {
    "frequency": 23,
    "simplified": "一笔抹煞",
    "traditional": "一筆抹煞"
  },
  {
    "frequency": 23,
    "simplified": "欢呼雷动",
    "traditional": "歡呼雷動"
  },
  {
    "frequency": 23,
    "simplified": "四体不勤五谷不分",
    "traditional": "四體不勤五穀不分"
  },
  {
    "frequency": 22,
    "simplified": "七尺之躯",
    "traditional": "七尺之軀"
  },
  {
    "frequency": 22,
    "simplified": "不可终日",
    "traditional": "不可終日"
  },
  {
    "frequency": 22,
    "simplified": "狂风怒号",
    "traditional": "狂風怒號"
  },
  {
    "frequency": 22,
    "simplified": "丛山峻岭",
    "traditional": "叢山峻嶺"
  },
  {
    "frequency": 22,
    "simplified": "隐恶扬善",
    "traditional": "隱惡揚善"
  },
  {
    "frequency": 22,
    "simplified": "放下屠刀立地成佛",
    "traditional": "放下屠刀立地成佛"
  },
  {
    "frequency": 22,
    "simplified": "流水行云",
    "traditional": "流水行雲"
  },
  {
    "frequency": 22,
    "simplified": "秀才造反",
    "traditional": "秀才造反"
  },
  {
    "frequency": 22,
    "simplified": "行己有耻",
    "traditional": "行己有恥"
  },
  {
    "frequency": 22,
    "simplified": "人善被人欺",
    "traditional": "人善被人欺"
  },
  {
    "frequency": 22,
    "simplified": "劈风斩浪",
    "traditional": "劈風斬浪"
  },
  {
    "frequency": 22,
    "simplified": "佳偶天成",
    "traditional": "佳偶天成"
  },
  {
    "frequency": 22,
    "simplified": "费心劳力",
    "traditional": "費心勞力"
  },
  {
    "frequency": 22,
    "simplified": "出入人罪",
    "traditional": "出入人罪"
  },
  {
    "frequency": 22,
    "simplified": "琴心剑胆",
    "traditional": "琴心劍膽"
  },
  {
    "frequency": 22,
    "simplified": "不欺暗室",
    "traditional": "不欺暗室"
  },
  {
    "frequency": 22,
    "simplified": "后生小子",
    "traditional": "後生小子"
  },
  {
    "frequency": 22,
    "simplified": "曲突徙薪",
    "traditional": "曲突徙薪"
  },
  {
    "frequency": 22,
    "simplified": "雨淋日晒",
    "traditional": "雨淋日曬"
  },
  {
    "frequency": 22,
    "simplified": "如临深渊如履薄冰",
    "traditional": "如臨深淵如履薄冰"
  },
  {
    "frequency": 22,
    "simplified": "韦编三绝",
    "traditional": "韋編三絕"
  },
  {
    "frequency": 22,
    "simplified": "沉滓泛起",
    "traditional": "沉滓泛起"
  },
  {
    "frequency": 22,
    "simplified": "讷言敏行",
    "traditional": "訥言敏行"
  },
  {
    "frequency": 22,
    "simplified": "机不可失时不再来",
    "traditional": "機不可失時不再來"
  },
  {
    "frequency": 22,
    "simplified": "何足为奇",
    "traditional": "何足為奇"
  },
  {
    "frequency": 22,
    "simplified": "念念不舍",
    "traditional": "念念不捨"
  },
  {
    "frequency": 22,
    "simplified": "耐人咀嚼",
    "traditional": "耐人咀嚼"
  },
  {
    "frequency": 22,
    "simplified": "出没无常",
    "traditional": "出沒無常"
  },
  {
    "frequency": 22,
    "simplified": "家人父子",
    "traditional": "家人父子"
  },
  {
    "frequency": 22,
    "simplified": "一身是胆",
    "traditional": "一身是膽"
  },
  {
    "frequency": 22,
    "simplified": "付之流水",
    "traditional": "付之流水"
  },
  {
    "frequency": 22,
    "simplified": "落拓不羁",
    "traditional": "落拓不羈"
  },
  {
    "frequency": 22,
    "simplified": "勃然变色",
    "traditional": "勃然變色"
  },
  {
    "frequency": 22,
    "simplified": "奔走呼号",
    "traditional": "奔走呼號"
  },
  {
    "frequency": 22,
    "simplified": "反骄破满",
    "traditional": "反驕破滿"
  },
  {
    "frequency": 22,
    "simplified": "骨肉团圆",
    "traditional": "骨肉團圓"
  },
  {
    "frequency": 22,
    "simplified": "风声鹤唳草木皆兵",
    "traditional": "風聲鶴唳草木皆兵"
  },
  {
    "frequency": 22,
    "simplified": "北门锁钥",
    "traditional": "北門鎖鑰"
  },
  {
    "frequency": 22,
    "simplified": "人心惟危",
    "traditional": "人心惟危"
  },
  {
    "frequency": 22,
    "simplified": "浅斟低唱",
    "traditional": "淺斟低唱"
  },
  {
    "frequency": 22,
    "simplified": "大张挞伐",
    "traditional": "大張撻伐"
  },
  {
    "frequency": 22,
    "simplified": "与民更始",
    "traditional": "與民更始"
  },
  {
    "frequency": 22,
    "simplified": "眼观四路",
    "traditional": "眼觀四路"
  },
  {
    "frequency": 22,
    "simplified": "逸兴遄飞",
    "traditional": "逸興遄飛"
  },
  {
    "frequency": 22,
    "simplified": "仁民爱物",
    "traditional": "仁民愛物"
  },
  {
    "frequency": 22,
    "simplified": "疲乏不堪",
    "traditional": "疲乏不堪"
  },
  {
    "frequency": 22,
    "simplified": "济世安民",
    "traditional": "濟世安民"
  },
  {
    "frequency": 22,
    "simplified": "残暴不仁",
    "traditional": "殘暴不仁"
  },
  {
    "frequency": 22,
    "simplified": "袅袅娜娜",
    "traditional": "嫋嫋娜娜"
  },
  {
    "frequency": 22,
    "simplified": "倾盆大雨",
    "traditional": "傾盆大雨"
  },
  {
    "frequency": 22,
    "simplified": "面红耳热",
    "traditional": "面紅耳熱"
  },
  {
    "frequency": 22,
    "simplified": "陈谷子烂芝麻",
    "traditional": "陳穀子爛芝麻"
  },
  {
    "frequency": 22,
    "simplified": "久经风霜",
    "traditional": "久經風霜"
  },
  {
    "frequency": 22,
    "simplified": "人之将死其言也善",
    "traditional": "人之將死其言也善"
  },
  {
    "frequency": 22,
    "simplified": "七折八扣",
    "traditional": "七折八扣"
  },
  {
    "frequency": 22,
    "simplified": "独运匠心",
    "traditional": "獨運匠心"
  },
  {
    "frequency": 22,
    "simplified": "水月观音",
    "traditional": "水月觀音"
  },
  {
    "frequency": 22,
    "simplified": "羚羊挂角",
    "traditional": "羚羊掛角"
  },
  {
    "frequency": 22,
    "simplified": "百端待举",
    "traditional": "百端待舉"
  },
  {
    "frequency": 22,
    "simplified": "仙山琼阁",
    "traditional": "仙山瓊閣"
  },
  {
    "frequency": 22,
    "simplified": "眼尖手快",
    "traditional": "眼尖手快"
  },
  {
    "frequency": 22,
    "simplified": "人生何处不相逢",
    "traditional": "人生何處不相逢"
  },
  {
    "frequency": 22,
    "simplified": "削职为民",
    "traditional": "削職為民"
  },
  {
    "frequency": 22,
    "simplified": "人中之龙",
    "traditional": "人中之龍"
  },
  {
    "frequency": 22,
    "simplified": "风流潇洒",
    "traditional": "風流瀟灑"
  },
  {
    "frequency": 22,
    "simplified": "康庄大道",
    "traditional": "康莊大道"
  },
  {
    "frequency": 22,
    "simplified": "半新半旧",
    "traditional": "半新半舊"
  },
  {
    "frequency": 22,
    "simplified": "世代书香",
    "traditional": "世代書香"
  },
  {
    "frequency": 22,
    "simplified": "没齿不忘",
    "traditional": "沒齒不忘"
  },
  {
    "frequency": 22,
    "simplified": "咸与维新",
    "traditional": "鹹與維新"
  },
  {
    "frequency": 22,
    "simplified": "何足道哉",
    "traditional": "何足道哉"
  },
  {
    "frequency": 22,
    "simplified": "白衣秀士",
    "traditional": "白衣秀士"
  },
  {
    "frequency": 22,
    "simplified": "弦外之意",
    "traditional": "弦外之意"
  },
  {
    "frequency": 22,
    "simplified": "梨园子弟",
    "traditional": "梨園子弟"
  },
  {
    "frequency": 21,
    "simplified": "补偏救弊",
    "traditional": "補偏救弊"
  },
  {
    "frequency": 21,
    "simplified": "青云之志",
    "traditional": "青雲之志"
  },
  {
    "frequency": 21,
    "simplified": "珍馐美馔",
    "traditional": "珍饈美饌"
  },
  {
    "frequency": 21,
    "simplified": "非分之财",
    "traditional": "非分之財"
  },
  {
    "frequency": 21,
    "simplified": "明枪易躲暗箭难防",
    "traditional": "明槍易躲暗箭難防"
  },
  {
    "frequency": 21,
    "simplified": "来势凶猛",
    "traditional": "來勢兇猛"
  },
  {
    "frequency": 21,
    "simplified": "看风使舵",
    "traditional": "看風使舵"
  },
  {
    "frequency": 21,
    "simplified": "牵牛织女",
    "traditional": "牽牛織女"
  },
  {
    "frequency": 21,
    "simplified": "近在眉睫",
    "traditional": "近在眉睫"
  },
  {
    "frequency": 21,
    "simplified": "冷水浇头",
    "traditional": "冷水澆頭"
  },
  {
    "frequency": 21,
    "simplified": "朋友妻不可欺",
    "traditional": "朋友妻不可欺"
  },
  {
    "frequency": 21,
    "simplified": "惊才绝艳",
    "traditional": "驚才絕豔"
  },
  {
    "frequency": 21,
    "simplified": "尧天舜日",
    "traditional": "堯天舜日"
  },
  {
    "frequency": 21,
    "simplified": "一切众生",
    "traditional": "一切眾生"
  },
  {
    "frequency": 21,
    "simplified": "至亲骨肉",
    "traditional": "至親骨肉"
  },
  {
    "frequency": 21,
    "simplified": "破玩意儿",
    "traditional": "破玩意兒"
  },
  {
    "frequency": 21,
    "simplified": "扬清激浊",
    "traditional": "揚清激濁"
  },
  {
    "frequency": 21,
    "simplified": "横槊赋诗",
    "traditional": "橫槊賦詩"
  },
  {
    "frequency": 21,
    "simplified": "差之毫厘谬以千里",
    "traditional": "差之毫釐謬以千里"
  },
  {
    "frequency": 21,
    "simplified": "如花似锦",
    "traditional": "如花似錦"
  },
  {
    "frequency": 21,
    "simplified": "白首偕老",
    "traditional": "白首偕老"
  },
  {
    "frequency": 21,
    "simplified": "一蟹不如一蟹",
    "traditional": "一蟹不如一蟹"
  },
  {
    "frequency": 21,
    "simplified": "良知良能",
    "traditional": "良知良能"
  },
  {
    "frequency": 21,
    "simplified": "轮流做庄",
    "traditional": "輪流做莊"
  },
  {
    "frequency": 21,
    "simplified": "天地不容",
    "traditional": "天地不容"
  },
  {
    "frequency": 21,
    "simplified": "八府巡按",
    "traditional": "八府巡按"
  },
  {
    "frequency": 21,
    "simplified": "公诸同好",
    "traditional": "公諸同好"
  },
  {
    "frequency": 21,
    "simplified": "一文钱难倒英雄汉",
    "traditional": "一文錢難倒英雄漢"
  },
  {
    "frequency": 21,
    "simplified": "顺水行舟",
    "traditional": "順水行舟"
  },
  {
    "frequency": 21,
    "simplified": "鼎足而三",
    "traditional": "鼎足而三"
  },
  {
    "frequency": 21,
    "simplified": "改名易姓",
    "traditional": "改名易姓"
  },
  {
    "frequency": 21,
    "simplified": "里勾外连",
    "traditional": "裡勾外連"
  },
  {
    "frequency": 21,
    "simplified": "平等互惠",
    "traditional": "平等互惠"
  },
  {
    "frequency": 21,
    "simplified": "落花有意流水无情",
    "traditional": "落花有意流水無情"
  },
  {
    "frequency": 21,
    "simplified": "胸有丘壑",
    "traditional": "胸有丘壑"
  },
  {
    "frequency": 21,
    "simplified": "万里鹏程",
    "traditional": "萬里鵬程"
  },
  {
    "frequency": 21,
    "simplified": "力不能支",
    "traditional": "力不能支"
  },
  {
    "frequency": 21,
    "simplified": "怒形于色",
    "traditional": "怒形於色"
  },
  {
    "frequency": 21,
    "simplified": "优胜劣败",
    "traditional": "優勝劣敗"
  },
  {
    "frequency": 21,
    "simplified": "贻人口实",
    "traditional": "貽人口實"
  },
  {
    "frequency": 21,
    "simplified": "达官显宦",
    "traditional": "達官顯宦"
  },
  {
    "frequency": 21,
    "simplified": "粗通文墨",
    "traditional": "粗通文墨"
  },
  {
    "frequency": 21,
    "simplified": "如是我闻",
    "traditional": "如是我聞"
  },
  {
    "frequency": 21,
    "simplified": "绿叶成荫",
    "traditional": "綠葉成蔭"
  },
  {
    "frequency": 21,
    "simplified": "小试锋芒",
    "traditional": "小試鋒芒"
  },
  {
    "frequency": 21,
    "simplified": "患难相恤",
    "traditional": "患難相恤"
  },
  {
    "frequency": 21,
    "simplified": "改过迁善",
    "traditional": "改過遷善"
  },
  {
    "frequency": 21,
    "simplified": "惊喜交集",
    "traditional": "驚喜交集"
  },
  {
    "frequency": 21,
    "simplified": "不知其详",
    "traditional": "不知其詳"
  },
  {
    "frequency": 21,
    "simplified": "授受不亲",
    "traditional": "授受不親"
  },
  {
    "frequency": 21,
    "simplified": "翻箱倒箧",
    "traditional": "翻箱倒篋"
  },
  {
    "frequency": 21,
    "simplified": "如隔三秋",
    "traditional": "如隔三秋"
  },
  {
    "frequency": 21,
    "simplified": "夏虫不可语冰",
    "traditional": "夏蟲不可語冰"
  },
  {
    "frequency": 21,
    "simplified": "不古不今",
    "traditional": "不古不今"
  },
  {
    "frequency": 21,
    "simplified": "攻其无备",
    "traditional": "攻其無備"
  },
  {
    "frequency": 21,
    "simplified": "心病还须心药医",
    "traditional": "心病還須心藥醫"
  },
  {
    "frequency": 21,
    "simplified": "不甘后人",
    "traditional": "不甘後人"
  },
  {
    "frequency": 21,
    "simplified": "聪明一世",
    "traditional": "聰明一世"
  },
  {
    "frequency": 21,
    "simplified": "知子莫若父",
    "traditional": "知子莫若父"
  },
  {
    "frequency": 21,
    "simplified": "老弱残兵",
    "traditional": "老弱殘兵"
  },
  {
    "frequency": 21,
    "simplified": "挨打受气",
    "traditional": "挨打受氣"
  },
  {
    "frequency": 21,
    "simplified": "二者必居其一",
    "traditional": "二者必居其一"
  },
  {
    "frequency": 21,
    "simplified": "依法炮制",
    "traditional": "依法炮製"
  },
  {
    "frequency": 21,
    "simplified": "习非成是",
    "traditional": "習非成是"
  },
  {
    "frequency": 21,
    "simplified": "无所措手足",
    "traditional": "無所措手足"
  },
  {
    "frequency": 21,
    "simplified": "天理良心",
    "traditional": "天理良心"
  },
  {
    "frequency": 21,
    "simplified": "成事在人",
    "traditional": "成事在人"
  },
  {
    "frequency": 21,
    "simplified": "功名富贵",
    "traditional": "功名富貴"
  },
  {
    "frequency": 21,
    "simplified": "一画开天",
    "traditional": "一畫開天"
  },
  {
    "frequency": 21,
    "simplified": "庆父不死",
    "traditional": "慶父不死"
  },
  {
    "frequency": 21,
    "simplified": "水月镜花",
    "traditional": "水月鏡花"
  },
  {
    "frequency": 21,
    "simplified": "吴带当风",
    "traditional": "吳帶當風"
  },
  {
    "frequency": 21,
    "simplified": "七擒七纵",
    "traditional": "七擒七縱"
  },
  {
    "frequency": 21,
    "simplified": "勾魂摄魄",
    "traditional": "勾魂攝魄"
  },
  {
    "frequency": 21,
    "simplified": "桃李不言下自成蹊",
    "traditional": "桃李不言下自成蹊"
  },
  {
    "frequency": 21,
    "simplified": "连日连夜",
    "traditional": "連日連夜"
  },
  {
    "frequency": 21,
    "simplified": "渔人之利",
    "traditional": "漁人之利"
  },
  {
    "frequency": 21,
    "simplified": "三男四女",
    "traditional": "三男四女"
  },
  {
    "frequency": 21,
    "simplified": "如鸟兽散",
    "traditional": "如鳥獸散"
  },
  {
    "frequency": 21,
    "simplified": "不安于室",
    "traditional": "不安於室"
  },
  {
    "frequency": 21,
    "simplified": "悔罪自新",
    "traditional": "悔罪自新"
  },
  {
    "frequency": 21,
    "simplified": "如芒刺背",
    "traditional": "如芒刺背"
  },
  {
    "frequency": 21,
    "simplified": "日丽风和",
    "traditional": "日麗風和"
  },
  {
    "frequency": 21,
    "simplified": "存亡绝续",
    "traditional": "存亡絕續"
  },
  {
    "frequency": 21,
    "simplified": "见机而作",
    "traditional": "見機而作"
  }
]
